var wy = (e) => {
  throw TypeError(e);
};
var Ey = (e, t, n) => t.has(e) || wy("Cannot " + n);
var zn = (e, t, n) => (Ey(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Iy = (e, t, n) => t.has(e) ? wy("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), lp = (e, t, n, r) => (Ey(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import * as S from "react";
import H, { useMemo as Be, useId as oi, forwardRef as It, createContext as Nn, useContext as On, useCallback as Ke, useRef as He, useLayoutEffect as oa, useState as Fe, useEffect as Le, createElement as Lt, Children as Aa, isValidElement as Wd, cloneElement as N1, Fragment as ll, useReducer as QS, memo as dk, useImperativeHandle as fk, useSyncExternalStore as cp } from "react";
import { useParams as ex, Link as Yc, useBlocker as mk, useBeforeUnload as pk, NavLink as Oh, useLocation as hk, useRouteError as gk, useSearchParams as vk } from "react-router-dom";
import { toast as up } from "react-hot-toast";
import { ResponsiveContainer as tx, Tooltip as nx, Sankey as yk, CartesianGrid as bk, XAxis as Sk, BarChart as xk, Bar as Ck, LineChart as rx, Line as ox, PieChart as ix, Pie as Ah, Cell as Ry } from "recharts";
import * as cl from "react-dom";
import M1, { flushSync as F1, unstable_batchedUpdates as Du, createPortal as wk } from "react-dom";
import { useQuery as L1, useQueries as Ek, useInfiniteQuery as Ik, queryOptions as Rk } from "@tanstack/react-query";
/*!
 * Font Awesome Free 7.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2026 Fonticons, Inc.
 */
function kh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Tk(e) {
  if (Array.isArray(e)) return e;
}
function _k(e) {
  if (Array.isArray(e)) return kh(e);
}
function Ok(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Ak(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ax(r.key), r);
  }
}
function kk(e, t, n) {
  return t && Ak(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function bd(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = $1(e)) || t) {
      n && (e = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, s = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return a = l.done, l;
    },
    e: function(l) {
      s = !0, i = l;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function Xe(e, t, n) {
  return (t = ax(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Dk(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Pk(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw o;
      }
    }
    return s;
  }
}
function Nk() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mk() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ty(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ty(Object(n), !0).forEach(function(r) {
      Xe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ty(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ff(e, t) {
  return Tk(e) || Pk(e, t) || $1(e, t) || Nk();
}
function co(e) {
  return _k(e) || Dk(e) || $1(e) || Mk();
}
function Fk(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ax(e) {
  var t = Fk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Hd(e) {
  "@babel/helpers - typeof";
  return Hd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hd(e);
}
function $1(e, t) {
  if (e) {
    if (typeof e == "string") return kh(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? kh(e, t) : void 0;
  }
}
var _y = function() {
}, z1 = {}, sx = {}, lx = null, cx = {
  mark: _y,
  measure: _y
};
try {
  typeof window < "u" && (z1 = window), typeof document < "u" && (sx = document), typeof MutationObserver < "u" && (lx = MutationObserver), typeof performance < "u" && (cx = performance);
} catch {
}
var Lk = z1.navigator || {}, Oy = Lk.userAgent, Ay = Oy === void 0 ? "" : Oy, Ui = z1, Bt = sx, ky = lx, Pu = cx;
Ui.document;
var vi = !!Bt.documentElement && !!Bt.head && typeof Bt.addEventListener == "function" && typeof Bt.createElement == "function", ux = ~Ay.indexOf("MSIE") || ~Ay.indexOf("Trident/"), Nu, $k = /fa(k|kd|s|r|l|t|d|dr|dl|dt|b|slr|slpr|wsb|tl|ns|nds|es|gt|jr|jfr|jdr|usb|ufsb|udsb|cr|ss|sr|sl|st|sds|sdr|sdl|sdt|sldr|slpdr|pr|ms|vs)?[\-\ ]/, zk = /Font ?Awesome ?([567 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit|Notdog Duo|Notdog|Chisel|Etch|Graphite|Thumbprint|Jelly Fill|Jelly Duo|Jelly|Utility|Utility Fill|Utility Duo|Slab Press|Slab|Slab Duo|Slab Press Duo|Pixel|Mosaic|Vellum|Whiteboard)?.*/i, dx = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  },
  slab: {
    "fa-regular": "regular",
    faslr: "regular"
  },
  "slab-press": {
    "fa-regular": "regular",
    faslpr: "regular"
  },
  "slab-duo": {
    "fa-regular": "regular",
    fasldr: "regular"
  },
  "slab-press-duo": {
    "fa-regular": "regular",
    faslpdr: "regular"
  },
  thumbprint: {
    "fa-light": "light",
    fatl: "light"
  },
  vellum: {
    "fa-solid": "solid",
    favs: "solid"
  },
  pixel: {
    "fa-regular": "regular",
    fapr: "regular"
  },
  mosaic: {
    "fa-solid": "solid",
    fams: "solid"
  },
  whiteboard: {
    "fa-semibold": "semibold",
    fawsb: "semibold"
  },
  notdog: {
    "fa-solid": "solid",
    fans: "solid"
  },
  "notdog-duo": {
    "fa-solid": "solid",
    fands: "solid"
  },
  etch: {
    "fa-solid": "solid",
    faes: "solid"
  },
  graphite: {
    "fa-thin": "thin",
    fagt: "thin"
  },
  jelly: {
    "fa-regular": "regular",
    fajr: "regular"
  },
  "jelly-fill": {
    "fa-regular": "regular",
    fajfr: "regular"
  },
  "jelly-duo": {
    "fa-regular": "regular",
    fajdr: "regular"
  },
  chisel: {
    "fa-regular": "regular",
    facr: "regular"
  },
  utility: {
    "fa-semibold": "semibold",
    fausb: "semibold"
  },
  "utility-duo": {
    "fa-semibold": "semibold",
    faudsb: "semibold"
  },
  "utility-fill": {
    "fa-semibold": "semibold",
    faufsb: "semibold"
  }
}, jk = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, fx = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone", "fa-thumbprint", "fa-whiteboard", "fa-notdog", "fa-notdog-duo", "fa-chisel", "fa-etch", "fa-graphite", "fa-jelly", "fa-jelly-fill", "fa-jelly-duo", "fa-slab", "fa-slab-press", "fa-slab-press-duo", "fa-slab-duo", "fa-mosaic", "fa-pixel", "fa-vellum", "fa-utility", "fa-utility-duo", "fa-utility-fill"], Mn = "classic", Kc = "duotone", mx = "sharp", px = "sharp-duotone", hx = "chisel", gx = "etch", vx = "graphite", yx = "jelly", bx = "jelly-duo", Sx = "jelly-fill", xx = "mosaic", Cx = "notdog", wx = "notdog-duo", Ex = "pixel", Ix = "slab", Rx = "slab-duo", Tx = "slab-press", _x = "slab-press-duo", Ox = "thumbprint", Ax = "utility", kx = "utility-duo", Dx = "utility-fill", Px = "vellum", Nx = "whiteboard", Bk = "Classic", Gk = "Duotone", Vk = "Sharp", Uk = "Sharp Duotone", Wk = "Chisel", Hk = "Etch", qk = "Graphite", Yk = "Jelly", Kk = "Jelly Duo", Zk = "Jelly Fill", Xk = "Mosaic", Jk = "Notdog", Qk = "Notdog Duo", eD = "Pixel", tD = "Slab", nD = "Slab Duo", rD = "Slab Press", oD = "Slab Press Duo", iD = "Thumbprint", aD = "Utility", sD = "Utility Duo", lD = "Utility Fill", cD = "Vellum", uD = "Whiteboard", Mx = [Mn, Kc, mx, px, hx, gx, vx, yx, bx, Sx, xx, Cx, wx, Ex, Ix, Rx, Tx, _x, Ox, Ax, kx, Dx, Px, Nx];
Nu = {}, Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Nu, Mn, Bk), Kc, Gk), mx, Vk), px, Uk), hx, Wk), gx, Hk), vx, qk), yx, Yk), bx, Kk), Sx, Zk), Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Nu, xx, Xk), Cx, Jk), wx, Qk), Ex, eD), Ix, tD), Rx, nD), Tx, rD), _x, oD), Ox, iD), Ax, aD), Xe(Xe(Xe(Xe(Nu, kx, sD), Dx, lD), Px, cD), Nx, uD);
var dD = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  },
  slab: {
    400: "faslr"
  },
  "slab-press": {
    400: "faslpr"
  },
  "slab-duo": {
    400: "fasldr"
  },
  "slab-press-duo": {
    400: "faslpdr"
  },
  vellum: {
    900: "favs"
  },
  mosaic: {
    900: "fams"
  },
  pixel: {
    400: "fapr"
  },
  whiteboard: {
    600: "fawsb"
  },
  thumbprint: {
    300: "fatl"
  },
  notdog: {
    900: "fans"
  },
  "notdog-duo": {
    900: "fands"
  },
  etch: {
    900: "faes"
  },
  graphite: {
    100: "fagt"
  },
  chisel: {
    400: "facr"
  },
  jelly: {
    400: "fajr"
  },
  "jelly-fill": {
    400: "fajfr"
  },
  "jelly-duo": {
    400: "fajdr"
  },
  utility: {
    600: "fausb"
  },
  "utility-duo": {
    600: "faudsb"
  },
  "utility-fill": {
    600: "faufsb"
  }
}, fD = {
  "Font Awesome 7 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 7 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 7 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 7 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 7 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 7 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  },
  "Font Awesome 7 Jelly": {
    400: "fajr",
    normal: "fajr"
  },
  "Font Awesome 7 Jelly Fill": {
    400: "fajfr",
    normal: "fajfr"
  },
  "Font Awesome 7 Jelly Duo": {
    400: "fajdr",
    normal: "fajdr"
  },
  "Font Awesome 7 Slab": {
    400: "faslr",
    normal: "faslr"
  },
  "Font Awesome 7 Slab Press": {
    400: "faslpr",
    normal: "faslpr"
  },
  "Font Awesome 7 Slab Duo": {
    400: "fasldr",
    normal: "fasldr"
  },
  "Font Awesome 7 Slab Press Duo": {
    400: "faslpdr",
    normal: "faslpdr"
  },
  "Font Awesome 7 Pixel": {
    400: "fapr",
    normal: "fapr"
  },
  "Font Awesome 7 Mosaic": {
    900: "fams",
    normal: "fams"
  },
  "Font Awesome 7 Vellum": {
    900: "favs",
    normal: "favs"
  },
  "Font Awesome 7 Thumbprint": {
    300: "fatl",
    normal: "fatl"
  },
  "Font Awesome 7 Notdog": {
    900: "fans",
    normal: "fans"
  },
  "Font Awesome 7 Notdog Duo": {
    900: "fands",
    normal: "fands"
  },
  "Font Awesome 7 Etch": {
    900: "faes",
    normal: "faes"
  },
  "Font Awesome 7 Graphite": {
    100: "fagt",
    normal: "fagt"
  },
  "Font Awesome 7 Chisel": {
    400: "facr",
    normal: "facr"
  },
  "Font Awesome 7 Whiteboard": {
    600: "fawsb",
    normal: "fawsb"
  },
  "Font Awesome 7 Utility": {
    600: "fausb",
    normal: "fausb"
  },
  "Font Awesome 7 Utility Duo": {
    600: "faudsb",
    normal: "faudsb"
  },
  "Font Awesome 7 Utility Fill": {
    600: "faufsb",
    normal: "faufsb"
  }
}, mD = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["chisel", {
  defaultShortPrefixId: "facr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["etch", {
  defaultShortPrefixId: "faes",
  defaultStyleId: "solid",
  styleIds: ["solid"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["graphite", {
  defaultShortPrefixId: "fagt",
  defaultStyleId: "thin",
  styleIds: ["thin"],
  futureStyleIds: [],
  defaultFontWeight: 100
}], ["jelly", {
  defaultShortPrefixId: "fajr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["jelly-duo", {
  defaultShortPrefixId: "fajdr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["jelly-fill", {
  defaultShortPrefixId: "fajfr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["mosaic", {
  defaultShortPrefixId: "fams",
  defaultStyleId: "solid",
  styleIds: ["solid"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["notdog", {
  defaultShortPrefixId: "fans",
  defaultStyleId: "solid",
  styleIds: ["solid"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["notdog-duo", {
  defaultShortPrefixId: "fands",
  defaultStyleId: "solid",
  styleIds: ["solid"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["pixel", {
  defaultShortPrefixId: "fapr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["slab", {
  defaultShortPrefixId: "faslr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["slab-duo", {
  defaultShortPrefixId: "fasldr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["slab-press", {
  defaultShortPrefixId: "faslpr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["slab-press-duo", {
  defaultShortPrefixId: "faslpdr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["thumbprint", {
  defaultShortPrefixId: "fatl",
  defaultStyleId: "light",
  styleIds: ["light"],
  futureStyleIds: [],
  defaultFontWeight: 300
}], ["utility", {
  defaultShortPrefixId: "fausb",
  defaultStyleId: "semibold",
  styleIds: ["semibold"],
  futureStyleIds: [],
  defaultFontWeight: 600
}], ["utility-duo", {
  defaultShortPrefixId: "faudsb",
  defaultStyleId: "semibold",
  styleIds: ["semibold"],
  futureStyleIds: [],
  defaultFontWeight: 600
}], ["utility-fill", {
  defaultShortPrefixId: "faufsb",
  defaultStyleId: "semibold",
  styleIds: ["semibold"],
  futureStyleIds: [],
  defaultFontWeight: 600
}], ["vellum", {
  defaultShortPrefixId: "favs",
  defaultStyleId: "solid",
  styleIds: ["solid"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["whiteboard", {
  defaultShortPrefixId: "fawsb",
  defaultStyleId: "semibold",
  styleIds: ["semibold"],
  futureStyleIds: [],
  defaultFontWeight: 600
}]]), pD = {
  chisel: {
    regular: "facr"
  },
  classic: {
    brands: "fab",
    light: "fal",
    regular: "far",
    solid: "fas",
    thin: "fat"
  },
  duotone: {
    light: "fadl",
    regular: "fadr",
    solid: "fad",
    thin: "fadt"
  },
  etch: {
    solid: "faes"
  },
  graphite: {
    thin: "fagt"
  },
  jelly: {
    regular: "fajr"
  },
  "jelly-duo": {
    regular: "fajdr"
  },
  "jelly-fill": {
    regular: "fajfr"
  },
  mosaic: {
    solid: "fams"
  },
  notdog: {
    solid: "fans"
  },
  "notdog-duo": {
    solid: "fands"
  },
  pixel: {
    regular: "fapr"
  },
  sharp: {
    light: "fasl",
    regular: "fasr",
    solid: "fass",
    thin: "fast"
  },
  "sharp-duotone": {
    light: "fasdl",
    regular: "fasdr",
    solid: "fasds",
    thin: "fasdt"
  },
  slab: {
    regular: "faslr"
  },
  "slab-duo": {
    regular: "fasldr"
  },
  "slab-press": {
    regular: "faslpr"
  },
  "slab-press-duo": {
    regular: "faslpdr"
  },
  thumbprint: {
    light: "fatl"
  },
  utility: {
    semibold: "fausb"
  },
  "utility-duo": {
    semibold: "faudsb"
  },
  "utility-fill": {
    semibold: "faufsb"
  },
  vellum: {
    solid: "favs"
  },
  whiteboard: {
    semibold: "fawsb"
  }
}, Fx = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Dy = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, hD = ["kit"], gD = "kit", vD = "kit-duotone", yD = "Kit", bD = "Kit Duotone";
Xe(Xe({}, gD, yD), vD, bD);
var SD = {
  kit: {
    "fa-kit": "fak"
  }
}, xD = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, CD = {
  kit: {
    fak: "fa-kit"
  }
}, Py = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, Mu, Fu = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, wD = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone", "fa-thumbprint", "fa-whiteboard", "fa-notdog", "fa-notdog-duo", "fa-chisel", "fa-etch", "fa-graphite", "fa-jelly", "fa-jelly-fill", "fa-jelly-duo", "fa-slab", "fa-slab-press", "fa-slab-press-duo", "fa-slab-duo", "fa-mosaic", "fa-pixel", "fa-vellum", "fa-utility", "fa-utility-duo", "fa-utility-fill"], ED = "classic", ID = "duotone", RD = "sharp", TD = "sharp-duotone", _D = "chisel", OD = "etch", AD = "graphite", kD = "jelly", DD = "jelly-duo", PD = "jelly-fill", ND = "mosaic", MD = "notdog", FD = "notdog-duo", LD = "pixel", $D = "slab", zD = "slab-duo", jD = "slab-press", BD = "slab-press-duo", GD = "thumbprint", VD = "utility", UD = "utility-duo", WD = "utility-fill", HD = "vellum", qD = "whiteboard", YD = "Classic", KD = "Duotone", ZD = "Sharp", XD = "Sharp Duotone", JD = "Chisel", QD = "Etch", eP = "Graphite", tP = "Jelly", nP = "Jelly Duo", rP = "Jelly Fill", oP = "Mosaic", iP = "Notdog", aP = "Notdog Duo", sP = "Pixel", lP = "Slab", cP = "Slab Duo", uP = "Slab Press", dP = "Slab Press Duo", fP = "Thumbprint", mP = "Utility", pP = "Utility Duo", hP = "Utility Fill", gP = "Vellum", vP = "Whiteboard";
Mu = {}, Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Mu, ED, YD), ID, KD), RD, ZD), TD, XD), _D, JD), OD, QD), AD, eP), kD, tP), DD, nP), PD, rP), Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Xe(Mu, ND, oP), MD, iP), FD, aP), LD, sP), $D, lP), zD, cP), jD, uP), BD, dP), GD, fP), VD, mP), Xe(Xe(Xe(Xe(Mu, UD, pP), WD, hP), HD, gP), qD, vP);
var yP = "kit", bP = "kit-duotone", SP = "Kit", xP = "Kit Duotone";
Xe(Xe({}, yP, SP), bP, xP);
var CP = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  },
  slab: {
    "fa-regular": "faslr"
  },
  "slab-press": {
    "fa-regular": "faslpr"
  },
  "slab-duo": {
    "fa-regular": "fasldr"
  },
  "slab-press-duo": {
    "fa-regular": "faslpdr"
  },
  pixel: {
    "fa-regular": "fapr"
  },
  mosaic: {
    "fa-solid": "fams"
  },
  vellum: {
    "fa-solid": "favs"
  },
  whiteboard: {
    "fa-semibold": "fawsb"
  },
  thumbprint: {
    "fa-light": "fatl"
  },
  notdog: {
    "fa-solid": "fans"
  },
  "notdog-duo": {
    "fa-solid": "fands"
  },
  etch: {
    "fa-solid": "faes"
  },
  graphite: {
    "fa-thin": "fagt"
  },
  jelly: {
    "fa-regular": "fajr"
  },
  "jelly-fill": {
    "fa-regular": "fajfr"
  },
  "jelly-duo": {
    "fa-regular": "fajdr"
  },
  chisel: {
    "fa-regular": "facr"
  },
  utility: {
    "fa-semibold": "fausb"
  },
  "utility-duo": {
    "fa-semibold": "faudsb"
  },
  "utility-fill": {
    "fa-semibold": "faufsb"
  }
}, wP = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"],
  slab: ["faslr"],
  "slab-press": ["faslpr"],
  "slab-duo": ["fasldr"],
  "slab-press-duo": ["faslpdr"],
  pixel: ["fapr"],
  mosaic: ["fams"],
  vellum: ["favs"],
  whiteboard: ["fawsb"],
  thumbprint: ["fatl"],
  notdog: ["fans"],
  "notdog-duo": ["fands"],
  etch: ["faes"],
  graphite: ["fagt"],
  jelly: ["fajr"],
  "jelly-fill": ["fajfr"],
  "jelly-duo": ["fajdr"],
  chisel: ["facr"],
  utility: ["fausb"],
  "utility-duo": ["faudsb"],
  "utility-fill": ["faufsb"]
}, Dh = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  },
  slab: {
    faslr: "fa-regular"
  },
  "slab-press": {
    faslpr: "fa-regular"
  },
  "slab-duo": {
    fasldr: "fa-regular"
  },
  "slab-press-duo": {
    faslpdr: "fa-regular"
  },
  pixel: {
    fapr: "fa-regular"
  },
  mosaic: {
    fams: "fa-solid"
  },
  vellum: {
    favs: "fa-solid"
  },
  whiteboard: {
    fawsb: "fa-semibold"
  },
  thumbprint: {
    fatl: "fa-light"
  },
  notdog: {
    fans: "fa-solid"
  },
  "notdog-duo": {
    fands: "fa-solid"
  },
  etch: {
    faes: "fa-solid"
  },
  graphite: {
    fagt: "fa-thin"
  },
  jelly: {
    fajr: "fa-regular"
  },
  "jelly-fill": {
    fajfr: "fa-regular"
  },
  "jelly-duo": {
    fajdr: "fa-regular"
  },
  chisel: {
    facr: "fa-regular"
  },
  utility: {
    fausb: "fa-semibold"
  },
  "utility-duo": {
    faudsb: "fa-semibold"
  },
  "utility-fill": {
    faufsb: "fa-semibold"
  }
}, EP = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands", "fa-semibold"], Lx = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", "faslr", "faslpr", "fasldr", "faslpdr", "fapr", "fams", "favs", "fawsb", "fatl", "fans", "fands", "faes", "fagt", "fajr", "fajfr", "fajdr", "facr", "fausb", "faudsb", "faufsb"].concat(wD, EP), IP = ["solid", "regular", "light", "thin", "duotone", "brands", "semibold"], $x = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], RP = $x.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), TP = ["aw", "fw", "pull-left", "pull-right"], _P = [].concat(co(Object.keys(wP)), IP, TP, ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "beat-fade", "border", "bounce", "buzz", "canvas-square", "canvas-roomy", "fade", "flip-360", "flip-both", "flip-horizontal", "flip-vertical", "flip", "float", "inverse", "jello", "layers", "layers-bottom-left", "layers-bottom-right", "layers-counter", "layers-text", "layers-top-left", "layers-top-right", "li", "pull-end", "pull-start", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "spin-snap", "spin-snap-4", "spin-snap-8", "stack-1x", "stack-2x", "stack", "swing", "ul", "wag", "width-auto", "width-fixed", Fu.GROUP, Fu.SWAP_OPACITY, Fu.PRIMARY, Fu.SECONDARY]).concat($x.map(function(e) {
  return "".concat(e, "x");
})).concat(RP.map(function(e) {
  return "w-".concat(e);
})), OP = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
}, ii = "___FONT_AWESOME___", Ph = 16, zx = "fa", jx = "svg-inline--fa", Ma = "data-fa-i2svg", Nh = "data-fa-pseudo-element", AP = "data-fa-pseudo-element-pending", j1 = "data-prefix", B1 = "data-icon", Ny = "fontawesome-i2svg", kP = "async", DP = ["HTML", "HEAD", "STYLE", "SCRIPT"], Bx = ["::before", "::after", ":before", ":after"], Gx = (function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function Zc(e) {
  return new Proxy(e, {
    get: function(n, r) {
      return r in n ? n[r] : n[Mn];
    }
  });
}
var Vx = be({}, dx);
Vx[Mn] = be(be(be(be({}, {
  "fa-duotone": "duotone"
}), dx[Mn]), Dy.kit), Dy["kit-duotone"]);
var PP = Zc(Vx), Mh = be({}, pD);
Mh[Mn] = be(be(be(be({}, {
  duotone: "fad"
}), Mh[Mn]), Py.kit), Py["kit-duotone"]);
var My = Zc(Mh), Fh = be({}, Dh);
Fh[Mn] = be(be({}, Fh[Mn]), CD.kit);
var G1 = Zc(Fh), Lh = be({}, CP);
Lh[Mn] = be(be({}, Lh[Mn]), SD.kit);
Zc(Lh);
var NP = $k, Ux = "fa-layers-text", MP = zk, FP = be({}, dD);
Zc(FP);
var LP = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], dp = jk, $P = [].concat(co(hD), co(_P)), ic = Ui.FontAwesomeConfig || {};
function zP(e) {
  var t = Bt.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function jP(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
if (Bt && typeof Bt.querySelector == "function") {
  var BP = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-search-pseudo-elements-warnings", "searchPseudoElementsWarnings"], ["data-search-pseudo-elements-full-scan", "searchPseudoElementsFullScan"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  BP.forEach(function(e) {
    var t = Ff(e, 2), n = t[0], r = t[1], o = jP(zP(n));
    o != null && (ic[r] = o);
  });
}
var Wx = {
  styleDefault: "solid",
  familyDefault: Mn,
  cssPrefix: zx,
  replacementClass: jx,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  searchPseudoElements: !1,
  searchPseudoElementsWarnings: !0,
  searchPseudoElementsFullScan: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
ic.familyPrefix && (ic.cssPrefix = ic.familyPrefix);
var Ws = be(be({}, Wx), ic);
Ws.autoReplaceSvg || (Ws.observeMutations = !1);
var Ze = {};
Object.keys(Wx).forEach(function(e) {
  Object.defineProperty(Ze, e, {
    enumerable: !0,
    set: function(n) {
      Ws[e] = n, ac.forEach(function(r) {
        return r(Ze);
      });
    },
    get: function() {
      return Ws[e];
    }
  });
});
Object.defineProperty(Ze, "familyPrefix", {
  enumerable: !0,
  set: function(t) {
    Ws.cssPrefix = t, ac.forEach(function(n) {
      return n(Ze);
    });
  },
  get: function() {
    return Ws.cssPrefix;
  }
});
Ui.FontAwesomeConfig = Ze;
var ac = [];
function GP(e) {
  return ac.push(e), function() {
    ac.splice(ac.indexOf(e), 1);
  };
}
var fs = Ph, Do = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function VP(e) {
  if (!(!e || !vi)) {
    var t = Bt.createElement("style");
    t.setAttribute("type", "text/css"), t.innerHTML = e;
    for (var n = Bt.head.childNodes, r = null, o = n.length - 1; o > -1; o--) {
      var i = n[o], a = (i.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(a) > -1 && (r = i);
    }
    return Bt.head.insertBefore(t, r), e;
  }
}
var UP = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Fy() {
  for (var e = 12, t = ""; e-- > 0; )
    t += UP[Math.random() * 62 | 0];
  return t;
}
function ul(e) {
  for (var t = [], n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function V1(e) {
  return e.classList ? ul(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function(t) {
    return t;
  });
}
function Hx(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function WP(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, '="').concat(Hx(e[n]), '" ');
  }, "").trim();
}
function Lf(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, ": ").concat(e[n].trim(), ";");
  }, "");
}
function U1(e) {
  return e.size !== Do.size || e.x !== Do.x || e.y !== Do.y || e.rotate !== Do.rotate || e.flipX || e.flipY;
}
function HP(e) {
  var t = e.transform, n = e.containerWidth, r = e.iconWidth, o = {
    transform: "translate(".concat(n / 2, " 256)")
  }, i = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(i, " ").concat(a, " ").concat(s)
  }, c = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: o,
    inner: l,
    path: c
  };
}
function qP(e) {
  var t = e.transform, n = e.width, r = n === void 0 ? Ph : n, o = e.height, i = o === void 0 ? Ph : o, a = "";
  return ux ? a += "translate(".concat(t.x / fs - r / 2, "em, ").concat(t.y / fs - i / 2, "em) ") : a += "translate(calc(-50% + ".concat(t.x / fs, "em), calc(-50% + ").concat(t.y / fs, "em)) "), a += "scale(".concat(t.size / fs * (t.flipX ? -1 : 1), ", ").concat(t.size / fs * (t.flipY ? -1 : 1), ") "), a += "rotate(".concat(t.rotate, "deg) "), a;
}
var YP = `:root, :host {
  --fa-font-solid: normal 900 1em/1 'Font Awesome 7 Free';
  --fa-font-regular: normal 400 1em/1 'Font Awesome 7 Free';
  --fa-font-light: normal 300 1em/1 'Font Awesome 7 Pro';
  --fa-font-thin: normal 100 1em/1 'Font Awesome 7 Pro';
  --fa-font-duotone: normal 900 1em/1 'Font Awesome 7 Duotone';
  --fa-font-duotone-regular: normal 400 1em/1 'Font Awesome 7 Duotone';
  --fa-font-duotone-light: normal 300 1em/1 'Font Awesome 7 Duotone';
  --fa-font-duotone-thin: normal 100 1em/1 'Font Awesome 7 Duotone';
  --fa-font-brands: normal 400 1em/1 'Font Awesome 7 Brands';
  --fa-font-sharp-solid: normal 900 1em/1 'Font Awesome 7 Sharp';
  --fa-font-sharp-regular: normal 400 1em/1 'Font Awesome 7 Sharp';
  --fa-font-sharp-light: normal 300 1em/1 'Font Awesome 7 Sharp';
  --fa-font-sharp-thin: normal 100 1em/1 'Font Awesome 7 Sharp';
  --fa-font-sharp-duotone-solid: normal 900 1em/1 'Font Awesome 7 Sharp Duotone';
  --fa-font-sharp-duotone-regular: normal 400 1em/1 'Font Awesome 7 Sharp Duotone';
  --fa-font-sharp-duotone-light: normal 300 1em/1 'Font Awesome 7 Sharp Duotone';
  --fa-font-sharp-duotone-thin: normal 100 1em/1 'Font Awesome 7 Sharp Duotone';
  --fa-font-slab-regular: normal 400 1em/1 'Font Awesome 7 Slab';
  --fa-font-slab-press-regular: normal 400 1em/1 'Font Awesome 7 Slab Press';
  --fa-font-slab-duo-regular: normal 400 1em/1 'Font Awesome 7 Slab Duo';
  --fa-font-slab-press-duo-regular: normal 400 1em/1 'Font Awesome 7 Slab Press Duo';
  --fa-font-pixel-regular: normal 400 1em/1 'Font Awesome 7 Pixel';
  --fa-font-mosaic-solid: normal 900 1em/1 'Font Awesome 7 Mosaic';
  --fa-font-vellum-solid: normal 900 1em/1 'Font Awesome 7 Vellum';
  --fa-font-whiteboard-semibold: normal 600 1em/1 'Font Awesome 7 Whiteboard';
  --fa-font-thumbprint-light: normal 300 1em/1 'Font Awesome 7 Thumbprint';
  --fa-font-notdog-solid: normal 900 1em/1 'Font Awesome 7 Notdog';
  --fa-font-notdog-duo-solid: normal 900 1em/1 'Font Awesome 7 Notdog Duo';
  --fa-font-etch-solid: normal 900 1em/1 'Font Awesome 7 Etch';
  --fa-font-graphite-thin: normal 100 1em/1 'Font Awesome 7 Graphite';
  --fa-font-jelly-regular: normal 400 1em/1 'Font Awesome 7 Jelly';
  --fa-font-jelly-fill-regular: normal 400 1em/1 'Font Awesome 7 Jelly Fill';
  --fa-font-jelly-duo-regular: normal 400 1em/1 'Font Awesome 7 Jelly Duo';
  --fa-font-chisel-regular: normal 400 1em/1 'Font Awesome 7 Chisel';
  --fa-font-utility-semibold: normal 600 1em/1 'Font Awesome 7 Utility';
  --fa-font-utility-duo-semibold: normal 600 1em/1 'Font Awesome 7 Utility Duo';
  --fa-font-utility-fill-semibold: normal 600 1em/1 'Font Awesome 7 Utility Fill';
}

.svg-inline--fa {
  box-sizing: content-box;
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
  width: var(--fa-width, 1.25em);
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285714em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left,
.svg-inline--fa .fa-pull-start {
  float: inline-start;
  margin-inline-end: var(--fa-pull-margin, 0.3em);
}
.svg-inline--fa.fa-pull-right,
.svg-inline--fa .fa-pull-end {
  float: inline-end;
  margin-inline-start: var(--fa-pull-margin, 0.3em);
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));
  inset-block-start: 0.25em; /* syncing vertical alignment with Web Font rendering */
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: var(--fa-width, 1.25em);
}
.fa-layers .svg-inline--fa {
  inset: 0;
  margin: auto;
  position: absolute;
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: calc(10 / 16 * 1em); /* converts a 10px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 10 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 10 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-xs {
  font-size: calc(12 / 16 * 1em); /* converts a 12px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 12 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 12 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-sm {
  font-size: calc(14 / 16 * 1em); /* converts a 14px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 14 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 14 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-lg {
  font-size: calc(20 / 16 * 1em); /* converts a 20px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 20 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 20 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-xl {
  font-size: calc(24 / 16 * 1em); /* converts a 24px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 24 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 24 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-2xl {
  font-size: calc(32 / 16 * 1em); /* converts a 32px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 32 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 32 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-width-auto {
  --fa-width: auto;
}

.fa-fw,
.fa-width-fixed {
  --fa-width: 1.25em;
}

.fa-canvas-square {
  padding-block: 0.125em;
  margin-block-end: -0.125em;
}

.fa-canvas-roomy {
  padding-block: 0.25em;
  padding-inline: 0.125em;
  margin-block-end: -0.25em;
  box-sizing: content-box;
}

.fa-ul {
  list-style-type: none;
  margin-inline-start: var(--fa-li-margin, 2.5em);
  padding-inline-start: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

/* Heads Up: Bordered Icons will not be supported in the future!
  - This feature will be deprecated in the next major release of Font Awesome (v8)!
  - You may continue to use it in this version *v7), but it will not be supported in Font Awesome v8.
*/
/* Notes:
* --@{v.$css-prefix}-border-width = 1/16 by default (to render as ~1px based on a 16px default font-size)
* --@{v.$css-prefix}-border-padding =
  ** 3/16 for vertical padding (to give ~2px of vertical whitespace around an icon considering it's vertical alignment)
  ** 4/16 for horizontal padding (to give ~4px of horizontal whitespace around an icon)
*/
.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.0625em);
  box-sizing: var(--fa-border-box-sizing, content-box);
  padding: var(--fa-border-padding, 0.1875em 0.25em);
}

.fa-pull-left,
.fa-pull-start {
  float: inline-start;
  margin-inline-end: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right,
.fa-pull-end {
  float: inline-end;
  margin-inline-start: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1.5s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-flip-360 {
  animation-name: fa-flip-360;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 0.75s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

.fa-spin-snap {
  animation-name: fa-spin-snap;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 3s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-snap-4 {
  animation-name: fa-spin-snap-4;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2.4s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-snap-8 {
  animation-name: fa-spin-snap-8;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 4s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-buzz {
  animation-name: fa-buzz;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 0.6s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-wag {
  animation-name: fa-wag;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 0.9s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-out);
  transform-origin: bottom center;
}

.fa-float {
  animation-name: fa-float;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 3s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
  will-change: transform;
}

.fa-swing {
  animation-name: fa-swing;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1.2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-out);
  transform-origin: top center;
}

.fa-jello {
  animation-name: fa-jello;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 0.9s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-out);
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-bounce,
  .fa-fade,
  .fa-beat-fade,
  .fa-flip,
  .fa-flip-360,
  .fa-pulse,
  .fa-shake,
  .fa-spin,
  .fa-spin-pulse,
  .fa-buzz,
  .fa-float,
  .fa-jello,
  .fa-spin-snap,
  .fa-spin-snap-4,
  .fa-spin-snap-8,
  .fa-swing,
  .fa-wag {
    animation: none !important;
    transition: none !important;
  }
}
@keyframes fa-beat {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(calc(1.25 * var(--fa-beat-scale, 1.25)));
  }
  45% {
    transform: scale(calc(1.22 * var(--fa-beat-scale, 1.22)));
  }
  65% {
    transform: scale(calc(1.25 * var(--fa-beat-scale, 1.25)));
  }
  90% {
    transform: scale(1);
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
    animation-timing-function: var(--fa-animation-timing);
  }
  14% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.06), var(--fa-bounce-start-scale-y, 0.94)) translateY(var(--fa-bounce-anticipation, 3px));
    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);
  }
  32% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.94), var(--fa-bounce-jump-scale-y, 1.12)) translateY(calc(-1 * var(--fa-bounce-height, 0.5em)));
    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);
  }
  52% {
    transform: scale(1, 1) translateY(calc(-1 * var(--fa-bounce-height, 0.5em) * 1.1));
    animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
  }
  70% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.06), var(--fa-bounce-land-scale-y, 0.92)) translateY(0);
    animation-timing-function: cubic-bezier(0.33, 0.33, 0.66, 1);
  }
  85% {
    transform: scale(0.98, 1.04) translateY(calc(-2px * var(--fa-bounce-rebound, 1)));
    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  0% {
    opacity: 1;
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);
  }
  40% {
    opacity: var(--fa-fade-opacity, 0.4);
    transform: scale(0.98);
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes fa-beat-fade {
  0% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);
  }
  25% {
    opacity: calc(var(--fa-beat-fade-opacity, 0.4) + 0.4);
    transform: scale(var(--fa-beat-fade-scale, 1.28));
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  45% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.25));
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  65% {
    opacity: calc(var(--fa-beat-fade-opacity, 0.4) + 0.4);
    transform: scale(var(--fa-beat-fade-scale, 1.28));
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
}
@keyframes fa-flip {
  0% {
    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);
    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);
  }
  8% {
    transform: perspective(2em) scale(var(--fa-flip-anticipation-scale, 0.95)) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);
    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);
  }
  35% {
    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * 0.6));
    animation-timing-function: linear;
  }
  65% {
    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * 0.5));
    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);
  }
  92% {
    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * var(--fa-flip-overshoot, 1.04)));
    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);
  }
  100% {
    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -360deg));
  }
}
@keyframes fa-flip-360 {
  0% {
    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);
    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);
  }
  8% {
    transform: perspective(2em) scale(var(--fa-flip-anticipation-scale, 0.95)) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);
    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);
  }
  50% {
    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * 0.6));
    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);
  }
  80% {
    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * var(--fa-flip-overshoot, 1.04)));
    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);
  }
  100% {
    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -360deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.2, 0, 0.8, 1);
  }
  8% {
    transform: rotate(35deg) translateX(1px);
    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);
  }
  20% {
    transform: rotate(-22deg) translateX(-1px);
    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);
  }
  35% {
    transform: rotate(15deg) translateX(1px);
    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);
  }
  50% {
    transform: rotate(-9deg);
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  65% {
    transform: rotate(5deg);
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  78% {
    transform: rotate(-3deg);
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  90% {
    transform: rotate(1deg);
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fa-spin-snap {
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  12% {
    transform: rotate(60deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  16.67% {
    transform: rotate(60deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  28.67% {
    transform: rotate(120deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  33.33% {
    transform: rotate(120deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  45.33% {
    transform: rotate(180deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: rotate(180deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  62% {
    transform: rotate(240deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  66.67% {
    transform: rotate(240deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  78.67% {
    transform: rotate(300deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  83.33% {
    transform: rotate(300deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  95.33% {
    transform: rotate(360deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fa-spin-snap-4 {
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  15% {
    transform: rotate(90deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  25% {
    transform: rotate(90deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  40% {
    transform: rotate(180deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: rotate(180deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  65% {
    transform: rotate(270deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  75% {
    transform: rotate(270deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  90% {
    transform: rotate(360deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fa-spin-snap-8 {
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  9% {
    transform: rotate(45deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  12.5% {
    transform: rotate(45deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  21.5% {
    transform: rotate(90deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  25% {
    transform: rotate(90deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  34% {
    transform: rotate(135deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  37.5% {
    transform: rotate(135deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  46.5% {
    transform: rotate(180deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: rotate(180deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  59% {
    transform: rotate(225deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  62.5% {
    transform: rotate(225deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  71.5% {
    transform: rotate(270deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  75% {
    transform: rotate(270deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  84% {
    transform: rotate(315deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  87.5% {
    transform: rotate(315deg);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
  96.5% {
    transform: rotate(360deg);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fa-buzz {
  0% {
    transform: translateX(0) rotate(0deg);
    animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);
  }
  5% {
    transform: translateX(var(--fa-buzz-distance, 4px)) rotate(0.5deg);
  }
  10% {
    transform: translateX(calc(-1 * var(--fa-buzz-distance, 4px))) rotate(-0.5deg);
  }
  15% {
    transform: translateX(var(--fa-buzz-distance, 4px)) rotate(0.3deg);
  }
  20% {
    transform: translateX(calc(-1 * var(--fa-buzz-distance, 4px))) rotate(-0.3deg);
  }
  25% {
    transform: translateX(calc(var(--fa-buzz-distance, 4px) * 0.7)) rotate(0.2deg);
  }
  30% {
    transform: translateX(calc(-1 * var(--fa-buzz-distance, 4px) * 0.7)) rotate(-0.2deg);
  }
  35% {
    transform: translateX(calc(var(--fa-buzz-distance, 4px) * 0.4)) rotate(0.1deg);
  }
  40% {
    transform: translateX(0) rotate(0deg);
  }
  100% {
    transform: translateX(0) rotate(0deg);
  }
}
@keyframes fa-wag {
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.2, 0, 0.6, 1);
  }
  12% {
    transform: rotate(var(--fa-wag-angle, 12deg));
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  24% {
    transform: rotate(2deg);
    animation-timing-function: cubic-bezier(0.2, 0, 0.6, 1);
  }
  36% {
    transform: rotate(calc(var(--fa-wag-angle, 12deg) * 0.85));
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  48% {
    transform: rotate(1deg);
    animation-timing-function: cubic-bezier(0.2, 0, 0.6, 1);
  }
  58% {
    transform: rotate(calc(var(--fa-wag-angle, 12deg) * 0.6));
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  68% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-float {
  0% {
    transform: translateY(0) translateX(0) rotate(0deg) scale(var(--fa-float-squash-x, 1.02), var(--fa-float-squash-y, 0.98));
    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);
  }
  15% {
    transform: translateY(calc(-0.4 * var(--fa-float-height, 6px))) translateX(var(--fa-float-drift, 1px)) rotate(var(--fa-float-tilt, 1deg)) scale(1, 1);
    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);
  }
  35% {
    transform: translateY(calc(-1 * var(--fa-float-height, 6px))) translateX(0) rotate(0deg) scale(var(--fa-float-stretch-x, 0.98), var(--fa-float-stretch-y, 1.03));
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 0);
  }
  50% {
    transform: translateY(calc(-0.92 * var(--fa-float-height, 6px))) translateX(calc(-0.5 * var(--fa-float-drift, 1px))) rotate(calc(-0.5 * var(--fa-float-tilt, 1deg))) scale(0.995, 1.01);
    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);
  }
  70% {
    transform: translateY(calc(-0.3 * var(--fa-float-height, 6px))) translateX(calc(-1 * var(--fa-float-drift, 1px))) rotate(calc(-1 * var(--fa-float-tilt, 1deg))) scale(1, 1);
    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);
  }
  90% {
    transform: translateY(calc(0.05 * var(--fa-float-height, 6px))) translateX(0) rotate(0deg) scale(var(--fa-float-squash-x, 1.02), var(--fa-float-squash-y, 0.98));
    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);
  }
  100% {
    transform: translateY(0) translateX(0) rotate(0deg) scale(var(--fa-float-squash-x, 1.02), var(--fa-float-squash-y, 0.98));
  }
}
@keyframes fa-swing {
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.2, 0, 0.8, 1);
  }
  8% {
    transform: rotate(var(--fa-swing-angle, 22deg));
    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);
  }
  18% {
    transform: rotate(calc(-1 * var(--fa-swing-angle, 22deg) * 0.85));
    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);
  }
  28% {
    transform: rotate(calc(var(--fa-swing-angle, 22deg) * 0.65));
    animation-timing-function: cubic-bezier(0.35, 0, 0.65, 1);
  }
  38% {
    transform: rotate(calc(-1 * var(--fa-swing-angle, 22deg) * 0.45));
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  48% {
    transform: rotate(calc(var(--fa-swing-angle, 22deg) * 0.25));
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  56% {
    transform: rotate(calc(-1 * var(--fa-swing-angle, 22deg) * 0.1));
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  64% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-jello {
  0% {
    transform: scale(1, 1);
    animation-timing-function: cubic-bezier(0.2, 0, 0.8, 1);
  }
  12% {
    transform: scale(var(--fa-jello-scale-x, 1.15), calc(2 - var(--fa-jello-scale-x, 1.15)));
    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);
  }
  24% {
    transform: scale(calc(2 - var(--fa-jello-scale-y, 1.12)), var(--fa-jello-scale-y, 1.12));
    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);
  }
  36% {
    transform: scale(calc(1 + (var(--fa-jello-scale-x, 1.15) - 1) * 0.5), calc(2 - (1 + (var(--fa-jello-scale-x, 1.15) - 1) * 0.5)));
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  48% {
    transform: scale(calc(2 - (1 + (var(--fa-jello-scale-y, 1.12) - 1) * 0.3)), calc(1 + (var(--fa-jello-scale-y, 1.12) - 1) * 0.3));
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
  }
  58% {
    transform: scale(1.02, 0.98);
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  68% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.svg-inline--fa.fa-inverse {
  fill: var(--fa-inverse, #fff);
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.svg-inline--fa.fa-stack-1x {
  --fa-width: 1.25em;
  height: 1em;
  width: var(--fa-width);
}
.svg-inline--fa.fa-stack-2x {
  --fa-width: 2.5em;
  height: 2em;
  width: var(--fa-width);
}

.fa-stack-1x,
.fa-stack-2x {
  inset: 0;
  margin: auto;
  position: absolute;
  z-index: var(--fa-stack-z-index, auto);
}`;
function qx() {
  var e = zx, t = jx, n = Ze.cssPrefix, r = Ze.replacementClass, o = YP;
  if (n !== e || r !== t) {
    var i = new RegExp("\\.".concat(e, "\\-"), "g"), a = new RegExp("\\--".concat(e, "\\-"), "g"), s = new RegExp("\\.".concat(t), "g");
    o = o.replace(i, ".".concat(n, "-")).replace(a, "--".concat(n, "-")).replace(s, ".".concat(r));
  }
  return o;
}
var Ly = !1;
function fp() {
  Ze.autoAddCss && !Ly && (VP(qx()), Ly = !0);
}
var KP = {
  mixout: function() {
    return {
      dom: {
        css: qx,
        insertCss: fp
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        fp();
      },
      beforeI2svg: function() {
        fp();
      }
    };
  }
}, ai = Ui || {};
ai[ii] || (ai[ii] = {});
ai[ii].styles || (ai[ii].styles = {});
ai[ii].hooks || (ai[ii].hooks = {});
ai[ii].shims || (ai[ii].shims = []);
var oo = ai[ii], Yx = [], Kx = function() {
  Bt.removeEventListener("DOMContentLoaded", Kx), qd = 1, Yx.map(function(t) {
    return t();
  });
}, qd = !1;
vi && (qd = (Bt.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Bt.readyState), qd || Bt.addEventListener("DOMContentLoaded", Kx));
function ZP(e) {
  vi && (qd ? setTimeout(e, 0) : Yx.push(e));
}
function Xc(e) {
  var t = e.tag, n = e.attributes, r = n === void 0 ? {} : n, o = e.children, i = o === void 0 ? [] : o;
  return typeof e == "string" ? Hx(e) : "<".concat(t, " ").concat(WP(r), ">").concat(i.map(Xc).join(""), "</").concat(t, ">");
}
function $y(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var mp = function(t, n, r, o) {
  var i = Object.keys(t), a = i.length, s = n, l, c, u;
  for (r === void 0 ? (l = 1, u = t[i[0]]) : (l = 0, u = r); l < a; l++)
    c = i[l], u = s(u, t[c], c, t);
  return u;
};
function Zx(e) {
  return co(e).length !== 1 ? null : e.codePointAt(0).toString(16);
}
function zy(e) {
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n], o = !!r.icon;
    return o ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function $h(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.skipHooks, o = r === void 0 ? !1 : r, i = zy(t);
  typeof oo.hooks.addPack == "function" && !o ? oo.hooks.addPack(e, zy(t)) : oo.styles[e] = be(be({}, oo.styles[e] || {}), i), e === "fas" && $h("fa", t);
}
var Ec = oo.styles, XP = oo.shims, Xx = Object.keys(G1), JP = Xx.reduce(function(e, t) {
  return e[t] = Object.keys(G1[t]), e;
}, {}), W1 = null, Jx = {}, Qx = {}, e3 = {}, t3 = {}, n3 = {};
function QP(e) {
  return ~$P.indexOf(e);
}
function eN(e, t) {
  var n = t.split("-"), r = n[0], o = n.slice(1).join("-");
  return r === e && o !== "" && !QP(o) ? o : null;
}
var r3 = function() {
  var t = function(i) {
    return mp(Ec, function(a, s, l) {
      return a[l] = mp(s, i, {}), a;
    }, {});
  };
  Jx = t(function(o, i, a) {
    if (i[3] && (o[i[3]] = a), i[2]) {
      var s = i[2].filter(function(l) {
        return typeof l == "number";
      });
      s.forEach(function(l) {
        o[l.toString(16)] = a;
      });
    }
    return o;
  }), Qx = t(function(o, i, a) {
    if (o[a] = a, i[2]) {
      var s = i[2].filter(function(l) {
        return typeof l == "string";
      });
      s.forEach(function(l) {
        o[l] = a;
      });
    }
    return o;
  }), n3 = t(function(o, i, a) {
    var s = i[2];
    return o[a] = a, s.forEach(function(l) {
      o[l] = a;
    }), o;
  });
  var n = "far" in Ec || Ze.autoFetchSvg, r = mp(XP, function(o, i) {
    var a = i[0], s = i[1], l = i[2];
    return s === "far" && !n && (s = "fas"), typeof a == "string" && (o.names[a] = {
      prefix: s,
      iconName: l
    }), typeof a == "number" && (o.unicodes[a.toString(16)] = {
      prefix: s,
      iconName: l
    }), o;
  }, {
    names: {},
    unicodes: {}
  });
  e3 = r.names, t3 = r.unicodes, W1 = $f(Ze.styleDefault, {
    family: Ze.familyDefault
  });
};
GP(function(e) {
  W1 = $f(e.styleDefault, {
    family: Ze.familyDefault
  });
});
r3();
function H1(e, t) {
  return (Jx[e] || {})[t];
}
function tN(e, t) {
  return (Qx[e] || {})[t];
}
function Ta(e, t) {
  return (n3[e] || {})[t];
}
function o3(e) {
  return e3[e] || {
    prefix: null,
    iconName: null
  };
}
function nN(e) {
  var t = t3[e], n = H1("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Wi() {
  return W1;
}
var i3 = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function rN(e) {
  var t = Mn, n = Xx.reduce(function(r, o) {
    return r[o] = "".concat(Ze.cssPrefix, "-").concat(o), r;
  }, {});
  return Mx.forEach(function(r) {
    (e.includes(n[r]) || e.some(function(o) {
      return JP[r].includes(o);
    })) && (t = r);
  }), t;
}
function $f(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.family, r = n === void 0 ? Mn : n, o = PP[r][e];
  if (r === Kc && !e)
    return "fad";
  var i = My[r][e] || My[r][o], a = e in oo.styles ? e : null, s = i || a || null;
  return s;
}
function oN(e) {
  var t = [], n = null;
  return e.forEach(function(r) {
    var o = eN(Ze.cssPrefix, r);
    o ? n = o : r && t.push(r);
  }), {
    iconName: n,
    rest: t
  };
}
function jy(e) {
  return e.sort().filter(function(t, n, r) {
    return r.indexOf(t) === n;
  });
}
var By = Lx.concat(Fx);
function zf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.skipLookups, r = n === void 0 ? !1 : n, o = null, i = jy(e.filter(function(h) {
    return By.includes(h);
  })), a = jy(e.filter(function(h) {
    return !By.includes(h);
  })), s = i.filter(function(h) {
    return o = h, !fx.includes(h);
  }), l = Ff(s, 1), c = l[0], u = c === void 0 ? null : c, d = rN(i), m = be(be({}, oN(a)), {}, {
    prefix: $f(u, {
      family: d
    })
  });
  return be(be(be({}, m), lN({
    values: e,
    family: d,
    styles: Ec,
    config: Ze,
    canonical: m,
    givenPrefix: o
  })), iN(r, o, m));
}
function iN(e, t, n) {
  var r = n.prefix, o = n.iconName;
  if (e || !r || !o)
    return {
      prefix: r,
      iconName: o
    };
  var i = t === "fa" ? o3(o) : {}, a = Ta(r, o);
  return o = i.iconName || a || o, r = i.prefix || r, r === "far" && !Ec.far && Ec.fas && !Ze.autoFetchSvg && (r = "fas"), {
    prefix: r,
    iconName: o
  };
}
var aN = Mx.filter(function(e) {
  return e !== Mn || e !== Kc;
}), sN = Object.keys(Dh).filter(function(e) {
  return e !== Mn;
}).map(function(e) {
  return Object.keys(Dh[e]);
}).flat();
function lN(e) {
  var t = e.values, n = e.family, r = e.canonical, o = e.givenPrefix, i = o === void 0 ? "" : o, a = e.styles, s = a === void 0 ? {} : a, l = e.config, c = l === void 0 ? {} : l, u = n === Kc, d = t.includes("fa-duotone") || t.includes("fad"), m = c.familyDefault === "duotone", h = r.prefix === "fad" || r.prefix === "fa-duotone";
  if (!u && (d || m || h) && (r.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (r.prefix = "fab"), !r.prefix && aN.includes(n)) {
    var v = Object.keys(s).find(function(x) {
      return sN.includes(x);
    });
    if (v || c.autoFetchSvg) {
      var g = mD.get(n).defaultShortPrefixId;
      r.prefix = g, r.iconName = Ta(r.prefix, r.iconName) || r.iconName;
    }
  }
  return (r.prefix === "fa" || i === "fa") && (r.prefix = Wi() || "fas"), r;
}
var cN = /* @__PURE__ */ (function() {
  function e() {
    Ok(this, e), this.definitions = {};
  }
  return kk(e, [{
    key: "add",
    value: function() {
      for (var n = this, r = arguments.length, o = new Array(r), i = 0; i < r; i++)
        o[i] = arguments[i];
      var a = o.reduce(this._pullDefinitions, {});
      Object.keys(a).forEach(function(s) {
        n.definitions[s] = be(be({}, n.definitions[s] || {}), a[s]), $h(s, a[s]);
        var l = G1[Mn][s];
        l && $h(l, a[s]), r3();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(n, r) {
      var o = r.prefix && r.iconName && r.icon ? {
        0: r
      } : r;
      return Object.keys(o).map(function(i) {
        var a = o[i], s = a.prefix, l = a.iconName, c = a.icon, u = c[2];
        n[s] || (n[s] = {}), u.length > 0 && u.forEach(function(d) {
          typeof d == "string" && (n[s][d] = c);
        }), n[s][l] = c;
      }), n;
    }
  }]);
})(), Gy = [], ks = {}, Ms = {}, uN = Object.keys(Ms);
function dN(e, t) {
  var n = t.mixoutsTo;
  return Gy = e, ks = {}, Object.keys(Ms).forEach(function(r) {
    uN.indexOf(r) === -1 && delete Ms[r];
  }), Gy.forEach(function(r) {
    var o = r.mixout ? r.mixout() : {};
    if (Object.keys(o).forEach(function(a) {
      typeof o[a] == "function" && (n[a] = o[a]), Hd(o[a]) === "object" && Object.keys(o[a]).forEach(function(s) {
        n[a] || (n[a] = {}), n[a][s] = o[a][s];
      });
    }), r.hooks) {
      var i = r.hooks();
      Object.keys(i).forEach(function(a) {
        ks[a] || (ks[a] = []), ks[a].push(i[a]);
      });
    }
    r.provides && r.provides(Ms);
  }), n;
}
function zh(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    r[o - 2] = arguments[o];
  var i = ks[e] || [];
  return i.forEach(function(a) {
    t = a.apply(null, [t].concat(r));
  }), t;
}
function Fa(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var o = ks[e] || [];
  o.forEach(function(i) {
    i.apply(null, n);
  });
}
function Hi() {
  var e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Ms[e] ? Ms[e].apply(null, t) : void 0;
}
function jh(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  var t = e.iconName, n = e.prefix || Wi();
  if (t)
    return t = Ta(n, t) || t, $y(a3.definitions, n, t) || $y(oo.styles, n, t);
}
var a3 = new cN(), fN = function() {
  Ze.autoReplaceSvg = !1, Ze.observeMutations = !1, Fa("noAuto");
}, mN = {
  i2svg: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return vi ? (Fa("beforeI2svg", t), Hi("pseudoElements2svg", t), Hi("i2svg", t)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot;
    Ze.autoReplaceSvg === !1 && (Ze.autoReplaceSvg = !0), Ze.observeMutations = !0, ZP(function() {
      hN({
        autoReplaceSvgRoot: n
      }), Fa("watch", t);
    });
  }
}, pN = {
  icon: function(t) {
    if (t === null)
      return null;
    if (Hd(t) === "object" && t.prefix && t.iconName)
      return {
        prefix: t.prefix,
        iconName: Ta(t.prefix, t.iconName) || t.iconName
      };
    if (Array.isArray(t) && t.length === 2) {
      var n = t[1].indexOf("fa-") === 0 ? t[1].slice(3) : t[1], r = $f(t[0]);
      return {
        prefix: r,
        iconName: Ta(r, n) || n
      };
    }
    if (typeof t == "string" && (t.indexOf("".concat(Ze.cssPrefix, "-")) > -1 || t.match(NP))) {
      var o = zf(t.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: o.prefix || Wi(),
        iconName: Ta(o.prefix, o.iconName) || o.iconName
      };
    }
    if (typeof t == "string") {
      var i = Wi();
      return {
        prefix: i,
        iconName: Ta(i, t) || t
      };
    }
  }
}, Dr = {
  noAuto: fN,
  config: Ze,
  dom: mN,
  parse: pN,
  library: a3,
  findIconDefinition: jh,
  toHtml: Xc
}, hN = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot, r = n === void 0 ? Bt : n;
  (Object.keys(oo.styles).length > 0 || Ze.autoFetchSvg) && vi && Ze.autoReplaceSvg && Dr.dom.i2svg({
    node: r
  });
};
function jf(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map(function(r) {
        return Xc(r);
      });
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (vi) {
        var r = Bt.createElement("div");
        return r.innerHTML = e.html, r.children;
      }
    }
  }), e;
}
function gN(e) {
  var t = e.children, n = e.main, r = e.mask, o = e.attributes, i = e.styles, a = e.transform;
  if (U1(a) && n.found && !r.found) {
    var s = n.width, l = n.height, c = {
      x: s / l / 2,
      y: 0.5
    };
    o.style = Lf(be(be({}, i), {}, {
      "transform-origin": "".concat(c.x + a.x / 16, "em ").concat(c.y + a.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: o,
    children: t
  }];
}
function vN(e) {
  var t = e.prefix, n = e.iconName, r = e.children, o = e.attributes, i = e.symbol, a = i === !0 ? "".concat(t, "-").concat(Ze.cssPrefix, "-").concat(n) : i;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: be(be({}, o), {}, {
        id: a
      }),
      children: r
    }]
  }];
}
function yN(e) {
  var t = ["aria-label", "aria-labelledby", "title", "role"];
  return t.some(function(n) {
    return n in e;
  });
}
function q1(e) {
  var t = e.icons, n = t.main, r = t.mask, o = e.prefix, i = e.iconName, a = e.transform, s = e.symbol, l = e.maskId, c = e.extra, u = e.watchable, d = u === void 0 ? !1 : u, m = r.found ? r : n, h = m.width, v = m.height, g = [Ze.replacementClass, i ? "".concat(Ze.cssPrefix, "-").concat(i) : ""].filter(function(R) {
    return c.classes.indexOf(R) === -1;
  }).filter(function(R) {
    return R !== "" || !!R;
  }).concat(c.classes).join(" "), x = {
    children: [],
    attributes: be(be({}, c.attributes), {}, {
      "data-prefix": o,
      "data-icon": i,
      class: g,
      role: c.attributes.role || "img",
      viewBox: "0 0 ".concat(h, " ").concat(v)
    })
  };
  !yN(c.attributes) && !c.attributes["aria-hidden"] && (x.attributes["aria-hidden"] = "true"), d && (x.attributes[Ma] = "");
  var b = be(be({}, x), {}, {
    prefix: o,
    iconName: i,
    main: n,
    mask: r,
    maskId: l,
    transform: a,
    symbol: s,
    styles: be({}, c.styles)
  }), C = r.found && n.found ? Hi("generateAbstractMask", b) || {
    children: [],
    attributes: {}
  } : Hi("generateAbstractIcon", b) || {
    children: [],
    attributes: {}
  }, I = C.children, T = C.attributes;
  return b.children = I, b.attributes = T, s ? vN(b) : gN(b);
}
function Vy(e) {
  var t = e.content, n = e.width, r = e.height, o = e.transform, i = e.extra, a = e.watchable, s = a === void 0 ? !1 : a, l = be(be({}, i.attributes), {}, {
    class: i.classes.join(" ")
  });
  s && (l[Ma] = "");
  var c = be({}, i.styles);
  U1(o) && (c.transform = qP({
    transform: o,
    width: n,
    height: r
  }), c["-webkit-transform"] = c.transform);
  var u = Lf(c);
  u.length > 0 && (l.style = u);
  var d = [];
  return d.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), d;
}
function bN(e) {
  var t = e.content, n = e.extra, r = be(be({}, n.attributes), {}, {
    class: n.classes.join(" ")
  }), o = Lf(n.styles);
  o.length > 0 && (r.style = o);
  var i = [];
  return i.push({
    tag: "span",
    attributes: r,
    children: [t]
  }), i;
}
var pp = oo.styles;
function Bh(e) {
  var t = e[0], n = e[1], r = e.slice(4), o = Ff(r, 1), i = o[0], a = null;
  return Array.isArray(i) ? a = {
    tag: "g",
    attributes: {
      class: "".concat(Ze.cssPrefix, "-").concat(dp.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Ze.cssPrefix, "-").concat(dp.SECONDARY),
        fill: "currentColor",
        d: i[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Ze.cssPrefix, "-").concat(dp.PRIMARY),
        fill: "currentColor",
        d: i[1]
      }
    }]
  } : a = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: i
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: a
  };
}
var SN = {
  found: !1,
  width: 512,
  height: 512
};
function xN(e, t) {
  !Gx && !Ze.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function Gh(e, t) {
  var n = t;
  return t === "fa" && Ze.styleDefault !== null && (t = Wi()), new Promise(function(r, o) {
    if (n === "fa") {
      var i = o3(e) || {};
      e = i.iconName || e, t = i.prefix || t;
    }
    if (e && t && pp[t] && pp[t][e]) {
      var a = pp[t][e];
      return r(Bh(a));
    }
    xN(e, t), r(be(be({}, SN), {}, {
      icon: Ze.showMissingIcons && e ? Hi("missingIconAbstract") || {} : {}
    }));
  });
}
var Uy = function() {
}, Vh = Ze.measurePerformance && Pu && Pu.mark && Pu.measure ? Pu : {
  mark: Uy,
  measure: Uy
}, Kl = 'FA "7.3.1"', CN = function(t) {
  return Vh.mark("".concat(Kl, " ").concat(t, " begins")), function() {
    return s3(t);
  };
}, s3 = function(t) {
  Vh.mark("".concat(Kl, " ").concat(t, " ends")), Vh.measure("".concat(Kl, " ").concat(t), "".concat(Kl, " ").concat(t, " begins"), "".concat(Kl, " ").concat(t, " ends"));
}, Y1 = {
  begin: CN,
  end: s3
}, Sd = function() {
};
function Wy(e) {
  var t = e.getAttribute ? e.getAttribute(Ma) : null;
  return typeof t == "string";
}
function wN(e) {
  var t = e.getAttribute ? e.getAttribute(j1) : null, n = e.getAttribute ? e.getAttribute(B1) : null;
  return t && n;
}
function EN(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(Ze.replacementClass);
}
function IN() {
  if (Ze.autoReplaceSvg === !0)
    return xd.replace;
  var e = xd[Ze.autoReplaceSvg];
  return e || xd.replace;
}
function RN(e) {
  return Bt.createElementNS("http://www.w3.org/2000/svg", e);
}
function TN(e) {
  return Bt.createElement(e);
}
function l3(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.ceFn, r = n === void 0 ? e.tag === "svg" ? RN : TN : n;
  if (typeof e == "string")
    return Bt.createTextNode(e);
  var o = r(e.tag);
  Object.keys(e.attributes || []).forEach(function(a) {
    o.setAttribute(a, e.attributes[a]);
  });
  var i = e.children || [];
  return i.forEach(function(a) {
    o.appendChild(l3(a, {
      ceFn: r
    }));
  }), o;
}
function _N(e) {
  var t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
var xd = {
  replace: function(t) {
    var n = t[0];
    if (n.parentNode)
      if (t[1].forEach(function(o) {
        n.parentNode.insertBefore(l3(o), n);
      }), n.getAttribute(Ma) === null && Ze.keepOriginalSource) {
        var r = Bt.createComment(_N(n));
        n.parentNode.replaceChild(r, n);
      } else
        n.remove();
  },
  nest: function(t) {
    var n = t[0], r = t[1];
    if (~V1(n).indexOf(Ze.replacementClass))
      return xd.replace(t);
    var o = new RegExp("".concat(Ze.cssPrefix, "-.*"));
    if (delete r[0].attributes.id, r[0].attributes.class) {
      var i = r[0].attributes.class.split(" ").reduce(function(s, l) {
        return l === Ze.replacementClass || l.match(o) ? s.toSvg.push(l) : s.toNode.push(l), s;
      }, {
        toNode: [],
        toSvg: []
      });
      r[0].attributes.class = i.toSvg.join(" "), i.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", i.toNode.join(" "));
    }
    var a = r.map(function(s) {
      return Xc(s);
    }).join(`
`);
    n.setAttribute(Ma, ""), n.innerHTML = a;
  }
};
function Hy(e) {
  e();
}
function c3(e, t) {
  var n = typeof t == "function" ? t : Sd;
  if (e.length === 0)
    n();
  else {
    var r = Hy;
    Ze.mutateApproach === kP && (r = Ui.requestAnimationFrame || Hy), r(function() {
      var o = IN(), i = Y1.begin("mutate");
      e.map(o), i(), n();
    });
  }
}
var K1 = !1;
function u3() {
  K1 = !0;
}
function Uh() {
  K1 = !1;
}
var Yd = null;
function qy(e) {
  if (ky && Ze.observeMutations) {
    var t = e.treeCallback, n = t === void 0 ? Sd : t, r = e.nodeCallback, o = r === void 0 ? Sd : r, i = e.pseudoElementsCallback, a = i === void 0 ? Sd : i, s = e.observeMutationsRoot, l = s === void 0 ? Bt : s;
    Yd = new ky(function(c) {
      if (!K1) {
        var u = Wi();
        ul(c).forEach(function(d) {
          if (d.type === "childList" && d.addedNodes.length > 0 && !Wy(d.addedNodes[0]) && (Ze.searchPseudoElements && a(d.target), n(d.target)), d.type === "attributes" && d.target.parentNode && Ze.searchPseudoElements && a([d.target], !0), d.type === "attributes" && Wy(d.target) && ~LP.indexOf(d.attributeName))
            if (d.attributeName === "class" && wN(d.target)) {
              var m = zf(V1(d.target)), h = m.prefix, v = m.iconName;
              d.target.setAttribute(j1, h || u), v && d.target.setAttribute(B1, v);
            } else EN(d.target) && o(d.target);
        });
      }
    }), vi && Yd.observe(l, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function ON() {
  Yd && Yd.disconnect();
}
function AN(e) {
  var t = e.getAttribute("style"), n = [];
  return t && (n = t.split(";").reduce(function(r, o) {
    var i = o.split(":"), a = i[0], s = i.slice(1);
    return a && s.length > 0 && (r[a] = s.join(":").trim()), r;
  }, {})), n;
}
function kN(e) {
  var t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "", o = zf(V1(e));
  return o.prefix || (o.prefix = Wi()), t && n && (o.prefix = t, o.iconName = n), o.iconName && o.prefix || (o.prefix && r.length > 0 && (o.iconName = tN(o.prefix, e.innerText) || H1(o.prefix, Zx(e.innerText))), !o.iconName && Ze.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (o.iconName = e.firstChild.data)), o;
}
function DN(e) {
  var t = ul(e.attributes).reduce(function(n, r) {
    return n.name !== "class" && n.name !== "style" && (n[r.name] = r.value), n;
  }, {});
  return t;
}
function PN() {
  return {
    iconName: null,
    prefix: null,
    transform: Do,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Yy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, n = kN(e), r = n.iconName, o = n.prefix, i = n.rest, a = DN(e), s = zh("parseNodeAttributes", {}, e), l = t.styleParser ? AN(e) : [];
  return be({
    iconName: r,
    prefix: o,
    transform: Do,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: l,
      attributes: a
    }
  }, s);
}
var NN = oo.styles;
function d3(e) {
  var t = Ze.autoReplaceSvg === "nest" ? Yy(e, {
    styleParser: !1
  }) : Yy(e);
  return ~t.extra.classes.indexOf(Ux) ? Hi("generateLayersText", e, t) : Hi("generateSvgReplacementMutation", e, t);
}
function MN() {
  return [].concat(co(Fx), co(Lx));
}
function Ky(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!vi) return Promise.resolve();
  var n = Bt.documentElement.classList, r = function(d) {
    return n.add("".concat(Ny, "-").concat(d));
  }, o = function(d) {
    return n.remove("".concat(Ny, "-").concat(d));
  }, i = Ze.autoFetchSvg ? MN() : fx.concat(Object.keys(NN));
  i.includes("fa") || i.push("fa");
  var a = [".".concat(Ux, ":not([").concat(Ma, "])")].concat(i.map(function(u) {
    return ".".concat(u, ":not([").concat(Ma, "])");
  })).join(", ");
  if (a.length === 0)
    return Promise.resolve();
  var s = [];
  try {
    s = ul(e.querySelectorAll(a));
  } catch {
  }
  if (s.length > 0)
    r("pending"), o("complete");
  else
    return Promise.resolve();
  var l = Y1.begin("onTree"), c = s.reduce(function(u, d) {
    try {
      var m = d3(d);
      m && u.push(m);
    } catch (h) {
      Gx || h.name === "MissingIcon" && console.error(h);
    }
    return u;
  }, []);
  return new Promise(function(u, d) {
    Promise.all(c).then(function(m) {
      c3(m, function() {
        r("active"), r("complete"), o("pending"), typeof t == "function" && t(), l(), u();
      });
    }).catch(function(m) {
      l(), d(m);
    });
  });
}
function FN(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  d3(e).then(function(n) {
    n && c3([n], t);
  });
}
function LN(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (t || {}).icon ? t : jh(t || {}), o = n.mask;
    return o && (o = (o || {}).icon ? o : jh(o || {})), e(r, be(be({}, n), {}, {
      mask: o
    }));
  };
}
var $N = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.transform, o = r === void 0 ? Do : r, i = n.symbol, a = i === void 0 ? !1 : i, s = n.mask, l = s === void 0 ? null : s, c = n.maskId, u = c === void 0 ? null : c, d = n.classes, m = d === void 0 ? [] : d, h = n.attributes, v = h === void 0 ? {} : h, g = n.styles, x = g === void 0 ? {} : g;
  if (t) {
    var b = t.prefix, C = t.iconName, I = t.icon;
    return jf(be({
      type: "icon"
    }, t), function() {
      return Fa("beforeDOMElementCreation", {
        iconDefinition: t,
        params: n
      }), q1({
        icons: {
          main: Bh(I),
          mask: l ? Bh(l.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: b,
        iconName: C,
        transform: be(be({}, Do), o),
        symbol: a,
        maskId: u,
        extra: {
          attributes: v,
          styles: x,
          classes: m
        }
      });
    });
  }
}, zN = {
  mixout: function() {
    return {
      icon: LN($N)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.treeCallback = Ky, n.nodeCallback = FN, n;
      }
    };
  },
  provides: function(t) {
    t.i2svg = function(n) {
      var r = n.node, o = r === void 0 ? Bt : r, i = n.callback, a = i === void 0 ? function() {
      } : i;
      return Ky(o, a);
    }, t.generateSvgReplacementMutation = function(n, r) {
      var o = r.iconName, i = r.prefix, a = r.transform, s = r.symbol, l = r.mask, c = r.maskId, u = r.extra;
      return new Promise(function(d, m) {
        Promise.all([Gh(o, i), l.iconName ? Gh(l.iconName, l.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(h) {
          var v = Ff(h, 2), g = v[0], x = v[1];
          d([n, q1({
            icons: {
              main: g,
              mask: x
            },
            prefix: i,
            iconName: o,
            transform: a,
            symbol: s,
            maskId: c,
            extra: u,
            watchable: !0
          })]);
        }).catch(m);
      });
    }, t.generateAbstractIcon = function(n) {
      var r = n.children, o = n.attributes, i = n.main, a = n.transform, s = n.styles, l = Lf(s);
      l.length > 0 && (o.style = l);
      var c;
      return U1(a) && (c = Hi("generateAbstractTransformGrouping", {
        main: i,
        transform: a,
        containerWidth: i.width,
        iconWidth: i.width
      })), r.push(c || i.icon), {
        children: r,
        attributes: o
      };
    };
  }
}, jN = {
  mixout: function() {
    return {
      layer: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.classes, i = o === void 0 ? [] : o;
        return jf({
          type: "layer"
        }, function() {
          Fa("beforeDOMElementCreation", {
            assembler: n,
            params: r
          });
          var a = [];
          return n(function(s) {
            Array.isArray(s) ? s.map(function(l) {
              a = a.concat(l.abstract);
            }) : a = a.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Ze.cssPrefix, "-layers")].concat(co(i)).join(" ")
            },
            children: a
          }];
        });
      }
    };
  }
}, BN = {
  mixout: function() {
    return {
      counter: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        r.title;
        var o = r.classes, i = o === void 0 ? [] : o, a = r.attributes, s = a === void 0 ? {} : a, l = r.styles, c = l === void 0 ? {} : l;
        return jf({
          type: "counter",
          content: n
        }, function() {
          return Fa("beforeDOMElementCreation", {
            content: n,
            params: r
          }), bN({
            content: n.toString(),
            extra: {
              attributes: s,
              styles: c,
              classes: ["".concat(Ze.cssPrefix, "-layers-counter")].concat(co(i))
            }
          });
        });
      }
    };
  }
}, GN = {
  mixout: function() {
    return {
      text: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.transform, i = o === void 0 ? Do : o, a = r.classes, s = a === void 0 ? [] : a, l = r.attributes, c = l === void 0 ? {} : l, u = r.styles, d = u === void 0 ? {} : u;
        return jf({
          type: "text",
          content: n
        }, function() {
          return Fa("beforeDOMElementCreation", {
            content: n,
            params: r
          }), Vy({
            content: n,
            transform: be(be({}, Do), i),
            extra: {
              attributes: c,
              styles: d,
              classes: ["".concat(Ze.cssPrefix, "-layers-text")].concat(co(s))
            }
          });
        });
      }
    };
  },
  provides: function(t) {
    t.generateLayersText = function(n, r) {
      var o = r.transform, i = r.extra, a = null, s = null;
      if (ux) {
        var l = parseInt(getComputedStyle(n).fontSize, 10), c = n.getBoundingClientRect();
        a = c.width / l, s = c.height / l;
      }
      return Promise.resolve([n, Vy({
        content: n.innerHTML,
        width: a,
        height: s,
        transform: o,
        extra: i,
        watchable: !0
      })]);
    };
  }
}, f3 = new RegExp('"', "ug"), Zy = [1105920, 1112319], Xy = be(be(be(be({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), fD), OP), xD), Wh = Object.keys(Xy).reduce(function(e, t) {
  return e[t.toLowerCase()] = Xy[t], e;
}, {}), VN = Object.keys(Wh).reduce(function(e, t) {
  var n = Wh[t];
  return e[t] = n[900] || co(Object.entries(n))[0][1], e;
}, {});
function UN(e) {
  var t = e.replace(f3, "");
  return Zx(co(t)[0] || "");
}
function WN(e) {
  var t = e.getPropertyValue("font-feature-settings").includes("ss01"), n = e.getPropertyValue("content"), r = n.replace(f3, ""), o = r.codePointAt(0), i = o >= Zy[0] && o <= Zy[1], a = r.length === 2 ? r[0] === r[1] : !1;
  return i || a || t;
}
function HN(e, t) {
  var n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(t), o = isNaN(r) ? "normal" : r;
  return (Wh[n] || {})[o] || VN[n];
}
function Jy(e, t) {
  var n = "".concat(AP).concat(t.replace(":", "-"));
  return new Promise(function(r, o) {
    if (e.getAttribute(n) !== null)
      return r();
    var i = ul(e.children), a = i.filter(function(A) {
      return A.getAttribute(Nh) === t;
    })[0], s = Ui.getComputedStyle(e, t), l = s.getPropertyValue("font-family"), c = l.match(MP), u = s.getPropertyValue("font-weight"), d = s.getPropertyValue("content");
    if (a && !c)
      return e.removeChild(a), r();
    if (c && d !== "none" && d !== "") {
      var m = s.getPropertyValue("content"), h = HN(l, u), v = UN(m), g = c[0].startsWith("FontAwesome"), x = WN(s), b = H1(h, v), C = b;
      if (g) {
        var I = nN(v);
        I.iconName && I.prefix && (b = I.iconName, h = I.prefix);
      }
      if (b && !x && (!a || a.getAttribute(j1) !== h || a.getAttribute(B1) !== C)) {
        e.setAttribute(n, C), a && e.removeChild(a);
        var T = PN(), R = T.extra;
        R.attributes[Nh] = t, Gh(b, h).then(function(A) {
          var _ = q1(be(be({}, T), {}, {
            icons: {
              main: A,
              mask: i3()
            },
            prefix: h,
            iconName: C,
            extra: R,
            watchable: !0
          })), k = Bt.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(k, e.firstChild) : e.appendChild(k), k.outerHTML = _.map(function(M) {
            return Xc(M);
          }).join(`
`), e.removeAttribute(n), r();
        }).catch(o);
      } else
        r();
    } else
      r();
  });
}
function qN(e) {
  return Promise.all([Jy(e, "::before"), Jy(e, "::after")]);
}
function YN(e) {
  return e.parentNode !== document.head && !~DP.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Nh) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
var KN = function(t) {
  return !!t && Bx.some(function(n) {
    return t.includes(n);
  });
}, ZN = function(t) {
  if (!t) return [];
  var n = /* @__PURE__ */ new Set(), r = t.split(/,(?![^()]*\))/).map(function(l) {
    return l.trim();
  });
  r = r.flatMap(function(l) {
    return l.includes("(") ? l : l.split(",").map(function(c) {
      return c.trim();
    });
  });
  var o = bd(r), i;
  try {
    for (o.s(); !(i = o.n()).done; ) {
      var a = i.value;
      if (KN(a)) {
        var s = Bx.reduce(function(l, c) {
          return l.replace(c, "");
        }, a);
        s !== "" && s !== "*" && n.add(s);
      }
    }
  } catch (l) {
    o.e(l);
  } finally {
    o.f();
  }
  return n;
};
function Qy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (vi) {
    var n;
    if (t)
      n = e;
    else if (Ze.searchPseudoElementsFullScan)
      n = e.querySelectorAll("*");
    else {
      var r = /* @__PURE__ */ new Set(), o = bd(document.styleSheets), i;
      try {
        for (o.s(); !(i = o.n()).done; ) {
          var a = i.value;
          try {
            var s = bd(a.cssRules), l;
            try {
              for (s.s(); !(l = s.n()).done; ) {
                var c = l.value, u = ZN(c.selectorText), d = bd(u), m;
                try {
                  for (d.s(); !(m = d.n()).done; ) {
                    var h = m.value;
                    r.add(h);
                  }
                } catch (g) {
                  d.e(g);
                } finally {
                  d.f();
                }
              }
            } catch (g) {
              s.e(g);
            } finally {
              s.f();
            }
          } catch (g) {
            Ze.searchPseudoElementsWarnings && console.warn("Font Awesome: cannot parse stylesheet: ".concat(a.href, " (").concat(g.message, `)
If it declares any Font Awesome CSS pseudo-elements, they will not be rendered as SVG icons. Add crossorigin="anonymous" to the <link>, enable searchPseudoElementsFullScan for slower but more thorough DOM parsing, or suppress this warning by setting searchPseudoElementsWarnings to false.`));
          }
        }
      } catch (g) {
        o.e(g);
      } finally {
        o.f();
      }
      if (!r.size) return;
      var v = Array.from(r).join(", ");
      try {
        n = e.querySelectorAll(v);
      } catch {
      }
    }
    return new Promise(function(g, x) {
      var b = ul(n).filter(YN).map(qN), C = Y1.begin("searchPseudoElements");
      u3(), Promise.all(b).then(function() {
        C(), Uh(), g();
      }).catch(function() {
        C(), Uh(), x();
      });
    });
  }
}
var XN = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.pseudoElementsCallback = Qy, n;
      }
    };
  },
  provides: function(t) {
    t.pseudoElements2svg = function(n) {
      var r = n.node, o = r === void 0 ? Bt : r;
      Ze.searchPseudoElements && Qy(o);
    };
  }
}, eb = !1, JN = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          u3(), eb = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        qy(zh("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        ON();
      },
      watch: function(n) {
        var r = n.observeMutationsRoot;
        eb ? Uh() : qy(zh("mutationObserverCallbacks", {
          observeMutationsRoot: r
        }));
      }
    };
  }
}, tb = function(t) {
  var n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return t.toLowerCase().split(" ").reduce(function(r, o) {
    var i = o.toLowerCase().split("-"), a = i[0], s = i.slice(1).join("-");
    if (a && s === "h")
      return r.flipX = !0, r;
    if (a && s === "v")
      return r.flipY = !0, r;
    if (s = parseFloat(s), isNaN(s))
      return r;
    switch (a) {
      case "grow":
        r.size = r.size + s;
        break;
      case "shrink":
        r.size = r.size - s;
        break;
      case "left":
        r.x = r.x - s;
        break;
      case "right":
        r.x = r.x + s;
        break;
      case "up":
        r.y = r.y - s;
        break;
      case "down":
        r.y = r.y + s;
        break;
      case "rotate":
        r.rotate = r.rotate + s;
        break;
    }
    return r;
  }, n);
}, QN = {
  mixout: function() {
    return {
      parse: {
        transform: function(n) {
          return tb(n);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var o = r.getAttribute("data-fa-transform");
        return o && (n.transform = tb(o)), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractTransformGrouping = function(n) {
      var r = n.main, o = n.transform, i = n.containerWidth, a = n.iconWidth, s = {
        transform: "translate(".concat(i / 2, " 256)")
      }, l = "translate(".concat(o.x * 32, ", ").concat(o.y * 32, ") "), c = "scale(".concat(o.size / 16 * (o.flipX ? -1 : 1), ", ").concat(o.size / 16 * (o.flipY ? -1 : 1), ") "), u = "rotate(".concat(o.rotate, " 0 0)"), d = {
        transform: "".concat(l, " ").concat(c, " ").concat(u)
      }, m = {
        transform: "translate(".concat(a / 2 * -1, " -256)")
      }, h = {
        outer: s,
        inner: d,
        path: m
      };
      return {
        tag: "g",
        attributes: be({}, h.outer),
        children: [{
          tag: "g",
          attributes: be({}, h.inner),
          children: [{
            tag: r.icon.tag,
            children: r.icon.children,
            attributes: be(be({}, r.icon.attributes), h.path)
          }]
        }]
      };
    };
  }
}, hp = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function nb(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function eM(e) {
  return e.tag === "g" ? e.children : [e];
}
var tM = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var o = r.getAttribute("data-fa-mask"), i = o ? zf(o.split(" ").map(function(a) {
          return a.trim();
        })) : i3();
        return i.prefix || (i.prefix = Wi()), n.mask = i, n.maskId = r.getAttribute("data-fa-mask-id"), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractMask = function(n) {
      var r = n.children, o = n.attributes, i = n.main, a = n.mask, s = n.maskId, l = n.transform, c = i.width, u = i.icon, d = a.width, m = a.icon, h = HP({
        transform: l,
        containerWidth: d,
        iconWidth: c
      }), v = {
        tag: "rect",
        attributes: be(be({}, hp), {}, {
          fill: "white"
        })
      }, g = u.children ? {
        children: u.children.map(nb)
      } : {}, x = {
        tag: "g",
        attributes: be({}, h.inner),
        children: [nb(be({
          tag: u.tag,
          attributes: be(be({}, u.attributes), h.path)
        }, g))]
      }, b = {
        tag: "g",
        attributes: be({}, h.outer),
        children: [x]
      }, C = "mask-".concat(s || Fy()), I = "clip-".concat(s || Fy()), T = {
        tag: "mask",
        attributes: be(be({}, hp), {}, {
          id: C,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [v, b]
      }, R = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: I
          },
          children: eM(m)
        }, T]
      };
      return r.push(R, {
        tag: "rect",
        attributes: be({
          fill: "currentColor",
          "clip-path": "url(#".concat(I, ")"),
          mask: "url(#".concat(C, ")")
        }, hp)
      }), {
        children: r,
        attributes: o
      };
    };
  }
}, nM = {
  provides: function(t) {
    var n = !1;
    Ui.matchMedia && (n = Ui.matchMedia("(prefers-reduced-motion: reduce)").matches), t.missingIconAbstract = function() {
      var r = [], o = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      r.push({
        tag: "path",
        attributes: be(be({}, o), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var a = be(be({}, i), {}, {
        attributeName: "opacity"
      }), s = {
        tag: "circle",
        attributes: be(be({}, o), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || s.children.push({
        tag: "animate",
        attributes: be(be({}, i), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: be(be({}, a), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), r.push(s), r.push({
        tag: "path",
        attributes: be(be({}, o), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: be(be({}, a), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || r.push({
        tag: "path",
        attributes: be(be({}, o), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: be(be({}, a), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: r
      };
    };
  }
}, rM = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var o = r.getAttribute("data-fa-symbol"), i = o === null ? !1 : o === "" ? !0 : o;
        return n.symbol = i, n;
      }
    };
  }
}, oM = [KP, zN, jN, BN, GN, XN, JN, QN, tM, nM, rM];
dN(oM, {
  mixoutsTo: Dr
});
Dr.noAuto;
var La = Dr.config;
Dr.library;
Dr.dom;
var m3 = Dr.parse;
Dr.findIconDefinition;
Dr.toHtml;
var iM = Dr.icon;
Dr.layer;
Dr.text;
Dr.counter;
La.autoAddCss = !1;
function p3(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = p3(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function aM() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = p3(e)) && (r && (r += " "), r += t);
  return r;
}
const sM = (e, t) => {
  const n = new Array(e.length + t.length);
  for (let r = 0; r < e.length; r++)
    n[r] = e[r];
  for (let r = 0; r < t.length; r++)
    n[e.length + r] = t[r];
  return n;
}, lM = (e, t) => ({
  classGroupId: e,
  validator: t
}), h3 = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
  nextPart: e,
  validators: t,
  classGroupId: n
}), Kd = "-", rb = [], cM = "arbitrary..", uM = (e) => {
  const t = fM(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      if (a.startsWith("[") && a.endsWith("]"))
        return dM(a);
      const s = a.split(Kd), l = s[0] === "" && s.length > 1 ? 1 : 0;
      return g3(s, l, t);
    },
    getConflictingClassGroupIds: (a, s) => {
      if (s) {
        const l = r[a], c = n[a];
        return l ? c ? sM(c, l) : l : c || rb;
      }
      return n[a] || rb;
    }
  };
}, g3 = (e, t, n) => {
  if (e.length - t === 0)
    return n.classGroupId;
  const o = e[t], i = n.nextPart.get(o);
  if (i) {
    const c = g3(e, t + 1, i);
    if (c) return c;
  }
  const a = n.validators;
  if (a === null)
    return;
  const s = t === 0 ? e.join(Kd) : e.slice(t).join(Kd), l = a.length;
  for (let c = 0; c < l; c++) {
    const u = a[c];
    if (u.validator(s))
      return u.classGroupId;
  }
}, dM = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
  return r ? cM + r : void 0;
})(), fM = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e;
  return mM(n, t);
}, mM = (e, t) => {
  const n = h3();
  for (const r in e) {
    const o = e[r];
    Z1(o, n, r, t);
  }
  return n;
}, Z1 = (e, t, n, r) => {
  const o = e.length;
  for (let i = 0; i < o; i++) {
    const a = e[i];
    pM(a, t, n, r);
  }
}, pM = (e, t, n, r) => {
  if (typeof e == "string") {
    hM(e, t, n);
    return;
  }
  if (typeof e == "function") {
    gM(e, t, n, r);
    return;
  }
  vM(e, t, n, r);
}, hM = (e, t, n) => {
  const r = e === "" ? t : v3(t, e);
  r.classGroupId = n;
}, gM = (e, t, n, r) => {
  if (yM(e)) {
    Z1(e(r), t, n, r);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(lM(n, e));
}, vM = (e, t, n, r) => {
  const o = Object.entries(e), i = o.length;
  for (let a = 0; a < i; a++) {
    const [s, l] = o[a];
    Z1(l, v3(t, s), n, r);
  }
}, v3 = (e, t) => {
  let n = e;
  const r = t.split(Kd), o = r.length;
  for (let i = 0; i < o; i++) {
    const a = r[i];
    let s = n.nextPart.get(a);
    s || (s = h3(), n.nextPart.set(a, s)), n = s;
  }
  return n;
}, yM = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, bM = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  const o = (i, a) => {
    n[i] = a, t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(i) {
      let a = n[i];
      if (a !== void 0)
        return a;
      if ((a = r[i]) !== void 0)
        return o(i, a), a;
    },
    set(i, a) {
      i in n ? n[i] = a : o(i, a);
    }
  };
}, Hh = "!", ob = ":", SM = [], ib = (e, t, n, r, o) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: n,
  maybePostfixModifierPosition: r,
  isExternal: o
}), xM = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (o) => {
    const i = [];
    let a = 0, s = 0, l = 0, c;
    const u = o.length;
    for (let g = 0; g < u; g++) {
      const x = o[g];
      if (a === 0 && s === 0) {
        if (x === ob) {
          i.push(o.slice(l, g)), l = g + 1;
          continue;
        }
        if (x === "/") {
          c = g;
          continue;
        }
      }
      x === "[" ? a++ : x === "]" ? a-- : x === "(" ? s++ : x === ")" && s--;
    }
    const d = i.length === 0 ? o : o.slice(l);
    let m = d, h = !1;
    d.endsWith(Hh) ? (m = d.slice(0, -1), h = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      d.startsWith(Hh) && (m = d.slice(1), h = !0)
    );
    const v = c && c > l ? c - l : void 0;
    return ib(i, h, m, v);
  };
  if (t) {
    const o = t + ob, i = r;
    r = (a) => a.startsWith(o) ? i(a.slice(o.length)) : ib(SM, !1, a, void 0, !0);
  }
  if (n) {
    const o = r;
    r = (i) => n({
      className: i,
      parseClassName: o
    });
  }
  return r;
}, CM = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((n, r) => {
    t.set(n, 1e6 + r);
  }), (n) => {
    const r = [];
    let o = [];
    for (let i = 0; i < n.length; i++) {
      const a = n[i], s = a[0] === "[", l = t.has(a);
      s || l ? (o.length > 0 && (o.sort(), r.push(...o), o = []), r.push(a)) : o.push(a);
    }
    return o.length > 0 && (o.sort(), r.push(...o)), r;
  };
}, wM = (e) => ({
  cache: bM(e.cacheSize),
  parseClassName: xM(e),
  sortModifiers: CM(e),
  postfixLookupClassGroupIds: EM(e),
  ...uM(e)
}), EM = (e) => {
  const t = /* @__PURE__ */ Object.create(null), n = e.postfixLookupClassGroups;
  if (n)
    for (let r = 0; r < n.length; r++)
      t[n[r]] = !0;
  return t;
}, IM = /\s+/, RM = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o,
    sortModifiers: i,
    postfixLookupClassGroupIds: a
  } = t, s = [], l = e.trim().split(IM);
  let c = "";
  for (let u = l.length - 1; u >= 0; u -= 1) {
    const d = l[u], {
      isExternal: m,
      modifiers: h,
      hasImportantModifier: v,
      baseClassName: g,
      maybePostfixModifierPosition: x
    } = n(d);
    if (m) {
      c = d + (c.length > 0 ? " " + c : c);
      continue;
    }
    let b = !!x, C;
    if (b) {
      const _ = g.substring(0, x);
      C = r(_);
      const k = C && a[C] ? r(g) : void 0;
      k && k !== C && (C = k, b = !1);
    } else
      C = r(g);
    if (!C) {
      if (!b) {
        c = d + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (C = r(g), !C) {
        c = d + (c.length > 0 ? " " + c : c);
        continue;
      }
      b = !1;
    }
    const I = h.length === 0 ? "" : h.length === 1 ? h[0] : i(h).join(":"), T = v ? I + Hh : I, R = T + C;
    if (s.indexOf(R) > -1)
      continue;
    s.push(R);
    const A = o(C, b);
    for (let _ = 0; _ < A.length; ++_) {
      const k = A[_];
      s.push(T + k);
    }
    c = d + (c.length > 0 ? " " + c : c);
  }
  return c;
}, TM = (...e) => {
  let t = 0, n, r, o = "";
  for (; t < e.length; )
    (n = e[t++]) && (r = y3(n)) && (o && (o += " "), o += r);
  return o;
}, y3 = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = y3(e[r])) && (n && (n += " "), n += t);
  return n;
}, _M = (e, ...t) => {
  let n, r, o, i;
  const a = (l) => {
    const c = t.reduce((u, d) => d(u), e());
    return n = wM(c), r = n.cache.get, o = n.cache.set, i = s, s(l);
  }, s = (l) => {
    const c = r(l);
    if (c)
      return c;
    const u = RM(l, n);
    return o(l, u), u;
  };
  return i = a, (...l) => i(TM(...l));
}, OM = [], bn = (e) => {
  const t = (n) => n[e] || OM;
  return t.isThemeGetter = !0, t.themeKey = e, t;
}, b3 = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, S3 = /^\((?:(\w[\w-]*):)?(.+)\)$/i, AM = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, kM = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, DM = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, PM = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/, NM = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, MM = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, xi = (e) => AM.test(e), ct = (e) => !!e && !Number.isNaN(Number(e)), Co = (e) => !!e && Number.isInteger(Number(e)), gp = (e) => e.endsWith("%") && ct(e.slice(0, -1)), Uo = (e) => kM.test(e), x3 = () => !0, FM = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  DM.test(e) && !PM.test(e)
), X1 = () => !1, LM = (e) => NM.test(e), $M = (e) => MM.test(e), zM = (e) => !Ae(e) && !Pe(e), jM = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), BM = (e) => ia(e, E3, X1), Ae = (e) => b3.test(e), Sa = (e) => ia(e, I3, FM), ab = (e) => ia(e, KM, ct), GM = (e) => ia(e, T3, x3), VM = (e) => ia(e, R3, X1), sb = (e) => ia(e, C3, X1), UM = (e) => ia(e, w3, $M), Lu = (e) => ia(e, _3, LM), Pe = (e) => S3.test(e), Dl = (e) => Ka(e, I3), WM = (e) => Ka(e, R3), lb = (e) => Ka(e, C3), HM = (e) => Ka(e, E3), qM = (e) => Ka(e, w3), $u = (e) => Ka(e, _3, !0), YM = (e) => Ka(e, T3, !0), ia = (e, t, n) => {
  const r = b3.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Ka = (e, t, n = !1) => {
  const r = S3.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, C3 = (e) => e === "position" || e === "percentage", w3 = (e) => e === "image" || e === "url", E3 = (e) => e === "length" || e === "size" || e === "bg-size", I3 = (e) => e === "length", KM = (e) => e === "number", R3 = (e) => e === "family-name", T3 = (e) => e === "number" || e === "weight", _3 = (e) => e === "shadow", ZM = () => {
  const e = bn("color"), t = bn("font"), n = bn("text"), r = bn("font-weight"), o = bn("tracking"), i = bn("leading"), a = bn("breakpoint"), s = bn("container"), l = bn("spacing"), c = bn("radius"), u = bn("shadow"), d = bn("inset-shadow"), m = bn("text-shadow"), h = bn("drop-shadow"), v = bn("blur"), g = bn("perspective"), x = bn("aspect"), b = bn("ease"), C = bn("animate"), I = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], R = () => [...T(), Pe, Ae], A = () => ["auto", "hidden", "clip", "visible", "scroll"], _ = () => ["auto", "contain", "none"], k = () => [Pe, Ae, l], M = () => [xi, "full", "auto", ...k()], j = () => [Co, "none", "subgrid", Pe, Ae], G = () => ["auto", {
    span: ["full", Co, Pe, Ae]
  }, Co, Pe, Ae], U = () => [Co, "auto", Pe, Ae], B = () => ["auto", "min", "max", "fr", Pe, Ae], K = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], ee = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], Y = () => ["auto", ...k()], J = () => [xi, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...k()], ye = () => [s, xi, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...k()], re = () => [xi, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...k()], le = () => [e, Pe, Ae], Te = () => [...T(), lb, sb, {
    position: [Pe, Ae]
  }], F = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], Z = () => ["auto", "cover", "contain", HM, BM, {
    size: [Pe, Ae]
  }], se = () => [gp, Dl, Sa], ae = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    c,
    Pe,
    Ae
  ], ue = () => ["", ct, Dl, Sa], te = () => ["solid", "dashed", "dotted", "double"], he = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], ge = () => [ct, gp, lb, sb], de = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    v,
    Pe,
    Ae
  ], xe = () => ["none", ct, Pe, Ae], ce = () => ["none", ct, Pe, Ae], je = () => [ct, Pe, Ae], z = () => [xi, "full", ...k()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Uo],
      breakpoint: [Uo],
      color: [x3],
      container: [Uo],
      "drop-shadow": [Uo],
      ease: ["in", "out", "in-out"],
      font: [zM],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Uo],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Uo],
      shadow: [Uo],
      spacing: ["px", ct],
      text: [Uo],
      "text-shadow": [Uo],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", xi, Ae, Pe, x]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */
      "container-type": [{
        "@container": ["", "normal", "size", Pe, Ae]
      }],
      /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */
      "container-named": [jM],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ct, "auto", Ae, Pe, s]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": I()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": I()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: R()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: A()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": A()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": A()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: _()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": _()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": _()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: M()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": M()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": M()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": M(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: M()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": M(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: M()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": M()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": M()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: M()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: M()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: M()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: M()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Co, "auto", Pe, Ae]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [xi, "full", "auto", s, ...k()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [ct, xi, "auto", "initial", "none", Ae]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", ct, Pe, Ae]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", ct, Pe, Ae]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Co, "first", "last", "none", Pe, Ae]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": j()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: G()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": U()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": U()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": j()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: G()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": U()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": U()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": B()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": B()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: k()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": k()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": k()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...K(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...ee(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...ee()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...K()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...ee(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...ee(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": K()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...ee(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...ee()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: k()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: k()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: k()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: k()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: k()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: k()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: k()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: k()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: k()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: k()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: k()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: Y()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: Y()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: Y()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: Y()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: Y()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: Y()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: Y()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: Y()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: Y()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: Y()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: Y()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": k()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": k()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: J()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/inline-size
       */
      "inline-size": [{
        inline: ["auto", ...ye()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-inline-size
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...ye()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-inline-size
       */
      "max-inline-size": [{
        "max-inline": ["none", ...ye()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/block-size
       */
      "block-size": [{
        block: ["auto", ...re()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-block-size
       */
      "min-block-size": [{
        "min-block": ["auto", ...re()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-block-size
       */
      "max-block-size": [{
        "max-block": ["none", ...re()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [s, "screen", ...J()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          s,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...J()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          s,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [a]
          },
          ...J()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...J()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...J()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", "none", ...J()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Dl, Sa]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, YM, GM]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", gp, Ae]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [WM, VM, t]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [Ae]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, Pe, Ae]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [ct, "none", Pe, ab]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          i,
          ...k()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Pe, Ae]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", Pe, Ae]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: le()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: le()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...te(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [ct, "from-font", "auto", Pe, Sa]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: le()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [ct, "auto", Pe, Ae]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */
      "tab-size": [{
        tab: [Co, Pe, Ae]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Pe, Ae]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Pe, Ae]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: Te()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: F()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: Z()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Co, Pe, Ae],
          radial: ["", Pe, Ae],
          conic: ["", Co, Pe, Ae]
        }, qM, UM]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: le()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: se()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: se()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: se()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: le()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: le()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: le()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: ae()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": ae()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": ae()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": ae()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": ae()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": ae()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": ae()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": ae()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": ae()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": ae()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": ae()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": ae()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": ae()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": ae()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": ae()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: ue()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": ue()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": ue()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": ue()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": ue()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": ue()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": ue()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": ue()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": ue()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": ue()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": ue()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": ue()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": ue()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...te(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...te(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: le()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": le()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": le()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": le()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": le()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": le()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": le()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": le()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": le()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": le()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": le()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: le()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...te(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ct, Pe, Ae]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", ct, Dl, Sa]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: le()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          // Deprecated since Tailwind CSS v4.0.0
          "inner",
          "none",
          u,
          $u,
          Lu
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: le()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", d, $u, Lu]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": le()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: ue()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: le()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [ct, Sa]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": le()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": ue()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": le()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", m, $u, Lu]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": le()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [ct, Pe, Ae]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...he(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": he()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [ct]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": ge()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": ge()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": le()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": le()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": ge()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": ge()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": le()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": le()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": ge()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": ge()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": le()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": le()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": ge()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": ge()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": le()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": le()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": ge()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": ge()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": le()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": le()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": ge()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": ge()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": le()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": le()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": ge()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": ge()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": le()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": le()
      }],
      "mask-image-radial": [{
        "mask-radial": [Pe, Ae]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": ge()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": ge()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": le()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": le()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": T()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [ct]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": ge()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": ge()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": le()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": le()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: Te()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: F()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: Z()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", Pe, Ae]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Pe,
          Ae
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: de()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [ct, Pe, Ae]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [ct, Pe, Ae]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          h,
          $u,
          Lu
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": le()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", ct, Pe, Ae]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [ct, Pe, Ae]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", ct, Pe, Ae]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [ct, Pe, Ae]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", ct, Pe, Ae]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Pe,
          Ae
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": de()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [ct, Pe, Ae]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [ct, Pe, Ae]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", ct, Pe, Ae]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [ct, Pe, Ae]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", ct, Pe, Ae]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [ct, Pe, Ae]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [ct, Pe, Ae]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", ct, Pe, Ae]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": k()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": k()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": k()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", Pe, Ae]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [ct, "initial", Pe, Ae]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", b, Pe, Ae]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [ct, Pe, Ae]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", C, Pe, Ae]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [g, Pe, Ae]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": R()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: xe()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": xe()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": xe()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": xe()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: ce()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": ce()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": ce()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": ce()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: je()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": je()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": je()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [Pe, Ae, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: R()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: z()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": z()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": z()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": z()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */
      zoom: [{
        zoom: [Co, Pe, Ae]
      }],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: le()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: le()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Pe, Ae]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-thumb-color": [{
        "scrollbar-thumb": le()
      }],
      /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-track-color": [{
        "scrollbar-track": le()
      }],
      /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */
      "scrollbar-gutter": [{
        "scrollbar-gutter": ["auto", "stable", "both"]
      }],
      /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */
      "scrollbar-w": [{
        scrollbar: ["auto", "thin", "none"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": k()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": k()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Pe, Ae]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...le()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ct, Dl, Sa, ab]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...le()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      "container-named": ["container-type"],
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["start", "end", "right", "left"],
      "inset-y": ["inset-bs", "inset-be", "top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["ps", "pe", "pr", "pl"],
      py: ["pbs", "pbe", "pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["ms", "me", "mr", "ml"],
      my: ["mbs", "mbe", "mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-s", "border-w-e", "border-w-r", "border-w-l"],
      "border-w-y": ["border-w-bs", "border-w-be", "border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-s", "border-color-e", "border-color-r", "border-color-l"],
      "border-color-y": ["border-color-bs", "border-color-be", "border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-ms", "scroll-me", "scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-ps", "scroll-pe", "scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    postfixLookupClassGroups: ["container-type"],
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, XM = /* @__PURE__ */ _M(ZM);
function oe(...e) {
  return XM(aM(e));
}
const Rve = (e) => {
  const t = ex();
  return Be(() => e.parse(t), [t, e]);
};
var zu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function JM(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ju = { exports: {} }, Pl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cb;
function QM() {
  if (cb) return Pl;
  cb = 1;
  var e = H, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, m = null, h = null;
    c !== void 0 && (m = "" + c), l.key !== void 0 && (m = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l) r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: m, ref: h, props: d, _owner: o.current };
  }
  return Pl.Fragment = n, Pl.jsx = a, Pl.jsxs = a, Pl;
}
var Nl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ub;
function e9() {
  return ub || (ub = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = H, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), v = Symbol.iterator, g = "@@iterator";
    function x($) {
      if ($ === null || typeof $ != "object")
        return null;
      var pe = v && $[v] || $[g];
      return typeof pe == "function" ? pe : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C($) {
      {
        for (var pe = arguments.length, _e = new Array(pe > 1 ? pe - 1 : 0), nt = 1; nt < pe; nt++)
          _e[nt - 1] = arguments[nt];
        I("error", $, _e);
      }
    }
    function I($, pe, _e) {
      {
        var nt = b.ReactDebugCurrentFrame, Tt = nt.getStackAddendum();
        Tt !== "" && (pe += "%s", _e = _e.concat([Tt]));
        var Mt = _e.map(function(St) {
          return String(St);
        });
        Mt.unshift("Warning: " + pe), Function.prototype.apply.call(console[$], console, Mt);
      }
    }
    var T = !1, R = !1, A = !1, _ = !1, k = !1, M;
    M = Symbol.for("react.module.reference");
    function j($) {
      return !!(typeof $ == "string" || typeof $ == "function" || $ === r || $ === i || k || $ === o || $ === c || $ === u || _ || $ === h || T || R || A || typeof $ == "object" && $ !== null && ($.$$typeof === m || $.$$typeof === d || $.$$typeof === a || $.$$typeof === s || $.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      $.$$typeof === M || $.getModuleId !== void 0));
    }
    function G($, pe, _e) {
      var nt = $.displayName;
      if (nt)
        return nt;
      var Tt = pe.displayName || pe.name || "";
      return Tt !== "" ? _e + "(" + Tt + ")" : _e;
    }
    function U($) {
      return $.displayName || "Context";
    }
    function B($) {
      if ($ == null)
        return null;
      if (typeof $.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof $ == "function")
        return $.displayName || $.name || null;
      if (typeof $ == "string")
        return $;
      switch ($) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof $ == "object")
        switch ($.$$typeof) {
          case s:
            var pe = $;
            return U(pe) + ".Consumer";
          case a:
            var _e = $;
            return U(_e._context) + ".Provider";
          case l:
            return G($, $.render, "ForwardRef");
          case d:
            var nt = $.displayName || null;
            return nt !== null ? nt : B($.type) || "Memo";
          case m: {
            var Tt = $, Mt = Tt._payload, St = Tt._init;
            try {
              return B(St(Mt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ee = 0, Y, J, ye, re, le, Te, F;
    function Z() {
    }
    Z.__reactDisabledLog = !0;
    function se() {
      {
        if (ee === 0) {
          Y = console.log, J = console.info, ye = console.warn, re = console.error, le = console.group, Te = console.groupCollapsed, F = console.groupEnd;
          var $ = {
            configurable: !0,
            enumerable: !0,
            value: Z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: $,
            log: $,
            warn: $,
            error: $,
            group: $,
            groupCollapsed: $,
            groupEnd: $
          });
        }
        ee++;
      }
    }
    function ae() {
      {
        if (ee--, ee === 0) {
          var $ = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, $, {
              value: Y
            }),
            info: K({}, $, {
              value: J
            }),
            warn: K({}, $, {
              value: ye
            }),
            error: K({}, $, {
              value: re
            }),
            group: K({}, $, {
              value: le
            }),
            groupCollapsed: K({}, $, {
              value: Te
            }),
            groupEnd: K({}, $, {
              value: F
            })
          });
        }
        ee < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ue = b.ReactCurrentDispatcher, te;
    function he($, pe, _e) {
      {
        if (te === void 0)
          try {
            throw Error();
          } catch (Tt) {
            var nt = Tt.stack.trim().match(/\n( *(at )?)/);
            te = nt && nt[1] || "";
          }
        return `
` + te + $;
      }
    }
    var ge = !1, de;
    {
      var xe = typeof WeakMap == "function" ? WeakMap : Map;
      de = new xe();
    }
    function ce($, pe) {
      if (!$ || ge)
        return "";
      {
        var _e = de.get($);
        if (_e !== void 0)
          return _e;
      }
      var nt;
      ge = !0;
      var Tt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Mt;
      Mt = ue.current, ue.current = null, se();
      try {
        if (pe) {
          var St = function() {
            throw Error();
          };
          if (Object.defineProperty(St.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(St, []);
            } catch (ir) {
              nt = ir;
            }
            Reflect.construct($, [], St);
          } else {
            try {
              St.call();
            } catch (ir) {
              nt = ir;
            }
            $.call(St.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ir) {
            nt = ir;
          }
          $();
        }
      } catch (ir) {
        if (ir && nt && typeof ir.stack == "string") {
          for (var ft = ir.stack.split(`
`), Zn = nt.stack.split(`
`), sn = ft.length - 1, fn = Zn.length - 1; sn >= 1 && fn >= 0 && ft[sn] !== Zn[fn]; )
            fn--;
          for (; sn >= 1 && fn >= 0; sn--, fn--)
            if (ft[sn] !== Zn[fn]) {
              if (sn !== 1 || fn !== 1)
                do
                  if (sn--, fn--, fn < 0 || ft[sn] !== Zn[fn]) {
                    var Fr = `
` + ft[sn].replace(" at new ", " at ");
                    return $.displayName && Fr.includes("<anonymous>") && (Fr = Fr.replace("<anonymous>", $.displayName)), typeof $ == "function" && de.set($, Fr), Fr;
                  }
                while (sn >= 1 && fn >= 0);
              break;
            }
        }
      } finally {
        ge = !1, ue.current = Mt, ae(), Error.prepareStackTrace = Tt;
      }
      var ds = $ ? $.displayName || $.name : "", ba = ds ? he(ds) : "";
      return typeof $ == "function" && de.set($, ba), ba;
    }
    function je($, pe, _e) {
      return ce($, !1);
    }
    function z($) {
      var pe = $.prototype;
      return !!(pe && pe.isReactComponent);
    }
    function Ue($, pe, _e) {
      if ($ == null)
        return "";
      if (typeof $ == "function")
        return ce($, z($));
      if (typeof $ == "string")
        return he($);
      switch ($) {
        case c:
          return he("Suspense");
        case u:
          return he("SuspenseList");
      }
      if (typeof $ == "object")
        switch ($.$$typeof) {
          case l:
            return je($.render);
          case d:
            return Ue($.type, pe, _e);
          case m: {
            var nt = $, Tt = nt._payload, Mt = nt._init;
            try {
              return Ue(Mt(Tt), pe, _e);
            } catch {
            }
          }
        }
      return "";
    }
    var st = Object.prototype.hasOwnProperty, Rt = {}, dn = b.ReactDebugCurrentFrame;
    function _t($) {
      if ($) {
        var pe = $._owner, _e = Ue($.type, $._source, pe ? pe.type : null);
        dn.setExtraStackFrame(_e);
      } else
        dn.setExtraStackFrame(null);
    }
    function L($, pe, _e, nt, Tt) {
      {
        var Mt = Function.call.bind(st);
        for (var St in $)
          if (Mt($, St)) {
            var ft = void 0;
            try {
              if (typeof $[St] != "function") {
                var Zn = Error((nt || "React class") + ": " + _e + " type `" + St + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof $[St] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Zn.name = "Invariant Violation", Zn;
              }
              ft = $[St](pe, St, nt, _e, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (sn) {
              ft = sn;
            }
            ft && !(ft instanceof Error) && (_t(Tt), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", nt || "React class", _e, St, typeof ft), _t(null)), ft instanceof Error && !(ft.message in Rt) && (Rt[ft.message] = !0, _t(Tt), C("Failed %s type: %s", _e, ft.message), _t(null));
          }
      }
    }
    var q = Array.isArray;
    function Q($) {
      return q($);
    }
    function Se($) {
      {
        var pe = typeof Symbol == "function" && Symbol.toStringTag, _e = pe && $[Symbol.toStringTag] || $.constructor.name || "Object";
        return _e;
      }
    }
    function ve($) {
      try {
        return me($), !1;
      } catch {
        return !0;
      }
    }
    function me($) {
      return "" + $;
    }
    function Ne($) {
      if (ve($))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Se($)), me($);
    }
    var et = b.ReactCurrentOwner, ot = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ot, nn;
    function Nt($) {
      if (st.call($, "ref")) {
        var pe = Object.getOwnPropertyDescriptor($, "ref").get;
        if (pe && pe.isReactWarning)
          return !1;
      }
      return $.ref !== void 0;
    }
    function wn($) {
      if (st.call($, "key")) {
        var pe = Object.getOwnPropertyDescriptor($, "key").get;
        if (pe && pe.isReactWarning)
          return !1;
      }
      return $.key !== void 0;
    }
    function kn($, pe) {
      typeof $.ref == "string" && et.current;
    }
    function hr($, pe) {
      {
        var _e = function() {
          Ot || (Ot = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pe));
        };
        _e.isReactWarning = !0, Object.defineProperty($, "key", {
          get: _e,
          configurable: !0
        });
      }
    }
    function gr($, pe) {
      {
        var _e = function() {
          nn || (nn = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pe));
        };
        _e.isReactWarning = !0, Object.defineProperty($, "ref", {
          get: _e,
          configurable: !0
        });
      }
    }
    var vr = function($, pe, _e, nt, Tt, Mt, St) {
      var ft = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: $,
        key: pe,
        ref: _e,
        props: St,
        // Record the component responsible for creating this element.
        _owner: Mt
      };
      return ft._store = {}, Object.defineProperty(ft._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ft, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: nt
      }), Object.defineProperty(ft, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Tt
      }), Object.freeze && (Object.freeze(ft.props), Object.freeze(ft)), ft;
    };
    function Mr($, pe, _e, nt, Tt) {
      {
        var Mt, St = {}, ft = null, Zn = null;
        _e !== void 0 && (Ne(_e), ft = "" + _e), wn(pe) && (Ne(pe.key), ft = "" + pe.key), Nt(pe) && (Zn = pe.ref, kn(pe, Tt));
        for (Mt in pe)
          st.call(pe, Mt) && !ot.hasOwnProperty(Mt) && (St[Mt] = pe[Mt]);
        if ($ && $.defaultProps) {
          var sn = $.defaultProps;
          for (Mt in sn)
            St[Mt] === void 0 && (St[Mt] = sn[Mt]);
        }
        if (ft || Zn) {
          var fn = typeof $ == "function" ? $.displayName || $.name || "Unknown" : $;
          ft && hr(St, fn), Zn && gr(St, fn);
        }
        return vr($, ft, Zn, Tt, nt, et.current, St);
      }
    }
    var Kn = b.ReactCurrentOwner, qe = b.ReactDebugCurrentFrame;
    function Ce($) {
      if ($) {
        var pe = $._owner, _e = Ue($.type, $._source, pe ? pe.type : null);
        qe.setExtraStackFrame(_e);
      } else
        qe.setExtraStackFrame(null);
    }
    var De;
    De = !1;
    function fe($) {
      return typeof $ == "object" && $ !== null && $.$$typeof === t;
    }
    function Ie() {
      {
        if (Kn.current) {
          var $ = B(Kn.current.type);
          if ($)
            return `

Check the render method of \`` + $ + "`.";
        }
        return "";
      }
    }
    function tt($) {
      return "";
    }
    var Me = {};
    function kt($) {
      {
        var pe = Ie();
        if (!pe) {
          var _e = typeof $ == "string" ? $ : $.displayName || $.name;
          _e && (pe = `

Check the top-level render call using <` + _e + ">.");
        }
        return pe;
      }
    }
    function Et($, pe) {
      {
        if (!$._store || $._store.validated || $.key != null)
          return;
        $._store.validated = !0;
        var _e = kt(pe);
        if (Me[_e])
          return;
        Me[_e] = !0;
        var nt = "";
        $ && $._owner && $._owner !== Kn.current && (nt = " It was passed a child from " + B($._owner.type) + "."), Ce($), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', _e, nt), Ce(null);
      }
    }
    function Yt($, pe) {
      {
        if (typeof $ != "object")
          return;
        if (Q($))
          for (var _e = 0; _e < $.length; _e++) {
            var nt = $[_e];
            fe(nt) && Et(nt, pe);
          }
        else if (fe($))
          $._store && ($._store.validated = !0);
        else if ($) {
          var Tt = x($);
          if (typeof Tt == "function" && Tt !== $.entries)
            for (var Mt = Tt.call($), St; !(St = Mt.next()).done; )
              fe(St.value) && Et(St.value, pe);
        }
      }
    }
    function an($) {
      {
        var pe = $.type;
        if (pe == null || typeof pe == "string")
          return;
        var _e;
        if (typeof pe == "function")
          _e = pe.propTypes;
        else if (typeof pe == "object" && (pe.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        pe.$$typeof === d))
          _e = pe.propTypes;
        else
          return;
        if (_e) {
          var nt = B(pe);
          L(_e, $.props, "prop", nt, $);
        } else if (pe.PropTypes !== void 0 && !De) {
          De = !0;
          var Tt = B(pe);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Tt || "Unknown");
        }
        typeof pe.getDefaultProps == "function" && !pe.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function bt($) {
      {
        for (var pe = Object.keys($.props), _e = 0; _e < pe.length; _e++) {
          var nt = pe[_e];
          if (nt !== "children" && nt !== "key") {
            Ce($), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", nt), Ce(null);
            break;
          }
        }
        $.ref !== null && (Ce($), C("Invalid attribute `ref` supplied to `React.Fragment`."), Ce(null));
      }
    }
    var Ln = {};
    function $n($, pe, _e, nt, Tt, Mt) {
      {
        var St = j($);
        if (!St) {
          var ft = "";
          ($ === void 0 || typeof $ == "object" && $ !== null && Object.keys($).length === 0) && (ft += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Zn = tt();
          Zn ? ft += Zn : ft += Ie();
          var sn;
          $ === null ? sn = "null" : Q($) ? sn = "array" : $ !== void 0 && $.$$typeof === t ? (sn = "<" + (B($.type) || "Unknown") + " />", ft = " Did you accidentally export a JSX literal instead of a component?") : sn = typeof $, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", sn, ft);
        }
        var fn = Mr($, pe, _e, Tt, Mt);
        if (fn == null)
          return fn;
        if (St) {
          var Fr = pe.children;
          if (Fr !== void 0)
            if (nt)
              if (Q(Fr)) {
                for (var ds = 0; ds < Fr.length; ds++)
                  Yt(Fr[ds], $);
                Object.freeze && Object.freeze(Fr);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Yt(Fr, $);
        }
        if (st.call(pe, "key")) {
          var ba = B($), ir = Object.keys(pe).filter(function(uk) {
            return uk !== "key";
          }), sp = ir.length > 0 ? "{key: someKey, " + ir.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ln[ba + sp]) {
            var ck = ir.length > 0 ? "{" + ir.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, sp, ba, ck, ba), Ln[ba + sp] = !0;
          }
        }
        return $ === r ? bt(fn) : an(fn), fn;
      }
    }
    function Zr($, pe, _e) {
      return $n($, pe, _e, !0);
    }
    function va($, pe, _e) {
      return $n($, pe, _e, !1);
    }
    var ya = va, xo = Zr;
    Nl.Fragment = r, Nl.jsx = ya, Nl.jsxs = xo;
  })()), Nl;
}
var db;
function t9() {
  return db || (db = 1, process.env.NODE_ENV === "production" ? ju.exports = QM() : ju.exports = e9()), ju.exports;
}
var f = t9();
function n9({ message: e }) {
  return /* @__PURE__ */ f.jsx("div", { className: "pointer-events-none", children: /* @__PURE__ */ f.jsx("div", { className: "ring-opacity-5 pointer-events-auto overflow-hidden rounded-lg bg-black shadow-lg ring-1 ring-black", children: /* @__PURE__ */ f.jsx("div", { className: "flex items-center justify-between px-6 py-4", children: /* @__PURE__ */ f.jsx("p", { className: "text-sm font-medium text-white", children: e }) }) }) });
}
const r9 = () => ({
  show: (r, o) => up.custom(/* @__PURE__ */ f.jsx(n9, { message: r }), {
    id: o,
    duration: 3e3,
    position: "bottom-center"
  }),
  remove: (r) => up.remove(r),
  dismiss: (r) => up.dismiss(r)
}), o9 = {
  base: "h-8",
  lg: "h-16",
  xl: "h-24"
};
function O3({
  size: e = "base"
}) {
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      className: o9[e],
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      viewBox: "0 0 200 234.59",
      fill: "currentColor",
      children: /* @__PURE__ */ f.jsxs("g", { children: [
        /* @__PURE__ */ f.jsx("path", { d: "M0,117.3c0,58.36,42.95,106.67,98.96,115.09v-62.37c-22.13-7.31-38.12-28.13-38.12-52.72s15.99-45.4,38.12-52.72V2.21 C42.95,10.62,0,58.94,0,117.3z" }),
        /* @__PURE__ */ f.jsx("path", { d: "M161.04,76.44c17.83,0,32.29-14.46,32.29-32.29c0-17.83-14.46-32.29-32.29-32.29s-32.29,14.46-32.29,32.29 C128.75,61.98,143.2,76.44,161.04,76.44z" }),
        /* @__PURE__ */ f.jsx("circle", { cx: "161.04", cy: "190.45", r: "32.29" })
      ] })
    }
  );
}
const i9 = {
  base: "w-24",
  lg: "w-64",
  sm: "w-16"
};
function Tve({
  size: e = "base"
}) {
  return /* @__PURE__ */ f.jsx(
    "svg",
    {
      className: i9[e],
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      x: "0px",
      y: "0px",
      fill: "currentColor",
      viewBox: "0 0 1080 234.59",
      children: /* @__PURE__ */ f.jsxs("g", { children: [
        /* @__PURE__ */ f.jsx("path", { d: "M356.55,160.79c14.58,0,25.51-4.62,37.17-12.63v47.38c-14.58,7.78-28.67,10.21-40.09,10.21 c-51.02,0-87.96-37.42-87.96-88.44c0-49.57,37.9-88.44,88.2-88.44c13.12,0,26.97,3.4,39.6,10.45v47.62 c-10.69-8.26-22.11-13.12-36.93-13.12c-26.48,0-43.73,19.19-43.73,43.49C312.82,141.35,330.07,160.79,356.55,160.79z M588.76,117.3 c0,49.32-40.33,88.44-90.14,88.44c-49.81,0-90.14-39.12-90.14-88.44s40.33-88.44,90.14-88.44 C548.43,28.85,588.76,67.97,588.76,117.3z M541.87,117.3c0-24.54-18.95-43.98-43.25-43.98c-24.3,0-43.25,19.44-43.25,43.98 s18.95,43.98,43.25,43.98C522.92,161.27,541.87,141.83,541.87,117.3z M701.07,139.16l43.49,63.17h-53.45l-35.72-56.12h-5.35v56.12 h-45.43V32.26h60.74c39.6,0,66.82,20.65,66.82,57.58C732.17,113.41,719.54,129.93,701.07,139.16z M686.25,91.05 c0-11.42-8.5-18.22-20.17-18.22h-16.04v36.44h16.04C677.75,109.28,686.25,102.47,686.25,91.05z M802.45,82.07 c0-9.47,11.91-11.42,19.92-11.42c18.47,0,40.09,8.26,55.15,18.47V42.71c-17.25-9.48-36.45-13.85-56.13-13.85 c-35.23,0-66.33,18.22-66.33,56.13c0,63.66,82.37,42.76,82.37,66.09c0,10.93-13.85,12.63-21.14,12.63 c-19.92,0-43.01-8.75-58.8-20.41v48.35c17.49,9.48,40.09,14.09,60.01,14.09c34.74,0,68.03-18.22,68.03-57.58 C885.55,87.41,802.45,104.66,802.45,82.07z M1080,117.3c0,49.32-40.33,88.44-90.14,88.44c-49.81,0-90.14-39.12-90.14-88.44 s40.33-88.44,90.14-88.44C1039.67,28.85,1080,67.97,1080,117.3z M1033.11,117.3c0-24.54-18.95-43.98-43.25-43.98 c-24.3,0-43.25,19.44-43.25,43.98s18.95,43.98,43.25,43.98C1014.16,161.27,1033.11,141.83,1033.11,117.3z" }),
        /* @__PURE__ */ f.jsxs("g", { children: [
          /* @__PURE__ */ f.jsx("path", { d: "M0,117.3c0,58.36,42.95,106.67,98.96,115.09v-62.37c-22.13-7.31-38.12-28.13-38.12-52.72s15.99-45.4,38.12-52.72V2.21 C42.95,10.62,0,58.94,0,117.3z" }),
          /* @__PURE__ */ f.jsx("path", { d: "M161.04,76.44c17.83,0,32.29-14.46,32.29-32.29c0-17.83-14.46-32.29-32.29-32.29s-32.29,14.46-32.29,32.29 C128.75,61.98,143.2,76.44,161.04,76.44z" }),
          /* @__PURE__ */ f.jsx("circle", { cx: "161.04", cy: "190.45", r: "32.29" })
        ] })
      ] })
    }
  );
}
/*!
 * Font Awesome Free 7.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2026 Fonticons, Inc.
 */
var a9 = {
  prefix: "fab",
  iconName: "ups",
  icon: [384, 512, [], "f7e0", "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19l0-104-32.7 0 0 102.6c0 74.9 80.2 51.1 97.9 39l0-141.6-32.6 0 0 123zM4 74.8L4 295.7c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1l0-220.9C263.1 13.2 97.6 25.2 4 74.8zM362.1 295.7c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3l0-126.4c102.3-93.8 231.6-100 340.9-89.8l0 216.2zM152.5 188.3l0 212.8 32.7 0 0-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.9-104.4-65.6zm32.7 117.3l0-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4 .6 23.5-30.4 23-50.8 4.9l0 30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2 .6-20.3 30.6-20.5 48.5-2.2l0-28.4c-28.5-22-79.9-9.2-79.7 31.9z"]
}, s9 = {
  prefix: "fab",
  iconName: "fedex",
  icon: [640, 512, [], "f797", "M586 284.5l53.3-59.9-62.4 0-21.7 24.8-22.5-24.8-118.7 0 0-16 56.1 0 0-48.1-151.2 0 0 75.5-.5 0c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14l0-24.2-54.8 0 0-26.2 60 0 0-41.1-109 0 0 184.4 49 0 0-77.5 48.9 0c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7l-42 0c-14.7 20.9-45.8 8.9-45.8-14.6l85.5 0c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6l.5 0 0 11.9 212.2 0 22.1-25 22.3 25 64.4 0-54-60.5zM139.3 267.9c6.1-26.3 41.7-25.6 46.5 0l-46.5 0zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1l-94.4 0 0-166.5 95 0 0 30.2-56.1 0 0 33.9 55.5 0 0 28.1-56.1 0 0 44.7 56.1 0 0 29.6zm-45.9-39.8l0-24.4 56.1 0 0-44 50.7 57-50.7 57 0-45.6-56.1 0zm138.6 10.3l-26.1 29.5-38.1 0 45.6-51.2-45.6-51.2 39.7 0 26.6 29.3 25.6-29.3 38.5 0-45.4 51 46 51.4-40.5 0-26.3-29.5z"]
}, l9 = {
  prefix: "fab",
  iconName: "dhl",
  icon: [640, 512, [], "f790", "M238 301.2l58.7 0 22.3-30.2-58.7 0-22.3 30.2zM0 282.9l0 6.4 81.8 0 4.7-6.4-86.5 0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1s2.8-5.9-2.8-5.9l-51 0-41.1 55.8 100.1 0c33.1 0 51.5-22.5 57.2-30.3l-68.2 0zm317.5-6.9l39.3-53.4-62.2 0-39.3 53.4 62.2 0zM95.3 271l-95.3 0 0 6.4 90.6 0 4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5l45.6 0s7.3-10 13.5-18.4c8.4-11.4 .7-35-29.2-35l-117.9 0-20.4 27.8 111.4 0c5.6 0 5.5 2.2 2.7 5.9zM0 301.2l73.1 0 4.7-6.4-77.8 0 0 6.4zm323 0l58.7 0 22.3-30.2-58.7 0c-.1 0-22.3 30.2-22.3 30.2zm222 .1l95 0 0-6.4-90.3 0-4.7 6.4zM567.3 271l-4.7 6.4 77.4 0 0-6.4-72.7 0zm-13.5 18.3l86.2 0 0-6.4-81.5 0-4.7 6.4zM389.6 210.7l-22.5 30.6-26.2 0 22.5-30.6-58.7 0-39.3 53.4 143.6 0 39.3-53.4-58.7 0zM423.1 271s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6l94.3 0 22.3-30.3-133.4 0z"]
}, c9 = {
  prefix: "fab",
  iconName: "shopify",
  icon: [448, 512, [], "e057", "M388.5 104.1c-.2-1.1-.7-2.1-1.5-2.8s-1.8-1.2-2.9-1.2c-2 0-37.2-.8-37.2-.8s-21.6-20.8-29.6-28.8l0 432.7 125.7-31.2s-54-365.5-54.4-367.9zM288.9 70.5c-1.9-6.1-4.3-11.9-7.2-17.6-10.4-20-26-30.9-44.4-30.9-1.3 0-2.7 .1-4 .4-.4-.8-1.2-1.2-1.6-2-8-8.8-18.4-12.8-30.8-12.4-24 .8-48 18-67.2 48.8-13.6 21.6-24 48.8-26.8 70.1-27.6 8.4-46.8 14.4-47.2 14.8-14 4.4-14.4 4.8-16 18-1.2 10-38 291.8-38 291.8l302.6 52.5 0-438.3c-1.5 .1-2.9 .2-4.4 .4 0 0-5.6 1.6-14.8 4.4zM233.6 87.7c-16 4.8-33.6 10.4-50.8 15.6 4.8-18.8 14.4-37.6 25.6-50 4.4-4.4 10.4-9.6 17.2-12.8 6.8 14.4 8.4 34 8 47.2zM200.8 24.4c5-.2 10 1.1 14.4 3.6-6.4 3.2-12.8 8.4-18.8 14.4-15.2 16.4-26.8 42-31.6 66.5-14.4 4.4-28.8 8.8-42 12.8 8.8-38.4 41.2-96.4 78-97.2zM154.4 244.6c1.6 25.6 69.2 31.2 73.2 91.7 2.8 47.6-25.2 80.1-65.6 82.5-48.8 3.2-75.6-25.6-75.6-25.6l10.4-44s26.8 20.4 48.4 18.8c14-.8 19.2-12.4 18.8-20.4-2-33.6-57.2-31.6-60.8-86.9-3.2-46.4 27.2-93.3 94.5-97.7 26-1.6 39.2 4.8 39.2 4.8l-15.2 57.6s-17.2-8-37.6-6.4c-29.6 2-30 20.8-29.6 25.6zM249.6 82.9c0-12-1.6-29.2-7.2-43.6 18.4 3.6 27.2 24 31.2 36.4-7.2 2-15.2 4.4-24 7.2z"]
}, u9 = {
  prefix: "fab",
  iconName: "canadian-maple-leaf",
  icon: [512, 512, [], "f785", "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5-5.1-7.5-42.7-79.8-42.7-79.8s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3s-12.5 27.3-15 32.3-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167S43 226.7 45.5 234.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512l30 0s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"]
}, d9 = {
  prefix: "fab",
  iconName: "usps",
  icon: [512, 512, [], "f7e1", "M428.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8l-27 0c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8 .1zM316.2 264.3c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3 196.6 0c-2.7-28.2-152.9-22.6-337.9-22.6L-5 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM62.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2L449.3 415.7 517 96 62.7 96z"]
};
/*!
 * Font Awesome Pro 7.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2026 Fonticons, Inc.
 */
var A3 = {
  prefix: "fad",
  iconName: "spinner-third",
  icon: [512, 512, [], "f3f4", ["M0 256c0 141.4 114.6 256 256 256 107.8 0 200-66.6 237.8-160.9-6.6 16.4-25.2 24.4-41.6 17.8s-24.4-25.2-17.8-41.7C406.1 398 336.9 448 256 448 150 448 64 362 64 256S150 64 256 64c9.3 0 18.5 .7 27.5 1.9-17.5-2.5-29.6-18.7-27.1-36.2 2.5-17.2 18.2-29.3 35.4-27.3-11.7-1.6-23.6-2.5-35.8-2.5-141.4 0-256 114.6-256 256z", "M256.3 29.7c2.5-17.5 18.7-29.6 36.2-27.1 124.1 17.8 219.5 124.4 219.5 253.4 0 33.5-6.5 65.6-18.2 95.1-6.6 16.4-25.2 24.4-41.6 17.8s-24.4-25.2-17.8-41.6c8.8-22 13.7-46 13.7-71.3 0-96.7-71.5-176.7-164.5-190.1-17.5-2.5-29.6-18.7-27.1-36.2z"]]
};
/*!
 * Font Awesome Pro 7.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2026 Fonticons, Inc.
 */
var f9 = {
  prefix: "fal",
  iconName: "dollar-sign",
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M144 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L113.9 96C77.5 96 48 125.5 48 161.9 48 194.4 71.6 222 103.7 227l113.8 17.8c49.8 7.8 86.4 50.6 86.4 101 0 56.5-45.8 102.2-102.2 102.2l-25.8 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l153.8 0c38.8 0 70.2-31.4 70.2-70.2 0-34.6-25.2-64-59.4-69.4L98.8 258.6C51.1 251.2 16 210.1 16 161.9 16 107.8 59.8 64 113.9 64l30.1 0 0-48z"]
}, m9 = {
  prefix: "fal",
  iconName: "file-arrow-down",
  icon: [384, 512, ["file-download"], "f56d", "M64 32l128 0 0 96c0 35.3 28.7 64 64 64l96 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM224 45.3L338.7 160 256 160c-17.7 0-32-14.3-32-32l0-82.7zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-261.5c0-17-6.7-33.3-18.7-45.3L242.7 18.7C230.7 6.7 214.5 0 197.5 0L64 0zm44.7 355.3l72 72c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 377.4 208 256c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"]
}, p9 = m9, h9 = {
  prefix: "fal",
  iconName: "calculator",
  icon: [384, 512, [128425], "f1ec", "M352 160l0 288c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-288 320 0zm0-32l-320 0 0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64zm32 0l0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320zM72 224a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM264 416c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zM80 400c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 400z"]
}, g9 = {
  prefix: "fal",
  iconName: "minus",
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M0 256c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 272c-8.8 0-16-7.2-16-16z"]
}, v9 = {
  prefix: "fal",
  iconName: "envelope",
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M0 122.5l0-2.5 .1 0C1.3 88.9 27 64 58.5 64l395 0c31.5 0 57.1 24.9 58.4 56l.1 0 0 264c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 122.5zm480 53.1L303.3 305.1c-28.2 20.6-66.5 20.6-94.6 0L32 175.6 32 384c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-208.4zm0-53.1c0-14.6-11.9-26.5-26.5-26.5l-395 0c-14.6 0-26.5 11.9-26.5 26.5 0 8.4 4 16.4 10.8 21.4L227.6 279.3c16.9 12.4 39.9 12.4 56.8 0L469.2 143.8c6.8-5 10.8-12.9 10.8-21.4z"]
}, y9 = {
  prefix: "fal",
  iconName: "cloud-arrow-up",
  icon: [576, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M128 176c0-61.9 50.1-112 112-112 39.3 0 73.8 20.2 93.8 50.8 4.4 6.7 13.1 9.1 20.3 5.7 11.4-5.5 24.3-8.5 37.9-8.5 48.6 0 88 39.4 88 88 0 14.1-3.3 27.4-9.2 39.2-2 4.1-2.2 8.9-.5 13.1s5.2 7.6 9.5 9.1c37.4 13.1 64.2 48.8 64.2 90.6 0 53-43 96-96 96l-304 0c-61.9 0-112-50.1-112-112 0-53.7 37.8-98.6 88.2-109.5 4.3-.9 8.1-3.6 10.3-7.4s2.9-8.3 1.7-12.6c-2.7-9.7-4.2-19.9-4.2-30.5zM240 32c-79.5 0-144 64.5-144 144 0 8 .7 15.9 1.9 23.5-56.9 19.2-97.9 73-97.9 136.5 0 79.5 64.5 144 144 144l304 0c70.7 0 128-57.3 128-128 0-49.9-28.5-93-70.1-114.2 3.9-11.9 6.1-24.6 6.1-37.8 0-66.3-53.7-120-120-120-13.7 0-26.9 2.3-39.2 6.5-26.4-33.2-67.1-54.5-112.8-54.5zm59.3 164.7c-6.2-6.2-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 246.6 272 368c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 44.7 44.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72-72z"]
}, b9 = {
  prefix: "fal",
  iconName: "at",
  icon: [512, 512, [61946], "40", "M256 32C132.3 32 32 132.3 32 256S132.3 480 256 480c8.8 0 16 7.2 16 16s-7.2 16-16 16C114.6 512 0 397.4 0 256S114.6 0 256 0 512 114.6 512 256l0 24c0 48.6-39.4 88-88 88-33.4 0-62.5-18.7-77.4-46.1-20.4 28-53.4 46.1-90.6 46.1-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6l0-1.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 104c0 30.9 25.1 56 56 56s56-25.1 56-56l0-24C480 132.3 379.7 32 256 32zm80 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
}, S9 = {
  prefix: "fal",
  iconName: "truck",
  icon: [576, 512, [128666, 9951], "f0d1", "M64 64C46.3 64 32 78.3 32 96l0 288c0 17.7 14.3 32 32 32l.4 0c4-44.9 41.7-80 87.6-80s83.6 35.1 87.6 80l96.7 0c2.8-30.8 21.4-57 47.6-70.4L384 96c0-17.7-14.3-32-32-32L64 64zM416 288l0 48.4c2.6-.2 5.3-.4 8-.4 45.9 0 83.6 35.1 87.6 80l.4 0c17.7 0 32-14.3 32-32l0-96-128 0zm128-32l0-28.1c0-8.5-3.4-16.6-9.4-22.6l-35.9-35.9c-6-6-14.1-9.4-22.6-9.4l-60.1 0 0 96 128 0zM67.3 448L64 448c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l288 0c35.3 0 64 28.7 64 64l0 32 60.1 0c17 0 33.3 6.7 45.3 18.7l35.9 35.9c12 12 18.7 28.3 18.7 45.3L576 384c0 35.3-28.7 64-64 64l-3.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-102.6 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64zM152 480a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm272 0a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
}, x9 = {
  prefix: "fal",
  iconName: "bell",
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-8.8 0-16 7.2-16 16l0 16.8C127.1 40.8 64 109 64 192l0 10.3c0 45.1-15.4 88.9-43.5 124.1L10.4 339C3.7 347.4 0 357.9 0 368.6 0 394.8 21.2 416 47.4 416l353.2 0c26.2 0 47.4-21.2 47.4-47.4 0-10.8-3.7-21.2-10.4-29.6l-10.1-12.6c-28.2-35.2-43.5-79-43.5-124.1l0-10.3c0-83-63.1-151.2-144-159.2L240 16c0-8.8-7.2-16-16-16zm0 64c70.7 0 128 57.3 128 128l0 10.3c0 52.4 17.8 103.2 50.6 144.1L412.6 359c2.2 2.7 3.4 6.1 3.4 9.6 0 8.5-6.9 15.4-15.4 15.4L47.4 384c-8.5 0-15.4-6.9-15.4-15.4 0-3.5 1.2-6.9 3.4-9.6l10.1-12.6C78.2 305.5 96 254.7 96 202.3L96 192c0-70.7 57.3-128 128-128zM156.1 464c9.9 28 36.6 48 67.9 48s58-20 67.9-48L256 464c-7.3 9.7-18.9 16-32 16s-24.7-6.3-32-16l-35.9 0z"]
}, C9 = {
  prefix: "fal",
  iconName: "message",
  icon: [512, 512, ["comment-alt"], "f27a", "M179.2 533.6s0 0 0 0l-6.4 4.8c-4.8 3.6-10.7 5.6-16.8 5.6-15.5 0-28-12.5-28-28l0-68-32 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l320 0c53 0 96 43 96 96l0 224c0 53-43 96-96 96l-120 0c-1.7 0-3.4 .6-4.8 1.6l-112 84zM160 468l0 40 112-84c6.9-5.2 15.3-8 24-8l120 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L96 64c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l40 0c13.3 0 24 10.7 24 24l0 28z"]
}, w9 = {
  prefix: "fal",
  iconName: "warehouse",
  icon: [576, 512, [], "f494", "M544 192l-512 0 0 304c0 8.8-7.2 16-16 16S0 504.8 0 496L0 155.8c0-26.4 16.2-50.1 40.8-59.6L270.6 6.8c11.2-4.4 23.6-4.4 34.8 0L535.2 96.1c24.6 9.6 40.8 33.3 40.8 59.6L576 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-304zm0-32l0-4.2c0-13.2-8.1-25-20.4-29.8L293.8 36.6c-3.7-1.5-7.9-1.5-11.6 0L52.4 126C40.1 130.7 32 142.6 32 155.8l0 4.2 512 0zM112 256l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 368c0-8.8 7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16zm16 80l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, E9 = {
  prefix: "fal",
  iconName: "gift",
  icon: [512, 512, [127873], "f06b", "M308.5 58.7L273.9 128 352 128c26.5 0 48-21.5 48-48 0-26.5-21.6-48-48.2-48-18.3 0-35.1 10.4-43.3 26.7zM160 160L48 160c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-304 0zM48 128l48 0c-10-13.4-16-30-16-48 0-44.2 36-80 80.2-80 30.4 0 58.3 17.2 71.9 44.4L256 92.2 279.9 44.4c13.6-27.2 41.5-44.4 71.9-44.4 44.1 0 80.2 35.8 80.2 80 0 18-6 34.6-16 48l48 0c26.5 0 48 21.5 48 48l0 32c0 20.9-13.4 38.7-32 45.3L480 416c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-162.7C13.4 246.7 0 228.9 0 208l0-32c0-26.5 21.5-48 48-48zm190.1 0L203.5 58.7c-8.2-16.3-25-26.7-43.3-26.7-26.6 0-48.2 21.5-48.2 48 0 26.5 21.5 48 48 48l78.1 0zM64 416c0 17.7 14.3 32 32 32l144 0 0-192-176 0 0 160zm208 32l144 0c17.7 0 32-14.3 32-32l0-160-176 0 0 192z"]
}, I9 = {
  prefix: "fal",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M448 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
}, R9 = {
  prefix: "fal",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M384 208a176 176 0 1 0 -352 0 176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"]
}, T9 = {
  prefix: "fal",
  iconName: "key",
  icon: [512, 512, [128273], "f084", "M192 176c0-79.5 64.5-144 144-144s144 64.5 144 144-64.5 144-144 144c-11.1 0-22-1.3-32.4-3.6-5.4-1.2-11 .4-14.9 4.3L257.4 352 208 352c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 48-96 0 0-81.4 162.8-162.8c4.2-4.2 5.7-10.5 3.9-16.2-4.4-13.8-6.7-28.4-6.7-43.7zM336 0c-97.2 0-176 78.8-176 176 0 15.1 1.9 29.8 5.5 43.9L4.7 380.7c-3 3-4.7 7.1-4.7 11.3L0 496c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-48 40 0c4.2 0 8.3-1.7 11.3-4.7l30-30c10 1.8 20.2 2.7 30.7 2.7 97.2 0 176-78.8 176-176S433.2 0 336 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, _9 = {
  prefix: "fal",
  iconName: "badge-percent",
  icon: [512, 512, [], "f646", "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8 25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8 23.5 12.4 39.4 37.1 39.4 65.4s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8 7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8-12.4 23.5-37.1 39.4-65.4 39.4s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8-23.5-12.4-39.4-37.1-39.4-65.4s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm91.3 164.7c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, O9 = {
  prefix: "fal",
  iconName: "paintbrush",
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M505.7 0c-14.9 0-29.3 4.7-41.4 13.5L254.1 166.3c-29 21.1-46.1 54.7-46.1 90.6l0 .1c-5.2-.7-10.6-1-16-1-70.7 0-128 57.3-128 128 0 15.5 2.8 30.4 7.8 44.2 7.6 20.8-5.8 51.8-28 51.8L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0c70.7 0 128-57.3 128-128 0-5.4-.3-10.8-1-16l.1 0c35.8 0 69.5-17.1 90.6-46.1L562.5 111.7C571.3 99.7 576 85.2 576 70.3 576 31.5 544.5 0 505.7 0zm-195 336c-13-32.1-38.6-57.7-70.7-70.7l0-8.4c0-25.6 12.2-49.6 32.9-64.7L483.1 39.3c6.6-4.8 14.4-7.3 22.5-7.3 21.2 0 38.3 17.2 38.3 38.3 0 8.1-2.6 16-7.3 22.5L383.8 303.1c-15.1 20.7-39.1 32.9-64.7 32.9l-8.4 0zM288 384c0 53-43 96-96 96l-96.4 0c.7-1.3 1.4-2.6 2.1-3.8 8.3-16.7 11.7-38.9 4.2-59-3.8-10.3-5.9-21.4-5.9-33.1 0-53 43-96 96-96s96 43 96 96z"]
}, A9 = O9, k9 = {
  prefix: "fal",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 64c-140.8 0-229.3 128-256 192 26.7 64 115.2 192 256 192 140.8 0 229.3-128 256-192-26.7-64-115.2-192-256-192zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1 3.3 7.9 3.3 16.7 0 24.6-14.9 35.7-46.2 87.7-93 131.1-47.1 43.7-111.8 80.6-192.6 80.6S142.5 443.2 95.4 399.4c-46.8-43.5-78.1-95.4-93-131.1-3.3-7.9-3.3-16.7 0-24.6 14.9-35.7 46.2-87.7 93-131.1zM288 352c53 0 96-43 96-96 0-43.3-28.7-79.9-68.1-91.9 2.7 8.8 4.1 18.2 4.1 27.9 0 53-43 96-96 96-9.7 0-19.1-1.4-27.9-4.1 11.9 39.4 48.6 68.1 91.9 68.1zM160.2 263.8c-.2-2.6-.2-5.2-.2-7.8 0-12.2 1.7-23.9 4.9-35 .3-.9 .5-1.8 .8-2.7 12.4-40.4 44.3-72.2 84.7-84.7 11.9-3.7 24.6-5.6 37.7-5.6 2.5 0 5 .1 7.4 .2l.4 0c67.1 4 120.2 59.7 120.2 127.8 0 70.7-57.3 128-128 128-68.1 0-123.8-53.2-127.8-120.2zm32.1-16.1c9.3 5.3 20.1 8.4 31.6 8.4 35.3 0 64-28.7 64-64 0-11.5-3-22.3-8.4-31.6-46.4 4-83.3 40.9-87.3 87.3z"]
}, D9 = {
  prefix: "fal",
  iconName: "clipboard-check",
  icon: [384, 512, [], "f46c", "M248 0c22.3 0 41.6 13.1 50.6 32L320 32c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l21.4 0c9-18.9 28.3-32 50.6-32L248 0zM64 64C46.3 64 32 78.3 32 96l0 352c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-352c0-17.7-14.3-32-32-32l-16.6 0c-3.9 27.1-27.2 48-55.4 48l-112 0c-28.2 0-51.6-20.9-55.4-48L64 64zM259.1 218.2c5.2-7.1 15.2-8.7 22.3-3.5s8.7 15.2 3.5 22.3L179.3 382.2c-2.8 3.8-7.1 6.2-11.8 6.5s-9.3-1.4-12.6-4.8l-54.4-56.3c-6.1-6.4-6-16.5 .4-22.6s16.5-5.9 22.6 .4l41.2 42.6 94.4-129.8zM136 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L136 32z"]
}, P9 = {
  prefix: "fal",
  iconName: "receipt",
  icon: [384, 512, [129534], "f543", "M135.2 1.7c-4.8-2.4-10.4-2.2-15.1 .4L72 29.6 23.9 2.1C19-.7 12.9-.7 8 2.2S0 10.3 0 16L0 496c0 5.7 3 11 8 13.8s11 2.9 16 .1l48.1-27.5 48.1 27.5c4.6 2.7 10.3 2.8 15.1 .4l56.8-28.4 56.8 28.4c4.8 2.4 10.4 2.2 15.1-.4l48.1-27.5 48.1 27.5c5 2.8 11 2.8 16-.1s8-8.1 8-13.8l0-480c0-5.7-3-11-8-13.8s-11-2.9-16-.1L312 29.6 263.9 2.1c-4.6-2.7-10.3-2.8-15.1-.4L192 30.1 135.2 1.7zM79.9 61.9l48.6-27.8 56.3 28.2c4.5 2.3 9.8 2.3 14.3 0l56.3-28.2 48.6 27.8c4.9 2.8 11 2.8 15.9 0l32.1-18.3 0 424.9-32.1-18.3c-4.9-2.8-11-2.8-15.9 0l-48.6 27.8-56.3-28.2c-4.5-2.3-9.8-2.3-14.3 0l-56.3 28.2-48.6-27.8c-4.9-2.8-11-2.8-15.9 0L32 468.4 32 43.6 64.1 61.9c4.9 2.8 11 2.8 15.9 0zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 144zM80 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 336c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 240z"]
}, N9 = {
  prefix: "fal",
  iconName: "chevron-up",
  icon: [448, 512, [], "f077", "M212.7 100.7c6.2-6.2 16.4-6.2 22.6 0l208 208c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 134.6 27.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l208-208z"]
}, M9 = {
  prefix: "fal",
  iconName: "hexagon-plus",
  icon: [576, 512, ["plus-hexagon"], "f300", "M61.3 275.9L157.5 444c7.1 12.4 20.4 20.1 34.7 20.1l191.6 0c14.3 0 27.6-7.7 34.7-20.1l96.2-168.1c7-12.3 7-27.4 0-39.7L418.5 68.1C411.4 55.7 398.2 48 383.8 48L192.2 48c-14.3 0-27.6 7.7-34.7 20.1L61.3 236.2c-7 12.3-7 27.4 0 39.7zM33.5 291.8c-12.7-22.2-12.7-49.4 0-71.5L129.7 52.2C142.5 29.8 166.4 16 192.2 16l191.6 0c25.8 0 49.7 13.8 62.5 36.2l96.2 168.1c12.7 22.2 12.7 49.4 0 71.5L446.3 459.9c-12.8 22.4-36.7 36.2-62.5 36.2l-191.6 0c-25.8 0-49.7-13.8-62.5-36.2L33.5 291.8zM272 352l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
}, F9 = {
  prefix: "fal",
  iconName: "clock",
  icon: [512, 512, [128339, "clock-four"], "f017", "M480 256a224 224 0 1 1 -448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM240 112l0 144c0 5.4 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
}, L9 = {
  prefix: "fal",
  iconName: "clone",
  icon: [512, 512, [], "f24d", "M288 480L64 480c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l48 0 0-32-48 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-48-32 0 0 48c0 17.7-14.3 32-32 32zM224 320c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-224 0zm-64-32c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 224z"]
}, $9 = {
  prefix: "fal",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M315.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-208 208c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 256 84.7 59.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l208 208z"]
}, z9 = {
  prefix: "fal",
  iconName: "arrow-down-to-bracket",
  icon: [448, 512, [], "e094", "M379.3 203.3l-144 144c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 297.4 208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 281.4 116.7-116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM32 336l0 80c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c0 53-43 96-96 96L96 512c-53 0-96-43-96-96l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
}, j9 = {
  prefix: "fal",
  iconName: "flask",
  icon: [448, 512, [], "f0c3", "M96 16c0-8.8 7.2-16 16-16L336 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 187.8 61.8 108.1c.1 .2 .2 .3 .3 .5l58.9 103c4.7 8.2 7.1 17.4 7.1 26.8 0 29.8-24.1 53.9-53.9 53.9L53.9 512c-29.8 0-53.9-24.1-53.9-53.9 0-9.4 2.4-18.6 7.1-26.8L66 328.3c.1-.2 .2-.3 .3-.5L128 219.8 128 32 112 32c-8.8 0-16-7.2-16-16zM89.3 352L34.9 447.2c-1.9 3.3-2.9 7.1-2.9 10.9 0 12.1 9.8 21.9 21.9 21.9l340.1 0c12.1 0 21.9-9.8 21.9-21.9 0-3.8-1-7.6-2.9-10.9L358.7 352 89.3 352zm251.1-32l-50.3-88.1c-1.4-2.4-2.1-5.2-2.1-7.9l0-192-128 0 0 192c0 2.8-.7 5.5-2.1 7.9l-50.3 88.1 232.9 0z"]
}, B9 = {
  prefix: "fal",
  iconName: "database",
  icon: [448, 512, [], "f1c0", "M416 416c0 2.4-1 7.4-8.4 14.9-7.5 7.6-19.9 15.9-37.8 23.6-35.7 15.3-87.2 25.5-145.8 25.5S113.9 469.8 78.2 454.5c-17.9-7.7-30.3-16-37.8-23.6-7.4-7.5-8.4-12.5-8.4-14.9l0-84.5c17.2 8.9 38.1 16.3 61.2 21.9 37.5 9.2 82.5 14.5 130.8 14.5s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9l0 84.5zm0-212.5l0 90.6c-14.5 10.6-37.9 20.6-68.9 28.3-34.7 8.5-77.1 13.6-123.1 13.6s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3l0-90.6c17.2 8.9 38.1 16.3 61.2 21.9 37.5 9.2 82.5 14.5 130.8 14.5s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9zm0-37.4c-14.5 10.6-37.9 20.6-68.9 28.3-34.7 8.5-77.1 13.6-123.1 13.6s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3L32 96c0-2.4 1-7.4 8.4-14.9 7.5-7.6 19.9-15.9 37.8-23.6 35.7-15.3 87.2-25.5 145.8-25.5S334.1 42.2 369.8 57.5c17.9 7.7 30.3 16 37.8 23.6 7.4 7.5 8.4 12.5 8.4 14.9l0 70.1zM448 416l0-320C448 43 347.7 0 224 0S0 43 0 96L0 416c0 53 100.3 96 224 96s224-43 224-96z"]
}, G9 = {
  prefix: "fal",
  iconName: "file-check",
  icon: [384, 512, [], "f316", "M197.5 0c17 0 33.2 6.8 45.2 18.8L365.3 141.2c12 12 18.7 28.3 18.7 45.2L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L197.5 0zM64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-256-96 0c-35.3 0-64-28.7-64-64l0-96-128 0zM259.1 250.2c5.2-7.1 15.2-8.7 22.3-3.5s8.7 15.2 3.5 22.3L179.3 414.2c-2.8 3.8-7.1 6.2-11.8 6.5s-9.3-1.4-12.6-4.8l-54.4-56.3c-6.1-6.4-6-16.5 .4-22.6s16.5-5.9 22.6 .4l41.2 42.6 94.4-129.8zM224 128c0 17.7 14.3 32 32 32l82.7 0-114.7-114.8 0 82.8z"]
}, V9 = {
  prefix: "fal",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M248 80L136 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm0 32c28.2 0 51.6-20.9 55.4-48L320 64c17.7 0 32 14.3 32 32l0 352c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l16.6 0c3.9 27.1 27.2 48 55.4 48l112 0zm50.6-80c-9-18.9-28.3-32-50.6-32L136 0C113.7 0 94.4 13.1 85.4 32L64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64l-21.4 0z"]
}, U9 = {
  prefix: "fal",
  iconName: "box-dollar",
  icon: [448, 512, ["box-usd"], "f4a0", "M416 160l-384 0 0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM208 128l0-80-95.1 0c-10.3 0-20 5-26 13.4L39.3 128 208 128zm200.7 0L361.1 61.4c-6-8.4-15.7-13.4-26-13.4l-95.1 0 0 80 168.7 0zM0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.9 42.8C72.9 26 92.3 16 112.9 16l222.1 0c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.8 10.9 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5zM224 200c8.8 0 16 7.2 16 16l0 8 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-49.7 0c-7.9 0-14.3 6.4-14.3 14.3 0 7 5.1 13 12 14.1l45.3 7.6c22.3 3.7 38.7 23 38.7 45.7 0 25.6-20.7 46.3-46.3 46.3l-1.7 0 0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l57.7 0c7.9 0 14.3-6.4 14.3-14.3 0-7-5.1-13-12-14.1L198.7 316c-22.3-3.7-38.7-23-38.7-45.7 0-25.6 20.7-46.3 46.3-46.3l1.7 0 0-8c0-8.8 7.2-16 16-16z"]
}, W9 = {
  prefix: "fal",
  iconName: "image",
  icon: [448, 512, [], "f03e", "M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 144a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM80 160a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm169.3 59.7c1.5-2.3 4-3.7 6.7-3.7s5.2 1.4 6.7 3.7l88 136c1.6 2.5 1.7 5.6 .3 8.2s-4.1 4.2-7 4.2l-240 0c-3 0-5.7-1.7-7.1-4.3s-1.2-5.8 .5-8.3l56-80c1.5-2.1 3.9-3.4 6.6-3.4s5.1 1.3 6.6 3.4l10.6 15.2c3.1 4.4 8.1 6.9 13.4 6.8s10.2-2.8 13.1-7.3l45.6-70.4zM256 184c-13.6 0-26.2 6.9-33.6 18.3l-32.9 50.8c-7.5-8.3-18.2-13.1-29.6-13.1-13.1 0-25.3 6.4-32.8 17.1l-56 80c-8.6 12.2-9.6 28.2-2.7 41.4S89.1 400 104 400l240 0c14.7 0 28.1-8 35.1-20.9s6.4-28.5-1.6-40.8l-88-136c-7.4-11.4-20-18.3-33.6-18.3z"]
}, H9 = {
  prefix: "fal",
  iconName: "lightbulb",
  icon: [384, 512, [128161], "f0eb", "M308.1 302.1c27.2-28.7 43.9-67.4 43.9-110.1 0-88.4-71.6-160-160-160S32 103.6 32 192c0 42.7 16.7 81.4 43.9 110.1 19.9 20.9 40.4 48.7 48.5 81.9l135.2 0c8.1-33.3 28.6-61 48.5-81.9zM128 432c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-16-128 0 0 16zM331.3 324.1C307.7 349 288 379.4 288 413.7l0 18.3c0 44.2-35.8 80-80 80l-32 0c-44.2 0-80-35.8-80-80l0-18.3C96 379.4 76.3 349 52.7 324.1 20 289.7 0 243.2 0 192 0 86 86 0 192 0S384 86 384 192c0 51.2-20 97.7-52.7 132.1zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96 8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z"]
}, q9 = {
  prefix: "fal",
  iconName: "code",
  icon: [576, 512, [], "f121", "M383.2 21.1c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-160 480c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l160-480zM139.3 132.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 256 139.3 155.3c6.2-6.2 6.2-16.4 0-22.6zm297.4 0c-6.2 6.2-6.2 16.4 0 22.6L537.4 256 436.7 356.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0z"]
}, Y9 = {
  prefix: "fal",
  iconName: "sparkles",
  icon: [576, 512, [10024], "f890", "M480-16c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16zM192 64c6.2 0 11.9 3.6 14.5 9.3l53.1 115 115 53.1c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5l-115 53.1-53.1 115c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3l-53.1-115-115-53.1C3.6 267.9 0 262.2 0 256s3.6-11.9 9.3-14.5l115-53.1 53.1-115c2.6-5.7 8.3-9.3 14.5-9.3zm0 54.2l-41.1 88.9c-1.6 3.5-4.4 6.2-7.8 7.8L54.2 256 143.1 297.1c3.5 1.6 6.2 4.4 7.8 7.8l41.1 88.9 41.1-88.9c1.6-3.4 4.4-6.2 7.8-7.8l88.9-41.1-88.9-41.1c-3.5-1.6-6.2-4.4-7.8-7.8L192 118.2zM464 384l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
}, K9 = {
  prefix: "fal",
  iconName: "box-check",
  icon: [448, 512, [], "f467", "M335.1 16c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.7 10.8 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.8 42.8C72.9 26 92.3 16 112.9 16l222.1 0zM32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256-384 0 0 256zM291.1 218.2c5.2-7.1 15.2-8.7 22.3-3.5s8.7 15.2 3.5 22.3L211.3 382.2c-2.8 3.8-7.1 6.2-11.8 6.5s-9.3-1.4-12.6-4.8l-54.4-56.3c-6.1-6.4-6-16.5 .4-22.6s16.5-5.9 22.6 .4l41.2 42.6 94.4-129.8zM112.9 48c-10.3 0-20 5-26 13.4l-47.6 66.6 168.7 0 0-80-95.1 0zM240 128l168.7 0-47.6-66.6c-6-8.4-15.7-13.4-26-13.4l-95.1 0 0 80z"]
}, k3 = {
  prefix: "fal",
  iconName: "circle",
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M480 256a224 224 0 1 0 -448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"]
}, Z9 = {
  prefix: "fal",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-480a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 352a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-256c13.5 0 24.3 11.4 23.5 24.9l-7.6 136c-.5 8.5-7.5 15.1-16 15.1s-15.5-6.6-16-15.1l-7.6-136c-.8-13.5 10-24.9 23.5-24.9z"]
}, X9 = {
  prefix: "fal",
  iconName: "circle-user",
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M412.1 416.6C398.1 361.1 347.9 320 288 320l-64 0C164.1 320 113.9 361.1 99.9 416.6 58 375.9 32 319 32 256 32 132.3 132.3 32 256 32S480 132.3 480 256c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.4 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1l64 0c50.4 0 91.6 38.8 95.7 88.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"]
}, J9 = X9, Q9 = {
  prefix: "fal",
  iconName: "thumbs-up",
  icon: [512, 512, [128077, 61575], "f164", "M180.5 32.8c19.8-28.2 58.2-37.3 88.9-20l5.9 3.7c26.3 18.5 36 53.2 23.2 82.7l-3.1 6.2-30.8 54.7 151.5 0 5.4 .2c49.5 4 73.2 61.7 47.3 99.8 16.9 25 13.8 59.6-7.7 81.2 8.5 28-3.7 59.3-29.2 74.2 .1 31.8-24 60.3-56.4 64.2l-7.5 .4-114.4 0c-29.6 0-54.5-11.5-76.7-21.3l-.1 0c-19.2-8.6-35.7-21.3-48.8-36.7l0 10.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 208c0-26.5 21.5-48 48-48l32 0c9.2 0 17.7 2.6 25 7 1.2-2.6 2.5-5.2 3.9-7.7l67.9-120.7 3.7-5.9zM48 192c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-32 0zM253.7 40.6c-16.2-9.1-36.6-4.3-47.1 10.6l-2 3.1-67.9 120.7c-5 8.8-7.9 18.6-8.6 28.7L128 334.4c0 41.1 24.2 78.3 61.8 95l0 0c23.6 10.3 42.2 18.6 63.9 18.6l114.4 0 3.7-.2c18.2-2.2 31.5-20.5 27.5-38.7-1.8-8 2.9-16.1 10.7-18.7 18.8-6.1 27.6-29.1 17.9-46.1-4.2-7.4-1.8-16.8 5.3-21.3 17.6-11.2 19.6-37.2 3.9-51-3.4-3-5.4-7.4-5.4-12s2-9 5.4-12c20-17.6 9.1-51.4-15.9-55.5l-5.2-.4-178.8 0c-5.7 0-10.9-3-13.8-7.9s-2.9-11-.1-15.9l44.2-78.5 1.6-3.3c6.8-15.6 1.7-33.9-12.2-43.7l-3.1-2z"]
}, eF = {
  prefix: "fal",
  iconName: "rectangle-history",
  icon: [512, 512, [], "e4a2", "M480 272c0-17.7-14.3-32-32-32L64 240c-17.7 0-32 14.3-32 32l0 144c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-144zm-32-64c35.3 0 64 28.7 64 64l0 144c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 272c0-35.3 28.7-64 64-64l384 0zm0-104c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 136c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0zM400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L112 32c-8.8 0-16-7.2-16-16s7.2-16 16-16L400 0z"]
}, tF = {
  prefix: "fal",
  iconName: "building",
  icon: [384, 512, [127970, 61687], "f1ad", "M64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l64 0 0-80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 80 64 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L64 32zm96 448l64 0 0-80c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 80zm-32 32l-64 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-192 0zm96-384c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16 96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM112 128c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16 96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z"]
}, nF = {
  prefix: "fal",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M185.9 112.3c-6.5 3.2-12.8 6.8-18.8 10.9-8.2 5.5-18.5 6.9-28 3.8L67.4 103.2 29.5 168.8 86 219.1c7.4 6.6 11.3 16.2 10.7 26.1-.5 7.2-.5 14.6 0 21.8 .7 9.9-3.3 19.5-10.7 26.1l-56.5 50.2 37.9 65.7 71.7-23.8c9.4-3.1 19.7-1.7 28 3.8 6 4 12.3 7.7 18.8 10.9 8.9 4.4 15.2 12.6 17.2 22.3l15.2 74 75.8 0 15.2-74c2-9.7 8.4-17.9 17.2-22.3 6.5-3.2 12.8-6.8 18.8-10.9 8.2-5.5 18.5-6.9 28-3.8l71.7 23.8 37.9-65.7-56.5-50.2c-7.4-6.6-11.3-16.2-10.7-26.1 .2-3.6 .4-7.2 .4-10.9s-.1-7.3-.4-10.9c-.7-9.9 3.3-19.5 10.7-26.1l56.5-50.2-37.9-65.7-71.7 23.8c-9.4 3.1-19.7 1.7-28-3.8-6-4-12.3-7.7-18.8-10.9-8.9-4.4-15.2-12.6-17.2-22.3l-15.2-74-75.8 0-15.2 74c-2 9.7-8.4 17.9-17.2 22.3zM294.2-16c15.2 0 28.3 10.7 31.3 25.5l15.2 74c7.8 3.8 15.4 8.2 22.6 13.1l71.7-23.8c14.4-4.8 30.2 1.2 37.8 14.4l37.9 65.7c7.6 13.2 4.9 29.8-6.5 39.9L447.9 243c.6 8.6 .6 17.5 0 26l56.5 50.2c11.4 10.1 14 26.8 6.5 39.9l-37.9 65.7c-7.6 13.2-23.4 19.2-37.8 14.4l-71.7-23.8c-7.2 4.8-14.7 9.2-22.6 13.1l-15.2 74c-3.1 14.9-16.2 25.5-31.3 25.5l-75.8 0c-15.2 0-28.3-10.7-31.3-25.5l-15.2-74c-7.8-3.8-15.4-8.2-22.6-13.1L77.5 439.2C63.1 444 47.3 438 39.7 424.8L1.8 359.2c-7.6-13.1-4.9-29.8 6.5-39.9L64.7 269c-.6-8.6-.6-17.5 0-26L8.2 192.8c-11.4-10.1-14-26.8-6.5-39.9L39.7 87.2C47.3 74 63.1 68 77.5 72.8l71.7 23.8c7.2-4.8 14.7-9.2 22.6-13.1l15.2-74C190.1-5.3 203.2-16 218.4-16l75.8 0zM200.3 256a55.7 55.7 0 1 0 111.4 0 55.7 55.7 0 1 0 -111.4 0zm55.4 88a88 88 0 1 1 .6-176 88 88 0 1 1 -.6 176z"]
}, rF = nF, oF = {
  prefix: "fal",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M480 256a224 224 0 1 0 -448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256-96c-26.5 0-48 21.5-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80s80 35.8 80 80c0 39.6-25.7 60.3-46.2 70.1-11.5 5.5-17.8 14.5-17.8 22.2l0 5.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-5.7c0-24.6 18.3-42.6 36-51 14.5-6.9 28-18.8 28-41.2 0-26.5-21.5-48-48-48zM232 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
}, iF = oF, aF = {
  prefix: "fal",
  iconName: "file",
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M192 32L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-256-96 0c-35.3 0-64-28.7-64-64l0-96zM338.7 160L224 45.3 224 128c0 17.7 14.3 32 32 32l82.7 0zM0 64C0 28.7 28.7 0 64 0L197.5 0c17 0 33.3 6.7 45.3 18.7L365.3 141.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"]
}, sF = {
  prefix: "fal",
  iconName: "arrow-up",
  icon: [384, 512, [8593], "f062", "M203.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6 176 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-441.4 148.7 148.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-176-176z"]
}, lF = {
  prefix: "fal",
  iconName: "shirt",
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M184.4 44.3l-130.3 117.3 60.4 72.5 51.8-38.9c4.8-3.6 11.3-4.2 16.8-1.5s8.8 8.3 8.8 14.3l0 256c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-256c0-6.1 3.4-11.6 8.8-14.3s11.9-2.1 16.8 1.5l51.8 38.9 60.4-72.5-130.3-117.3C446.7 36.4 435.3 32 423.4 32l-8.8 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80l-8.8 0c-11.9 0-23.3 4.4-32.1 12.3zM416 0l7.4 0c19.8 0 38.8 7.3 53.5 20.5L618.7 148.1c6.4 5.8 7.1 15.5 1.6 22.1l-80 96c-5.5 6.5-15.1 7.7-21.9 2.6L480 240 480 464c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-224-38.4 28.8c-6.8 5.1-16.4 4-21.9-2.6l-80-96c-5.5-6.6-4.8-16.4 1.6-22.1L163 20.5C177.7 7.3 196.8 0 216.6 0L416 0zM382 32L258 32c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48z"]
}, cF = {
  prefix: "fal",
  iconName: "trash-can",
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M160.5 27.4c2-6.8 8.3-11.4 15.3-11.4l96.4 0c7.1 0 13.3 4.6 15.3 11.4l11 36.6-149 0 11-36.6zM116.1 64L16 64C7.2 64 0 71.2 0 80S7.2 96 16 96l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-100.1 0-13.7-45.8C312.1-2.1 293.4-16 272.2-16l-96.4 0c-21.2 0-39.9 13.9-46 34.2L116.1 64zM32 144l0 304c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-304-32 0 0 304c0 17.7-14.3 32-32 32L96 480c-17.7 0-32-14.3-32-32l0-304-32 0zm112 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192z"]
}, uF = {
  prefix: "fal",
  iconName: "bell-concierge",
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 48.6C123.8 152.8 32 249.7 32 368l32 0c0-106 86-192 192-192s192 86 192 192l32 0c0-118.3-91.8-215.2-208-223.4l0-48.6 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zM16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 416z"]
}, dF = uF, fF = {
  prefix: "fal",
  iconName: "calendar",
  icon: [448, 512, [128197, 128198], "f133", "M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32zm32 96l-384 0 0 224c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-224z"]
}, mF = {
  prefix: "fal",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M441.4 67.1c7.1 5.2 8.7 15.2 3.5 22.4l-280 384c-2.8 3.8-7 6.2-11.7 6.5s-9.2-1.3-12.6-4.6l-136-136c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l122.8 122.8 269-368.9c5.2-7.1 15.2-8.7 22.4-3.5z"]
}, pF = {
  prefix: "fal",
  iconName: "hat-wizard",
  icon: [512, 512, [], "f6e8", "M512 456c0-30.5-24.5-55.4-54.9-56l-79-184.3c-6.6-15.3-7.6-32.5-2.9-48.5L413.6 35.8c3.9-13.5-10.2-25.1-22.7-18.7L236 97c-38.8 20-69.6 52.7-87.4 92.6L55.1 400c-30.5 .5-55.1 25.4-55.1 56 0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56zM348.8 228.3l73.6 171.7-182.3 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32-117.9 0 87.7-197.3c14.8-33.3 40.5-60.5 72.8-77.2l121.7-62.8-27.9 95.6c-6.7 23.1-5.2 47.9 4.2 70.1zM480 456c0 13.3-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24zM288 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16z"]
}, hF = {
  prefix: "fal",
  iconName: "sliders",
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0-8.8 7.2-16 16-16l65.6 0c7.4-36.5 39.7-64 78.4-64s71 27.5 78.4 64L496 400c8.8 0 16 7.2 16 16s-7.2 16-16 16l-257.6 0c-7.4 36.5-39.7 64-78.4 64s-71-27.5-78.4-64L16 432c-8.8 0-16-7.2-16-16zm208 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80c38.7 0 71 27.5 78.4 64l65.6 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-65.6 0c-7.4 36.5-39.7 64-78.4 64s-71-27.5-78.4-64L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l257.6 0c7.4-36.5 39.7-64 78.4-64zM192 48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm78.4 32L496 80c8.8 0 16 7.2 16 16s-7.2 16-16 16l-225.6 0c-7.4 36.5-39.7 64-78.4 64s-71-27.5-78.4-64L16 112c-8.8 0-16-7.2-16-16S7.2 80 16 80l97.6 0C121 43.5 153.3 16 192 16s71 27.5 78.4 64z"]
}, gF = {
  prefix: "fal",
  iconName: "image-broken",
  icon: [448, 512, [], "e8aa", "M222.6 32c4.9 0 9.6 2.3 12.6 6.1l76.7 98.1c5.2 6.7 8.1 14.9 8.1 23.3 0 9.4-3.5 18.5-9.8 25.5L161.5 348.5c-1 1.1-1.5 2.5-1.5 4 0 1.3 .4 2.6 1.2 3.6l76.8 98c3.8 4.8 4.5 11.4 1.8 16.9s-8.3 9-14.4 9L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l158.6 0zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-96.7 0c2.7-10.6 2.7-21.6 0-32l96.7 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32l-67.6 0-25-32 92.7 0zM64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l128.5 0-56.5-72.2c-5.2-6.7-8.1-14.9-8.1-23.3 0-9.4 3.5-18.5 9.8-25.5L286.5 163.5c1-1.1 1.5-2.5 1.5-4 0-1.3-.4-2.6-1.3-3.6L214.8 64 64 64zM377.6 338.3l2.6 4.7c5.4 11.4 5.1 24.8-1.1 36.1-7 12.9-20.5 20.9-35.2 20.9l-87.4 0-25-32 112.5 0c2.9 0 5.6-1.6 7-4.2 1-1.9 1.2-4.1 .6-6.2l-.9-2-54.4-84.1 22.2-24.5 59 91.2zM128 208a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-64a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
}, vF = {
  prefix: "fal",
  iconName: "arrow-right",
  icon: [512, 512, [8594], "f061", "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l441.4 0-148.7 148.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z"]
}, yF = {
  prefix: "fal",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 27.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 4.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 356.7 443.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 379.3 91.3z"]
}, bF = yF, SF = {
  prefix: "fal",
  iconName: "tags",
  icon: [576, 512, [], "f02c", "M64.3 96c0-17.7 14.3-32 32-32l136.8 0c6.4 0 12.5 2.5 17 7L404.5 225.4c12.5 12.5 12.5 32.8 0 45.3L271 404.1c-12.5 12.5-32.8 12.5-45.3 0L71.4 249.8c-4.5-4.5-7-10.6-7-17L64.3 96zm-32 0l0 136.8c0 14.9 5.9 29.1 16.4 39.6L203.1 426.7c25 25 65.5 25 90.5 0L427.1 293.3c25-25 25-65.5 0-90.5L272.7 48.4C262.2 37.9 248 32 233.1 32L96.3 32c-35.3 0-64 28.7-64 64zM381.1 52.6c-6.3 6.2-6.4 16.3-.2 22.6L534.8 231.1c9.2 9.4 9.2 24.4 0 33.7l-162 163.9c-6.2 6.3-6.2 16.4 .1 22.6s16.4 6.2 22.6-.1l162-163.9c21.5-21.8 21.6-56.9 0-78.7L403.7 52.8c-6.2-6.3-16.3-6.4-22.6-.2zM144.3 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, xF = {
  prefix: "fal",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-480a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm83.1 134.6c5.2-7.1 15.2-8.7 22.3-3.5s8.7 15.2 3.5 22.3l-128 176c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l50.7 50.7 117-160.8z"]
}, CF = xF, wF = {
  prefix: "fal",
  iconName: "address-book",
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M96 32C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-384c0-17.7-14.3-32-32-32L96 32zM32 64C32 28.7 60.7 0 96 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64zM272 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm32 128c-26.5 0-48 21.5-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48l-64 0zM512 80l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 192c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm16 144l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
}, EF = {
  prefix: "fal",
  iconName: "split",
  icon: [512, 512, [], "e254", "M404.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-104.2 0c-17 0-33.3 6.7-45.3 18.7L194.7 243.9c-4.6 4.6-9.5 8.6-14.8 12.1 5.3 3.5 10.3 7.6 14.8 12.1L307.9 381.3c12 12 28.3 18.7 45.3 18.7l104.2 0-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-104.2 0c-25.5 0-49.9-10.1-67.9-28.1L172.1 290.7c-12-12-28.3-18.7-45.3-18.7L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l110.9 0c17 0 33.3-6.7 45.3-18.7L285.3 108.1c18-18 42.4-28.1 67.9-28.1l104.2 0-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
}, IF = {
  prefix: "fal",
  iconName: "list",
  icon: [512, 512, ["list-squares"], "f03a", "M48 112l0-32 32 0 0 32-32 0zM16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48C26.7 48 16 58.7 16 72zm160 8c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L176 80zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0zM48 240l32 0 0 32-32 0 0-32zm-8-32c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm8 224l0-32 32 0 0 32-32 0zM16 392l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z"]
}, RF = {
  prefix: "fal",
  iconName: "gift-card",
  icon: [512, 512, [], "f663", "M351.8 32c26.6 0 48.2 21.5 48.2 48 0 26.5-21.5 48-48 48l-78.1 0 34.7-69.3c8.2-16.3 25-26.7 43.3-26.7zM222.7 160l-43.2 54c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5L256 169.6 307.5 234c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-43.2-54 158.7 0c17.7 0 32 14.3 32 32l0 128-448 0 0-128c0-17.7 14.3-32 32-32l158.7 0zM96 128l-32 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-32 0c10-13.4 16-30 16-48 0-44.2-36-80-80.2-80-30.4 0-58.3 17.2-71.9 44.4L256 92.2 232.1 44.4C218.5 17.2 190.5 0 160.2 0 116 0 80 35.8 80 80 80 98 86 114.6 96 128zm64 0c-26.5 0-48-21.5-48-48 0-26.5 21.6-48 48.2-48 18.3 0 35.1 10.4 43.3 26.7l34.7 69.3-78.1 0zM32 352l448 0 0 64c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-64z"]
}, TF = {
  prefix: "fal",
  iconName: "chevron-down",
  icon: [448, 512, [], "f078", "M235.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-208-208c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 377.4 420.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-208 208z"]
}, _F = {
  prefix: "fal",
  iconName: "badge-check",
  icon: [512, 512, [], "f336", "M256 0c36.1 0 68 18.1 87.1 45.6 33-6 68.4 3.8 93.9 29.3s35.3 60.9 29.3 93.9C493.9 188 512 219.9 512 256s-18.1 68-45.6 87.1c6 33-3.8 68.4-29.3 93.9s-60.9 35.3-93.9 29.3C324 493.9 292.1 512 256 512s-68-18.1-87.1-45.6c-33 6-68.4-3.8-93.9-29.3s-35.3-60.9-29.3-93.9C18.1 324 0 292.1 0 256s18.1-68 45.6-87.1c-6-33 3.8-68.4 29.3-93.9s60.9-35.3 93.9-29.3C188 18.1 219.9 0 256 0zm0 32c-28.3 0-53 15.9-65.4 39.4-3.6 6.8-11.5 10-18.8 7.8-25.4-7.8-54.1-1.6-74.2 18.4s-26.2 48.8-18.4 74.2c2.2 7.3-1 15.2-7.8 18.8-23.5 12.4-39.4 37.1-39.4 65.4s15.9 53 39.4 65.4c6.8 3.6 10 11.5 7.8 18.8-7.8 25.4-1.6 54.1 18.4 74.2s48.8 26.2 74.2 18.4c7.3-2.2 15.2 1 18.8 7.8 12.4 23.5 37.1 39.4 65.4 39.4s53-15.9 65.4-39.4c3.6-6.8 11.5-10 18.8-7.8 25.4 7.8 54.1 1.6 74.2-18.4s26.2-48.7 18.4-74.1c-2.3-7.3 1-15.2 7.8-18.8 23.5-12.4 39.4-37.1 39.4-65.4s-15.9-53-39.4-65.4c-6.8-3.6-10-11.5-7.8-18.8 7.8-25.4 1.6-54.1-18.4-74.1s-48.8-26.2-74.2-18.4c-7.3 2.2-15.2-1-18.8-7.8-12.4-23.5-37.1-39.4-65.4-39.4zm67.1 138.2c5.2-7.1 15.2-8.7 22.3-3.5s8.7 15.2 3.5 22.3L243.3 334.2c-2.8 3.8-7.1 6.2-11.8 6.5s-9.3-1.4-12.6-4.8l-54.4-56.3c-6.1-6.4-6-16.5 .4-22.6s16.5-5.9 22.6 .4l41.2 42.6 94.4-129.8z"]
}, OF = {
  prefix: "fal",
  iconName: "plug-circle-plus",
  icon: [640, 512, [], "e55f", "M496 288a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16zM192-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 96c0 100.6 77.4 183.2 176 191.3l0 80.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80.7c.2 0 .4 0 .6-.1-.8-9.8-.9-20.8 .1-32.2-5.5 .6-11.1 .9-16.7 .9-88.4 0-160-71.6-160-160l0-96 320 0 0 86c10.4-2.7 21-4.5 32-5.4l0-80.7 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112-192 0 0-112z"]
}, AF = {
  prefix: "fal",
  iconName: "credit-card",
  icon: [512, 512, [128179, 62083, "credit-card-alt"], "f09d", "M448 96c17.7 0 32 14.3 32 32l0 64-448 0 0-64c0-17.7 14.3-32 32-32l384 0zm32 128l0 160c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-160 448 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM96 336c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
}, kF = {
  prefix: "fal",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M4.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l208-208c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L38.6 256 235.3 452.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-208-208z"]
}, DF = {
  prefix: "fal",
  iconName: "wand-magic-sparkles",
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M272-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-24zM460 32c5.6 0 10.9 2.2 14.8 6.1l31 31c3.9 3.9 6.1 9.3 6.1 14.8s-2.2 10.9-6.1 14.8L393.7 211 333 150.3 445.2 38.1c3.9-3.9 9.3-6.1 14.8-6.1zM70.1 413.2L310.3 173 371 233.7 130.8 473.9c-3.9 3.9-9.3 6.1-14.8 6.1s-10.9-2.2-14.8-6.1l-31-31 0 0c-3.9-3.9-6.1-9.3-6.1-14.8s2.2-10.9 6.1-14.8zM460 0c-14 0-27.5 5.6-37.5 15.5l-375 375C37.6 400.5 32 414 32 428s5.6 27.5 15.5 37.5l31 31C88.5 506.4 102 512 116 512s27.5-5.6 37.5-15.5l375-375C538.4 111.5 544 98 544 84s-5.6-27.5-15.5-37.5l-31-31C487.5 5.6 474 0 460 0zM112 48c0-8.8-7.2-16-16-16S80 39.2 80 48l0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64zM464 304c-8.8 0-16 7.2-16 16l0 64-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-64c0-8.8-7.2-16-16-16z"]
}, PF = {
  prefix: "fal",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256.5 0c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5S486.6 480 472.5 480l-432 0c-14.1 0-27.1-7.4-34.3-19.5s-7.5-27.1-.8-39.5l216-400c7-12.9 20.5-21 35.2-21zm0 32c-2.9 0-5.6 1.6-7 4.2l-216 400c-1.3 2.5-1.3 5.5 .2 7.9s4.1 3.9 6.9 3.9l432 0c2.8 0 5.4-1.5 6.9-3.9s1.5-5.4 .2-7.9l-216-400c-1.4-2.6-4.1-4.2-7-4.2zm0 368a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-224c13.6 0 24.3 11.6 23.4 25.1l-7.4 104c-.6 8.4-7.6 14.9-16 14.9s-15.4-6.5-16-14.9l-7.4-104c-1-13.6 9.8-25.1 23.4-25.1z"]
}, NF = {
  prefix: "fal",
  iconName: "store",
  icon: [512, 512, [], "f54e", "M28.5 82.2C38 52.3 65.7 32 97.1 32l318 0c31.4 0 59.1 20.3 68.7 50.2l18.8 59.2c9.7 30.4-.8 61.2-22.5 80.1l0 186.5c0 39.8-32.2 72-72 72l-304 0c-39.8 0-72-32.2-72-72l0-186.5C10.4 202.7-.1 171.9 9.6 141.4L28.5 82.2zM377.7 64l8.7 96.1 0 .1 .7 8.1c2 22.5 20.9 39.7 43.4 39.7 29.5 0 50.5-28.7 41.6-56.9L453.3 91.9C448 75.3 432.6 64 415.2 64l-37.5 0zm-23.1 99.1c0 0 0-.1 0-.1l-9-99-73.4 0 0 102.7c0 22.8 18.5 41.3 41.3 41.3 24.2 0 43.3-20.8 41.1-44.9zm-98.4 49.4c-13.4 16.8-34.1 27.6-57.3 27.6-23.7 0-44.7-11.2-58-28.5-13.9 17.4-35.3 28.5-59.2 28.5-6.1 0-11.9-.7-17.5-2l0 82 384 0 0-82c-5.6 1.3-11.5 2-17.5 2-23.8 0-45.2-11.1-59.2-28.5-13.3 17.3-34.3 28.5-58 28.5-23.2 0-43.9-10.8-57.3-27.6zM240.1 64l-73.4 0-9 99c-2.2 24.2 16.8 45 41.1 45 22.8 0 41.3-18.5 41.3-41.3l0-102.7zm-143 0C79.7 64 64.2 75.3 59 91.9L40.1 151.1c-9 28.1 12 56.9 41.6 56.9 22.6 0 41.4-17.2 43.4-39.7l.7-8.2 0 0 8.7-96.1-37.5 0zm-33 288l0 56c0 22.1 17.9 40 40 40l304 0c22.1 0 40-17.9 40-40l0-56-384 0z"]
}, MF = {
  prefix: "fal",
  iconName: "lock",
  icon: [384, 512, [128274], "f023", "M96 96l0 64 192 0 0-64c0-53-43-96-96-96S96 43 96 96zM64 160l0-64C64 25.3 121.3-32 192-32S320 25.3 320 96l0 64c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64zM32 224l0 224c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L64 192c-17.7 0-32 14.3-32 32z"]
}, FF = {
  prefix: "fal",
  iconName: "user-group-simple",
  icon: [640, 512, [], "e603", "M464 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM400 443c10.6 3.3 21.9 5 33.5 5l61 0c62.7 0 113.5-50.8 113.5-113.5 0-8-6.5-14.5-14.5-14.5L360 320c-8.8-11.7-18.8-22.3-29.8-31.8 1.4-.1 2.8-.2 4.3-.2l259 0c25.7 0 46.5 20.8 46.5 46.5 0 80.4-65.2 145.5-145.5 145.5l-61 0c-11.9 0-23.5-1.4-34.6-4.1 .7-3.8 1.1-7.8 1.1-11.9l0-21zM176 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM152 320C85.7 320 32 373.7 32 440l0 24c0 8.8-7.2 16-16 16S0 472.8 0 464l0-24c0-83.9 68.1-152 152-152l48 0c83.9 0 152 68.1 152 152l0 24c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24c0-66.3-53.7-120-120-120l-48 0z"]
}, LF = {
  prefix: "fal",
  iconName: "arrow-right-arrow-left",
  icon: [512, 512, [8644, "exchange"], "f0ec", "M139.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112c-6.2-6.2-6.2-16.4 0-22.6l112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 368 496 368c8.8 0 16 7.2 16 16s-7.2 16-16 16l-441.4 0 84.7 84.7zm233.4-256L457.4 144 16 144c-8.8 0-16-7.2-16-16s7.2-16 16-16l441.4 0-84.7-84.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l112 112c6.2 6.2 6.2 16.4 0 22.6l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"]
}, $F = LF, zF = {
  prefix: "fal",
  iconName: "file-pdf",
  icon: [576, 512, [], "f1c1", "M224 32L96 32C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l80 0 0 32-80 0c-35.3 0-64-28.7-64-64L32 64C32 28.7 60.7 0 96 0L229.5 0c17 0 33.3 6.7 45.3 18.7L397.3 141.3c12 12 18.7 28.3 18.7 45.3l0 149.5-32 0 0-144-96 0c-35.3 0-64-28.7-64-64l0-96zM370.7 160L256 45.3 256 128c0 17.7 14.3 32 32 32l82.7 0zM240 384l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128z"]
}, jF = {
  prefix: "fal",
  iconName: "globe",
  icon: [512, 512, [127760], "f0ac", "M317.5 420.1C295.4 465 271.5 480 256 480s-39.4-15-61.5-59.9c-19-38.6-32.1-91.3-34.2-148.1l191.4 0c-2.1 56.8-15.2 109.5-34.2 148.1zM351.7 240l-191.4 0c2.1-56.8 15.2-109.5 34.2-148.1 22.1-44.9 46-59.9 61.5-59.9s39.4 15 61.5 59.9c19 38.6 32.1 91.3 34.2 148.1zm32 32l95.7 0c-6.5 92.5-69.2 169.5-154.2 197.1 33-44.2 55.8-117.8 58.5-197.1zm95.7-32l-95.7 0c-2.7-79.3-25.5-152.9-58.5-197.1 85 27.6 147.7 104.6 154.2 197.1zm-351.2 0l-95.7 0c6.5-92.5 69.2-169.5 154.2-197.1-33 44.2-55.8 117.8-58.5 197.1zM32.6 272l95.7 0c2.7 79.3 25.5 152.9 58.5 197.1-85-27.6-147.7-104.6-154.2-197.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"]
}, BF = {
  prefix: "fal",
  iconName: "arrow-left",
  icon: [512, 512, [8592], "f060", "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 496 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z"]
}, GF = {
  prefix: "fal",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M240 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192-192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0 0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192 192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0 0-192z"]
}, VF = {
  prefix: "fal",
  iconName: "box",
  icon: [448, 512, [128230], "f466", "M416 416c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-256 384 0 0 256zM39.3 128L86.9 61.4c6-8.4 15.7-13.4 26-13.4l95.1 0 0 80-168.7 0zM240 128l0-80 95.1 0c10.3 0 20 5 26 13.4L408.7 128 240 128zM11.9 111.3C4.2 122.2 0 135.2 0 148.5L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-267.5c0-13.3-4.2-26.3-11.9-37.2L387.1 42.8C375.1 26 355.7 16 335.1 16L112.9 16C92.3 16 72.9 26 60.9 42.8L11.9 111.3z"]
}, UF = {
  prefix: "fal",
  iconName: "eye-slash",
  icon: [576, 512, [], "f070", "M27.3-27.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l544 544c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L466.4 411.9c4.9-4.1 9.6-8.2 14.1-12.5 46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1-47.1-43.7-111.8-80.6-192.6-80.6-60 0-111.1 20.3-152.8 48.7L27.3-27.2zm131 131c36.4-23.7 79.7-39.8 129.7-39.8 140.8 0 229.3 128 256 192-13.3 32-42.1 80-85.2 120-4.9 4.5-9.9 8.9-15.1 13.2l-54.6-54.6c16.9-21.7 26.9-48.9 26.9-78.5 0-70.7-57.3-128-128-128-29.6 0-56.9 10-78.5 26.9l-51.2-51.2zM366.2 311.7L232.3 177.8c15.7-11.2 34.9-17.8 55.7-17.8 53 0 96 43 96 96 0 20.8-6.6 40-17.8 55.7zM74.8 133.3c-35.5 38.5-59.7 80.2-72.3 110.4-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47.1 43.7 111.8 80.6 192.6 80.6 40.6 0 77.1-9.3 109.4-24.1L373 431.5c-25.8 10.3-54.1 16.5-85 16.5-140.8 0-229.3-128-256-192 11.2-26.8 33.2-64.9 65.4-100.1L74.8 133.3z"]
}, WF = {
  prefix: "fal",
  iconName: "arrow-rotate-left",
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M16 0c8.8 0 16 7.2 16 16l0 103.8 37-39.1C117.6 29.2 185.2 0 256 0 397.4 0 512 114.6 512 256S397.4 512 256 512c-98.3 0-183.6-55.4-226.5-136.5-4.1-7.8-1.1-17.5 6.7-21.6s17.5-1.1 21.6 6.7C95.4 431.6 170.1 480 256 480 379.7 480 480 379.7 480 256S379.7 32 256 32c-62 0-121.2 25.5-163.8 70.6L53.1 144 160 144c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 176c-8.8 0-16-7.2-16-16L0 16C0 7.2 7.2 0 16 0z"]
}, HF = WF, qF = {
  prefix: "fal",
  iconName: "chart-pie-simple",
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M304 208l0-173.6C393.2 48.2 463.8 118.8 477.6 208L304 208zm176 32c17.7 0 32.2-14.4 29.9-31.9-14.2-107-99-191.7-206-206-17.5-2.3-31.9 12.2-31.9 29.9l0 176c0 17.7 14.3 32 32 32l176 0zM32 272c0-98.3 68.3-180.8 160-202.4L192 272c0 26.5 21.5 48 48 48l202.4 0C420.8 411.7 338.3 480 240 480 125.1 480 32 386.9 32 272zM224 68.7C224 49.7 206.7 33.4 186.3 38 79.6 62.4 0 157.9 0 272 0 404.6 107.5 512 240 512 354.1 512 449.6 432.4 474 325.7 478.6 305.3 462.3 288 443.3 288L240 288c-8.8 0-16-7.2-16-16l0-203.3z"]
}, YF = {
  prefix: "fal",
  iconName: "tag",
  icon: [512, 512, [127991], "f02b", "M64.1 96c0-17.7 14.3-32 32-32l156.1 0c8.5 0 16.6 3.4 22.6 9.4l192 192c12.5 12.5 12.5 32.8 0 45.2L310.7 466.7c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-6-6-9.4-14.1-9.4-22.6L64.1 96zm32-64c-35.3 0-64 28.7-64 64l0 156.1c0 17 6.7 33.2 18.7 45.3l192 192c25 25 65.5 25 90.5 0L489.5 333.3c25-25 25-65.5 0-90.5l-192-192c-12-12-28.3-18.7-45.3-18.7L96.1 32zm48 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, KF = {
  prefix: "fal",
  iconName: "webhook",
  icon: [576, 512, [], "e5d5", "M312.9 35.3c-51.2-13.7-103.9 16.7-117.6 67.9-11 40.9 6.2 82.8 39.8 105 10.1 6.7 14.7 20.5 8 32.3l-63 111.9c7.4 8.4 11.9 19.5 11.9 31.6 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48c2.8 0 5.6 .2 8.2 .7l59.5-105.8c-41-30.4-61.4-83.7-47.4-136 18.3-68.3 88.5-108.8 156.8-90.5S430 92.8 411.7 161.1c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6C394.5 101.6 364.1 49 312.9 35.3zM272 128a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16-48c26.5 0 48 21.5 48 48 0 12.1-4.5 23.2-11.9 31.6l59.5 105.8c46.2-18.8 101.3-9.5 138.8 28 50 50 50 131 0 181-41.5 41.5-104.5 48.5-153.3 21.1-7.7-4.3-10.4-14.1-6.1-21.8s14.1-10.4 21.8-6.1c36.6 20.6 83.8 15.3 115-15.8 37.5-37.5 37.5-98.3 0-135.8-29.4-29.4-73.2-35.8-108.9-19-10.9 5.2-25.2 1.9-31.8-9.9l-63-111.9c-2.7 .5-5.4 .7-8.2 .7-26.5 0-48-21.5-48-48s21.5-48 48-48zM128 384a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm304-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-45.3 0c6.6-18.6 24.4-32 45.3-32 26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32l-115.7 0c-6.3 49.6-41.5 93.1-92.8 107.3-68.1 18.9-138.7-21-157.6-89.1s21-138.7 89.1-157.6c8.5-2.4 17.3 2.6 19.7 11.1s-2.6 17.3-11.1 19.7c-51.1 14.2-81 67.1-66.8 118.2s67.1 81 118.2 66.8c40.2-11.2 67.3-46.3 70.1-85.6 .9-12 10.7-22.9 24.2-22.9l122.7 0z"]
}, ZF = {
  prefix: "fal",
  iconName: "grid-2",
  icon: [448, 512, [], "e196", "M48 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L48 64zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM48 320c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM400 64l-96 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm0 288c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0zm-48 16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z"]
}, XF = {
  prefix: "fal",
  iconName: "bag-shopping-plus",
  icon: [448, 512, [], "e651", "M160 64l0 64 128 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm160 96L48 160c-8.8 0-16 7.2-16 16l0 208c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-208c0-8.8-7.2-16-16-16l-80 0zM128 128l0-64c0-53 43-96 96-96s96 43 96 96l0 64 80 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 176c0-26.5 21.5-48 48-48l80 0zm80 248l0-56-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0 0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56 56 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56 0 0 56c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
}, JF = {
  prefix: "fal",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M304 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l153.4 0-260.7 260.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6 480 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L304 0zM80 96C35.8 96 0 131.8 0 176L0 432c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-256c0-26.5 21.5-48 48-48l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 96z"]
}, QF = {
  prefix: "fal",
  iconName: "square",
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
}, eL = {
  prefix: "fal",
  iconName: "key-skeleton",
  icon: [448, 512, [128477], "f6f3", "M304 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256c79.5 0 144-64.5 144-144S383.5 0 304 0 160 64.5 160 144c0 34 11.8 65.2 31.5 89.9L4.7 420.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 432 80 390.6 132.7 443.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L102.6 368 214.1 256.5C238.8 276.2 270 288 304 288z"]
}, tL = {
  prefix: "fal",
  iconName: "arrow-down",
  icon: [384, 512, [8595], "f063", "M180.7 507.3c6.2 6.2 16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 457.4 208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 441.4-148.7-148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176z"]
}, nL = {
  prefix: "fal",
  iconName: "location-dot",
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M32 188.6C32 102.6 103.1 32 192 32s160 70.6 160 156.6c0 50.3-25.9 109.4-61.4 165.6-34 53.8-74 100.5-98.6 127.4-24.6-26.9-64.6-73.7-98.6-127.4-35.5-56.2-61.4-115.3-61.4-165.6zM192 0C86 0 0 84.4 0 188.6 0 307.9 120.2 450.9 170.4 505.4 182.2 518.2 201.8 518.2 213.6 505.4 263.8 450.9 384 307.9 384 188.6 384 84.4 298 0 192 0zm48 192a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]
}, rL = {
  prefix: "fal",
  iconName: "grip-dots-vertical",
  icon: [320, 512, [], "e411", "M224 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM256 416c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm64 32c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64 64-28.7 64-64zM64 416c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm64 32c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64 64-28.7 64-64zM32 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM64 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32A64 64 0 1 0 0 64 64 64 0 1 0 128 64z"]
}, oL = {
  prefix: "fal",
  iconName: "arrows-rotate",
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M32.5 241.1C36 188.8 57.7 137.6 97.6 97.6 141.3 53.9 198.6 32 256 32 318 32 377.2 57.5 419.8 102.6L458.9 144 352 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0c8.8 0 16-7.2 16-16l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 103.8-37-39.1C394.4 29.2 326.8 0 256 0 190.5 0 125 25 75 75 29.3 120.6 4.5 179.2 .6 238.9 0 247.8 6.7 255.4 15.5 256s16.4-6.1 17-14.9zm447 29.9c-3.5 52.3-25.2 103.5-65.1 143.4-43.7 43.7-101 65.6-158.4 65.6-62 0-121.2-25.5-163.8-70.6L53.1 368 160 368c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 336c-8.8 0-16 7.2-16 16L0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-103.8 37 39.1c48.6 51.5 116.3 80.6 187 80.6 65.5 0 131-25 181-75 45.6-45.6 70.4-104.3 74.4-164 .6-8.8-6.1-16.4-14.9-17s-16.4 6.1-17 14.9z"]
}, iL = {
  prefix: "fal",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-112c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 96-32 0zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, aL = {
  prefix: "fal",
  iconName: "feather",
  icon: [512, 512, [129718], "f52d", "M325.6 163.8L96 393.4 96 330c0-59.4 23.6-116.4 65.6-158.4L265.4 67.9c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l5.5 5.5c23 23 35.9 54.1 35.9 86.6 0 22.8-6.3 44.9-18 64l-151.3 0 37.6-37.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm-47 92.2l156.1 0-64 64-156.1 0 64-64zm60.1 96c-41.8 41-98.1 64-156.8 64l-63.3 0 64-64 156.1 0zM64 330l0 95.3-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448 182 448c67.9 0 133-27 181-75L466.7 269.3c29-29 45.3-68.3 45.3-109.3S495.7 79.7 466.7 50.7l-5.5-5.5C432.3 16.3 393 0 352 0S271.7 16.3 242.7 45.3L139 149C91 197 64 262.1 64 330z"]
}, sL = {
  prefix: "fal",
  iconName: "cart-shopping",
  icon: [640, 512, [128722, "shopping-cart"], "f07a", "M16 0C7.2 0 0 7.2 0 16S7.2 32 16 32l45.3 0C69 32 75.7 37.5 77 45.1l50.9 279.7c6.2 34.2 36 59.1 70.8 59.1L464 384c8.8 0 16-7.2 16-16s-7.2-16-16-16l-265.3 0c-19.3 0-35.9-13.8-39.4-32.8l-5.7-31.2 313 0c33.9 0 63.3-23.7 70.4-56.9L569.4 80.4C574.8 55.5 555.8 32 530.3 32L106.6 32C99.9 13.1 81.9 0 61.3 0L16 0zm97 64l417.3 0c5.1 0 8.9 4.7 7.8 9.7L505.8 224.4c-4 18.4-20.2 31.6-39.1 31.6L147.9 256 113 64zm75 396a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm72 0a52 52 0 1 0 -104 0 52 52 0 1 0 104 0zm172-20a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0 72a52 52 0 1 0 0-104 52 52 0 1 0 0 104z"]
}, lL = sL, cL = {
  prefix: "fal",
  iconName: "arrow-up-arrow-down",
  icon: [512, 512, ["sort-up-down"], "e099", "M484.7 372.7L400 457.4 400 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 441.4-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm-256-233.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 54.6 112 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-441.4 84.7 84.7z"]
};
/*!
 * Font Awesome Pro 7.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2026 Fonticons, Inc.
 */
var uL = {
  prefix: "far",
  iconName: "ellipsis-vertical",
  icon: [128, 512, ["ellipsis-v"], "f142", "M112 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM16 256c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48zm96 176c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48z"]
};
/*!
 * Font Awesome Pro 7.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2026 Fonticons, Inc.
 */
var dL = {
  prefix: "fas",
  iconName: "dollar-sign",
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M136 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-114.9 0c-24.9 0-45.1 20.2-45.1 45.1 0 22.5 16.5 41.5 38.7 44.7l91.6 13.1c53.8 7.7 93.7 53.7 93.7 108 0 60.3-48.9 109.1-109.1 109.1l-10.9 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-72 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l130.9 0c24.9 0 45.1-20.2 45.1-45.1 0-22.5-16.5-41.5-38.7-44.7l-91.6-13.1C55.9 273.5 16 227.4 16 173.1 16 112.9 64.9 64 125.1 64l10.9 0 0-40z"]
}, fL = {
  prefix: "fas",
  iconName: "minus",
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z"]
}, mL = {
  prefix: "fas",
  iconName: "at",
  icon: [512, 512, [61946], "40", "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0 512 114.6 512 256l0 32c0 53-43 96-96 96-29.3 0-55.6-13.2-73.2-33.9-22.8 21-53.3 33.9-86.8 33.9-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1 5.7-5 13.1-8.1 21.3-8.1 17.7 0 32 14.3 32 32l0 112c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
}, pL = {
  prefix: "fas",
  iconName: "truck",
  icon: [576, 512, [128666, 9951], "f0d1", "M0 96C0 60.7 28.7 32 64 32l288 0c35.3 0 64 28.7 64 64l0 32 50.7 0c17 0 33.3 6.7 45.3 18.7L557.3 192c12 12 18.7 28.3 18.7 45.3L576 384c0 35.3-28.7 64-64 64l-3.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-102.6 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64L64 448c-35.3 0-64-28.7-64-64L0 96zM512 288l0-50.7-45.3-45.3-50.7 0 0 96 96 0zM192 424a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm232 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
}, hL = {
  prefix: "fas",
  iconName: "bell",
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32l0 3.2C119 50 64 114.6 64 192l0 21.7c0 48.1-16.4 94.8-46.4 132.4L7.8 358.3C2.7 364.6 0 372.4 0 380.5 0 400.1 15.9 416 35.5 416l376.9 0c19.6 0 35.5-15.9 35.5-35.5 0-8.1-2.7-15.9-7.8-22.2l-9.8-12.2C400.4 308.5 384 261.8 384 213.7l0-21.7c0-77.4-55-142-128-156.8l0-3.2c0-17.7-14.3-32-32-32zM162 464c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48l-124 0z"]
}, gL = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, vL = {
  prefix: "fas",
  iconName: "badge-percent",
  icon: [512, 512, [], "f646", "M256 0C292.8 0 324.8 20.7 340.9 51.1 373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"]
}, yL = {
  prefix: "fas",
  iconName: "paintbrush",
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M480.5 10.3L259.1 158c-29.1 19.4-47.6 50.9-50.6 85.3 62.3 12.8 111.4 61.9 124.3 124.3 34.5-3 65.9-21.5 85.3-50.6L565.7 95.5c6.7-10.1 10.3-21.9 10.3-34.1 0-33.9-27.5-61.4-61.4-61.4-12.1 0-24 3.6-34.1 10.3zM288 400c0-61.9-50.1-112-112-112S64 338.1 64 400c0 3.9 .2 7.8 .6 11.6 1.8 17.5-10.2 36.4-27.8 36.4L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112z"]
}, bL = yL, SL = {
  prefix: "fas",
  iconName: "receipt",
  icon: [384, 512, [129534], "f543", "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.2-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6S384 14.6 384 24l0 464c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6l-40.4-34.6-40.4 34.6c-9 7.7-22.2 7.7-31.2 0l-40.4-34.6-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488L0 24C0 14.6 5.5 6.1 14 2.2zM104 136c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0zM80 352c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm24-120c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z"]
}, xL = {
  prefix: "fas",
  iconName: "hexagon-plus",
  icon: [576, 512, ["plus-hexagon"], "f300", "M33.5 291.8c-12.7-22.2-12.7-49.4 0-71.5L129.7 52.2C142.5 29.8 166.4 16 192.2 16l191.6 0c25.8 0 49.7 13.8 62.5 36.2l96.2 168.1c12.7 22.2 12.7 49.4 0 71.5L446.3 459.9c-12.8 22.4-36.7 36.2-62.5 36.2l-191.6 0c-25.8 0-49.7-13.8-62.5-36.2L33.5 291.8zM264 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
}, CL = {
  prefix: "fas",
  iconName: "flask",
  icon: [448, 512, [], "f0c3", "M288 0L128 0C110.3 0 96 14.3 96 32s14.3 32 32 32L128 215.5 7.5 426.3C2.6 435 0 444.7 0 454.7 0 486.4 25.6 512 57.3 512l333.4 0c31.6 0 57.3-25.6 57.3-57.3 0-10-2.6-19.8-7.5-28.4L320 215.5 320 64c17.7 0 32-14.3 32-32S337.7 0 320 0L288 0zM192 215.5l0-151.5 64 0 0 151.5c0 11.1 2.9 22.1 8.4 31.8l41.6 72.7-164 0 41.6-72.7c5.5-9.7 8.4-20.6 8.4-31.8z"]
}, wL = {
  prefix: "fas",
  iconName: "database",
  icon: [448, 512, [], "f1c0", "M448 205.8c-14.8 9.8-31.8 17.7-49.5 24-47 16.8-108.7 26.2-174.5 26.2S96.4 246.5 49.5 229.8c-17.6-6.3-34.7-14.2-49.5-24L0 288c0 44.2 100.3 80 224 80s224-35.8 224-80l0-82.2zm0-77.8l0-48C448 35.8 347.7 0 224 0S0 35.8 0 80l0 48c0 44.2 100.3 80 224 80s224-35.8 224-80zM398.5 389.8C351.6 406.5 289.9 416 224 416S96.4 406.5 49.5 389.8c-17.6-6.3-34.7-14.2-49.5-24L0 432c0 44.2 100.3 80 224 80s224-35.8 224-80l0-66.2c-14.8 9.8-31.8 17.7-49.5 24z"]
}, EL = {
  prefix: "fas",
  iconName: "square-check",
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM342 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L189.1 315.2 137 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.9 7.5 18.8 7s13.4-4.1 17.5-9.8L347.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z"]
}, IL = {
  prefix: "fas",
  iconName: "code",
  icon: [576, 512, [], "f121", "M360.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm64.6 136.1c-12.5 12.5-12.5 32.8 0 45.3l73.4 73.4-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zm-274.7 0c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 150.6 182.6c12.5-12.5 12.5-32.8 0-45.3z"]
}, RL = {
  prefix: "fas",
  iconName: "sparkles",
  icon: [576, 512, [10024], "f890", "M391.5 53.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L448 96 469.2 152.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L512 96 568.5 74.8c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L512 32 490.8-24.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L448 32 391.5 53.2zm-185 20.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-53.1 115-115 53.1C3.6 244.1 0 249.8 0 256s3.6 11.9 9.3 14.5l115 53.1 53.1 115c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l53.1-115 115-53.1c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-115-53.1-53.1-115zM416 416l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 480 437.2 536.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 480 536.5 458.8c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 416 458.8 359.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 416z"]
}, TL = {
  prefix: "fas",
  iconName: "box-check",
  icon: [448, 512, [], "f467", "M335.1 16c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.7 10.8 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64l-320 0-6.5-.3C25.2 476.4 0 449.1 0 416L0 148.5c0-11.7 3.2-23.1 9.2-33l2.7-4.2 48.9-68.5c10.5-14.7 26.7-24.2 44.4-26.3l7.7-.5 222.1 0zM314.9 212.6c-10.7-7.8-25.7-5.4-33.5 5.3l-85.6 117.7-26.5-27.4c-9.2-9.5-24.4-9.8-33.9-.6s-9.8 24.4-.6 33.9l46.4 48c4.9 5.1 11.8 7.8 18.9 7.3s13.6-4.1 17.8-9.8L320.2 246.1c7.8-10.7 5.4-25.7-5.3-33.5zM78.7 128l121.3 0 0-48-87.1 0-34.3 48zM248 128l121.3 0-34.3-48-87.1 0 0 48z"]
}, _L = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-192a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-192c-18.2 0-32.7 15.5-31.4 33.7l7.4 104c.9 12.6 11.4 22.3 23.9 22.3 12.6 0 23-9.7 23.9-22.3l7.4-104c1.3-18.2-13.1-33.7-31.4-33.7z"]
}, OL = {
  prefix: "fas",
  iconName: "rectangle-history",
  icon: [512, 512, [], "e4a2", "M512 272c0-35.3-28.7-64-64-64L64 208c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-144zM440 104L72 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM392 0L120 0C106.7 0 96 10.7 96 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24S405.3 0 392 0z"]
}, AL = {
  prefix: "fas",
  iconName: "building",
  icon: [384, 512, [127970, 61687], "f1ad", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM176 352l32 0c17.7 0 32 14.3 32 32l0 80-96 0 0-80c0-17.7 14.3-32 32-32zM96 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM240 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm144-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"]
}, kL = {
  prefix: "fas",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M195.1 9.5C198.1-5.3 211.2-16 226.4-16l59.8 0c15.2 0 28.3 10.7 31.3 25.5L332 79.5c14.1 6 27.3 13.7 39.3 22.8l67.8-22.5c14.4-4.8 30.2 1.2 37.8 14.4l29.9 51.8c7.6 13.2 4.9 29.8-6.5 39.9L447 233.3c.9 7.4 1.3 15 1.3 22.7s-.5 15.3-1.3 22.7l53.4 47.5c11.4 10.1 14 26.8 6.5 39.9l-29.9 51.8c-7.6 13.1-23.4 19.2-37.8 14.4l-67.8-22.5c-12.1 9.1-25.3 16.7-39.3 22.8l-14.4 69.9c-3.1 14.9-16.2 25.5-31.3 25.5l-59.8 0c-15.2 0-28.3-10.7-31.3-25.5l-14.4-69.9c-14.1-6-27.2-13.7-39.3-22.8L73.5 432.3c-14.4 4.8-30.2-1.2-37.8-14.4L5.8 366.1c-7.6-13.2-4.9-29.8 6.5-39.9l53.4-47.5c-.9-7.4-1.3-15-1.3-22.7s.5-15.3 1.3-22.7L12.3 185.8c-11.4-10.1-14-26.8-6.5-39.9L35.7 94.1c7.6-13.2 23.4-19.2 37.8-14.4l67.8 22.5c12.1-9.1 25.3-16.7 39.3-22.8L195.1 9.5zM256.3 336a80 80 0 1 0 -.6-160 80 80 0 1 0 .6 160z"]
}, DL = kL, PL = {
  prefix: "fas",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-336c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 47.2-36 67.2-56 74.5l0 3.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8.1c0-20.5 14.8-35.2 30.1-40.2 6.4-2.1 13.2-5.5 18.2-10.3 4.3-4.2 7.7-10 7.7-19.6 0-17.7-14.3-32-32-32zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, NL = PL, ML = {
  prefix: "fas",
  iconName: "shirt",
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M320.2 112c44.2 0 80-35.8 80-80l53.5 0c17 0 33.3 6.7 45.3 18.7L617.6 169.4c12.5 12.5 12.5 32.8 0 45.3l-50.7 50.7c-12.5 12.5-32.8 12.5-45.3 0l-41.4-41.4 0 224c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-224-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0L22.9 214.6c-12.5-12.5-12.5-32.8 0-45.3L141.5 50.7c12-12 28.3-18.7 45.3-18.7l53.5 0c0 44.2 35.8 80 80 80z"]
}, FL = {
  prefix: "fas",
  iconName: "bell-concierge",
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.3C124.8 156.7 40.2 243.7 32.6 352l446.9 0C471.8 243.7 387.2 156.7 280 145.3l0-33.3 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 400z"]
}, LL = FL, fb = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"]
}, $L = {
  prefix: "fas",
  iconName: "hat-wizard",
  icon: [512, 512, [], "f6e8", "M64 400l85.7-208.2c17-41.3 47.8-75.3 87.2-96.3L383.8 17.2c12.3-6.6 26.5 4.7 23 18.2L369.6 177.8c-1.1 4.1-1.6 8.3-1.6 12.6 0 6.3 1.2 12.6 3.6 18.5l76.4 191.1-207.1 0 11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 260.4 230.9 256 224 256s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 323 144 329.1 144 336s4.4 13 10.9 15.2l40.4 13.5 11.8 35.4-143.1 0zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
}, zL = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z"]
}, jL = {
  prefix: "fas",
  iconName: "tags",
  icon: [576, 512, [], "f02c", "M401.2 39.1L549.4 189.4c27.7 28.1 27.7 73.1 0 101.2L393 448.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L515.3 256.8c9.2-9.3 9.2-24.4 0-33.7L367 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM32.1 229.5L32.1 96c0-35.3 28.7-64 64-64l133.5 0c17 0 33.3 6.7 45.3 18.7l144 144c25 25 25 65.5 0 90.5L285.4 418.7c-25 25-65.5 25-90.5 0l-144-144c-12-12-18.7-28.3-18.7-45.3zm144-85.5a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, D3 = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM374 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L221.1 315.2 169 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8L379.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z"]
}, BL = D3, GL = {
  prefix: "fas",
  iconName: "address-book",
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM208 288l64 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-24-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm0 128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 320c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z"]
}, VL = {
  prefix: "fas",
  iconName: "list",
  icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"]
}, UL = {
  prefix: "fas",
  iconName: "badge-check",
  icon: [512, 512, [], "f336", "M256 0C292.8 0 324.8 20.7 340.9 51.1 373.8 41 411 48.9 437 75s34 63.3 23.9 96.2C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.2 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.2C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 48.9 101 75 75s63.3-34 96.2-23.9C187.2 20.7 219.2 0 256 0zm90.9 164.6c-10.7-7.8-25.7-5.4-33.5 5.3l-85.6 117.7-26.5-27.4c-9.2-9.5-24.4-9.8-33.9-.6s-9.8 24.4-.6 33.9l46.4 48c4.9 5.1 11.8 7.8 18.9 7.3s13.6-4.1 17.8-9.8L352.2 198.1c7.8-10.7 5.4-25.7-5.3-33.5z"]
}, WL = {
  prefix: "fas",
  iconName: "plug-circle-plus",
  icon: [640, 512, [], "e55f", "M192-32c17.7 0 32 14.3 32 32l0 96 128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7C165.2 398.1 96 319.1 96 224l0-64c-17.7 0-32-14.3-32-32S78.3 96 96 96l64 0 0-96c0-17.7 14.3-32 32-32zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"]
}, HL = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 0c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5S486.1 480 472 480L40 480c-14.1 0-27.2-7.4-34.4-19.5s-7.5-27.1-.8-39.5l216-400c7-12.9 20.5-21 35.2-21zm0 352a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-192c-18.2 0-32.7 15.5-31.4 33.7l7.4 104c.9 12.5 11.4 22.3 23.9 22.3 12.6 0 23-9.7 23.9-22.3l7.4-104c1.3-18.2-13.1-33.7-31.4-33.7z"]
}, qL = {
  prefix: "fas",
  iconName: "store",
  icon: [512, 512, [], "f54e", "M30.7 72.3C37.6 48.4 59.5 32 84.4 32l344 0c24.9 0 46.8 16.4 53.8 40.3l23.4 80.2c12.8 43.7-20.1 87.5-65.6 87.5-26.3 0-49.4-14.9-60.8-37.1-11.6 21.9-34.6 37.1-61.4 37.1-26.6 0-49.7-15-61.3-37-11.6 22-34.7 37-61.3 37-26.8 0-49.8-15.1-61.4-37.1-11.4 22.1-34.5 37.1-60.8 37.1-45.6 0-78.4-43.7-65.6-87.5L30.7 72.3zM96.4 352l320 0 0-66.4c7.6 1.6 15.5 2.4 23.5 2.4 14.3 0 28-2.6 40.5-7.2l0 151.2c0 26.5-21.5 48-48 48l-352 0c-26.5 0-48-21.5-48-48l0-151.2c12.5 4.6 26.1 7.2 40.5 7.2 8.1 0 15.9-.8 23.5-2.4l0 66.4z"]
}, YL = {
  prefix: "fas",
  iconName: "user-group-simple",
  icon: [576, 512, [], "e603", "M48 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM0 432c0-79.5 64.5-144 144-144s144 64.5 144 144l0 38c0 23.2-18.8 42-42 42L42 512c-23.2 0-42-18.8-42-42l0-38zM432 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 480c-37 0-70.7-13.9-96.1-36.8 .1-1.7 .1-3.5 .1-5.2l0-38c0-46.1-16.2-88.3-43.3-121.4 7-13.4 21.1-22.6 37.3-22.6l204 0c23.2 0 42 18.8 42 42l0 38c0 79.5-64.5 144-144 144z"]
}, KL = {
  prefix: "fas",
  iconName: "arrow-right-arrow-left",
  icon: [512, 512, [8644, "exchange"], "f0ec", "M502.6 150.6l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 160 32 160c-17.7 0-32-14.3-32-32S14.3 96 32 96l370.7 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3zm-397.3 352l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 352 480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32l-370.7 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"]
}, ZL = KL, XL = {
  prefix: "fas",
  iconName: "box",
  icon: [448, 512, [128230], "f466", "M335.1 16c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.7 10.8 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64l-320 0-6.5-.3C25.2 476.4 0 449.1 0 416L0 148.5c0-11.7 3.2-23.1 9.2-33l2.7-4.2 48.9-68.5c10.5-14.7 26.7-24.2 44.4-26.3l7.7-.5 222.1 0zM248 128l121.3 0-34.3-48-87.1 0 0 48zM78.7 128l121.3 0 0-48-87.1 0-34.3 48z"]
}, JL = {
  prefix: "fas",
  iconName: "chart-pie-simple",
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M304 240l176 0c17.7 0 32.2-14.4 29.9-31.9-14.2-107-99-191.7-206-206-17.5-2.3-31.9 12.2-31.9 29.9l0 176c0 17.7 14.3 32 32 32zM224 66.7c0-18.5-15.7-33.3-33.8-29.5-108.6 22.9-190.2 119.4-190.2 234.8 0 132.5 107.5 240 240 240 115.5 0 211.9-81.5 234.8-190.2 3.8-18.1-11-33.8-29.5-33.8L248 288c-13.3 0-24-10.7-24-24l0-197.3z"]
}, QL = {
  prefix: "fas",
  iconName: "grid-2",
  icon: [448, 512, [], "e196", "M192 80c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zm0 256c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zM256 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM448 336c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96z"]
}, e$ = {
  prefix: "fas",
  iconName: "bag-shopping-plus",
  icon: [448, 512, [], "e651", "M224 16c-35.3 0-64 28.7-64 64l0 48 128 0 0-48c0-35.3-28.7-64-64-64zM48 128l64 0 0-48c0-61.9 50.1-112 112-112S336 18.1 336 80l0 48 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 176c0-26.5 21.5-48 48-48zm176 80c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"]
}, t$ = {
  prefix: "fas",
  iconName: "key-skeleton",
  icon: [448, 512, [128477], "f6f3", "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224c79.5 0 144-64.5 144-144S383.5 0 304 0 160 64.5 160 144c0 28.2 8.1 54.5 22.1 76.7L9.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 416 96 397.3 137.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-41.4-41.4 86.1-86.1c22.2 14 48.5 22.1 76.7 22.1z"]
}, n$ = {
  prefix: "fas",
  iconName: "grip-dots-vertical",
  icon: [320, 512, [], "e411", "M128 64A64 64 0 1 0 0 64 64 64 0 1 0 128 64zm0 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM0 448c0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64-64 28.7-64 64zM320 64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM320 448c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64 64-28.7 64-64z"]
}, r$ = {
  prefix: "fas",
  iconName: "circle-dot",
  icon: [512, 512, [128280, "dot-circle"], "f192", "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
}, o$ = {
  prefix: "fas",
  iconName: "feather",
  icon: [512, 512, [129718], "f52d", "M352 0c41 0 80.3 16.3 109.2 45.2l5.5 5.5c29 29 45.3 68.3 45.3 109.2 0 24.1-5.7 47.6-16.2 68.8-1.9 3.7-5.3 6.5-9.3 7.7L374.5 270c-3.9 1.2-6.5 4.7-6.5 8.8 0 5.1 4.1 9.2 9.2 9.2l32.2 0c14.3 0 21.4 17.2 11.3 27.3l-22.4 22.4c-1.9 1.9-4.2 3.2-6.7 4l-81 24.3c-3.9 1.2-6.5 4.7-6.5 8.8 0 5.1 4.1 9.2 9.2 9.2 13.2 0 18.9 15.7 7.8 22.9-41.1 26.6-89.3 41.1-139 41.1l-86 0-48 48c-8.8 8.8-23.2 8.8-32 0s-8.8-23.2 0-32L256 224c8.8-8.8 8.8-23.2 0-32s-23.2-8.8-32 0L79.5 336.5c-5.7 5.7-15.5 1.7-15.5-6.4 0-67.9 27-133 75-181L242.8 45.2C271.7 16.3 311 0 352 0z"]
}, i$ = {
  prefix: "fas",
  iconName: "cart-shopping",
  icon: [640, 512, [128722, "shopping-cart"], "f07a", "M24-16C10.7-16 0-5.3 0 8S10.7 32 24 32l45.3 0c3.9 0 7.2 2.8 7.9 6.6l52.1 286.3c6.2 34.2 36 59.1 70.8 59.1L456 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-255.9 0c-11.6 0-21.5-8.3-23.6-19.7l-5.1-28.3 303.6 0c30.8 0 57.2-21.9 62.9-52.2L568.9 69.9C572.6 50.2 557.5 32 537.4 32l-412.7 0-.4-2c-4.8-26.6-28-46-55.1-46L24-16zM208 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm224 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
}, a$ = i$;
function s$(e) {
  return e = e - 0, e === e;
}
function P3(e) {
  return s$(e) ? e : (e = e.replace(/[_-]+(.)?/g, (t, n) => n ? n.toUpperCase() : ""), e.charAt(0).toLowerCase() + e.slice(1));
}
var l$ = (e, t) => H.createElement("stop", {
  key: `${t}-${e.offset}`,
  offset: e.offset,
  stopColor: e.color,
  ...e.opacity !== void 0 && { stopOpacity: e.opacity }
});
function c$(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var ms = /* @__PURE__ */ new Map(), u$ = 1e3;
function d$(e) {
  if (ms.has(e))
    return ms.get(e);
  const t = {};
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const o = e.indexOf(";", n), i = o === -1 ? r : o, a = e.slice(n, i).trim();
    if (a) {
      const s = a.indexOf(":");
      if (s > 0) {
        const l = a.slice(0, s).trim(), c = a.slice(s + 1).trim();
        if (l && c) {
          const u = P3(l);
          t[u.startsWith("webkit") ? c$(u) : u] = c;
        }
      }
    }
    n = i + 1;
  }
  if (ms.size === u$) {
    const o = ms.keys().next().value;
    o && ms.delete(o);
  }
  return ms.set(e, t), t;
}
function N3(e, t, n = {}) {
  if (typeof t == "string")
    return t;
  const r = (t.children || []).map((d) => {
    let m = d;
    return ("fill" in n || n.gradientFill) && d.tag === "path" && "fill" in d.attributes && (m = {
      ...d,
      attributes: {
        ...d.attributes,
        fill: void 0
      }
    }), N3(e, m);
  }), o = t.attributes || {}, i = {};
  for (const [d, m] of Object.entries(o))
    switch (!0) {
      case d === "class": {
        i.className = m;
        break;
      }
      case d === "style": {
        i.style = d$(String(m));
        break;
      }
      case d.startsWith("aria-"):
      case d.startsWith("data-"): {
        i[d.toLowerCase()] = m;
        break;
      }
      default:
        i[P3(d)] = m;
    }
  const {
    style: a,
    role: s,
    "aria-label": l,
    gradientFill: c,
    ...u
  } = n;
  if (a && (i.style = i.style ? { ...i.style, ...a } : a), s && (i.role = s), l && (i["aria-label"] = l, i["aria-hidden"] = "false"), c) {
    i.fill = `url(#${c.id})`;
    const {
      type: d,
      stops: m = [],
      ...h
    } = c;
    r.unshift(
      e(
        d === "linear" ? "linearGradient" : "radialGradient",
        {
          ...h,
          id: c.id
        },
        m.map(l$)
      )
    );
  }
  return e(t.tag, { ...i, ...u }, ...r);
}
var f$ = N3.bind(null, H.createElement), mb = (e, t) => {
  const n = oi();
  return e || (t ? n : void 0);
}, m$ = class {
  constructor(e = "react-fontawesome") {
    var n;
    this.enabled = !1;
    let t = !1;
    try {
      t = typeof process < "u" && ((n = process.env) == null ? void 0 : n.NODE_ENV) === "development";
    } catch {
    }
    this.scope = e, this.enabled = t;
  }
  /**
   * Logs messages to the console if not in production.
   * @param args - The message and/or data to log.
   */
  log(...e) {
    this.enabled && console.log(`[${this.scope}]`, ...e);
  }
  /**
   * Logs warnings to the console if not in production.
   * @param args - The warning message and/or data to log.
   */
  warn(...e) {
    this.enabled && console.warn(`[${this.scope}]`, ...e);
  }
  /**
   * Logs errors to the console if not in production.
   * @param args - The error message and/or data to log.
   */
  error(...e) {
    this.enabled && console.error(`[${this.scope}]`, ...e);
  }
}, JS;
typeof process < "u" && ((JS = process.env) != null && JS.FA_VERSION);
var p$ = (
  // @ts-expect-error TS2872 - Expression is always truthy - This is true when v7 of SVGCore is used, but not when v6 is used.
  // This is the point of this check - if the property exists on config, we have v7, otherwise we have v6.
  // TS is checking this against the dev dependencies which uses v7, so it reports a false error here.
  "searchPseudoElementsFullScan" in La && typeof La.searchPseudoElementsFullScan == "boolean" ? "7.0.0" : "6.0.0"
), h$ = Number.parseInt(p$) >= 7, g$ = () => h$, sc = "fa", En = {
  beat: "fa-beat",
  fade: "fa-fade",
  beatFade: "fa-beat-fade",
  bounce: "fa-bounce",
  shake: "fa-shake",
  spin: "fa-spin",
  spinPulse: "fa-spin-pulse",
  spinReverse: "fa-spin-reverse",
  pulse: "fa-pulse",
  // the following animations are only supported in version 7.3.0 and later
  flip360: "fa-flip-360",
  buzz: "fa-buzz",
  float: "fa-float",
  jello: "fa-jello",
  spinSnap: "fa-spin-snap",
  spinSnap4: "fa-spin-snap-4",
  spinSnap8: "fa-spin-snap-8",
  swing: "fa-swing",
  wag: "fa-wag"
}, v$ = {
  left: "fa-pull-left",
  right: "fa-pull-right"
}, y$ = {
  90: "fa-rotate-90",
  180: "fa-rotate-180",
  270: "fa-rotate-270"
}, b$ = {
  "2xs": "fa-2xs",
  xs: "fa-xs",
  sm: "fa-sm",
  lg: "fa-lg",
  xl: "fa-xl",
  "2xl": "fa-2xl",
  "1x": "fa-1x",
  "2x": "fa-2x",
  "3x": "fa-3x",
  "4x": "fa-4x",
  "5x": "fa-5x",
  "6x": "fa-6x",
  "7x": "fa-7x",
  "8x": "fa-8x",
  "9x": "fa-9x",
  "10x": "fa-10x"
}, Xr = {
  border: "fa-border",
  /** @deprecated */
  fixedWidth: "fa-fw",
  flip: "fa-flip",
  flipHorizontal: "fa-flip-horizontal",
  flipVertical: "fa-flip-vertical",
  inverse: "fa-inverse",
  rotateBy: "fa-rotate-by",
  swapOpacity: "fa-swap-opacity",
  widthAuto: "fa-width-auto",
  // the following style classes are only supported in version 7.3.0 and later
  canvasSquare: "fa-canvas-square",
  canvasRoomy: "fa-canvas-roomy"
};
function S$(e) {
  const t = La.cssPrefix || La.familyPrefix || sc;
  return t === sc ? e : e.replace(
    new RegExp(String.raw`(?<=^|\s)${sc}-`, "g"),
    `${t}-`
  );
}
function x$(e) {
  const {
    beat: t,
    fade: n,
    beatFade: r,
    bounce: o,
    shake: i,
    spin: a,
    spinPulse: s,
    spinReverse: l,
    pulse: c,
    fixedWidth: u,
    inverse: d,
    border: m,
    flip: h,
    size: v,
    rotation: g,
    pull: x,
    swapOpacity: b,
    rotateBy: C,
    widthAuto: I,
    canvasSquare: T,
    canvasRoomy: R,
    flip360: A,
    buzz: _,
    float: k,
    jello: M,
    spinSnap: j,
    spinSnap4: G,
    spinSnap8: U,
    swing: B,
    wag: K,
    className: ee
  } = e, Y = [];
  return ee && Y.push(...ee.split(" ")), t && Y.push(En.beat), n && Y.push(En.fade), r && Y.push(En.beatFade), o && Y.push(En.bounce), i && Y.push(En.shake), a && Y.push(En.spin), l && Y.push(En.spinReverse), s && Y.push(En.spinPulse), c && Y.push(En.pulse), u && Y.push(Xr.fixedWidth), d && Y.push(Xr.inverse), m && Y.push(Xr.border), h === !0 && Y.push(Xr.flip), (h === "horizontal" || h === "both") && Y.push(Xr.flipHorizontal), (h === "vertical" || h === "both") && Y.push(Xr.flipVertical), v != null && Y.push(b$[v]), g != null && g !== 0 && Y.push(y$[g]), x != null && Y.push(v$[x]), b && Y.push(Xr.swapOpacity), g$() ? (C && Y.push(Xr.rotateBy), I && Y.push(Xr.widthAuto), T && Y.push(Xr.canvasSquare), R && Y.push(Xr.canvasRoomy), A && Y.push(En.flip360), _ && Y.push(En.buzz), k && Y.push(En.float), M && Y.push(En.jello), j && Y.push(En.spinSnap), G && Y.push(En.spinSnap4), U && Y.push(En.spinSnap8), B && Y.push(En.swing), K && Y.push(En.wag), (La.cssPrefix || La.familyPrefix || sc) === sc ? Y : (
    // TODO: see if we can achieve custom prefix support without iterating
    // eslint-disable-next-line unicorn/no-array-callback-reference
    Y.map(S$)
  )) : Y;
}
var C$ = (e) => typeof e == "object" && "icon" in e && !!e.icon;
function pb(e) {
  if (e)
    return C$(e) ? e : m3.icon(e);
}
function w$(e) {
  return Object.keys(e);
}
var hb = new m$("FontAwesomeIcon"), M3 = {
  border: !1,
  className: "",
  mask: void 0,
  maskId: void 0,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: void 0,
  listItem: !1,
  pull: void 0,
  pulse: !1,
  rotation: void 0,
  rotateBy: !1,
  size: void 0,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: void 0,
  transform: void 0,
  swapOpacity: !1,
  widthAuto: !1,
  canvasSquare: !1,
  canvasRoomy: !1,
  flip360: !1,
  buzz: !1,
  float: !1,
  jello: !1,
  spinSnap: !1,
  spinSnap4: !1,
  spinSnap8: !1,
  swing: !1,
  wag: !1
}, E$ = new Set(Object.keys(M3)), F3 = H.forwardRef((e, t) => {
  const n = { ...M3, ...e }, {
    icon: r,
    mask: o,
    symbol: i,
    title: a,
    titleId: s,
    maskId: l,
    transform: c
  } = n, u = mb(l, !!o), d = mb(s, !!a), m = pb(r);
  if (!m)
    return hb.error("Icon lookup is undefined", r), null;
  const h = x$(n), v = typeof c == "string" ? m3.transform(c) : c, g = pb(o), x = iM(m, {
    ...h.length > 0 && { classes: h },
    ...v && { transform: v },
    ...g && { mask: g },
    symbol: i,
    title: a,
    titleId: d,
    maskId: u
  });
  if (!x)
    return hb.error("Could not find icon", m), null;
  const { abstract: b } = x, C = { ref: t };
  for (const I of w$(n))
    E$.has(I) || (C[I] = n[I]);
  return f$(b[0], C);
});
F3.displayName = "FontAwesomeIcon";
const I$ = It(
  (e, t) => (
    // pencil icon from HeroIcons; https://heroicons.com/
    /* @__PURE__ */ f.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        "aria-hidden": "true",
        ...e,
        ref: t,
        children: /* @__PURE__ */ f.jsx(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
          }
        )
      }
    )
  )
), R$ = {
  // Actions
  add: GF,
  remove: cF,
  edit: I$,
  // edit: faPen,
  close: bF,
  duplicate: L9,
  undo: HF,
  refresh: oL,
  download: z9,
  downloadFile: p9,
  upload: y9,
  // navigation
  chevronUp: N9,
  chevronRight: $9,
  chevronDown: TF,
  chevronLeft: kF,
  arrowLeft: BF,
  arrowRight: vF,
  externalLink: JF,
  overflowMenu: uL,
  overflowMenuHorizontal: I9,
  // ui primitives
  check: mF,
  minus: g9,
  calendar: fF,
  // search
  search: R9,
  searchSolid: gL,
  // status
  success: BL,
  error: _L,
  warning: HL,
  info: iL,
  pending: F9,
  // identity / warranty / proof verification - distinct from `success`
  verified: _F,
  // ? maybe rename or alias for warranty
  // loading spinner - the only duotone usage
  spinner: A3,
  // inline status (light - paired with text, less heavy than solid badges)
  successInline: CF,
  warningInline: PF,
  errorInline: Z9,
  // visibility
  eye: k9,
  eyeSlash: UF,
  // commerce
  store: NF,
  storeSolid: qL,
  order: lL,
  orderSolid: a$,
  box: VF,
  boxSolid: XL,
  product: lF,
  database: B9,
  databaseSolid: wL,
  productSolid: ML,
  productGroup: K9,
  productGroupSolid: TL,
  shipment: S9,
  shipmentSolid: pL,
  warehouse: w9,
  tag: YF,
  tags: SF,
  tagsSolid: jL,
  exchange: $F,
  exchangeSolid: ZL,
  discount: _9,
  discountSolid: vL,
  dollar: f9,
  dollarSolid: dL,
  calculator: h9,
  fee: U9,
  giftCard: RF,
  gift: E9,
  payment: AF,
  receipt: P9,
  receiptSolid: SL,
  shopNow: XF,
  shopNowSolid: e$,
  // people
  customer: J9,
  users: FF,
  usersSolid: YL,
  accounts: b9,
  accountsSolid: mL,
  organization: tF,
  organizationSolid: AL,
  // features
  registration: wF,
  registrationSolid: GL,
  automation: pF,
  automationSolid: $L,
  branch: EF,
  rule: IF,
  ruleSolid: VL,
  dashboard: ZF,
  dashboardSolid: QL,
  analytics: qF,
  analyticsSolid: JL,
  concierge: dF,
  conciergeSolid: LL,
  customFields: aL,
  customFieldsSolid: o$,
  apiKey: eL,
  apiKeySolid: t$,
  webhook: KF,
  developer: q9,
  developerSolid: IL,
  integration: M9,
  integrationSolid: xL,
  plugins: OF,
  pluginsSolid: WL,
  testDrive: j9,
  testDriveSolid: CL,
  branding: A9,
  brandingSolid: bL,
  history: eF,
  historySolid: OL,
  globe: jF,
  location: nL,
  email: v9,
  message: C9,
  bell: x9,
  bellSolid: hL,
  settings: rF,
  settingsSolid: DL,
  filters: hF,
  positiveFeedback: Q9,
  lightbulb: H9,
  help: iF,
  helpSolid: NL,
  verifiedSolid: UL,
  // ? maybe rename or alias for warranty
  // AI / decorative
  ai: RL,
  aiInline: Y9,
  aiWand: DF,
  // files / media
  file: aF,
  filePdf: zF,
  image: W9,
  imageBroken: gF,
  // lock / auth
  lock: MF,
  lockKey: T9,
  // misc
  dot: k3,
  // drag and drop
  grip: rL,
  gripSolid: n$,
  // carriers / brands
  shopify: c9,
  fedex: s9,
  ups: a9,
  usps: d9,
  dhl: l9,
  canadaPost: u9
};
function Ve({
  icon: e,
  className: t,
  accessibilityLabel: n
}) {
  const r = typeof e == "string" ? R$[e] : e;
  return "$$typeof" in r || typeof r == "function" ? /* @__PURE__ */ f.jsx(
    r,
    {
      "aria-label": n,
      "data-icon-type": "svg",
      className: oe("size-3.5", t)
    }
  ) : /* @__PURE__ */ f.jsx(
    F3,
    {
      "aria-label": n,
      "data-icon-type": "fontawesome",
      icon: r,
      className: oe("size-3.5", t)
    }
  );
}
function J1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ f.jsx(
    Ve,
    {
      icon: A3,
      className: oe("size-5 animate-spin text-current", e),
      ...t
    }
  );
}
function L3(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = L3(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function T$() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = L3(e)) && (r && (r += " "), r += t);
  return r;
}
const gb = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, vb = T$, qr = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return vb(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, a = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = i == null ? void 0 : i[c];
    if (u === null) return null;
    const m = gb(u) || gb(d);
    return o[c][m];
  }), s = n && Object.entries(n).reduce((c, u) => {
    let [d, m] = u;
    return m === void 0 || (c[d] = m), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: m, ...h } = u;
    return Object.entries(h).every((v) => {
      let [g, x] = v;
      return Array.isArray(x) ? x.includes({
        ...i,
        ...s
      }[g]) : {
        ...i,
        ...s
      }[g] === x;
    }) ? [
      ...c,
      d,
      m
    ] : c;
  }, []);
  return vb(e, a, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, _$ = qr(
  "inline-flex items-center gap-1 rounded-md px-2.5 py-1 text-xs transition-colors",
  {
    variants: {
      variant: {
        default: "bg-neutral-200 text-neutral-800",
        warning: "bg-amber-100 text-amber-700",
        success: "bg-emerald-100 text-emerald-800",
        danger: "bg-red-100 text-red-800",
        info: "bg-corso-blue-100 text-corso-blue-800"
      },
      hoverable: { true: null }
      // providing a variant to be used as part of a compound variant
    },
    compoundVariants: [
      {
        variant: "default",
        hoverable: !0,
        className: "hover:bg-neutral-300"
      },
      {
        variant: "warning",
        hoverable: !0,
        className: "hover:bg-amber-200"
      },
      {
        variant: "success",
        hoverable: !0,
        className: "hover:bg-emerald-200"
      },
      {
        variant: "danger",
        hoverable: !0,
        className: "hover:bg-red-300"
      },
      {
        variant: "info",
        hoverable: !0,
        className: "hover:bg-corso-blue-400"
      }
    ],
    defaultVariants: {
      variant: "default",
      hoverable: !1
    }
  }
), ka = It(
  ({ className: e, variant: t, hoverable: n, ...r }, o) => /* @__PURE__ */ f.jsx(
    "span",
    {
      className: oe(_$({ variant: t, hoverable: n }), e),
      ref: o,
      ...r
    }
  )
);
function O$(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Bf(...e) {
  return (t) => e.forEach((n) => O$(n, t));
}
function mt(...e) {
  return S.useCallback(Bf(...e), e);
}
var si = S.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = S.Children.toArray(n), i = o.find(A$);
  if (i) {
    const a = i.props.children, s = o.map((l) => l === i ? S.Children.count(a) > 1 ? S.Children.only(null) : S.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ f.jsx(qh, { ...r, ref: t, children: S.isValidElement(a) ? S.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ f.jsx(qh, { ...r, ref: t, children: n });
});
si.displayName = "Slot";
var qh = S.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (S.isValidElement(n)) {
    const o = D$(n);
    return S.cloneElement(n, {
      ...k$(r, n.props),
      // @ts-ignore
      ref: t ? Bf(t, o) : o
    });
  }
  return S.Children.count(n) > 1 ? S.Children.only(null) : null;
});
qh.displayName = "SlotClone";
var $3 = ({ children: e }) => /* @__PURE__ */ f.jsx(f.Fragment, { children: e });
function A$(e) {
  return S.isValidElement(e) && e.type === $3;
}
function k$(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function D$(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const Yh = qr(
  "inline-flex items-center justify-center rounded-md font-medium text-wrap whitespace-nowrap ring-offset-white transition-colors focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "border border-neutral-200 bg-white text-sm text-neutral-700 shadow-xs hover:bg-neutral-200/80 hover:text-neutral-900 active:bg-neutral-200",
        ghost: "text-sm text-neutral-700 hover:bg-neutral-200/80 hover:text-neutral-900 active:bg-neutral-200",
        primary: "border border-corso-blue-700 bg-corso-blue-600 text-sm text-white shadow-xs hover:bg-corso-blue-600/90 active:bg-corso-blue-700",
        destructive: "border border-red-700 bg-red-600 text-sm text-white shadow-xs hover:bg-red-600/90 active:bg-red-700",
        caution: "border border-amber-700 bg-amber-600 text-sm text-white shadow-xs hover:bg-amber-600/90 active:bg-amber-700",
        link: "cursor-pointer text-corso-blue-800 underline-offset-2 hover:text-corso-blue-600 hover:underline active:text-corso-blue-700"
      },
      size: {
        // twice the horizontal padding as vertical padding
        default: "px-4 py-2",
        lg: "px-6 py-3"
      },
      icon: { true: null },
      // providing a variant to be used as part of a compound variant
      pressed: { true: null }
      // providing a variant to be used as part of a compound variant // ? maybe relevant styles just becomes a selector
    },
    compoundVariants: [
      // TODO way to verify all sizes are overridden
      // icon sizes; scaled to match text roughly based on default `Icon` size
      {
        icon: !0,
        size: "default",
        className: "p-2"
      },
      {
        icon: !0,
        size: "lg",
        className: "p-3"
      },
      // TODO find a way to disallow `size` when `variant` is `link`
      // link override to remove whitespace
      {
        variant: "link",
        size: ["default", "lg"],
        className: "p-0"
      },
      // pressed variants
      {
        variant: "default",
        pressed: !0,
        className: "aria-pressed:bg-neutral-200 aria-pressed:hover:bg-neutral-200"
      },
      {
        variant: "ghost",
        pressed: !0,
        className: "aria-pressed:bg-neutral-200 aria-pressed:hover:bg-neutral-200"
      },
      {
        variant: "primary",
        pressed: !0,
        className: "aria-pressed:bg-corso-blue-700 aria-pressed:hover:bg-corso-blue-700"
      },
      {
        variant: "destructive",
        pressed: !0,
        className: "aria-pressed:bg-red-700 aria-pressed:hover:bg-red-700"
      },
      {
        variant: "caution",
        pressed: !0,
        className: "aria-pressed:bg-amber-700 aria-pressed:hover:bg-amber-700"
      },
      {
        variant: "link",
        pressed: !0,
        className: "aria-pressed:text-corso-blue-700 aria-pressed:hover:text-corso-blue-700"
      }
    ],
    defaultVariants: {
      variant: "default",
      size: "default",
      icon: !1,
      pressed: !1
    }
  }
), en = S.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    icon: r,
    pressed: o,
    asChild: i = !1,
    // default to `button` type, since the normal default is `submit`
    type: a = "button",
    ...s
  }, l) => {
    const c = i ? si : "button";
    return /* @__PURE__ */ f.jsx(
      c,
      {
        "aria-pressed": o ?? void 0,
        className: oe(
          Yh({ variant: t, size: n, icon: r, pressed: o, className: e })
        ),
        ref: l,
        type: a,
        ...s
      }
    );
  }
);
en.displayName = "Button";
function P$(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const vp = {}, Zl = {};
function Qo(e, t) {
  try {
    const r = (vp[e] || (vp[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1];
    return r in Zl ? Zl[r] : yb(r, r.split(":"));
  } catch {
    if (e in Zl) return Zl[e];
    const n = e == null ? void 0 : e.match(N$);
    return n ? yb(e, n.slice(1)) : NaN;
  }
}
const N$ = /([+-]\d\d):?(\d\d)?/;
function yb(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), o = +(t[2] || 0) / 60;
  return Zl[e] = n * 60 + r > 0 ? n * 60 + r + o : n * 60 - r - o;
}
class Po extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Qo(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), z3(this, t)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Po(...n, t) : new Po(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Po(+this, t);
  }
  getTimezoneOffset() {
    const t = -Qo(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), Zd(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Po(+new Date(t), this.timeZone);
  }
  //#endregion
}
const bb = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!bb.test(e)) return;
  const t = e.replace(bb, "$1UTC");
  Po.prototype[t] && (e.startsWith("get") ? Po.prototype[e] = function() {
    return this.internal[t]();
  } : (Po.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), M$(this), +this;
  }, Po.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), Zd(this), +this;
  }));
});
function Zd(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - // Round after converting minutes to seconds to avoid fractional offset
  // precision errors from historical offsets.
  Math.round(-Qo(e.timeZone, e) * 60));
}
function M$(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), z3(e);
}
function z3(e, t) {
  const n = Array.isArray(t) ? F$(t) : +e.internal, r = Qo(e.timeZone, e), o = r > 0 ? Math.floor(r) : Math.ceil(r), i = /* @__PURE__ */ new Date(+e);
  i.setUTCHours(i.getUTCHours() - 1);
  const a = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), s = -(/* @__PURE__ */ new Date(+i)).getTimezoneOffset(), l = a - s;
  let c = a;
  if (l && a !== o) {
    const M = Date.prototype.getHours.apply(e), j = Array.isArray(t) ? t[3] || 0 : e.internal.getUTCHours();
    if (M !== j) {
      const G = /* @__PURE__ */ new Date(+e), U = a - o;
      U && G.setUTCMinutes(G.getUTCMinutes() + U);
      const B = Qo(e.timeZone, G);
      (B > 0 ? Math.floor(B) : Math.ceil(B)) === o && (c = s);
    }
  }
  const u = c - o;
  u && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + u);
  const d = /* @__PURE__ */ new Date(+e);
  d.setUTCSeconds(0);
  const m = a > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, h = Math.round(-(Qo(e.timeZone, e) * 60)) % 60;
  (h || m) && Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + h + m);
  const v = Qo(e.timeZone, e), g = v > 0 ? Math.floor(v) : Math.ceil(v), b = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - g, C = g !== o, I = b - u, T = g - o, R = n - g * 60 * 1e3, A = T > 0 && Sb(e) - n === T * 60 * 1e3 && Sb(e, R) !== n;
  if (C && I && !A) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + I);
    const M = Qo(e.timeZone, e), j = M > 0 ? Math.floor(M) : Math.ceil(M), G = g - j;
    G && I < 0 && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + G);
  }
  Zd(e);
  const k = (t ? n : n + h * 1e3) - +e.internal;
  k && Math.abs(k) < 1800 * 1e3 && (Date.prototype.setTime.call(e, +e + k), Zd(e));
}
function F$(e) {
  return Date.UTC(e[0], e.length > 1 ? e[1] : 0, e.length > 2 ? e[2] : 1, ...e.slice(3));
}
function Sb(e, t) {
  const n = new Date(t ?? +e);
  return n.setUTCSeconds(n.getUTCSeconds() - Math.round(-Qo(e.timeZone, n) * 60)), +n;
}
class Vn extends Po {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Vn(...n, t) : new Vn(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${P$(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new Vn(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Vn(+new Date(t), this.timeZone);
  }
  //#endregion
}
const j3 = 6048e5, L$ = 864e5, B3 = 6e4, G3 = 36e5, Bu = 43200, xb = 1440, Cb = Symbol.for("constructDateFrom");
function on(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Cb in e ? e[Cb](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function pt(e, t) {
  return on(t || e, e);
}
function Ic(e, t, n) {
  const r = pt(e, n == null ? void 0 : n.in);
  return isNaN(t) ? on(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Gf(e, t, n) {
  const r = pt(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return on(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), i = on(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return o >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
let $$ = {};
function dl() {
  return $$;
}
function Hs(e, t) {
  var s, l, c, u;
  const n = dl(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = pt(e, t == null ? void 0 : t.in), i = o.getDay(), a = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function Rc(e, t) {
  return Hs(e, { ...t, weekStartsOn: 1 });
}
function V3(e, t) {
  const n = pt(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = on(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Rc(o), a = on(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const s = Rc(a);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function Xd(e) {
  const t = pt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function aa(e, ...t) {
  const n = on.bind(
    null,
    e || t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function li(e, t) {
  const n = pt(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Vf(e, t, n) {
  const [r, o] = aa(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = li(r), a = li(o), s = +i - Xd(i), l = +a - Xd(a);
  return Math.round((s - l) / L$);
}
function z$(e, t) {
  const n = V3(e, t), r = on(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Rc(r);
}
function U3(e, t, n) {
  return Ic(e, t * 7, n);
}
function W3(e, t, n) {
  return Gf(e, t * 12, n);
}
function j$(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = on.bind(null, o));
    const i = pt(o, r);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), on(r, n || NaN);
}
function B$(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = on.bind(null, o));
    const i = pt(o, r);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), on(r, n || NaN);
}
function Cd(e, t) {
  const n = +pt(e) - +pt(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function G$(e, t, n) {
  const [r, o] = aa(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +li(r) == +li(o);
}
function H3(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function V$(e) {
  return !(!H3(e) && typeof e != "number" || isNaN(+pt(e)));
}
function Q1(e, t, n) {
  const [r, o] = aa(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return i * 12 + a;
}
function U$(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function W$(e, t) {
  return +pt(e) - +pt(t);
}
function q3(e, t) {
  const n = pt(e, t == null ? void 0 : t.in);
  return n.setHours(23, 59, 59, 999), n;
}
function Y3(e, t) {
  const n = pt(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function H$(e, t) {
  const n = pt(e, t == null ? void 0 : t.in);
  return +q3(n, t) == +Y3(n, t);
}
function q$(e, t, n) {
  const [r, o, i] = aa(
    n == null ? void 0 : n.in,
    e,
    e,
    t
  ), a = Cd(o, i), s = Math.abs(
    Q1(o, i)
  );
  if (s < 1) return 0;
  o.getMonth() === 1 && o.getDate() > 27 && o.setDate(30), o.setMonth(o.getMonth() - a * s);
  let l = Cd(o, i) === -a;
  H$(r) && s === 1 && Cd(r, i) === 1 && (l = !1);
  const c = a * (s - +l);
  return c === 0 ? 0 : c;
}
function Y$(e, t, n) {
  const r = W$(e, t) / 1e3;
  return U$(n == null ? void 0 : n.roundingMethod)(r);
}
function K3(e, t) {
  const [n, r] = aa(e, t.start, t.end);
  return { start: n, end: r };
}
function K$(e, t) {
  const { start: n, end: r } = K3(t == null ? void 0 : t.in, e);
  let o = +n > +r;
  const i = o ? +n : +r, a = o ? r : n;
  a.setHours(0, 0, 0, 0), a.setDate(1);
  let s = 1;
  const l = [];
  for (; +a <= i; )
    l.push(on(n, a)), a.setMonth(a.getMonth() + s);
  return o ? l.reverse() : l;
}
function Z3(e, t) {
  const n = pt(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function Z$(e, t) {
  const n = pt(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function X3(e, t) {
  const n = pt(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function X$(e, t) {
  const { start: n, end: r } = K3(t == null ? void 0 : t.in, e);
  let o = +n > +r;
  const i = o ? +n : +r, a = o ? r : n;
  a.setHours(0, 0, 0, 0), a.setMonth(0, 1);
  let s = 1;
  const l = [];
  for (; +a <= i; )
    l.push(on(n, a)), a.setFullYear(a.getFullYear() + s);
  return o ? l.reverse() : l;
}
function J3(e, t) {
  var s, l, c, u;
  const n = dl(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = pt(e, t == null ? void 0 : t.in), i = o.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function J$(e, t) {
  return J3(e, { ...t, weekStartsOn: 1 });
}
const Q$ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ez = (e, t, n) => {
  let r;
  const o = Q$[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function yp(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const tz = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, nz = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, rz = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, oz = {
  date: yp({
    formats: tz,
    defaultWidth: "full"
  }),
  time: yp({
    formats: nz,
    defaultWidth: "full"
  }),
  dateTime: yp({
    formats: rz,
    defaultWidth: "full"
  })
}, iz = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, az = (e, t, n, r) => iz[e];
function Ml(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const sz = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, lz = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, cz = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, uz = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, dz = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, fz = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, mz = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, pz = {
  ordinalNumber: mz,
  era: Ml({
    values: sz,
    defaultWidth: "wide"
  }),
  quarter: Ml({
    values: lz,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ml({
    values: cz,
    defaultWidth: "wide"
  }),
  day: Ml({
    values: uz,
    defaultWidth: "wide"
  }),
  dayPeriod: Ml({
    values: dz,
    defaultWidth: "wide",
    formattingValues: fz,
    defaultFormattingWidth: "wide"
  })
};
function Fl(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? gz(s, (d) => d.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      hz(s, (d) => d.test(a))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(a.length);
    return { value: c, rest: u };
  };
}
function hz(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function gz(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function vz(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(o.length);
    return { value: a, rest: s };
  };
}
const yz = /^(\d+)(th|st|nd|rd)?/i, bz = /\d+/i, Sz = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, xz = {
  any: [/^b/i, /^(a|c)/i]
}, Cz = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, wz = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ez = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Iz = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Rz = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Tz = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, _z = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Oz = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Az = {
  ordinalNumber: vz({
    matchPattern: yz,
    parsePattern: bz,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Fl({
    matchPatterns: Sz,
    defaultMatchWidth: "wide",
    parsePatterns: xz,
    defaultParseWidth: "any"
  }),
  quarter: Fl({
    matchPatterns: Cz,
    defaultMatchWidth: "wide",
    parsePatterns: wz,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Fl({
    matchPatterns: Ez,
    defaultMatchWidth: "wide",
    parsePatterns: Iz,
    defaultParseWidth: "any"
  }),
  day: Fl({
    matchPatterns: Rz,
    defaultMatchWidth: "wide",
    parsePatterns: Tz,
    defaultParseWidth: "any"
  }),
  dayPeriod: Fl({
    matchPatterns: _z,
    defaultMatchWidth: "any",
    parsePatterns: Oz,
    defaultParseWidth: "any"
  })
}, Ia = {
  code: "en-US",
  formatDistance: ez,
  formatLong: oz,
  formatRelative: az,
  localize: pz,
  match: Az,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function kz(e, t) {
  const n = pt(e, t == null ? void 0 : t.in);
  return Vf(n, X3(n)) + 1;
}
function e0(e, t) {
  const n = pt(e, t == null ? void 0 : t.in), r = +Rc(n) - +z$(n);
  return Math.round(r / j3) + 1;
}
function Q3(e, t) {
  var u, d, m, h;
  const n = pt(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = dl(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((h = (m = o.locale) == null ? void 0 : m.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = on((t == null ? void 0 : t.in) || e, 0);
  a.setFullYear(r + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = Hs(a, t), l = on((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const c = Hs(l, t);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function Dz(e, t) {
  var s, l, c, u;
  const n = dl(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = Q3(e, t), i = on((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), Hs(i, t);
}
function t0(e, t) {
  const n = pt(e, t == null ? void 0 : t.in), r = +Hs(n, t) - +Dz(n, t);
  return Math.round(r / j3) + 1;
}
function At(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Ci = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return At(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : At(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return At(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return At(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return At(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return At(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return At(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return At(o, t.length);
  }
}, ps = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, wb = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Ci.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = Q3(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return At(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : At(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = V3(e);
    return At(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return At(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return At(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return At(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ci.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return At(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = t0(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : At(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = e0(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : At(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Ci.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = kz(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : At(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return At(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return At(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return At(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = ps.noon : r === 0 ? o = ps.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = ps.evening : r >= 12 ? o = ps.afternoon : r >= 4 ? o = ps.morning : o = ps.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Ci.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Ci.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : At(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : At(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Ci.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Ci.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Ci.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Ib(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Ea(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Ea(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Ib(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Ea(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Ea(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Eb(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Ea(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Eb(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Ea(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return At(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return At(+e, t.length);
  }
};
function Eb(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + At(i, 2);
}
function Ib(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + At(Math.abs(e) / 60, 2) : Ea(e, t);
}
function Ea(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = At(Math.trunc(r / 60), 2), i = At(r % 60, 2);
  return n + o + t + i;
}
const Rb = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, eC = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Pz = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Rb(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Rb(r, t)).replace("{{time}}", eC(o, t));
}, Nz = {
  p: eC,
  P: Pz
}, Mz = /^D+$/, Fz = /^Y+$/, Lz = ["D", "DD", "YY", "YYYY"];
function $z(e) {
  return Mz.test(e);
}
function zz(e) {
  return Fz.test(e);
}
function jz(e, t, n) {
  const r = Bz(e, t, n);
  if (console.warn(r), Lz.includes(e)) throw new RangeError(r);
}
function Bz(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Gz = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Vz = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Uz = /^'([^]*?)'?$/, Wz = /''/g, Hz = /[a-zA-Z]/;
function Ds(e, t, n) {
  var u, d, m, h, v, g, x, b;
  const r = dl(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Ia, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((b = (x = r.locale) == null ? void 0 : x.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = pt(e, n == null ? void 0 : n.in);
  if (!V$(s))
    throw new RangeError("Invalid time value");
  let l = t.match(Vz).map((C) => {
    const I = C[0];
    if (I === "p" || I === "P") {
      const T = Nz[I];
      return T(C, o.formatLong);
    }
    return C;
  }).join("").match(Gz).map((C) => {
    if (C === "''")
      return { isToken: !1, value: "'" };
    const I = C[0];
    if (I === "'")
      return { isToken: !1, value: qz(C) };
    if (wb[I])
      return { isToken: !0, value: C };
    if (I.match(Hz))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + I + "`"
      );
    return { isToken: !1, value: C };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return l.map((C) => {
    if (!C.isToken) return C.value;
    const I = C.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && zz(I) || !(n != null && n.useAdditionalDayOfYearTokens) && $z(I)) && jz(I, t, String(e));
    const T = wb[I[0]];
    return T(s, I, o.localize, c);
  }).join("");
}
function qz(e) {
  const t = e.match(Uz);
  return t ? t[1].replace(Wz, "'") : e;
}
function Yz(e, t, n) {
  const r = dl(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Ia, i = 2520, a = Cd(e, t);
  if (isNaN(a)) throw new RangeError("Invalid time value");
  const s = Object.assign({}, n, {
    addSuffix: n == null ? void 0 : n.addSuffix,
    comparison: a
  }), [l, c] = aa(
    n == null ? void 0 : n.in,
    ...a > 0 ? [t, e] : [e, t]
  ), u = Y$(c, l), d = (Xd(c) - Xd(l)) / 1e3, m = Math.round((u - d) / 60);
  let h;
  if (m < 2)
    return n != null && n.includeSeconds ? u < 5 ? o.formatDistance("lessThanXSeconds", 5, s) : u < 10 ? o.formatDistance("lessThanXSeconds", 10, s) : u < 20 ? o.formatDistance("lessThanXSeconds", 20, s) : u < 40 ? o.formatDistance("halfAMinute", 0, s) : u < 60 ? o.formatDistance("lessThanXMinutes", 1, s) : o.formatDistance("xMinutes", 1, s) : m === 0 ? o.formatDistance("lessThanXMinutes", 1, s) : o.formatDistance("xMinutes", m, s);
  if (m < 45)
    return o.formatDistance("xMinutes", m, s);
  if (m < 90)
    return o.formatDistance("aboutXHours", 1, s);
  if (m < xb) {
    const v = Math.round(m / 60);
    return o.formatDistance("aboutXHours", v, s);
  } else {
    if (m < i)
      return o.formatDistance("xDays", 1, s);
    if (m < Bu) {
      const v = Math.round(m / xb);
      return o.formatDistance("xDays", v, s);
    } else if (m < Bu * 2)
      return h = Math.round(m / Bu), o.formatDistance("aboutXMonths", h, s);
  }
  if (h = q$(c, l), h < 12) {
    const v = Math.round(m / Bu);
    return o.formatDistance("xMonths", v, s);
  } else {
    const v = h % 12, g = Math.trunc(h / 12);
    return v < 3 ? o.formatDistance("aboutXYears", g, s) : v < 9 ? o.formatDistance("overXYears", g, s) : o.formatDistance("almostXYears", g + 1, s);
  }
}
function Kz(e, t) {
  const n = pt(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = n.getMonth(), i = on(n, 0);
  return i.setFullYear(r, o + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function Zz(e, t) {
  return pt(e, t == null ? void 0 : t.in).getMonth();
}
function Xz(e, t) {
  return pt(e, t == null ? void 0 : t.in).getFullYear();
}
function Jz(e, t) {
  return +pt(e) > +pt(t);
}
function Qz(e, t) {
  return +pt(e) < +pt(t);
}
function ej(e, t, n) {
  const [r, o] = aa(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function tj(e, t, n) {
  const [r, o] = aa(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function tC(e, t, n) {
  return Ic(e, -t, n);
}
function nj(e, t) {
  const n = () => on(t == null ? void 0 : t.in, NaN), o = aj(e);
  let i;
  if (o.date) {
    const c = sj(o.date, 2);
    i = lj(c.restDateString, c.year);
  }
  if (!i || isNaN(+i)) return n();
  const a = +i;
  let s = 0, l;
  if (o.time && (s = cj(o.time), isNaN(s)))
    return n();
  if (o.timezone) {
    if (l = uj(o.timezone), isNaN(l)) return n();
  } else {
    const c = new Date(a + s), u = pt(0, t == null ? void 0 : t.in);
    return u.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), u.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), u;
  }
  return pt(a + s + l, t == null ? void 0 : t.in);
}
const Gu = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, rj = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, oj = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, ij = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function aj(e) {
  const t = {}, n = e.split(Gu.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Gu.timeZoneDelimiter.test(t.date) && (t.date = e.split(Gu.timeZoneDelimiter)[0], r = e.substr(
    t.date.length,
    e.length
  ))), r) {
    const o = Gu.timezone.exec(r);
    o ? (t.time = r.replace(o[1], ""), t.timezone = o[1]) : t.time = r;
  }
  return t;
}
function sj(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), r = e.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const o = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? o : i * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function lj(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(rj);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], o = Ll(n[1]), i = Ll(n[2]) - 1, a = Ll(n[3]), s = Ll(n[4]), l = Ll(n[5]) - 1;
  if (r)
    return hj(t, s, l) ? dj(t, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !mj(t, i, a) || !pj(t, o) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, i, Math.max(o, a)), c);
  }
}
function Ll(e) {
  return e ? parseInt(e) : 1;
}
function cj(e) {
  const t = e.match(oj);
  if (!t) return NaN;
  const n = bp(t[1]), r = bp(t[2]), o = bp(t[3]);
  return gj(n, r, o) ? n * G3 + r * B3 + o * 1e3 : NaN;
}
function bp(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function uj(e) {
  if (e === "Z") return 0;
  const t = e.match(ij);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), o = t[3] && parseInt(t[3]) || 0;
  return vj(r, o) ? n * (r * G3 + o * B3) : NaN;
}
function dj(e, t, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const o = r.getUTCDay() || 7, i = (t - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
const fj = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function nC(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function mj(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (fj[t] || (nC(e) ? 29 : 28));
}
function pj(e, t) {
  return t >= 1 && t <= (nC(e) ? 366 : 365);
}
function hj(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function gj(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function vj(e, t) {
  return t >= 0 && t <= 59;
}
function yj(e, t, n) {
  const r = pt(e, n == null ? void 0 : n.in), o = r.getFullYear(), i = r.getDate(), a = on(e, 0);
  a.setFullYear(o, t, 15), a.setHours(0, 0, 0, 0);
  const s = Kz(a);
  return r.setMonth(t, Math.min(i, s)), r;
}
function bj(e, t, n) {
  const r = pt(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? on(e, NaN) : (r.setFullYear(t), r);
}
function Sj(e, t, n) {
  return Gf(e, -t, n);
}
function xj(e, t, n) {
  const {
    years: r = 0,
    months: o = 0,
    weeks: i = 0,
    days: a = 0,
    hours: s = 0,
    minutes: l = 0,
    seconds: c = 0
  } = t, u = Sj(e, o + r * 12, n), d = tC(u, a + i * 7, n), m = l + s * 60, v = (c + m * 60) * 1e3;
  return on(e, +d - v);
}
function Cj(e, t, n) {
  return U3(e, -1, n);
}
function wj(e, t, n) {
  return W3(e, -1, n);
}
const Tb = 5, Ej = 4;
function Ij(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), i = t.addDays(o, Tb * 7 - 1);
  return t.getMonth(e) === t.getMonth(i) ? Tb : Ej;
}
function rC(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (r - 1));
}
function Rj(e, t) {
  const n = rC(e, t), r = Ij(e, t);
  return t.addDays(n, r * 7 - 1);
}
const oC = {
  ...Ia,
  labels: {
    labelDayButton: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (a, s) => Ds(a, s, { locale: Ia, ...n });
      let i = o(e, "PPPP");
      return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, i) => Ds(o, i, { locale: Ia, ...t }), r(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (a, s) => Ds(a, s, { locale: Ia, ...n });
      let i = o(e, "PPPP");
      return t != null && t.today && (i = `Today, ${i}`), i;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, i) => Ds(o, i, { locale: Ia, ...t }), r(e, "cccc");
    }
  }
};
class Ar {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => {
      var r;
      return (r = this.overrides) != null && r.today ? this.overrides.today() : this.options.timeZone ? Vn.tz(this.options.timeZone) : new this.Date();
    }, this.newDate = (r, o, i) => {
      var a;
      return (a = this.overrides) != null && a.newDate ? this.overrides.newDate(r, o, i) : this.options.timeZone ? new Vn(r, o, i, this.options.timeZone) : new Date(r, o, i);
    }, this.addDays = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addDays ? this.overrides.addDays(r, o) : Ic(r, o);
    }, this.addMonths = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addMonths ? this.overrides.addMonths(r, o) : Gf(r, o);
    }, this.addWeeks = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addWeeks ? this.overrides.addWeeks(r, o) : U3(r, o);
    }, this.addYears = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addYears ? this.overrides.addYears(r, o) : W3(r, o);
    }, this.differenceInCalendarDays = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Vf(r, o);
    }, this.differenceInCalendarMonths = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : Q1(r, o);
    }, this.eachMonthOfInterval = (r) => {
      var o;
      return (o = this.overrides) != null && o.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : K$(r);
    }, this.eachYearOfInterval = (r) => {
      var s;
      const o = (s = this.overrides) != null && s.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : X$(r), i = new Set(o.map((l) => this.getYear(l)));
      if (i.size === o.length)
        return o;
      const a = [];
      return i.forEach((l) => {
        a.push(new Date(l, 0, 1));
      }), a;
    }, this.endOfBroadcastWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : Rj(r, this);
    }, this.endOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfISOWeek ? this.overrides.endOfISOWeek(r) : J$(r);
    }, this.endOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfMonth ? this.overrides.endOfMonth(r) : Y3(r);
    }, this.endOfWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.endOfWeek ? this.overrides.endOfWeek(r, o) : J3(r, this.options);
    }, this.endOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfYear ? this.overrides.endOfYear(r) : Z$(r);
    }, this.format = (r, o, i) => {
      var s;
      const a = (s = this.overrides) != null && s.format ? this.overrides.format(r, o, this.options) : Ds(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(a) : a;
    }, this.getISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getISOWeek ? this.overrides.getISOWeek(r) : e0(r);
    }, this.getMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.getMonth ? this.overrides.getMonth(r, this.options) : Zz(r, this.options);
    }, this.getYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.getYear ? this.overrides.getYear(r, this.options) : Xz(r, this.options);
    }, this.getWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.getWeek ? this.overrides.getWeek(r, this.options) : t0(r, this.options);
    }, this.isAfter = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isAfter ? this.overrides.isAfter(r, o) : Jz(r, o);
    }, this.isBefore = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isBefore ? this.overrides.isBefore(r, o) : Qz(r, o);
    }, this.isDate = (r) => {
      var o;
      return (o = this.overrides) != null && o.isDate ? this.overrides.isDate(r) : H3(r);
    }, this.isSameDay = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameDay ? this.overrides.isSameDay(r, o) : G$(r, o);
    }, this.isSameMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameMonth ? this.overrides.isSameMonth(r, o) : ej(r, o);
    }, this.isSameYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameYear ? this.overrides.isSameYear(r, o) : tj(r, o);
    }, this.max = (r) => {
      var o;
      return (o = this.overrides) != null && o.max ? this.overrides.max(r) : j$(r);
    }, this.min = (r) => {
      var o;
      return (o = this.overrides) != null && o.min ? this.overrides.min(r) : B$(r);
    }, this.setMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.setMonth ? this.overrides.setMonth(r, o) : yj(r, o);
    }, this.setYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.setYear ? this.overrides.setYear(r, o) : bj(r, o);
    }, this.startOfBroadcastWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : rC(r, this);
    }, this.startOfDay = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfDay ? this.overrides.startOfDay(r) : li(r);
    }, this.startOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Rc(r);
    }, this.startOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfMonth ? this.overrides.startOfMonth(r) : Z3(r);
    }, this.startOfWeek = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Hs(r, this.options);
    }, this.startOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfYear ? this.overrides.startOfYear(r) : X3(r);
    }, this.options = { locale: oC, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    var n;
    const t = (n = this.options.locale) == null ? void 0 : n.code;
    return t && Ar.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: o } = this.options, i = n == null ? void 0 : n.code;
    if (i && Ar.yearFirstLocales.has(i))
      try {
        return new Intl.DateTimeFormat(i, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: o
        }).format(t);
      } catch {
      }
    const a = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, a);
  }
}
Ar.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const Bo = new Ar();
class iC {
  constructor(t, n, r = Bo) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r, this.isoDate = r.format(t, "yyyy-MM-dd"), this.displayMonthId = r.format(n, "yyyy-MM"), this.dateMonthId = r.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class Tj {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class _j {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function Oj(e) {
  return H.createElement("button", { ...e });
}
function Aj(e) {
  return H.createElement("span", { ...e });
}
function kj(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    H.createElement(
      "svg",
      { className: r, width: t, height: t, viewBox: "0 0 24 24" },
      n === "up" && H.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && H.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && H.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && H.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function Dj(e) {
  const { day: t, modifiers: n, ...r } = e;
  return H.createElement("td", { ...r });
}
function Pj(e) {
  const { day: t, modifiers: n, ...r } = e, o = H.useRef(null);
  return H.useEffect(() => {
    var i;
    n.focused && ((i = o.current) == null || i.focus());
  }, [n.focused]), H.createElement("button", { ref: o, ...r });
}
var Ye;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(Ye || (Ye = {}));
var Zt;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(Zt || (Zt = {}));
var io;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(io || (io = {}));
var yr;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(yr || (yr = {}));
function Nj(e) {
  const { options: t, className: n, components: r, classNames: o, ...i } = e, a = [o[Ye.Dropdown], n].join(" "), s = t == null ? void 0 : t.find(({ value: l }) => l === i.value);
  return H.createElement(
    "span",
    { "data-disabled": i.disabled, className: o[Ye.DropdownRoot] },
    H.createElement(r.Select, { className: a, ...i }, t == null ? void 0 : t.map(({ value: l, label: c, disabled: u }) => H.createElement(r.Option, { key: l, value: l, disabled: u }, c))),
    H.createElement(
      "span",
      { className: o[Ye.CaptionLabel], "aria-hidden": !0 },
      s == null ? void 0 : s.label,
      H.createElement(r.Chevron, { orientation: "down", size: 18, className: o[Ye.Chevron] })
    )
  );
}
function Mj(e) {
  return H.createElement("div", { ...e });
}
function Fj(e) {
  return H.createElement("div", { ...e });
}
function Lj(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return H.createElement("div", { ...r }, e.children);
}
function $j(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return H.createElement("div", { ...r });
}
function zj(e) {
  return H.createElement("table", { ...e });
}
function jj(e) {
  return H.createElement("div", { ...e });
}
const aC = Nn(void 0);
function Jc() {
  const e = On(aC);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function Bj(e) {
  const { components: t } = Jc();
  return H.createElement(t.Dropdown, { ...e });
}
function Gj(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...i } = e, { components: a, classNames: s, labels: { labelPrevious: l, labelNext: c } } = Jc(), u = Ke((m) => {
    o && (n == null || n(m));
  }, [o, n]), d = Ke((m) => {
    r && (t == null || t(m));
  }, [r, t]);
  return H.createElement(
    "nav",
    { ...i },
    H.createElement(
      a.PreviousMonthButton,
      { type: "button", className: s[Ye.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": l(r), onClick: d },
      H.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: s[Ye.Chevron], orientation: "left" })
    ),
    H.createElement(
      a.NextMonthButton,
      { type: "button", className: s[Ye.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": c(o), onClick: u },
      H.createElement(a.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: s[Ye.Chevron] })
    )
  );
}
function Vj(e) {
  const { components: t } = Jc();
  return H.createElement(t.Button, { ...e });
}
function Uj(e) {
  return H.createElement("option", { ...e });
}
function Wj(e) {
  const { components: t } = Jc();
  return H.createElement(t.Button, { ...e });
}
function Hj(e) {
  const { rootRef: t, ...n } = e;
  return H.createElement("div", { ...n, ref: t });
}
function qj(e) {
  return H.createElement("select", { ...e });
}
function Yj(e) {
  const { week: t, ...n } = e;
  return H.createElement("tr", { ...n });
}
function Kj(e) {
  return H.createElement("th", { ...e });
}
function Zj(e) {
  return H.createElement(
    "thead",
    { "aria-hidden": !0 },
    H.createElement("tr", { ...e })
  );
}
function Xj(e) {
  const { week: t, ...n } = e;
  return H.createElement("th", { ...n });
}
function Jj(e) {
  return H.createElement("th", { ...e });
}
function Qj(e) {
  return H.createElement("tbody", { ...e });
}
function eB(e) {
  const { components: t } = Jc();
  return H.createElement(t.Dropdown, { ...e });
}
const tB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Oj,
  CaptionLabel: Aj,
  Chevron: kj,
  Day: Dj,
  DayButton: Pj,
  Dropdown: Nj,
  DropdownNav: Mj,
  Footer: Fj,
  Month: Lj,
  MonthCaption: $j,
  MonthGrid: zj,
  Months: jj,
  MonthsDropdown: Bj,
  Nav: Gj,
  NextMonthButton: Vj,
  Option: Uj,
  PreviousMonthButton: Wj,
  Root: Hj,
  Select: qj,
  Week: Yj,
  WeekNumber: Xj,
  WeekNumberHeader: Jj,
  Weekday: Kj,
  Weekdays: Zj,
  Weeks: Qj,
  YearsDropdown: eB
}, Symbol.toStringTag, { value: "Module" }));
function ti(e, t, n = !1, r = Bo) {
  let { from: o, to: i } = e;
  const { differenceInCalendarDays: a, isSameDay: s } = r;
  return o && i ? (a(i, o) < 0 && ([o, i] = [i, o]), a(t, o) >= (n ? 1 : 0) && a(i, t) >= (n ? 1 : 0)) : !n && i ? s(i, t) : !n && o ? s(o, t) : !1;
}
function n0(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Uf(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function r0(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function o0(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function sC(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function lC(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function ni(e, t, n = Bo) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: i, isAfter: a } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return o(e, s);
    if (lC(s, n))
      return s.some((l) => o(e, l));
    if (Uf(s))
      return ti(s, e, !1, n);
    if (sC(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (n0(s)) {
      const l = i(s.before, e), c = i(s.after, e), u = l > 0, d = c < 0;
      return a(s.before, s.after) ? d && u : u || d;
    }
    return r0(s) ? i(e, s.after) > 0 : o0(s) ? i(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function nB(e, t, n, r, o) {
  const { disabled: i, hidden: a, modifiers: s, showOutsideDays: l, broadcastCalendar: c, today: u = o.today() } = t, { isSameDay: d, isSameMonth: m, startOfMonth: h, isBefore: v, endOfMonth: g, isAfter: x } = o, b = n && h(n), C = r && g(r), I = {
    [Zt.focused]: [],
    [Zt.outside]: [],
    [Zt.disabled]: [],
    [Zt.hidden]: [],
    [Zt.today]: []
  }, T = {};
  for (const R of e) {
    const { date: A, displayMonth: _ } = R, k = !!(_ && !m(A, _)), M = !!(b && v(A, b)), j = !!(C && x(A, C)), G = !!(i && ni(A, i, o)), U = !!(a && ni(A, a, o)) || M || j || // Broadcast calendar will show outside days as default
    !c && !l && k || c && l === !1 && k, B = d(A, u);
    k && I.outside.push(R), G && I.disabled.push(R), U && I.hidden.push(R), B && I.today.push(R), s && Object.keys(s).forEach((K) => {
      const ee = s == null ? void 0 : s[K];
      ee && ni(A, ee, o) && (T[K] ? T[K].push(R) : T[K] = [R]);
    });
  }
  return (R) => {
    const A = {
      [Zt.focused]: !1,
      [Zt.disabled]: !1,
      [Zt.hidden]: !1,
      [Zt.outside]: !1,
      [Zt.today]: !1
    }, _ = {};
    for (const k in I) {
      const M = I[k];
      A[k] = M.some((j) => j === R);
    }
    for (const k in T)
      _[k] = T[k].some((M) => M === R);
    return {
      ...A,
      // custom modifiers should override all the previous ones
      ..._
    };
  };
}
function rB(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [i]) => (n[i] ? o.push(n[i]) : t[Zt[i]] ? o.push(t[Zt[i]]) : t[io[i]] && o.push(t[io[i]]), o), [t[Ye.Day]]);
}
function oB(e) {
  return {
    ...tB,
    ...e
  };
}
function iB(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function aB() {
  const e = {};
  for (const t in Ye)
    e[Ye[t]] = `rdp-${Ye[t]}`;
  for (const t in Zt)
    e[Zt[t]] = `rdp-${Zt[t]}`;
  for (const t in io)
    e[io[t]] = `rdp-${io[t]}`;
  for (const t in yr)
    e[yr[t]] = `rdp-${yr[t]}`;
  return e;
}
function cC(e, t, n) {
  return (n ?? new Ar(t)).formatMonthYear(e);
}
const sB = cC;
function lB(e, t, n) {
  return (n ?? new Ar(t)).format(e, "d");
}
function cB(e, t = Bo) {
  return t.format(e, "LLLL");
}
function uB(e, t, n) {
  return (n ?? new Ar(t)).format(e, "cccccc");
}
function dB(e, t = Bo) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function fB() {
  return "";
}
function uC(e, t = Bo) {
  return t.format(e, "yyyy");
}
const mB = uC, pB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: cC,
  formatDay: lB,
  formatMonthCaption: sB,
  formatMonthDropdown: cB,
  formatWeekNumber: dB,
  formatWeekNumberHeader: fB,
  formatWeekdayName: uB,
  formatYearCaption: mB,
  formatYearDropdown: uC
}, Symbol.toStringTag, { value: "Module" }));
function hB(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...pB,
    ...e
  };
}
function i0(e, t, n, r) {
  let o = (r ?? new Ar(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const gB = i0;
function a0(e, t, n) {
  return (n ?? new Ar(t)).formatMonthYear(e);
}
const vB = a0;
function dC(e, t, n, r) {
  let o = (r ?? new Ar(n)).format(e, "PPPP");
  return t != null && t.today && (o = `Today, ${o}`), o;
}
function fC(e) {
  return "Choose the Month";
}
function mC() {
  return "";
}
const yB = "Go to the Next Month";
function pC(e, t) {
  return yB;
}
function hC(e) {
  return "Go to the Previous Month";
}
function gC(e, t, n) {
  return (n ?? new Ar(t)).format(e, "cccc");
}
function vC(e, t) {
  return `Week ${e}`;
}
function yC(e) {
  return "Week Number";
}
function bC(e) {
  return "Choose the Year";
}
const bB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: vB,
  labelDay: gB,
  labelDayButton: i0,
  labelGrid: a0,
  labelGridcell: dC,
  labelMonthDropdown: fC,
  labelNav: mC,
  labelNext: pC,
  labelPrevious: hC,
  labelWeekNumber: vC,
  labelWeekNumberHeader: yC,
  labelWeekday: gC,
  labelYearDropdown: bC
}, Symbol.toStringTag, { value: "Module" })), Jr = (e, t, n) => t || (n ? typeof n == "function" ? n : (...r) => n : e);
function SB(e, t) {
  var r;
  const n = ((r = t.locale) == null ? void 0 : r.labels) ?? {};
  return {
    ...bB,
    ...e ?? {},
    labelDayButton: Jr(i0, e == null ? void 0 : e.labelDayButton, n.labelDayButton),
    labelMonthDropdown: Jr(fC, e == null ? void 0 : e.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: Jr(pC, e == null ? void 0 : e.labelNext, n.labelNext),
    labelPrevious: Jr(hC, e == null ? void 0 : e.labelPrevious, n.labelPrevious),
    labelWeekNumber: Jr(vC, e == null ? void 0 : e.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: Jr(bC, e == null ? void 0 : e.labelYearDropdown, n.labelYearDropdown),
    labelGrid: Jr(a0, e == null ? void 0 : e.labelGrid, n.labelGrid),
    labelGridcell: Jr(dC, e == null ? void 0 : e.labelGridcell, n.labelGridcell),
    labelNav: Jr(mC, e == null ? void 0 : e.labelNav, n.labelNav),
    labelWeekNumberHeader: Jr(yC, e == null ? void 0 : e.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: Jr(gC, e == null ? void 0 : e.labelWeekday, n.labelWeekday)
  };
}
function xB(e, t, n, r, o) {
  const { startOfMonth: i, startOfYear: a, endOfYear: s, eachMonthOfInterval: l, getMonth: c } = o;
  return l({
    start: a(e),
    end: s(e)
  }).map((m) => {
    const h = r.formatMonthDropdown(m, o), v = c(m), g = t && m < i(t) || n && m > i(n) || !1;
    return { value: v, label: h, disabled: g };
  });
}
function CB(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[Ye.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[o]
    };
  }), r;
}
function wB(e, t, n, r) {
  const o = r ?? e.today(), i = n ? e.startOfBroadcastWeek(o, e) : t ? e.startOfISOWeek(o) : e.startOfWeek(o), a = [];
  for (let s = 0; s < 7; s++) {
    const l = e.addDays(i, s);
    a.push(l);
  }
  return a;
}
function EB(e, t, n, r, o = !1) {
  if (!e || !t)
    return;
  const { startOfYear: i, endOfYear: a, eachYearOfInterval: s, getYear: l } = r, c = i(e), u = a(t), d = s({ start: c, end: u });
  return o && d.reverse(), d.map((m) => {
    const h = n.formatYearDropdown(m, r);
    return {
      value: l(m),
      label: h,
      disabled: !1
    };
  });
}
function IB(e, t = {}) {
  var s;
  const { weekStartsOn: n, locale: r } = t, o = n ?? ((s = r == null ? void 0 : r.options) == null ? void 0 : s.weekStartsOn) ?? 0, i = (l) => {
    const c = typeof l == "number" || typeof l == "string" ? new Date(l) : l;
    return new Vn(c.getFullYear(), c.getMonth(), c.getDate(), 12, 0, 0, e);
  }, a = (l) => {
    const c = i(l);
    return new Date(c.getFullYear(), c.getMonth(), c.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => i(Vn.tz(e)),
    newDate: (l, c, u) => new Vn(l, c, u, 12, 0, 0, e),
    startOfDay: (l) => i(l),
    startOfWeek: (l, c) => {
      const u = i(l), d = (c == null ? void 0 : c.weekStartsOn) ?? o, m = (u.getDay() - d + 7) % 7;
      return u.setDate(u.getDate() - m), u;
    },
    startOfISOWeek: (l) => {
      const c = i(l), u = (c.getDay() - 1 + 7) % 7;
      return c.setDate(c.getDate() - u), c;
    },
    startOfMonth: (l) => {
      const c = i(l);
      return c.setDate(1), c;
    },
    startOfYear: (l) => {
      const c = i(l);
      return c.setMonth(0, 1), c;
    },
    endOfWeek: (l, c) => {
      const u = i(l), h = ((((c == null ? void 0 : c.weekStartsOn) ?? o) + 6) % 7 - u.getDay() + 7) % 7;
      return u.setDate(u.getDate() + h), u;
    },
    endOfISOWeek: (l) => {
      const c = i(l), u = (7 - c.getDay()) % 7;
      return c.setDate(c.getDate() + u), c;
    },
    endOfMonth: (l) => {
      const c = i(l);
      return c.setMonth(c.getMonth() + 1, 0), c;
    },
    endOfYear: (l) => {
      const c = i(l);
      return c.setMonth(11, 31), c;
    },
    eachMonthOfInterval: (l) => {
      const c = i(l.start), u = i(l.end), d = [], m = new Vn(c.getFullYear(), c.getMonth(), 1, 12, 0, 0, e), h = u.getFullYear() * 12 + u.getMonth();
      for (; m.getFullYear() * 12 + m.getMonth() <= h; )
        d.push(new Vn(m, e)), m.setMonth(m.getMonth() + 1, 1);
      return d;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (l, c) => {
      const u = i(l);
      return u.setDate(u.getDate() + c), u;
    },
    addWeeks: (l, c) => {
      const u = i(l);
      return u.setDate(u.getDate() + c * 7), u;
    },
    addMonths: (l, c) => {
      const u = i(l);
      return u.setMonth(u.getMonth() + c), u;
    },
    addYears: (l, c) => {
      const u = i(l);
      return u.setFullYear(u.getFullYear() + c), u;
    },
    eachYearOfInterval: (l) => {
      const c = i(l.start), u = i(l.end), d = [], m = new Vn(c.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; m.getFullYear() <= u.getFullYear(); )
        d.push(new Vn(m, e)), m.setFullYear(m.getFullYear() + 1, 0, 1);
      return d;
    },
    getWeek: (l, c) => {
      var d;
      const u = a(l);
      return t0(u, {
        weekStartsOn: (c == null ? void 0 : c.weekStartsOn) ?? o,
        firstWeekContainsDate: (c == null ? void 0 : c.firstWeekContainsDate) ?? ((d = r == null ? void 0 : r.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1
      });
    },
    getISOWeek: (l) => {
      const c = a(l);
      return e0(c);
    },
    differenceInCalendarDays: (l, c) => {
      const u = a(l), d = a(c);
      return Vf(u, d);
    },
    differenceInCalendarMonths: (l, c) => {
      const u = a(l), d = a(c);
      return Q1(u, d);
    }
  };
}
const Qc = (e) => e instanceof HTMLElement ? e : null, Sp = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], RB = (e) => Qc(e.querySelector("[data-animated-month]")), xp = (e) => Qc(e.querySelector("[data-animated-caption]")), Cp = (e) => Qc(e.querySelector("[data-animated-weeks]")), TB = (e) => Qc(e.querySelector("[data-animated-nav]")), _B = (e) => Qc(e.querySelector("[data-animated-weekdays]"));
function OB(e, t, { classNames: n, months: r, focused: o, dateLib: i }) {
  const a = He(null), s = He(r), l = He(!1);
  oa(() => {
    const c = s.current;
    if (s.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || c.length === 0 || r.length !== c.length)
      return;
    const u = i.isSameMonth(r[0].date, c[0].date), d = i.isAfter(r[0].date, c[0].date), m = d ? n[yr.caption_after_enter] : n[yr.caption_before_enter], h = d ? n[yr.weeks_after_enter] : n[yr.weeks_before_enter], v = a.current, g = e.current.cloneNode(!0);
    if (g instanceof HTMLElement ? (Sp(g).forEach((I) => {
      if (!(I instanceof HTMLElement))
        return;
      const T = RB(I);
      T && I.contains(T) && I.removeChild(T);
      const R = xp(I);
      R && R.classList.remove(m);
      const A = Cp(I);
      A && A.classList.remove(h);
    }), a.current = g) : a.current = null, l.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const x = v instanceof HTMLElement ? Sp(v) : [], b = Sp(e.current);
    if (b != null && b.every((C) => C instanceof HTMLElement) && x && x.every((C) => C instanceof HTMLElement)) {
      l.current = !0, e.current.style.isolation = "isolate";
      const C = TB(e.current);
      C && (C.style.zIndex = "1"), b.forEach((I, T) => {
        const R = x[T];
        if (!R)
          return;
        I.style.position = "relative", I.style.overflow = "hidden";
        const A = xp(I);
        A && A.classList.add(m);
        const _ = Cp(I);
        _ && _.classList.add(h);
        const k = () => {
          l.current = !1, e.current && (e.current.style.isolation = ""), C && (C.style.zIndex = ""), A && A.classList.remove(m), _ && _.classList.remove(h), I.style.position = "", I.style.overflow = "", I.contains(R) && I.removeChild(R);
        };
        R.style.pointerEvents = "none", R.style.position = "absolute", R.style.overflow = "hidden", R.setAttribute("aria-hidden", "true");
        const M = _B(R);
        M && (M.style.opacity = "0");
        const j = xp(R);
        j && (j.classList.add(d ? n[yr.caption_before_exit] : n[yr.caption_after_exit]), j.addEventListener("animationend", k));
        const G = Cp(R);
        G && G.classList.add(d ? n[yr.weeks_before_exit] : n[yr.weeks_after_exit]), I.insertBefore(R, I.firstChild);
      });
    }
  });
}
function AB(e, t, n, r) {
  const o = e[0], i = e[e.length - 1], { ISOWeek: a, fixedWeeks: s, broadcastCalendar: l } = n ?? {}, { addDays: c, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: m, endOfISOWeek: h, endOfMonth: v, endOfWeek: g, isAfter: x, startOfBroadcastWeek: b, startOfISOWeek: C, startOfWeek: I } = r, T = l ? b(o, r) : a ? C(o) : I(o), R = l ? m(i) : a ? h(v(i)) : g(v(i)), A = t && (l ? m(t) : a ? h(t) : g(t)), _ = A && x(R, A) ? A : R, k = u(_, T), M = d(i, o) + 1, j = [];
  for (let B = 0; B <= k; B++) {
    const K = c(T, B);
    j.push(K);
  }
  const U = (l ? 35 : 42) * M;
  if (s && j.length < U) {
    const B = U - j.length;
    for (let K = 0; K < B; K++) {
      const ee = c(j[j.length - 1], 1);
      j.push(ee);
    }
  }
  return j;
}
function kB(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((i, a) => i.concat(a.days.slice()), t.slice());
    return n.concat(o.slice());
  }, t.slice());
}
function DB(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, i = [];
  for (let a = 0; a < o; a++) {
    const s = r.addMonths(e, a);
    if (t && s > t)
      break;
    i.push(s);
  }
  return i;
}
function _b(e, t, n, r) {
  const { month: o, defaultMonth: i, today: a = r.today(), numberOfMonths: s = 1 } = e;
  let l = o || i || a;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = r;
  if (n && c(n, l) < s - 1) {
    const m = -1 * (s - 1);
    l = u(n, m);
  }
  return t && c(l, t) < 0 && (l = t), d(l);
}
function PB(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: i, endOfISOWeek: a, endOfMonth: s, endOfWeek: l, getISOWeek: c, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: m, startOfWeek: h } = r, v = e.reduce((g, x) => {
    const b = n.broadcastCalendar ? d(x, r) : n.ISOWeek ? m(x) : h(x), C = n.broadcastCalendar ? i(x) : n.ISOWeek ? a(s(x)) : l(s(x)), I = t.filter((_) => _ >= b && _ <= C), T = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && I.length < T) {
      const _ = t.filter((k) => {
        const M = T - I.length;
        return k > C && k <= o(C, M);
      });
      I.push(..._);
    }
    const R = I.reduce((_, k) => {
      const M = n.ISOWeek ? c(k) : u(k), j = _.find((U) => U.weekNumber === M), G = new iC(k, x, r);
      return j ? j.days.push(G) : _.push(new _j(M, [G])), _;
    }, []), A = new Tj(x, R);
    return g.push(A), g;
  }, []);
  return n.reverseMonths ? v.reverse() : v;
}
function NB(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: i, startOfMonth: a, endOfMonth: s, addYears: l, endOfYear: c, newDate: u, today: d } = t, { fromYear: m, toYear: h, fromMonth: v, toMonth: g } = e;
  !n && v && (n = v), !n && m && (n = t.newDate(m, 0, 1)), !r && g && (r = g), !r && h && (r = u(h, 11, 31));
  const x = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = a(n) : m ? n = u(m, 0, 1) : !n && x && (n = o(l(e.today ?? d(), -100))), r ? r = s(r) : h ? r = u(h, 11, 31) : !r && x && (r = c(e.today ?? d())), [
    n && i(n),
    r && i(r)
  ];
}
function MB(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i = 1 } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i : 1, u = a(e);
  if (!t)
    return s(u, c);
  if (!(l(t, e) < i))
    return s(u, c);
}
function FB(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = o ? i ?? 1 : 1, u = a(e);
  if (!t)
    return s(u, -c);
  if (!(l(u, t) <= 0))
    return s(u, -c);
}
function LB(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function Wf(e, t) {
  const [n, r] = Fe(e);
  return [t === void 0 ? n : t, r];
}
function $B(e, t) {
  var T;
  const [n, r] = NB(e, t), { startOfMonth: o, endOfMonth: i } = t, a = _b(e, n, r, t), [s, l] = Wf(
    a,
    // initialMonth is always computed from props.month if provided
    e.month ? a : void 0
  );
  Le(() => {
    const R = _b(e, n, r, t);
    l(R);
  }, [e.timeZone]);
  const { months: c, weeks: u, days: d, previousMonth: m, nextMonth: h } = Be(() => {
    const R = DB(s, r, { numberOfMonths: e.numberOfMonths }, t), A = AB(R, e.endMonth ? i(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), _ = PB(R, A, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), k = LB(_), M = kB(_), j = FB(s, n, e, t), G = MB(s, r, e, t);
    return {
      months: _,
      weeks: k,
      days: M,
      previousMonth: j,
      nextMonth: G
    };
  }, [
    t,
    s.getTime(),
    r == null ? void 0 : r.getTime(),
    n == null ? void 0 : n.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    (T = e.endMonth) == null ? void 0 : T.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: v, onMonthChange: g } = e, x = (R) => u.some((A) => A.days.some((_) => _.isEqualTo(R))), b = (R) => {
    if (v)
      return;
    let A = o(R);
    n && A < o(n) && (A = o(n)), r && A > o(r) && (A = o(r)), l(A), g == null || g(A);
  };
  return {
    months: c,
    weeks: u,
    days: d,
    navStart: n,
    navEnd: r,
    previousMonth: m,
    nextMonth: h,
    goToMonth: b,
    goToDay: (R) => {
      x(R) || b(R.date);
    }
  };
}
var Io;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Io || (Io = {}));
function Ob(e) {
  return !e[Zt.disabled] && !e[Zt.hidden] && !e[Zt.outside];
}
function zB(e, t, n, r) {
  let o, i = -1;
  for (const a of e) {
    const s = t(a);
    Ob(s) && (s[Zt.focused] && i < Io.FocusedModifier ? (o = a, i = Io.FocusedModifier) : r != null && r.isEqualTo(a) && i < Io.LastFocused ? (o = a, i = Io.LastFocused) : n(a.date) && i < Io.Selected ? (o = a, i = Io.Selected) : s[Zt.today] && i < Io.Today && (o = a, i = Io.Today));
  }
  return o || (o = e.find((a) => Ob(t(a)))), o;
}
function jB(e, t, n, r, o, i, a) {
  const { ISOWeek: s, broadcastCalendar: l } = i, { addDays: c, addMonths: u, addWeeks: d, addYears: m, endOfBroadcastWeek: h, endOfISOWeek: v, endOfWeek: g, max: x, min: b, startOfBroadcastWeek: C, startOfISOWeek: I, startOfWeek: T } = a;
  let A = {
    day: c,
    week: d,
    month: u,
    year: m,
    startOfWeek: (_) => l ? C(_, a) : s ? I(_) : T(_),
    endOfWeek: (_) => l ? h(_) : s ? v(_) : g(_)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? A = x([r, A]) : t === "after" && o && (A = b([o, A])), A;
}
function SC(e, t, n, r, o, i, a, s = 0) {
  if (s > 365)
    return;
  const l = jB(e, t, n.date, r, o, i, a), c = !!(i.disabled && ni(l, i.disabled, a)), u = !!(i.hidden && ni(l, i.hidden, a)), d = l, m = new iC(l, d, a);
  return !c && !u ? m : SC(e, t, m, r, o, i, a, s + 1);
}
function BB(e, t, n, r, o) {
  const { autoFocus: i } = e, [a, s] = Fe(), l = zB(t.days, n, r || (() => !1), a), [c, u] = Fe(i ? l : void 0);
  return {
    isFocusTarget: (g) => !!(l != null && l.isEqualTo(g)),
    setFocused: u,
    focused: c,
    blur: () => {
      s(c), u(void 0);
    },
    moveFocus: (g, x) => {
      if (!c)
        return;
      const b = SC(g, x, c, t.navStart, t.navEnd, e, o);
      b && (e.disableNavigation && !t.days.some((I) => I.isEqualTo(b)) || (t.goToDay(b), u(b)));
    }
  };
}
function GB(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = Wf(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = t, c = (h) => (s == null ? void 0 : s.some((v) => l(v, h))) ?? !1, { min: u, max: d } = e;
  return {
    selected: s,
    select: (h, v, g) => {
      let x = [...s ?? []];
      if (c(h)) {
        if ((s == null ? void 0 : s.length) === u || r && (s == null ? void 0 : s.length) === 1)
          return;
        x = s == null ? void 0 : s.filter((b) => !l(b, h));
      } else
        (s == null ? void 0 : s.length) === d ? x = [h] : x = [...x, h];
      return o || a(x), o == null || o(x, h, v, g), x;
    },
    isSelected: c
  };
}
function VB(e, t, n = 0, r = 0, o = !1, i = Bo) {
  const { from: a, to: s } = t || {}, { isSameDay: l, isAfter: c, isBefore: u } = i;
  let d;
  if (!a && !s)
    d = { from: e, to: n > 0 ? void 0 : e };
  else if (a && !s)
    l(a, e) ? n === 0 ? d = { from: a, to: e } : o ? d = { from: a, to: void 0 } : d = void 0 : u(e, a) ? d = { from: e, to: a } : d = { from: a, to: e };
  else if (a && s)
    if (l(a, e) && l(s, e))
      o ? d = { from: a, to: s } : d = void 0;
    else if (l(a, e))
      d = { from: a, to: n > 0 ? void 0 : e };
    else if (l(s, e))
      d = { from: e, to: n > 0 ? void 0 : e };
    else if (u(e, a))
      d = { from: e, to: s };
    else if (c(e, a))
      d = { from: a, to: e };
    else if (c(e, s))
      d = { from: a, to: e };
    else
      throw new Error("Invalid range");
  if (d != null && d.from && (d != null && d.to)) {
    const m = i.differenceInCalendarDays(d.to, d.from);
    r > 0 && m > r ? d = { from: e, to: void 0 } : n > 1 && m < n && (d = { from: e, to: void 0 });
  }
  return d;
}
function UB(e, t, n = Bo) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const i = n.differenceInCalendarDays(e.to, e.from), a = Math.min(i, 6);
  for (let s = 0; s <= a; s++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function Ab(e, t, n = Bo) {
  return ti(e, t.from, !1, n) || ti(e, t.to, !1, n) || ti(t, e.from, !1, n) || ti(t, e.to, !1, n);
}
function WB(e, t, n = Bo) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? ti(e, s, !1, n) : lC(s, n) ? s.some((l) => ti(e, l, !1, n)) : Uf(s) ? s.from && s.to ? Ab(e, { from: s.from, to: s.to }, n) : !1 : sC(s) ? UB(e, s.dayOfWeek, n) : n0(s) ? n.isAfter(s.before, s.after) ? Ab(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : ni(e.from, s, n) || ni(e.to, s, n) : r0(s) || o0(s) ? ni(e.from, s, n) || ni(e.to, s, n) : !1))
    return !0;
  const a = r.filter((s) => typeof s == "function");
  if (a.length) {
    let s = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (a.some((u) => u(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function HB(e, t) {
  const { disabled: n, excludeDisabled: r, resetOnSelect: o, selected: i, required: a, onSelect: s } = e, [l, c] = Wf(i, s ? i : void 0), u = s ? i : l;
  return {
    selected: u,
    select: (h, v, g) => {
      const { min: x, max: b } = e;
      let C;
      if (h) {
        const I = u == null ? void 0 : u.from, T = u == null ? void 0 : u.to, R = !!I && !!T, A = !!I && !!T && t.isSameDay(I, T) && t.isSameDay(h, I);
        o && (R || !(u != null && u.from)) ? !a && A ? C = void 0 : C = { from: h, to: void 0 } : C = VB(h, u, x, b, a, t);
      }
      return r && n && (C != null && C.from) && C.to && WB({ from: C.from, to: C.to }, n, t) && (C.from = h, C.to = void 0), s || c(C), s == null || s(C, h, v, g), C;
    },
    isSelected: (h) => u && ti(u, h, !1, t)
  };
}
function qB(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = Wf(n, o ? n : void 0), s = o ? n : i, { isSameDay: l } = t;
  return {
    selected: s,
    select: (d, m, h) => {
      let v = d;
      return !r && s && s && l(d, s) && (v = void 0), o || a(v), o == null || o(v, d, m, h), v;
    },
    isSelected: (d) => s ? l(s, d) : !1
  };
}
function YB(e, t) {
  const n = qB(e, t), r = GB(e, t), o = HB(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function Lr(e, t) {
  return e instanceof Vn && e.timeZone === t ? e : new Vn(e, t);
}
function hs(e, t, n) {
  return Lr(e, t);
}
function kb(e, t, n) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? hs(e, t) : Array.isArray(e) ? e.map((r) => r instanceof Date ? hs(r, t) : r) : Uf(e) ? {
    ...e,
    from: e.from ? Lr(e.from, t) : e.from,
    to: e.to ? Lr(e.to, t) : e.to
  } : n0(e) ? {
    before: hs(e.before, t),
    after: hs(e.after, t)
  } : r0(e) ? {
    after: hs(e.after, t)
  } : o0(e) ? {
    before: hs(e.before, t)
  } : e;
}
function wp(e, t, n) {
  return e && (Array.isArray(e) ? e.map((r) => kb(r, t)) : kb(e, t));
}
function KB(e) {
  var qe;
  let t = e;
  const n = t.timeZone;
  if (n && (t = {
    ...e,
    timeZone: n
  }, t.today && (t.today = Lr(t.today, n)), t.month && (t.month = Lr(t.month, n)), t.defaultMonth && (t.defaultMonth = Lr(t.defaultMonth, n)), t.startMonth && (t.startMonth = Lr(t.startMonth, n)), t.endMonth && (t.endMonth = Lr(t.endMonth, n)), t.mode === "single" && t.selected ? t.selected = Lr(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = (qe = t.selected) == null ? void 0 : qe.map((Ce) => Lr(Ce, n)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? Lr(t.selected.from, n) : t.selected.from,
    to: t.selected.to ? Lr(t.selected.to, n) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = wp(t.disabled, n)), t.hidden !== void 0 && (t.hidden = wp(t.hidden, n)), t.modifiers)) {
    const Ce = {};
    Object.keys(t.modifiers).forEach((De) => {
      var fe;
      Ce[De] = wp((fe = t.modifiers) == null ? void 0 : fe[De], n);
    }), t.modifiers = Ce;
  }
  const { components: r, formatters: o, labels: i, dateLib: a, locale: s, classNames: l } = Be(() => {
    const Ce = { ...oC, ...t.locale }, De = t.broadcastCalendar ? 1 : t.weekStartsOn, fe = t.noonSafe && t.timeZone ? IB(t.timeZone, {
      weekStartsOn: De,
      locale: Ce
    }) : void 0, Ie = t.dateLib && fe ? { ...fe, ...t.dateLib } : t.dateLib ?? fe, tt = new Ar({
      locale: Ce,
      weekStartsOn: De,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, Ie);
    return {
      dateLib: tt,
      components: oB(t.components),
      formatters: hB(t.formatters),
      labels: SB(t.labels, tt.options),
      locale: Ce,
      classNames: { ...aB(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: a.today() });
  const { captionLayout: c, mode: u, navLayout: d, numberOfMonths: m = 1, onDayBlur: h, onDayClick: v, onDayFocus: g, onDayKeyDown: x, onDayMouseEnter: b, onDayMouseLeave: C, onNextClick: I, onPrevClick: T, showWeekNumber: R, styles: A } = t, { formatCaption: _, formatDay: k, formatMonthDropdown: M, formatWeekNumber: j, formatWeekNumberHeader: G, formatWeekdayName: U, formatYearDropdown: B } = o, K = $B(t, a), { days: ee, months: Y, navStart: J, navEnd: ye, previousMonth: re, nextMonth: le, goToMonth: Te } = K, F = nB(ee, t, J, ye, a), { isSelected: Z, select: se, selected: ae } = YB(t, a) ?? {}, { blur: ue, focused: te, isFocusTarget: he, moveFocus: ge, setFocused: de } = BB(t, K, F, Z ?? (() => !1), a), { labelDayButton: xe, labelGridcell: ce, labelGrid: je, labelMonthDropdown: z, labelNav: Ue, labelPrevious: st, labelNext: Rt, labelWeekday: dn, labelWeekNumber: _t, labelWeekNumberHeader: L, labelYearDropdown: q } = i, Q = Be(() => wB(a, t.ISOWeek, t.broadcastCalendar, t.today), [a, t.ISOWeek, t.broadcastCalendar, t.today]), Se = u !== void 0 || v !== void 0, ve = Ke(() => {
    re && (Te(re), T == null || T(re));
  }, [re, Te, T]), me = Ke(() => {
    le && (Te(le), I == null || I(le));
  }, [Te, le, I]), Ne = Ke((Ce, De) => (fe) => {
    fe.preventDefault(), fe.stopPropagation(), de(Ce), !De.disabled && (se == null || se(Ce.date, De, fe), v == null || v(Ce.date, De, fe));
  }, [se, v, de]), et = Ke((Ce, De) => (fe) => {
    de(Ce), g == null || g(Ce.date, De, fe);
  }, [g, de]), ot = Ke((Ce, De) => (fe) => {
    ue(), h == null || h(Ce.date, De, fe);
  }, [ue, h]), Ot = Ke((Ce, De) => (fe) => {
    const Ie = {
      ArrowLeft: [
        fe.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        fe.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [fe.shiftKey ? "year" : "week", "after"],
      ArrowUp: [fe.shiftKey ? "year" : "week", "before"],
      PageUp: [fe.shiftKey ? "year" : "month", "before"],
      PageDown: [fe.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (Ie[fe.key]) {
      fe.preventDefault(), fe.stopPropagation();
      const [tt, Me] = Ie[fe.key];
      ge(tt, Me);
    }
    x == null || x(Ce.date, De, fe);
  }, [ge, x, t.dir]), nn = Ke((Ce, De) => (fe) => {
    b == null || b(Ce.date, De, fe);
  }, [b]), Nt = Ke((Ce, De) => (fe) => {
    C == null || C(Ce.date, De, fe);
  }, [C]), wn = Ke((Ce) => (De) => {
    const fe = Number(De.target.value), Ie = a.setMonth(a.startOfMonth(Ce), fe);
    Te(Ie);
  }, [a, Te]), kn = Ke((Ce) => (De) => {
    const fe = Number(De.target.value), Ie = a.setYear(a.startOfMonth(Ce), fe);
    Te(Ie);
  }, [a, Te]), { className: hr, style: gr } = Be(() => ({
    className: [l[Ye.Root], t.className].filter(Boolean).join(" "),
    style: { ...A == null ? void 0 : A[Ye.Root], ...t.style }
  }), [l, t.className, t.style, A]), vr = iB(t), Mr = He(null);
  OB(Mr, !!t.animate, {
    classNames: l,
    months: Y,
    focused: te,
    dateLib: a
  });
  const Kn = {
    dayPickerProps: t,
    selected: ae,
    select: se,
    isSelected: Z,
    months: Y,
    nextMonth: le,
    previousMonth: re,
    goToMonth: Te,
    getModifiers: F,
    components: r,
    classNames: l,
    styles: A,
    labels: i,
    formatters: o
  };
  return H.createElement(
    aC.Provider,
    { value: Kn },
    H.createElement(
      r.Root,
      { rootRef: t.animate ? Mr : void 0, className: hr, style: gr, dir: t.dir, id: t.id, lang: t.lang ?? s.code, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...vr },
      H.createElement(
        r.Months,
        { className: l[Ye.Months], style: A == null ? void 0 : A[Ye.Months] },
        !t.hideNavigation && !d && H.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[Ye.Nav], style: A == null ? void 0 : A[Ye.Nav], "aria-label": Ue(), onPreviousClick: ve, onNextClick: me, previousMonth: re, nextMonth: le }),
        Y.map((Ce, De) => H.createElement(
          r.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: l[Ye.Month],
            style: A == null ? void 0 : A[Ye.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: De,
            displayIndex: De,
            calendarMonth: Ce
          },
          d === "around" && !t.hideNavigation && De === 0 && H.createElement(
            r.PreviousMonthButton,
            { type: "button", className: l[Ye.PreviousMonthButton], tabIndex: re ? void 0 : -1, "aria-disabled": re ? void 0 : !0, "aria-label": st(re), onClick: ve, "data-animated-button": t.animate ? "true" : void 0 },
            H.createElement(r.Chevron, { disabled: re ? void 0 : !0, className: l[Ye.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          H.createElement(r.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: l[Ye.MonthCaption], style: A == null ? void 0 : A[Ye.MonthCaption], calendarMonth: Ce, displayIndex: De }, c != null && c.startsWith("dropdown") ? H.createElement(
            r.DropdownNav,
            { className: l[Ye.Dropdowns], style: A == null ? void 0 : A[Ye.Dropdowns] },
            (() => {
              const fe = c === "dropdown" || c === "dropdown-months" ? H.createElement(r.MonthsDropdown, { key: "month", className: l[Ye.MonthsDropdown], "aria-label": z(), classNames: l, components: r, disabled: !!t.disableNavigation, onChange: wn(Ce.date), options: xB(Ce.date, J, ye, o, a), style: A == null ? void 0 : A[Ye.Dropdown], value: a.getMonth(Ce.date) }) : H.createElement("span", { key: "month" }, M(Ce.date, a)), Ie = c === "dropdown" || c === "dropdown-years" ? H.createElement(r.YearsDropdown, { key: "year", className: l[Ye.YearsDropdown], "aria-label": q(a.options), classNames: l, components: r, disabled: !!t.disableNavigation, onChange: kn(Ce.date), options: EB(J, ye, o, a, !!t.reverseYears), style: A == null ? void 0 : A[Ye.Dropdown], value: a.getYear(Ce.date) }) : H.createElement("span", { key: "year" }, B(Ce.date, a));
              return a.getMonthYearOrder() === "year-first" ? [Ie, fe] : [fe, Ie];
            })(),
            H.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, _(Ce.date, a.options, a))
          ) : H.createElement(r.CaptionLabel, { className: l[Ye.CaptionLabel], role: "status", "aria-live": "polite" }, _(Ce.date, a.options, a))),
          d === "around" && !t.hideNavigation && De === m - 1 && H.createElement(
            r.NextMonthButton,
            { type: "button", className: l[Ye.NextMonthButton], tabIndex: le ? void 0 : -1, "aria-disabled": le ? void 0 : !0, "aria-label": Rt(le), onClick: me, "data-animated-button": t.animate ? "true" : void 0 },
            H.createElement(r.Chevron, { disabled: le ? void 0 : !0, className: l[Ye.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          De === m - 1 && d === "after" && !t.hideNavigation && H.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[Ye.Nav], style: A == null ? void 0 : A[Ye.Nav], "aria-label": Ue(), onPreviousClick: ve, onNextClick: me, previousMonth: re, nextMonth: le }),
          H.createElement(
            r.MonthGrid,
            { role: "grid", "aria-multiselectable": u === "multiple" || u === "range", "aria-label": je(Ce.date, a.options, a) || void 0, className: l[Ye.MonthGrid], style: A == null ? void 0 : A[Ye.MonthGrid] },
            !t.hideWeekdays && H.createElement(
              r.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: l[Ye.Weekdays], style: A == null ? void 0 : A[Ye.Weekdays] },
              R && H.createElement(r.WeekNumberHeader, { "aria-label": L(a.options), className: l[Ye.WeekNumberHeader], style: A == null ? void 0 : A[Ye.WeekNumberHeader], scope: "col" }, G()),
              Q.map((fe) => H.createElement(r.Weekday, { "aria-label": dn(fe, a.options, a), className: l[Ye.Weekday], key: String(fe), style: A == null ? void 0 : A[Ye.Weekday], scope: "col" }, U(fe, a.options, a)))
            ),
            H.createElement(r.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: l[Ye.Weeks], style: A == null ? void 0 : A[Ye.Weeks] }, Ce.weeks.map((fe) => H.createElement(
              r.Week,
              { className: l[Ye.Week], key: fe.weekNumber, style: A == null ? void 0 : A[Ye.Week], week: fe },
              R && H.createElement(r.WeekNumber, { week: fe, style: A == null ? void 0 : A[Ye.WeekNumber], "aria-label": _t(fe.weekNumber, {
                locale: s
              }), className: l[Ye.WeekNumber], scope: "row", role: "rowheader" }, j(fe.weekNumber, a)),
              fe.days.map((Ie) => {
                const { date: tt } = Ie, Me = F(Ie);
                if (Me[Zt.focused] = !Me.hidden && !!(te != null && te.isEqualTo(Ie)), Me[io.selected] = (Z == null ? void 0 : Z(tt)) || Me.selected, Uf(ae)) {
                  const { from: an, to: bt } = ae;
                  Me[io.range_start] = !!(an && bt && a.isSameDay(tt, an)), Me[io.range_end] = !!(an && bt && a.isSameDay(tt, bt)), Me[io.range_middle] = ti(ae, tt, !0, a);
                }
                const kt = CB(Me, A, t.modifiersStyles), Et = rB(Me, l, t.modifiersClassNames), Yt = !Se && !Me.hidden ? ce(tt, Me, a.options, a) : void 0;
                return H.createElement(r.Day, { key: `${Ie.isoDate}_${Ie.displayMonthId}`, day: Ie, modifiers: Me, className: Et.join(" "), style: kt, role: "gridcell", "aria-selected": Me.selected || void 0, "aria-label": Yt, "data-day": Ie.isoDate, "data-month": Ie.outside ? Ie.dateMonthId : void 0, "data-selected": Me.selected || void 0, "data-disabled": Me.disabled || void 0, "data-hidden": Me.hidden || void 0, "data-outside": Ie.outside || void 0, "data-focused": Me.focused || void 0, "data-today": Me.today || void 0 }, !Me.hidden && Se ? H.createElement(r.DayButton, { className: l[Ye.DayButton], style: A == null ? void 0 : A[Ye.DayButton], type: "button", day: Ie, modifiers: Me, disabled: !Me.focused && Me.disabled || void 0, "aria-disabled": Me.focused && Me.disabled || void 0, tabIndex: he(Ie) ? 0 : -1, "aria-label": xe(tt, Me, a.options, a), onClick: Ne(Ie, Me), onBlur: ot(Ie, Me), onFocus: et(Ie, Me), onKeyDown: Ot(Ie, Me), onMouseEnter: nn(Ie, Me), onMouseLeave: Nt(Ie, Me) }, k(tt, a.options, a)) : !Me.hidden && k(Ie.date, a.options, a));
              })
            )))
          )
        ))
      ),
      t.footer && H.createElement(r.Footer, { className: l[Ye.Footer], style: A == null ? void 0 : A[Ye.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const ZB = {
  left: "chevronLeft",
  right: "chevronRight",
  up: "chevronUp",
  down: "chevronDown"
};
function XB({
  orientation: e = "left",
  className: t
}) {
  return /* @__PURE__ */ f.jsx(Ve, { icon: ZB[e], className: t });
}
function s0({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  ...r
}) {
  return /* @__PURE__ */ f.jsx(
    KB,
    {
      showOutsideDays: n,
      className: oe("group/calendar p-3", e),
      classNames: {
        months: "relative flex flex-col gap-4 sm:flex-row",
        month: "space-y-4",
        month_caption: "flex h-7 items-center justify-center",
        caption_label: "text-sm font-medium",
        nav: "absolute inset-x-0 top-0 z-10 flex items-center justify-between",
        button_previous: oe(
          Yh({ variant: "default" }),
          // TODO iterate to remove
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 aria-disabled:opacity-25"
        ),
        button_next: oe(
          Yh({ variant: "default" }),
          // TODO iterate to remove
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 aria-disabled:opacity-25"
        ),
        month_grid: "w-full border-collapse space-y-1",
        weekdays: "flex",
        weekday: "text-neutral-500 rounded-md w-9 font-normal text-[0.8rem]",
        week: "flex w-full mt-2",
        day: oe(
          "relative flex h-9 w-9 items-center justify-center rounded-none p-0 text-sm font-normal focus-within:z-20",
          "hover:not-aria-selected:not-data-disabled:rounded-md hover:not-aria-selected:not-data-disabled:bg-neutral-100 hover:not-aria-selected:not-data-disabled:text-neutral-900",
          "aria-selected:text-neutral-50 aria-selected:not-[.day-range-middle]:bg-neutral-950",
          // all selected (base)
          "aria-selected:first:rounded-l-md aria-selected:last:rounded-r-md"
          // first and last of row within range
        ),
        day_button: "h-9 w-9 p-0",
        selected: "day-selected group-[&:not(:has(.day-range-start,.day-range-end))]/calendar:rounded-md",
        range_start: "day-range-start rounded-l-md",
        range_middle: "day-range-middle bg-neutral-800",
        range_end: "day-range-end rounded-r-md",
        today: "not-aria-selected:bg-neutral-100 not-aria-selected:text-neutral-900 not-aria-selected:rounded-md",
        outside: "day-outside text-neutral-500 opacity-50 aria-selected:text-neutral-50/50 aria-selected:opacity-50",
        disabled: "text-neutral-500 opacity-50",
        hidden: "invisible",
        ...t
      },
      components: { Chevron: XB },
      ...r
    }
  );
}
s0.displayName = "Calendar";
function JB(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Db(e) {
  return JB(e) || Array.isArray(e);
}
function QB() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function l0(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const o = JSON.stringify(Object.keys(e.breakpoints || {})), i = JSON.stringify(Object.keys(t.breakpoints || {}));
  return o !== i ? !1 : n.every((a) => {
    const s = e[a], l = t[a];
    return typeof s == "function" ? `${s}` == `${l}` : !Db(s) || !Db(l) ? s === l : l0(s, l);
  });
}
function Pb(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function eG(e, t) {
  if (e.length !== t.length) return !1;
  const n = Pb(e), r = Pb(t);
  return n.every((o, i) => {
    const a = r[i];
    return l0(o, a);
  });
}
function c0(e) {
  return typeof e == "number";
}
function Kh(e) {
  return typeof e == "string";
}
function Hf(e) {
  return typeof e == "boolean";
}
function Nb(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Jt(e) {
  return Math.abs(e);
}
function u0(e) {
  return Math.sign(e);
}
function lc(e, t) {
  return Jt(e - t);
}
function tG(e, t) {
  if (e === 0 || t === 0 || Jt(e) <= Jt(t)) return 0;
  const n = lc(Jt(e), Jt(t));
  return Jt(n / e);
}
function nG(e) {
  return Math.round(e * 100) / 100;
}
function Tc(e) {
  return _c(e).map(Number);
}
function so(e) {
  return e[eu(e)];
}
function eu(e) {
  return Math.max(0, e.length - 1);
}
function d0(e, t) {
  return t === eu(e);
}
function Mb(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function _c(e) {
  return Object.keys(e);
}
function xC(e, t) {
  return [e, t].reduce((n, r) => (_c(r).forEach((o) => {
    const i = n[o], a = r[o], s = Nb(i) && Nb(a);
    n[o] = s ? xC(i, a) : a;
  }), n), {});
}
function Zh(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function rG(e, t) {
  const n = {
    start: r,
    center: o,
    end: i
  };
  function r() {
    return 0;
  }
  function o(l) {
    return i(l) / 2;
  }
  function i(l) {
    return t - l;
  }
  function a(l, c) {
    return Kh(e) ? n[e](l) : e(t, l, c);
  }
  return {
    measure: a
  };
}
function Oc() {
  let e = [];
  function t(o, i, a, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in o)
      o.addEventListener(i, a, s), l = () => o.removeEventListener(i, a, s);
    else {
      const c = o;
      c.addListener(a), l = () => c.removeListener(a);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((o) => o());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function oG(e, t, n, r) {
  const o = Oc(), i = 1e3 / 60;
  let a = null, s = 0, l = 0;
  function c() {
    o.add(e, "visibilitychange", () => {
      e.hidden && v();
    });
  }
  function u() {
    h(), o.clear();
  }
  function d(x) {
    if (!l) return;
    a || (a = x, n(), n());
    const b = x - a;
    for (a = x, s += b; s >= i; )
      n(), s -= i;
    const C = s / i;
    r(C), l && (l = t.requestAnimationFrame(d));
  }
  function m() {
    l || (l = t.requestAnimationFrame(d));
  }
  function h() {
    t.cancelAnimationFrame(l), a = null, s = 0, l = 0;
  }
  function v() {
    a = null, s = 0;
  }
  return {
    init: c,
    destroy: u,
    start: m,
    stop: h,
    update: n,
    render: r
  };
}
function iG(e, t) {
  const n = t === "rtl", r = e === "y", o = r ? "y" : "x", i = r ? "x" : "y", a = !r && n ? -1 : 1, s = u(), l = d();
  function c(v) {
    const {
      height: g,
      width: x
    } = v;
    return r ? g : x;
  }
  function u() {
    return r ? "top" : n ? "right" : "left";
  }
  function d() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function m(v) {
    return v * a;
  }
  return {
    scroll: o,
    cross: i,
    startEdge: s,
    endEdge: l,
    measureSize: c,
    direction: m
  };
}
function $a(e = 0, t = 0) {
  const n = Jt(e - t);
  function r(c) {
    return c < e;
  }
  function o(c) {
    return c > t;
  }
  function i(c) {
    return r(c) || o(c);
  }
  function a(c) {
    return i(c) ? r(c) ? e : t : c;
  }
  function s(c) {
    return n ? c - n * Math.ceil((c - t) / n) : c;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: a,
    reachedAny: i,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
}
function CC(e, t, n) {
  const {
    constrain: r
  } = $a(0, e), o = e + 1;
  let i = a(t);
  function a(m) {
    return n ? Jt((o + m) % o) : r(m);
  }
  function s() {
    return i;
  }
  function l(m) {
    return i = a(m), d;
  }
  function c(m) {
    return u().set(s() + m);
  }
  function u() {
    return CC(e, s(), n);
  }
  const d = {
    get: s,
    set: l,
    add: c,
    clone: u
  };
  return d;
}
function aG(e, t, n, r, o, i, a, s, l, c, u, d, m, h, v, g, x, b, C) {
  const {
    cross: I,
    direction: T
  } = e, R = ["INPUT", "SELECT", "TEXTAREA"], A = {
    passive: !1
  }, _ = Oc(), k = Oc(), M = $a(50, 225).constrain(h.measure(20)), j = {
    mouse: 300,
    touch: 400
  }, G = {
    mouse: 500,
    touch: 600
  }, U = v ? 43 : 25;
  let B = !1, K = 0, ee = 0, Y = !1, J = !1, ye = !1, re = !1;
  function le(ce) {
    if (!C) return;
    function je(Ue) {
      (Hf(C) || C(ce, Ue)) && ue(Ue);
    }
    const z = t;
    _.add(z, "dragstart", (Ue) => Ue.preventDefault(), A).add(z, "touchmove", () => {
    }, A).add(z, "touchend", () => {
    }).add(z, "touchstart", je).add(z, "mousedown", je).add(z, "touchcancel", he).add(z, "contextmenu", he).add(z, "click", ge, !0);
  }
  function Te() {
    _.clear(), k.clear();
  }
  function F() {
    const ce = re ? n : t;
    k.add(ce, "touchmove", te, A).add(ce, "touchend", he).add(ce, "mousemove", te, A).add(ce, "mouseup", he);
  }
  function Z(ce) {
    const je = ce.nodeName || "";
    return R.includes(je);
  }
  function se() {
    return (v ? G : j)[re ? "mouse" : "touch"];
  }
  function ae(ce, je) {
    const z = d.add(u0(ce) * -1), Ue = u.byDistance(ce, !v).distance;
    return v || Jt(ce) < M ? Ue : x && je ? Ue * 0.5 : u.byIndex(z.get(), 0).distance;
  }
  function ue(ce) {
    const je = Zh(ce, r);
    re = je, ye = v && je && !ce.buttons && B, B = lc(o.get(), a.get()) >= 2, !(je && ce.button !== 0) && (Z(ce.target) || (Y = !0, i.pointerDown(ce), c.useFriction(0).useDuration(0), o.set(a), F(), K = i.readPoint(ce), ee = i.readPoint(ce, I), m.emit("pointerDown")));
  }
  function te(ce) {
    if (!Zh(ce, r) && ce.touches.length >= 2) return he(ce);
    const z = i.readPoint(ce), Ue = i.readPoint(ce, I), st = lc(z, K), Rt = lc(Ue, ee);
    if (!J && !re && (!ce.cancelable || (J = st > Rt, !J)))
      return he(ce);
    const dn = i.pointerMove(ce);
    st > g && (ye = !0), c.useFriction(0.3).useDuration(0.75), s.start(), o.add(T(dn)), ce.preventDefault();
  }
  function he(ce) {
    const z = u.byDistance(0, !1).index !== d.get(), Ue = i.pointerUp(ce) * se(), st = ae(T(Ue), z), Rt = tG(Ue, st), dn = U - 10 * Rt, _t = b + Rt / 50;
    J = !1, Y = !1, k.clear(), c.useDuration(dn).useFriction(_t), l.distance(st, !v), re = !1, m.emit("pointerUp");
  }
  function ge(ce) {
    ye && (ce.stopPropagation(), ce.preventDefault(), ye = !1);
  }
  function de() {
    return Y;
  }
  return {
    init: le,
    destroy: Te,
    pointerDown: de
  };
}
function sG(e, t) {
  let r, o;
  function i(d) {
    return d.timeStamp;
  }
  function a(d, m) {
    const v = `client${(m || e.scroll) === "x" ? "X" : "Y"}`;
    return (Zh(d, t) ? d : d.touches[0])[v];
  }
  function s(d) {
    return r = d, o = d, a(d);
  }
  function l(d) {
    const m = a(d) - a(o), h = i(d) - i(r) > 170;
    return o = d, h && (r = d), m;
  }
  function c(d) {
    if (!r || !o) return 0;
    const m = a(o) - a(r), h = i(d) - i(r), v = i(d) - i(o) > 170, g = m / h;
    return h && !v && Jt(g) > 0.1 ? g : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: c,
    readPoint: a
  };
}
function lG() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: o,
      offsetWidth: i,
      offsetHeight: a
    } = n;
    return {
      top: r,
      right: o + i,
      bottom: r + a,
      left: o,
      width: i,
      height: a
    };
  }
  return {
    measure: e
  };
}
function cG(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function uG(e, t, n, r, o, i, a) {
  const s = [e].concat(r);
  let l, c, u = [], d = !1;
  function m(x) {
    return o.measureSize(a.measure(x));
  }
  function h(x) {
    if (!i) return;
    c = m(e), u = r.map(m);
    function b(C) {
      for (const I of C) {
        if (d) return;
        const T = I.target === e, R = r.indexOf(I.target), A = T ? c : u[R], _ = m(T ? e : r[R]);
        if (Jt(_ - A) >= 0.5) {
          x.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((C) => {
      (Hf(i) || i(x, C)) && b(C);
    }), n.requestAnimationFrame(() => {
      s.forEach((C) => l.observe(C));
    });
  }
  function v() {
    d = !0, l && l.disconnect();
  }
  return {
    init: h,
    destroy: v
  };
}
function dG(e, t, n, r, o, i) {
  let a = 0, s = 0, l = o, c = i, u = e.get(), d = 0;
  function m() {
    const A = r.get() - e.get(), _ = !l;
    let k = 0;
    return _ ? (a = 0, n.set(r), e.set(r), k = A) : (n.set(e), a += A / l, a *= c, u += a, e.add(a), k = u - d), s = u0(k), d = u, R;
  }
  function h() {
    const A = r.get() - t.get();
    return Jt(A) < 1e-3;
  }
  function v() {
    return l;
  }
  function g() {
    return s;
  }
  function x() {
    return a;
  }
  function b() {
    return I(o);
  }
  function C() {
    return T(i);
  }
  function I(A) {
    return l = A, R;
  }
  function T(A) {
    return c = A, R;
  }
  const R = {
    direction: g,
    duration: v,
    velocity: x,
    seek: m,
    settled: h,
    useBaseFriction: C,
    useBaseDuration: b,
    useFriction: T,
    useDuration: I
  };
  return R;
}
function fG(e, t, n, r, o) {
  const i = o.measure(10), a = o.measure(50), s = $a(0.1, 0.99);
  let l = !1;
  function c() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function u(h) {
    if (!c()) return;
    const v = e.reachedMin(t.get()) ? "min" : "max", g = Jt(e[v] - t.get()), x = n.get() - t.get(), b = s.constrain(g / a);
    n.subtract(x * b), !h && Jt(x) < i && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function d(h) {
    l = !h;
  }
  return {
    shouldConstrain: c,
    constrain: u,
    toggleActive: d
  };
}
function mG(e, t, n, r, o) {
  const i = $a(-t + e, 0), a = d(), s = u(), l = m();
  function c(v, g) {
    return lc(v, g) <= 1;
  }
  function u() {
    const v = a[0], g = so(a), x = a.lastIndexOf(v), b = a.indexOf(g) + 1;
    return $a(x, b);
  }
  function d() {
    return n.map((v, g) => {
      const {
        min: x,
        max: b
      } = i, C = i.constrain(v), I = !g, T = d0(n, g);
      return I ? b : T || c(x, C) ? x : c(b, C) ? b : C;
    }).map((v) => parseFloat(v.toFixed(3)));
  }
  function m() {
    if (t <= e + o) return [i.max];
    if (r === "keepSnaps") return a;
    const {
      min: v,
      max: g
    } = s;
    return a.slice(v, g);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function pG(e, t, n) {
  const r = t[0], o = n ? r - e : so(t);
  return {
    limit: $a(o, r)
  };
}
function hG(e, t, n, r) {
  const i = t.min + 0.1, a = t.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = $a(i, a);
  function c(m) {
    return m === 1 ? l(n.get()) : m === -1 ? s(n.get()) : !1;
  }
  function u(m) {
    if (!c(m)) return;
    const h = e * (m * -1);
    r.forEach((v) => v.add(h));
  }
  return {
    loop: u
  };
}
function gG(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(i) {
    const a = i - t;
    return n ? a / -n : 0;
  }
  return {
    get: r
  };
}
function vG(e, t, n, r, o) {
  const {
    startEdge: i,
    endEdge: a
  } = e, {
    groupSlides: s
  } = o, l = d().map(t.measure), c = m(), u = h();
  function d() {
    return s(r).map((g) => so(g)[a] - g[0][i]).map(Jt);
  }
  function m() {
    return r.map((g) => n[i] - g[i]).map((g) => -Jt(g));
  }
  function h() {
    return s(c).map((g) => g[0]).map((g, x) => g + l[x]);
  }
  return {
    snaps: c,
    snapsAligned: u
  };
}
function yG(e, t, n, r, o, i) {
  const {
    groupSlides: a
  } = o, {
    min: s,
    max: l
  } = r, c = u();
  function u() {
    const m = a(i), h = !e || t === "keepSnaps";
    return n.length === 1 ? [i] : h ? m : m.slice(s, l).map((v, g, x) => {
      const b = !g, C = d0(x, g);
      if (b) {
        const I = so(x[0]) + 1;
        return Mb(I);
      }
      if (C) {
        const I = eu(i) - so(x)[0] + 1;
        return Mb(I, so(x)[0]);
      }
      return v;
    });
  }
  return {
    slideRegistry: c
  };
}
function bG(e, t, n, r, o) {
  const {
    reachedAny: i,
    removeOffset: a,
    constrain: s
  } = r;
  function l(v) {
    return v.concat().sort((g, x) => Jt(g) - Jt(x))[0];
  }
  function c(v) {
    const g = e ? a(v) : s(v), x = t.map((C, I) => ({
      diff: u(C - g, 0),
      index: I
    })).sort((C, I) => Jt(C.diff) - Jt(I.diff)), {
      index: b
    } = x[0];
    return {
      index: b,
      distance: g
    };
  }
  function u(v, g) {
    const x = [v, v + n, v - n];
    if (!e) return v;
    if (!g) return l(x);
    const b = x.filter((C) => u0(C) === g);
    return b.length ? l(b) : so(x) - n;
  }
  function d(v, g) {
    const x = t[v] - o.get(), b = u(x, g);
    return {
      index: v,
      distance: b
    };
  }
  function m(v, g) {
    const x = o.get() + v, {
      index: b,
      distance: C
    } = c(x), I = !e && i(x);
    if (!g || I) return {
      index: b,
      distance: v
    };
    const T = t[b] - C, R = v + u(T, 0);
    return {
      index: b,
      distance: R
    };
  }
  return {
    byDistance: m,
    byIndex: d,
    shortcut: u
  };
}
function SG(e, t, n, r, o, i, a) {
  function s(d) {
    const m = d.distance, h = d.index !== t.get();
    i.add(m), m && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), h && (n.set(t.get()), t.set(d.index), a.emit("select"));
  }
  function l(d, m) {
    const h = o.byDistance(d, m);
    s(h);
  }
  function c(d, m) {
    const h = t.clone().set(d), v = o.byIndex(h.get(), m);
    s(v);
  }
  return {
    distance: l,
    index: c
  };
}
function xG(e, t, n, r, o, i, a, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let c = 0;
  function u(h) {
    if (!s) return;
    function v(g) {
      if ((/* @__PURE__ */ new Date()).getTime() - c > 10) return;
      a.emit("slideFocusStart"), e.scrollLeft = 0;
      const C = n.findIndex((I) => I.includes(g));
      c0(C) && (o.useDuration(0), r.index(C, 0), a.emit("slideFocus"));
    }
    i.add(document, "keydown", d, !1), t.forEach((g, x) => {
      i.add(g, "focus", (b) => {
        (Hf(s) || s(h, b)) && v(x);
      }, l);
    });
  }
  function d(h) {
    h.code === "Tab" && (c = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: u
  };
}
function Xl(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = a(l);
  }
  function o(l) {
    t += a(l);
  }
  function i(l) {
    t -= a(l);
  }
  function a(l) {
    return c0(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: o,
    subtract: i
  };
}
function wC(e, t) {
  const n = e.scroll === "x" ? a : s, r = t.style;
  let o = null, i = !1;
  function a(m) {
    return `translate3d(${m}px,0px,0px)`;
  }
  function s(m) {
    return `translate3d(0px,${m}px,0px)`;
  }
  function l(m) {
    if (i) return;
    const h = nG(e.direction(m));
    h !== o && (r.transform = n(h), o = h);
  }
  function c(m) {
    i = !m;
  }
  function u() {
    i || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: u,
    to: l,
    toggleActive: c
  };
}
function CG(e, t, n, r, o, i, a, s, l) {
  const u = Tc(o), d = Tc(o).reverse(), m = b().concat(C());
  function h(_, k) {
    return _.reduce((M, j) => M - o[j], k);
  }
  function v(_, k) {
    return _.reduce((M, j) => h(M, k) > 0 ? M.concat([j]) : M, []);
  }
  function g(_) {
    return i.map((k, M) => ({
      start: k - r[M] + 0.5 + _,
      end: k + t - 0.5 + _
    }));
  }
  function x(_, k, M) {
    const j = g(k);
    return _.map((G) => {
      const U = M ? 0 : -n, B = M ? n : 0, K = M ? "end" : "start", ee = j[G][K];
      return {
        index: G,
        loopPoint: ee,
        slideLocation: Xl(-1),
        translate: wC(e, l[G]),
        target: () => s.get() > ee ? U : B
      };
    });
  }
  function b() {
    const _ = a[0], k = v(d, _);
    return x(k, n, !1);
  }
  function C() {
    const _ = t - a[0] - 1, k = v(u, _);
    return x(k, -n, !0);
  }
  function I() {
    return m.every(({
      index: _
    }) => {
      const k = u.filter((M) => M !== _);
      return h(k, t) <= 0.1;
    });
  }
  function T() {
    m.forEach((_) => {
      const {
        target: k,
        translate: M,
        slideLocation: j
      } = _, G = k();
      G !== j.get() && (M.to(G), j.set(G));
    });
  }
  function R() {
    m.forEach((_) => _.translate.clear());
  }
  return {
    canLoop: I,
    clear: R,
    loop: T,
    loopPoints: m
  };
}
function wG(e, t, n) {
  let r, o = !1;
  function i(l) {
    if (!n) return;
    function c(u) {
      for (const d of u)
        if (d.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((u) => {
      o || (Hf(n) || n(l, u)) && c(u);
    }), r.observe(e, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), o = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function EG(e, t, n, r) {
  const o = {};
  let i = null, a = null, s, l = !1;
  function c() {
    s = new IntersectionObserver((v) => {
      l || (v.forEach((g) => {
        const x = t.indexOf(g.target);
        o[x] = g;
      }), i = null, a = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((v) => s.observe(v));
  }
  function u() {
    s && s.disconnect(), l = !0;
  }
  function d(v) {
    return _c(o).reduce((g, x) => {
      const b = parseInt(x), {
        isIntersecting: C
      } = o[b];
      return (v && C || !v && !C) && g.push(b), g;
    }, []);
  }
  function m(v = !0) {
    if (v && i) return i;
    if (!v && a) return a;
    const g = d(v);
    return v && (i = g), v || (a = g), g;
  }
  return {
    init: c,
    destroy: u,
    get: m
  };
}
function IG(e, t, n, r, o, i) {
  const {
    measureSize: a,
    startEdge: s,
    endEdge: l
  } = e, c = n[0] && o, u = v(), d = g(), m = n.map(a), h = x();
  function v() {
    if (!c) return 0;
    const C = n[0];
    return Jt(t[s] - C[s]);
  }
  function g() {
    if (!c) return 0;
    const C = i.getComputedStyle(so(r));
    return parseFloat(C.getPropertyValue(`margin-${l}`));
  }
  function x() {
    return n.map((C, I, T) => {
      const R = !I, A = d0(T, I);
      return R ? m[I] + u : A ? m[I] + d : T[I + 1][s] - C[s];
    }).map(Jt);
  }
  return {
    slideSizes: m,
    slideSizesWithGaps: h,
    startGap: u,
    endGap: d
  };
}
function RG(e, t, n, r, o, i, a, s, l) {
  const {
    startEdge: c,
    endEdge: u,
    direction: d
  } = e, m = c0(n);
  function h(b, C) {
    return Tc(b).filter((I) => I % C === 0).map((I) => b.slice(I, I + C));
  }
  function v(b) {
    return b.length ? Tc(b).reduce((C, I, T) => {
      const R = so(C) || 0, A = R === 0, _ = I === eu(b), k = o[c] - i[R][c], M = o[c] - i[I][u], j = !r && A ? d(a) : 0, G = !r && _ ? d(s) : 0, U = Jt(M - G - (k + j));
      return T && U > t + l && C.push(I), _ && C.push(b.length), C;
    }, []).map((C, I, T) => {
      const R = Math.max(T[I - 1] || 0);
      return b.slice(R, C);
    }) : [];
  }
  function g(b) {
    return m ? h(b, n) : v(b);
  }
  return {
    groupSlides: g
  };
}
function TG(e, t, n, r, o, i, a) {
  const {
    align: s,
    axis: l,
    direction: c,
    startIndex: u,
    loop: d,
    duration: m,
    dragFree: h,
    dragThreshold: v,
    inViewThreshold: g,
    slidesToScroll: x,
    skipSnaps: b,
    containScroll: C,
    watchResize: I,
    watchSlides: T,
    watchDrag: R,
    watchFocus: A
  } = i, _ = 2, k = lG(), M = k.measure(t), j = n.map(k.measure), G = iG(l, c), U = G.measureSize(M), B = cG(U), K = rG(s, U), ee = !d && !!C, Y = d || !!C, {
    slideSizes: J,
    slideSizesWithGaps: ye,
    startGap: re,
    endGap: le
  } = IG(G, M, j, n, Y, o), Te = RG(G, U, x, d, M, j, re, le, _), {
    snaps: F,
    snapsAligned: Z
  } = vG(G, K, M, j, Te), se = -so(F) + so(ye), {
    snapsContained: ae,
    scrollContainLimit: ue
  } = mG(U, se, Z, C, _), te = ee ? ae : Z, {
    limit: he
  } = pG(se, te, d), ge = CC(eu(te), u, d), de = ge.clone(), xe = Tc(n), ce = ({
    dragHandler: nn,
    scrollBody: Nt,
    scrollBounds: wn,
    options: {
      loop: kn
    }
  }) => {
    kn || wn.constrain(nn.pointerDown()), Nt.seek();
  }, je = ({
    scrollBody: nn,
    translate: Nt,
    location: wn,
    offsetLocation: kn,
    previousLocation: hr,
    scrollLooper: gr,
    slideLooper: vr,
    dragHandler: Mr,
    animation: Kn,
    eventHandler: qe,
    scrollBounds: Ce,
    options: {
      loop: De
    }
  }, fe) => {
    const Ie = nn.settled(), tt = !Ce.shouldConstrain(), Me = De ? Ie : Ie && tt, kt = Me && !Mr.pointerDown();
    kt && Kn.stop();
    const Et = wn.get() * fe + hr.get() * (1 - fe);
    kn.set(Et), De && (gr.loop(nn.direction()), vr.loop()), Nt.to(kn.get()), kt && qe.emit("settle"), Me || qe.emit("scroll");
  }, z = oG(r, o, () => ce(Ot), (nn) => je(Ot, nn)), Ue = 0.68, st = te[ge.get()], Rt = Xl(st), dn = Xl(st), _t = Xl(st), L = Xl(st), q = dG(Rt, _t, dn, L, m, Ue), Q = bG(d, te, se, he, L), Se = SG(z, ge, de, q, Q, L, a), ve = gG(he), me = Oc(), Ne = EG(t, n, a, g), {
    slideRegistry: et
  } = yG(ee, C, te, ue, Te, xe), ot = xG(e, n, et, Se, q, me, a, A), Ot = {
    ownerDocument: r,
    ownerWindow: o,
    eventHandler: a,
    containerRect: M,
    slideRects: j,
    animation: z,
    axis: G,
    dragHandler: aG(G, e, r, o, L, sG(G, o), Rt, z, Se, q, Q, ge, a, B, h, v, b, Ue, R),
    eventStore: me,
    percentOfView: B,
    index: ge,
    indexPrevious: de,
    limit: he,
    location: Rt,
    offsetLocation: _t,
    previousLocation: dn,
    options: i,
    resizeHandler: uG(t, a, o, n, G, I, k),
    scrollBody: q,
    scrollBounds: fG(he, _t, L, q, B),
    scrollLooper: hG(se, he, _t, [Rt, _t, dn, L]),
    scrollProgress: ve,
    scrollSnapList: te.map(ve.get),
    scrollSnaps: te,
    scrollTarget: Q,
    scrollTo: Se,
    slideLooper: CG(G, U, se, J, ye, F, te, _t, n),
    slideFocus: ot,
    slidesHandler: wG(t, a, T),
    slidesInView: Ne,
    slideIndexes: xe,
    slideRegistry: et,
    slidesToScroll: Te,
    target: L,
    translate: wC(G, t)
  };
  return Ot;
}
function _G() {
  let e = {}, t;
  function n(c) {
    t = c;
  }
  function r(c) {
    return e[c] || [];
  }
  function o(c) {
    return r(c).forEach((u) => u(t, c)), l;
  }
  function i(c, u) {
    return e[c] = r(c).concat([u]), l;
  }
  function a(c, u) {
    return e[c] = r(c).filter((d) => d !== u), l;
  }
  function s() {
    e = {};
  }
  const l = {
    init: n,
    emit: o,
    off: a,
    on: i,
    clear: s
  };
  return l;
}
const OG = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function AG(e) {
  function t(i, a) {
    return xC(i, a || {});
  }
  function n(i) {
    const a = i.breakpoints || {}, s = _c(a).filter((l) => e.matchMedia(l).matches).map((l) => a[l]).reduce((l, c) => t(l, c), {});
    return t(i, s);
  }
  function r(i) {
    return i.map((a) => _c(a.breakpoints || {})).reduce((a, s) => a.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function kG(e) {
  let t = [];
  function n(i, a) {
    return t = a.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(i, e)), a.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((i) => i.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Jd(e, t, n) {
  const r = e.ownerDocument, o = r.defaultView, i = AG(o), a = kG(i), s = Oc(), l = _G(), {
    mergeOptions: c,
    optionsAtMedia: u,
    optionsMediaQueries: d
  } = i, {
    on: m,
    off: h,
    emit: v
  } = l, g = G;
  let x = !1, b, C = c(OG, Jd.globalOptions), I = c(C), T = [], R, A, _;
  function k() {
    const {
      container: xe,
      slides: ce
    } = I;
    A = (Kh(xe) ? e.querySelector(xe) : xe) || e.children[0];
    const z = Kh(ce) ? A.querySelectorAll(ce) : ce;
    _ = [].slice.call(z || A.children);
  }
  function M(xe) {
    const ce = TG(e, A, _, r, o, xe, l);
    if (xe.loop && !ce.slideLooper.canLoop()) {
      const je = Object.assign({}, xe, {
        loop: !1
      });
      return M(je);
    }
    return ce;
  }
  function j(xe, ce) {
    x || (C = c(C, xe), I = u(C), T = ce || T, k(), b = M(I), d([C, ...T.map(({
      options: je
    }) => je)]).forEach((je) => s.add(je, "change", G)), I.active && (b.translate.to(b.location.get()), b.animation.init(), b.slidesInView.init(), b.slideFocus.init(de), b.eventHandler.init(de), b.resizeHandler.init(de), b.slidesHandler.init(de), b.options.loop && b.slideLooper.loop(), A.offsetParent && _.length && b.dragHandler.init(de), R = a.init(de, T)));
  }
  function G(xe, ce) {
    const je = Te();
    U(), j(c({
      startIndex: je
    }, xe), ce), l.emit("reInit");
  }
  function U() {
    b.dragHandler.destroy(), b.eventStore.clear(), b.translate.clear(), b.slideLooper.clear(), b.resizeHandler.destroy(), b.slidesHandler.destroy(), b.slidesInView.destroy(), b.animation.destroy(), a.destroy(), s.clear();
  }
  function B() {
    x || (x = !0, s.clear(), U(), l.emit("destroy"), l.clear());
  }
  function K(xe, ce, je) {
    !I.active || x || (b.scrollBody.useBaseFriction().useDuration(ce === !0 ? 0 : I.duration), b.scrollTo.index(xe, je || 0));
  }
  function ee(xe) {
    const ce = b.index.add(1).get();
    K(ce, xe, -1);
  }
  function Y(xe) {
    const ce = b.index.add(-1).get();
    K(ce, xe, 1);
  }
  function J() {
    return b.index.add(1).get() !== Te();
  }
  function ye() {
    return b.index.add(-1).get() !== Te();
  }
  function re() {
    return b.scrollSnapList;
  }
  function le() {
    return b.scrollProgress.get(b.offsetLocation.get());
  }
  function Te() {
    return b.index.get();
  }
  function F() {
    return b.indexPrevious.get();
  }
  function Z() {
    return b.slidesInView.get();
  }
  function se() {
    return b.slidesInView.get(!1);
  }
  function ae() {
    return R;
  }
  function ue() {
    return b;
  }
  function te() {
    return e;
  }
  function he() {
    return A;
  }
  function ge() {
    return _;
  }
  const de = {
    canScrollNext: J,
    canScrollPrev: ye,
    containerNode: he,
    internalEngine: ue,
    destroy: B,
    off: h,
    on: m,
    emit: v,
    plugins: ae,
    previousScrollSnap: F,
    reInit: g,
    rootNode: te,
    scrollNext: ee,
    scrollPrev: Y,
    scrollProgress: le,
    scrollSnapList: re,
    scrollTo: K,
    selectedScrollSnap: Te,
    slideNodes: ge,
    slidesInView: Z,
    slidesNotInView: se
  };
  return j(t, n), setTimeout(() => l.emit("init"), 0), de;
}
Jd.globalOptions = void 0;
function f0(e = {}, t = []) {
  const n = He(e), r = He(t), [o, i] = Fe(), [a, s] = Fe(), l = Ke(() => {
    o && o.reInit(n.current, r.current);
  }, [o]);
  return Le(() => {
    l0(n.current, e) || (n.current = e, l());
  }, [e, l]), Le(() => {
    eG(r.current, t) || (r.current = t, l());
  }, [t, l]), Le(() => {
    if (QB() && a) {
      Jd.globalOptions = f0.globalOptions;
      const c = Jd(a, n.current, r.current);
      return i(c), () => c.destroy();
    } else
      i(void 0);
  }, [a, i]), [s, o];
}
f0.globalOptions = void 0;
const EC = S.createContext(null);
function m0() {
  const e = S.useContext(EC);
  if (!e)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
const DG = S.forwardRef(
  ({
    orientation: e = "horizontal",
    opts: t,
    setApi: n,
    plugins: r,
    className: o,
    children: i,
    ...a
  }, s) => {
    const [l, c] = f0(
      {
        ...t,
        axis: e === "horizontal" ? "x" : "y"
      },
      r
    ), [u, d] = S.useState(!1), [m, h] = S.useState(!1), v = S.useCallback((I) => {
      I && (d(I.canScrollPrev()), h(I.canScrollNext()));
    }, []), g = S.useCallback(() => {
      c == null || c.scrollPrev();
    }, [c]), x = S.useCallback(() => {
      c == null || c.scrollNext();
    }, [c]), b = S.useCallback(
      (I) => {
        I.key === "ArrowLeft" ? (I.preventDefault(), g()) : I.key === "ArrowRight" && (I.preventDefault(), x());
      },
      [g, x]
    );
    S.useEffect(() => {
      !c || !n || n(c);
    }, [c, n]), S.useEffect(() => {
      if (c)
        return v(c), c.on("reInit", v), c.on("select", v), () => {
          c.off("select", v);
        };
    }, [c, v]);
    const C = S.useMemo(
      () => ({
        carouselRef: l,
        api: c,
        opts: t,
        orientation: e,
        scrollPrev: g,
        scrollNext: x,
        canScrollPrev: u,
        canScrollNext: m
      }),
      [
        c,
        m,
        u,
        l,
        t,
        e,
        x,
        g
      ]
    );
    return /* @__PURE__ */ f.jsx(EC.Provider, { value: C, children: /* @__PURE__ */ f.jsx(
      "div",
      {
        ref: s,
        onKeyDownCapture: b,
        className: o,
        role: "region",
        "aria-roledescription": "carousel",
        ...a,
        children: i
      }
    ) });
  }
);
DG.displayName = "Carousel";
const PG = S.forwardRef(({ className: e, ...t }, n) => {
  const { carouselRef: r, orientation: o } = m0();
  return /* @__PURE__ */ f.jsx("div", { ref: r, className: "size-full overflow-hidden", children: /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: n,
      className: oe(
        "flex gap-4",
        o !== "horizontal" && "flex-col",
        e
      ),
      ...t
    }
  ) });
});
PG.displayName = "CarouselContent";
const NG = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  "div",
  {
    ref: n,
    role: "group",
    "aria-roledescription": "slide",
    className: oe("min-w-0 shrink-0 grow-0 basis-full", e),
    ...t
  }
));
NG.displayName = "CarouselItem";
const MG = S.forwardRef(({ className: e, variant: t = "default", size: n = "default", ...r }, o) => {
  const { orientation: i, scrollPrev: a, canScrollPrev: s } = m0();
  return /* @__PURE__ */ f.jsxs(
    en,
    {
      ref: o,
      variant: t,
      size: n,
      icon: !0,
      className: oe(
        "rounded-full",
        i !== "horizontal" && "rotate-90",
        e
      ),
      disabled: !s,
      onClick: a,
      ...r,
      children: [
        /* @__PURE__ */ f.jsx(Ve, { icon: "arrowLeft" }),
        /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Previous slide" })
      ]
    }
  );
});
MG.displayName = "CarouselPrevious";
const FG = S.forwardRef(({ className: e, variant: t = "default", size: n = "default", ...r }, o) => {
  const { orientation: i, scrollNext: a, canScrollNext: s } = m0();
  return /* @__PURE__ */ f.jsxs(
    en,
    {
      ref: o,
      variant: t,
      size: n,
      icon: !0,
      className: oe(
        "rounded-full",
        i !== "horizontal" && "rotate-90",
        e
      ),
      disabled: !s,
      onClick: a,
      ...r,
      children: [
        /* @__PURE__ */ f.jsx(Ve, { icon: "arrowRight" }),
        /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Next slide" })
      ]
    }
  );
});
FG.displayName = "CarouselNext";
const No = [
  "var(--color-chart-1)",
  "var(--color-chart-2)",
  "var(--color-chart-3)",
  "var(--color-chart-4)",
  "var(--color-chart-5)"
], qf = ({
  className: e,
  children: t,
  ...n
}) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: oe(
      "h-64 w-full min-w-0 text-xs [&_.recharts-cartesian-axis-tick_text]:fill-neutral-500 [&_.recharts-cartesian-grid_line]:stroke-neutral-200",
      e
    ),
    ...n,
    children: /* @__PURE__ */ f.jsx(tx, { width: "100%", height: "100%", children: t })
  }
), IC = ({
  heading: e,
  hidden: t = !1,
  children: n
}) => /* @__PURE__ */ f.jsxs(
  "output",
  {
    "aria-live": "assertive",
    className: oe(
      "flex flex-col gap-1 rounded-lg border border-neutral-200 bg-white px-3 py-2 text-xs shadow-sm",
      t && "hidden"
    ),
    children: [
      e && /* @__PURE__ */ f.jsx("p", { className: "text-neutral-500", children: e }),
      n
    ]
  }
), RC = ({
  color: e,
  name: t,
  value: n
}) => /* @__PURE__ */ f.jsxs("span", { className: "flex items-center gap-2 text-neutral-900", children: [
  /* @__PURE__ */ f.jsx(
    "span",
    {
      "aria-hidden": !0,
      className: "size-2 shrink-0 rounded-sm",
      style: { backgroundColor: e }
    }
  ),
  /* @__PURE__ */ f.jsx("span", { children: t }),
  /* @__PURE__ */ f.jsx("span", { className: "ml-auto pl-2 font-medium tabular-nums", children: n })
] }), LG = ({
  active: e,
  payload: t,
  label: n,
  formatLabel: r = (i) => i,
  formatValue: o = (i) => `${i}`
}) => {
  const i = e ? t ?? [] : [];
  return /* @__PURE__ */ f.jsx(
    IC,
    {
      heading: i.length > 0 && typeof n == "string" && n !== "" ? r(n) : void 0,
      hidden: i.length === 0,
      children: i.length > 0 && /* @__PURE__ */ f.jsx("ul", { className: "flex flex-col gap-1", children: i.map((a) => /* @__PURE__ */ f.jsx("li", { children: /* @__PURE__ */ f.jsx(
        RC,
        {
          color: a.color,
          name: a.name,
          value: typeof a.value == "number" ? o(a.value) : a.value
        }
      ) }, a.name)) })
    }
  );
}, TC = ({
  cursor: e = { fill: "var(--color-neutral-100)" },
  formatLabel: t,
  formatValue: n,
  ...r
}) => /* @__PURE__ */ f.jsx(
  nx,
  {
    cursor: e,
    ...r,
    content: /* @__PURE__ */ f.jsx(
      LG,
      {
        formatLabel: t,
        formatValue: n
      }
    )
  }
), $l = (e, { locale: t, ...n }) => new Intl.NumberFormat(t, n).format(e), _C = (e, t = !1, { locale: n, ...r } = {}) => new Intl.NumberFormat(n, {
  notation: t ? "compact" : "standard",
  style: "currency",
  currency: e,
  ...r
}), $G = (e) => {
  var n;
  return ((n = _C(e).formatToParts(1).find((r) => r.type === "currency")) == null ? void 0 : n.value) ?? e;
}, OC = (e, { locale: t, ...n } = { dateStyle: "medium" }) => new Intl.DateTimeFormat(t, n).format(new Date(e)), zG = (e, { locale: t, ...n } = {
  dateStyle: "full",
  timeStyle: "long"
}) => new Intl.DateTimeFormat(t, n).format(new Date(e)), Qd = (e) => Number.isNaN(new Date(e).getTime()), AC = (e, t = !1) => {
  const n = new Date(e);
  if (Qd(n))
    return "Invalid Date";
  const r = /* @__PURE__ */ new Date(), o = li(r), i = tC(o, 1), a = Cj(o), s = wj(o), l = n.toLocaleTimeString(void 0, { timeStyle: "short" }).toLocaleLowerCase();
  return t ? `${n.toLocaleDateString(void 0, { dateStyle: "long" })} at ${l}` : n > r ? `${n.toLocaleDateString(void 0, { dateStyle: "medium" })} at ${l}` : n >= i && n < r ? `${n < o ? "Yesterday" : "Today"} at ${l}` : n >= a ? `${n.toLocaleDateString(void 0, { weekday: "long" })} at ${l}` : n >= s ? `${n.toLocaleDateString(void 0, {
    month: "short",
    day: "numeric"
  })} at ${l}` : OC(n);
}, jG = (e, t, n) => {
  const r = new Intl.PluralRules(n, { type: "cardinal" }).select(e);
  return t[r] ?? t.other;
}, dt = {
  number: $l,
  count: (e, t = !1, n = {}) => $l(e, {
    notation: t ? "compact" : "standard",
    style: "decimal",
    ...n
  }),
  percent: (e, t = !1, n = {}) => $l(e, {
    notation: t ? "compact" : "standard",
    minimumSignificantDigits: 2,
    maximumSignificantDigits: 4,
    style: "percent",
    ...n
  }),
  // one place, so a column of parts lines up; a part too small to round above zero still reads as some
  share: (e, t = {}) => {
    const n = {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
      ...t
    };
    return e > 0 && e < 5e-4 ? `<${$l(1e-3, n)}` : $l(e, n);
  },
  currencySymbol: $G,
  currency: (e, t, n = !1, r = {}) => _C(t, n, r).format(e),
  date: OC,
  dateTime: zG,
  isInvalidDate: Qd,
  relativeDateTime: AC,
  relativeTimeFromNow: (e) => Yz(e, /* @__PURE__ */ new Date(), { addSuffix: !0 }),
  list: {
    and: (e) => new Intl.ListFormat(void 0, { type: "conjunction" }).format(e),
    or: (e) => new Intl.ListFormat(void 0, { type: "disjunction" }).format(e),
    unit: (e) => new Intl.ListFormat(void 0, { type: "unit" }).format(e)
  },
  plural: jG
}, BG = /* @__PURE__ */ new Set(["assets.corso.com", "assets.stg.corso.com"]);
function GG(e) {
  if (!e.startsWith("https://"))
    return e;
  const t = new URL(e);
  return BG.has(t.hostname) ? (t.searchParams.set("optimize", "true"), t.toString()) : e;
}
function Xh(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, o]) => t.indexOf(+r) === -1).map(([r, o]) => o);
}
function Fb(e, t = "|") {
  return e.map((n) => MC(n)).join(t);
}
function Jh(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
class VG {
  constructor(t) {
    this._getter = t, this._value = void 0;
  }
  get value() {
    const t = this._getter;
    return t !== void 0 && (this._value = t(), this._getter = void 0), this._value;
  }
}
function Yf(e) {
  return new VG(e);
}
function UG(e) {
  return e == null;
}
function p0(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function WG(e, t) {
  const n = e / t, r = Math.round(n), o = 4 * Number.EPSILON * Math.max(Math.abs(n), 1);
  return Math.abs(n - r) < o ? 0 : n - r;
}
function yi(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function h0(e) {
  const t = Object.getOwnPropertyDescriptor(e, "shape");
  return t != null && t.get ? t.get.raw : t == null ? void 0 : t.value;
}
function ci(e) {
  return h0(e._zod.def) ?? e._zod.def.shape;
}
function kC(e, t, n) {
  Object.defineProperty(e, t, {
    get() {
      const r = n();
      return yi(this, t, r), r;
    },
    enumerable: !0,
    configurable: !0
  });
}
function DC(e, t, n) {
  t in e ? yi(e, t, n) : e[t] = n;
}
function za(e, t, n, r) {
  const o = ci(t);
  for (const i of n) {
    const a = Object.getOwnPropertyDescriptor(o, i);
    a.enumerable && (a.get ? kC(e, i, () => {
      const s = t._zod.def.shape[i];
      return r ? r(s, i) : s;
    }) : DC(e, i, r ? r(a.value, i) : a.value));
  }
}
function HG(e, t) {
  for (const n of Reflect.ownKeys(t)) {
    const r = Object.getOwnPropertyDescriptor(t, n);
    r.enumerable && (r.get ? kC(e, n, () => t[n]) : DC(e, n, r.value));
  }
}
function wr(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function qG(e) {
  return JSON.stringify(e);
}
function YG(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const PC = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Ac(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const KG = /* @__PURE__ */ Yf(() => {
  var e;
  if (Ur.jitless || typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function qs(e) {
  if (Ac(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(Ac(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function NC(e) {
  return qs(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
const ZG = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Ys(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function sa(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function Oe(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function MC(e) {
  return typeof e == "bigint" ? e.toString() + "n" : typeof e == "string" ? `"${e}"` : `${e}`;
}
function XG(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin !== void 0 && e[t]._zod.optout === "optional");
}
const FC = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
}, JG = {
  int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
  uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
};
function QG(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = {};
  return za(i, e, Kf(e, t)), sa(e, wr(n, { shape: i, checks: [] }));
}
function Kf(e, t) {
  var o;
  const n = ci(e), r = [];
  for (const i of Reflect.ownKeys(t)) {
    if (!((o = Object.getOwnPropertyDescriptor(n, i)) != null && o.enumerable))
      throw new Error(`Unrecognized key: "${String(i)}"`);
    t[i] && r.push(i);
  }
  return r;
}
function eV(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = new Set(Kf(e, t)), a = {};
  return za(a, e, Reflect.ownKeys(ci(e)).filter((s) => !i.has(s))), sa(e, wr(n, { shape: a, checks: [] }));
}
function tV(e, t) {
  if (!qs(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const o = ci(e);
    for (const i of Reflect.ownKeys(t))
      if (Object.getOwnPropertyDescriptor(o, i) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  return sa(e, wr(e._zod.def, { shape: LC(e, t) }));
}
function LC(e, t) {
  const n = {};
  return za(n, e, Reflect.ownKeys(ci(e))), HG(n, t), n;
}
function nV(e, t) {
  if (!qs(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  return sa(e, wr(e._zod.def, { shape: LC(e, t) }));
}
function rV(e, t) {
  var o, i;
  if (!((o = t == null ? void 0 : t._zod) != null && o.def))
    throw new Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
  if ((i = e._zod.def.checks) != null && i.length)
    throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
  const n = {};
  za(n, e, Reflect.ownKeys(ci(e))), za(n, t, Reflect.ownKeys(ci(t)));
  const r = wr(e._zod.def, {
    shape: n,
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: t._zod.def.checks ?? []
  });
  return sa(e, r);
}
function Lb(e, t, n, r = "partial") {
  const i = t._zod.def.checks;
  if (i && i.length > 0)
    throw new Error(`.${r}() cannot be used on object schemas containing refinements`);
  const s = n ? new Set(Kf(t, n)) : void 0, l = {};
  return za(l, t, Reflect.ownKeys(ci(t)), e && ((c, u) => s && !s.has(u) ? c : new e({ type: "optional", innerType: c }))), sa(t, wr(t._zod.def, { shape: l, checks: [] }));
}
function oV(e, t, n) {
  const r = n ? new Set(Kf(t, n)) : void 0, o = {};
  return za(o, t, Reflect.ownKeys(ci(t)), (i, a) => (
    // overwrite with non-optional
    r && !r.has(a) ? i : new e({ type: "nonoptional", innerType: i })
  )), sa(t, wr(t._zod.def, { shape: o }));
}
function ao(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function iV(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) === !1)
      return !0;
  return !1;
}
function Fi(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function zl(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function $b(e, t, n) {
  var r;
  for (let o = t; o < e.length; o++)
    (r = e[o]).schema ?? (r.schema = n);
}
function qi(e, t, n) {
  var l, c, u, d, m, h, v, g, x, b;
  var r;
  const o = (c = (l = e.inst) == null ? void 0 : l._zod) == null ? void 0 : c.traits;
  o != null && o.has("$ZodType") && (o.has("$ZodCheck") ? (r = e).schema ?? (r.schema = e.inst) : e.schema = e.inst);
  const i = e.schema !== e.inst ? (d = (u = e.schema) == null ? void 0 : u._zod.def) == null ? void 0 : d.error : void 0, a = e.message ? e.message : zl((v = (h = (m = e.inst) == null ? void 0 : m._zod.def) == null ? void 0 : h.error) == null ? void 0 : v.call(h, e)) ?? zl(i == null ? void 0 : i(e)) ?? zl((g = t == null ? void 0 : t.error) == null ? void 0 : g.call(t, e)) ?? zl((x = n.customError) == null ? void 0 : x.call(n, e)) ?? zl((b = n.localeError) == null ? void 0 : b.call(n, e)) ?? "Invalid input", s = {};
  for (const C of Object.keys(e))
    C === "inst" || C === "schema" || C === "continue" || C === "input" || C === "__proto__" || (s[C] = e[C]);
  return s.path ?? (s.path = []), s.message = a, t != null && t.reportInput && (s.input = e.input), s;
}
const aV = /[\uD800-\uDBFF]/;
function g0(e) {
  const t = e.length;
  if (!aV.test(e))
    return t;
  let n = t;
  for (let r = 0; r < t - 1; r++)
    (e.charCodeAt(r) & 64512) === 55296 && (e.charCodeAt(r + 1) & 64512) === 56320 && (n--, r++);
  return n;
}
function v0(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function sV(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "nan" : "number";
    case "object": {
      if (e === null)
        return "null";
      if (Array.isArray(e))
        return "array";
      const n = e;
      if (n && Object.getPrototypeOf(n) !== Object.prototype && "constructor" in n && n.constructor)
        return n.constructor.name;
    }
  }
  return t;
}
function kc(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
function lV(e, t) {
  for (const n in t) {
    const r = Object.getOwnPropertyDescriptor(t, n);
    r.get ? Object.defineProperty(e, n, { ...r, enumerable: !1 }) : cV(e, n, r.value);
  }
}
function Yi(e, t, n, r = !0) {
  return Object.defineProperty(e, t, { configurable: !0, writable: !0, enumerable: r, value: n }), n;
}
function $C(e, t, n) {
  return Yi(e, t, n, !1);
}
function y0(e, t) {
  for (const n in e) {
    const r = e[n];
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !0,
      get() {
        return Yi(this, n, r(this));
      },
      set(o) {
        Yi(this, n, o);
      }
    });
  }
  return t;
}
function cV(e, t, n) {
  Object.defineProperty(e, t, {
    configurable: !0,
    get() {
      return this == null ? n : Yi(this, t, n.bind(this));
    },
    set(r) {
      Yi(this, t, r);
    }
  });
}
function uV(e, t) {
  const n = Object.getPrototypeOf(e);
  return t in n ? void 0 : n;
}
let Ep, wi = !1;
const dV = {
  configurable: !0,
  get() {
    wi = !0;
  }
};
function yt(e, t, n) {
  const r = Object.getPrototypeOf(e._zod);
  if (t in r && Ep !== e._zod) {
    Ep = void 0;
    return;
  }
  Ep = e._zod, Object.defineProperty(r, t, {
    configurable: !0,
    get() {
      Object.defineProperty(this, t, dV);
      const o = wi;
      wi = !1;
      try {
        const i = n(this);
        return wi ? delete this[t] : Object.defineProperty(this, t, { configurable: !0, writable: !0, value: i }), wi = wi || o, i;
      } catch (i) {
        throw delete this[t], wi = wi || o, i;
      }
    },
    set(o) {
      Object.defineProperty(this, t, { configurable: !0, writable: !0, value: o });
    }
  });
}
function fV(e, t, n, r) {
  const o = uV(e, t);
  o && Object.defineProperty(o, t, {
    configurable: !0,
    get() {
      const i = { configurable: !0, writable: !0, enumerable: r, value: void 0 };
      return Object.defineProperty(this, t, i), i.value = n(this), Object.defineProperty(this, t, i), i.value;
    },
    set(i) {
      Object.defineProperty(this, t, { configurable: !0, writable: !0, enumerable: r, value: i });
    }
  });
}
const mV = "~constantCatch";
function pV(e) {
  const t = () => e;
  return t[mV] = !0, t;
}
var zb;
const hV = /* @__PURE__ */ Object.freeze({
  status: "aborted"
}), Ip = { value: void 0, enumerable: !1 };
let jb = "captureStackTrace" in Error ? Error : null;
function gV(e) {
  const t = jb;
  if (t) {
    const n = t.stackTraceLimit;
    if (typeof n == "number") {
      try {
        t.stackTraceLimit = 0;
      } catch {
        return jb = null, new e();
      }
      try {
        return new e();
      } finally {
        t.stackTraceLimit = n;
      }
    }
  }
  return new e();
}
function ie(e, t, n, r) {
  const o = {};
  function i(m) {
    this.def = m, this.constr = d, this.traits = /* @__PURE__ */ new Set();
  }
  i.prototype = o;
  const a = n, s = a && /* @__PURE__ */ new WeakSet();
  function l(m, h) {
    if (m._zod) {
      if (m._zod.traits.has(e))
        return;
    } else {
      Ip.value = new i(h);
      try {
        Object.defineProperty(m, "_zod", Ip);
      } finally {
        Ip.value = void 0;
      }
    }
    if (m._zod.traits.add(e), t(m, h), s) {
      const g = Object.getPrototypeOf(m), x = m._zod.constr.prototype;
      let b = g;
      for (; b && b !== x; )
        b = Object.getPrototypeOf(b);
      const C = b ?? g;
      s.has(C) || (s.add(C), lV(C, a));
    }
    const v = d.prototype;
    for (const g in v)
      Object.prototype.hasOwnProperty.call(v, g) && (g in m || (m[g] = v[g].bind(m)));
  }
  const c = (r == null ? void 0 : r.Parent) ?? Object;
  class u extends c {
  }
  Object.defineProperty(u, "name", { value: e });
  function d(m) {
    var x;
    const h = r != null && r.Parent ? gV(u) : this;
    l(h, m);
    const v = h._zod.deferred;
    if (v) {
      for (const b of v)
        b();
      h._zod.deferred = void 0;
    }
    const g = (x = globalThis.__zod_globalConfig) == null ? void 0 : x.postProcessor;
    return g && g(h), h;
  }
  return Object.defineProperty(d, "init", { value: l }), Object.defineProperty(d, Symbol.hasInstance, {
    value: (m) => {
      var h, v;
      return r != null && r.Parent && m instanceof r.Parent ? !0 : (v = (h = m == null ? void 0 : m._zod) == null ? void 0 : h.traits) == null ? void 0 : v.has(e);
    }
  }), Object.defineProperty(d, "name", { value: e }), d;
}
class Da extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class zC extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
(zb = globalThis).__zod_globalConfig ?? (zb.__zod_globalConfig = {});
const Ur = globalThis.__zod_globalConfig;
function Lo(e) {
  return e && Object.assign(Ur, e), Ur;
}
function vV() {
  const e = this._zod;
  return e.message ?? (e.message = JSON.stringify(e.def, Jh, 2)), e.message;
}
function yV(e) {
  this._zod.message = e;
}
const bV = {
  get: vV,
  set: yV,
  enumerable: !0,
  configurable: !0
}, Rp = { value: void 0, enumerable: !1 }, Bb = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]), SV = (e, t) => {
  e.name = "$ZodError", Rp.value = t, Object.defineProperty(e, "issues", Rp), Rp.value = void 0, Object.defineProperty(e, "message", bV);
  const n = Object.getPrototypeOf(e);
  Bb.has(n) || (Bb.add(n), Object.defineProperty(n, "toString", {
    configurable: !0,
    enumerable: !1,
    get() {
      const r = () => this.message;
      return Object.defineProperty(this, "toString", { value: r, configurable: !0, writable: !0 }), r;
    },
    set(r) {
      Object.defineProperty(this, "toString", { value: r, configurable: !0, writable: !0 });
    }
  }));
}, xV = ie("$ZodError", SV);
function CV(e, t, n) {
  return Object.prototype.hasOwnProperty.call(e, t) || (t === "__proto__" ? Object.defineProperty(e, t, { value: n(), writable: !0, enumerable: !0, configurable: !0 }) : e[t] = n()), e[t];
}
function wV(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const o of e.issues)
    o.path.length > 0 ? CV(n, o.path[0], () => []).push(t(o)) : r.push(t(o));
  return { formErrors: r, fieldErrors: n };
}
function EV(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (o, i = []) => {
    for (const a of o.issues)
      if (a.code === "invalid_union" && a.errors.length)
        a.errors.map((s) => r({ issues: s }, [...i, ...a.path]));
      else if (a.code === "invalid_key")
        r({ issues: a.issues }, [...i, ...a.path]);
      else if (a.code === "invalid_element")
        r({ issues: a.issues }, [...i, ...a.path]);
      else {
        const s = [...i, ...a.path];
        if (s.length === 0)
          n._errors.push(t(a));
        else {
          let l = n, c = 0;
          for (; c < s.length; ) {
            const u = s[c], d = c === s.length - 1;
            if (u === "_errors") {
              d && l._errors.push(t(a)), c++;
              continue;
            }
            Object.prototype.hasOwnProperty.call(l, u) || Object.defineProperty(l, u, {
              value: { _errors: [] },
              enumerable: !0,
              writable: !0,
              configurable: !0
            });
            const m = l[u];
            d && m._errors.push(t(a)), l = m, c++;
          }
        }
      }
  };
  return r(e), n;
}
function Zf(e, t) {
  return { callee: (t == null ? void 0 : t.callee) ?? e, Err: t == null ? void 0 : t.Err };
}
const b0 = (e) => {
  const t = (n, r, o, i) => {
    const a = o ? { ...o, async: !1 } : { async: !1 }, s = n._zod.run({ value: r, issues: [] }, a);
    if (s instanceof Promise)
      throw new Da();
    if (s.issues.length) {
      const l = new ((i == null ? void 0 : i.Err) ?? e)(s.issues.map((c) => qi(c, a, Lo())));
      throw PC(l, (i == null ? void 0 : i.callee) ?? t), l;
    }
    return s.value;
  };
  return t;
}, S0 = (e) => {
  const t = async (n, r, o, i) => {
    const a = o ? { ...o, async: !0 } : { async: !0 };
    let s = n._zod.run({ value: r, issues: [] }, a);
    if (s instanceof Promise && (s = await s), s.issues.length) {
      const l = new ((i == null ? void 0 : i.Err) ?? e)(s.issues.map((c) => qi(c, a, Lo())));
      throw PC(l, (i == null ? void 0 : i.callee) ?? t), l;
    }
    return s.value;
  };
  return t;
}, x0 = (e) => (t, n, r) => {
  const o = r ? { ...r, async: !1 } : { async: !1 }, i = t._zod.run({ value: n, issues: [] }, o);
  if (i instanceof Promise)
    throw new Da();
  return i.issues.length ? jC(e, i.issues, o) : { success: !0, data: i.value };
};
function jC(e, t, n) {
  let r;
  return {
    success: !1,
    get error() {
      return r || (r = new e(t.map((o) => qi(o, n, Lo()))), t = void 0, n = void 0), r;
    },
    set error(o) {
      r = o, t = void 0, n = void 0;
    }
  };
}
const C0 = (e) => async (t, n, r) => {
  const o = r ? { ...r, async: !0 } : { async: !0 };
  let i = t._zod.run({ value: n, issues: [] }, o);
  return i instanceof Promise && (i = await i), i.issues.length ? jC(e, i.issues, o) : { success: !0, data: i.value };
}, IV = /* @__PURE__ */ Symbol.for("zod.compile.invalid"), RV = /* @__PURE__ */ Symbol.for("zod.compile.fallback"), TV = ((e, t, n) => {
  const r = e._zod.bag.validator;
  if (r !== void 0) {
    if (r(t) !== IV)
      return !0;
    if (r.definite === !0 && n === void 0)
      return !1;
  }
  return _V(e, t, n);
});
function _V(e, t, n) {
  const r = n ? { ...n, async: !1, abortEarly: !0 } : { async: !1, abortEarly: !0 }, o = e._zod.bag.fallbackRun;
  let i;
  if (o ? (r[RV] = !0, i = o({ value: t, issues: [] }, r)) : i = e._zod.run({ value: t, issues: [] }, r), i instanceof Promise)
    throw new Da();
  return i.issues.length === 0;
}
const OV = async (e, t, n) => {
  const r = n ? { ...n, async: !0, abortEarly: !0 } : { async: !0, abortEarly: !0 };
  let o = e._zod.run({ value: t, issues: [] }, r);
  return o instanceof Promise && (o = await o), o.issues.length === 0;
}, AV = (e) => {
  const t = b0(e), n = (r, o, i, a) => {
    const s = i ? { ...i, direction: "backward" } : { direction: "backward" };
    return t(r, o, s, Zf(n, a));
  };
  return n;
}, kV = (e) => {
  const t = b0(e), n = (r, o, i, a) => t(r, o, i, Zf(n, a));
  return n;
}, DV = (e) => {
  const t = S0(e), n = async (r, o, i, a) => {
    const s = i ? { ...i, direction: "backward" } : { direction: "backward" };
    return await t(r, o, s, Zf(n, a));
  };
  return n;
}, PV = (e) => {
  const t = S0(e), n = async (r, o, i, a) => await t(r, o, i, Zf(n, a));
  return n;
}, NV = (e) => (t, n, r) => {
  const o = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return x0(e)(t, n, o);
}, MV = (e) => (t, n, r) => x0(e)(t, n, r), FV = (e) => async (t, n, r) => {
  const o = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return C0(e)(t, n, o);
}, LV = (e) => async (t, n, r) => C0(e)(t, n, r), $V = /^[cC][0-9a-z]{6,}$/, zV = /^[0-9a-z]+$/, jV = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/, BV = /^[0-9a-vA-V]{20}$/, GV = /^[A-Za-z0-9]{27}$/, VV = /^[a-zA-Z0-9_-]{21}$/;
function UV(e) {
  return new RegExp(`^[a-zA-Z0-9_-]{${e}}$`);
}
const WV = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, HV = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Gb = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, qV = /^(?:[A-Za-z0-9_'+\-]+\.)*[A-Za-z0-9_'+\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, YV = "^(?=[\\s\\S]*[\\p{Extended_Pictographic}\\p{Regional_Indicator}\\u20E3])[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$";
function KV() {
  return new RegExp(YV, "u");
}
const ZV = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, XV = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, JV = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, QV = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, eU = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, tU = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2,3})?$/, nU = /^(?=.{1,253}$)([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/, rU = /^https?$/, oU = /^\+[1-9]\d{6,14}$/, BC = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))";
function iU(e) {
  return new RegExp(`^${e}$`);
}
const aU = /* @__PURE__ */ iU(BC);
function Qh(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : e.seconds ? `${t}:[0-5]\\d(?:\\.\\d+)?` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function sU(e) {
  return new RegExp(`^${Qh(e)}$`);
}
function lU(e) {
  const t = ["Z"];
  e.offset && t.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const n = `${Qh({ precision: e.precision, seconds: !0 })}(?:${t.join("|")})`, r = e.local ? `${n}|${Qh({ precision: e.precision })}` : n;
  return new RegExp(`^${BC}T(?:${r})$`);
}
const cU = /^[\s\S]{0,}$/, uU = /^-?\d+$/, w0 = /^-?\d+(?:\.\d+)?$/, dU = /^(?:true|false)$/i, fU = /^null$/i, mU = /^[^A-Z]*$/, pU = /^[^a-z]*$/, mr = /* @__PURE__ */ ie("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), E0 = (e) => {
  const t = e.value;
  return !UG(t) && t.length !== void 0;
}, ef = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, GC = /* @__PURE__ */ ie("$ZodCheckLessThan", (e, t) => {
  mr.init(e, t);
  const n = ef[typeof t.value];
  e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: ef[typeof r.value] ?? n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), VC = /* @__PURE__ */ ie("$ZodCheckGreaterThan", (e, t) => {
  mr.init(e, t);
  const n = ef[typeof t.value];
  e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: ef[typeof r.value] ?? n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), hU = /* @__PURE__ */ ie("$ZodCheckMultipleOf", (e, t) => {
  mr.init(e, t), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? (
      // `value % 0n` throws, and nothing is a multiple of zero — the number branch already fails this way via NaN
      t.value !== BigInt(0) && n.value % t.value === BigInt(0)
    ) : WG(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), gU = /* @__PURE__ */ ie("$ZodCheckNumberFormat", (e, t) => {
  var a;
  mr.init(e, t), t.format = t.format || "float64";
  const n = (a = t.format) == null ? void 0 : a.includes("int"), r = n ? "int" : "number", [o, i] = FC[t.format];
  e._zod.check = (s) => {
    const l = s.value;
    if (n) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: r,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > i && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), vU = /* @__PURE__ */ ie("$ZodCheckMaxLength", (e, t) => {
  var n;
  mr.init(e, t), (n = e._zod.def).when ?? (n.when = E0), e._zod.check = (r) => {
    const o = r.value, i = o.length;
    if ((typeof o == "string" && i > t.maximum ? g0(o) : i) <= t.maximum)
      return;
    const s = v0(o);
    r.issues.push({
      origin: s,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), yU = /* @__PURE__ */ ie("$ZodCheckMinLength", (e, t) => {
  var n;
  mr.init(e, t), (n = e._zod.def).when ?? (n.when = E0), e._zod.check = (r) => {
    const o = r.value, i = o.length;
    if ((typeof o == "string" && i >= t.minimum && i < t.minimum * 2 ? g0(o) : i) >= t.minimum)
      return;
    const s = v0(o);
    r.issues.push({
      origin: s,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), bU = /* @__PURE__ */ ie("$ZodCheckLengthEquals", (e, t) => {
  var n;
  mr.init(e, t), (n = e._zod.def).when ?? (n.when = E0), e._zod.check = (r) => {
    const o = r.value, i = o.length, a = typeof o == "string" && i >= t.length && i <= t.length * 2 ? g0(o) : i;
    if (a === t.length)
      return;
    const s = v0(o), l = a > t.length;
    r.issues.push({
      origin: s,
      ...l ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Xf = /* @__PURE__ */ ie("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  mr.init(e, t), t.pattern ? (n = e._zod).check ?? (n.check = (o) => {
    t.pattern.lastIndex = 0, !t.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: o.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), SU = /* @__PURE__ */ ie("$ZodCheckRegex", (e, t) => {
  Xf.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), xU = /* @__PURE__ */ ie("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = mU), Xf.init(e, t);
}), CU = /* @__PURE__ */ ie("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = pU), Xf.init(e, t);
}), wU = /* @__PURE__ */ ie("$ZodCheckIncludes", (e, t) => {
  mr.init(e, t);
  const n = Ys(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position},}${n}` : n);
  t.pattern = r, e._zod.check = (o) => {
    o.value.includes(t.includes, t.position) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), EU = /* @__PURE__ */ ie("$ZodCheckStartsWith", (e, t) => {
  mr.init(e, t);
  const n = new RegExp(`^${Ys(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), IU = /* @__PURE__ */ ie("$ZodCheckEndsWith", (e, t) => {
  mr.init(e, t);
  const n = new RegExp(`.*${Ys(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), RU = /* @__PURE__ */ ie("$ZodCheckOverwrite", (e, t) => {
  mr.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class TU {
  constructor(t = [], n = {}) {
    this.content = [], this.indent = 0, this.args = t, this.closed = n;
  }
  // the compiler catches a child's throw and keeps writing into this doc, so the indent has to unwind with it
  indented(t) {
    this.indent += 1;
    try {
      t(this);
    } finally {
      this.indent -= 1;
    }
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((a) => a), o = Math.min(...r.map((a) => a.length - a.trimStart().length)), i = r.map((a) => a.slice(o)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of i)
      this.content.push(a);
  }
  compile() {
    const t = Function, n = (this == null ? void 0 : this.content) ?? [""];
    return new t(...Object.keys(this.closed), `return function (${this.args.join(", ")}) {
${n.join(`
`)}
};`)(...Object.values(this.closed));
  }
}
const _U = {
  major: 4,
  minor: 6,
  patch: 5
}, Pt = /* @__PURE__ */ ie("$ZodType", (e, t) => {
  var i;
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = _U;
  const r = e._zod.def.checks, o = e._zod.traits.has("$ZodCheck") ? [e, ...r ?? []] : r != null && r.length ? [...r] : [];
  for (const a of o)
    for (const s of a._zod.onattach)
      s(e);
  if (o.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), (i = e._zod.deferred) == null || i.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const a = (l, c, u) => {
      if (l.memo)
        return l;
      let d = ao(l), m;
      for (const h of c) {
        if (h._zod.def.when) {
          if (iV(l) || !h._zod.def.when(l))
            continue;
        } else if (d)
          continue;
        const v = l.issues.length, g = h._zod.check(l);
        if (g instanceof Promise && (u == null ? void 0 : u.async) === !1)
          throw new Da();
        if (m || g instanceof Promise)
          m = (m ?? Promise.resolve()).then(async () => {
            await g, l.issues.length !== v && ($b(l.issues, v, e), d || (d = ao(l, v)));
          });
        else {
          if (l.issues.length === v)
            continue;
          $b(l.issues, v, e), d || (d = ao(l, v));
        }
      }
      return m ? m.then(() => l) : l;
    }, s = (l, c, u) => {
      if (ao(l))
        return l.aborted = !0, l;
      const d = a(c, o, u);
      if (d instanceof Promise) {
        if (u.async === !1)
          throw new Da();
        return d.then((m) => e._zod.parse(m, u));
      }
      return e._zod.parse(d, u);
    };
    e._zod.run = (l, c) => {
      if (c.skipChecks)
        return e._zod.parse(l, c);
      if (c.direction === "backward") {
        const d = e._zod.parse({ value: l.value, issues: [] }, { ...c, skipChecks: !0 });
        return d instanceof Promise ? d.then((m) => s(m, l, c)) : s(d, l, c);
      }
      const u = e._zod.parse(l, c);
      if (u instanceof Promise) {
        if (c.async === !1)
          throw new Da();
        return u.then((d) => a(d, o, c));
      }
      return a(u, o, c);
    };
  }
}, {
  // Wrappers extend this by installing a richer factory over it; reading it eagerly would defeat the laziness.
  get "~standard"() {
    return $C(this, "~standard", WC(this));
  },
  set "~standard"(e) {
    Yi(this, "~standard", e);
  }
}), UC = (e, t) => e.issues.length ? { issues: e.issues.map((n) => qi(n, t, Lo())) } : { value: e.value };
async function OU(e, t) {
  const n = { async: !0 };
  return UC(await e._zod.run({ value: t, issues: [] }, n), n);
}
function WC(e) {
  return {
    validate: (t) => {
      const n = { async: !1 };
      try {
        const r = e._zod.run({ value: t, issues: [] }, n);
        if (!(r instanceof Promise))
          return UC(r, n);
      } catch {
      }
      return OU(e, t);
    },
    vendor: "zod",
    version: 1
  };
}
const Jf = /* @__PURE__ */ ie("$ZodString", (e, t) => {
  Pt.init(e, t), e._zod.pattern = t.pattern ?? cU, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), qt = /* @__PURE__ */ ie("$ZodStringFormat", (e, t) => {
  Xf.init(e, t), Jf.init(e, t);
}), AU = /* @__PURE__ */ ie("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = HV), qt.init(e, t);
}), kU = /* @__PURE__ */ ie("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Gb(r));
  } else
    t.pattern ?? (t.pattern = Gb());
  qt.init(e, t);
}), DU = /* @__PURE__ */ ie("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = qV), qt.init(e, t);
}), HC = 1, tf = 2;
function qC(e) {
  try {
    return typeof URL < "u" && typeof URL.canParse == "function" ? URL.canParse(e) : (new URL(e), !0);
  } catch {
    return !1;
  }
}
function PU(e, t) {
  return !("normalize" in t) && !("hostname" in t) && !("protocol" in t) ? qC(e) || tf : NU(e, t);
}
function NU(e, t) {
  var n;
  if (!t.normalize && ((n = t.protocol) == null ? void 0 : n.source) === rU.source && !/^https?:\/\//i.test(e))
    return HC;
  try {
    if (typeof URL < "u") {
      const r = URL;
      if (typeof r.parse == "function")
        return r.parse(e) ?? tf;
    }
    return new URL(e);
  } catch {
    return tf;
  }
}
const MU = /[\t\n\r]/g;
function Vb(e) {
  return e.replace(MU, "");
}
function FU(e, t) {
  return t.lastIndex = 0, t.test(e.hostname);
}
function LU(e, t) {
  return t.lastIndex = 0, t.test(e.protocol.endsWith(":") ? e.protocol.slice(0, -1) : e.protocol);
}
const $U = /* @__PURE__ */ ie("$ZodURL", (e, t) => {
  qt.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), o = PU(r, t);
      if (o === HC) {
        n.issues.push({
          code: "invalid_format",
          format: "url",
          note: "Invalid URL format",
          input: n.value,
          inst: e,
          continue: !t.abort
        });
        return;
      }
      if (o === tf) {
        n.issues.push({
          code: "invalid_format",
          format: "url",
          input: n.value,
          inst: e,
          continue: !t.abort
        });
        return;
      }
      if (o === !0) {
        n.value = Vb(r);
        return;
      }
      t.hostname && !FU(o, t.hostname) && n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      }), t.protocol && !LU(o, t.protocol) && n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      }), n.value = t.normalize ? o.href : Vb(r);
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), zU = /* @__PURE__ */ ie("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = KV()), qt.init(e, t);
}), jU = /* @__PURE__ */ ie("$ZodNanoID", (e, t) => {
  if (t.length !== void 0 && (!Number.isInteger(t.length) || t.length < 1))
    throw new Error(`Invalid nanoid length: ${t.length}`);
  t.pattern ?? (t.pattern = t.length === void 0 ? VV : UV(t.length)), qt.init(e, t);
}), BU = /* @__PURE__ */ ie("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = $V), qt.init(e, t);
}), GU = /* @__PURE__ */ ie("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = zV), qt.init(e, t);
}), VU = /* @__PURE__ */ ie("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = jV), qt.init(e, t);
}), UU = /* @__PURE__ */ ie("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = BV), qt.init(e, t);
}), WU = /* @__PURE__ */ ie("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = GV), qt.init(e, t);
}), HU = /* @__PURE__ */ ie("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = lU(t)), qt.init(e, t);
}), qU = /* @__PURE__ */ ie("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = aU), qt.init(e, t);
}), YU = /* @__PURE__ */ ie("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = sU(t)), qt.init(e, t);
}), KU = /* @__PURE__ */ ie("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = WV), qt.init(e, t);
}), ZU = /* @__PURE__ */ ie("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = ZV), qt.init(e, t);
}), XU = /^[0-9a-fA-F:.]+$/;
function YC(e) {
  return XU.test(e) ? qC(`http://[${e}]`) : !1;
}
const JU = /* @__PURE__ */ ie("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = XV), qt.init(e, t), e._zod.check = (n) => {
    YC(n.value) || n.issues.push({
      code: "invalid_format",
      format: "ipv6",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), QU = /* @__PURE__ */ ie("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = JV), qt.init(e, t);
});
function eW(e) {
  const t = e.split("/");
  if (t.length !== 2)
    return !1;
  const [n, r] = t;
  if (!r)
    return !1;
  const o = Number(r);
  return `${o}` !== r || o < 0 || o > 128 ? !1 : YC(n);
}
const tW = /* @__PURE__ */ ie("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = QV), qt.init(e, t), e._zod.check = (n) => {
    eW(n.value) || n.issues.push({
      code: "invalid_format",
      format: "cidrv6",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function KC(e) {
  if (e === "")
    return !0;
  if (/\s/.test(e) || e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const ZC = /^[0-9a-zA-Z+/]*={0,2}$/, nW = /* @__PURE__ */ ie("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = ZC), qt.init(e, t), e._zod.check = (n) => {
    KC(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), I0 = /^[A-Za-z0-9_-]*$/;
function rW(e) {
  if (!I0.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return KC(n);
}
const oW = /* @__PURE__ */ ie("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = I0), qt.init(e, t), e._zod.check = (n) => {
    rW(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), iW = /* @__PURE__ */ ie("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = oU), qt.init(e, t);
});
function aW(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const o = JSON.parse(atob(r));
    return !("typ" in o && (o == null ? void 0 : o.typ) !== "JWT" || !o.alg || t && (!("alg" in o) || o.alg !== t));
  } catch {
    return !1;
  }
}
const sW = /* @__PURE__ */ ie("$ZodJWT", (e, t) => {
  qt.init(e, t), e._zod.check = (n) => {
    aW(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), XC = /* @__PURE__ */ ie("$ZodNumber", (e, t) => {
  Pt.init(e, t), e._zod.pattern = w0, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const o = n.value;
    if (typeof o == "number" && !Number.isNaN(o) && Number.isFinite(o))
      return n;
    const i = typeof o == "number" ? Number.isNaN(o) ? "NaN" : Number.isFinite(o) ? void 0 : String(o) : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: o,
      inst: e,
      ...i ? { received: i } : {}
    }), n;
  };
}), lW = /* @__PURE__ */ ie("$ZodNumberFormat", (e, t) => {
  gU.init(e, t), XC.init(e, t);
}), JC = /* @__PURE__ */ ie("$ZodBoolean", (e, t) => {
  Pt.init(e, t), e._zod.pattern = dU, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const o = n.value;
    return typeof o == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: o,
      inst: e
    }), n;
  };
}), cW = /* @__PURE__ */ ie("$ZodNull", (e, t) => {
  Pt.init(e, t), e._zod.pattern = fU, e._zod.values = /* @__PURE__ */ new Set([null]), e._zod.parse = (n, r) => {
    const o = n.value;
    return o === null || n.issues.push({
      expected: "null",
      code: "invalid_type",
      input: o,
      inst: e
    }), n;
  };
}), uW = /* @__PURE__ */ ie("$ZodUnknown", (e, t) => {
  Pt.init(e, t), e._zod.parse = (n) => n;
}), dW = /* @__PURE__ */ ie("$ZodNever", (e, t) => {
  Pt.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
}), fW = /* @__PURE__ */ ie("$ZodDate", (e, t) => {
  Pt.init(e, t), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = new Date(n.value);
      } catch {
      }
    const o = n.value, i = o instanceof Date;
    return i && !Number.isNaN(o.getTime()) || n.issues.push({
      expected: "date",
      code: "invalid_type",
      input: o,
      ...i ? { received: "Invalid Date" } : {},
      inst: e
    }), n;
  };
});
function Ub(e, t, n) {
  e.issues.length && t.issues.push(...Fi(n, e.issues)), t.value[n] = e.value;
}
const mW = /* @__PURE__ */ ie("$ZodArray", (e, t) => {
  Pt.init(e, t);
  const n = Ur.memoizer;
  n == null || n.attach(e), e._zod.parse = (r, o) => {
    const i = r.value;
    if (!Array.isArray(i))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), r;
    r.value = n ? n.alloc(e, r, Array(i.length), o) : Array(i.length);
    const a = [], s = o == null ? void 0 : o.abortEarly;
    for (let l = 0; l < i.length; l++) {
      const c = i[l], u = t.element._zod.run({
        value: c,
        issues: []
      }, o);
      if (u instanceof Promise)
        a.push(u.then((d) => Ub(d, r, l)));
      else if (Ub(u, r, l), s && u.issues.length !== 0 && ao(u))
        break;
    }
    return a.length ? Promise.all(a).then(() => r) : r;
  };
});
function nf(e, t, n, r, o, i) {
  const a = n in r, s = i === "optional";
  if (!(!a && s && o === "optional")) {
    if (e.issues.length) {
      if (o !== void 0 && s && !a)
        return;
      t.issues.push(...Fi(n, e.issues));
    }
    if (!a && o === void 0) {
      e.issues.length || t.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: void 0,
        path: [n]
      });
      return;
    }
    e.value === void 0 ? (a || o === "defaulted" && !s) && (t.value[n] = void 0) : t.value[n] = e.value;
  }
}
const pW = [];
function QC(e) {
  var a, s, l, c;
  const t = Object.keys(e.shape), n = Object.getOwnPropertySymbols(e.shape), r = n.length ? n : pW, o = r.length ? [...t, ...r] : t;
  for (const u of o)
    if (!((c = (l = (s = (a = e.shape) == null ? void 0 : a[u]) == null ? void 0 : s._zod) == null ? void 0 : l.traits) != null && c.has("$ZodType")))
      throw new Error(`Invalid element at key "${String(u)}": expected a Zod schema`);
  const i = XG(e.shape);
  return {
    ...e,
    allKeys: o,
    symbolKeys: r,
    // string-only: handleCatchall matches it against `for...in`, which never yields a symbol
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(i)
  };
}
function ew(e, t, n, r, o, i, a) {
  const s = [], l = o.keySet, c = o.catchall._zod, u = c.def.type, d = c.optin, m = c.optout;
  let h = 0;
  for (const v in t) {
    if (a && n.issues.length !== h) {
      if (ao(n, h))
        break;
      h = n.issues.length;
    }
    if (l.has(v))
      continue;
    if (v === "__proto__") {
      u === "never" && s.push(v);
      continue;
    }
    if (u === "never") {
      s.push(v);
      continue;
    }
    const g = c.run({ value: t[v], issues: [] }, r);
    g instanceof Promise ? e.push(g.then((x) => nf(x, n, v, t, d, m))) : nf(g, n, v, t, d, m);
  }
  return s.length && n.issues.push({
    code: "unrecognized_keys",
    keys: s,
    input: t,
    inst: i,
    // Describes the shape of the input, not the validity of the parsed value, so it never aborts. The parse still fails; the schema's own checks just get to run first, and an enclosing intersection can reconcile the key against a sibling operand.
    continue: !0
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const hW = /* @__PURE__ */ ie("$ZodObject", (e, t) => {
  Pt.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape"), r = n != null && n.get ? n.get.raw : t.shape ?? {};
  if (r) {
    const c = () => {
      const u = { ...r };
      return Object.defineProperty(t, "shape", { value: u }), c.raw = u, u;
    };
    c.raw = r, Object.defineProperty(t, "shape", { get: c });
  }
  const o = Yf(() => QC(t));
  yt(e, "propValues", (c) => {
    const u = c.def.shape, d = {};
    for (const m in u) {
      const h = u[m]._zod;
      if (h.values) {
        Object.prototype.hasOwnProperty.call(d, m) || yi(d, m, /* @__PURE__ */ new Set());
        for (const v of h.values)
          d[m].add(v);
        h.optin !== void 0 && d[m].add(void 0);
      }
    }
    return d;
  });
  const i = Ac, a = t.catchall;
  let s;
  const l = Ur.memoizer;
  l == null || l.attach(e), e._zod.parse = (c, u) => {
    s ?? (s = o.value);
    const d = c.value;
    if (!i(d))
      return c.issues.push({
        expected: "object",
        code: "invalid_type",
        input: d,
        inst: e
      }), c;
    c.value = l ? l.alloc(e, c, {}, u) : {};
    const m = [], h = s.shape, v = u == null ? void 0 : u.abortEarly;
    let g = c.issues.length;
    for (const x of s.allKeys) {
      if (v && c.issues.length !== g) {
        if (ao(c, g))
          break;
        g = c.issues.length;
      }
      if (x === "__proto__")
        continue;
      const b = h[x], C = b._zod.optin, I = b._zod.optout, T = b._zod.run({ value: d[x], issues: [] }, u);
      T instanceof Promise ? m.push(T.then((R) => nf(R, c, x, d, C, I))) : nf(T, c, x, d, C, I);
    }
    return a ? ew(m, d, c, u, o.value, e, v === !0) : m.length ? Promise.all(m).then(() => c) : c;
  };
}), gW = /* @__PURE__ */ ie("$ZodObjectJIT", (e, t) => {
  hW.init(e, t);
  const n = e._zod.parse, r = Yf(() => QC(t)), o = Ur.memoizer, i = (h) => {
    var R, A;
    const v = r.value, g = v.symbolKeys, x = new TU(["payload", "ctx"], { shape: h, inst: e, memo: o, syms: g }), b = (_) => `shape[${_}]._zod.run({ value: input[${_}], issues: [] }, ctx)`, C = (_, k) => `
          let ${_}_ab = false;
          for (let i = 0; i < ${_}.issues.length; i++) {
            const iss = ${_}.issues[i];
            iss.path = iss.path ? [${k}, ...iss.path] : [${k}];
            payload.issues.push(iss);
            if (iss.continue !== true) ${_}_ab = true;
          }
          if (${_}_ab && ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }`;
    x.write("const input = payload.value;");
    const I = /* @__PURE__ */ Object.create(null);
    let T = 0;
    for (const _ of v.allKeys)
      I[_] = `key_${T++}`;
    x.write(o ? "const newResult = memo.alloc(inst, payload, {}, ctx);" : "const newResult = {};");
    for (const _ of v.allKeys) {
      if (_ === "__proto__")
        continue;
      const k = I[_], M = typeof _ == "symbol" ? `syms[${g.indexOf(_)}]` : qG(_), j = `${M} in input`, G = h[_], U = (R = G == null ? void 0 : G._zod) == null ? void 0 : R.optin, B = U !== void 0, K = ((A = G == null ? void 0 : G._zod) == null ? void 0 : A.optout) === "optional";
      if (x.write(`const ${k} = ${b(M)};`), B && K) {
        const ee = U === "optional" ? `${k}_present` : `${k}.value !== undefined || ${k}_present`;
        x.write(`
        const ${k}_present = ${j};
        if (!${k}.issues.length || ${k}_present) {
          if (${k}.issues.length) {${C(k, M)}
          }

          if (${ee}) {
            newResult[${M}] = ${k}.value;
          }
        }

      `);
      } else B ? (x.write(`
        if (${k}.issues.length) {${C(k, M)}
        }
      `), U === "defaulted" ? x.write(`newResult[${M}] = ${k}.value;`) : x.write(`
        if (${k}.value !== undefined || ${j}) {
          newResult[${M}] = ${k}.value;
        }
      `)) : x.write(`
        const ${k}_present = ${j};
        if (${k}.issues.length) {${C(k, M)}
        }
        if (!${k}_present && !${k}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${M}]
          });
          if (ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }
        }

        if (${k}_present) {
          newResult[${M}] = ${k}.value;
        }

      `);
    }
    return x.write("payload.value = newResult;"), x.write("return payload;"), x.compile();
  };
  let a;
  const s = Ac, l = !Ur.jitless, u = l && KG.value, d = t.catchall;
  let m;
  e._zod.parse = (h, v) => {
    m ?? (m = r.value);
    const g = h.value;
    return s(g) ? l && u && (v == null ? void 0 : v.async) === !1 && v.jitless !== !0 ? (a || (a = i(t.shape)), h = a(h, v), d ? ew([], g, h, v, m, e, (v == null ? void 0 : v.abortEarly) === !0) : h) : n(h, v) : (h.issues.push({
      expected: "object",
      code: "invalid_type",
      input: g,
      inst: e
    }), h);
  };
});
function Wb(e, t, n, r) {
  for (const i of e)
    if (i.issues.length === 0)
      return t.value = i.value, t;
  const o = e.filter((i) => !ao(i));
  return o.length === 1 ? (t.value = o[0].value, o[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((i) => i.issues.map((a) => qi(a, r, Lo())))
  }), t);
}
const tw = /* @__PURE__ */ ie("$ZodUnion", (e, t) => {
  Pt.init(e, t), yt(e, "optin", (r) => r.def.options.some((o) => o._zod.optin === "defaulted") ? "defaulted" : r.def.options.some((o) => o._zod.optin !== void 0) ? "optional" : void 0), yt(e, "optout", (r) => r.def.options.some((o) => o._zod.optout === "optional") ? "optional" : void 0), yt(e, "values", (r) => {
    if (r.def.options.every((o) => o._zod.values))
      return new Set(r.def.options.flatMap((o) => Array.from(o._zod.values)));
  }), yt(e, "pattern", (r) => {
    if (r.def.options.every((o) => o._zod.pattern)) {
      const o = r.def.options.map((i) => i._zod.pattern);
      return new RegExp(`^(${o.map((i) => p0(i.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1 ? t.options[0]._zod.run : null;
  e._zod.parse = (r, o) => {
    if (n)
      return n(r, o);
    let i = !1;
    const a = [];
    for (const s of t.options) {
      const l = s._zod.run({
        value: r.value,
        issues: []
      }, o);
      if (l instanceof Promise)
        a.push(l), i = !0;
      else {
        if (l.issues.length === 0)
          return l;
        a.push(l);
      }
    }
    return i ? Promise.all(a).then((s) => Wb(s, r, e, o)) : Wb(a, r, e, o);
  };
});
function vW(e) {
  var n;
  const t = /* @__PURE__ */ new Map();
  for (const r of e.options) {
    const o = (n = r._zod.propValues) == null ? void 0 : n[e.discriminator];
    if (!o || o.size === 0)
      throw new Error(`Invalid discriminated union option at index "${e.options.indexOf(r)}"`);
    for (const i of o)
      if (t.has(i)) {
        if (i !== void 0)
          throw new Error(`Duplicate discriminator value "${String(i)}"`);
        t.set(i, null);
      } else
        t.set(i, r);
  }
  return t;
}
const yW = /* @__PURE__ */ ie("$ZodDiscriminatedUnion", (e, t) => {
  t.inclusive = !1, tw.init(e, t);
  const n = e._zod.parse;
  yt(e, "propValues", (o) => {
    var s, l;
    const i = {};
    let a = 0;
    for (const c of o.def.options) {
      const u = c._zod.propValues;
      if (!u || Object.keys(u).length === 0)
        throw new Error(`Invalid discriminated union option at index "${o.def.options.indexOf(c)}"`);
      (s = u[o.def.discriminator]) != null && s.has(void 0) && a++;
      for (const [d, m] of Object.entries(u)) {
        Object.prototype.hasOwnProperty.call(i, d) || yi(i, d, /* @__PURE__ */ new Set());
        for (const h of m)
          i[d].add(h);
      }
    }
    return !o.def.unionFallback && a > 1 && ((l = i[o.def.discriminator]) == null || l.delete(void 0)), i;
  }), t.options.forEach((o, i) => {
    const a = h0(o._zod.def);
    if (a && !Object.prototype.hasOwnProperty.call(a, t.discriminator))
      throw new Error(`Invalid discriminated union option at index "${i}"`);
  });
  const r = Yf(() => vW(t));
  e._zod.parse = (o, i) => {
    const a = o.value;
    if (!Ac(a))
      return o.issues.push({
        code: "invalid_type",
        expected: "object",
        input: a,
        inst: e
      }), o;
    const s = a == null ? void 0 : a[t.discriminator], l = r.value.get(s);
    return l && (s !== void 0 || i.direction !== "backward") ? l._zod.run(o, i) : t.unionFallback || i.direction === "backward" ? n(o, i) : (o.issues.push({
      code: "invalid_union",
      errors: [],
      note: "No matching discriminator",
      discriminator: t.discriminator,
      options: Array.from(r.value.keys()).filter((c) => r.value.get(c) !== null),
      input: a,
      path: [t.discriminator],
      inst: e
    }), o);
  };
}), bW = /* @__PURE__ */ ie("$ZodIntersection", (e, t) => {
  Pt.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value, i = t.left._zod.run({ value: o, issues: [] }, r), a = t.right._zod.run({ value: o, issues: [] }, r);
    return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([l, c]) => Hb(n, l, c)) : Hb(n, i, a);
  };
});
function eg(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (qs(e) && qs(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((i) => n.indexOf(i) !== -1), o = { ...e, ...t };
    Object.prototype.hasOwnProperty.call(o, "__proto__") && delete o.__proto__;
    for (const i of r) {
      if (i === "__proto__")
        continue;
      const a = eg(e[i], t[i]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...a.mergeErrorPath]
        };
      o[i] = a.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const o = e[r], i = t[r], a = eg(o, i);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Hb(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let o;
  const i = /* @__PURE__ */ new Map(), a = (c, u) => {
    var m, h;
    let d;
    if (c.code === "unrecognized_keys" && !((m = c.path) != null && m.length))
      o ?? (o = c), d = c.keys;
    else if (c.code === "invalid_key" && c.origin === "record" && ((h = c.path) == null ? void 0 : h.length) === 1) {
      const v = String(c.path[0]);
      i.has(v) || i.set(v, c), d = [v];
    } else
      return !1;
    for (const v of d)
      r.has(v) || r.set(v, {}), r.get(v)[u] = !0;
    return !0;
  };
  for (const c of t.issues)
    a(c, "l") || e.issues.push(c);
  for (const c of n.issues)
    a(c, "r") || e.issues.push(c);
  const s = [...r].filter(([, c]) => c.l && c.r).map(([c]) => c);
  if (s.length) {
    const c = o ? s.filter((u) => o.keys.includes(u)) : [];
    c.length && e.issues.push({ ...o, keys: c });
    for (const u of s)
      !c.includes(u) && i.has(u) && e.issues.push(i.get(u));
  }
  const l = eg(t.value, n.value);
  if (!l.valid) {
    if (ao(e))
      return e;
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(l.mergeErrorPath)}`);
  }
  return e.value = l.data, e;
}
const SW = /* @__PURE__ */ ie("$ZodTuple", (e, t) => {
  Pt.init(e, t);
  const n = t.items, r = Ur.memoizer;
  r == null || r.attach(e), e._zod.parse = (o, i) => {
    const a = o.value;
    if (!Array.isArray(a))
      return o.issues.push({
        input: a,
        inst: e,
        expected: "tuple",
        code: "invalid_type"
      }), o;
    o.value = r ? r.alloc(e, o, [], i) : [];
    const s = [], l = qb(n, "optin"), c = qb(n, "optout");
    if (!t.rest) {
      if (a.length < l)
        return o.issues.push({
          code: "too_small",
          minimum: l,
          inclusive: !0,
          input: a,
          inst: e,
          origin: "array"
        }), o;
      a.length > n.length && o.issues.push({
        code: "too_big",
        maximum: n.length,
        inclusive: !0,
        input: a,
        inst: e,
        origin: "array"
      });
    }
    const u = new Array(n.length), d = t.rest ? i == null ? void 0 : i.abortEarly : void 0;
    let m = !1;
    for (let h = 0; h < n.length; h++) {
      const v = n[h]._zod.run({ value: a[h], issues: [] }, i);
      v instanceof Promise ? s.push(v.then((g) => {
        u[h] = g;
      })) : (u[h] = v, d && !m && v.issues.length && (m = ao(v)));
    }
    if (t.rest && !m) {
      let h = n.length - 1;
      const v = a.slice(n.length);
      let g = o.issues.length;
      for (const x of v) {
        if (d && o.issues.length !== g) {
          if (ao(o, g))
            break;
          g = o.issues.length;
        }
        h++;
        const b = t.rest._zod.run({ value: x, issues: [] }, i);
        b instanceof Promise ? s.push(b.then((C) => Yb(C, o, h))) : Yb(b, o, h);
      }
    }
    return s.length ? Promise.all(s).then(() => Kb(u, o, n, a, c)) : Kb(u, o, n, a, c);
  };
});
function qb(e, t) {
  for (let n = e.length - 1; n >= 0; n--)
    if (!(t === "optin" ? e[n]._zod.optin !== void 0 : e[n]._zod.optout === "optional"))
      return n + 1;
  return 0;
}
function Yb(e, t, n) {
  e.issues.length && t.issues.push(...Fi(n, e.issues)), t.value[n] = e.value;
}
function Kb(e, t, n, r, o) {
  for (let i = 0; i < n.length; i++) {
    const a = e[i], s = i < r.length;
    if (!s && i >= o && n[i]._zod.optin === "optional") {
      t.value.length = i;
      break;
    }
    if (a.issues.length) {
      if (!s && i >= o) {
        t.value.length = i;
        break;
      }
      t.issues.push(...Fi(i, a.issues));
    }
    t.value[i] = a.value;
  }
  for (let i = t.value.length - 1; i >= r.length && (n[i]._zod.optout === "optional" && t.value[i] === void 0); i--)
    t.value.length = i;
  return t;
}
const xW = /* @__PURE__ */ ie("$ZodRecord", (e, t) => {
  Pt.init(e, t);
  const n = Ur.memoizer;
  n == null || n.attach(e), e._zod.parse = (r, o) => {
    const i = r.value;
    if (!qs(i))
      return r.issues.push({
        expected: "record",
        code: "invalid_type",
        input: i,
        inst: e
      }), r;
    const a = [], s = t.keyType._zod.values;
    if (s && !t.partial) {
      r.value = n ? n.alloc(e, r, {}, o) : {};
      const l = /* @__PURE__ */ new Set();
      for (const u of s)
        if (typeof u == "string" || typeof u == "number" || typeof u == "symbol") {
          if (l.add(typeof u == "number" ? u.toString() : u), u === "__proto__")
            continue;
          const d = t.keyType._zod.run({ value: u, issues: [] }, o);
          if (d instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          if (d.issues.length) {
            r.issues.push({
              code: "invalid_key",
              origin: "record",
              issues: d.issues.map((v) => qi(v, o, Lo())),
              input: u,
              path: [u],
              inst: e
            });
            continue;
          }
          const m = d.value;
          if (m === "__proto__")
            continue;
          const h = t.valueType._zod.run({ value: i[u], issues: [] }, o);
          h instanceof Promise ? a.push(h.then((v) => {
            v.issues.length && r.issues.push(...Fi(u, v.issues)), r.value[m] = v.value;
          })) : (h.issues.length && r.issues.push(...Fi(u, h.issues)), r.value[m] = h.value);
        }
      let c;
      for (const u in i)
        if (!l.has(u))
          if (t.mode === "loose") {
            if (u === "__proto__")
              continue;
            r.value[u] = i[u];
          } else
            c = c ?? [], c.push(u);
      c && c.length > 0 && r.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: c,
        continue: !0
      });
    } else {
      r.value = n ? n.alloc(e, r, {}, o) : {};
      let l;
      for (const c of Reflect.ownKeys(i)) {
        if (c === "__proto__" || !Object.prototype.propertyIsEnumerable.call(i, c))
          continue;
        let u = t.keyType._zod.run({ value: c, issues: [] }, o);
        if (u instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof c == "string" && w0.test(c) && u.issues.length) {
          const v = t.keyType._zod.run({ value: Number(c), issues: [] }, o);
          if (v instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          v.issues.length === 0 && (u = v);
        }
        if (u.issues.length) {
          t.mode === "loose" ? r.value[c] = i[c] : s ? (l = l ?? [], l.push(c)) : r.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: u.issues.map((v) => qi(v, o, Lo())),
            input: c,
            path: [c],
            inst: e
          });
          continue;
        }
        const m = u.value;
        if (m === "__proto__")
          continue;
        const h = t.valueType._zod.run({ value: i[c], issues: [] }, o);
        h instanceof Promise ? a.push(h.then((v) => {
          v.issues.length && r.issues.push(...Fi(c, v.issues)), r.value[m] = v.value;
        })) : (h.issues.length && r.issues.push(...Fi(c, h.issues)), r.value[m] = h.value);
      }
      l && l.length > 0 && r.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: l,
        continue: !0
      });
    }
    return a.length ? Promise.all(a).then(() => r) : r;
  };
}), CW = /* @__PURE__ */ ie("$ZodEnum", (e, t) => {
  Pt.init(e, t);
  const n = Xh(t.entries), r = new Set(n);
  e._zod.values = r, yt(e, "pattern", (o) => {
    const i = Xh(o.def.entries).filter((a) => ZG.has(typeof a));
    return new RegExp(i.length ? `^(${i.map((a) => Ys(a.toString())).join("|")})$` : "^[^\\s\\S]$");
  }), e._zod.parse = (o, i) => {
    const a = o.value;
    return r.has(a) || o.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), o;
  };
}), wW = /* @__PURE__ */ ie("$ZodLiteral", (e, t) => {
  Pt.init(e, t);
  const n = new Set(t.values);
  e._zod.values = n, yt(e, "pattern", (r) => {
    const o = r.def.values;
    return new RegExp(o.length ? `^(${o.map((i) => typeof i == "string" ? Ys(i) : i ? Ys(i.toString()) : String(i)).join("|")})$` : "^[^\\s\\S]$");
  }), e._zod.parse = (r, o) => {
    const i = r.value;
    return n.has(i) || r.issues.push({
      code: "invalid_value",
      values: t.values,
      input: i,
      inst: e
    }), r;
  };
}), EW = /* @__PURE__ */ ie("$ZodTransform", (e, t) => {
  var n;
  Pt.init(e, t), e._zod.optin = "optional", (n = Ur.memoizer) == null || n.guard(e), e._zod.parse = (r, o) => {
    if (o.direction === "backward")
      throw new zC(e.constructor.name);
    const i = t.transform(r.value, r);
    if (o.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((s) => (r.value = s, r));
    if (i instanceof Promise)
      throw new Da();
    return r.value = i, r;
  };
});
function Zb(e, t) {
  return e.value = t.issues.length ? void 0 : t.value, e;
}
const nw = /* @__PURE__ */ ie("$ZodOptional", (e, t) => {
  Pt.init(e, t), yt(e, "optin", (n) => n.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), e._zod.optout = "optional", yt(e, "values", (n) => {
    const r = n.def.innerType._zod.values;
    return r ? /* @__PURE__ */ new Set([...r, void 0]) : void 0;
  }), yt(e, "pattern", (n) => {
    const r = n.def.innerType._zod.pattern;
    return r ? new RegExp(`^(${p0(r.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (n.value === void 0) {
      if (t.innerType._zod.optin !== "defaulted")
        return n;
      const o = t.innerType._zod.run({ value: n.value, issues: [] }, r);
      return o instanceof Promise ? o.then((i) => Zb(n, i)) : Zb(n, o);
    }
    return t.innerType._zod.run(n, r);
  };
}), IW = /* @__PURE__ */ ie("$ZodExactOptional", (e, t) => {
  nw.init(e, t), yt(e, "values", (n) => n.def.innerType._zod.values), yt(e, "pattern", (n) => n.def.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), RW = /* @__PURE__ */ ie("$ZodNullable", (e, t) => {
  Pt.init(e, t), yt(e, "optin", (n) => n.def.innerType._zod.optin), yt(e, "optout", (n) => n.def.innerType._zod.optout), yt(e, "pattern", (n) => {
    const r = n.def.innerType._zod.pattern;
    return r ? new RegExp(`^(${p0(r.source)}|null)$`) : void 0;
  }), yt(e, "values", (n) => n.def.innerType._zod.values ? /* @__PURE__ */ new Set([...n.def.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), TW = /* @__PURE__ */ ie("$ZodDefault", (e, t) => {
  Pt.init(e, t), e._zod.optin = "defaulted", yt(e, "values", (n) => n.def.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => Xb(i, t)) : Xb(o, t);
  };
});
function Xb(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const _W = /* @__PURE__ */ ie("$ZodPrefault", (e, t) => {
  Pt.init(e, t), e._zod.optin = "defaulted", yt(e, "values", (n) => n.def.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), OW = /* @__PURE__ */ ie("$ZodNonOptional", (e, t) => {
  Pt.init(e, t), yt(e, "values", (n) => {
    const r = n.def.innerType._zod.values;
    return r ? new Set([...r].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => Jb(i, e)) : Jb(o, e);
  };
});
function Jb(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
function Qb(e, t, n, r) {
  return t.issues.length ? (e.value = n.catchValue({
    ...t,
    value: e.value,
    error: {
      issues: t.issues.map((o) => qi(o, r, Lo()))
    },
    input: e.value
  }), e) : (e.value = t.value, t.memo && (e.memo = !0), e);
}
const AW = /* @__PURE__ */ ie("$ZodCatch", (e, t) => {
  Pt.init(e, t), yt(e, "optin", (n) => n.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), yt(e, "optout", (n) => n.def.innerType._zod.optout), yt(e, "values", (n) => n.def.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const o = t.innerType._zod.run({ value: n.value, issues: [] }, r);
    return o instanceof Promise ? o.then((i) => Qb(n, i, t, r)) : Qb(n, o, t, r);
  };
}), kW = /* @__PURE__ */ ie("$ZodPipe", (e, t) => {
  Pt.init(e, t), yt(e, "values", (n) => n.def.in._zod.values), yt(e, "optin", (n) => n.def.in._zod.optin), yt(e, "optout", (n) => n.def.out._zod.optout), yt(e, "propValues", (n) => n.def.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const i = t.out._zod.run(n, r);
      return i instanceof Promise ? i.then((a) => Vu(a, t.in, r)) : Vu(i, t.in, r);
    }
    const o = t.in._zod.run(n, r);
    return o instanceof Promise ? o.then((i) => Vu(i, t.out, r)) : Vu(o, t.out, r);
  };
});
function Vu(e, t, n) {
  return e.issues.some((r) => r.code !== "unrecognized_keys") ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const rw = /* @__PURE__ */ ie("$ZodCodec", (e, t) => {
  Pt.init(e, t), yt(e, "values", (n) => n.def.in._zod.values), yt(e, "optin", (n) => n.def.in._zod.optin), yt(e, "optout", (n) => n.def.out._zod.optout), yt(e, "propValues", (n) => n.def.in._zod.propValues), e._zod.parse = (n, r) => {
    if ((r.direction || "forward") === "forward") {
      const i = t.in._zod.run(n, r);
      return i instanceof Promise ? i.then((a) => Uu(a, t, r)) : Uu(i, t, r);
    } else {
      const i = t.out._zod.run(n, r);
      return i instanceof Promise ? i.then((a) => Uu(a, t, r)) : Uu(i, t, r);
    }
  };
});
function Uu(e, t, n) {
  if (e.issues.length)
    return e.aborted = !0, e;
  if ((n.direction || "forward") === "forward") {
    const o = t.transform(e.value, e);
    return o instanceof Promise ? o.then((i) => Wu(e, i, t.out, n)) : Wu(e, o, t.out, n);
  } else {
    const o = t.reverseTransform(e.value, e);
    return o instanceof Promise ? o.then((i) => Wu(e, i, t.in, n)) : Wu(e, o, t.in, n);
  }
}
function Wu(e, t, n, r) {
  return e.issues.length ? (e.aborted = !0, e) : n._zod.run({ value: t, issues: e.issues }, r);
}
const DW = /* @__PURE__ */ ie("$ZodReadonly", (e, t) => {
  Pt.init(e, t), yt(e, "propValues", (n) => n.def.innerType._zod.propValues), yt(e, "values", (n) => n.def.innerType._zod.values), yt(e, "optin", (n) => {
    var r, o;
    return (o = (r = n.def.innerType) == null ? void 0 : r._zod) == null ? void 0 : o.optin;
  }), yt(e, "optout", (n) => {
    var r, o;
    return (o = (r = n.def.innerType) == null ? void 0 : r._zod) == null ? void 0 : o.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then(e6) : e6(o);
  };
});
function e6(e) {
  return e.memo || (e.value = Object.freeze(e.value)), e;
}
const PW = /* @__PURE__ */ ie("$ZodCustom", (e, t) => {
  mr.init(e, t), Pt.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, o = t.fn(r);
    if (o instanceof Promise)
      return o.then((i) => t6(i, n, r, e));
    t6(o, n, r, e);
  };
});
function t6(e, t, n, r) {
  if (!e) {
    const o = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (o.params = r._zod.def.params), t.issues.push(kc(o));
  }
}
class NW extends Error {
  constructor() {
    super("Cannot parse a reference cycle that closes through a transform"), this.name = "ZodCyclicError";
  }
}
const tg = "~memo", n6 = [];
function ow(e) {
  return e !== null && typeof e == "object";
}
function Tp(e) {
  return e.map((t) => t.path ? { ...t, path: t.path.slice() } : { ...t });
}
const iw = /* @__PURE__ */ new WeakMap(), Jl = 0, wd = 1, cc = 2;
function Ed(e, t, n) {
  const r = iw.get(e);
  if (r !== void 0)
    return r ? cc : Jl;
  if (t.has(e))
    return cc;
  t.add(e);
  let o = Jl;
  const i = (u) => {
    if (o !== cc && (u != null && u._zod)) {
      const d = Ed(u, t);
      d > o && (o = d);
    }
  }, a = (u, d) => {
    var h;
    let m = Jl;
    for (const v of Reflect.ownKeys(u)) {
      const g = Object.getOwnPropertyDescriptor(u, v);
      if (!g.enumerable)
        continue;
      const x = g.get ? wd : (h = g.value) != null && h._zod ? Ed(g.value, t) : Jl;
      x > m && (m = x);
    }
    return m;
  }, s = (u) => {
    u > o && (o = u);
  }, l = e._zod.def;
  switch (l.type) {
    case "object": {
      const u = h0(l);
      s(u ? a(u) : wd), i(l.catchall);
      break;
    }
    case "array":
      i(l.element);
      break;
    case "tuple":
      for (const u of l.items)
        i(u);
      i(l.rest);
      break;
    case "record":
    case "map":
      i(l.keyType), i(l.valueType);
      break;
    case "set":
      i(l.valueType);
      break;
    case "union":
      for (const u of l.options)
        i(u);
      break;
    case "intersection":
      i(l.left), i(l.right);
      break;
    case "optional":
    case "nullable":
    case "default":
    case "prefault":
    case "catch":
    case "readonly":
    case "nonoptional":
    case "promise":
    case "success":
      i(l.innerType);
      break;
    case "pipe":
      i(l.in), i(l.out);
      break;
    case "function":
      i(l.input), i(l.output);
      break;
    // `$ZodLazy` caches its inner on the def, so a resolved edge is followed exactly
    case "lazy": {
      const u = l._cachedInner ?? void 0;
      s(u ? Ed(u, t) : wd);
      break;
    }
    // a leaf by choice: `parts` are regex fragments, not data positions
    case "template_literal":
    // leaves
    case "string":
    case "number":
    case "int":
    case "boolean":
    case "bigint":
    case "symbol":
    case "undefined":
    case "null":
    case "void":
    case "never":
    case "any":
    case "unknown":
    case "date":
    case "nan":
    case "enum":
    case "literal":
    case "file":
    case "transform":
    case "custom":
      break;
    default:
      for (const u in l) {
        const d = Object.getOwnPropertyDescriptor(l, u);
        if (!d || d.get)
          continue;
        const m = d.value;
        if (!(!m || typeof m != "object")) {
          if (m._zod)
            i(m);
          else if (Array.isArray(m))
            for (const h of m)
              i(h);
        }
      }
  }
  return t.delete(e), MW(e, o);
}
function MW(e, t) {
  return t !== wd && iw.set(e, t === cc), t;
}
function FW(e, t) {
  let n = e.buckets.get(t);
  return n || (n = /* @__PURE__ */ new WeakMap(), e.buckets.set(t, n)), n;
}
let Hu;
const qu = [], LW = {
  alloc(e, t, n) {
    const r = Hu;
    if (!r)
      return n;
    Hu = void 0;
    const o = { value: n, issues: null };
    return r.set(t.value, o), qu.push(o), n;
  },
  guard(e) {
    var t;
    (t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
      const n = e._zod.parse, r = (o, i) => {
        if (i.direction !== "backward" && zW(i, o.value))
          throw new NW();
        return n(o, i);
      };
      e._zod.parse = r, e._zod.run === n && (e._zod.run = r);
    });
  },
  attach(e) {
    var t;
    let n, r = !1, o, i;
    (t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
      const a = e._zod.parse, s = (l, c) => {
        if (n === void 0) {
          const b = Ed(e, /* @__PURE__ */ new Set());
          if (b === Jl)
            return e._zod.parse = a, e._zod.run === s && (e._zod.run = a), a(l, c);
          b === cc || r ? n = !0 : r = !0;
        }
        const u = l.value;
        if (!ow(u))
          return a(l, c);
        let d = c[tg];
        d || (d = { buckets: /* @__PURE__ */ new WeakMap(), backEdges: void 0 }, c[tg] = d);
        let m;
        o === c ? m = i : (m = FW(d, e), o = c, i = m);
        const h = m.get(u);
        if (h)
          return l.value = h.value, h.issues ? h.issues.length && l.issues.push(...Tp(h.issues)) : (l.memo = !0, d.backEdges ?? (d.backEdges = /* @__PURE__ */ new WeakSet()), d.backEdges.add(h.value)), l;
        Hu = m;
        const v = qu.length, g = a(l, c);
        Hu = void 0;
        const x = qu.length > v ? qu.pop() : void 0;
        return g instanceof Promise ? g.then((b) => (x && (x.issues = b.issues.length ? Tp(b.issues) : n6), b)) : (x && (x.issues = g.issues.length ? Tp(g.issues) : n6), g);
      };
      e._zod.parse = s, e._zod.run === a && (e._zod.run = s);
    });
  }
};
function $W() {
  return LW;
}
function zW(e, t) {
  var r;
  const n = (r = e[tg]) == null ? void 0 : r.backEdges;
  return n !== void 0 && ow(t) && n.has(t);
}
const jW = () => {
  const e = {
    string: { unit: "characters", verb: "to have" },
    file: { unit: "bytes", verb: "to have" },
    array: { unit: "items", verb: "to have" },
    set: { unit: "items", verb: "to have" },
    map: { unit: "entries", verb: "to have" }
  };
  function t(i) {
    return e[i] ?? null;
  }
  const n = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    mac: "MAC address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    currency_code: "currency code",
    credit_card: "credit card number",
    iban: "IBAN",
    jwt: "JWT",
    template_literal: "input"
  }, r = {
    // Compatibility: "nan" -> "NaN" for display
    nan: "NaN"
    // All other type names omitted - they fall back to raw values via ?? operator
  };
  function o(i, a) {
    return i === "number" && typeof a == "number" && !Number.isFinite(a) ? String(a) : r[i] ?? i;
  }
  return (i) => {
    switch (i.code) {
      case "invalid_type": {
        const a = o(i.expected), s = sV(i.input), l = o(s, i.input);
        return `Invalid input: expected ${a}, received ${l}`;
      }
      case "invalid_value":
        return i.values.length === 1 ? `Invalid input: expected ${MC(i.values[0])}` : `Invalid option: expected one of ${Fb(i.values, "|")}`;
      case "too_big": {
        const a = i.exact ? "exactly " : i.inclusive ? "<=" : "<", s = t(i.origin);
        return s ? `Too big: expected ${i.origin ?? "value"} to have ${a}${i.maximum.toString()} ${s.unit ?? "elements"}` : `Too big: expected ${i.origin ?? "value"} to be ${a}${i.maximum.toString()}`;
      }
      case "too_small": {
        const a = i.exact ? "exactly " : i.inclusive ? ">=" : ">", s = t(i.origin);
        return s ? `Too small: expected ${i.origin} to have ${a}${i.minimum.toString()} ${s.unit}` : `Too small: expected ${i.origin} to be ${a}${i.minimum.toString()}`;
      }
      case "invalid_format": {
        const a = i;
        return a.format === "starts_with" ? `Invalid string: must start with "${a.prefix}"` : a.format === "ends_with" ? `Invalid string: must end with "${a.suffix}"` : a.format === "includes" ? `Invalid string: must include "${a.includes}"` : a.format === "regex" ? `Invalid string: must match pattern ${a.pattern}` : `Invalid ${n[a.format] ?? i.format}`;
      }
      case "not_multiple_of":
        return `Invalid number: must be a multiple of ${i.divisor}`;
      case "unrecognized_keys":
        return `Unrecognized key${i.keys.length > 1 ? "s" : ""}: ${Fb(i.keys, ", ")}`;
      case "invalid_key":
        return `Invalid key in ${i.origin}`;
      case "invalid_union":
        return i.options && Array.isArray(i.options) && i.options.length > 0 ? `Invalid discriminator value. Expected ${i.options.map((s) => `'${s}'`).join(" | ")}` : i.inclusive === !1 ? "Invalid input: more than one option matched" : "Invalid input";
      case "invalid_element":
        return `Invalid value in ${i.origin}`;
      default:
        return "Invalid input";
    }
  };
};
function BW() {
  return {
    localeError: jW()
  };
}
var r6;
class GW {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const o = { ...r, ...this._map.get(t) };
      return Object.keys(o).length ? o : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function VW() {
  return new GW();
}
(r6 = globalThis).__zod_globalRegistry ?? (r6.__zod_globalRegistry = VW());
const Ql = globalThis.__zod_globalRegistry;
function Qf(e) {
  return e.checks && (e.checks = [...e.checks]), e;
}
// @__NO_SIDE_EFFECTS__
function UW(e, t) {
  return new e(Qf({ type: "string", ...Oe(t) }));
}
// @__NO_SIDE_EFFECTS__
function WW(e, t) {
  return new e(Qf({ type: "string", coerce: !0, ...Oe(t) }));
}
// @__NO_SIDE_EFFECTS__
function aw(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function HW(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qW(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function YW(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function KW(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ZW(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sw(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function XW(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function JW(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function QW(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eH(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tH(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nH(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rH(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function oH(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function iH(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function aH(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sH(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lH(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cH(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function uH(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dH(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lw(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cw(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fH(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function mH(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pH(e, t) {
  return new e(Qf({ type: "number", checks: [], ...Oe(t) }));
}
// @__NO_SIDE_EFFECTS__
function hH(e, t) {
  return new e(Qf({ type: "number", coerce: !0, checks: [], ...Oe(t) }));
}
// @__NO_SIDE_EFFECTS__
function gH(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function vH(e, t) {
  return new e({
    type: "boolean",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yH(e, t) {
  return new e({
    type: "null",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function bH(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function SH(e, t) {
  return new e({
    type: "never",
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xH(e, t) {
  return new e({
    type: "date",
    coerce: !0,
    ...Oe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function o6(e, t) {
  return new GC({
    check: "less_than",
    ...Oe(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Id(e, t) {
  return new GC({
    check: "less_than",
    ...Oe(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function i6(e, t) {
  return new VC({
    check: "greater_than",
    ...Oe(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Rd(e, t) {
  return new VC({
    check: "greater_than",
    ...Oe(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function a6(e, t) {
  return new hU({
    check: "multiple_of",
    ...Oe(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function uw(e, t) {
  return new vU({
    check: "max_length",
    ...Oe(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function rf(e, t) {
  return new yU({
    check: "min_length",
    ...Oe(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function dw(e, t) {
  return new bU({
    check: "length_equals",
    ...Oe(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function CH(e, t) {
  return new SU({
    check: "string_format",
    format: "regex",
    ...Oe(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function wH(e) {
  return new xU({
    check: "string_format",
    format: "lowercase",
    ...Oe(e)
  });
}
// @__NO_SIDE_EFFECTS__
function EH(e) {
  return new CU({
    check: "string_format",
    format: "uppercase",
    ...Oe(e)
  });
}
// @__NO_SIDE_EFFECTS__
function IH(e, t) {
  return new wU({
    check: "string_format",
    format: "includes",
    ...Oe(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function RH(e, t) {
  return new EU({
    check: "string_format",
    format: "starts_with",
    ...Oe(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function TH(e, t) {
  return new IU({
    check: "string_format",
    format: "ends_with",
    ...Oe(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function fl(e) {
  return new RU({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function _H(e) {
  return /* @__PURE__ */ fl((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function OH() {
  return /* @__PURE__ */ fl((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function AH() {
  return /* @__PURE__ */ fl((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function kH() {
  return /* @__PURE__ */ fl((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function DH() {
  return /* @__PURE__ */ fl((e) => YG(e));
}
// @__NO_SIDE_EFFECTS__
function PH(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Oe(n)
  });
}
// @__NO_SIDE_EFFECTS__
function NH(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Oe(n)
  });
}
// @__NO_SIDE_EFFECTS__
function MH(e, t) {
  const n = /* @__PURE__ */ FH((r) => (r.addIssue = (o) => {
    if (typeof o == "string")
      r.issues.push(kc(o, r.value, n._zod.def));
    else {
      const i = o;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), "input" in i || (i.input = r.value), i.inst ?? (i.inst = n), i.continue ?? (i.continue = !n._zod.def.abort), r.issues.push(kc(i));
    }
  }, e(r.value, r)), t);
  return n;
}
// @__NO_SIDE_EFFECTS__
function FH(e, t) {
  const n = new mr({
    check: "custom",
    ...Oe(t)
  });
  return n._zod.check = e, n;
}
// @__NO_SIDE_EFFECTS__
function LH(e, t) {
  const n = Oe(t);
  let r = n.truthy ?? ["true", "1", "yes", "on", "y", "enabled"], o = n.falsy ?? ["false", "0", "no", "off", "n", "disabled"];
  n.case !== "sensitive" && (r = r.map((h) => typeof h == "string" ? h.toLowerCase() : h), o = o.map((h) => typeof h == "string" ? h.toLowerCase() : h));
  const i = new Set(r), a = new Set(o), s = e.Codec ?? rw, l = e.Boolean ?? JC, c = e.String ?? Jf, u = new c({ type: "string", error: n.error }), d = new l({ type: "boolean", error: n.error }), m = new s({
    type: "pipe",
    in: u,
    out: d,
    transform: ((h, v) => {
      let g = h;
      return n.case !== "sensitive" && (g = g.toLowerCase()), i.has(g) ? !0 : a.has(g) ? !1 : (v.issues.push({
        code: "invalid_value",
        expected: "stringbool",
        values: [...i, ...a],
        input: v.value,
        inst: m,
        continue: !1
      }), {});
    }),
    reverseTransform: ((h, v) => h === !0 ? r[0] || "true" : o[0] || "false"),
    error: n.error
  });
  return m._zod.bag.truthy = r, m._zod.bag.falsy = o, m._zod.bag.case = n.case ?? "insensitive", m;
}
function uc(e, ...t) {
  for (const n of t)
    for (const r of Reflect.ownKeys(n))
      Object.prototype.propertyIsEnumerable.call(n, r) && yi(e, r, n[r]);
  return e;
}
function fw(e) {
  let t = (e == null ? void 0 : e.target) ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: (e == null ? void 0 : e.metadata) ?? Ql,
    target: t,
    unrepresentable: (e == null ? void 0 : e.unrepresentable) ?? "throw",
    override: (e == null ? void 0 : e.override) ?? (() => {
    }),
    io: (e == null ? void 0 : e.io) ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    sharedDefsExtractedFor: void 0,
    sharedEmitDoneFor: void 0,
    cycles: (e == null ? void 0 : e.cycles) ?? "ref",
    reused: (e == null ? void 0 : e.reused) ?? "inline",
    intersections: [],
    deferred: [],
    external: (e == null ? void 0 : e.external) ?? void 0
  };
}
function ui(e, t, n, r, o) {
  const i = typeof t.unrepresentable == "function" ? t.unrepresentable({ zodSchema: e, path: r.path, message: o }) : t.unrepresentable;
  if (i === "any")
    return !1;
  if (i === void 0 || i === "throw")
    throw new Error(o);
  return Object.assign(n, i), !0;
}
function rn(e, t, n = { path: [], schemaPath: [] }) {
  var u, d;
  var r;
  const o = e._zod.def, i = t.seen.get(e);
  if (i)
    return i.count++, n.schemaPath.includes(e) && (i.cycle = n.path), i.schema;
  const a = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, a), t.sharedDefsExtractedFor = void 0, t.sharedEmitDoneFor = void 0;
  const s = (d = (u = e._zod).toJSONSchema) == null ? void 0 : d.call(u);
  if (s)
    a.schema = s;
  else {
    const m = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, a.schema, m);
    else {
      const v = a.schema, g = t.processors[o.type];
      if (!g)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${o.type}`);
      g(e, t, v, m);
    }
    const h = e._zod.parent;
    h && (a.ref || (a.ref = h), rn(h, t, m), t.seen.get(h).isParent = !0);
  }
  const l = t.metadataRegistry.get(e);
  return l && uc(a.schema, l), t.io === "input" && Jn(e) && (delete a.schema.examples, delete a.schema.default), t.io === "input" && "_prefault" in a.schema && ((r = a.schema).default ?? (r.default = a.schema._prefault)), delete a.schema._prefault, t.seen.get(e).schema;
}
function s6(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function mw(e, t) {
  var a, s, l, c;
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  if (e.external && e.sharedDefsExtractedFor === e.external)
    return;
  const r = /* @__PURE__ */ new Map();
  for (const u of e.seen.entries()) {
    const d = (a = e.metadataRegistry.get(u[0])) == null ? void 0 : a.id;
    if (d) {
      const m = r.get(d);
      if (m && m !== u[0])
        throw new Error(`Duplicate schema id "${d}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      r.set(d, u[0]);
    }
  }
  const o = (u) => {
    var g;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const x = (g = e.external.registry.get(u[0])) == null ? void 0 : g.id, b = e.external.uri ?? ((I) => I);
      if (x)
        return { ref: b(x) };
      const C = u[1].defId ?? u[1].schema.id ?? `schema${e.counter++}`;
      return u[1].defId = C, { defId: C, ref: `${b("__shared")}#/${d}/${s6(C)}` };
    }
    const m = "#", h = `${m}/${d}/`;
    if (u[1] === n && !u[1].schema.id)
      return { ref: m };
    const v = u[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: v, ref: h + s6(v) };
  }, i = (u) => {
    if (u[1].schema.$ref)
      return;
    const d = u[1], { ref: m, defId: h } = o(u);
    d.def = { ...d.schema }, h && (d.defId = h);
    const v = d.schema;
    for (const g in v)
      delete v[g];
    v.$ref = m;
  };
  if (e.cycles === "throw")
    for (const u of e.seen.entries()) {
      const d = u[1];
      if (d.cycle)
        throw new Error(`Cycle detected: #/${(s = d.cycle) == null ? void 0 : s.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const u of e.seen.entries()) {
    const d = u[1];
    if (t === u[0]) {
      i(u);
      continue;
    }
    if (e.external) {
      const h = (l = e.external.registry.get(u[0])) == null ? void 0 : l.id;
      if (t !== u[0] && h) {
        i(u);
        continue;
      }
    }
    if ((c = e.metadataRegistry.get(u[0])) == null ? void 0 : c.id) {
      i(u);
      continue;
    }
    if (d.cycle) {
      i(u);
      continue;
    }
    d.count > 1 && e.reused === "ref" && i(u);
  }
  e.external && (e.sharedDefsExtractedFor = e.external);
}
function pw(e) {
  const t = e.anyOf;
  if (!Array.isArray(t) || t.length === 0 || e.type !== void 0)
    return;
  const n = [];
  for (const r of t) {
    if (!r || typeof r != "object")
      return;
    pw(r);
    const o = Object.keys(r);
    if (o.length !== 1 || o[0] !== "type")
      return;
    const i = r.type;
    for (const a of Array.isArray(i) ? i : [i]) {
      if (typeof a != "string")
        return;
      n.includes(a) || n.push(a);
    }
  }
  delete e.anyOf, e.type = n.length === 1 ? n[0] : n;
}
const hw = /* @__PURE__ */ new Set(["type", "properties", "required", "additionalProperties"]), l6 = ["oneOf", "anyOf"];
function c6(e) {
  const t = e.additionalProperties;
  return t === void 0 || t === !1 || typeof t != "object" || t === null ? null : Object.keys(t).length ? t : null;
}
function ng(e) {
  var i;
  const t = [];
  for (const a of e) {
    if (typeof a != "object" || a.type !== "object")
      return null;
    for (const s in a)
      if (!hw.has(s))
        return null;
    t.push(a);
  }
  const n = {}, r = /* @__PURE__ */ new Set();
  for (const a of t) {
    for (const s in a.properties) {
      if (Object.prototype.hasOwnProperty.call(n, s))
        continue;
      const l = [];
      for (const u of t) {
        const d = ((i = u.properties) == null ? void 0 : i[s]) ?? c6(u);
        d != null && (l.some((m) => JSON.stringify(m) === JSON.stringify(d)) || l.push(d));
      }
      const c = l.length === 1 ? l[0] : ng(l) ?? { allOf: l };
      yi(n, s, c);
    }
    for (const s of a.required ?? [])
      r.add(s);
  }
  const o = { type: "object", properties: n };
  if (r.size && (o.required = [...r]), t.every((a) => a.additionalProperties === !1))
    o.additionalProperties = !1;
  else {
    const a = [];
    for (const s of t) {
      const l = c6(s);
      l && !a.some((c) => JSON.stringify(c) === JSON.stringify(l)) && a.push(l);
    }
    a.length === 1 ? o.additionalProperties = a[0] : a.length > 1 && (o.additionalProperties = { allOf: a });
  }
  return o;
}
function $H(e) {
  const t = e.allOf;
  if (!Array.isArray(t) || t.length < 2)
    return;
  for (const o of hw)
    if (o in e)
      return;
  const n = t.filter((o) => l6.some((i) => Array.isArray(o[i])));
  let r = null;
  if (!n.length)
    r = ng(t);
  else {
    const o = n[0], i = l6.find((l) => Array.isArray(o[l]));
    if (Object.keys(o).length !== 1)
      return;
    const a = t.filter((l) => l !== o), s = o[i].map((l) => ng([...a, l]));
    if (s.some((l) => !l))
      return;
    r = { [i]: s };
  }
  r && (delete e.allOf, uc(e, r));
}
function gw(e, t) {
  var s, l, c, u;
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = (d) => {
    const m = e.seen.get(d);
    if (m.ref === null)
      return;
    const h = m.def ?? m.schema, v = { ...h }, g = m.ref;
    if (m.ref = null, g) {
      r(g);
      const b = e.seen.get(g), C = b.schema;
      if (C.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (h.allOf = h.allOf ?? [], h.allOf.push(C)) : uc(h, C), uc(h, v), d._zod.parent === g)
        for (const T in h)
          T === "$ref" || T === "allOf" || T in v || delete h[T];
      if (C.$ref && b.def)
        for (const T in h)
          T === "$ref" || T === "allOf" || T in b.def && JSON.stringify(h[T]) === JSON.stringify(b.def[T]) && delete h[T];
    }
    const x = d._zod.parent;
    if (x && x !== g) {
      r(x);
      const b = e.seen.get(x);
      if (b != null && b.schema.$ref && (h.$ref = b.schema.$ref, b.def))
        for (const C in h)
          C === "$ref" || C === "allOf" || C in b.def && JSON.stringify(h[C]) === JSON.stringify(b.def[C]) && delete h[C];
    }
    e.override({
      zodSchema: d,
      jsonSchema: h,
      path: m.path ?? []
    });
  };
  if (!e.external || e.sharedEmitDoneFor !== e.external) {
    for (const d of [...e.seen.entries()].reverse())
      r(d[0]);
    if (e.target !== "openapi-3.0")
      for (const d of e.seen.entries())
        pw(d[1].def ?? d[1].schema);
    for (const d of e.deferred)
      d();
    if (e.intersections.length) {
      const d = /* @__PURE__ */ new Map();
      for (const m of e.seen.values())
        for (const h of [m.schema, m.def]) {
          const v = h == null ? void 0 : h.allOf;
          if (!Array.isArray(v))
            continue;
          const g = d.get(v);
          g ? g.push(h) : d.set(v, [h]);
        }
      for (const m of e.intersections)
        for (const h of d.get(m) ?? [])
          $H(h);
    }
  }
  const o = {};
  if (e.target === "draft-2020-12" ? o.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? o.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? o.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (s = e.external) != null && s.uri) {
    const d = (l = e.external.registry.get(t)) == null ? void 0 : l.id;
    if (!d)
      throw new Error("Schema is missing an `id` property");
    o.$id = e.external.uri(d);
  }
  uc(o, n.defId ? n.schema : n.def ?? n.schema);
  const i = (c = e.metadataRegistry.get(t)) == null ? void 0 : c.id;
  i !== void 0 && o.id === i && delete o.id;
  const a = ((u = e.external) == null ? void 0 : u.defs) ?? {};
  if (!e.external || e.sharedEmitDoneFor !== e.external)
    for (const d of e.seen.entries()) {
      const m = d[1];
      m.def && m.defId && (m.def.id === m.defId && delete m.def.id, yi(a, m.defId, m.def));
    }
  e.external && (e.sharedEmitDoneFor = e.external), e.external || Object.keys(a).length > 0 && (e.target === "draft-2020-12" ? o.$defs = a : o.definitions = a);
  try {
    const d = JSON.parse(JSON.stringify(o));
    return Object.defineProperty(d, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: of(t, "input", e.processors),
          output: of(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), d;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Jn(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return Jn(r.element, n);
  if (r.type === "set")
    return Jn(r.valueType, n);
  if (r.type === "lazy")
    return Jn(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault" || r.type === "catch")
    return Jn(r.innerType, n);
  if (r.type === "intersection")
    return Jn(r.left, n) || Jn(r.right, n);
  if (r.type === "record" || r.type === "map")
    return Jn(r.keyType, n) || Jn(r.valueType, n);
  if (r.type === "pipe")
    return e._zod.traits.has("$ZodCodec") ? !0 : Jn(r.in, n) || Jn(r.out, n);
  if (r.type === "object") {
    for (const o in r.shape)
      if (Jn(r.shape[o], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const o of r.options)
      if (Jn(o, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const o of r.items)
      if (Jn(o, n))
        return !0;
    return !!(r.rest && Jn(r.rest, n));
  }
  return !1;
}
const zH = (e, t = {}) => (n) => {
  const r = fw({ ...n, processors: t });
  return rn(e, r), mw(r, e), gw(r, e);
}, of = (e, t, n = {}) => (r) => {
  const { libraryOptions: o, target: i } = r ?? {}, a = fw({ ...o ?? {}, target: i, io: t, processors: n });
  return rn(e, a), mw(a, e), gw(a, e);
}, Ks = (e, t, n) => {
  (e[t] === void 0 || n > e[t]) && (e[t] = n);
}, Zs = (e, t, n) => {
  (e[t] === void 0 || n < e[t]) && (e[t] = n);
}, u6 = (e, t) => {
  Ks(e, "minimum", t), Zs(e, "maximum", t);
}, vw = (e, t) => {
  e.multipleOf ?? (e.multipleOf = []), e.multipleOf.includes(t) || e.multipleOf.push(t);
}, yw = (e, t) => {
  e.patterns ?? (e.patterns = /* @__PURE__ */ new Set()), e.patterns.add(t);
}, bw = (e, t) => {
  e.mime = e.mime ? e.mime.filter((n) => t.includes(n)) : [...t];
}, Sw = (e, t) => {
  e.format = t, t.includes("int") && (e.isInt = !0);
}, d6 = (e, t) => Ks(e, "minimum", t.minimum), f6 = (e, t) => Zs(e, "maximum", t.maximum), m6 = (e) => (t, n) => {
  Sw(t, n.format);
  const [r, o] = e[n.format];
  Ks(t, "minimum", r), Zs(t, "maximum", o);
}, _p = {
  greater_than: (e, t) => Ks(e, t.inclusive ? "minimum" : "exclusiveMinimum", t.value),
  less_than: (e, t) => Zs(e, t.inclusive ? "maximum" : "exclusiveMaximum", t.value),
  multiple_of: (e, t) => vw(e, t.value),
  number_format: m6(FC),
  bigint_format: m6(JG),
  min_length: d6,
  max_length: f6,
  length_equals: (e, t) => u6(e, t.length),
  min_size: d6,
  max_size: f6,
  size_equals: (e, t) => u6(e, t.size),
  string_format: (e, t) => {
    Sw(e, t.format), t.pattern && yw(e, t.pattern), (t.format === "base64" || t.format === "base64url") && (e.contentEncoding = t.format), (t.local || t.precision === -1) && (e.laxFormat = !0);
  },
  mime_type: (e, t) => bw(e, t.mime)
};
function dr(e) {
  var i;
  const t = {}, n = e._zod.def, r = e._zod.traits.has("$ZodCheck") ? [e, ...n.checks ?? []] : n.checks ?? [];
  for (const a of r)
    (i = _p[a._zod.def.check]) == null || i.call(_p, t, a._zod.def);
  const o = e._zod.bag;
  o.minimum !== void 0 && Ks(t, "minimum", o.minimum), o.exclusiveMinimum !== void 0 && Ks(t, "exclusiveMinimum", o.exclusiveMinimum), o.maximum !== void 0 && Zs(t, "maximum", o.maximum), o.exclusiveMaximum !== void 0 && Zs(t, "exclusiveMaximum", o.exclusiveMaximum), o.multipleOf !== void 0 && vw(t, o.multipleOf), o.format !== void 0 && (t.format ?? (t.format = o.format), o.format.includes("int") && (t.isInt = !0)), o.mime && bw(t, o.mime);
  for (const a of o.patterns ?? [])
    yw(t, a);
  return t;
}
const jH = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, BH = /* @__PURE__ */ new Map([
  [ZC, eU],
  [I0, tU]
]), xw = (e) => BH.get(e) ?? e, GH = (e, t, n, r) => {
  const o = n;
  o.type = "string";
  const { minimum: i, maximum: a, format: s, patterns: l, contentEncoding: c, laxFormat: u } = dr(e);
  if (typeof i == "number" && (o.minLength = i), typeof a == "number" && (o.maxLength = a), s && (o.format = jH[s] ?? s, o.format === "" && delete o.format, (s === "time" || u) && delete o.format), c && (o.contentEncoding = c), l && l.size > 0) {
    const d = [...l].map(xw);
    d.length === 1 ? o.pattern = d[0].source : d.length > 1 && (o.allOf = [
      ...d.map((m) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: m.source
      }))
    ]);
  }
}, VH = (e, t, n, r) => {
  const o = n, { minimum: i, maximum: a, multipleOf: s, exclusiveMaximum: l, exclusiveMinimum: c, isInt: u } = dr(e);
  o.type = u ? "integer" : "number";
  const d = typeof c == "number" && c >= (i ?? Number.NEGATIVE_INFINITY), m = typeof l == "number" && l <= (a ?? Number.POSITIVE_INFINITY), h = t.target === "draft-04" || t.target === "openapi-3.0";
  if (d ? h ? (o.minimum = c, o.exclusiveMinimum = !0) : o.exclusiveMinimum = c : typeof i == "number" && (o.minimum = i), m ? h ? (o.maximum = l, o.exclusiveMaximum = !0) : o.exclusiveMaximum = l : typeof a == "number" && (o.maximum = a), s) {
    const v = /* @__PURE__ */ new Set();
    for (const b of s)
      Number.isFinite(b) && b !== 0 ? v.add(Math.abs(b)) : ui(e, t, o, r, `A multipleOf divisor of ${b} cannot be represented in JSON Schema`);
    const [g, ...x] = v;
    g !== void 0 && (o.multipleOf = g), x.length && (o.allOf = [...o.allOf ?? [], ...x.map((b) => ({ multipleOf: b }))]);
  }
}, UH = (e, t, n, r) => {
  n.type = "boolean";
}, WH = (e, t, n, r) => {
  t.target === "openapi-3.0" ? (n.type = "string", n.nullable = !0, n.enum = [null]) : n.type = "null";
}, HH = (e, t, n, r) => {
  n.not = {};
}, qH = (e, t, n, r) => {
}, YH = (e, t, n, r) => {
  ui(e, t, n, r, "Date cannot be represented in JSON Schema");
}, KH = (e, t, n, r) => {
  const o = e._zod.def, i = Xh(o.entries);
  if (i.length === 0) {
    n.not = {};
    return;
  }
  i.every((a) => typeof a == "number") && (n.type = "number"), i.every((a) => typeof a == "string") && (n.type = "string"), n.enum = i;
}, ZH = (e, t, n, r) => {
  const o = e._zod.def;
  if (o.values.length === 0) {
    n.not = {};
    return;
  }
  const i = [];
  for (const a of o.values)
    if (a === void 0) {
      if (ui(e, t, n, r, "Literal `undefined` cannot be represented in JSON Schema"))
        return;
    } else if (typeof a == "bigint") {
      if (ui(e, t, n, r, "BigInt literals cannot be represented in JSON Schema"))
        return;
      i.push(Number(a));
    } else
      i.push(a);
  if (i.length !== 0) if (i.length === 1) {
    const a = i[0];
    n.type = a === null ? "null" : typeof a, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [a] : n.const = a;
  } else
    i.every((a) => typeof a == "number") && (n.type = "number"), i.every((a) => typeof a == "string") && (n.type = "string"), i.every((a) => typeof a == "boolean") && (n.type = "boolean"), i.every((a) => a === null) && (n.type = "null"), n.enum = i;
}, XH = (e, t, n, r) => {
  ui(e, t, n, r, "Custom types cannot be represented in JSON Schema");
}, JH = (e, t, n, r) => {
  ui(e, t, n, r, "Transforms cannot be represented in JSON Schema");
}, QH = (e, t, n, r) => {
  const o = n, i = e._zod.def, { minimum: a, maximum: s } = dr(e);
  typeof a == "number" && (o.minItems = a), typeof s == "number" && (o.maxItems = s), o.type = "array", o.items = rn(i.element, t, {
    ...r,
    path: [...r.path, "items"]
  });
};
function Dc(e) {
  const t = e._zod.def;
  return t.type === "pipe" && t.in._zod.traits.has("$ZodTransform") ? Dc(t.out) : t.type === "catch" ? Dc(t.innerType) : e._zod.optin;
}
const eq = (e, t, n, r) => {
  var c;
  const o = n, i = e._zod.def, a = i.shape;
  if (Object.getOwnPropertySymbols(a).length && ui(e, t, o, r, "Symbol keys cannot be represented in JSON Schema"))
    return;
  o.type = "object", o.properties = {};
  for (const u in a)
    yi(o.properties, u, rn(a[u], t, {
      ...r,
      path: [...r.path, "properties", u]
    }));
  const l = [];
  for (const u of Object.keys(a)) {
    const d = i.shape[u];
    (t.io === "input" ? Dc(d) === void 0 : d._zod.optout === void 0) && l.push(u);
  }
  l.length > 0 && (o.required = l), ((c = i.catchall) == null ? void 0 : c._zod.def.type) === "never" ? o.additionalProperties = !1 : i.catchall ? i.catchall && (o.additionalProperties = rn(i.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, tq = (e, t, n, r) => {
  const o = e._zod.def, i = o.inclusive === !1, a = o.options.map((s, l) => rn(s, t, {
    ...r,
    path: [...r.path, i ? "oneOf" : "anyOf", l]
  }));
  i ? n.oneOf = a : n.anyOf = a;
}, nq = (e, t, n, r) => {
  const o = e._zod.def, i = rn(o.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = rn(o.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (c) => "allOf" in c && Object.keys(c).length === 1, l = [
    ...s(i) ? i.allOf : [i],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l, t.intersections.push(l);
}, rq = (e, t, n, r) => {
  const o = n, i = e._zod.def;
  o.type = "array";
  const a = t.target === "draft-2020-12" ? "prefixItems" : "items", s = t.target === "draft-2020-12" || t.target === "openapi-3.0" ? "items" : "additionalItems", l = i.items.map((g, x) => rn(g, t, {
    ...r,
    path: [...r.path, a, x]
  })), c = i.rest ? rn(i.rest, t, {
    ...r,
    path: [...r.path, s, ...t.target === "openapi-3.0" ? [i.items.length] : []]
  }) : null;
  let u = i.items.length;
  for (; u > 0; ) {
    const g = i.items[u - 1];
    if (!(t.io === "input" ? Dc(g) !== void 0 : g._zod.optout === "optional"))
      break;
    u--;
  }
  const d = i.items.length, m = !i.rest;
  t.target === "draft-2020-12" ? (o.prefixItems = l, m ? o.items = !1 : c && (o.items = c), u > 0 && (o.minItems = u), m && (o.maxItems = d)) : t.target === "openapi-3.0" ? (o.items = {
    anyOf: l
  }, c && o.items.anyOf.push(c), u > 0 && (o.minItems = u), m && (o.maxItems = d)) : (o.items = l, m ? o.additionalItems = !1 : c && (o.additionalItems = c), u > 0 && (o.minItems = u), m && (o.maxItems = d));
  const { minimum: h, maximum: v } = dr(e);
  typeof h == "number" && (o.minItems = h), typeof v == "number" && (o.maxItems = v);
};
function rg(e, t, n) {
  var v;
  if (t.$ref) {
    if (n.has(t))
      return t;
    n.add(t);
    const g = (v = e.get(t)) == null ? void 0 : v.def;
    if (!g)
      return t;
    const x = rg(e, g, n);
    return x === g ? t : x;
  }
  for (const g of ["anyOf", "oneOf"]) {
    const x = t[g];
    if (!Array.isArray(x))
      continue;
    const b = x.map((C) => rg(e, C, n));
    b.some((C, I) => C !== x[I]) && (t = { ...t, [g]: b });
  }
  const r = Array.isArray(t.type) ? t.type : [t.type], o = !r.includes("string") && r.some((g) => g === "number" || g === "integer"), i = t.enum ?? (t.const !== void 0 ? [t.const] : void 0);
  if (!o && !(i != null && i.some((g) => typeof g == "number")))
    return t;
  const { minimum: a, maximum: s, exclusiveMinimum: l, exclusiveMaximum: c, multipleOf: u, format: d, id: m, ...h } = t;
  return h.enum ? h.enum = h.enum.map((g) => typeof g == "number" ? String(g) : g) : typeof h.const == "number" && (h.const = String(h.const)), o && (h.type = "string", i || (h.pattern = (r.includes("number") ? w0 : uU).source)), h;
}
const og = /* @__PURE__ */ new WeakMap();
function oq(e) {
  var r;
  const t = /* @__PURE__ */ new Map();
  for (const o of e.seen.values())
    o.def && !t.has(o.schema) && t.set(o.schema, o);
  const n = /* @__PURE__ */ new Map();
  for (const o of og.get(e) ?? []) {
    const i = e.seen.get(o), a = (r = (i == null ? void 0 : i.def) ?? (i == null ? void 0 : i.schema)) == null ? void 0 : r.propertyNames;
    if (!a || a === !0 || n.has(a))
      continue;
    const s = rg(t, a, /* @__PURE__ */ new Set());
    s !== a && n.set(a, s);
  }
  if (n.size)
    for (const o of e.seen.values())
      for (const i of [o.schema, o.def]) {
        const a = i && n.get(i.propertyNames);
        a && (i.propertyNames = a);
      }
}
const iq = (e, t, n, r) => {
  const o = n, i = e._zod.def;
  o.type = "object";
  const a = i.keyType, s = dr(a).patterns;
  if (i.mode === "loose" && s && s.size > 0) {
    const u = rn(i.valueType, t, {
      ...r,
      path: [...r.path, "patternProperties", "*"]
    });
    o.patternProperties = {};
    for (const d of s)
      yi(o.patternProperties, xw(d).source, u);
  } else {
    if (t.target === "draft-07" || t.target === "draft-2020-12") {
      o.propertyNames = rn(i.keyType, t, {
        ...r,
        path: [...r.path, "propertyNames"]
      });
      let u = og.get(t);
      u || (u = [], og.set(t, u), t.deferred.push(() => oq(t))), u.push(e);
    }
    o.additionalProperties = rn(i.valueType, t, {
      ...r,
      path: [...r.path, "additionalProperties"]
    });
  }
  const l = a._zod.values, c = t.io === "input" && Dc(i.valueType) !== void 0;
  if (l && !i.partial && !c) {
    const u = [...l].filter((d) => typeof d == "string" || typeof d == "number");
    u.length > 0 && (o.required = u.map(String));
  }
}, aq = (e, t, n, r) => {
  const o = e._zod.def, i = rn(o.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = o.innerType, n.nullable = !0) : n.anyOf = [i, { type: "null" }];
}, sq = (e, t, n, r) => {
  const o = e._zod.def;
  rn(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType;
}, R0 = Symbol();
function Cw(e, t, n, r, o) {
  let i = !1;
  const a = JSON.stringify(e, (s, l) => typeof l != "bigint" ? l : (i = !0, null));
  return i ? (ui(t, n, r, o, "BigInt defaults cannot be represented in JSON Schema"), R0) : JSON.parse(a);
}
const lq = (e, t, n, r) => {
  const o = e._zod.def;
  rn(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType;
  const a = Cw(o.defaultValue, e, t, n, r);
  a !== R0 && (n.default = a);
}, cq = (e, t, n, r) => {
  const o = e._zod.def;
  rn(o.innerType, t, r);
  const i = t.seen.get(e);
  if (i.ref = o.innerType, t.io !== "input")
    return;
  const a = Cw(o.defaultValue, e, t, n, r);
  a !== R0 && (n._prefault = a);
}, uq = (e, t, n, r) => {
  const o = e._zod.def;
  rn(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType;
  let a;
  try {
    a = o.catchValue(void 0);
  } catch {
    ui(e, t, n, r, "Dynamic catch values are not supported in JSON Schema");
    return;
  }
  n.default = a;
}, dq = (e, t, n, r) => {
  const o = e._zod.def, i = o.in._zod.traits.has("$ZodTransform"), a = t.io === "input" ? i ? o.out : o.in : o.out;
  rn(a, t, r);
  const s = t.seen.get(e);
  s.ref = a;
}, fq = (e, t, n, r) => {
  const o = e._zod.def;
  rn(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType, n.readOnly = !0;
}, ww = (e, t, n, r) => {
  const o = e._zod.def;
  rn(o.innerType, t, r);
  const i = t.seen.get(e);
  i.ref = o.innerType;
}, p6 = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]);
function Yu(e, t, n) {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    get() {
      const r = n(this);
      return Object.defineProperty(this, t, { value: r, configurable: !0, writable: !0 }), r;
    },
    set(r) {
      Object.defineProperty(this, t, { value: r, configurable: !0, writable: !0 });
    }
  });
}
const mq = (e, t) => {
  xV.init(e, t), e.name = "ZodError";
  const n = Object.getPrototypeOf(e);
  p6.has(n) || (p6.add(n), Yu(n, "format", (r) => (o) => EV(r, o)), Yu(n, "flatten", (r) => (o) => wV(r, o)), Yu(n, "addIssue", (r) => (o) => {
    r.issues.push(o), r.message = JSON.stringify(r.issues, Jh, 2);
  }), Yu(n, "addIssues", (r) => (o) => {
    r.issues.push(...o), r.message = JSON.stringify(r.issues, Jh, 2);
  }), Object.defineProperty(n, "isEmpty", {
    configurable: !0,
    enumerable: !1,
    get() {
      return this.issues.length === 0;
    }
  }));
}, Yr = /* @__PURE__ */ ie("ZodError", mq, void 0, {
  Parent: Error
}), pq = /* @__PURE__ */ b0(Yr), hq = /* @__PURE__ */ S0(Yr), gq = /* @__PURE__ */ x0(Yr), vq = /* @__PURE__ */ C0(Yr), yq = /* @__PURE__ */ AV(Yr), bq = /* @__PURE__ */ kV(Yr), Sq = /* @__PURE__ */ DV(Yr), xq = /* @__PURE__ */ PV(Yr), Cq = /* @__PURE__ */ NV(Yr), wq = /* @__PURE__ */ MV(Yr), Eq = /* @__PURE__ */ FV(Yr), Iq = /* @__PURE__ */ LV(Yr);
function Rq() {
  Ur.localeError || Lo(BW());
}
function tu() {
  Ur.memoizer || Lo({ memoizer: $W() });
}
const $t = /* @__PURE__ */ ie("ZodType", (e, t) => (Rq(), Pt.init(e, t), e.def = t, e.type = t.type, e), {
  check(...e) {
    const t = this.def;
    return this.clone(wr(t, {
      checks: [
        ...t.checks ?? [],
        ...e.map((n) => typeof n == "function" ? { _zod: { check: n, def: { check: "custom" }, onattach: [] } } : n)
      ]
    }), { parent: !0 });
  },
  with(...e) {
    return this.check(...e);
  },
  clone(e, t) {
    return sa(this, e, t);
  },
  brand() {
    return this;
  },
  register(e, t) {
    return e.add(this, t), this;
  },
  refine(e, t) {
    return this.check(vY(e, t));
  },
  superRefine(e, t) {
    return this.check(yY(e, t));
  },
  overwrite(e) {
    return this.check(/* @__PURE__ */ fl(e));
  },
  optional() {
    return ag(this);
  },
  exactOptional() {
    return oY(this);
  },
  nullable() {
    return g6(this);
  },
  nullish() {
    return ag(g6(this));
  },
  nonoptional(e) {
    return uY(this, e);
  },
  array() {
    return O(this);
  },
  or(e) {
    return We([this, e]);
  },
  and(e) {
    return Dw(this, e);
  },
  transform(e) {
    return v6(this, rY(e));
  },
  default(e) {
    return sY(this, e);
  },
  prefault(e) {
    return cY(this, e);
  },
  catch(e) {
    return fY(this, e);
  },
  pipe(e) {
    return v6(this, e);
  },
  readonly() {
    return hY(this);
  },
  describe(e) {
    const t = this.clone();
    return Ql.add(t, { description: e }), t;
  },
  meta(...e) {
    if (e.length === 0)
      return Ql.get(this);
    const t = this.clone();
    return Ql.add(t, e[0]), t;
  },
  isOptional() {
    return this.safeParse(void 0).success;
  },
  isNullable() {
    return this.safeParse(null).success;
  },
  apply(e, ...t) {
    return t.length === 0 ? e(this) : e(this, ...t);
  },
  // Overrides core's `~standard` to add `jsonSchema`. Must stay a prototype entry: redefining it per instance demotes instances to dictionary mode.
  get "~standard"() {
    return $C(this, "~standard", {
      ...WC(this),
      jsonSchema: {
        input: of(this, "input"),
        output: of(this, "output")
      }
    });
  },
  set "~standard"(e) {
    Yi(this, "~standard", e);
  },
  parse: function e(t, n) {
    return pq(this, t, n, { callee: e });
  },
  parseAsync: async function e(t, n) {
    return await hq(this, t, n, { callee: e });
  },
  safeParse(e, t) {
    return gq(this, e, t);
  },
  async safeParseAsync(e, t) {
    return vq(this, e, t);
  },
  // `spa` is an alias: same function object as `safeParseAsync`, as before.
  get spa() {
    return this == null ? void 0 : this.safeParseAsync;
  },
  set spa(e) {
    Yi(this, "spa", e);
  },
  validate(e, t) {
    return TV(this, e, t);
  },
  validateAsync(e, t) {
    return OV(this, e, t);
  },
  encode: function e(t, n) {
    return yq(this, t, n, { callee: e });
  },
  decode: function e(t, n) {
    return bq(this, t, n, { callee: e });
  },
  encodeAsync: async function e(t, n) {
    return await Sq(this, t, n, { callee: e });
  },
  decodeAsync: async function e(t, n) {
    return await xq(this, t, n, { callee: e });
  },
  safeEncode(e, t) {
    return Cq(this, e, t);
  },
  safeDecode(e, t) {
    return wq(this, e, t);
  },
  async safeEncodeAsync(e, t) {
    return Eq(this, e, t);
  },
  async safeDecodeAsync(e, t) {
    return Iq(this, e, t);
  },
  toJSONSchema(e) {
    return zH(this, {})(e);
  },
  // Reads through to the registry on every access, so it must not cache.
  get description() {
    var e;
    return (e = Ql.get(this)) == null ? void 0 : e.description;
  },
  // No setter: `schema._def = x` throws, as it did when `_def` was a non-writable own property.
  get _def() {
    return this._zod.def;
  }
}), Ew = /* @__PURE__ */ ie(
  "_ZodString",
  (e, t) => {
    Jf.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => GH(e, n, r);
  },
  /* @__PURE__ */ y0({
    format: (e) => dr(e).format ?? null,
    minLength: (e) => dr(e).minimum ?? null,
    maxLength: (e) => dr(e).maximum ?? null
  }, {
    regex(...e) {
      return this.check(/* @__PURE__ */ CH(...e));
    },
    includes(...e) {
      return this.check(/* @__PURE__ */ IH(...e));
    },
    startsWith(...e) {
      return this.check(/* @__PURE__ */ RH(...e));
    },
    endsWith(...e) {
      return this.check(/* @__PURE__ */ TH(...e));
    },
    min(...e) {
      return this.check(/* @__PURE__ */ rf(...e));
    },
    max(...e) {
      return this.check(/* @__PURE__ */ uw(...e));
    },
    length(...e) {
      return this.check(/* @__PURE__ */ dw(...e));
    },
    nonempty(...e) {
      return this.check(/* @__PURE__ */ rf(1, ...e));
    },
    lowercase(e) {
      return this.check(/* @__PURE__ */ wH(e));
    },
    uppercase(e) {
      return this.check(/* @__PURE__ */ EH(e));
    },
    trim() {
      return this.check(/* @__PURE__ */ OH());
    },
    normalize(...e) {
      return this.check(/* @__PURE__ */ _H(...e));
    },
    toLowerCase() {
      return this.check(/* @__PURE__ */ AH());
    },
    toUpperCase() {
      return this.check(/* @__PURE__ */ kH());
    },
    slugify() {
      return this.check(/* @__PURE__ */ DH());
    }
  })
), T0 = /* @__PURE__ */ ie("ZodString", (e, t) => {
  Jf.init(e, t), Ew.init(e, t);
}, {
  email(e) {
    return this.check(/* @__PURE__ */ aw(Tw, e));
  },
  url(e) {
    return this.check(/* @__PURE__ */ sw(_w, e));
  },
  jwt(e) {
    return this.check(/* @__PURE__ */ dH(Uq, e));
  },
  emoji(e) {
    return this.check(/* @__PURE__ */ XW(Aq, e));
  },
  guid(e) {
    return this.check(/* @__PURE__ */ HW(Oq, e));
  },
  uuid(e) {
    return this.check(/* @__PURE__ */ qW(Ku, e));
  },
  uuidv4(e) {
    return this.check(/* @__PURE__ */ YW(Ku, e));
  },
  uuidv6(e) {
    return this.check(/* @__PURE__ */ KW(Ku, e));
  },
  uuidv7(e) {
    return this.check(/* @__PURE__ */ ZW(Ku, e));
  },
  nanoid(e) {
    return this.check(/* @__PURE__ */ JW(kq, e));
  },
  cuid(e) {
    return this.check(/* @__PURE__ */ QW(Dq, e));
  },
  cuid2(e) {
    return this.check(/* @__PURE__ */ eH(Pq, e));
  },
  ulid(e) {
    return this.check(/* @__PURE__ */ tH(Nq, e));
  },
  base64(e) {
    return this.check(/* @__PURE__ */ lH(Bq, e));
  },
  base64url(e) {
    return this.check(/* @__PURE__ */ cH(Gq, e));
  },
  xid(e) {
    return this.check(/* @__PURE__ */ nH(Mq, e));
  },
  ksuid(e) {
    return this.check(/* @__PURE__ */ rH(Fq, e));
  },
  ipv4(e) {
    return this.check(/* @__PURE__ */ oH(Lq, e));
  },
  ipv6(e) {
    return this.check(/* @__PURE__ */ iH($q, e));
  },
  cidrv4(e) {
    return this.check(/* @__PURE__ */ aH(zq, e));
  },
  cidrv6(e) {
    return this.check(/* @__PURE__ */ sH(jq, e));
  },
  e164(e) {
    return this.check(/* @__PURE__ */ uH(Vq, e));
  },
  datetime(e) {
    return this.check(/* @__PURE__ */ lw(Iw, e));
  },
  date(e) {
    return this.check(/* @__PURE__ */ cw(Rw, e));
  },
  time(e) {
    return this.check(/* @__PURE__ */ fH(Tq, e));
  },
  duration(e) {
    return this.check(/* @__PURE__ */ mH(_q, e));
  }
});
function p(e) {
  return /* @__PURE__ */ UW(T0, e);
}
const tn = /* @__PURE__ */ ie("ZodStringFormat", (e, t) => {
  qt.init(e, t), Ew.init(e, t);
}), Iw = /* @__PURE__ */ ie("ZodISODateTime", (e, t) => {
  HU.init(e, t), tn.init(e, t);
}), Rw = /* @__PURE__ */ ie("ZodISODate", (e, t) => {
  qU.init(e, t), tn.init(e, t);
}), Tq = /* @__PURE__ */ ie("ZodISOTime", (e, t) => {
  YU.init(e, t), tn.init(e, t);
}), _q = /* @__PURE__ */ ie("ZodISODuration", (e, t) => {
  KU.init(e, t), tn.init(e, t);
}), Tw = /* @__PURE__ */ ie("ZodEmail", (e, t) => {
  DU.init(e, t), tn.init(e, t);
});
function Ki(e) {
  return /* @__PURE__ */ aw(Tw, e);
}
const Oq = /* @__PURE__ */ ie("ZodGUID", (e, t) => {
  AU.init(e, t), tn.init(e, t);
}), Ku = /* @__PURE__ */ ie("ZodUUID", (e, t) => {
  kU.init(e, t), tn.init(e, t);
}), _w = /* @__PURE__ */ ie("ZodURL", (e, t) => {
  $U.init(e, t), tn.init(e, t);
});
function Cn(e) {
  return /* @__PURE__ */ sw(_w, e);
}
const Aq = /* @__PURE__ */ ie("ZodEmoji", (e, t) => {
  zU.init(e, t), tn.init(e, t);
}), kq = /* @__PURE__ */ ie("ZodNanoID", (e, t) => {
  jU.init(e, t), tn.init(e, t);
}), Dq = /* @__PURE__ */ ie("ZodCUID", (e, t) => {
  BU.init(e, t), tn.init(e, t);
}), Pq = /* @__PURE__ */ ie("ZodCUID2", (e, t) => {
  GU.init(e, t), tn.init(e, t);
}), Nq = /* @__PURE__ */ ie("ZodULID", (e, t) => {
  VU.init(e, t), tn.init(e, t);
}), Mq = /* @__PURE__ */ ie("ZodXID", (e, t) => {
  UU.init(e, t), tn.init(e, t);
}), Fq = /* @__PURE__ */ ie("ZodKSUID", (e, t) => {
  WU.init(e, t), tn.init(e, t);
}), Lq = /* @__PURE__ */ ie("ZodIPv4", (e, t) => {
  ZU.init(e, t), tn.init(e, t);
}), $q = /* @__PURE__ */ ie("ZodIPv6", (e, t) => {
  JU.init(e, t), tn.init(e, t);
}), zq = /* @__PURE__ */ ie("ZodCIDRv4", (e, t) => {
  QU.init(e, t), tn.init(e, t);
}), jq = /* @__PURE__ */ ie("ZodCIDRv6", (e, t) => {
  tW.init(e, t), tn.init(e, t);
}), Bq = /* @__PURE__ */ ie("ZodBase64", (e, t) => {
  nW.init(e, t), tn.init(e, t);
}), Gq = /* @__PURE__ */ ie("ZodBase64URL", (e, t) => {
  oW.init(e, t), tn.init(e, t);
}), Vq = /* @__PURE__ */ ie("ZodE164", (e, t) => {
  iW.init(e, t), tn.init(e, t);
}), Uq = /* @__PURE__ */ ie("ZodJWT", (e, t) => {
  sW.init(e, t), tn.init(e, t);
}), _0 = /* @__PURE__ */ ie(
  "ZodNumber",
  (e, t) => {
    XC.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => VH(e, n, r, o), e.isFinite = !0;
  },
  /* @__PURE__ */ y0({
    minValue: (e) => {
      const { minimum: t, exclusiveMinimum: n } = dr(e);
      return Math.max(t ?? Number.NEGATIVE_INFINITY, n ?? Number.NEGATIVE_INFINITY);
    },
    maxValue: (e) => {
      const { maximum: t, exclusiveMaximum: n } = dr(e);
      return Math.min(t ?? Number.POSITIVE_INFINITY, n ?? Number.POSITIVE_INFINITY);
    },
    isInt: (e) => {
      const { isInt: t, multipleOf: n } = dr(e);
      return !!t || !!(n != null && n.some(Number.isSafeInteger));
    },
    format: (e) => dr(e).format ?? null
  }, {
    gt(e, t) {
      return this.check(/* @__PURE__ */ i6(e, t));
    },
    gte(e, t) {
      return this.check(/* @__PURE__ */ Rd(e, t));
    },
    min(e, t) {
      return this.check(/* @__PURE__ */ Rd(e, t));
    },
    lt(e, t) {
      return this.check(/* @__PURE__ */ o6(e, t));
    },
    lte(e, t) {
      return this.check(/* @__PURE__ */ Id(e, t));
    },
    max(e, t) {
      return this.check(/* @__PURE__ */ Id(e, t));
    },
    int(e) {
      return this.check(Un(e));
    },
    safe(e) {
      return this.check(Un(e));
    },
    positive(e) {
      return this.check(/* @__PURE__ */ i6(0, e));
    },
    nonnegative(e) {
      return this.check(/* @__PURE__ */ Rd(0, e));
    },
    negative(e) {
      return this.check(/* @__PURE__ */ o6(0, e));
    },
    nonpositive(e) {
      return this.check(/* @__PURE__ */ Id(0, e));
    },
    multipleOf(e, t) {
      return this.check(/* @__PURE__ */ a6(e, t));
    },
    step(e, t) {
      return this.check(/* @__PURE__ */ a6(e, t));
    },
    finite() {
      return this;
    }
  })
);
function w(e) {
  return /* @__PURE__ */ pH(_0, e);
}
const Wq = /* @__PURE__ */ ie("ZodNumberFormat", (e, t) => {
  lW.init(e, t), _0.init(e, t);
});
function Un(e) {
  return /* @__PURE__ */ gH(Wq, e);
}
const Ow = /* @__PURE__ */ ie("ZodBoolean", (e, t) => {
  JC.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => UH(e, n, r);
});
function N(e) {
  return /* @__PURE__ */ vH(Ow, e);
}
const Hq = /* @__PURE__ */ ie("ZodNull", (e, t) => {
  cW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => WH(e, n, r);
});
function Ps(e) {
  return /* @__PURE__ */ yH(Hq, e);
}
const qq = /* @__PURE__ */ ie("ZodUnknown", (e, t) => {
  uW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => qH();
});
function uo() {
  return /* @__PURE__ */ bH(qq);
}
const Yq = /* @__PURE__ */ ie("ZodNever", (e, t) => {
  dW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => HH(e, n, r);
});
function em(e) {
  return /* @__PURE__ */ SH(Yq, e);
}
const Kq = /* @__PURE__ */ ie(
  "ZodDate",
  (e, t) => {
    fW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => YH(e, n, r, o), e.min = (n, r) => e.check(/* @__PURE__ */ Rd(n, r)), e.max = (n, r) => e.check(/* @__PURE__ */ Id(n, r));
  },
  /* @__PURE__ */ y0({
    minDate: (e) => {
      const { minimum: t } = dr(e);
      return t ? new Date(t) : null;
    },
    maxDate: (e) => {
      const { maximum: t } = dr(e);
      return t ? new Date(t) : null;
    }
  }, {})
), Zq = /* @__PURE__ */ ie("ZodArray", (e, t) => {
  tu(), mW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => QH(e, n, r, o), e.element = t.element;
}, {
  min(e, t) {
    return this.check(/* @__PURE__ */ rf(e, t));
  },
  nonempty(e) {
    return this.check(/* @__PURE__ */ rf(1, e));
  },
  max(e, t) {
    return this.check(/* @__PURE__ */ uw(e, t));
  },
  length(e, t) {
    return this.check(/* @__PURE__ */ dw(e, t));
  },
  unwrap() {
    return this.element;
  }
});
function O(e, t) {
  return /* @__PURE__ */ PH(Zq, e, t);
}
const O0 = /* @__PURE__ */ ie("ZodObject", (e, t) => {
  tu(), gW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => eq(e, n, r, o), fV(e, "shape", (n) => n._zod.def.shape, !1);
}, {
  keyof() {
    return ne(Object.keys(this._zod.def.shape));
  },
  catchall(e) {
    return this.clone(wr(this._zod.def, { catchall: e }));
  },
  passthrough() {
    return this.clone(wr(this._zod.def, { catchall: uo() }));
  },
  loose() {
    return this.clone(wr(this._zod.def, { catchall: uo() }));
  },
  strict() {
    return this.clone(wr(this._zod.def, { catchall: em() }));
  },
  strip() {
    return this.clone(wr(this._zod.def, { catchall: void 0 }));
  },
  extend(e) {
    return tV(this, e);
  },
  safeExtend(e) {
    return nV(this, e);
  },
  merge(e) {
    return rV(this, e);
  },
  pick(e) {
    return QG(this, e);
  },
  omit(e) {
    return eV(this, e);
  },
  partial(...e) {
    return Lb(A0, this, e[0]);
  },
  exactPartial(...e) {
    return Lb(Pw, this, e[0], "exactPartial");
  },
  required(...e) {
    return oV(Nw, this, e[0]);
  }
});
function y(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Oe(t)
  };
  return new O0(n);
}
function it(e, t) {
  return new O0({
    type: "object",
    shape: e,
    catchall: em(),
    ...Oe(t)
  });
}
function Aw(e, t) {
  return new O0({
    type: "object",
    shape: e,
    catchall: uo(),
    ...Oe(t)
  });
}
const kw = /* @__PURE__ */ ie("ZodUnion", (e, t) => {
  tw.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => tq(e, n, r, o), e.options = t.options;
});
function We(e, t) {
  return new kw({
    type: "union",
    options: e,
    ...Oe(t)
  });
}
const Xq = /* @__PURE__ */ ie("ZodDiscriminatedUnion", (e, t) => {
  kw.init(e, t), yW.init(e, t);
});
function ke(e, t, n) {
  return new Xq({
    type: "union",
    options: t,
    discriminator: e,
    ...Oe(n)
  });
}
const Jq = /* @__PURE__ */ ie("ZodIntersection", (e, t) => {
  bW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => nq(e, n, r, o);
});
function Dw(e, t) {
  return new Jq({
    type: "intersection",
    left: e,
    right: t
  });
}
const Qq = /* @__PURE__ */ ie("ZodTuple", (e, t) => {
  tu(), SW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => rq(e, n, r, o);
}, {
  rest(e) {
    return this.clone({
      ...this._zod.def,
      rest: e
    });
  },
  partial() {
    var t;
    const e = this._zod.def;
    if ((t = e.checks) != null && t.length)
      throw new Error(".partial() cannot be used on tuple schemas containing refinements");
    return this.clone({
      ...e,
      items: e.items.map((n) => new A0({ type: "optional", innerType: n }))
    });
  }
});
function h6(e, t, n) {
  const r = t instanceof Pt, o = r ? n : t, i = r ? t : null;
  return new Qq({
    type: "tuple",
    items: e,
    rest: i,
    ...Oe(o)
  });
}
const ig = /* @__PURE__ */ ie("ZodRecord", (e, t) => {
  tu(), xW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => iq(e, n, r, o), e.keyType = t.keyType, e.valueType = t.valueType;
});
function nu(e, t, n) {
  return !t || !t._zod ? new ig({
    type: "record",
    keyType: p(),
    valueType: e,
    ...Oe(t)
  }) : new ig({
    type: "record",
    keyType: e,
    valueType: t,
    ...Oe(n)
  });
}
function eY(e, t, n) {
  return new ig({
    type: "record",
    keyType: e,
    valueType: t,
    ...Oe(n),
    partial: !0
  });
}
const af = /* @__PURE__ */ ie("ZodEnum", (e, t) => {
  CW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (r, o, i) => KH(e, r, o), e.enum = t.entries, e.options = [...e._zod.values];
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, o) => {
    const i = {};
    for (const a of r)
      if (n.has(a))
        i[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new af({
      ...t,
      checks: [],
      ...Oe(o),
      entries: i
    });
  }, e.exclude = (r, o) => {
    const i = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete i[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new af({
      ...t,
      checks: [],
      ...Oe(o),
      entries: i
    });
  };
});
function ne(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new af({
    type: "enum",
    entries: n,
    ...Oe(t)
  });
}
function Hn(e, t) {
  return new af({
    type: "enum",
    entries: e,
    ...Oe(t)
  });
}
const tY = /* @__PURE__ */ ie("ZodLiteral", (e, t) => {
  wW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => ZH(e, n, r, o), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function P(e, t) {
  return new tY({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...Oe(t)
  });
}
const nY = /* @__PURE__ */ ie("ZodTransform", (e, t) => {
  tu(), EW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => JH(e, n, r, o), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new zC(e.constructor.name);
    n.addIssue = (i) => {
      if (typeof i == "string")
        n.issues.push(kc(i, n.value, t));
      else {
        const a = i;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), "input" in a || (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(kc(a));
      }
    };
    const o = t.transform(n.value, n);
    return o instanceof Promise ? o.then((i) => (n.value = i, n)) : (n.value = o, n);
  };
});
function rY(e) {
  return new nY({
    type: "transform",
    transform: e
  });
}
const A0 = /* @__PURE__ */ ie("ZodOptional", (e, t) => {
  nw.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => ww(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function ag(e) {
  return new A0({
    type: "optional",
    innerType: e
  });
}
const Pw = /* @__PURE__ */ ie("ZodExactOptional", (e, t) => {
  IW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => ww(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function oY(e) {
  return new Pw({
    type: "optional",
    innerType: e
  });
}
const iY = /* @__PURE__ */ ie("ZodNullable", (e, t) => {
  RW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => aq(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function g6(e) {
  return new iY({
    type: "nullable",
    innerType: e
  });
}
const aY = /* @__PURE__ */ ie("ZodDefault", (e, t) => {
  TW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => lq(e, n, r, o), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function sY(e, t) {
  return new aY({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : NC(t);
    }
  });
}
const lY = /* @__PURE__ */ ie("ZodPrefault", (e, t) => {
  _W.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => cq(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function cY(e, t) {
  return new lY({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : NC(t);
    }
  });
}
const Nw = /* @__PURE__ */ ie("ZodNonOptional", (e, t) => {
  OW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => sq(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function uY(e, t) {
  return new Nw({
    type: "nonoptional",
    innerType: e,
    ...Oe(t)
  });
}
const dY = /* @__PURE__ */ ie("ZodCatch", (e, t) => {
  AW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => uq(e, n, r, o), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function fY(e, t) {
  return new dY({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : pV(t)
  });
}
const Mw = /* @__PURE__ */ ie("ZodPipe", (e, t) => {
  kW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => dq(e, n, r, o), e.in = t.in, e.out = t.out;
});
function v6(e, t) {
  return new Mw({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const mY = /* @__PURE__ */ ie("ZodCodec", (e, t) => {
  Mw.init(e, t), rw.init(e, t);
}), pY = /* @__PURE__ */ ie("ZodReadonly", (e, t) => {
  DW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => fq(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function hY(e) {
  return new pY({
    type: "readonly",
    innerType: e
  });
}
const gY = /* @__PURE__ */ ie("ZodCustom", (e, t) => {
  PW.init(e, t), $t.init(e, t), e._zod.processJSONSchema = (n, r, o) => XH(e, n, r, o);
});
function vY(e, t = {}) {
  return /* @__PURE__ */ NH(gY, e, t);
}
function yY(e, t) {
  return /* @__PURE__ */ MH(e, t);
}
const sg = (...e) => /* @__PURE__ */ LH({
  Codec: mY,
  Boolean: Ow,
  String: T0
}, ...e);
function ru(e) {
  return /* @__PURE__ */ lw(Iw, e);
}
function bY(e) {
  return /* @__PURE__ */ cw(Rw, e);
}
function SY(e) {
  return /* @__PURE__ */ WW(T0, e);
}
function Ee(e) {
  return /* @__PURE__ */ hH(_0, e);
}
function Op(e) {
  return /* @__PURE__ */ xH(Kq, e);
}
const Pc = ne(["Return", "Warranty"]), Sr = (e) => it({
  operator: P("in"),
  /** the dataset's own dimension whose values the filter selects among */
  dimension: e
}), Fs = it({ operator: P("equals") }), Fw = it({
  operator: P("in"),
  values: O(Pc)
}), Bi = {
  maxRows: 500,
  // twelve months back through the end of today: a leap year, today, and a daylight saving hour
  maxRangeDays: 368,
  maxBucketEdges: 400,
  maxDimensions: 3,
  maxFilterValues: 50
}, xY = Date.UTC(1900, 0, 1), CY = Date.UTC(2300, 0, 1), Ls = ru().refine((e) => {
  const t = Date.parse(e);
  return t >= xY && t < CY;
}, { message: "Instants must fall in the years 1900 through 2299" }), xr = O(p().min(1).max(200)).min(1).max(Bi.maxFilterValues), Lw = O(Pc).min(1).max(Pc.options.length), k0 = {
  operator: "in",
  dimension: "productTitle"
}, wY = it({
  description: p(),
  output: ne(["integer", "decimalString"]),
  nullable: N(),
  /** whether values add up across groups and buckets: a `distinct` count can overlap between them, and a `ratio` is a mean or rate */
  additive: ne(["sum", "distinct", "ratio"])
}), Go = (e, t) => ({
  catalog: it({
    dataset: P(e),
    dimensions: O(t.dimension),
    metrics: nu(t.metric, wY),
    filters: t.catalogFilters,
    timeFields: O(t.timeField)
  }),
  request: it({
    dataset: P(e),
    metrics: O(t.metric).min(1).max(t.metric.options.length),
    dimensions: O(t.dimension).max(Bi.maxDimensions),
    // UTC only: the client picks bucket edges (e.g. its local midnights) and sends
    // them as UTC instants, so the API never needs a timezone
    time: it({
      field: t.timeField,
      from: Ls,
      to: Ls,
      /** empty for a single total over the range */
      bucketEdges: O(Ls).max(Bi.maxBucketEdges)
    }),
    filters: t.filters,
    orderBy: O(it({
      field: We([
        P("bucketStart"),
        t.dimension,
        t.metric
      ]),
      direction: ne(["asc", "desc"])
    })).min(1).max(1 + t.dimension.options.length + t.metric.options.length),
    /** a longer result is cut to its first `limit` rows in `orderBy` order, and the response says so in `truncated` */
    limit: Un().min(1).max(Bi.maxRows)
  })
}), qo = ne([
  "reason",
  "reasonDetail",
  "reasonCategory",
  "status",
  "claimStatus",
  "resolution",
  "requestedResolution",
  "productType",
  "inspectionGrade",
  "productTitle",
  "variantTitle",
  "sku"
]), EY = ne([
  "claims",
  "lineItems",
  "items",
  "itemsPerClaim",
  "refundDeflectionRate",
  "refundSaveRate",
  "resolvedExternally",
  "requestedAmount",
  "resolvedAmount",
  "itemValue",
  "itemCost",
  "labelCost",
  "avgLabelCost",
  "avgDaysOrderToClaim",
  "avgDaysClaimToTransit",
  "avgDaysInTransit",
  "avgDaysDeliveredToResolved",
  "avgDaysClaimToResolved"
]), In = {
  claims: "Requests",
  lineItems: "Line items",
  items: "Items",
  itemsPerClaim: "Items per request",
  refundDeflectionRate: "Resolved without a refund",
  refundSaveRate: "Refund requests saved",
  resolvedExternally: "Resolved externally",
  requestedAmount: "Requested amount",
  resolvedAmount: "Resolved amount",
  itemValue: "Item value",
  itemCost: "Item cost",
  labelCost: "Label cost",
  avgLabelCost: "Average label cost",
  avgDaysOrderToClaim: "Days from order to claim",
  avgDaysClaimToTransit: "Days from claim to dropoff",
  avgDaysInTransit: "Days in transit",
  avgDaysDeliveredToResolved: "Days from delivered to resolved",
  avgDaysClaimToResolved: "Days from claim to resolved"
}, $w = ne([
  "createdOn",
  "finalizedOn",
  "deliveredOn",
  "inTransitOn",
  "inspectionCreatedOn"
]), tm = Go("claimItems", {
  dimension: qo,
  metric: EY,
  timeField: $w,
  filters: it({
    claimTypes: Lw.optional(),
    reasons: xr.optional(),
    statuses: xr.optional(),
    claimStatuses: xr.optional(),
    resolutions: xr.optional(),
    requestedResolutions: xr.optional(),
    productTypes: xr.optional(),
    productTitles: xr.optional(),
    hasInspection: N().optional(),
    /** `true` keeps rows whose resolution differs from the one requested; rows missing either are left out both ways */
    wasResolutionChanged: N().optional(),
    isShopNow: N().optional()
  }),
  catalogFilters: it({
    claimTypes: Fw,
    reasons: Sr(qo),
    statuses: Sr(qo),
    claimStatuses: Sr(qo),
    resolutions: Sr(qo),
    requestedResolutions: Sr(qo),
    productTypes: Sr(qo),
    productTitles: Sr(qo),
    hasInspection: Fs,
    wasResolutionChanged: Fs,
    isShopNow: Fs
  })
}), jl = (e, t) => ({
  description: `Mean UTC calendar days from ${e} to ${t}, per line item with both dates, rounded to two places; null when none have both.`,
  output: "decimalString",
  nullable: !0,
  additive: "ratio"
}), IY = {
  dataset: "claimItems",
  dimensions: qo.options,
  metrics: {
    claims: {
      description: "Distinct non-null claim IDs; counts across reasons may overlap.",
      output: "integer",
      nullable: !1,
      additive: "distinct"
    },
    lineItems: {
      description: "Claim line items, counted once each whatever the quantity.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    items: {
      description: "Sum of non-null quantities; null when none are present.",
      output: "integer",
      nullable: !0,
      additive: "sum"
    },
    itemsPerClaim: {
      description: "`items` divided by distinct non-null claim IDs, rounded to two places; null when there are no claims.",
      output: "decimalString",
      nullable: !0,
      additive: "ratio"
    },
    refundDeflectionRate: {
      description: "Quantity resolved by any method but `Refund`, divided by the quantity with a resolution; a fraction rounded to four places, null when nothing is resolved.",
      output: "decimalString",
      nullable: !0,
      additive: "ratio"
    },
    refundSaveRate: {
      description: "Of the quantity requested as a `Refund` and resolved, the share resolved by another method; a fraction rounded to four places, null when no such item is resolved.",
      output: "decimalString",
      nullable: !0,
      additive: "ratio"
    },
    resolvedExternally: {
      description: "Claim line items flagged as resolved outside Corso.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    requestedAmount: {
      description: "Sum of non-null requested amounts in source currency units, without conversion; null when none are present.",
      output: "decimalString",
      nullable: !0,
      additive: "sum"
    },
    resolvedAmount: {
      description: "Sum of non-null resolved amounts in source currency units, without conversion; null when none are present.",
      output: "decimalString",
      nullable: !0,
      additive: "sum"
    },
    itemValue: {
      description: "Sum of original order line item unit price times quantity, where both are present, in source currency units, without conversion; null when none are.",
      output: "decimalString",
      nullable: !0,
      additive: "sum"
    },
    itemCost: {
      description: "Sum of the variant's current unit cost times quantity, where both are present, in source currency units, without conversion; null when none are.",
      output: "decimalString",
      nullable: !0,
      additive: "sum"
    },
    labelCost: {
      description: "Return label cost, counting each distinct rate once per claim because a label covering several line items carries its whole rate on each; in the currency the label was billed in, usually the store’s, and never converted; zero when none are present.",
      output: "decimalString",
      nullable: !1,
      additive: "distinct"
    },
    avgLabelCost: {
      description: "Mean return label cost per distinct rate, counted once per claim as in `labelCost`, rounded to four places; null when none are present.",
      output: "decimalString",
      nullable: !0,
      additive: "ratio"
    },
    avgDaysOrderToClaim: jl("the original order", "the claim"),
    avgDaysClaimToTransit: jl("the claim", "the return going in transit"),
    avgDaysInTransit: jl("the return going in transit", "its delivery"),
    avgDaysDeliveredToResolved: jl("the return delivery", "the claim being finalized, counting a claim finalized before delivery as zero"),
    avgDaysClaimToResolved: jl("the claim", "it being finalized")
  },
  filters: {
    claimTypes: { operator: "in", values: Pc.options },
    reasons: { operator: "in", dimension: "reason" },
    statuses: { operator: "in", dimension: "status" },
    claimStatuses: { operator: "in", dimension: "claimStatus" },
    resolutions: { operator: "in", dimension: "resolution" },
    requestedResolutions: { operator: "in", dimension: "requestedResolution" },
    productTypes: { operator: "in", dimension: "productType" },
    productTitles: k0,
    hasInspection: { operator: "equals" },
    wasResolutionChanged: { operator: "equals" },
    isShopNow: { operator: "equals" }
  },
  timeFields: $w.options
}, RY = ne([
  "itemsSold",
  "returnItemsFinalized",
  "warrantyItemsFinalized",
  "returnRate",
  "warrantyRate"
]), lg = ne([
  "productTitle",
  "variantTitle",
  "lineItemName"
]), zw = ne(["createdOn"]), jw = Go("orderItems", {
  dimension: lg,
  metric: RY,
  timeField: zw,
  filters: it({ productTitles: xr.optional() }),
  catalogFilters: it({
    productTitles: Sr(lg)
  })
}), y6 = (e) => ({
  description: `Units on ${e} claim line items that were approved or denied, counted on the order line they were sold on; null when no order lines match.`,
  output: "integer",
  nullable: !0,
  additive: "sum"
}), b6 = (e, t) => ({
  description: `\`${t}\` divided by \`itemsSold\`, so it counts denied ${e} items as well as approved ones; a fraction rounded to four places, null when nothing was sold.`,
  output: "decimalString",
  nullable: !0,
  additive: "ratio"
}), TY = {
  dataset: "orderItems",
  dimensions: lg.options,
  metrics: {
    itemsSold: {
      description: "Sum of non-null order line quantities, with canceled lines and Corso's own shipping protection line included; null when none are present.",
      output: "integer",
      nullable: !0,
      additive: "sum"
    },
    returnItemsFinalized: y6("return"),
    warrantyItemsFinalized: y6("warranty"),
    returnRate: b6("return", "returnItemsFinalized"),
    warrantyRate: b6("warranty", "warrantyItemsFinalized")
  },
  filters: { productTitles: k0 },
  timeFields: zw.options
}, cg = ne(["status", "creditResolution"]), _Y = ne([
  "claims",
  "newRevenue",
  "retainedRevenue",
  "feesApplied",
  "returnShippingCharged",
  "giftCardIncentives",
  "shopNowIncentives",
  "totalRevenue",
  "totalFees",
  "totalIncentives"
]), Bw = ne(["createdOn", "finalizedOn"]), Gw = Go("claims", {
  dimension: cg,
  metric: _Y,
  timeField: Bw,
  filters: it({
    claimTypes: Lw.optional(),
    statuses: xr.optional(),
    hasShopNow: N().optional()
  }),
  catalogFilters: it({
    claimTypes: Fw,
    statuses: Sr(cg),
    hasShopNow: Fs
  })
}), gs = (e) => ({
  description: `Sum of each claim's ${e}, where present, in source currency units, without conversion; null when none are.`,
  output: "decimalString",
  nullable: !0,
  additive: "sum"
}), Td = (e, t) => ({
  description: `\`${e}\` plus \`${t}\`, with a null one counted as zero; null when both are.`,
  output: "decimalString",
  nullable: !0,
  additive: "sum"
}), OY = {
  dataset: "claims",
  dimensions: cg.options,
  metrics: {
    claims: {
      description: "Requests, one per claim.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    newRevenue: gs("new revenue, such as what an exchange order added above the original item value"),
    retainedRevenue: gs("retained revenue, kept through an exchange or Shop Now and not refunded"),
    feesApplied: gs("service fee charged to the customer"),
    returnShippingCharged: gs("return shipping charged to the customer"),
    giftCardIncentives: gs("gift card incentive"),
    shopNowIncentives: gs("Shop Now incentive"),
    totalRevenue: Td("newRevenue", "retainedRevenue"),
    totalFees: Td("feesApplied", "returnShippingCharged"),
    totalIncentives: Td("giftCardIncentives", "shopNowIncentives")
  },
  filters: {
    claimTypes: { operator: "in", values: Pc.options },
    statuses: { operator: "in", dimension: "status" },
    hasShopNow: { operator: "equals" }
  },
  timeFields: Bw.options
}, ug = ne([
  "salesChannel",
  "shippingTitle",
  "carrier",
  "orderProtectionPrice"
]), AY = ne([
  "orders",
  "protectedOrders",
  "attachRate",
  "protectionPrice",
  "avgProtectionPrice",
  "shippingCharged",
  "avgShippingCharge",
  "carbonGrams"
]), Vw = ne(["orderedOn"]), D0 = Go("orders", {
  dimension: ug,
  metric: AY,
  timeField: Vw,
  filters: it({
    salesChannels: xr.optional(),
    /** `false` keeps orders without shipping protection, whose flag is null in the source */
    isProtected: N().optional(),
    /** Placed through a storefront channel; `false` keeps every other order, those with no channel included */
    isOnline: N().optional()
  }),
  catalogFilters: it({
    salesChannels: Sr(ug),
    isProtected: Fs,
    isOnline: Fs
  })
}), dg = (e, t) => ({
  description: `Mean ${e} over the ${t} that have one, rounded to four places; null when none do.`,
  output: "decimalString",
  nullable: !0,
  additive: "ratio"
}), kY = {
  dataset: "orders",
  dimensions: ug.options,
  metrics: {
    orders: {
      description: "Orders, canceled ones included.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    protectedOrders: {
      description: "Orders with shipping protection attached.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    attachRate: {
      description: "`protectedOrders` divided by `orders`; a fraction rounded to four places, null when there are no orders.",
      output: "decimalString",
      nullable: !0,
      additive: "ratio"
    },
    protectionPrice: {
      description: "Sum of each protected order's protection tier price, in USD at the tier's current price, which is not the amount charged at checkout; null when none are present.",
      output: "decimalString",
      nullable: !0,
      additive: "sum"
    },
    avgProtectionPrice: {
      description: "`protectionPrice` divided by `protectedOrders`, in USD, rounded to four places; null when no order is protected.",
      output: "decimalString",
      nullable: !0,
      additive: "ratio"
    },
    shippingCharged: {
      description: "Sum of the shipping price charged on each order, where present, in source currency units, without conversion; null when none are.",
      output: "decimalString",
      nullable: !0,
      additive: "sum"
    },
    avgShippingCharge: dg("shipping price", "orders"),
    carbonGrams: {
      description: "Sum of the grams of carbon recorded on each order; null when none are present.",
      output: "integer",
      nullable: !0,
      additive: "sum"
    }
  },
  filters: {
    salesChannels: { operator: "in", dimension: "salesChannel" },
    isProtected: { operator: "equals" },
    isOnline: { operator: "equals" }
  },
  timeFields: Vw.options
}, fg = ne(["reason", "status", "source"]), DY = ne([
  "claims",
  "refundAmount",
  "reorderAmount",
  "totalClaimAmount",
  "avgRefundAmount",
  "avgReorderAmount"
]), Uw = ne(["createdOn", "resolvedOn"]), P0 = Go("shippingClaims", {
  dimension: fg,
  metric: DY,
  timeField: Uw,
  filters: it({ statuses: xr.optional() }),
  catalogFilters: it({
    statuses: Sr(fg)
  })
}), PY = {
  dataset: "shippingClaims",
  dimensions: fg.options,
  metrics: {
    claims: {
      description: "Shipping protection claims.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    refundAmount: {
      description: "Sum of each claim's refunds, where it has any, in source currency units, without conversion; null when none do.",
      output: "decimalString",
      nullable: !0,
      additive: "sum"
    },
    reorderAmount: {
      description: "Sum of each claim's reorders, where it has any, at the reorder's recorded amount or else its order total, in source currency units, without conversion; null when none do.",
      output: "decimalString",
      nullable: !0,
      additive: "sum"
    },
    totalClaimAmount: Td("refundAmount", "reorderAmount"),
    avgRefundAmount: dg("refund total", "claims"),
    avgReorderAmount: dg("reorder total", "claims")
  },
  filters: { statuses: { operator: "in", dimension: "status" } },
  timeFields: Uw.options
}, _d = ne([
  "salesChannelName",
  "productTitle",
  "variantDisplayName"
]), NY = ne([
  "registrations",
  "registeredProducts",
  "orderClaims",
  "newCustomers",
  "newSubscribers"
]), Ww = ne(["createdOn", "purchasedOn"]), Hw = Go("registrations", {
  dimension: _d,
  metric: NY,
  timeField: Ww,
  filters: it({
    salesChannelNames: xr.optional(),
    productTitles: xr.optional()
  }),
  catalogFilters: it({
    salesChannelNames: Sr(_d),
    productTitles: Sr(_d)
  })
}), MY = {
  dataset: "registrations",
  dimensions: _d.options,
  metrics: {
    registrations: {
      description: "Distinct registrations, canceled ones included; one covering several products counts in each product group.",
      output: "integer",
      nullable: !1,
      additive: "distinct"
    },
    registeredProducts: {
      description: "Line items on the registrations' orders, one each whatever the quantity; a registration whose order has no line items still counts once, under a null product.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    orderClaims: {
      description: "Claims on the registrations' orders, of any type and not only warranties, counting each order's claims once; zero when none are present. The count is as of each registration's last update, so a claim filed after it may be missing.",
      output: "integer",
      nullable: !1,
      additive: "distinct"
    },
    newCustomers: {
      description: "Distinct registrations that created their customer on the platform, which had no customer with that email before.",
      output: "integer",
      nullable: !1,
      additive: "distinct"
    },
    newSubscribers: {
      description: "Distinct registrations that subscribed their customer to email marketing on the platform, where the customer was not subscribed before.",
      output: "integer",
      nullable: !1,
      additive: "distinct"
    }
  },
  filters: {
    salesChannelNames: { operator: "in", dimension: "salesChannelName" },
    productTitles: k0
  },
  timeFields: Ww.options
}, qw = ne(["editType", "orderId"]), FY = ne(["edits", "minutesSaved", "newRevenue"]), Yw = ne(["createdOn"]), Kw = Go("orderEdits", {
  dimension: qw,
  metric: FY,
  timeField: Yw,
  filters: it({}),
  catalogFilters: it({})
}), LY = {
  dataset: "orderEdits",
  dimensions: qw.options,
  metrics: {
    edits: {
      description: "Order edits applied.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    minutesSaved: {
      description: "Sum of each edit's estimated minutes saved, where it has one; null when none do.",
      output: "integer",
      nullable: !0,
      additive: "sum"
    },
    newRevenue: {
      description: "Sum of each edit's new revenue, where it has any, in source currency units, without conversion; null when none do.",
      output: "decimalString",
      nullable: !0,
      additive: "sum"
    }
  },
  filters: {},
  timeFields: Yw.options
}, $Y = ne([
  "conversations",
  "avgFirstResponseMinutes"
]), Zw = ne(["startedOn", "firstRespondedOn"]), Xw = Go("supportConversations", {
  dimension: ne([]),
  metric: $Y,
  timeField: Zw,
  filters: it({}),
  catalogFilters: it({})
}), zY = {
  dataset: "supportConversations",
  dimensions: [],
  metrics: {
    conversations: {
      description: "Conversations Corso Concierge handled, counted as Front counts them: a conversation idle for 5 days starts a new one at its next activity.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    avgFirstResponseMinutes: {
      description: "Mean minutes from a conversation's first customer message to the first teammate reply, inside Front's business hours (Monday to Friday 9:00-17:00 Mountain time), to 2 places; null when none were answered.",
      output: "decimalString",
      nullable: !0,
      additive: "ratio"
    }
  },
  filters: {},
  timeFields: Zw.options
}, Jw = ne(["sentBy", "channel"]), jY = ne(["messagesSent", "messagesReceived"]), Qw = ne(["sentOn"]), e8 = Go("supportMessages", {
  dimension: Jw,
  metric: jY,
  timeField: Qw,
  filters: it({}),
  catalogFilters: it({})
}), BY = {
  dataset: "supportMessages",
  dimensions: Jw.options,
  metrics: {
    messagesSent: {
      description: "Messages sent to customers, by teammates or by automation such as autoreplies, as Front counts them.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    messagesReceived: {
      description: "Messages customers sent.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    }
  },
  filters: {},
  timeFields: Qw.options
}, t8 = ne(["csatRating"]), GY = ne([
  "csatScore",
  "scoresCollected",
  "scoresWithComment"
]), n8 = ne(["ratedOn"]), r8 = Go("supportCsat", {
  dimension: t8,
  metric: GY,
  timeField: n8,
  filters: it({}),
  catalogFilters: it({})
}), VY = {
  dataset: "supportCsat",
  dimensions: t8.options,
  metrics: {
    csatScore: {
      description: "Mean of each survey rating as a fraction of its scale, to 4 places; null when no ratings were collected.",
      output: "decimalString",
      nullable: !0,
      additive: "ratio"
    },
    scoresCollected: {
      description: "Customer satisfaction survey ratings collected.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    },
    scoresWithComment: {
      description: "Ratings that came with a written comment.",
      output: "integer",
      nullable: !1,
      additive: "sum"
    }
  },
  filters: {},
  timeFields: n8.options
}, zt = p().nullable().optional(), jn = Un().nonnegative().optional(), vs = Un().nullable().optional(), lt = p().regex(/^-?\d+(?:\.\d+)?$/).nullable().optional(), S6 = it({
  time: Ls,
  id: Un()
}), zr = p().nullable(), Xo = ru().nullable(), UY = Un().nullable(), x6 = lt.unwrap(), N0 = (e, t, n) => {
  const r = it({
    list: P(e),
    // the dataset's time fields and UTC range; rows come back newest first on this field, then by `id`
    time: it({
      field: t.request.shape.time.shape.field,
      from: Ls,
      to: Ls
    }),
    filters: t.request.shape.filters,
    /** null for the first page, then the previous page's `nextCursor` */
    cursor: S6.nullable(),
    limit: Un().min(1).max(Bi.maxRows)
  });
  return {
    catalog: it({
      list: P(e),
      columns: nu(n.keyof(), it({
        description: p(),
        output: ne(["integer", "decimalString", "string", "datetime"]),
        nullable: N()
      }))
    }),
    request: r,
    response: it({
      query: r,
      rows: O(n),
      /** null on the last page */
      nextCursor: S6.nullable()
    })
  };
}, WY = it({
  id: Un(),
  createdOn: Xo,
  finalizedOn: Xo,
  deliveredOn: Xo,
  inTransitOn: Xo,
  inspectionCreatedOn: Xo,
  orderedOn: Xo,
  orderNumber: zr,
  productTitle: zr,
  sku: zr,
  quantity: UY,
  reason: zr,
  resolution: zr,
  inspectionGrade: zr
}), M0 = N0("claimItems", tm, WY), HY = it({
  id: Un(),
  orderedOn: Xo,
  orderNumber: zr,
  salesChannel: zr,
  orderTotal: x6,
  protectionPrice: x6
}), F0 = N0("orders", D0, HY), qY = it({
  id: Un(),
  createdOn: Xo,
  resolvedOn: Xo,
  orderName: zr,
  status: zr,
  resolution: zr,
  reason: zr
}), L0 = N0("shippingClaims", P0, qY);
it({
  datasets: h6([
    tm.catalog,
    jw.catalog,
    Gw.catalog,
    D0.catalog,
    P0.catalog,
    Hw.catalog,
    Kw.catalog,
    Xw.catalog,
    e8.catalog,
    r8.catalog
  ]),
  /** row-level lists: each is named for a dataset, takes its time fields and filters, and returns these columns */
  lists: h6([
    M0.catalog,
    F0.catalog,
    L0.catalog
  ]),
  time: it({
    timezone: P("UTC"),
    bounds: P("[from,to)"),
    bucketEdges: P("ascending, first equals from, all before to")
  }),
  limits: it({
    maxRows: Un().positive(),
    maxRangeDays: Un().positive(),
    maxBucketEdges: Un().positive(),
    maxDimensions: Un().positive(),
    maxFilterValues: Un().positive()
  })
});
const Xs = {
  datasets: [
    IY,
    TY,
    OY,
    kY,
    PY,
    MY,
    LY,
    zY,
    BY,
    VY
  ],
  limits: Bi
}, o8 = `Date range must be between 1 and ${Bi.maxRangeDays} days`, i8 = ({ from: e, to: t }) => {
  const n = (Date.parse(t) - Date.parse(e)) / 864e5;
  return n > 0 && n <= Bi.maxRangeDays;
}, YY = tm.request, KY = ke("dataset", [
  tm.request,
  jw.request,
  Gw.request,
  D0.request,
  P0.request,
  Hw.request,
  Kw.request,
  Xw.request,
  e8.request,
  r8.request
]).superRefine((e, t) => {
  i8(e.time) || t.addIssue({
    code: "custom",
    message: o8,
    path: ["time", "to"]
  });
  for (const u of ["dimensions", "metrics"])
    new Set(e[u]).size !== e[u].length && t.addIssue({
      code: "custom",
      message: `${u} must be unique`,
      path: [u]
    });
  const { from: n, to: r, bucketEdges: o } = e.time, i = o.map((u) => Date.parse(u)), a = i.slice(1).every((u, d) => u > (i[d] ?? u));
  i.length > 0 && (i[0] !== Date.parse(n) || !a || i.some((u) => u >= Date.parse(r)) || // bucketStart comes back in whole seconds, so a fractional edge would never match its rows
  i.some((u) => u % 1e3 !== 0)) && t.addIssue({
    code: "custom",
    message: "Bucket edges must be whole seconds, ascend, start at `from`, and fall before `to`",
    path: ["time", "bucketEdges"]
  });
  const s = [
    ...e.dimensions,
    ...o.length === 0 ? [] : ["bucketStart"]
  ], l = /* @__PURE__ */ new Set([...s, ...e.metrics]), c = new Set(e.orderBy.map(({ field: u }) => u));
  (c.size !== e.orderBy.length || [...c].some((u) => !l.has(u)) || s.some((u) => !c.has(u))) && t.addIssue({
    code: "custom",
    message: "Order fields must be unique, selected, and include every grouping field for stable results",
    path: ["orderBy"]
  });
}), ZY = it({
  bucketStart: ru().optional(),
  reason: zt,
  reasonDetail: zt,
  reasonCategory: zt,
  status: zt,
  claimStatus: zt,
  resolution: zt,
  requestedResolution: zt,
  productType: zt,
  inspectionGrade: zt,
  productTitle: zt,
  variantTitle: zt,
  sku: zt,
  lineItemName: zt,
  salesChannel: zt,
  shippingTitle: zt,
  carrier: zt,
  salesChannelName: zt,
  variantDisplayName: zt,
  // a decimal string, unlike the other groups
  orderProtectionPrice: lt,
  source: zt,
  editType: zt,
  // Corso's own order ID as a string, like every other group
  orderId: zt,
  creditResolution: zt,
  sentBy: zt,
  channel: zt,
  csatRating: zt,
  claims: jn,
  lineItems: jn,
  items: vs,
  itemsPerClaim: lt,
  refundDeflectionRate: lt,
  refundSaveRate: lt,
  resolvedExternally: jn,
  requestedAmount: lt,
  resolvedAmount: lt,
  itemValue: lt,
  itemCost: lt,
  labelCost: lt,
  avgLabelCost: lt,
  avgDaysOrderToClaim: lt,
  avgDaysClaimToTransit: lt,
  avgDaysInTransit: lt,
  avgDaysDeliveredToResolved: lt,
  avgDaysClaimToResolved: lt,
  itemsSold: vs,
  returnItemsFinalized: vs,
  warrantyItemsFinalized: vs,
  returnRate: lt,
  warrantyRate: lt,
  newRevenue: lt,
  retainedRevenue: lt,
  feesApplied: lt,
  returnShippingCharged: lt,
  giftCardIncentives: lt,
  shopNowIncentives: lt,
  totalRevenue: lt,
  totalFees: lt,
  totalIncentives: lt,
  orders: jn,
  protectedOrders: jn,
  attachRate: lt,
  protectionPrice: lt,
  avgProtectionPrice: lt,
  shippingCharged: lt,
  avgShippingCharge: lt,
  carbonGrams: vs,
  refundAmount: lt,
  reorderAmount: lt,
  totalClaimAmount: lt,
  avgRefundAmount: lt,
  avgReorderAmount: lt,
  registrations: jn,
  registeredProducts: jn,
  orderClaims: jn,
  newCustomers: jn,
  newSubscribers: jn,
  edits: jn,
  minutesSaved: vs,
  conversations: jn,
  avgFirstResponseMinutes: lt,
  messagesSent: jn,
  messagesReceived: jn,
  csatScore: lt,
  scoresCollected: jn,
  scoresWithComment: jn
});
it({
  query: KY,
  rows: O(ZY),
  /** `true` when the result had more rows than `limit`, so `rows` is only its first `limit` */
  truncated: N()
});
ke("list", [
  M0.request,
  F0.request,
  L0.request
]).refine(({ time: e }) => i8(e), {
  message: o8,
  path: ["time", "to"]
});
We([
  M0.response,
  F0.response,
  L0.response
]);
const a8 = We([P("Monthly"), P("Weekly")]), Ap = y({
  id: w(),
  invoiceDefinitionId: w(),
  name: p(),
  amount: w(),
  type: p(),
  createdOn: p(),
  updatedOn: p().nullable()
});
y({
  id: w(),
  startDate: Op(),
  endDate: Op(),
  createdOn: Op(),
  isUsed: N(),
  frequency: a8,
  isTrial: N(),
  crewChargeMinimum: Ap.optional(),
  gspCharge: Ap.optional(),
  crewCharge: Ap.optional(),
  storeName: p(),
  isTest: N(),
  isActive: N()
});
y({
  termInMonths: w(),
  name: p(),
  frequency: a8,
  startDate: p(),
  amount: w(),
  minimumAmount: w(),
  gspDiscount: w()
});
var C6;
(function(e) {
  e[e.shopify = 1] = "shopify", e[e.bigCommerce = 2] = "bigCommerce", e[e.custom = 3] = "custom";
})(C6 || (C6 = {}));
var mg;
(function(e) {
  e.protectedOrders = "Protected Orders", e.reorders = "Reorders", e.refunds = "Refunds", e.adjustments = "Adjustments", e.revShare = "Revenue Share", e.crewSubscriptionCharge = "Crew Subscription Charge";
})(mg || (mg = {}));
const $o = {
  easyPost: "Easy_Post",
  vesyl: "Vesyl",
  globalE: "Global_E",
  happyReturns: "Happy_Returns"
};
var w6;
(function(e) {
  e.shopify = "Shopify", e.bigCommerce = "BigCommerce", e.custom = "Custom";
})(w6 || (w6 = {}));
var sf;
(function(e) {
  e.stripe = "Stripe", e.shopifySubscription = "Shopify_Subscription";
})(sf || (sf = {}));
var E6;
(function(e) {
  e.billing = "Billing", e.fulfillment = "Fulfillment", e.shipping = "Shipping", e.return = "Return";
})(E6 || (E6 = {}));
var lf;
(function(e) {
  e.gsp = "GSP", e.crew = "CREW";
})(lf || (lf = {}));
var I6;
(function(e) {
  e.generated = "Generated", e.submitted = "Submitted", e.paid = "Paid", e.partiallyPaid = "Partially_Paid", e.uncollectable = "Uncollectable", e.zeroDollar = "Zero_Dollar", e.writtenOff = "Written_Off", e.submissionScheduled = "Submission_Scheduled";
})(I6 || (I6 = {}));
var pg;
(function(e) {
  e.partner = "Partner", e.accountExecutive = "Account_Executive", e.merchant = "Merchant";
})(pg || (pg = {}));
var hg;
(function(e) {
  e.billing = "Billing", e.support = "Support";
})(hg || (hg = {}));
var R6;
(function(e) {
  e.invoiceCreditCreate = "Invoice_Credit_Create", e.credit = "Credit", e.debit = "Debit", e.invoiceCreditApply = "Invoice_Credit_Apply";
})(R6 || (R6 = {}));
var T6;
(function(e) {
  e.paypal = "Paypal", e.venmo = "Venmo", e.shopifyAdmin = "Shopify_Admin", e.shopifyApi = "Shopify_API";
})(T6 || (T6 = {}));
const Wt = {
  corsoAdmin: "Corso_Admin",
  admin: "Admin",
  staff: "Staff",
  commerceApiAdmin: "Commerce_API_Admin"
};
Wt.corsoAdmin + "", Wt.admin + "", Wt.staff + "", Wt.commerceApiAdmin + "";
Wt.commerceApiAdmin, Wt.commerceApiAdmin, Wt.admin, Wt.admin, Wt.corsoAdmin, Wt.corsoAdmin, Wt.staff, Wt.staff;
var _6;
(function(e) {
  e.product = "Product", e.order = "Order", e.variant = "Variant", e.variantMetafield = "Variant_Metafield";
})(_6 || (_6 = {}));
const s8 = y({
  id: w(),
  name: p(),
  storeCount: w(),
  createdOn: p().nullable()
}), l8 = y({
  id: w(),
  email: p(),
  firstName: p().nullable(),
  lastName: p().nullable(),
  roleCode: ne(Wt),
  createdOn: p().nullable()
});
s8.extend({
  users: O(l8)
});
const O6 = {
  userList: l8,
  create: s8.pick({ name: !0 })
}, c8 = w().nonnegative("Charge amount must be non-negative").max(9999.99, "Charge amount cannot exceed 9999.99"), u8 = y({
  cartValueStart: w().nonnegative("Cart value start must be non-negative"),
  cartValueEnd: w().positive("Cart value end must be greater than 0")
}), XY = u8.extend({
  chargePercentage: w().min(0, "Charge percentage must be between 0 and 100").max(100, "Charge percentage must be between 0 and 100"),
  unitInterval: P([25, 50, 100, 200, 250])
}), JY = u8.extend({
  chargeAmount: c8,
  unitInterval: P("none")
}), QY = ke("unitInterval", [XY, JY]);
y({
  name: p().min(1, "Ship protect set name is required"),
  displayName: p().optional(),
  tiers: O(QY).min(1, "At least one tier is required")
});
const eK = y({
  id: w(),
  name: p(),
  displayName: p().nullable(),
  code: p().nullable(),
  description: p().nullable(),
  createdOn: p(),
  updatedOn: p().nullable(),
  storeCount: w()
}), tK = y({
  id: w(),
  rangeStart: w(),
  rangeEnd: w(),
  chargeAmount: w(),
  billMerchantAmount: w(),
  sku: p().nullable()
});
y({
  chargeAmount: c8,
  rangeStart: w().nonnegative("Range start must be non-negative"),
  rangeEnd: w().positive("Range end must be greater than 0"),
  billMerchantAmount: w().nonnegative("Bill merchant amount must be non-negative").optional()
});
eK.extend({
  units: O(tK)
});
const nm = {
  warranty: "Warranty",
  return: "Return"
}, Qt = {
  Return: "Return",
  Warranty: "Warranty",
  Shipping: "Shipping",
  Registration: "Registration",
  Order: "Order"
}, nK = {
  Return: Qt.Return,
  Warranty: Qt.Warranty,
  Registration: Qt.Registration,
  Shipping: Qt.Shipping
}, ec = {
  Order_Fulfilled_On: "Order_Fulfilled_On",
  Order_Created_On: "Order_Created_On",
  Order_Payment_Processed_On: "Order_Payment_Processed_On",
  Order_Shipment_Delivered_On: "Order_Shipment_Delivered_On"
};
ec.Order_Created_On + "", ec.Order_Fulfilled_On + "", ec.Order_Shipment_Delivered_On + "", ec.Order_Payment_Processed_On + "";
const Od = {
  Bypass: "Bypass",
  Decrement_Ignoring_Policy: "Decrement_Ignoring_Policy",
  Decrement_Obeying_Policy: "Decrement_Obeying_Policy"
};
Od.Bypass + "", Od.Decrement_Ignoring_Policy + "", Od.Decrement_Obeying_Policy + "";
const Ht = {
  customerName: "customer_name",
  customerEmail: "customer_email",
  createdDate: "created_date",
  status: "status",
  productName: "product_name",
  productSku: "product_sku",
  quantity: "quantity",
  price: "price"
}, Oo = {
  originalOrderName: "original_order_name",
  originalOrderId: "original_order_id",
  originalOrderDate: "original_order_date",
  finalizedDate: "finalized_date",
  resolutionMethod: "resolution_method"
}, rK = {
  // identifiers
  claimId: "claim_id",
  originalOrderName: Oo.originalOrderName,
  originalOrderId: Oo.originalOrderId,
  originalOrderDate: Oo.originalOrderDate,
  // customer
  customerName: Ht.customerName,
  customerEmail: Ht.customerEmail,
  // claim metadata
  createdDate: Ht.createdDate,
  finalizedDate: Oo.finalizedDate,
  status: Ht.status,
  tags: "tags",
  // line item
  productName: Ht.productName,
  productSku: Ht.productSku,
  quantity: Ht.quantity,
  price: Ht.price,
  // line item status & resolution
  lineItemStatus: "line_item_status",
  lineItemStatusDetail: "line_item_status_detail",
  lineItemReason: "line_item_reason",
  lineItemReasonDetail: "line_item_reason_detail",
  requestedResolutionMethod: "requested_resolution_method",
  resolutionMethod: Oo.resolutionMethod,
  lineItemNoteFromCustomer: "line_item_note_from_customer",
  lineItemNoteToCustomer: "line_item_note_to_customer",
  // shipping & media
  returnTrackingNumber: "return_tracking_number",
  lineItemMedia: "line_item_media",
  // fees
  feeName: "fee_name",
  feeApplied: "fee_applied",
  returnShippingFeeApplied: "return_shipping_fee_applied",
  exchangeOrderShippingFeeApplied: "exchange_order_shipping_fee_applied",
  // inspection
  inspectionGrade: "inspection_grade",
  inspectionDate: "inspection_date",
  inspectionMedia: "inspection_media"
}, oK = {
  // identifiers
  registrationId: "registration_id",
  // customer
  customerName: Ht.customerName,
  customerEmail: Ht.customerEmail,
  // registration metadata
  createdDate: Ht.createdDate,
  status: Ht.status,
  canceledDate: "canceled_date",
  estimatedPurchaseDate: "estimated_purchase_date",
  channel: "channel",
  tags: "tags",
  proofOfPurchaseFileUrls: "proof_of_purchase_file_urls",
  // line item
  productName: Ht.productName,
  productSku: Ht.productSku,
  quantity: Ht.quantity,
  price: Ht.price,
  // marketing & incentive
  customerCreatedOnPlatform: "customer_created_on_platform",
  emailMarketingConsentCollected: "email_marketing_consent_collected",
  emailMarketingConsentUpdatedOnPlatform: "email_marketing_consent_updated_on_platform",
  incentiveDiscountCode: "incentive_discount_code",
  incentiveDiscountExpiresOn: "incentive_discount_expires_on"
}, iK = {
  // identifiers
  shippingClaimId: "shipping_claim_id",
  originalOrderName: Oo.originalOrderName,
  originalOrderId: Oo.originalOrderId,
  originalOrderDate: Oo.originalOrderDate,
  // customer
  customerName: Ht.customerName,
  customerEmail: Ht.customerEmail,
  // claim metadata
  createdDate: Ht.createdDate,
  finalizedDate: Oo.finalizedDate,
  status: Ht.status,
  reason: "reason",
  resolutionMethod: Oo.resolutionMethod,
  tags: "tags",
  // line item
  productName: Ht.productName,
  productSku: Ht.productSku,
  quantity: Ht.quantity,
  price: Ht.price,
  // tracking
  originalOrderTrackingNumber: "original_order_tracking_number",
  originalOrderTrackingCarrier: "original_order_tracking_carrier"
};
var gg;
(function(e) {
  e.bypass = "bypass", e.decrementIgnoringPolicy = "decrement_ignoring_policy", e.decrementObeyingPolicy = "decrement_obeying_policy";
})(gg || (gg = {}));
const aK = {
  authorized: "Authorized",
  captured: "Captured",
  refunded: "Refunded"
};
var Qr;
(function(e) {
  e.percent = "Percent", e.fixed = "Fixed", e.none = "None";
})(Qr || (Qr = {}));
var A6;
(function(e) {
  e.toCustomer = "To_Customer", e.fromCustomer = "From_Customer";
})(A6 || (A6 = {}));
var Li;
(function(e) {
  e.active = "active", e.draft = "draft", e.archived = "archived", e.unlisted = "unlisted";
})(Li || (Li = {}));
Li.active + "", Li.draft + "", Li.archived + "", Li.unlisted + "";
var to;
(function(e) {
  e.aStock = "A_Stock", e.bStock = "B_Stock", e.cStock = "C_Stock", e.dStock = "D_Stock", e.dispose = "Dispose";
})(to || (to = {}));
to.aStock + "", to.bStock + "", to.cStock + "", to.dStock + "", to.dispose + "";
const rt = {
  refund: "Refund",
  variantExchange: "Variant_Exchange",
  // ? one for one of the same product
  giftCard: "Gift_Card",
  repair: "Repair",
  replacementOrder: "Replacement_Order",
  // ? any number of products can be replaced
  warrantyReview: "Warranty_Review",
  other: "Other"
  // ? used for claims that do not have to be refunded, but still returned
}, rm = {
  refund: rt.refund,
  giftCard: rt.giftCard
}, Ad = {
  [rt.refund]: "Refund",
  [rt.variantExchange]: "Exchange",
  [rt.giftCard]: "Gift Card",
  [rt.repair]: "Repair",
  [rt.replacementOrder]: "Replacement Order",
  [rt.warrantyReview]: "Warranty Review",
  [rt.other]: "Return"
}, Ro = {
  defectiveItem: "Defective_Item",
  wrongFit: "Wrong_Fit",
  notAsExpected: "Not_As_Expected",
  notSatisfied: "Not_Satisfied",
  noLongerNeeded: "No_Longer_Needed",
  wrongItem: "Wrong_Item",
  shippingIssue: "Shipping_Issue",
  rightToWithdraw: "Right_To_Withdraw"
}, dc = {
  giftCardOrder: "Gift_Card_Order",
  storeCredit: "Store_Credit",
  giftCard: "Gift_Card"
};
dc.giftCardOrder + "", dc.storeCredit + "", dc.giftCard + "";
const vg = {
  corso: "Corso",
  shopifyFulfillmentEvent: "Shopify_Fulfillment_Event"
};
vg.shopifyFulfillmentEvent + "", vg.corso + "";
const sK = {
  [Ro.defectiveItem]: "Defective Item",
  [Ro.wrongFit]: "Wrong Fit",
  [Ro.notAsExpected]: "Not As Expected",
  [Ro.notSatisfied]: "Not Satisfied",
  [Ro.noLongerNeeded]: "No Longer Needed",
  [Ro.wrongItem]: "Wrong Item",
  [Ro.shippingIssue]: "Shipping Issue",
  [Ro.rightToWithdraw]: "Right to Withdraw"
};
var yg;
(function(e) {
  e.returnExpiring = "Return_Expiring", e.returnReminder = "Return_Reminder", e.claimSubmitted = "Claim_Submitted", e.claimShipmentCreated = "Claim_Shipment_Created", e.registrationSubmitted = "Registration_Submitted", e.warrantySubmitted = "Warranty_Submitted";
})(yg || (yg = {}));
var cf;
(function(e) {
  e.claimApprovedAsRequested = "Claim_Approved_As_Requested", e.claimApprovedNotAsRequested = "Claim_Approved_Not_As_Requested", e.claimDenied = "Claim_Denied", e.claimNeedsMoreInfo = "Claim_Needs_More_Info", e.orderGiftReturn = "Order_Gift_Return", e.warrantyApprovedAsRequested = "Warranty_Approved_As_Requested", e.warrantyApprovedNotAsRequested = "Warranty_Approved_Not_As_Requested", e.warrantyDenied = "Warranty_Denied";
})(cf || (cf = {}));
const Tr = {
  packingSlip: "Packing_Slip",
  label: "Label",
  // TODO: workshop this type
  consolidatedDropoff: "Consolidated_Dropoff"
}, lK = {
  [Tr.label]: "Shipping Label",
  [Tr.packingSlip]: "Packing Slip",
  [Tr.consolidatedDropoff]: "Happy Returns"
}, Ei = {
  shipBob: "Ship_Bob",
  shipHero: "Ship_Hero",
  blueBox: "Blue_Box",
  xbFulfillment: "Xb_Fulfillment",
  logiwa: "Logiwa",
  twoBoxes: "Two_Boxes",
  masonHub: "Mason_Hub"
}, cK = {
  [Ei.shipHero]: "ShipHero",
  [Ei.shipBob]: "ShipBob",
  [Ei.blueBox]: "BlueBox",
  [Ei.xbFulfillment]: "XB Fulfillment",
  [Ei.logiwa]: "Logiwa",
  [Ei.twoBoxes]: "Two Boxes",
  [Ei.masonHub]: "MasonHub"
}, $s = {
  inProgress: "In_Progress",
  readyForReview: "Ready_For_Review",
  completed: "Completed"
}, bg = {
  [$s.inProgress]: "In Progress",
  [$s.readyForReview]: "Ready For Review",
  [$s.completed]: "Completed"
}, Qn = {
  open: "Open",
  approved: "Approved",
  denied: "Denied",
  // TODO: Rename this to "Canceled" to better match what the Shopify API uses
  closed: "Closed",
  // remove all of these at some point
  awaitingReturn: "Awaiting_Return",
  inTransit: "In_Transit",
  atReturnLocation: "At_Return_Location"
}, wt = {
  finalSale: "Final_Sale",
  pendingReview: "Pending_Review",
  pendingAdditionalInfo: "Pending_Additional_Info",
  awaitingCustomerDropoffLabelProvided: "Awaiting_Customer_Dropoff_Label_Provided",
  awaitingCustomerDropOffPackingSlipProvided: "Awaiting_Customer_Dropoff_Packing_Slip_Provided",
  inTransit: "In_Transit",
  pendingInspection: "Pending_Inspection",
  pendingApproval: "Pending_Approval",
  variantExchange: "Variant_Exchange",
  giftCardIssued: "Gift_Card_Issued",
  refunded: "Refunded",
  refundedPartial: "Refunded_Partial",
  gifCardIssuedPartial: "Gift_Card_Issued_Partial",
  replacementOrder: "Replacement_Order",
  repaired: "Repaired",
  wrongItem: "Wrong_Item",
  itemNotReturned: "Item_Not_Returned",
  noncompliantReturn: "Noncompliant_Return",
  notCoveredUnderWarranty: "Not_Covered_Under_Warranty",
  pendingReturnShipmentCreation: "Pending_Return_Shipment_Creation",
  returnNotRequired: "Return_Not_Required",
  additionalInfoNotProvided: "Additional_Info_Not_Provided",
  noActionTaken: "No_Action_Taken",
  itemCreditAppliedToClaim: "Item_Credit_Applied_To_Claim"
}, uK = {
  code: Qn.open,
  name: "Open",
  claimStatusDetail: [
    { code: wt.pendingReview, name: "Pending Review" },
    {
      code: wt.pendingAdditionalInfo,
      name: "Pending Additional Info"
    },
    {
      code: wt.pendingReturnShipmentCreation,
      name: "Pending Return Shipment Creation"
    },
    {
      code: wt.returnNotRequired,
      name: "Manual Review"
    }
  ]
}, dK = {
  code: Qn.awaitingReturn,
  name: "Awaiting Return",
  claimStatusDetail: [
    {
      code: wt.awaitingCustomerDropoffLabelProvided,
      name: "Awaiting Customer Dropoff"
    },
    {
      code: wt.awaitingCustomerDropOffPackingSlipProvided,
      name: "Awaiting Customer Dropoff"
    }
  ]
}, fK = {
  code: Qn.inTransit,
  name: "In Transit",
  claimStatusDetail: [
    { code: wt.inTransit, name: "In Transit" }
  ]
}, mK = {
  code: Qn.atReturnLocation,
  name: "At Return Location",
  claimStatusDetail: [
    {
      code: wt.pendingInspection,
      name: "Pending Inspection"
    },
    {
      code: wt.pendingApproval,
      name: "Pending Approval"
    },
    {
      code: wt.pendingAdditionalInfo,
      name: "Pending Additional Info"
    }
  ]
}, pK = {
  code: Qn.approved,
  name: "Approved",
  claimStatusDetail: [
    {
      code: wt.variantExchange,
      name: "Variant Exchange"
    },
    {
      code: wt.giftCardIssued,
      name: "Gift Card"
    },
    {
      code: wt.refunded,
      name: "Refund"
    },
    {
      code: wt.refundedPartial,
      name: "Partial Refund"
    },
    {
      code: wt.gifCardIssuedPartial,
      name: "Partial Gift Card"
    },
    {
      code: wt.replacementOrder,
      name: "Replacement Order"
    },
    {
      code: wt.repaired,
      name: "Repaired"
    },
    {
      code: wt.itemCreditAppliedToClaim,
      name: "Credit Applied to Replacement Order"
    },
    {
      code: wt.noActionTaken,
      name: "Nothing Issued Inside Corso"
    }
  ]
}, hK = {
  // TODO: rename this to "Canceled" to better match what the Shopify API uses
  code: Qn.closed,
  name: "Canceled",
  claimStatusDetail: [
    {
      code: wt.noActionTaken,
      name: "Nothing Issued Inside Corso"
    }
  ]
}, gK = {
  code: Qn.denied,
  name: "Denied",
  claimStatusDetail: [
    {
      code: wt.wrongItem,
      name: "Wrong Item"
    },
    {
      code: wt.itemNotReturned,
      name: "Item Not Returned"
    },
    {
      code: wt.noncompliantReturn,
      name: "Non-compliant Return"
    },
    {
      code: wt.notCoveredUnderWarranty,
      name: "Not Covered Under Warranty"
    },
    {
      code: wt.noActionTaken,
      name: "Nothing Issued Inside Corso"
    }
    // ? additional info not provided was removed
  ]
}, vK = {
  [Qn.open]: uK,
  [Qn.awaitingReturn]: dK,
  [Qn.inTransit]: fK,
  [Qn.atReturnLocation]: mK,
  [Qn.approved]: pK,
  [Qn.denied]: gK,
  [Qn.closed]: hK
}, d8 = {
  orderShipmentUpdate: "Order_Shipment_Update",
  registrationCreated: "Registration_Created",
  claimCreated: "Claim_Created",
  claimShipmentCreated: "Claim_Shipment_Created",
  claimShipmentInTransit: "Claim_Shipment_In_Transit",
  claimShipmentDelivered: "Claim_Shipment_Delivered",
  claimFinalized: "Claim_Finalized",
  claimCancelled: "Claim_Cancelled",
  claimOutOfStock: "Claim_Out_Of_Stock"
}, jr = {
  closedDenied: "Closed_Denied",
  closedRefunded: "Closed_Refunded",
  closedReordered: "Closed_Reordered",
  closedResolved: "Closed_Resolved",
  inProgress: "InProgress",
  open: "Open"
}, f8 = {
  [jr.open]: "Open",
  [jr.closedDenied]: "Closed - Denied",
  [jr.closedRefunded]: "Closed - Refunded",
  [jr.closedReordered]: "Closed - Reordered",
  [jr.inProgress]: "In Progress",
  [jr.closedResolved]: "Closed - Resolved"
}, yK = {
  hasCustomization: "has_customization",
  removedFromOrder: "removed_from_order",
  unfulfilled: "unfulfilled"
}, Xt = {
  damaged: "Damaged",
  lost: "Lost",
  stolen: "Stolen",
  wrongItem: "Wrong_Item",
  missingItem: "Missing_Item",
  qualityIssue: "Quality_Issue",
  incorrectAddress: "Incorrect_Address",
  satisfactionGuarantee: "Satisfaction_Guarantee"
}, m8 = {
  [Xt.damaged]: "Damaged",
  [Xt.stolen]: "Stolen",
  [Xt.lost]: "Lost",
  [Xt.wrongItem]: "Wrong Item",
  [Xt.missingItem]: "Missing Item",
  [Xt.qualityIssue]: "Quality Issue",
  [Xt.incorrectAddress]: "Incorrect Address",
  [Xt.satisfactionGuarantee]: "Satisfaction Guarantee"
};
Xt.damaged + "", Xt.stolen + "", Xt.lost + "", Xt.wrongItem + "", Xt.missingItem + "", Xt.qualityIssue + "", Xt.incorrectAddress + "", Xt.satisfactionGuarantee + "";
const Zi = {
  refund: "Refund",
  reorder: "Reorder"
}, bK = {
  [Zi.refund]: "Refund",
  [Zi.reorder]: "Reorder"
};
var zs;
(function(e) {
  e.onOrderCreate = "On_Order_Create", e.onFirstFulfillment = "On_First_Fulfillment", e.none = "None";
})(zs || (zs = {}));
zs.none + "", zs.onFirstFulfillment + "", zs.onOrderCreate + "";
var k6;
(function(e) {
  e.corsoSupport = "Corso_Support", e.customer = "Customer", e.merchant = "Merchant", e.retool = "Retool", e.reorderRequest = "Reorder_Request", e.customerUi = "Customer_UI", e.reorderRequestMerchant = "Reorder_Request_Merchant", e.gorgiasTicketWidget = "Gorgias_Ticket_Widget", e.zowieInboxIntegration = "Zowie_Inbox_Integration";
})(k6 || (k6 = {}));
var Sg;
(function(e) {
  e.pending = "PENDING", e.active = "ACTIVE", e.expired = "EXPIRED", e.uninstalled = "UNINSTALLED", e.declined = "DECLINED", e.frozen = "FROZEN", e.cancelled = "CANCELLED", e.accepted = "ACCEPTED";
})(Sg || (Sg = {}));
var Gn;
(function(e) {
  e.preTransit = "pre_transit", e.inTransit = "in_transit", e.outForDelivery = "out_for_delivery", e.delivered = "delivered", e.availableForPickup = "available_for_pickup", e.returnToSender = "return_to_sender", e.failure = "failure", e.cancelled = "cancelled", e.unknown = "unknown", e.error = "error";
})(Gn || (Gn = {}));
const SK = {
  [Gn.availableForPickup]: "Available for Pickup",
  [Gn.cancelled]: "Cancelled",
  [Gn.delivered]: "Delivered",
  [Gn.error]: "Error",
  [Gn.failure]: "Failure",
  [Gn.inTransit]: "In Transit",
  [Gn.outForDelivery]: "Out for Delivery",
  [Gn.preTransit]: "Pre-Transit",
  [Gn.returnToSender]: "Return to Sender",
  [Gn.unknown]: "Unknown"
};
var D6;
(function(e) {
  e.unknown = "unknown", e.return = "return", e.statusUpdate = "status_update", e.departedFacility = "departed_facility", e.arrivedAtFacility = "arrived_at_facility", e.outForDelivery = "out_for_delivery", e.arrivedAtDestination = "arrived_at_destination", e.label_created = "label_created", e.in_transit = "in_transit", e.received_at_destination_facility = "received_at_destination_facility", e.delayed = "delayed", e.received_at_origin_facility = "received_at_origin_facility", e.delivery_exception = "delivery_exception", e.arrived_at_pickup_location = "arrived_at_pickup_location", e.transferred_to_destination_carrier = "transferred_to_destination_carrier", e.departed_origin_facility = "departed_origin_facility", e.held = "held", e.weather_delay = "weather_delay", e.address_correction = "address_correction", e.damaged = "damaged", e.failure = "failure", e.transit_exception = "transit_exception", e.lost = "lost";
})(D6 || (D6 = {}));
const xK = (e) => e != null;
function CK(e) {
  return e == null;
}
const Gi = (e) => !!e;
function wK(e, t) {
  return e.length >= t;
}
function EK(e, t) {
  return e.map(t);
}
function $e(e) {
  const t = Object.values(e);
  if (!wK(t, 2))
    throw new Error("A Union Requires at Least Two Enum Values");
  const r = t.map((o) => P(o.toString()));
  return We(r);
}
function Ao(e) {
  return p().trim().nullish().transform((t) => t || null).pipe(e.nullable());
}
function Nc(e) {
  return p().trim().nullish().transform((t) => t || void 0).pipe(e.optional());
}
const Pa = p().trim(), p8 = Pa.min(1, { message: "Must not be empty." }), IK = Pa.transform((e) => (
  // could be a single value or many, separated by a comma and optional whitespace
  e.split(",").map((t) => t.trim()).filter(Gi)
)).transform((e) => e.join(", ")), P6 = Pa.transform((e) => e.split(",").map((t) => t.trim()).filter(Gi)).pipe(O(Pa.pipe(Ki()))).transform((e) => e.join(", "));
p().transform((e, t) => {
  try {
    return JSON.parse(e);
  } catch {
    return t.addIssue({ code: "custom", message: "Invalid JSON" }), hV;
  }
});
const RK = (e, t, n) => w().refine((r) => {
  const o = r.toString(), [i, a] = o.split(".");
  return i ? a ? e >= i.length + a.length && t >= a.length : e >= i.length : !1;
}, {
  message: n ?? `Decimal must have at most ${e} digits and at most ${t} decimal places, otherwise it may overflow or be rounded`
}), TK = (e) => !/(insure|insurance|insured|insuring)/i.test(e), N6 = (e = 1 / 0) => p8.max(e).refine(TK, {
  message: 'Please avoid using any variation of words like "insure" or "insurance"'
}), _K = 999999, X = {
  trimmedString: Pa,
  nonEmptyString: p8,
  nullifiedInsuranceString: (e) => Ao(N6(e)),
  insuranceString: (e) => N6(e),
  /**
   * Converts falsy and white-space only strings into `null` when parsed, while still accepting `null` values.
   * Validates for `string` or `null` values removing whitespace, and transforms empty strings to `null`.
   * Inadvertently this ensures that all `string` results are non-empty.
   */
  nullifiedString: Ao(Pa),
  nullifiedEmail: Ao(Ki("Must be a valid email.")),
  csv: IK,
  nullifiedUrl: Ao(Cn("Must be a valid URL.")),
  nullifiedEmailList: Ao(P6),
  // ? probably needs a nicer message
  emailList: P6,
  decimal: RK,
  nonNegativeNumber: w({
    error: (e) => e.input === void 0 ? "Must provide a number." : "Must be a number."
  }).nonnegative("Must be zero or a positive number."),
  policyDays: w({
    error: (e) => e.input === void 0 ? "Must provide a number." : "Must be a number."
  }).min(0, "Must be zero or a positive number.").max(_K, "Must be less than 1,000,000."),
  optionalizedString: Nc(Pa),
  optionalizedDatetime: Nc(ru())
}, $0 = {
  Low: "Low",
  Medium: "Medium",
  High: "High"
}, OK = {
  emailReuseStore: "emailReuse-store",
  emailReuseGlobal: "emailReuse-global",
  orderVerification: "orderVerification",
  mediaReuse: "mediaReuse",
  mediaSimilarity: "mediaSimilarity",
  proofOfPurchaseReuse: "proofOfPurchaseReuse",
  deviceFanOut: "deviceFanOut",
  ipFanOut: "ipFanOut",
  addressFanOut: "addressFanOut",
  platformRisk: "platformRisk",
  botDetection: "botDetection",
  fingerprintSuspectScore: "fingerprintSuspectScore",
  ipAddress: "ipAddress",
  isMerchantCreated: "isMerchantCreated"
}, h8 = {
  Critical: "Critical",
  Positive: "Positive",
  Negative: "Negative",
  Neutral: "Neutral"
}, g8 = y({
  level: Hn($0),
  aggregateScore: w(),
  // optional: rows written before provenance was recorded have neither
  calculatedOn: p().optional(),
  modelVersion: p().optional(),
  facts: O(y({
    factor: Hn(OK),
    score: w(),
    justification: p(),
    sentiment: Hn(h8)
  }))
}), v8 = y({
  visitorId: p().optional(),
  requestId: p().optional()
}), gn = (e) => O(e).min(1), M6 = p().datetime().nullable(), ou = y({
  start: M6,
  end: M6
}), Za = y({
  searchTerm: X.optionalizedString,
  createdOn: ou.optional()
}), xg = y({
  kind: P(Qt.Registration),
  filters: y({
    salesChannels: gn(p()).optional(),
    estimatedPurchaseDate: ou.optional(),
    hasClaim: N().optional(),
    hasBeenCanceled: N().optional(),
    registrationTaggedWith: gn(p()).optional(),
    productVariantIds: gn(p()).optional()
  }).merge(Za)
}), y8 = y({
  hasError: N().optional(),
  productVariantIds: gn(p()).optional(),
  claimReasonIds: gn(p()).optional(),
  claimReasonDetailIds: gn(p()).optional(),
  inspectionGrade: gn(ne(to)).optional(),
  hasInspection: N().optional(),
  wasResolvedExternally: N().optional(),
  riskLevel: gn(ne($0)).optional(),
  isDenied: N().optional(),
  hasShipment: N().optional(),
  source: gn(We([P("Merchant_App"), P("Customer_App")])).optional(),
  shipmentStatus: gn($e(Gn)).optional(),
  statusCodes: gn($e($s)).optional(),
  claimTaggedWith: gn(p()).optional(),
  requestedResolutionMethods: gn($e(rt)).optional(),
  paymentStatuses: gn($e(aK)).optional(),
  inspectionCreatedOn: ou.optional(),
  wasOutsideEligibilityWindow: N().optional()
}), Cg = y({
  kind: P(Qt.Return),
  filters: y8.merge(Za).extend({
    hasInstantExchange: N().optional(),
    hasUpsellExchange: N().optional(),
    hasShopNowItems: N().optional()
  })
}), wg = y({
  kind: P(Qt.Warranty),
  filters: y8.merge(Za).extend({
    salesChannels: gn(p()).optional(),
    hasRegistration: N().optional()
  })
}), Eg = y({
  kind: P(Qt.Shipping),
  filters: y({
    resolutionMethods: gn($e(Zi)).optional(),
    claimReasons: gn($e(Xt)).optional(),
    shippingClaimTaggedWith: gn(p()).optional()
  }).merge(Za)
}), Ig = y({
  kind: P(Qt.Order),
  filters: Za
}), Rg = y({
  kind: P("Product"),
  filters: y({
    isOffPlatform: N().optional(),
    productGroupIds: gn(p()).optional(),
    productStatuses: gn($e(Li)).optional()
  }).merge(Za)
}), Ns = y({
  cursor: y({
    id: w(),
    direction: We([P("next"), P("prev")])
  }).nullable(),
  orderBy: We([P("asc"), P("desc")]),
  take: w().default(50),
  shouldUseOpenSearch: N().optional()
}), b8 = Eg.extend(Ns.shape), S8 = Ig.extend(Ns.shape), AK = ke("kind", [
  b8,
  Cg.merge(Ns),
  wg.merge(Ns),
  xg.merge(Ns),
  S8,
  Rg.merge(Ns)
]), kK = ke("kind", [
  b8,
  S8
]), ei = {
  today: "0d",
  last7Days: "7d",
  last30Days: "30d",
  last90Days: "90d",
  last12Months: "12m"
}, Xa = ke("kind", [
  y({
    kind: P("preset"),
    preset: ne(ei)
  }),
  y({
    kind: P("custom"),
    range: ou
  })
]), ml = Za.extend({
  createdOn: Xa.optional()
}), om = Cg.extend({
  filters: Cg.shape.filters.extend({
    inspectionCreatedOn: Xa.optional()
  }).merge(ml)
}), im = wg.extend({
  filters: wg.shape.filters.extend({
    inspectionCreatedOn: Xa.optional()
  }).merge(ml)
}), am = xg.extend({
  filters: xg.shape.filters.extend({
    estimatedPurchaseDate: Xa.optional()
  }).merge(ml)
}), sm = Eg.extend({
  filters: Eg.shape.filters.merge(ml)
}), z0 = Ig.extend({
  filters: Ig.shape.filters.merge(ml)
}), j0 = Rg.extend({
  filters: Rg.shape.filters.merge(ml)
}), Br = y({
  id: w(),
  name: X.nonEmptyString.max(40)
}), DK = ke("kind", [
  om.pick({ kind: !0, filters: !0 }),
  im.pick({ kind: !0, filters: !0 }),
  am.pick({ kind: !0, filters: !0 }),
  sm.pick({ kind: !0, filters: !0 }),
  z0.pick({ kind: !0, filters: !0 }),
  j0.pick({ kind: !0, filters: !0 })
]), PK = ke("kind", [
  om.merge(Br),
  im.merge(Br),
  am.merge(Br),
  sm.merge(Br),
  z0.merge(Br),
  j0.merge(Br)
]);
ke("kind", [
  om.merge(Br.omit({ id: !0 })),
  im.merge(Br.omit({ id: !0 })),
  am.merge(Br.omit({ id: !0 })),
  sm.merge(Br.omit({ id: !0 })),
  z0.merge(Br.omit({ id: !0 })),
  j0.merge(Br.omit({ id: !0 }))
]);
const Jo = y({
  nextCursor: w().nullable(),
  prevCursor: w().nullable()
}), B0 = y({
  filename: p().optional()
}), F6 = B0.extend({
  columns: O(ne(rK)),
  lineItemCustomFieldIds: O(w()),
  inspectionCustomFieldIds: O(w())
}), NK = B0.extend({
  columns: O(ne(oK)),
  registrationCustomFieldIds: O(w())
}), MK = B0.extend({
  columns: O(ne(iK))
}), pl = {
  Return: F6,
  Warranty: F6,
  Registration: NK,
  Shipping: MK
}, hl = {
  Return: om.shape.filters,
  Warranty: im.shape.filters,
  Registration: am.shape.filters,
  Shipping: sm.shape.filters
}, G0 = y({
  kind: P(Qt.Return),
  filters: hl.Return,
  jsonDefinition: pl.Return
}), V0 = y({
  kind: P(Qt.Warranty),
  filters: hl.Warranty,
  jsonDefinition: pl.Warranty
}), U0 = y({
  kind: P(Qt.Registration),
  filters: hl.Registration,
  jsonDefinition: pl.Registration
}), W0 = y({
  kind: P(Qt.Shipping),
  filters: hl.Shipping,
  jsonDefinition: pl.Shipping
}), FK = ke("kind", [
  G0,
  V0,
  U0,
  W0
]), $i = {
  name: X.nonEmptyString,
  frequency: ne(["Daily", "Weekly", "Monthly"]).optional(),
  exportDay: w().optional(),
  exportEmails: X.emailList.optional()
  // comma-separated list of emails to send the export to
}, x8 = ke("kind", [
  G0.extend($i),
  V0.extend($i),
  U0.extend($i),
  W0.extend($i)
]), LK = x8, Zu = {
  id: w(),
  storeId: w(),
  createdOn: p(),
  updatedOn: p().nullable()
}, $K = ke("kind", [
  G0.extend({ ...$i, ...Zu }),
  V0.extend({ ...$i, ...Zu }),
  U0.extend({ ...$i, ...Zu }),
  W0.extend({ ...$i, ...Zu })
]);
var cr;
(function(e) {
  const t = {
    User: "User",
    Assistant: "Assistant"
  };
  e.MessageIntent = {
    corsoHelp: "corsoHelp",
    clickhouseData: "clickhouseData",
    frontReportData: "frontReportData",
    contactRequest: "contactRequest",
    unknown: "unknown"
  }, e.UserSentiment = {
    Positive: "Positive",
    Neutral: "Neutral",
    Negative: "Negative"
  };
  const n = y({
    title: p(),
    url: p(),
    category: p()
  }), r = y({
    // the page's title as the merchant sees it, e.g. "#1844"
    title: p()
  });
  e.pageContextSchema = ke("kind", [
    r.extend({
      kind: P(Qt.Return),
      id: w()
    }),
    r.extend({
      kind: P(Qt.Warranty),
      id: w()
    }),
    r.extend({
      kind: P(Qt.Shipping),
      id: w()
    }),
    r.extend({
      kind: P(Qt.Registration),
      id: w()
    }),
    // the order lookup page is addressed by the platform's order id
    r.extend({
      kind: P(Qt.Order),
      sourceOrderId: p()
    }),
    r.extend({
      kind: P("Automation"),
      id: w()
    }),
    r.extend({
      kind: P("Settings"),
      section: p()
    })
  ]), e.usageSchema = y({
    model: p(),
    effort: ne(["low", "medium", "high", "xhigh", "max"]),
    inputTokens: w(),
    cacheReadTokens: w(),
    cacheWriteTokens: w(),
    outputTokens: w()
  }), e.messageMetadataSchema = y({
    usage: e.usageSchema.optional(),
    sources: O(n).optional(),
    intent: ne(e.MessageIntent).optional(),
    // AI SDK UIMessage parts (text, tool calls and results); validated by the AI SDK, not here
    parts: O(uo()).optional(),
    // the page a question was asked from; dropped when its kind is no longer offered, so older chats still load
    pageContext: e.pageContextSchema.optional().catch(void 0)
  }).passthrough(), e.messageSchema = y({
    role: ne(t),
    content: p().min(1),
    metadata: e.messageMetadataSchema.nullish(),
    userSentiment: ne(e.UserSentiment).nullable(),
    userComment: p().nullable(),
    createdOn: p(),
    updatedOn: p().optional(),
    id: w()
  }), e.feedbackSchema = e.messageSchema.pick({
    userSentiment: !0,
    userComment: !0
  }), e.chatRequestSchema = y({
    // the new user message; the server holds the rest of the conversation
    message: Aw({
      id: p(),
      role: P("user"),
      parts: O(uo())
    }),
    // answer the last stored question again, replacing the answer after it
    regenerate: N().optional(),
    // absent when the merchant dismissed it, or asked from a page with nothing to point at
    pageContext: e.pageContextSchema.optional()
  }), e.toUiMessage = ({ id: o, role: i, content: a, metadata: s }) => ({
    id: `${o}`,
    role: i === "User" ? "user" : "assistant",
    parts: (s == null ? void 0 : s.parts) ?? [
      { type: "text", text: a },
      ...((s == null ? void 0 : s.sources) ?? []).map(({ title: l, url: c }) => ({
        type: "source-url",
        sourceId: c,
        url: c,
        title: l
      }))
    ]
  }), e.conversationSchema = y({
    id: w(),
    name: p(),
    createdOn: p(),
    updatedOn: p().optional()
  }), e.CONVERSATION_NAME_MAX_LENGTH = 100, e.renameSchema = y({
    name: p().trim().min(1).max(e.CONVERSATION_NAME_MAX_LENGTH)
  }), e.conversationWithMessagesSchema = e.conversationSchema.extend({
    messages: O(e.messageSchema)
  }), e.defaultConversationName = "New Conversation";
})(cr || (cr = {}));
const zK = y({
  inputTokens: w(),
  cacheReadTokens: w(),
  cacheWriteTokens: w(),
  outputTokens: w()
}), jK = y({
  id: w(),
  email: p(),
  firstName: p().nullable(),
  lastName: p().nullable()
}), BK = y({ id: w(), name: p() }), L6 = y({
  id: w(),
  name: p(),
  store: BK,
  user: jK,
  createdOn: p(),
  questionCount: w(),
  costUsd: w(),
  // the thumbs up or down left on answers in the period, with any comment
  feedback: O(y({
    messageId: w(),
    sentiment: ne(cr.UserSentiment),
    comment: p().nullable()
  }))
}), GK = cr.messageSchema.pick({
  id: !0,
  role: !0,
  content: !0,
  createdOn: !0,
  userSentiment: !0,
  userComment: !0
}).extend({
  usage: cr.usageSchema.nullable(),
  // the page a question was asked from
  pageContext: cr.pageContextSchema.nullable(),
  // null when the answer has no usage or its model has no rate
  costUsd: w().nullable(),
  toolCalls: O(p()),
  failed: N()
});
y({
  // only conversations with a message in this period; the summary covers the same period
  createdOn: Xa,
  // only conversations with an answer rated one of these ways in the period
  sentiments: O(ne(cr.UserSentiment)).optional(),
  // only conversations started by someone in the Corso organization, or only by merchants
  isCorsoUser: N().optional(),
  // matches a conversation's name or its user's email
  searchTerm: p().optional(),
  cursor: y({ id: w(), direction: ne(["next", "prev"]) }).nullable()
}), y({
  summary: zK.extend({
    costUsd: w(),
    conversationCount: w(),
    questionCount: w(),
    answerCount: w(),
    // answers from before usage was recorded, or on a model without a rate
    unpricedAnswerCount: w()
  }),
  // one page of the conversations the summary covers
  conversations: O(L6),
  pageInfo: Jo
}), L6.omit({ questionCount: !0, feedback: !0 }).extend({
  messages: O(GK)
});
const VK = y({
  customerEmail: p(),
  customerName: p().nullable(),
  subject: p(),
  messages: O(y({
    from: p(),
    preview: p(),
    // ! a preview of the message, called a "blurb" in the Front API
    text: p(),
    // ! the full text of the message, (not useful, filled with junk)
    htmlBody: p(),
    // ! the full body of the message, generally HTML
    sanitizedHtmlBody: p(),
    //! the sanitized HTML body of the message
    createdOn: p()
    // ISO date string with timestamp
  }))
}), UK = p().nullish(), Xi = y({
  firstName: p().optional(),
  lastName: p().optional(),
  line1: p().optional(),
  line2: p().optional(),
  city: p().optional(),
  countryCode: p().length(2, { message: "Country code should a be two letters" }).optional(),
  // two letter country code ISO 3166
  // ? renamed from provinceCode
  stateOrProvinceCode: p().optional(),
  // ? renamed from zip
  postalCode: p().optional(),
  phone: p().optional()
}), Wr = Xi.required().extend({
  line2: Ao(p()).optional(),
  phone: Ao(p()).optional(),
  stateOrProvinceCode: UK,
  // countries with no postal system legitimately have none; the crew UI requires it for US only
  postalCode: Ao(p()).optional(),
  id: w().optional()
}), Tg = Wr.omit({ id: !0 }), uf = Wr.omit({
  firstName: !0,
  lastName: !0
}).merge(y({ name: X.nonEmptyString })), WK = y({
  field: p(),
  original: p().nullish(),
  suggested: p().nullish()
}), HK = ke("ok", [
  y({ ok: P(!0) }),
  y({
    ok: P(!0),
    corrections: O(WK)
  }),
  y({
    ok: P(!1),
    errors: O(p())
  })
]);
//! the following enums are used to handle currency across the platform, but are not automatically populated during a migration
//! they are populated through a cron job located in the API on a time interval (every 24 hours)
const V = {
  // United Arab Emirates Dirham (AED).
  AED: "AED",
  // Afghan Afghani (AFN).
  AFN: "AFN",
  // Albanian Lek (ALL).
  ALL: "ALL",
  // Armenian Dram (AMD).
  AMD: "AMD",
  // Netherlands Antillean Guilder.
  ANG: "ANG",
  // Angolan Kwanza (AOA).
  AOA: "AOA",
  // Argentine Pesos (ARS).
  ARS: "ARS",
  // Australian Dollars (AUD).
  AUD: "AUD",
  // Aruban Florin (AWG).
  AWG: "AWG",
  // Azerbaijani Manat (AZN).
  AZN: "AZN",
  // Bosnia and Herzegovina Convertible Mark (BAM).
  BAM: "BAM",
  // Barbadian Dollar (BBD).
  BBD: "BBD",
  // Bangladesh Taka (BDT).
  BDT: "BDT",
  // Bulgarian Lev (BGN).
  BGN: "BGN",
  // Bahraini Dinar (BHD).
  BHD: "BHD",
  // Burundian Franc (BIF).
  BIF: "BIF",
  // Bermudian Dollar (BMD).
  BMD: "BMD",
  // Brunei Dollar (BND).
  BND: "BND",
  // Bolivian Boliviano (BOB).
  BOB: "BOB",
  // Brazilian Real (BRL).
  BRL: "BRL",
  // Bahamian Dollar (BSD).
  BSD: "BSD",
  // Bhutanese Ngultrum (BTN).
  BTN: "BTN",
  // Botswana Pula (BWP).
  BWP: "BWP",
  // Belarusian Ruble (BYN).
  BYN: "BYN",
  // Belize Dollar (BZD).
  BZD: "BZD",
  // Canadian Dollars (CAD).
  CAD: "CAD",
  // Congolese franc (CDF).
  CDF: "CDF",
  // Swiss Francs (CHF).
  CHF: "CHF",
  // Chilean Peso (CLP).
  CLP: "CLP",
  // Chinese Yuan Renminbi (CNY).
  CNY: "CNY",
  // Colombian Peso (COP).
  COP: "COP",
  // Costa Rican Colones (CRC).
  CRC: "CRC",
  // Cape Verdean escudo (CVE).
  CVE: "CVE",
  // Czech Koruny (CZK).
  CZK: "CZK",
  // Djiboutian Franc (DJF).
  DJF: "DJF",
  // Danish Kroner (DKK).
  DKK: "DKK",
  // Dominican Peso (DOP).
  DOP: "DOP",
  // Algerian Dinar (DZD).
  DZD: "DZD",
  // Egyptian Pound (EGP).
  EGP: "EGP",
  // Eritrean Nakfa (ERN).
  ERN: "ERN",
  // Ethiopian Birr (ETB).
  ETB: "ETB",
  // Euro (EUR).
  EUR: "EUR",
  // Fijian Dollars (FJD).
  FJD: "FJD",
  // Falkland Islands Pounds (FKP).
  FKP: "FKP",
  // United Kingdom Pounds (GBP).
  GBP: "GBP",
  // Georgian Lari (GEL).
  GEL: "GEL",
  // Ghanaian Cedi (GHS).
  GHS: "GHS",
  // Gibraltar Pounds (GIP).
  GIP: "GIP",
  // Gambian Dalasi (GMD).
  GMD: "GMD",
  // Guinean Franc (GNF).
  GNF: "GNF",
  // Guatemalan Quetzal (GTQ).
  GTQ: "GTQ",
  // Guyanese Dollar (GYD).
  GYD: "GYD",
  // Hong Kong Dollars (HKD).
  HKD: "HKD",
  // Honduran Lempira (HNL).
  HNL: "HNL",
  // Croatian Kuna (HRK).
  HRK: "HRK",
  // Haitian Gourde (HTG).
  HTG: "HTG",
  // Hungarian Forint (HUF).
  HUF: "HUF",
  // Indonesian Rupiah (IDR).
  IDR: "IDR",
  // Israeli New Shekel (NIS).
  ILS: "ILS",
  // Indian Rupees (INR).
  INR: "INR",
  // Iraqi Dinar (IQD).
  IQD: "IQD",
  // Iranian Rial (IRR).
  IRR: "IRR",
  // Icelandic Kronur (ISK).
  ISK: "ISK",
  // Jersey Pound.
  JEP: "JEP",
  // Jamaican Dollars (JMD).
  JMD: "JMD",
  // Jordanian Dinar (JOD).
  JOD: "JOD",
  // Japanese Yen (JPY).
  JPY: "JPY",
  // Kenyan Shilling (KES).
  KES: "KES",
  // Kyrgyzstani Som (KGS).
  KGS: "KGS",
  // Cambodian Riel.
  KHR: "KHR",
  // Kiribati Dollar (KID).
  KID: "KID",
  // Comorian Franc (KMF).
  KMF: "KMF",
  // South Korean Won (KRW).
  KRW: "KRW",
  // Kuwaiti Dinar (KWD).
  KWD: "KWD",
  // Cayman Dollars (KYD).
  KYD: "KYD",
  // Kazakhstani Tenge (KZT).
  KZT: "KZT",
  // Laotian Kip (LAK).
  LAK: "LAK",
  // Lebanese Pounds (LBP).
  LBP: "LBP",
  // Sri Lankan Rupees (LKR).
  LKR: "LKR",
  // Liberian Dollar (LRD).
  LRD: "LRD",
  // Lesotho Loti (LSL).
  LSL: "LSL",
  // Lithuanian Litai (LTL).
  LTL: "LTL",
  // Latvian Lati (LVL).
  LVL: "LVL",
  // Libyan Dinar (LYD).
  LYD: "LYD",
  // Moroccan Dirham.
  MAD: "MAD",
  // Moldovan Leu (MDL).
  MDL: "MDL",
  // Malagasy Ariary (MGA).
  MGA: "MGA",
  // Macedonia Denar (MKD).
  MKD: "MKD",
  // Burmese Kyat (MMK).
  MMK: "MMK",
  // Mongolian Tugrik.
  MNT: "MNT",
  // Macanese Pataca (MOP).
  MOP: "MOP",
  // Mauritanian Ouguiya (MRU).
  MRU: "MRU",
  // Mauritian Rupee (MUR).
  MUR: "MUR",
  // Maldivian Rufiyaa (MVR).
  MVR: "MVR",
  // Malawian Kwacha (MWK).
  MWK: "MWK",
  // Mexican Pesos (MXN).
  MXN: "MXN",
  // Malaysian Ringgits (MYR).
  MYR: "MYR",
  // Mozambican Metical.
  MZN: "MZN",
  // Namibian Dollar.
  NAD: "NAD",
  // Nigerian Naira (NGN).
  NGN: "NGN",
  // Nicaraguan Córdoba (NIO).
  NIO: "NIO",
  // Norwegian Kroner (NOK).
  NOK: "NOK",
  // Nepalese Rupee (NPR).
  NPR: "NPR",
  // New Zealand Dollars (NZD).
  NZD: "NZD",
  // Omani Rial (OMR).
  OMR: "OMR",
  // Panamian Balboa (PAB).
  PAB: "PAB",
  // Peruvian Nuevo Sol (PEN).
  PEN: "PEN",
  // Papua New Guinean Kina (PGK).
  PGK: "PGK",
  // Philippine Peso (PHP).
  PHP: "PHP",
  // Pakistani Rupee (PKR).
  PKR: "PKR",
  // Polish Zlotych (PLN).
  PLN: "PLN",
  // Paraguayan Guarani (PYG).
  PYG: "PYG",
  // Qatari Rial (QAR).
  QAR: "QAR",
  // Romanian Lei (RON).
  RON: "RON",
  // Serbian dinar (RSD).
  RSD: "RSD",
  // Russian Rubles (RUB).
  RUB: "RUB",
  // Rwandan Franc (RWF).
  RWF: "RWF",
  // Saudi Riyal (SAR).
  SAR: "SAR",
  // Solomon Islands Dollar (SBD).
  SBD: "SBD",
  // Seychellois Rupee (SCR).
  SCR: "SCR",
  // Sudanese Pound (SDG).
  SDG: "SDG",
  // Swedish Kronor (SEK).
  SEK: "SEK",
  // Singapore Dollars (SGD).
  SGD: "SGD",
  // Saint Helena Pounds (SHP).
  SHP: "SHP",
  // Sierra Leonean Leone (SLL).
  SLL: "SLL",
  // Somali Shilling (SOS).
  SOS: "SOS",
  // Surinamese Dollar (SRD).
  SRD: "SRD",
  // South Sudanese Pound (SSP).
  SSP: "SSP",
  // Sao Tome And Principe Dobra (STN).
  STN: "STN",
  // Syrian Pound (SYP).
  SYP: "SYP",
  // Swazi Lilangeni (SZL).
  SZL: "SZL",
  // Thai baht (THB).
  THB: "THB",
  // Tajikistani Somoni (TJS).
  TJS: "TJS",
  // Turkmenistani Manat (TMT).
  TMT: "TMT",
  // Tunisian Dinar (TND).
  TND: "TND",
  // Tongan Pa'anga (TOP).
  TOP: "TOP",
  // Turkish Lira (TRY).
  TRY: "TRY",
  // Trinidad and Tobago Dollars (TTD).
  TTD: "TTD",
  // Taiwan Dollars (TWD).
  TWD: "TWD",
  // Tanzanian Shilling (TZS).
  TZS: "TZS",
  // Ukrainian Hryvnia (UAH).
  UAH: "UAH",
  // Ugandan Shilling (UGX).
  UGX: "UGX",
  // United States Dollars (USD).
  USD: "USD",
  // Uruguayan Pesos (UYU).
  UYU: "UYU",
  // Uzbekistan som (UZS).
  UZS: "UZS",
  // Venezuelan Bolivares (VED).
  VED: "VED",
  // Venezuelan Bolivares Soberanos (VES).
  VES: "VES",
  // Vietnamese đồng (VND).
  VND: "VND",
  // Vanuatu Vatu (VUV).
  VUV: "VUV",
  // Samoan Tala (WST).
  WST: "WST",
  // Central African CFA Franc (XAF).
  XAF: "XAF",
  // East Caribbean Dollar (XCD).
  XCD: "XCD",
  // West African CFA franc (XOF).
  XOF: "XOF",
  // CFP Franc (XPF).
  XPF: "XPF",
  // Unrecognized currency.
  XXX: "XXX",
  // Yemeni Rial (YER).
  YER: "YER",
  // South African Rand (ZAR).
  ZAR: "ZAR",
  // Zambian Kwacha (ZMW).
  ZMW: "ZMW",
  // Belarusian Ruble (BYR).
  BYR: "BYR",
  // Sao Tome And Principe Dobra (STD).
  STD: "STD",
  // Venezuelan Bolivares (VEF).
  VEF: "VEF"
};
V.USD + "", V.USD, V.CAD + "", V.CAD, V.GBP + "", V.GBP, V.EUR + "", V.EUR, V.AUD + "", V.AUD, V.JPY + "", V.JPY, V.NZD + "", V.NZD, V.CHF + "", V.CHF, V.MXN + "", V.MXN, V.CLP + "", V.CLP;
V.AED + "", V.AFN + "", V.ALL + "", V.AMD + "", V.ANG + "", V.AOA + "", V.ARS + "", V.AUD + "", V.AWG + "", V.AZN + "", V.BAM + "", V.BBD + "", V.BDT + "", V.BGN + "", V.BHD + "", V.BIF + "", V.BMD + "", V.BND + "", V.BOB + "", V.BRL + "", V.BSD + "", V.BTN + "", V.BWP + "", V.BYN + "", V.BZD + "", V.CAD + "", V.CDF + "", V.CHF + "", V.CLP + "", V.COP + "", V.CRC + "", V.CVE + "", V.CZK + "", V.DJF + "", V.DKK + "", V.DOP + "", V.DZD + "", V.EGP + "", V.ERN + "", V.ETB + "", V.EUR + "", V.FJD + "", V.FKP + "", V.GBP + "", V.GEL + "", V.GHS + "", V.GIP + "", V.GMD + "", V.GNF + "", V.GTQ + "", V.GYD + "", V.HKD + "", V.HNL + "", V.HTG + "", V.HUF + "", V.IDR + "", V.ILS + "", V.INR + "", V.IQD + "", V.IRR + "", V.ISK + "", V.JMD + "", V.JOD + "", V.JPY + "", V.KES + "", V.KGS + "", V.KHR + "", V.KMF + "", V.KRW + "", V.KWD + "", V.KYD + "", V.KZT + "", V.LAK + "", V.LBP + "", V.LKR + "", V.LRD + "", V.LSL + "", V.LYD + "", V.MAD + "", V.MDL + "", V.MGA + "", V.MKD + "", V.MMK + "", V.MNT + "", V.MOP + "", V.MRU + "", V.MUR + "", V.MVR + "", V.MWK + "", V.MXN + "", V.MYR + "", V.MZN + "", V.NAD + "", V.NGN + "", V.NIO + "", V.NOK + "", V.NPR + "", V.NZD + "", V.OMR + "", V.PAB + "", V.PEN + "", V.PGK + "", V.PHP + "", V.PKR + "", V.PLN + "", V.PYG + "", V.QAR + "", V.RON + "", V.RSD + "", V.CNY + "", V.RUB + "", V.RWF + "", V.SAR + "", V.SBD + "", V.SCR + "", V.SDG + "", V.SEK + "", V.SGD + "", V.SHP + "", V.SLL + "", V.SOS + "", V.SRD + "", V.SSP + "", V.STN + "", V.SYP + "", V.SZL + "", V.THB + "", V.TJS + "", V.TMT + "", V.TND + "", V.TOP + "", V.TRY + "", V.TTD + "", V.TWD + "", V.TZS + "", V.UAH + "", V.UGX + "", V.USD + "", V.UYU + "", V.UZS + "", V.VED + "", V.VES + "", V.VND + "", V.VUV + "", V.WST + "", V.XAF + "", V.XCD + "", V.XOF + "", V.XPF + "", V.XXX + "", V.YER + "", V.ZAR + "", V.ZMW + "", V.LVL + "", V.BYR + "", V.LTL + "", V.STD + "", V.VEF + "", V.HRK + "", V.JEP + "", V.KID + "";
const C8 = y({
  label: p().optional(),
  minDeliveryDate: p(),
  maxDeliveryDate: p().optional(),
  shippingCutoffDate: p().optional()
}), qK = {
  AZ: "Abu Dhabi",
  AJ: "Ajman",
  DU: "Dubai",
  FU: "Fujairah",
  RK: "Ras al-Khaimah",
  SH: "Sharjah",
  UQ: "Umm al-Quwain"
}, YK = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
  DC: "District of Columbia",
  AS: "American Samoa",
  GU: "Guam",
  MP: "Northern Mariana Islands",
  PR: "Puerto Rico",
  VI: "Virgin Islands",
  FM: "Federated States of Micronesia",
  MH: "Marshall Islands",
  PW: "Palau",
  AA: "Armed Forces Americas",
  AE: "Armed Forces Europe",
  AP: "Armed Forces Pacific"
}, KK = {
  C: "A Coruña",
  VI: "Álava",
  AB: "Albacete",
  A: "Alicante",
  AL: "Almería",
  O: "Asturias",
  AV: "Ávila",
  BA: "Badajoz",
  PM: "Balears",
  B: "Barcelona",
  BU: "Burgos",
  CC: "Cáceres",
  CA: "Cádiz",
  S: "Cantabria",
  CS: "Castellón",
  CE: "Ceuta",
  CR: "Ciudad Real",
  CO: "Córdoba",
  CU: "Cuenca",
  GI: "Girona",
  GR: "Granada",
  GU: "Guadalajara",
  SS: "Guipúzcoa",
  H: "Huelva",
  HU: "Huesca",
  J: "Jaén",
  LO: "La Rioja",
  GC: "Las Palmas",
  LE: "León",
  L: "Lleida",
  LU: "Lugo",
  M: "Madrid",
  MA: "Málaga",
  ML: "Melilla",
  MU: "Murcia",
  NA: "Navarra",
  OR: "Ourense",
  P: "Palencia",
  PO: "Pontevedra",
  SA: "Salamanca",
  TF: "Santa Cruz de Tenerife",
  SG: "Segovia",
  SE: "Sevilla",
  SO: "Soria",
  T: "Tarragona",
  TE: "Teruel",
  TO: "Toledo",
  V: "Valencia",
  VA: "Valladolid",
  BI: "Vizcaya",
  ZA: "Zamora",
  Z: "Zaragoza"
}, ZK = {
  BFP: "British Forces",
  ENG: "England",
  NIR: "Northern Ireland",
  SCT: "Scotland",
  WLS: "Wales"
}, XK = {
  HK: "Hong Kong Island",
  KL: "Kowloon",
  NT: "New Territories"
}, JK = {
  CW: "Carlow",
  CN: "Cavan",
  CE: "Clare",
  CO: "Cork",
  DL: "Donegal",
  D: "Dublin",
  G: "Galway",
  KY: "Kerry",
  KE: "Kildare",
  KK: "Kilkenny",
  LS: "Laois",
  LM: "Leitrim",
  LK: "Limerick",
  LD: "Longford",
  LH: "Louth",
  MO: "Mayo",
  MH: "Meath",
  MN: "Monaghan",
  OY: "Offaly",
  RN: "Roscommon",
  SO: "Sligo",
  TA: "Tipperary",
  WD: "Waterford",
  WH: "Westmeath",
  WX: "Wexford",
  WW: "Wicklow"
}, QK = {
  AG: "Agrigento",
  AL: "Alessandria",
  AN: "Ancona",
  AO: "Aosta",
  AR: "Arezzo",
  AP: "Ascoli Piceno",
  AT: "Asti",
  AV: "Avellino",
  BA: "Bari",
  BT: "Barletta-Andria-Trani",
  BL: "Belluno",
  BN: "Benevento",
  BG: "Bergamo",
  BI: "Biella",
  BO: "Bologna",
  BZ: "Bolzano",
  BS: "Brescia",
  BR: "Brindisi",
  CA: "Cagliari",
  CL: "Caltanissetta",
  CB: "Campobasso",
  CI: "Carbonia-Iglesias",
  CE: "Caserta",
  CT: "Catania",
  CZ: "Catanzaro",
  CH: "Chieti",
  CO: "Como",
  CS: "Cosenza",
  CR: "Cremona",
  KR: "Crotone",
  CN: "Cuneo",
  EN: "Enna",
  FM: "Fermo",
  FE: "Ferrara",
  FI: "Firenze",
  FG: "Foggia",
  FC: "Forlì-Cesena",
  FR: "Frosinone",
  GE: "Genova",
  GO: "Gorizia",
  GR: "Grosseto",
  IM: "Imperia",
  IS: "Isernia",
  AQ: "L'Aquila",
  SP: "La Spezia",
  LT: "Latina",
  LE: "Lecce",
  LC: "Lecco",
  LI: "Livorno",
  LO: "Lodi",
  LU: "Lucca",
  MC: "Macerata",
  MN: "Mantova",
  MS: "Massa-Carrara",
  MT: "Matera",
  VS: "Medio Campidano",
  ME: "Messina",
  MI: "Milano",
  MO: "Modena",
  MB: "Monza e Brianza",
  NA: "Napoli",
  NO: "Novara",
  NU: "Nuoro",
  OG: "Ogliastra",
  OT: "Olbia-Tempio",
  OR: "Oristano",
  PD: "Padova",
  PA: "Palermo",
  PR: "Parma",
  PV: "Pavia",
  PG: "Perugia",
  PU: "Pesaro e Urbino",
  PE: "Pescara",
  PC: "Piacenza",
  PI: "Pisa",
  PT: "Pistoia",
  PN: "Pordenone",
  PZ: "Potenza",
  PO: "Prato",
  RG: "Ragusa",
  RA: "Ravenna",
  RC: "Reggio Calabria",
  RE: "Reggio Emilia",
  RI: "Rieti",
  RN: "Rimini",
  RM: "Roma",
  RO: "Rovigo",
  SA: "Salerno",
  SS: "Sassari",
  SV: "Savona",
  SI: "Siena",
  SR: "Siracusa",
  SO: "Sondrio",
  TA: "Taranto",
  TE: "Teramo",
  TR: "Terni",
  TO: "Torino",
  TP: "Trapani",
  TN: "Trento",
  TV: "Treviso",
  TS: "Trieste",
  UD: "Udine",
  VA: "Varese",
  VE: "Venezia",
  VB: "Verbano-Cusio-Ossola",
  VC: "Vercelli",
  VR: "Verona",
  VV: "Vibo Valentia",
  VI: "Vicenza",
  VT: "Viterbo"
}, eZ = {
  "JP-23": "Aichi",
  "JP-05": "Akita",
  "JP-02": "Aomori",
  "JP-12": "Chiba",
  "JP-38": "Ehime",
  "JP-18": "Fukui",
  "JP-40": "Fukuoka",
  "JP-07": "Fukushima",
  "JP-21": "Gifu",
  "JP-10": "Gunma",
  "JP-34": "Hiroshima",
  "JP-01": "Hokkaidō",
  "JP-28": "Hyōgo",
  "JP-08": "Ibaraki",
  "JP-17": "Ishikawa",
  "JP-03": "Iwate",
  "JP-37": "Kagawa",
  "JP-46": "Kagoshima",
  "JP-14": "Kanagawa",
  "JP-39": "Kōchi",
  "JP-43": "Kumamoto",
  "JP-26": "Kyōto",
  "JP-24": "Mie",
  "JP-04": "Miyagi",
  "JP-45": "Miyazaki",
  "JP-20": "Nagano",
  "JP-42": "Nagasaki",
  "JP-29": "Nara",
  "JP-15": "Niigata",
  "JP-44": "Ōita",
  "JP-33": "Okayama",
  "JP-47": "Okinawa",
  "JP-27": "Ōsaka",
  "JP-41": "Saga",
  "JP-11": "Saitama",
  "JP-25": "Shiga",
  "JP-32": "Shimane",
  "JP-22": "Shizuoka",
  "JP-09": "Tochigi",
  "JP-36": "Tokushima",
  "JP-13": "Tōkyō",
  "JP-31": "Tottori",
  "JP-16": "Toyama",
  "JP-30": "Wakayama",
  "JP-06": "Yamagata",
  "JP-35": "Yamaguchi",
  "JP-19": "Yamanashi"
}, tZ = {
  "KR-26": "Busan",
  "KR-43": "Chungbuk",
  "KR-44": "Chungnam",
  "KR-27": "Daegu",
  "KR-30": "Daejeon",
  "KR-42": "Gangwon",
  "KR-29": "Gwangju",
  "KR-47": "Gyeongbuk",
  "KR-41": "Gyeonggi",
  "KR-48": "Gyeongnam",
  "KR-28": "Incheon",
  "KR-49": "Jeju",
  "KR-45": "Jeonbuk",
  "KR-46": "Jeonnam",
  "KR-50": "Sejong",
  "KR-11": "Seoul",
  "KR-31": "Ulsan"
}, nZ = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  NT: "Northwest Territories",
  NU: "Nunavut",
  YT: "Yukon"
}, rZ = {
  ACT: "Australian Capital Territory",
  NSW: "New South Wales",
  NT: "Northern Territory",
  QLD: "Queensland",
  SA: "South Australia",
  TAS: "Tasmania",
  VIC: "Victoria",
  WA: "Western Australia"
}, oZ = {
  AGS: "Aguascalientes",
  BC: "Baja California",
  BCS: "Baja California Sur",
  CAMP: "Campeche",
  CHIS: "Chiapas",
  CHIH: "Chihuahua",
  DF: "Ciudad de México",
  COAH: "Coahuila",
  COL: "Colima",
  DGO: "Durango",
  GTO: "Guanajuato",
  GRO: "Guerrero",
  HGO: "Hidalgo",
  JAL: "Jalisco",
  MEX: "México",
  MICH: "Michoacán",
  MOR: "Morelos",
  NAY: "Nayarit",
  NL: "Nuevo León",
  OAX: "Oaxaca",
  PUE: "Puebla",
  QRO: "Querétaro",
  "Q ROO": "Quintana Roo",
  SLP: "San Luis Potosí",
  SIN: "Sinaloa",
  SON: "Sonora",
  TAB: "Tabasco",
  TAMPS: "Tamaulipas",
  TLAX: "Tlaxcala",
  VER: "Veracruz",
  YUC: "Yucatán",
  ZAC: "Zacatecas"
}, iZ = {
  JHR: "Johor",
  KDH: "Kedah",
  KTN: "Kelantan",
  KUL: "Kuala Lumpur",
  LBN: "Labuan",
  MLK: "Melaka",
  NSN: "Negeri Sembilan",
  PHG: "Pahang",
  PNG: "Penang",
  PRK: "Perak",
  PLS: "Perlis",
  PJY: "Putrajaya",
  SBH: "Sabah",
  SWK: "Sarawak",
  SGR: "Selangor",
  TRG: "Terengganu"
}, aZ = {
  AUK: "Auckland",
  BOP: "Bay of Plenty",
  CAN: "Canterbury",
  CIT: "Chatham Islands",
  GIS: "Gisborne",
  HKB: "Hawke's Bay",
  MWT: "Manawatu-Wanganui",
  MBH: "Marlborough",
  NSN: "Nelson",
  NTL: "Northland",
  OTA: "Otago",
  STL: "Southland",
  TKI: "Taranaki",
  TAS: "Tasman",
  WKO: "Waikato",
  WGN: "Wellington",
  WTC: "West Coast"
}, sZ = {
  "PT-20": "Açores",
  "PT-01": "Aveiro",
  "PT-02": "Beja",
  "PT-03": "Braga",
  "PT-04": "Bragança",
  "PT-05": "Castelo Branco",
  "PT-06": "Coimbra",
  "PT-07": "Évora",
  "PT-08": "Faro",
  "PT-09": "Guarda",
  "PT-10": "Leiria",
  "PT-11": "Lisboa",
  "PT-30": "Madeira",
  "PT-12": "Portalegre",
  "PT-13": "Porto",
  "PT-14": "Santarém",
  "PT-15": "Setúbal",
  "PT-16": "Viana do Castelo",
  "PT-17": "Vila Real",
  "PT-18": "Viseu"
}, lZ = {
  BL: "Burgenland",
  KN: "Carinthia",
  NO: "Lower Austria",
  SZ: "Salzburg",
  ST: "Styria",
  TY: "Tyrol",
  UA: "Upper Austria",
  VI: "Vienna",
  VO: "Vorarlberg"
}, cZ = {
  BR: "Brussels-Capital",
  VW: "Flemish Brabant",
  HW: "Hainaut",
  LG: "Liège",
  LX: "Luxembourg",
  NA: "Namur",
  AN: "Antwerp",
  LM: "Limburg",
  OV: "East Flanders",
  WV: "West Flanders"
}, uZ = {
  H: "Hovedstaden",
  M: "Midtjylland",
  N: "Nordjylland",
  S: "Sjælland",
  SD: "Syddanmark"
}, dZ = {
  AL: "Åland",
  ES: "South Karelia",
  EP: "South Ostrobothnia",
  EM: "South Savo",
  KU: "Kainuu",
  KA: "Kanta-Häme",
  KE: "Central Ostrobothnia",
  KP: "Central Finland",
  LA: "Lapland",
  PI: "Pirkanmaa",
  PO: "Pohjanmaa",
  PK: "North Karelia",
  PP: "North Ostrobothnia",
  PS: "North Savo",
  PH: "Päijät-Häme",
  SA: "Satakunta",
  U: "Uusimaa",
  VA: "Varsinais-Suomi"
}, fZ = {
  IDF: "Île-de-France",
  NAQ: "Nouvelle-Aquitaine",
  ARA: "Auvergne-Rhône-Alpes",
  BRE: "Brittany",
  BFC: "Bourgogne-Franche-Comté",
  CVL: "Centre-Val de Loire",
  COR: "Corsica",
  GES: "Grand Est",
  HDF: "Hauts-de-France",
  NOR: "Normandy",
  OCC: "Occitanie",
  PAC: "Provence-Alpes-Côte d’Azur",
  PDL: "Pays de la Loire"
}, mZ = {
  BW: "Baden-Württemberg",
  BY: "Bavaria",
  BE: "Berlin",
  BB: "Brandenburg",
  HB: "Bremen",
  HH: "Hamburg",
  HE: "Hesse",
  MV: "Mecklenburg-Vorpommern",
  NI: "Lower Saxony",
  NW: "North Rhine-Westphalia",
  RP: "Rhineland-Palatinate",
  SL: "Saarland",
  SN: "Saxony",
  ST: "Saxony-Anhalt",
  SH: "Schleswig-Holstein",
  TH: "Thuringia"
}, pZ = {
  VIK: "Viken",
  INN: "Innlandet",
  TRO: "Troms og Finnmark",
  NOR: "Nordland",
  MRO: "Møre og Romsdal",
  VES: "Vestfold og Telemark",
  ROG: "Rogaland",
  VESL: "Vestland",
  AGD: "Agder",
  OS: "Oslo",
  TR: "Trøndelag"
}, hZ = {
  AB: "Stockholm",
  AC: "Västerbotten",
  BD: "Norrbotten",
  C: "Uppsala",
  D: "Södermanland",
  E: "Östergötland",
  F: "Jönköping",
  G: "Kronoberg",
  H: "Kalmar",
  I: "Gotland",
  K: "Blekinge",
  M: "Skåne",
  N: "Halland",
  O: "Västra Götaland",
  S: "Värmland",
  T: "Örebro",
  U: "Västmanland",
  W: "Dalarna",
  X: "Gävleborg",
  Y: "Västernorrland",
  Z: "Jämtland"
}, gZ = {
  AG: "Aargau",
  AI: "Appenzell Innerrhoden",
  AR: "Appenzell Ausserrhoden",
  BE: "Bern",
  BL: "Basel-Landschaft",
  BS: "Basel-Stadt",
  FR: "Fribourg",
  GE: "Geneva",
  GL: "Glarus",
  GR: "Graubünden",
  JU: "Jura",
  LU: "Lucerne",
  NE: "Neuchâtel",
  NW: "Nidwalden",
  OW: "Obwalden",
  SG: "St. Gallen",
  SH: "Schaffhausen",
  SO: "Solothurn",
  SZ: "Schwyz",
  TG: "Thurgau",
  TI: "Ticino",
  UR: "Uri",
  VD: "Vaud",
  VS: "Valais",
  ZG: "Zug",
  ZH: "Zurich"
}, vZ = {
  BA: "Buenos Aires",
  C: "Ciudad Autónoma de Buenos Aires",
  CT: "Catamarca",
  CH: "Chaco",
  CB: "Chubut",
  CD: "Córdoba",
  CR: "Corrientes",
  ER: "Entre Ríos",
  FO: "Formosa",
  JY: "Jujuy",
  LP: "La Pampa",
  LR: "La Rioja",
  MZ: "Mendoza",
  MN: "Misiones",
  NQ: "Neuquén",
  RN: "Río Negro",
  SA: "Salta",
  SJ: "San Juan",
  SL: "San Luis",
  SC: "Santa Cruz",
  SF: "Santa Fe",
  SE: "Santiago del Estero",
  TF: "Tierra del Fuego",
  TU: "Tucumán"
}, yZ = {
  BE: "Beni",
  CH: "Chuquisaca",
  CB: "Cochabamba",
  LP: "La Paz",
  OR: "Oruro",
  PD: "Pando",
  PT: "Potosí",
  SC: "Santa Cruz",
  TA: "Tarija"
}, bZ = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins"
}, SZ = {
  AI: "Aisén",
  AN: "Antofagasta",
  AP: "Arica y Parinacota",
  AT: "Atacama",
  BI: "Biobío",
  CO: "Coquimbo",
  AR: "Araucanía",
  LI: "Libertador General Bernardo O’Higgins",
  LL: "Los Lagos",
  LR: "Los Ríos",
  MA: "Magallanes y de la Antártica Chilena",
  ML: "Maule",
  NB: "Ñuble",
  RM: "Región Metropolitana de Santiago",
  TA: "Tarapacá",
  VS: "Valparaíso"
}, xZ = {
  AM: "Amazonas",
  AN: "Antioquia",
  AR: "Arauca",
  AT: "Atlántico",
  DC: "Bogotá",
  BO: "Bolívar",
  BY: "Boyacá",
  CA: "Caldas",
  CQ: "Caquetá",
  CN: "Casanare",
  CS: "Cauca",
  CE: "Cesar",
  CH: "Chocó",
  CO: "Córdoba",
  CU: "Cundinamarca",
  GU: "Guainía",
  GD: "Guaviare",
  HG: "Huila",
  LG: "La Guajira",
  MG: "Magdalena",
  MT: "Meta",
  NS: "Nariño",
  SA: "Santander",
  SU: "Sucre",
  TO: "Tolima",
  VA: "Valle del Cauca",
  VC: "Vaupés",
  VD: "Vichada"
}, CZ = {
  AZ: "Azuay",
  BO: "Bolívar",
  CA: "Cañar",
  CH: "Carchi",
  CO: "Cotopaxi",
  EO: "El Oro",
  ES: "Esmeraldas",
  GA: "Galápagos",
  GU: "Guayas",
  IM: "Imbabura",
  LO: "Loja",
  LR: "Los Ríos",
  MA: "Manabí",
  MO: "Morona Santiago",
  NA: "Napo",
  OR: "Orellana",
  PA: "Pastaza",
  PI: "Pichincha",
  SE: "Santa Elena",
  SD: "Santo Domingo de los Tsáchilas",
  SU: "Sucumbíos",
  TU: "Tungurahua",
  ZA: "Zamora Chinchipe"
}, wZ = {
  AS: "Asunción",
  CN: "Concepción",
  AM: "Amambay",
  BO: "Boquerón",
  CR: "Canindeyú",
  CE: "Central",
  CG: "Cordillera",
  GU: "Guairá",
  IT: "Itapúa",
  MI: "Misiones",
  NE: "Ñeembucú",
  PA: "Paraguarí",
  PD: "Presidente Hayes",
  SP: "San Pedro",
  AP: "Alto Paraná",
  TA: "Alto Paraguay",
  CA: "Caaguazú",
  CU: "Caazapá"
}, EZ = {
  AM: "Amazonas",
  AN: "Áncash",
  AP: "Apurímac",
  AR: "Arequipa",
  AY: "Ayacucho",
  CA: "Cajamarca",
  CL: "Callao",
  CU: "Cusco",
  HU: "Huancavelica",
  HP: "Huánuco",
  IC: "Ica",
  JU: "Junín",
  LD: "La Libertad",
  LM: "Lambayeque",
  LI: "Lima",
  LO: "Loreto",
  MD: "Madre de Dios",
  MO: "Moquegua",
  PA: "Pasco",
  PI: "Piura",
  PU: "Puno",
  SM: "San Martín",
  TA: "Tacna",
  TU: "Tumbes",
  UC: "Ucayali"
}, IZ = {
  AR: "Artigas",
  CA: "Canelones",
  CE: "Cerro Largo",
  CO: "Colonia",
  DU: "Durazno",
  FD: "Florida",
  FS: "Flores",
  LA: "Lavalleja",
  MA: "Maldonado",
  MO: "Montevideo",
  PA: "Paysandú",
  RN: "Río Negro",
  RV: "Rivera",
  RO: "Rocha",
  SA: "Salto",
  SJ: "San José",
  SO: "Soriano",
  TA: "Tacuarembó",
  TT: "Treinta y Tres"
}, RZ = {
  AM: "Amazonas",
  AN: "Anzoátegui",
  AP: "Apure",
  AR: "Aragua",
  BA: "Barinas",
  BO: "Bolívar",
  CA: "Carabobo",
  CO: "Cojedes",
  DA: "Delta Amacuro",
  DC: "Distrito Capital",
  FA: "Falcón",
  GU: "Guárico",
  LA: "Lara",
  ME: "Mérida",
  MI: "Miranda",
  MO: "Monagas",
  NE: "Nueva Esparta",
  PO: "Portuguesa",
  SU: "Sucre",
  TA: "Táchira",
  TR: "Trujillo",
  VA: "Vargas",
  YA: "Yaracuy",
  ZU: "Zulia"
}, E = {
  /** Ascension Island. */
  AC: "AC",
  /** Andorra. */
  AD: "AD",
  /** United Arab Emirates. */
  AE: "AE",
  /** Afghanistan. */
  AF: "AF",
  /** Antigua & Barbuda. */
  AG: "AG",
  /** Anguilla. */
  AI: "AI",
  /** Albania. */
  AL: "AL",
  /** Armenia. */
  AM: "AM",
  /** Netherlands Antilles. */
  AN: "AN",
  /** Angola. */
  AO: "AO",
  /** Argentina. */
  AR: "AR",
  /** Austria. */
  AT: "AT",
  /** Australia. */
  AU: "AU",
  /** Aruba. */
  AW: "AW",
  /** Åland Islands. */
  AX: "AX",
  /** Azerbaijan. */
  AZ: "AZ",
  /** Bosnia & Herzegovina. */
  BA: "BA",
  /** Barbados. */
  BB: "BB",
  /** Bangladesh. */
  BD: "BD",
  /** Belgium. */
  BE: "BE",
  /** Burkina Faso. */
  BF: "BF",
  /** Bulgaria. */
  BG: "BG",
  /** Bahrain. */
  BH: "BH",
  /** Burundi. */
  BI: "BI",
  /** Benin. */
  BJ: "BJ",
  /** St. Barthélemy. */
  BL: "BL",
  /** Bermuda. */
  BM: "BM",
  /** Brunei. */
  BN: "BN",
  /** Bolivia. */
  BO: "BO",
  /** Caribbean Netherlands. */
  BQ: "BQ",
  /** Brazil. */
  BR: "BR",
  /** Bahamas. */
  BS: "BS",
  /** Bhutan. */
  BT: "BT",
  /** Bouvet Island. */
  BV: "BV",
  /** Botswana. */
  BW: "BW",
  /** Belarus. */
  BY: "BY",
  /** Belize. */
  BZ: "BZ",
  /** Canada. */
  CA: "CA",
  /** Cocos (Keeling) Islands. */
  CC: "CC",
  /** Congo - Kinshasa. */
  CD: "CD",
  /** Central African Republic. */
  CF: "CF",
  /** Congo - Brazzaville. */
  CG: "CG",
  /** Switzerland. */
  CH: "CH",
  /** Côte d’Ivoire. */
  CI: "CI",
  /** Cook Islands. */
  CK: "CK",
  /** Chile. */
  CL: "CL",
  /** Cameroon. */
  CM: "CM",
  /** China. */
  CN: "CN",
  /** Colombia. */
  CO: "CO",
  /** Costa Rica. */
  CR: "CR",
  /** Cuba. */
  CU: "CU",
  /** Cape Verde. */
  CV: "CV",
  /** Curaçao. */
  CW: "CW",
  /** Christmas Island. */
  CX: "CX",
  /** Cyprus. */
  CY: "CY",
  /** Czechia. */
  CZ: "CZ",
  /** Germany. */
  DE: "DE",
  /** Djibouti. */
  DJ: "DJ",
  /** Denmark. */
  DK: "DK",
  /** Dominica. */
  DM: "DM",
  /** Dominican Republic. */
  DO: "DO",
  /** Algeria. */
  DZ: "DZ",
  /** Ecuador. */
  EC: "EC",
  /** Estonia. */
  EE: "EE",
  /** Egypt. */
  EG: "EG",
  /** Western Sahara. */
  EH: "EH",
  /** Eritrea. */
  ER: "ER",
  /** Spain. */
  ES: "ES",
  /** Ethiopia. */
  ET: "ET",
  /** Finland. */
  FI: "FI",
  /** Fiji. */
  FJ: "FJ",
  /** Falkland Islands. */
  FK: "FK",
  /** Faroe Islands. */
  FO: "FO",
  /** France. */
  FR: "FR",
  /** Gabon. */
  GA: "GA",
  /** United Kingdom. */
  GB: "GB",
  /** Grenada. */
  GD: "GD",
  /** Georgia. */
  GE: "GE",
  /** French Guiana. */
  GF: "GF",
  /** Guernsey. */
  GG: "GG",
  /** Ghana. */
  GH: "GH",
  /** Gibraltar. */
  GI: "GI",
  /** Greenland. */
  GL: "GL",
  /** Gambia. */
  GM: "GM",
  /** Guinea. */
  GN: "GN",
  /** Guadeloupe. */
  GP: "GP",
  /** Equatorial Guinea. */
  GQ: "GQ",
  /** Greece. */
  GR: "GR",
  /** South Georgia & South Sandwich Islands. */
  GS: "GS",
  /** Guatemala. */
  GT: "GT",
  /** Guinea-Bissau. */
  GW: "GW",
  /** Guyana. */
  GY: "GY",
  /** Hong Kong SAR. */
  HK: "HK",
  /** Heard & McDonald Islands. */
  HM: "HM",
  /** Honduras. */
  HN: "HN",
  /** Croatia. */
  HR: "HR",
  /** Haiti. */
  HT: "HT",
  /** Hungary. */
  HU: "HU",
  /** Indonesia. */
  ID: "ID",
  /** Ireland. */
  IE: "IE",
  /** Israel. */
  IL: "IL",
  /** Isle of Man. */
  IM: "IM",
  /** India. */
  IN: "IN",
  /** British Indian Ocean Territory. */
  IO: "IO",
  /** Iraq. */
  IQ: "IQ",
  /** Iran. */
  IR: "IR",
  /** Iceland. */
  IS: "IS",
  /** Italy. */
  IT: "IT",
  /** Jersey. */
  JE: "JE",
  /** Jamaica. */
  JM: "JM",
  /** Jordan. */
  JO: "JO",
  /** Japan. */
  JP: "JP",
  /** Kenya. */
  KE: "KE",
  /** Kyrgyzstan. */
  KG: "KG",
  /** Cambodia. */
  KH: "KH",
  /** Kiribati. */
  KI: "KI",
  /** Comoros. */
  KM: "KM",
  /** St. Kitts & Nevis. */
  KN: "KN",
  /** North Korea. */
  KP: "KP",
  /** South Korea. */
  KR: "KR",
  /** Kuwait. */
  KW: "KW",
  /** Cayman Islands. */
  KY: "KY",
  /** Kazakhstan. */
  KZ: "KZ",
  /** Laos. */
  LA: "LA",
  /** Lebanon. */
  LB: "LB",
  /** St. Lucia. */
  LC: "LC",
  /** Liechtenstein. */
  LI: "LI",
  /** Sri Lanka. */
  LK: "LK",
  /** Liberia. */
  LR: "LR",
  /** Lesotho. */
  LS: "LS",
  /** Lithuania. */
  LT: "LT",
  /** Luxembourg. */
  LU: "LU",
  /** Latvia. */
  LV: "LV",
  /** Libya. */
  LY: "LY",
  /** Morocco. */
  MA: "MA",
  /** Monaco. */
  MC: "MC",
  /** Moldova. */
  MD: "MD",
  /** Montenegro. */
  ME: "ME",
  /** St. Martin. */
  MF: "MF",
  /** Madagascar. */
  MG: "MG",
  /** North Macedonia. */
  MK: "MK",
  /** Mali. */
  ML: "ML",
  /** Myanmar (Burma). */
  MM: "MM",
  /** Mongolia. */
  MN: "MN",
  /** Macao SAR. */
  MO: "MO",
  /** Martinique. */
  MQ: "MQ",
  /** Mauritania. */
  MR: "MR",
  /** Montserrat. */
  MS: "MS",
  /** Malta. */
  MT: "MT",
  /** Mauritius. */
  MU: "MU",
  /** Maldives. */
  MV: "MV",
  /** Malawi. */
  MW: "MW",
  /** Mexico. */
  MX: "MX",
  /** Malaysia. */
  MY: "MY",
  /** Mozambique. */
  MZ: "MZ",
  /** Namibia. */
  NA: "NA",
  /** New Caledonia. */
  NC: "NC",
  /** Niger. */
  NE: "NE",
  /** Norfolk Island. */
  NF: "NF",
  /** Nigeria. */
  NG: "NG",
  /** Nicaragua. */
  NI: "NI",
  /** Netherlands. */
  NL: "NL",
  /** Norway. */
  NO: "NO",
  /** Nepal. */
  NP: "NP",
  /** Nauru. */
  NR: "NR",
  /** Niue. */
  NU: "NU",
  /** New Zealand. */
  NZ: "NZ",
  /** Oman. */
  OM: "OM",
  /** Panama. */
  PA: "PA",
  /** Peru. */
  PE: "PE",
  /** French Polynesia. */
  PF: "PF",
  /** Papua New Guinea. */
  PG: "PG",
  /** Philippines. */
  PH: "PH",
  /** Pakistan. */
  PK: "PK",
  /** Poland. */
  PL: "PL",
  /** St. Pierre & Miquelon. */
  PM: "PM",
  /** Pitcairn Islands. */
  PN: "PN",
  /** Palestinian Territories. */
  PS: "PS",
  /** Portugal. */
  PT: "PT",
  /** Paraguay. */
  PY: "PY",
  /** Qatar. */
  QA: "QA",
  /** Réunion. */
  RE: "RE",
  /** Romania. */
  RO: "RO",
  /** Serbia. */
  RS: "RS",
  /** Russia. */
  RU: "RU",
  /** Rwanda. */
  RW: "RW",
  /** Saudi Arabia. */
  SA: "SA",
  /** Solomon Islands. */
  SB: "SB",
  /** Seychelles. */
  SC: "SC",
  /** Sudan. */
  SD: "SD",
  /** Sweden. */
  SE: "SE",
  /** Singapore. */
  SG: "SG",
  /** St. Helena. */
  SH: "SH",
  /** Slovenia. */
  SI: "SI",
  /** Svalbard & Jan Mayen. */
  SJ: "SJ",
  /** Slovakia. */
  SK: "SK",
  /** Sierra Leone. */
  SL: "SL",
  /** San Marino. */
  SM: "SM",
  /** Senegal. */
  SN: "SN",
  /** Somalia. */
  SO: "SO",
  /** Suriname. */
  SR: "SR",
  /** South Sudan. */
  SS: "SS",
  /** São Tomé & Príncipe. */
  ST: "ST",
  /** El Salvador. */
  SV: "SV",
  /** Sint Maarten. */
  SX: "SX",
  /** Syria. */
  SY: "SY",
  /** Eswatini. */
  SZ: "SZ",
  /** Tristan da Cunha. */
  TA: "TA",
  /** Turks & Caicos Islands. */
  TC: "TC",
  /** Chad. */
  TD: "TD",
  /** French Southern Territories. */
  TF: "TF",
  /** Togo. */
  TG: "TG",
  /** Thailand. */
  TH: "TH",
  /** Tajikistan. */
  TJ: "TJ",
  /** Tokelau. */
  TK: "TK",
  /** Timor-Leste. */
  TL: "TL",
  /** Turkmenistan. */
  TM: "TM",
  /** Tunisia. */
  TN: "TN",
  /** Tonga. */
  TO: "TO",
  /** Türkiye. */
  TR: "TR",
  /** Trinidad & Tobago. */
  TT: "TT",
  /** Tuvalu. */
  TV: "TV",
  /** Taiwan. */
  TW: "TW",
  /** Tanzania. */
  TZ: "TZ",
  /** Ukraine. */
  UA: "UA",
  /** Uganda. */
  UG: "UG",
  /** U.S. Outlying Islands. */
  UM: "UM",
  /** United States. */
  US: "US",
  /** Uruguay. */
  UY: "UY",
  /** Uzbekistan. */
  UZ: "UZ",
  /** Vatican City. */
  VA: "VA",
  /** St. Vincent & Grenadines. */
  VC: "VC",
  /** Venezuela. */
  VE: "VE",
  /** British Virgin Islands. */
  VG: "VG",
  /** Vietnam. */
  VN: "VN",
  /** Vanuatu. */
  VU: "VU",
  /** Wallis & Futuna. */
  WF: "WF",
  /** Samoa. */
  WS: "WS",
  /** Kosovo. */
  XK: "XK",
  /** Yemen. */
  YE: "YE",
  /** Mayotte. */
  YT: "YT",
  /** South Africa. */
  ZA: "ZA",
  /** Zambia. */
  ZM: "ZM",
  /** Zimbabwe. */
  ZW: "ZW",
  /** Unknown Region. */
  ZZ: "ZZ"
}, TZ = ({ countryCode: e, provinceCode: t }) => e && t ? `${e}-${t}` : null, xt = (e) => Object.entries(e).map(([t, n]) => ({
  code: t,
  name: n
})), _Z = {
  [E.US]: {
    code: E.US,
    name: "United States",
    provinces: xt(YK)
  },
  [E.CA]: {
    code: E.CA,
    name: "Canada",
    provinces: xt(nZ)
  },
  [E.AU]: {
    code: E.AU,
    name: "Australia",
    provinces: xt(rZ)
  },
  [E.AF]: {
    code: E.AF,
    name: "Afghanistan",
    provinces: []
  },
  [E.AX]: {
    code: E.AX,
    name: "Aland Islands",
    provinces: []
  },
  [E.AL]: {
    code: E.AL,
    name: "Albania",
    provinces: []
  },
  [E.DZ]: {
    code: E.DZ,
    name: "Algeria",
    provinces: []
  },
  [E.AD]: {
    code: E.AD,
    name: "Andorra",
    provinces: []
  },
  [E.AO]: {
    code: E.AO,
    name: "Angola",
    provinces: []
  },
  [E.AI]: {
    code: E.AI,
    name: "Anguilla",
    provinces: []
  },
  [E.AG]: {
    code: E.AG,
    name: "Antigua and Barbuda",
    provinces: []
  },
  [E.AR]: {
    code: E.AR,
    name: "Argentina",
    provinces: xt(vZ)
  },
  [E.AM]: {
    code: E.AM,
    name: "Armenia",
    provinces: []
  },
  [E.AW]: {
    code: E.AW,
    name: "Aruba",
    provinces: []
  },
  [E.AT]: {
    code: E.AT,
    name: "Austria",
    provinces: xt(lZ)
  },
  [E.AZ]: {
    code: E.AZ,
    name: "Azerbaijan",
    provinces: []
  },
  [E.BS]: {
    code: E.BS,
    name: "Bahamas",
    provinces: []
  },
  [E.BH]: {
    code: E.BH,
    name: "Bahrain",
    provinces: []
  },
  [E.BD]: {
    code: E.BD,
    name: "Bangladesh",
    provinces: []
  },
  [E.BB]: {
    code: E.BB,
    name: "Barbados",
    provinces: []
  },
  [E.BY]: {
    code: E.BY,
    name: "Belarus",
    provinces: []
  },
  [E.BE]: {
    code: E.BE,
    name: "Belgium",
    provinces: xt(cZ)
  },
  [E.BZ]: {
    code: E.BZ,
    name: "Belize",
    provinces: []
  },
  [E.BJ]: {
    code: E.BJ,
    name: "Benin",
    provinces: []
  },
  [E.BM]: {
    code: E.BM,
    name: "Bermuda",
    provinces: []
  },
  [E.BT]: {
    code: E.BT,
    name: "Bhutan",
    provinces: []
  },
  [E.BO]: {
    code: E.BO,
    name: "Bolivia",
    provinces: xt(yZ)
  },
  [E.BA]: {
    code: E.BA,
    name: "Bosnia and Herzegovina",
    provinces: []
  },
  [E.BW]: {
    code: E.BW,
    name: "Botswana",
    provinces: []
  },
  [E.BV]: {
    code: E.BV,
    name: "Bouvet Island",
    provinces: []
  },
  [E.BR]: {
    code: E.BR,
    name: "Brazil",
    provinces: xt(bZ)
  },
  [E.IO]: {
    code: E.IO,
    name: "British Indian Ocean Territory",
    provinces: []
  },
  [E.BN]: {
    code: E.BN,
    name: "Brunei Darussalam",
    provinces: []
  },
  [E.BG]: {
    code: E.BG,
    name: "Bulgaria",
    provinces: []
  },
  [E.BF]: {
    code: E.BF,
    name: "Burkina Faso",
    provinces: []
  },
  [E.BI]: {
    code: E.BI,
    name: "Burundi",
    provinces: []
  },
  [E.KH]: {
    code: E.KH,
    name: "Cambodia",
    provinces: []
  },
  [E.CM]: {
    code: E.CM,
    name: "Cameroon",
    provinces: []
  },
  [E.CV]: {
    code: E.CV,
    name: "Cape Verde",
    provinces: []
  },
  [E.KY]: {
    code: E.KY,
    name: "Cayman Islands",
    provinces: []
  },
  [E.CF]: {
    code: E.CF,
    name: "Central African Republic",
    provinces: []
  },
  [E.TD]: { code: E.TD, name: "Chad", provinces: [] },
  [E.CL]: {
    code: E.CL,
    name: "Chile",
    provinces: xt(SZ)
  },
  [E.CN]: {
    code: E.CN,
    name: "China",
    provinces: []
  },
  [E.CX]: {
    code: E.CX,
    name: "Christmas Island",
    provinces: []
  },
  [E.CC]: {
    code: E.CC,
    name: "Cocos (Keeling) Islands",
    provinces: []
  },
  [E.CO]: {
    code: E.CO,
    name: "Colombia",
    provinces: xt(xZ)
  },
  [E.KM]: {
    code: E.KM,
    name: "Comoros",
    provinces: []
  },
  [E.CG]: {
    code: E.CG,
    name: "Congo",
    provinces: []
  },
  [E.CD]: {
    code: E.CD,
    name: "Congo, The Democratic Republic of the",
    provinces: []
  },
  [E.CK]: {
    code: E.CK,
    name: "Cook Islands",
    provinces: []
  },
  [E.CR]: {
    code: E.CR,
    name: "Costa Rica",
    provinces: []
  },
  [E.CI]: {
    code: E.CI,
    name: 'Cote D"Ivoire',
    provinces: []
  },
  [E.HR]: {
    code: E.HR,
    name: "Croatia",
    provinces: []
  },
  [E.CU]: { code: E.CU, name: "Cuba", provinces: [] },
  [E.CY]: {
    code: E.CY,
    name: "Cyprus",
    provinces: []
  },
  [E.CZ]: {
    code: E.CZ,
    name: "Czech Republic",
    provinces: []
  },
  [E.DK]: {
    code: E.DK,
    name: "Denmark",
    provinces: xt(uZ)
  },
  [E.DJ]: {
    code: E.DJ,
    name: "Djibouti",
    provinces: []
  },
  [E.DM]: {
    code: E.DM,
    name: "Dominica",
    provinces: []
  },
  [E.DO]: {
    code: E.DO,
    name: "Dominican Republic",
    provinces: []
  },
  [E.EC]: {
    code: E.EC,
    name: "Ecuador",
    provinces: xt(CZ)
  },
  [E.EG]: {
    code: E.EG,
    name: "Egypt",
    provinces: []
  },
  [E.SV]: {
    code: E.SV,
    name: "El Salvador",
    provinces: []
  },
  [E.GQ]: {
    code: E.GQ,
    name: "Equatorial Guinea",
    provinces: []
  },
  [E.ER]: {
    code: E.ER,
    name: "Eritrea",
    provinces: []
  },
  [E.EE]: {
    code: E.EE,
    name: "Estonia",
    provinces: []
  },
  [E.ET]: {
    code: E.ET,
    name: "Ethiopia",
    provinces: []
  },
  [E.FK]: {
    code: E.FK,
    name: "Falkland Islands (Malvinas)",
    provinces: []
  },
  [E.FO]: {
    code: E.FO,
    name: "Faroe Islands",
    provinces: []
  },
  [E.FJ]: { code: E.FJ, name: "Fiji", provinces: [] },
  [E.FI]: {
    code: E.FI,
    name: "Finland",
    provinces: xt(dZ)
  },
  [E.FR]: {
    code: E.FR,
    name: "France",
    provinces: xt(fZ)
  },
  [E.GF]: {
    code: E.GF,
    name: "French Guiana",
    provinces: []
  },
  [E.PF]: {
    code: E.PF,
    name: "French Polynesia",
    provinces: []
  },
  [E.TF]: {
    code: E.TF,
    name: "French Southern Territories",
    provinces: []
  },
  [E.GA]: {
    code: E.GA,
    name: "Gabon",
    provinces: []
  },
  [E.GM]: {
    code: E.GM,
    name: "Gambia",
    provinces: []
  },
  [E.GE]: {
    code: E.GE,
    name: "Georgia",
    provinces: []
  },
  [E.DE]: {
    code: E.DE,
    name: "Germany",
    provinces: xt(mZ)
  },
  [E.GH]: {
    code: E.GH,
    name: "Ghana",
    provinces: []
  },
  [E.GI]: {
    code: E.GI,
    name: "Gibraltar",
    provinces: []
  },
  [E.GR]: {
    code: E.GR,
    name: "Greece",
    provinces: []
  },
  [E.GL]: {
    code: E.GL,
    name: "Greenland",
    provinces: []
  },
  [E.GD]: {
    code: E.GD,
    name: "Grenada",
    provinces: []
  },
  [E.GP]: {
    code: E.GP,
    name: "Guadeloupe",
    provinces: []
  },
  [E.GT]: {
    code: E.GT,
    name: "Guatemala",
    provinces: []
  },
  [E.GG]: {
    code: E.GG,
    name: "Guernsey",
    provinces: []
  },
  [E.GN]: {
    code: E.GN,
    name: "Guinea",
    provinces: []
  },
  [E.GW]: {
    code: E.GW,
    name: "Guinea-Bissau",
    provinces: []
  },
  [E.GY]: {
    code: E.GY,
    name: "Guyana",
    provinces: []
  },
  [E.HT]: {
    code: E.HT,
    name: "Haiti",
    provinces: []
  },
  [E.HM]: {
    code: E.HM,
    name: "Heard Island and Mcdonald Islands",
    provinces: []
  },
  [E.VA]: {
    code: E.VA,
    name: "Holy See (Vatican City State)",
    provinces: []
  },
  [E.HN]: {
    code: E.HN,
    name: "Honduras",
    provinces: []
  },
  [E.HK]: {
    code: E.HK,
    name: "Hong Kong",
    provinces: xt(XK)
  },
  [E.HU]: {
    code: E.HU,
    name: "Hungary",
    provinces: []
  },
  [E.IS]: {
    code: E.IS,
    name: "Iceland",
    provinces: []
  },
  [E.IN]: {
    code: E.IN,
    name: "India",
    provinces: []
  },
  [E.ID]: {
    code: E.ID,
    name: "Indonesia",
    provinces: []
  },
  [E.IR]: {
    code: E.IR,
    name: "Iran, Islamic Republic Of",
    provinces: []
  },
  [E.IQ]: { code: E.IQ, name: "Iraq", provinces: [] },
  [E.IE]: {
    code: E.IE,
    name: "Ireland",
    provinces: xt(JK)
  },
  [E.IM]: {
    code: E.IM,
    name: "Isle of Man",
    provinces: []
  },
  [E.IL]: {
    code: E.IL,
    name: "Israel",
    provinces: []
  },
  [E.IT]: {
    code: E.IT,
    name: "Italy",
    provinces: xt(QK)
  },
  [E.JM]: {
    code: E.JM,
    name: "Jamaica",
    provinces: []
  },
  [E.JP]: {
    code: E.JP,
    name: "Japan",
    provinces: xt(eZ)
  },
  [E.JE]: {
    code: E.JE,
    name: "Jersey",
    provinces: []
  },
  [E.JO]: {
    code: E.JO,
    name: "Jordan",
    provinces: []
  },
  [E.KZ]: {
    code: E.KZ,
    name: "Kazakhstan",
    provinces: []
  },
  [E.KE]: {
    code: E.KE,
    name: "Kenya",
    provinces: []
  },
  [E.KI]: {
    code: E.KI,
    name: "Kiribati",
    provinces: []
  },
  [E.KP]: {
    code: E.KP,
    name: "Korea, Democratic People's Republic of",
    provinces: xt(tZ)
  },
  [E.KR]: {
    code: E.KR,
    name: "Korea, Republic of",
    provinces: []
  },
  [E.KW]: {
    code: E.KW,
    name: "Kuwait",
    provinces: []
  },
  [E.KG]: {
    code: E.KG,
    name: "Kyrgyzstan",
    provinces: []
  },
  [E.LA]: {
    code: E.LA,
    name: 'Lao People"s Democratic Republic',
    provinces: []
  },
  [E.LV]: {
    code: E.LV,
    name: "Latvia",
    provinces: []
  },
  [E.LB]: {
    code: E.LB,
    name: "Lebanon",
    provinces: []
  },
  [E.LS]: {
    code: E.LS,
    name: "Lesotho",
    provinces: []
  },
  [E.LR]: {
    code: E.LR,
    name: "Liberia",
    provinces: []
  },
  [E.LY]: {
    code: E.LY,
    name: "Libyan Arab Jamahiriya",
    provinces: []
  },
  [E.LI]: {
    code: E.LI,
    name: "Liechtenstein",
    provinces: []
  },
  [E.LT]: {
    code: E.LT,
    name: "Lithuania",
    provinces: []
  },
  [E.LU]: {
    code: E.LU,
    name: "Luxembourg",
    provinces: []
  },
  [E.MO]: {
    code: E.MO,
    name: "Macao",
    provinces: []
  },
  [E.MK]: {
    code: E.MK,
    name: "Macedonia, The Former Yugoslav Republic of",
    provinces: []
  },
  [E.MG]: {
    code: E.MG,
    name: "Madagascar",
    provinces: []
  },
  [E.MW]: {
    code: E.MW,
    name: "Malawi",
    provinces: []
  },
  [E.MY]: {
    code: E.MY,
    name: "Malaysia",
    provinces: xt(iZ)
  },
  [E.MV]: {
    code: E.MV,
    name: "Maldives",
    provinces: []
  },
  [E.ML]: { code: E.ML, name: "Mali", provinces: [] },
  [E.MT]: {
    code: E.MT,
    name: "Malta",
    provinces: []
  },
  [E.MQ]: {
    code: E.MQ,
    name: "Martinique",
    provinces: []
  },
  [E.MR]: {
    code: E.MR,
    name: "Mauritania",
    provinces: []
  },
  [E.MU]: {
    code: E.MU,
    name: "Mauritius",
    provinces: []
  },
  [E.YT]: {
    code: E.YT,
    name: "Mayotte",
    provinces: []
  },
  [E.MX]: {
    code: E.MX,
    name: "Mexico",
    provinces: xt(oZ)
  },
  [E.MD]: {
    code: E.MD,
    name: "Moldova, Republic of",
    provinces: []
  },
  [E.MC]: {
    code: E.MC,
    name: "Monaco",
    provinces: []
  },
  [E.MN]: {
    code: E.MN,
    name: "Mongolia",
    provinces: []
  },
  [E.MS]: {
    code: E.MS,
    name: "Montserrat",
    provinces: []
  },
  [E.MA]: {
    code: E.MA,
    name: "Morocco",
    provinces: []
  },
  [E.MZ]: {
    code: E.MZ,
    name: "Mozambique",
    provinces: []
  },
  [E.MM]: {
    code: E.MM,
    name: "Myanmar",
    provinces: []
  },
  [E.NA]: {
    code: E.NA,
    name: "Namibia",
    provinces: []
  },
  [E.NR]: {
    code: E.NR,
    name: "Nauru",
    provinces: []
  },
  [E.NP]: {
    code: E.NP,
    name: "Nepal",
    provinces: []
  },
  [E.NL]: {
    code: E.NL,
    name: "Netherlands",
    provinces: []
  },
  [E.AN]: {
    code: E.AN,
    name: "Netherlands Antilles",
    provinces: []
  },
  [E.NC]: {
    code: E.NC,
    name: "New Caledonia",
    provinces: []
  },
  [E.NZ]: {
    code: E.NZ,
    name: "New Zealand",
    provinces: xt(aZ)
  },
  [E.NI]: {
    code: E.NI,
    name: "Nicaragua",
    provinces: []
  },
  [E.NE]: {
    code: E.NE,
    name: "Niger",
    provinces: []
  },
  [E.NG]: {
    code: E.NG,
    name: "Nigeria",
    provinces: []
  },
  [E.NU]: { code: E.NU, name: "Niue", provinces: [] },
  [E.NF]: {
    code: E.NF,
    name: "Norfolk Island",
    provinces: []
  },
  [E.NO]: {
    code: E.NO,
    name: "Norway",
    provinces: xt(pZ)
  },
  [E.OM]: { code: E.OM, name: "Oman", provinces: [] },
  [E.PK]: {
    code: E.PK,
    name: "Pakistan",
    provinces: []
  },
  [E.PS]: {
    code: E.PS,
    name: "Palestinian Territory, Occupied",
    provinces: []
  },
  [E.PA]: {
    code: E.PA,
    name: "Panama",
    provinces: []
  },
  [E.PG]: {
    code: E.PG,
    name: "Papua New Guinea",
    provinces: []
  },
  [E.PY]: {
    code: E.PY,
    name: "Paraguay",
    provinces: xt(wZ)
  },
  [E.PE]: {
    code: E.PE,
    name: "Peru",
    provinces: xt(EZ)
  },
  [E.PH]: {
    code: E.PH,
    name: "Philippines",
    provinces: []
  },
  [E.PN]: {
    code: E.PN,
    name: "Pitcairn",
    provinces: []
  },
  [E.PL]: {
    code: E.PL,
    name: "Poland",
    provinces: []
  },
  [E.PT]: {
    code: E.PT,
    name: "Portugal",
    provinces: xt(sZ)
  },
  [E.QA]: {
    code: E.QA,
    name: "Qatar",
    provinces: []
  },
  [E.RE]: {
    code: E.RE,
    name: "Reunion",
    provinces: []
  },
  [E.RO]: {
    code: E.RO,
    name: "Romania",
    provinces: []
  },
  [E.RU]: {
    code: E.RU,
    name: "Russian Federation",
    provinces: []
  },
  [E.RW]: {
    code: E.RW,
    name: "RWANDA",
    provinces: []
  },
  [E.SH]: {
    code: E.SH,
    name: "Saint Helena",
    provinces: []
  },
  [E.KN]: {
    code: E.KN,
    name: "Saint Kitts and Nevis",
    provinces: []
  },
  [E.LC]: {
    code: E.LC,
    name: "Saint Lucia",
    provinces: []
  },
  [E.PM]: {
    code: E.PM,
    name: "Saint Pierre and Miquelon",
    provinces: []
  },
  [E.VC]: {
    code: E.VC,
    name: "Saint Vincent and the Grenadines",
    provinces: []
  },
  [E.WS]: {
    code: E.WS,
    name: "Samoa",
    provinces: []
  },
  [E.SM]: {
    code: E.SM,
    name: "San Marino",
    provinces: []
  },
  [E.ST]: {
    code: E.ST,
    name: "Sao Tome and Principe",
    provinces: []
  },
  [E.SA]: {
    code: E.SA,
    name: "Saudi Arabia",
    provinces: []
  },
  [E.SN]: {
    code: E.SN,
    name: "Senegal",
    provinces: []
  },
  [E.SC]: {
    code: E.SC,
    name: "Seychelles",
    provinces: []
  },
  [E.SL]: {
    code: E.SL,
    name: "Sierra Leone",
    provinces: []
  },
  [E.SG]: {
    code: E.SG,
    name: "Singapore",
    provinces: []
  },
  [E.SK]: {
    code: E.SK,
    name: "Slovakia",
    provinces: []
  },
  [E.SI]: {
    code: E.SI,
    name: "Slovenia",
    provinces: []
  },
  [E.SB]: {
    code: E.SB,
    name: "Solomon Islands",
    provinces: []
  },
  [E.SO]: {
    code: E.SO,
    name: "Somalia",
    provinces: []
  },
  [E.ZA]: {
    code: E.ZA,
    name: "South Africa",
    provinces: []
  },
  [E.GS]: {
    code: E.GS,
    name: "South Georgia and the South Sandwich Islands",
    provinces: []
  },
  [E.ES]: {
    code: E.ES,
    name: "Spain",
    provinces: xt(KK)
  },
  [E.LK]: {
    code: E.LK,
    name: "Sri Lanka",
    provinces: []
  },
  [E.SD]: {
    code: E.SD,
    name: "Sudan",
    provinces: []
  },
  [E.SR]: {
    code: E.SR,
    name: "Suriname",
    provinces: []
  },
  [E.SJ]: {
    code: E.SJ,
    name: "Svalbard and Jan Mayen",
    provinces: []
  },
  [E.SZ]: {
    code: E.SZ,
    name: "Swaziland",
    provinces: []
  },
  [E.SE]: {
    code: E.SE,
    name: "Sweden",
    provinces: xt(hZ)
  },
  [E.CH]: {
    code: E.CH,
    name: "Switzerland",
    provinces: xt(gZ)
  },
  [E.SY]: {
    code: E.SY,
    name: "Syrian Arab Republic",
    provinces: []
  },
  [E.TW]: {
    code: E.TW,
    name: "Taiwan",
    provinces: []
  },
  [E.TJ]: {
    code: E.TJ,
    name: "Tajikistan",
    provinces: []
  },
  [E.TZ]: {
    code: E.TZ,
    name: "Tanzania, United Republic of",
    provinces: []
  },
  [E.TH]: {
    code: E.TH,
    name: "Thailand",
    provinces: []
  },
  [E.TL]: {
    code: E.TL,
    name: "Timor-Leste",
    provinces: []
  },
  [E.TG]: { code: E.TG, name: "Togo", provinces: [] },
  [E.TK]: {
    code: E.TK,
    name: "Tokelau",
    provinces: []
  },
  [E.TO]: {
    code: E.TO,
    name: "Tonga",
    provinces: []
  },
  [E.TT]: {
    code: E.TT,
    name: "Trinidad and Tobago",
    provinces: []
  },
  [E.TN]: {
    code: E.TN,
    name: "Tunisia",
    provinces: []
  },
  [E.TR]: {
    code: E.TR,
    name: "Turkey",
    provinces: []
  },
  [E.TM]: {
    code: E.TM,
    name: "Turkmenistan",
    provinces: []
  },
  [E.TC]: {
    code: E.TC,
    name: "Turks and Caicos Islands",
    provinces: []
  },
  [E.TV]: {
    code: E.TV,
    name: "Tuvalu",
    provinces: []
  },
  [E.UG]: {
    code: E.UG,
    name: "Uganda",
    provinces: []
  },
  [E.UA]: {
    code: E.UA,
    name: "Ukraine",
    provinces: []
  },
  [E.AE]: {
    code: E.AE,
    name: "United Arab Emirates",
    provinces: xt(qK)
  },
  [E.GB]: {
    code: E.GB,
    name: "United Kingdom",
    provinces: xt(ZK)
  },
  [E.UM]: {
    code: E.UM,
    name: "United States Minor Outlying Islands",
    provinces: []
  },
  [E.UY]: {
    code: E.UY,
    name: "Uruguay",
    provinces: xt(IZ)
  },
  [E.UZ]: {
    code: E.UZ,
    name: "Uzbekistan",
    provinces: []
  },
  [E.VU]: {
    code: E.VU,
    name: "Vanuatu",
    provinces: []
  },
  [E.VE]: {
    code: E.VE,
    name: "Venezuela",
    provinces: xt(RZ)
  },
  [E.VN]: {
    code: E.VN,
    name: "Viet Nam",
    provinces: []
  },
  [E.VG]: {
    code: E.VG,
    name: "Virgin Islands, British",
    provinces: []
  },
  [E.WF]: {
    code: E.WF,
    name: "Wallis and Futuna",
    provinces: []
  },
  [E.EH]: {
    code: E.EH,
    name: "Western Sahara",
    provinces: []
  },
  [E.YE]: {
    code: E.YE,
    name: "Yemen",
    provinces: []
  },
  [E.ZM]: {
    code: E.ZM,
    name: "Zambia",
    provinces: []
  },
  [E.ZW]: {
    code: E.ZW,
    name: "Zimbabwe",
    provinces: []
  },
  [E.AC]: {
    code: E.AC,
    name: "Ascension Island",
    provinces: []
  },
  [E.BL]: {
    code: E.BL,
    name: "St. Barthélemy",
    provinces: []
  },
  [E.BQ]: {
    code: E.BQ,
    name: "Caribbean Netherlands",
    provinces: []
  },
  [E.CW]: {
    code: E.CW,
    name: "Curaçao",
    provinces: []
  },
  [E.ME]: {
    code: E.ME,
    name: "Montenegro",
    provinces: []
  },
  [E.MF]: {
    code: E.MF,
    name: "St. Martin",
    provinces: []
  },
  [E.RS]: {
    code: E.RS,
    name: "Serbia",
    provinces: []
  },
  [E.SS]: {
    code: E.SS,
    name: "South Sudan",
    provinces: []
  },
  [E.SX]: {
    code: E.SX,
    name: "Sint Maarten",
    provinces: []
  },
  [E.TA]: {
    code: E.TA,
    name: "Tristan da Cunha",
    provinces: []
  },
  [E.XK]: {
    code: E.XK,
    name: "Kosovo",
    provinces: []
  },
  [E.ZZ]: {
    code: E.ZZ,
    name: "Unknown Region",
    provinces: []
  }
};
Object.entries(_Z).map(([e, t]) => {
  const { provinces: n } = t;
  if (!n.length)
    return null;
  const r = n.map((o) => {
    const i = TZ({
      countryCode: e,
      provinceCode: o.code
    });
    return i ? {
      label: o.name,
      value: i
    } : null;
  }).filter(Gi);
  return {
    label: t.name,
    options: r
  };
}).filter(Gi);
const OZ = {
  shopNow: {
    checkoutButtonText: "Finish My Return"
  }
}, AZ = {
  checkoutPlus: OZ
};
//! CPO demands we don't change these due to custom brand implementations
//! attributes must be between 3-30 characters in length
const kZ = {
  plusTitle: "_corsoSpTitle",
  plusPrice: "_corsoSpPrice",
  plusEstimatedDeliveryStart: "_corsoSpEstDeliveryStart",
  plusEstimatedDeliveryEnd: "_corsoSpEstDeliveryEnd",
  dgShippingGuaranteed: "_corsoSpGuarantee",
  discountName: "_corsoSpDiscount",
  dgGuaranteeOptOutOn: "_corsoSpDgOptOutOn",
  dgCheckboxSelected: "_corsoSpDgOptOut",
  //! do not modify this without updating the corso-reorder-shipping-lines function
  cpReorderOptIn: "_corsoCpReorderOptIn",
  cpCartOptOut: "_corsoCpCartOptOut"
}, df = {
  appliedGiftCardCodes: "_corsoAppliedGiftCardCodes",
  customer: "_corsoCustomer"
}, DZ = {
  insertAdjacentBeforeBegin: "insertAdjacentBeforeBegin",
  insertAdjacentAfterBegin: "insertAdjacentAfterBegin",
  insertAdjacentBeforeEnd: "insertAdjacentBeforeEnd",
  insertAdjacentAfterEnd: "insertAdjacentAfterEnd"
}, PZ = {
  setShippingPlusReorderRate: "setShippingPlusReorderRate",
  setShippingPlusOptOut: "setShippingPlusOptOut",
  addVariantToCart: "addVariantToCart"
}, NZ = {
  cartWatcher: "cartWatcher",
  selectorObserver: "selectorObserver"
}, MZ = {
  reloadPage: "reloadPage",
  none: "none"
}, w8 = {
  checkoutExtensionProduct: "checkout-extension-product",
  checkoutExtensionShipping: "checkout-extension-shipping",
  customerAccount: "customer-account",
  deliveryEstimate: "delivery-estimate",
  deliveryGuarantee: "delivery-guarantee",
  embeddedUi: "embedded-ui",
  orderEdit: "order-edit",
  removeProduct: "remove-product",
  checkoutPlusScript: "checkout-plus-script",
  checkoutPlusThemeAppEmbed: "checkout-plus-theme-app-embed"
};
y({
  rateTitle: p().optional(),
  rateId: w().optional(),
  rateKind: We([P("plus"), P("non-plus")]),
  shippingDiscount: y({
    message: p().optional(),
    amount: w(),
    type: We([P("percentage"), P("fixedAmount")]),
    isCheckboxApplicationEnabled: N()
  }).optional(),
  shipProtectUnitId: w().optional(),
  deliveryEstimate: C8.optional(),
  pricingDetail: y({
    shippingPrice: w(),
    plusPrice: w(),
    currency: p()
  }).optional()
});
const ff = 128, FZ = y({
  imageUrl: p().url(),
  title: X.insuranceString(ff),
  description: p().nullable(),
  benefits: O(y({
    title: X.insuranceString(ff),
    description: X.insuranceString()
  }))
}), LZ = y({
  // -- General Settings
  isEnabled: N().default(!1).optional(),
  isRateTableCacheEnabled: N().default(!1).optional(),
  enabledLineItemProperties: O(ne([
    df.appliedGiftCardCodes,
    df.customer
  ])).optional(),
  isWidgetDebugEnabled: N().default(!1).optional(),
  isFreeShippingOptInEnabled: N().default(!1).optional(),
  isUpdateExistingDiscountsEnabled: N().default(!1).optional(),
  backupRateIds: O(w()).default([]).optional(),
  enabledCartAttributes: O($e(kZ)).default([]).optional(),
  // -- Delivery Customization Settings
  deliveryCustomization: y({
    isEnabled: N().default(!1).optional(),
    isReorderShippingLinesEnabled: N().default(!1).optional(),
    hideRateNames: O(p()).default([]).optional(),
    hideRateNamesOptOut: O(p()).default([]).optional()
  }).optional(),
  intelligems: y({
    isEnabled: N().default(!1).optional(),
    lineItemAttributeKey: p().default("_igTestGroup").optional()
  }).optional(),
  // -- UI settings for the Widget + Modal-------
  label: X.insuranceString(ff),
  freeShippingLabel: X.nullifiedInsuranceString(ff),
  freeShippingDescription: X.nullifiedInsuranceString(),
  description: X.nullifiedInsuranceString()
}), E8 = p().array(), _g = E8.min(1), $Z = $e(DZ), $6 = y({
  selectors: _g,
  title: p(),
  description: X.nullifiedInsuranceString(128),
  insertionStrategy: $Z,
  imgUrl: Nc(Cn()),
  imgHtmlContent: p().default(""),
  kind: We([P("altCheckoutButton"), P("checkoutInfo")])
}), z6 = AZ.checkoutPlus.shopNow.checkoutButtonText, zZ = y({
  isEnabled: N(),
  cartRetrievalKey: p().default("cart"),
  scriptTagNote: p().optional(),
  isDirectCheckoutEnabled: N().default(!1).optional(),
  removeProtectionProductOnPageLoad: N().default(!0),
  shouldProtectCompanyCarts: N().default(!0),
  shouldQueryShadowDom: N().default(!1),
  cartRefreshMethod: $e(MZ).default("reloadPage"),
  disabledUrls: O(p()).default([]),
  disabledCustomerTags: O(p()).default([]),
  cloneOmitAttributes: O(p()).default([]),
  productCheckoutExtensionTitle: p().default("Delivery Guarantee"),
  productCheckoutExtensionDescription: p().default("For lost, damaged, or stolen packages"),
  checkoutSelectors: _g.default(['button[name="checkout"]']),
  checkoutButtonText: p().trim().optional(),
  // TODO consider rename to checkoutContent or checkoutTemplate
  areSubscriptionsEnabled: N().default(!1),
  hideWidgetSkus: O(p()).default([]),
  isQueryAjaxCartApiEnabled: N().default(!0),
  cartChangeDetectionMethod: $e(NZ).default("cartWatcher"),
  displayCountryCodes: O($e(E)).min(1).default(["US"]),
  // TODO keep in sync with appropriate defaults in `apps/corso-checkout-plus` and `WIDGET_DEFAULTS` in `packages/corso-types/src/corso-shopify-extensions/shared.ts`
  cartSelectors: _g.default([
    "cart-items",
    "cart-drawer",
    "#cart"
  ]),
  checkoutAction: $e(PZ),
  customCss: p().default("").optional(),
  elements: O($6).refine((e) => new Set(e.map((n) => n.kind)).size === $6.shape.kind.options.length, { message: "At least one of each element type is required." }),
  shopNow: y({
    placement: ne(["bottom left", "bottom right"]).default("bottom left").optional(),
    hideSelectors: E8.default(["shopify-accelerated-checkout"]).optional(),
    // marked optional, as it may not exist in some configs
    checkoutButtonText: p().trim().transform((e) => e || z6).default(z6).optional()
    // marked as optional, as it may not exist in some configs
  }).optional()
});
y({
  storefrontId: p(),
  baseApiUrl: p(),
  checkoutPlusUrl: p(),
  defaultProtectSetId: w()
});
const jZ = y({
  isDefaultOptIn: N().default(!1).optional()
}), BZ = y({
  externalStorefrontId: p(),
  modal: FZ,
  shippingPlus: LZ,
  checkoutPlus: zZ,
  checkoutExtensionProduct: jZ.optional()
});
y({
  [df.appliedGiftCardCodes]: p().optional(),
  [df.customer]: p().optional()
}).optional();
y({
  appHandle: ne(w8),
  location: p(),
  metadata: nu(p(), uo()).optional()
});
//! Single source of truth for uploadable media types, shared by the browser
//! (file-picker `accept`) and the server (signed-URL extension allowlist).
const I8 = [
  {
    mime: "image/jpeg",
    extensions: ["jpg", "jpeg", "jpe", "jif", "jfif", "jfi"]
  },
  { mime: "image/png", extensions: ["png"] },
  { mime: "image/webp", extensions: ["webp"] }
], R8 = [
  { mime: "video/mp4", extensions: ["mp4"] },
  { mime: "video/webm", extensions: ["webm"] },
  { mime: "video/quicktime", extensions: ["mov", "qt"] }
], T8 = [
  { mime: "application/pdf", extensions: ["pdf"] }
], _8 = [
  ...I8,
  ...R8,
  ...T8
];
I8.map((e) => e.mime);
R8.map((e) => e.mime);
T8.map((e) => e.mime);
_8.map((e) => e.mime);
const Xu = {
  image: "image",
  video: "video",
  pdf: "pdf"
}, GZ = new Set(_8.flatMap((e) => e.extensions)), VZ = /[\p{C}/\\%]/u, O8 = p().trim().nonempty().max(255).transform((e) => {
  var t, n;
  return {
    filename: e,
    ext: (n = (t = /\.([^.\s]+)$/.exec(e)) == null ? void 0 : t[1]) == null ? void 0 : n.toLowerCase()
  };
}).refine(({ filename: e }) => !VZ.test(e) && !e.includes("..") && // a leading dot hides the file, a leading hyphen reads as a CLI flag
!/^[.-]/.test(e), { error: "Invalid filename" }).refine(({ ext: e }) => e && GZ.has(e), {
  error: "Disallowed file type"
  // ? possibly include extension
}).transform(({ filename: e }) => e);
var D;
(function(e) {
  let t;
  (function(z) {
    z.equal = "equal", z.notEqual = "notEqual", z.lessThan = "lessThan", z.greaterThan = "greaterThan", z.in = "in", z.notIn = "notIn", z.contains = "contains", z.doesNotContain = "doesNotContain";
  })(t = e.Operator || (e.Operator = {}));
  let n;
  (function(z) {
    z.orderDaysSinceCreated = "order/daysSinceCreated", z.statusCustomer = "status/customer", z.registrationChannel = "registration/channel", z.registrationEstimatedPurchaseDate = "registration/estimatedPurchaseDate", z.registrationDaysSincePurchaseEstimate = "registration/daysSincePurchaseEstimate", z.registrationEmailMarketingConsentCollected = "registration/emailMarketingConsentCollected", z.registrationNewCustomerCreated = "registration/newCustomerCreated", z.orderLineItemCustomPropertyName = "order/lineItem/customProperty/name", z.orderLineItemCompareAtPricePercentage = "order/lineItem/compareAtPricePercentage", z.orderDiscountCode = "order/discountCode", z.orderFinancialStatus = "order/financialStatus", z.orderCreated = "order/created", z.orderChannel = "order/channel", z.orderGateway = "order/gateway", z.orderIsGlobalE = "order/isGlobalE", z.orderCountry = "order/country", z.orderProvince = "order/province", z.orderTotal = "order/total", z.orderTags = "order/tags", z.orderCanceled = "order/canceled", z.orderFulfillmentDisplayStatus = "order/fulfillmentDisplayStatus", z.orderProtectedByCorso = "order/protectedByCorso", z.orderShippingLineTitle = "order/shippingLine/title", z.orderRechargeProtectedPrepaid = "order/recharge/protectedPrepaid", z.orderFulfillmentLocationId = "order/fulfillmentLocationId", z.orderNumber = "order/number", z.customerSegmentId = "customer/segmentId", z.customerTags = "customer/tags", z.customerEmail = "customer/email", z.customerTotalReturnCountLastYear = "customer/totalReturnCount/lastYear", z.customerTotalWarrantyCountLastYear = "customer/totalWarrantyCount/lastYear", z.customerTotalOrderCountAllTime = "customer/totalOrderCount/allTime", z.exchangeOrderTotal = "exchangeOrder/total", z.productVendor = "product/vendor", z.productTags = "product/tags", z.productTypes = "product/types", z.productCollections = "product/collections", z.productSku = "product/sku", z.productGroupId = "product/groupId", z.reasonId = "reason/id", z.reasonCategoryCode = "reason/categoryCode", z.reasonDetailId = "reason/detailId", z.claimType = "claim/type", z.claimTags = "claim/tags", z.claimTotal = "claim/total", z.claimRiskLevel = "claim/riskLevel", z.claimIsShopNow = "claim/isShopNow", z.claimLineItemRequestedResolutionMethod = "claimLineItem/requestedResolutionMethod", z.claimLineItemTotal = "claimLineItem/total", z.claimLineItemTotalQuantity = "claimLineItem/totalQuantity", z.claimLineItemCustomFieldResponse = "claimLineItem/customFieldResponse", z.claimLineItemInspectionGrade = "claimLineItem/inspectionGrade", z.claimLineItemWasResolvedExternally = "claimLineItem/wasResolvedExternally", z.claimIsGiftReturn = "claim/isGiftReturn", z.rmaStatus = "rma/status", z.rmaAllItemsReceived = "rma/allItemsReceived", z.rmaDisposition = "rma/disposition", z.returnShipmentStatus = "returnShipment/status", z.returnShipmentLocationId = "returnShipment/locationId", z.intelligemsTestGroupId = "intelligems/testGroupId", z.giftCardIssuedByCorso = "giftCard/issuedByCorso", z.shippingClaimTotal = "shippingClaim/total", z.shippingClaimResolutionMethod = "shippingClaim/resolutionMethod", z.shippingClaimReason = "shippingClaim/reason", z.shippingClaimLineItemReorderSku = "shippingClaimLineItem/reorderSku", z.userRole = "user/roleCode";
  })(n = e.Fact || (e.Fact = {}));
  let r;
  (function(z) {
    z.numberArray = "numberArray", z.stringArray = "stringArray", z.number = "number", z.boolean = "boolean", z.date = "date";
  })(r = e.ValueType || (e.ValueType = {})), e.valueTypeSchema = {
    [r.stringArray]: O(p()),
    [r.numberArray]: O(w()),
    [r.number]: w(),
    [r.boolean]: N(),
    [r.date]: p().datetime()
  }, e.valueOperators = {
    [r.numberArray]: [t.in, t.notIn],
    [r.stringArray]: [
      t.in,
      t.notIn,
      t.contains,
      t.doesNotContain
    ],
    [r.number]: [
      t.lessThan,
      t.greaterThan,
      t.equal,
      t.notEqual
    ],
    [r.boolean]: [t.equal, t.notEqual],
    [r.date]: [t.lessThan, t.greaterThan]
  };
  const o = Object.values({
    [r.stringArray]: r.stringArray,
    [r.numberArray]: r.numberArray
  });
  function i(z) {
    return o.includes(z);
  }
  e.isArrayValueType = i, e.factValueType = {
    [n.orderCreated]: r.date,
    [n.orderCountry]: r.stringArray,
    [n.orderTotal]: r.number,
    [n.orderTags]: r.stringArray,
    [n.customerTags]: r.stringArray,
    [n.rmaStatus]: r.stringArray,
    [n.rmaAllItemsReceived]: r.boolean,
    [n.returnShipmentStatus]: r.stringArray,
    [n.productTags]: r.stringArray,
    [n.productTypes]: r.stringArray,
    [n.reasonId]: r.numberArray,
    [n.reasonCategoryCode]: r.stringArray,
    [n.reasonDetailId]: r.numberArray,
    [n.claimType]: r.stringArray,
    [n.orderNumber]: r.stringArray,
    [n.customerEmail]: r.stringArray,
    [n.orderChannel]: r.stringArray,
    [n.orderProtectedByCorso]: r.boolean,
    [n.claimLineItemRequestedResolutionMethod]: r.stringArray,
    [n.productCollections]: r.stringArray,
    [n.exchangeOrderTotal]: r.number,
    [n.claimLineItemTotal]: r.number,
    [n.claimLineItemCustomFieldResponse]: r.stringArray,
    [n.orderDaysSinceCreated]: r.number,
    [n.statusCustomer]: r.boolean,
    [n.orderGateway]: r.stringArray,
    [n.registrationChannel]: r.stringArray,
    [n.registrationEstimatedPurchaseDate]: r.date,
    [n.orderDiscountCode]: r.stringArray,
    [n.claimTotal]: r.number,
    [n.productVendor]: r.stringArray,
    [n.productSku]: r.stringArray,
    [n.productGroupId]: r.numberArray,
    [n.customerTotalReturnCountLastYear]: r.number,
    [n.customerTotalOrderCountAllTime]: r.number,
    [n.orderProvince]: r.stringArray,
    [n.orderFulfillmentLocationId]: r.numberArray,
    [n.orderLineItemCompareAtPricePercentage]: r.number,
    [n.intelligemsTestGroupId]: r.stringArray,
    [n.customerSegmentId]: r.numberArray,
    [n.orderFulfillmentDisplayStatus]: r.stringArray,
    [n.orderCanceled]: r.boolean,
    [n.orderFinancialStatus]: r.stringArray,
    [n.registrationDaysSincePurchaseEstimate]: r.number,
    [n.claimLineItemInspectionGrade]: r.stringArray,
    [n.returnShipmentLocationId]: r.numberArray,
    [n.claimLineItemTotalQuantity]: r.number,
    [n.rmaDisposition]: r.stringArray,
    [n.claimLineItemWasResolvedExternally]: r.boolean,
    [n.claimIsGiftReturn]: r.boolean,
    [n.claimRiskLevel]: r.stringArray,
    [n.customerTotalWarrantyCountLastYear]: r.number,
    [n.claimIsShopNow]: r.boolean,
    [n.giftCardIssuedByCorso]: r.boolean,
    [n.orderLineItemCustomPropertyName]: r.stringArray,
    [n.registrationEmailMarketingConsentCollected]: r.boolean,
    [n.registrationNewCustomerCreated]: r.boolean,
    [n.orderShippingLineTitle]: r.stringArray,
    [n.orderRechargeProtectedPrepaid]: r.boolean,
    [n.claimTags]: r.stringArray,
    [n.orderIsGlobalE]: r.boolean,
    [n.shippingClaimTotal]: r.number,
    [n.shippingClaimResolutionMethod]: r.stringArray,
    [n.userRole]: r.stringArray,
    [n.shippingClaimReason]: r.stringArray,
    [n.shippingClaimLineItemReorderSku]: r.stringArray
  };
  const a = (z) => {
    const Ue = e.factValueType[z];
    return y({
      fact: P(`${z}`),
      operator: We(EK(e.valueOperators[Ue], (st) => P(`${st}`))),
      value: e.valueTypeSchema[Ue]
    });
  };
  e.arrayFacts = Object.values({
    [n.orderCountry]: n.orderCountry,
    [n.orderTags]: n.orderTags,
    [n.customerTags]: n.customerTags,
    [n.productTags]: n.productTags,
    [n.productTypes]: n.productTypes,
    [n.reasonId]: n.reasonId,
    [n.reasonCategoryCode]: n.reasonCategoryCode,
    [n.reasonDetailId]: n.reasonDetailId,
    [n.claimType]: n.claimType,
    [n.rmaStatus]: n.rmaStatus,
    [n.returnShipmentStatus]: n.returnShipmentStatus,
    [n.orderNumber]: n.orderNumber,
    [n.customerEmail]: n.customerEmail,
    [n.orderChannel]: n.orderChannel,
    [n.productCollections]: n.productCollections,
    [n.claimLineItemRequestedResolutionMethod]: n.claimLineItemRequestedResolutionMethod,
    [n.orderGateway]: n.orderGateway,
    [n.claimLineItemCustomFieldResponse]: n.claimLineItemCustomFieldResponse,
    [n.registrationChannel]: n.registrationChannel,
    [n.orderDiscountCode]: n.orderDiscountCode,
    [n.productVendor]: n.productVendor,
    [n.productSku]: n.productSku,
    [n.productGroupId]: n.productGroupId,
    [n.orderProvince]: n.orderProvince,
    [n.orderFulfillmentLocationId]: n.orderFulfillmentLocationId,
    [n.intelligemsTestGroupId]: n.intelligemsTestGroupId,
    [n.customerSegmentId]: n.customerSegmentId,
    [n.orderFulfillmentDisplayStatus]: n.orderFulfillmentDisplayStatus,
    [n.orderFinancialStatus]: n.orderFinancialStatus,
    [n.claimLineItemInspectionGrade]: n.claimLineItemInspectionGrade,
    [n.returnShipmentLocationId]: n.returnShipmentLocationId,
    [n.rmaDisposition]: n.rmaDisposition,
    [n.claimRiskLevel]: n.claimRiskLevel,
    [n.orderLineItemCustomPropertyName]: n.orderLineItemCustomPropertyName,
    [n.orderShippingLineTitle]: n.orderShippingLineTitle,
    [n.claimTags]: n.claimTags,
    [n.shippingClaimResolutionMethod]: n.shippingClaimResolutionMethod,
    [n.userRole]: n.userRole,
    [n.shippingClaimReason]: n.shippingClaimReason,
    [n.shippingClaimLineItemReorderSku]: n.shippingClaimLineItemReorderSku
  });
  function s(z) {
    return e.arrayFacts.includes(z);
  }
  e.isArrayFact = s;
  let l;
  (function(z) {
    z.arbitrary = "arbitrary", z.definite = "definite";
  })(l = e.ArrayFactType || (e.ArrayFactType = {})), e.arrayFactType = {
    [n.orderCountry]: l.definite,
    [n.orderTags]: l.arbitrary,
    [n.customerTags]: l.arbitrary,
    [n.rmaStatus]: l.arbitrary,
    [n.returnShipmentStatus]: l.definite,
    [n.productTags]: l.arbitrary,
    [n.productTypes]: l.arbitrary,
    [n.reasonId]: l.definite,
    [n.reasonCategoryCode]: l.definite,
    [n.reasonDetailId]: l.definite,
    [n.claimType]: l.definite,
    [n.orderNumber]: l.arbitrary,
    [n.customerEmail]: l.arbitrary,
    [n.orderChannel]: l.definite,
    [n.claimLineItemRequestedResolutionMethod]: l.definite,
    [n.productCollections]: l.arbitrary,
    [n.claimLineItemCustomFieldResponse]: l.definite,
    [n.orderGateway]: l.definite,
    [n.registrationChannel]: l.definite,
    [n.orderDiscountCode]: l.arbitrary,
    [n.productVendor]: l.arbitrary,
    [n.productSku]: l.arbitrary,
    [n.productGroupId]: l.definite,
    [n.orderProvince]: l.definite,
    [n.orderFulfillmentLocationId]: l.definite,
    [n.intelligemsTestGroupId]: l.arbitrary,
    [n.customerSegmentId]: l.definite,
    [n.orderFulfillmentDisplayStatus]: l.definite,
    [n.orderFinancialStatus]: l.definite,
    [n.claimLineItemInspectionGrade]: l.definite,
    [n.returnShipmentLocationId]: l.definite,
    [n.rmaDisposition]: l.definite,
    [n.claimRiskLevel]: l.definite,
    [n.orderLineItemCustomPropertyName]: l.arbitrary,
    [n.orderShippingLineTitle]: l.arbitrary,
    [n.claimTags]: l.arbitrary,
    [n.shippingClaimResolutionMethod]: l.definite,
    [n.userRole]: l.definite,
    [n.shippingClaimReason]: l.definite,
    [n.shippingClaimLineItemReorderSku]: l.arbitrary
  };
  function c(z) {
    return s(z) ? e.arrayFactType[z] === l.arbitrary : !1;
  }
  e.isArbitraryFact = c;
  const u = Object.values({
    [r.stringArray]: r.stringArray
  });
  function d(z) {
    return u.includes(z);
  }
  e.isArbitraryValueType = d;
  function m(z) {
    return s(z) ? e.arrayFactType[z] === l.definite : !1;
  }
  e.isDefiniteFact = m;
  const h = Object.values({
    [r.stringArray]: r.stringArray,
    [r.numberArray]: r.numberArray
  });
  function v(z) {
    return h.includes(z);
  }
  e.isDefiniteValueType = v, e.EventType = {
    merchantPaidShippingProtection: "merchantPaidShippingProtection",
    modifyResolutionWindow: "modifyResolutionWindow",
    autoFinalizeClaim: "autoFinalizeClaim",
    modifyIncentives: "modifyIncentives",
    applyFee: "applyFee",
    omitResolutionMethods: "omitResolutionMethods",
    applyLineItemFee: "applyLineItemFee",
    askAPolicyEnforcingQuestion: "askAPolicyEnforcingQuestion",
    offerInstantExchange: "offerInstantExchange",
    offerAdvancedExchange: "offerAdvancedExchange",
    allowClaimTypeSelection: "allowClaimTypeSelection",
    collectCustomFields: "collectCustomFields",
    applyClaimTags: "applyClaimTags",
    customizeClaimFinalizationSettings: "customizeClaimFinalizationSettings",
    chargeForReturnLabel: "chargeForReturnLabel",
    chargeForExchangeOrderShipping: "chargeForExchangeOrderShipping",
    allowCustomerToKeepItem: "allowCustomerToKeepItem",
    productRegistrationSelection: "productRegistrationSelection",
    returnShippingConfig: "returnShippingConfig",
    applyOrderTags: "applyOrderTags",
    customizeClaimLineItemInspection: "customizeClaimLineItemInspection",
    quoteOrderShipment: "quoteOrderShipment",
    quoteOrderShipmentModify: "quoteOrderShipmentModify",
    quoteOrderShipmentParcel: "quoteOrderShipmentParcel",
    quoteOrderShipmentDeliveryEstimate: "quoteOrderShipmentDeliveryEstimate",
    orderEditing: "orderEditing",
    restockInventory: "restockInventory",
    shopNow: "shopNow",
    setOrderShippingTitle: "setOrderShippingTitle",
    rightToWithdraw: "rightToWithdraw",
    registrationDiscountIncentive: "registrationDiscountIncentive",
    customizeReturnShipment: "customizeReturnShipment",
    createGorgiasTicket: "createGorgiasTicket",
    // shipping claim events
    shipClaimAllowedResolutions: "shipClaimAllowedResolutions",
    shipApplyOrderTags: "shipApplyOrderTags",
    shipClaimSlaAlert: "shipClaimSlaAlert",
    shipClaimReorderLocations: "shipClaimReorderLocations",
    shipClaimReorderShipping: "shipClaimReorderShipping"
  };
  const g = [
    e.EventType.quoteOrderShipment,
    e.EventType.quoteOrderShipmentModify,
    e.EventType.quoteOrderShipmentParcel,
    e.EventType.quoteOrderShipmentDeliveryEstimate,
    e.EventType.merchantPaidShippingProtection,
    e.EventType.shopNow,
    e.EventType.orderEditing,
    // ? shipping claim
    e.EventType.shipClaimAllowedResolutions,
    e.EventType.shipClaimReorderLocations,
    e.EventType.shipClaimSlaAlert,
    e.EventType.shipClaimReorderShipping,
    e.EventType.shipApplyOrderTags
  ];
  e.hiddenEvents = [
    ...new Set(g)
  ], e.Hook = {
    registrationProductSelection: "Registration_Product_Selection",
    // at registration product selection
    registrationCreated: "Registration_Created",
    // at registration created
    orderLookup: "Order_Lookup",
    // at order lookup
    claimCreated: "Claim_Created",
    // at claim created
    claimLineItemReview: "Claim_Line_Item_Review",
    // at claim line item review
    afterReasonSelection: "After_Reason_Selection",
    // after reason selection
    beforeClaimSubmission: "Before_Claim_Submission",
    // before claim submission
    rmaWebhook: "RMA_Webhook",
    // at rma webhook
    returnShipmentWebhook: "Return_Shipment_Webhook",
    // at return shipment webhook
    claimFinalized: "Claim_Finalized",
    // at claim finalize
    returnShipmentCreated: "Return_Shipment_Created",
    // at return shipment purchased
    returnShipmentQuote: "Return_Shipment_Quote",
    // at return shipment quote
    beforeClaimLineItemInspection: "Before_Claim_Line_Item_Inspection",
    // before claim line item inspection
    orderCheckoutBegin: "Order_Checkout_Begin",
    // at order checkout start
    orderCheckoutQuoteShipping: "Order_Checkout_Quote_Shipping",
    // at order checkout quote shipping
    exchangeProductSelection: "Exchange_Product_Selection",
    // at variant exchange start
    shippingClaimLookup: "Shipping_Claim_Lookup",
    // at shipping claim lookup
    shippingClaimFinalized: "Shipping_Claim_Finalized",
    // at shipping claim finalize
    orderCreated: "Order_Created"
    // at order created
  }, e.returnOrWarrantyHook = [
    e.Hook.orderLookup,
    e.Hook.afterReasonSelection,
    e.Hook.exchangeProductSelection,
    e.Hook.claimLineItemReview,
    e.Hook.returnShipmentQuote,
    e.Hook.beforeClaimSubmission,
    e.Hook.claimCreated,
    e.Hook.returnShipmentCreated,
    e.Hook.returnShipmentWebhook,
    e.Hook.rmaWebhook,
    e.Hook.beforeClaimLineItemInspection,
    e.Hook.claimFinalized
  ], e.factExpression = {
    [n.orderCreated]: a(n.orderCreated),
    [n.orderCountry]: a(n.orderCountry),
    [n.orderTotal]: a(n.orderTotal),
    [n.orderTags]: a(n.orderTags),
    [n.customerTags]: a(n.customerTags),
    [n.rmaStatus]: a(n.rmaStatus),
    [n.rmaAllItemsReceived]: a(n.rmaAllItemsReceived),
    [n.returnShipmentStatus]: a(n.returnShipmentStatus),
    [n.productTags]: a(n.productTags),
    [n.productTypes]: a(n.productTypes),
    [n.reasonId]: a(n.reasonId),
    [n.reasonCategoryCode]: a(n.reasonCategoryCode),
    [n.reasonDetailId]: a(n.reasonDetailId),
    [n.claimType]: a(n.claimType),
    [n.orderNumber]: a(n.orderNumber),
    [n.customerEmail]: a(n.customerEmail),
    [n.orderChannel]: a(n.orderChannel),
    [n.orderProtectedByCorso]: a(n.orderProtectedByCorso),
    [n.claimLineItemRequestedResolutionMethod]: a(n.claimLineItemRequestedResolutionMethod),
    [n.orderDaysSinceCreated]: a(n.orderDaysSinceCreated),
    [n.productCollections]: a(n.productCollections),
    [n.exchangeOrderTotal]: a(n.exchangeOrderTotal),
    [n.claimLineItemTotal]: a(n.claimLineItemTotal),
    [n.statusCustomer]: a(n.statusCustomer),
    [n.claimLineItemCustomFieldResponse]: a(n.claimLineItemCustomFieldResponse),
    [n.orderGateway]: a(n.orderGateway),
    [n.registrationChannel]: a(n.registrationChannel),
    [n.registrationEstimatedPurchaseDate]: a(n.registrationEstimatedPurchaseDate),
    [n.orderDiscountCode]: a(n.orderDiscountCode),
    [n.claimTotal]: a(n.claimTotal),
    [n.productVendor]: a(n.productVendor),
    [n.productSku]: a(n.productSku),
    [n.productGroupId]: a(n.productGroupId),
    [n.customerTotalReturnCountLastYear]: a(n.customerTotalReturnCountLastYear),
    [n.customerTotalOrderCountAllTime]: a(n.customerTotalOrderCountAllTime),
    [n.orderProvince]: a(n.orderProvince),
    [n.orderFulfillmentLocationId]: a(n.orderFulfillmentLocationId),
    [n.orderLineItemCompareAtPricePercentage]: a(n.orderLineItemCompareAtPricePercentage),
    [n.intelligemsTestGroupId]: a(n.intelligemsTestGroupId),
    [n.customerSegmentId]: a(n.customerSegmentId),
    [n.orderFulfillmentDisplayStatus]: a(n.orderFulfillmentDisplayStatus),
    [n.orderCanceled]: a(n.orderCanceled),
    [n.orderFinancialStatus]: a(n.orderFinancialStatus),
    [n.registrationDaysSincePurchaseEstimate]: a(n.registrationDaysSincePurchaseEstimate),
    [n.claimLineItemInspectionGrade]: a(n.claimLineItemInspectionGrade),
    [n.returnShipmentLocationId]: a(n.returnShipmentLocationId),
    [n.claimLineItemTotalQuantity]: a(n.claimLineItemTotalQuantity),
    [n.rmaDisposition]: a(n.rmaDisposition),
    [n.claimLineItemWasResolvedExternally]: a(n.claimLineItemWasResolvedExternally),
    [n.claimIsGiftReturn]: a(n.claimIsGiftReturn),
    [n.claimRiskLevel]: a(n.claimRiskLevel),
    [n.customerTotalWarrantyCountLastYear]: a(n.customerTotalWarrantyCountLastYear),
    [n.claimIsShopNow]: a(n.claimIsShopNow),
    [n.giftCardIssuedByCorso]: a(n.giftCardIssuedByCorso),
    [n.orderLineItemCustomPropertyName]: a(n.orderLineItemCustomPropertyName),
    [n.registrationEmailMarketingConsentCollected]: a(n.registrationEmailMarketingConsentCollected),
    [n.registrationNewCustomerCreated]: a(n.registrationNewCustomerCreated),
    [n.orderShippingLineTitle]: a(n.orderShippingLineTitle),
    [n.orderRechargeProtectedPrepaid]: a(n.orderRechargeProtectedPrepaid),
    [n.claimTags]: a(n.claimTags),
    [n.orderIsGlobalE]: a(n.orderIsGlobalE),
    [n.shippingClaimTotal]: a(n.shippingClaimTotal),
    [n.shippingClaimResolutionMethod]: a(n.shippingClaimResolutionMethod),
    [n.userRole]: a(n.userRole),
    [n.shippingClaimReason]: a(n.shippingClaimReason),
    [n.shippingClaimLineItemReorderSku]: a(n.shippingClaimLineItemReorderSku)
  }, e.expressionSchema = ke("fact", [
    e.factExpression[n.shippingClaimResolutionMethod],
    e.factExpression[n.shippingClaimTotal],
    e.factExpression[n.orderIsGlobalE],
    e.factExpression[n.shippingClaimReason],
    e.factExpression[n.userRole],
    e.factExpression[n.orderShippingLineTitle],
    e.factExpression[n.orderCreated],
    e.factExpression[n.orderCountry],
    e.factExpression[n.orderTotal],
    e.factExpression[n.orderTags],
    e.factExpression[n.customerTags],
    e.factExpression[n.rmaStatus],
    e.factExpression[n.rmaAllItemsReceived],
    e.factExpression[n.returnShipmentStatus],
    e.factExpression[n.productTags],
    e.factExpression[n.productTypes],
    e.factExpression[n.reasonId],
    e.factExpression[n.reasonCategoryCode],
    e.factExpression[n.reasonDetailId],
    e.factExpression[n.claimType],
    e.factExpression[n.orderNumber],
    e.factExpression[n.customerEmail],
    e.factExpression[n.orderChannel],
    e.factExpression[n.orderProtectedByCorso],
    e.factExpression[n.claimLineItemRequestedResolutionMethod],
    e.factExpression[n.exchangeOrderTotal],
    e.factExpression[n.claimLineItemTotal],
    e.factExpression[n.productCollections],
    e.factExpression[n.claimLineItemCustomFieldResponse],
    e.factExpression[n.orderDaysSinceCreated],
    e.factExpression[n.statusCustomer],
    e.factExpression[n.orderGateway],
    e.factExpression[n.registrationEstimatedPurchaseDate],
    e.factExpression[n.registrationChannel],
    e.factExpression[n.orderDiscountCode],
    e.factExpression[n.claimTotal],
    e.factExpression[n.productVendor],
    e.factExpression[n.productSku],
    e.factExpression[n.shippingClaimLineItemReorderSku],
    e.factExpression[n.productGroupId],
    e.factExpression[n.customerTotalReturnCountLastYear],
    e.factExpression[n.customerTotalOrderCountAllTime],
    e.factExpression[n.orderProvince],
    e.factExpression[n.orderFulfillmentLocationId],
    e.factExpression[n.orderLineItemCompareAtPricePercentage],
    e.factExpression[n.intelligemsTestGroupId],
    e.factExpression[n.customerSegmentId],
    e.factExpression[n.orderFulfillmentDisplayStatus],
    e.factExpression[n.orderCanceled],
    e.factExpression[n.orderFinancialStatus],
    e.factExpression[n.registrationDaysSincePurchaseEstimate],
    e.factExpression[n.claimLineItemInspectionGrade],
    e.factExpression[n.returnShipmentLocationId],
    e.factExpression[n.claimLineItemTotalQuantity],
    e.factExpression[n.rmaDisposition],
    e.factExpression[n.claimLineItemWasResolvedExternally],
    e.factExpression[n.claimIsGiftReturn],
    e.factExpression[n.claimRiskLevel],
    e.factExpression[n.customerTotalWarrantyCountLastYear],
    e.factExpression[n.claimIsShopNow],
    e.factExpression[n.giftCardIssuedByCorso],
    e.factExpression[n.orderLineItemCustomPropertyName],
    e.factExpression[n.registrationEmailMarketingConsentCollected],
    e.factExpression[n.registrationNewCustomerCreated],
    e.factExpression[n.orderRechargeProtectedPrepaid],
    e.factExpression[n.claimTags]
  ]);
  const x = y({
    all: O(e.expressionSchema)
  }), b = y({
    any: O(e.expressionSchema)
  });
  e.eventClaimFinalizationSettings = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.customizeClaimFinalizationSettings}`),
    params: y({
      inventoryBehavior: $e(gg).optional(),
      failOnOutOfStockScenarios: N(),
      allowFulfillmentLocationIds: O(w()).optional()
    })
  }), e.eventAllowCustomerToKeepItem = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.allowCustomerToKeepItem}`),
    params: y({
      // ? we might need to add a message to display after a yes selection
    })
  });
  const C = P("markAsIneligible");
  e.eventPolicyEnforcement = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.askAPolicyEnforcingQuestion}`),
    params: y({
      question: X.nonEmptyString,
      // ? optional message to display after a yes selection
      onYesMessage: p().optional(),
      yes: C,
      no: Ps()
      // ! do nothing
    })
  }), e.eventAllowClaimTypeSelection = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.allowClaimTypeSelection}`),
    params: y({
      claimTypeSelectionDetailText: X.nonEmptyString,
      returnSelectionButtonTitle: X.optionalizedString
    })
  });
  const I = y({
    name: p()
  });
  e.eventApplyClaimTags = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.applyClaimTags}`),
    params: y({
      claimTags: O(I)
    })
  }), e.OrderTagActionTarget = {
    Replacement_Order: "Replacement Order",
    Original_Order: "Original Order"
  }, e.eventApplyOrderTags = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.applyOrderTags}`),
    params: y({
      orderTagAction: ne(e.OrderTagActionTarget),
      orderTags: O(I),
      tagWithReason: N().optional()
    })
  });
  const T = O(We([
    P(`${rt.refund}`),
    P(`${rt.giftCard}`),
    P(`${rt.variantExchange}`)
  ]));
  e.omittedResolutionMethodOptions = O(We([
    P(`${rt.refund}`),
    P(`${rt.giftCard}`)
  ])), e.eventOmitResolutionMethods = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.omitResolutionMethods}`),
    params: y({
      omittedResolutionMethods: e.omittedResolutionMethodOptions.min(1, "Please select at least one resolution method to omit")
    })
  }), e.eventAutoFinalizeClaim = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.autoFinalizeClaim}`),
    params: y({
      // todo: remove this after fully moving off it in favor of conditions
      allowedResolutionMethods: T.optional()
    })
  });
  const R = Nc(p().max(30, {
    message: "Footnote must be less than 30 characters"
  }).trim()), A = X.policyDays.nullish();
  e.eventModifyResolutionWindow = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.modifyResolutionWindow}`),
    // might need to XOR dates so that at least one is required; otherwise, this wouldn't do anything if nothing was specified
    params: ke("kind", [
      y({
        kind: P("returnableUntil"),
        ineligibleLineItemFootnote: R,
        refund: X.optionalizedDatetime,
        giftCard: X.optionalizedDatetime,
        exchange: X.optionalizedDatetime,
        // ? should this be `variantExchange`
        warrantyReview: X.optionalizedDatetime,
        isIneligibleWarrantyClaimAllowed: N().optional(),
        ineligibleWarrantyClaimTitle: p().optional(),
        ineligibleWarrantyClaimDisclaimer: p().optional()
      }),
      y({
        kind: P("eligibilityDays"),
        ineligibleLineItemFootnote: R,
        refund: A,
        giftCard: A,
        exchange: A,
        // ? should this be `variantExchange`
        warrantyReview: A,
        isIneligibleWarrantyClaimAllowed: N().optional(),
        ineligibleWarrantyClaimTitle: p().optional(),
        ineligibleWarrantyClaimDisclaimer: p().optional()
      })
    ])
  }), e.eventCollectCustomFieldsParams = y({
    customFieldIds: O(w()),
    showDefaultCommentField: N(),
    isDefaultCommentFieldRequired: N().optional(),
    isMediaUploadRequired: N(),
    mediaUploadInstructions: p().optional(),
    minimumMediaUploadAmount: w().optional(),
    allowedContentTypes: O(ne(Xu)).min(1, "Please select at least one media type").default([
      Xu.image,
      Xu.video,
      Xu.pdf
    ])
  }), e.eventCollectCustomFields = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.collectCustomFields}`),
    params: e.eventCollectCustomFieldsParams
  }), e.GorgiasTicketTemplateVars = {
    claimName: "claimName",
    claimType: "claimType",
    customerEmail: "customerEmail",
    merchantAppUrl: "merchantAppUrl"
  }, e.eventCreateGorgiasTicket = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.createGorgiasTicket}`),
    params: y({
      subject: X.nonEmptyString,
      assigneeTeamId: w().optional(),
      shouldAssignSender: N().optional(),
      body: X.optionalizedString,
      // must be a user in Gorgias
      senderEmail: Ki(),
      tags: O(p()).optional()
    })
  }), e.eventCustomizeClaimLineItemInspection = y({
    type: P(`${e.EventType.customizeClaimLineItemInspection}`),
    storeRuleId: w().optional(),
    params: y({
      inspectionCustomFieldIds: O(w()),
      showInspectionComment: N(),
      showInspectionMediaUpload: N(),
      shouldCollectInspectionGrade: N(),
      inspectionInstructions: X.optionalizedString
    })
  });
  function _(z) {
    return ke("shouldModify", [
      y({ shouldModify: P(!1) }),
      z.merge(y({ shouldModify: P(!0) }))
    ]);
  }
  e.shouldModify = _, e.eventModifyIncentives = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.modifyIncentives}`),
    params: y({
      giftCardIncentive: _(y({
        amount: X.nonNegativeNumber,
        type: $e(Qr)
      }))
    })
  }), e.eventChargeForReturnLabel = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.chargeForReturnLabel}`),
    params: y({
      applyLabelMarkup: _(y({
        amount: X.nonNegativeNumber,
        type: $e(Qr)
      }))
    })
  }), e.eventProductRegistrationSelection = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.productRegistrationSelection}`),
    params: y({
      productRegistrationProductGroupId: p().or(w()).pipe(Ee()).pipe(w().gt(0, "Please select a Product Group"))
    })
  }), e.ReturnHandling = {
    returnLocation: "Return_Location",
    globalE: "Global_E"
  };
  const k = y({
    // `.optional()` lets the discriminated union match rules stored before this
    // field existed; `.default()` then stamps them as return-location policies
    returnHandling: P(e.ReturnHandling.returnLocation).optional().default(e.ReturnHandling.returnLocation),
    returnMethods: O(We([P("Label"), P("Packing_Slip")])).min(1, "Please select at least one Return Method"),
    returnLocationId: p().or(w()).pipe(Ee()).pipe(w().gt(0, "Please select a Return Location"))
  }), M = y({
    returnHandling: P(e.ReturnHandling.globalE)
  });
  e.eventReturnShippingConfig = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.returnShippingConfig}`),
    params: ke("returnHandling", [
      k,
      M
    ])
  }), e.eventChargeForExchangeOrderShipping = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.chargeForExchangeOrderShipping}`),
    params: y({
      applyExchangeOrderShippingMarkup: _(y({
        amount: X.nonNegativeNumber,
        type: $e(Qr)
      }))
    })
  });
  const j = y({
    feeDisplayName: p(),
    feeAmount: w().nonnegative(),
    feeType: $e(Qr).default("Fixed")
  });
  e.eventApplyFee = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.applyFee}`),
    params: j
  }), e.eventApplyLineItemFee = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.applyLineItemFee}`),
    params: j.extend({
      applyPerItem: N().default(!1)
    })
  }), e.ShopNowBenefitKind = {
    incentive: "incentive",
    informational: "informational"
  }, e.ShopNowIcon = {
    DollarSign: "DollarSign",
    MagnifyingGlass: "MagnifyingGlass",
    Truck: "Truck",
    ArrowRightArrowLeft: "ArrowRightArrowLeft"
  };
  const G = y({
    label: X.nonEmptyString.max(36, "Label must be less than 36 characters"),
    description: X.nonEmptyString.max(150, "Description must be less than 100 characters"),
    icon: $e(e.ShopNowIcon).optional()
  }), U = G.extend({
    kind: P(e.ShopNowBenefitKind.informational)
  }), B = G.extend({
    kind: P(e.ShopNowBenefitKind.incentive),
    incentive: y({
      amount: X.nonNegativeNumber,
      type: We([
        P(Qr.fixed),
        P(Qr.percent)
      ])
    })
  });
  e.ShopNowBenefit = ke("kind", [
    U,
    B
  ]), e.shopNowEventParams = y({
    startShoppingUrl: p().url().min(1, "Start Shopping URL is required"),
    // TODO: add error messaging
    shopNowBenefits: O(e.ShopNowBenefit).max(4, "Please add up to 4 benefits")
  }), e.eventShopNow = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.shopNow}`),
    params: e.shopNowEventParams
  }), e.eventOfferInstantExchangeParams = y({
    timeToReturnBeforeCharging: P(7),
    // ! this can be altered once we determine how Stripe interacts with us for pre-authorizations
    isInstantExchangeRequired: N().default(!1),
    instantExchangeDescriptionText: p().optional()
  }), e.eventOfferInstantExchange = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.offerInstantExchange}`),
    params: e.eventOfferInstantExchangeParams
  }), e.eventQuoteOrderShipment = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.quoteOrderShipment}`),
    params: y({
      storeShipRateIds: O(w())
    })
  }), e.QuoteModification = {
    APPLY_FIXED_FEE: "APPLY_FIXED_FEE",
    APPLY_PERCENTAGE_FEE: "APPLY_PERCENTAGE_FEE",
    ADD_OR_REMOVE_RATES: "ADD_OR_REMOVE_RATES",
    APPLY_SHIPPING_DISCOUNT: "APPLY_SHIPPING_DISCOUNT"
  }, e.USHoliday = {
    NEW_YEARS_DAY: "NEW_YEARS_DAY",
    MARTIN_LUTHER_KING_JR_DAY: "MARTIN_LUTHER_KING_JR_DAY",
    PRESIDENTS_DAY: "PRESIDENTS_DAY",
    MEMORIAL_DAY: "MEMORIAL_DAY",
    INDEPENDENCE_DAY: "INDEPENDENCE_DAY",
    LABOR_DAY: "LABOR_DAY",
    VETERANS_DAY: "VETERANS_DAY",
    THANKSGIVING_DAY: "THANKSGIVING_DAY",
    CHRISTMAS_DAY: "CHRISTMAS_DAY",
    INDIGENOUS_PEOPLES_DAY: "INDIGENOUS_PEOPLES_DAY",
    JUNETEENTH: "JUNETEENTH"
  }, e.estimatedDeliveryDisplayLocationUnion = We([
    P("EXTENSION"),
    P("ADD_TO_DESCRIPTION")
  ]), e.EstimatedDeliveryStrategy = {
    STATIC: "STATIC",
    CARRIER_PROVIDED: "CARRIER_PROVIDED"
  }, e.provideEstimatedDeliveryDate = y({
    strategy: $e(e.EstimatedDeliveryStrategy),
    estimatedDeliveryShippingCutOffTime: ag(p().pipe(Ee()).or(w())),
    estimatedDeliveryRangeStartDays: w().nonnegative().default(3),
    estimatedDeliveryRangeEndDays: w().nonnegative().optional(),
    estimatedDeliveryDisplayLocation: e.estimatedDeliveryDisplayLocationUnion,
    estimatedDeliveryFulfillmentTz: p().optional(),
    carrierEstimatedFulfillmentDays: w().nonnegative().optional(),
    estimatedDeliveryHolidays: O($e(e.USHoliday)).optional().default(Object.values(e.USHoliday)),
    estimatedDeliveryBlackoutDates: O(p()).optional(),
    estimatedTargetStoreShipRateIds: O(w())
  });
  const K = y({
    kind: P(e.QuoteModification.APPLY_FIXED_FEE),
    amount: w().nonnegative(),
    applyPerItem: N().default(!1),
    fixedFeeStoreShipRateIds: O(w()).optional().default([])
  }), ee = y({
    kind: P(e.QuoteModification.APPLY_PERCENTAGE_FEE),
    percentage: w().nonnegative(),
    percentageFeeStoreShipRateIds: O(w()).optional().default([])
  }), Y = We([
    P("ADD"),
    P("REMOVE"),
    P("REPLACE")
  ]), J = y({
    kind: P(e.QuoteModification.ADD_OR_REMOVE_RATES),
    action: Y,
    addOrRemoveStoreShipRateIds: O(w())
  });
  e.ShippingDiscountType = {
    percentage: "percentage",
    fixedAmount: "fixedAmount",
    removePlusPricing: "removePlusPricing"
  }, e.shippingDiscount = y({
    kind: P(e.QuoteModification.APPLY_SHIPPING_DISCOUNT),
    discountMessage: p().optional(),
    discountType: $e(e.ShippingDiscountType),
    discountAmount: w().nonnegative(),
    discountStoreShipRateIds: O(w()).optional().default([]),
    isCheckboxApplicationEnabled: N().optional().default(!0)
  });
  const ye = ke("kind", [
    ee,
    K,
    J,
    e.shippingDiscount
  ]);
  e.eventQuoteOrderShipmentModify = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.quoteOrderShipmentModify}`),
    params: y({
      checkoutRateModifications: O(ye)
    })
  }), e.eventQuoteOrderShipmentDeliveryEstimate = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.quoteOrderShipmentDeliveryEstimate}`),
    params: y({
      deliveryEstimateConfigs: O(e.provideEstimatedDeliveryDate)
    })
  }), e.RestockPlatform = {
    SHOPIFY: "SHOPIFY",
    XORO: "XORO"
  };
  const re = y({
    restockPlatform: $e(e.RestockPlatform)
  });
  e.RestockName = {
    available: "available",
    damaged: "damaged",
    none: "none"
  };
  const le = re.extend({
    restockPlatform: P(e.RestockPlatform.SHOPIFY),
    restockLocationIdFromPlatform: p().optional(),
    shopifyRestockName: $e(e.RestockName)
  }), Te = re.extend({
    restockPlatform: P(e.RestockPlatform.XORO)
  });
  e.eventRestockInventory = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.restockInventory}`),
    params: ke("restockPlatform", [
      le,
      Te
    ])
  }), e.OrderEditType = {
    CANCEL_ORDER: "CANCEL_ORDER",
    UPDATE_SHIPPING_ADDRESS: "UPDATE_SHIPPING_ADDRESS",
    REMOVE_PACKAGE_PROTECTION: "REMOVE_PACKAGE_PROTECTION",
    MODIFY_QUANTITY: "MODIFY_QUANTITY",
    UPDATE_EMAIL: "UPDATE_EMAIL",
    UPDATE_SHIPPING_LINE: "UPDATE_SHIPPING_LINE",
    ADD_DISCOUNT_CODE: "ADD_DISCOUNT_CODE"
  }, e.OrderEditMinuteSavedMultiplier = {
    [e.OrderEditType.CANCEL_ORDER]: 5,
    [e.OrderEditType.UPDATE_SHIPPING_ADDRESS]: 5,
    [e.OrderEditType.REMOVE_PACKAGE_PROTECTION]: 3,
    [e.OrderEditType.MODIFY_QUANTITY]: 4,
    [e.OrderEditType.UPDATE_EMAIL]: 2,
    [e.OrderEditType.UPDATE_SHIPPING_LINE]: 4,
    [e.OrderEditType.ADD_DISCOUNT_CODE]: 4
  }, e.OrderEditHoldTag = "CORSO-OE-HOLD", e.OrderEditDisplayContent = {
    [e.OrderEditType.CANCEL_ORDER]: {
      name: "Cancel Order",
      customerDescription: "Request to cancel your order.",
      merchantDescription: "Let customers request order cancellation."
    },
    [e.OrderEditType.UPDATE_SHIPPING_ADDRESS]: {
      name: "Update Shipping Address",
      customerDescription: "Change the shipping address for your order.",
      merchantDescription: "Allow customers to update their shipping address."
    },
    [e.OrderEditType.REMOVE_PACKAGE_PROTECTION]: {
      name: "Remove Package Protection",
      customerDescription: "Remove shipping protection from your order.",
      merchantDescription: "Let customers remove package protection."
    },
    [e.OrderEditType.MODIFY_QUANTITY]: {
      name: "Adjust Product Quantity",
      customerDescription: "Change the quantity of items on your order.",
      merchantDescription: "Allow customers to add or remove quantity on existing items."
    },
    [e.OrderEditType.UPDATE_EMAIL]: {
      name: "Update Email",
      customerDescription: "Change the email address on your order.",
      merchantDescription: "Let customers update their email address."
    },
    [e.OrderEditType.UPDATE_SHIPPING_LINE]: {
      name: "Change Shipping Method",
      customerDescription: "Upgrade or change the shipping method on your order.",
      merchantDescription: "Allow customers to upgrade or change their shipping method."
    },
    [e.OrderEditType.ADD_DISCOUNT_CODE]: {
      name: "Apply Discount Code",
      customerDescription: "Apply a discount code to your order.",
      merchantDescription: "Let customers apply a discount code post-purchase and receive a refund for the difference."
    }
  }, e.OrderEditStoredType = {
    [e.OrderEditType.UPDATE_SHIPPING_ADDRESS]: "Update_Shipping_Address",
    [e.OrderEditType.CANCEL_ORDER]: "Cancel_Order",
    [e.OrderEditType.REMOVE_PACKAGE_PROTECTION]: "Remove_Package_Protection",
    [e.OrderEditType.MODIFY_QUANTITY]: "Modify_Quantity",
    [e.OrderEditType.UPDATE_EMAIL]: "Update_Email",
    [e.OrderEditType.UPDATE_SHIPPING_LINE]: "Update_Shipping_Line",
    [e.OrderEditType.ADD_DISCOUNT_CODE]: "Add_Discount_code"
  };
  const F = (z) => e.OrderEditDisplayContent[z].name;
  e.orderEditStoredTypeName = {
    Update_Shipping_Address: F(e.OrderEditType.UPDATE_SHIPPING_ADDRESS),
    Cancel_Order: F(e.OrderEditType.CANCEL_ORDER),
    Remove_Package_Protection: F(e.OrderEditType.REMOVE_PACKAGE_PROTECTION),
    Modify_Quantity: F(e.OrderEditType.MODIFY_QUANTITY),
    Update_Email: F(e.OrderEditType.UPDATE_EMAIL),
    Update_Shipping_Line: F(e.OrderEditType.UPDATE_SHIPPING_LINE),
    Add_Discount_code: F(e.OrderEditType.ADD_DISCOUNT_CODE)
  }, e.orderEditTypeUnion = We([
    P(`${e.OrderEditType.CANCEL_ORDER}`),
    P(`${e.OrderEditType.UPDATE_SHIPPING_ADDRESS}`),
    P(`${e.OrderEditType.REMOVE_PACKAGE_PROTECTION}`),
    P(`${e.OrderEditType.MODIFY_QUANTITY}`),
    P(`${e.OrderEditType.UPDATE_EMAIL}`),
    P(`${e.OrderEditType.UPDATE_SHIPPING_LINE}`),
    P(`${e.OrderEditType.ADD_DISCOUNT_CODE}`)
  ]);
  const Z = y({
    storeRuleId: w().optional(),
    editConfirmLabel: p().optional(),
    editSuccessLabel: p().optional()
  });
  e.orderEditCancelOrderActionSchema = Z.extend({
    editType: P(`${e.OrderEditType.CANCEL_ORDER}`),
    shouldNotifyOnCancellation: N().default(!0),
    shouldRestockOnCancellation: N().default(!0)
  }), e.orderEditUpdateShippingLineActionSchema = Z.extend({
    editType: P(`${e.OrderEditType.UPDATE_SHIPPING_LINE}`),
    allowedShippingLines: O(p()).min(1, "Please specify at least one shipping line.").max(5, "Please specify no more than 5 shipping lines.")
  }), e.orderEditUpdateAddressActionSchema = Z.extend({
    editType: P(`${e.OrderEditType.UPDATE_SHIPPING_ADDRESS}`),
    allowDifferentCountryAddressEdit: N().optional(),
    shouldRecalculateTaxesOnAddressEdit: N().optional()
  }), e.orderEditRemovePackageProtection = Z.extend({
    editType: P(`${e.OrderEditType.REMOVE_PACKAGE_PROTECTION}`)
  });
  const se = {
    ADD: "ADD",
    REMOVE: "REMOVE",
    BOTH: "BOTH"
  };
  e.orderEditModifyQuantityActionSchema = Z.extend({
    editType: P(`${e.OrderEditType.MODIFY_QUANTITY}`),
    quantityModificationType: ne(se),
    quantityModificationValue: w().int().positive()
  }), e.orderEditUpdateEmailActionSchema = Z.extend({
    editType: P(`${e.OrderEditType.UPDATE_EMAIL}`)
  }), e.orderEditAddDiscountCodeActionSchema = Z.extend({
    editType: P(`${e.OrderEditType.ADD_DISCOUNT_CODE}`)
  }), e.orderEditAction = ke("editType", [
    e.orderEditCancelOrderActionSchema,
    e.orderEditUpdateAddressActionSchema,
    e.orderEditRemovePackageProtection,
    e.orderEditModifyQuantityActionSchema,
    e.orderEditUpdateEmailActionSchema,
    e.orderEditUpdateShippingLineActionSchema,
    e.orderEditAddDiscountCodeActionSchema
  ]), e.eventOrderEditing = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.orderEditing}`),
    params: e.orderEditAction
  }), e.eventRegistrationDiscountIncentive = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.registrationDiscountIncentive}`),
    params: y({
      storeDiscountDefinitionId: w(),
      discountRedirectUrl: Cn(),
      discountValidityDays: w().nonnegative().optional(),
      discountCustomerMessage: p().optional()
    })
  }), e.AdvancedExchangeMethod = {
    PAYMENT: "PAYMENT",
    // Previously UPSELL
    PAYMENT_AND_PARTIAL_REFUND: "PAYMENT_AND_PARTIAL_REFUND",
    // Previously PARTIAL_REFUND
    NO_PAYMENT_OR_REFUND: "NO_PAYMENT_OR_REFUND"
    // Previously NO_PAYMENT
  }, e.advancedExchangeMethodUnion = We([
    P(`${e.AdvancedExchangeMethod.PAYMENT}`),
    P(`${e.AdvancedExchangeMethod.PAYMENT_AND_PARTIAL_REFUND}`),
    P(`${e.AdvancedExchangeMethod.NO_PAYMENT_OR_REFUND}`)
  ]), e.AdvancedExchangeSortCriteria = {
    ALPHABETICAL: "ALPHABETICAL",
    NEWEST_FIRST: "NEWEST_FIRST"
  };
  const ae = We([
    P(`${e.AdvancedExchangeSortCriteria.ALPHABETICAL}`),
    P(`${e.AdvancedExchangeSortCriteria.NEWEST_FIRST}`)
  ]), ue = y({
    isAdvancedExchangeFilterAndSearchEnabled: N().default(!0).optional(),
    advancedExchangeSortCriteria: ae.default(`${e.AdvancedExchangeSortCriteria.ALPHABETICAL}`),
    excludedAdvancedExchangeOptionNames: O(p()).default(["Title"]),
    minInventoryAvailableToCustomer: X.nonNegativeNumber.nullish(),
    advancedExchangeMethod: e.advancedExchangeMethodUnion.default("NO_PAYMENT_OR_REFUND")
  });
  e.eventOfferAdvancedExchange = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.offerAdvancedExchange}`),
    params: ke("exchangeKind", [
      ue.extend({
        exchangeKind: P("product"),
        isNoAdjustmentVariantExchangeEnabled: N().default(!1).optional(),
        storeProductTags: O(p()).optional(),
        matchAllTags: N().default(!1).optional(),
        storeProductGroupIds: O(w())
      }).refine((z) => {
        var Ue;
        return !!((Ue = z.storeProductTags) != null && Ue.length) || !!z.storeProductGroupIds.length;
      }, {
        error: "Please specify at least one product tag or product group.",
        path: ["storeProductGroupIds"]
      }),
      ue.extend({
        exchangeKind: P("variant")
      })
    ])
  });
  const te = y({
    name: p(),
    length: w().nonnegative().min(1),
    width: w().nonnegative().min(1),
    height: w().nonnegative().min(1)
  });
  e.eventQuoteOrderShipmentParcel = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.quoteOrderShipmentParcel}`),
    params: y({
      parcel: te
    })
  }), e.customReturnParcel = te.omit({
    name: !0
  }).extend({
    weight: w().nonnegative().optional(),
    name: p().optional()
  }), e.eventCustomizeReturnShipment = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.customizeReturnShipment}`),
    params: y({
      isApplicablePerLineItemQuantity: N().default(!0),
      fileUrlCta: p().max(32, "Must be less than 32 characters").optional(),
      fileUrl: Cn().optional(),
      returnParcels: O(e.customReturnParcel).min(1, "Please specify at least one parcel")
    })
  }), e.eventMerchantPaidProtection = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.merchantPaidShippingProtection}`),
    params: y({
      shipProtectUnitId: w()
    })
  }), e.eventSetOrderShippingTitle = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.setOrderShippingTitle}`),
    params: y({
      shippingTitle: p()
    })
  }), e.eventRightToWithdraw = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.rightToWithdraw}`),
    params: y({
      rightToWithdrawTitle: p(),
      rightToWithdrawDescription: p()
    })
  }), e.eventSpcAllowedResolutions = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.shipClaimAllowedResolutions}`),
    params: y({
      isGiftCardEnabled: N().optional(),
      shippingClaimResolutionMethods: O(ne(Zi)).min(1)
    })
  }), e.eventSpcAllowedReorderLocations = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.shipClaimReorderLocations}`),
    params: y({
      reorderLocationIds: O(w()).min(1),
      minInventoryAvailable: X.nonNegativeNumber.nullish()
    })
  }), e.eventSpcReorderShipping = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.shipClaimReorderShipping}`),
    params: ke("shippingTitleKind", [
      y({
        shippingTitleKind: P("selection"),
        shippingTitles: O(p()).min(1)
      }),
      y({
        shippingTitleKind: P("assignment"),
        shippingTitle: p()
      })
    ])
  }), e.eventSpcApplyOrderTags = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.shipApplyOrderTags}`),
    params: e.eventApplyOrderTags.shape.params.omit({ tagWithReason: !0 })
  }), e.eventSpcSlaNotification = y({
    storeRuleId: w().optional(),
    type: P(`${e.EventType.shipClaimSlaAlert}`),
    params: y({
      alert: y({
        title: X.nonEmptyString.max(40, {
          message: "Title must be less than 40 characters"
        }),
        message: X.nonEmptyString.max(150, {
          message: "Message must be less than 150 characters"
        }),
        variant: We([
          P("warning"),
          P("info"),
          P("danger")
        ])
      }),
      // ? disables finalize in the merchant-ui; manual refunds and reorders stay available
      shouldBlockFinalization: N().optional()
    })
  }), e.hooksForEvent = {
    // order lookup
    [e.EventType.orderEditing]: [e.Hook.orderLookup],
    [e.EventType.modifyResolutionWindow]: [e.Hook.orderLookup],
    [e.EventType.offerInstantExchange]: [e.Hook.orderLookup],
    [e.EventType.allowClaimTypeSelection]: [e.Hook.orderLookup],
    [e.EventType.rightToWithdraw]: [e.Hook.orderLookup],
    // after reason selection
    [e.EventType.askAPolicyEnforcingQuestion]: [e.Hook.afterReasonSelection],
    [e.EventType.collectCustomFields]: [e.Hook.afterReasonSelection],
    // exchange product selection
    [e.EventType.offerAdvancedExchange]: [e.Hook.exchangeProductSelection],
    // return shipment quote
    [e.EventType.returnShippingConfig]: [e.Hook.returnShipmentQuote],
    // before claim submission
    [e.EventType.chargeForReturnLabel]: [e.Hook.beforeClaimSubmission],
    [e.EventType.chargeForExchangeOrderShipping]: [e.Hook.beforeClaimSubmission],
    [e.EventType.modifyIncentives]: [e.Hook.beforeClaimSubmission],
    [e.EventType.applyFee]: [e.Hook.beforeClaimSubmission],
    // claim created
    [e.EventType.applyClaimTags]: [
      e.Hook.claimCreated,
      e.Hook.rmaWebhook,
      e.Hook.returnShipmentWebhook,
      e.Hook.returnShipmentCreated
    ],
    [e.EventType.autoFinalizeClaim]: [
      e.Hook.rmaWebhook,
      e.Hook.returnShipmentWebhook,
      e.Hook.claimCreated
    ],
    [e.EventType.allowCustomerToKeepItem]: [e.Hook.returnShipmentCreated],
    [e.EventType.customizeClaimLineItemInspection]: [
      e.Hook.beforeClaimLineItemInspection
    ],
    [e.EventType.applyOrderTags]: [e.Hook.claimCreated, e.Hook.claimFinalized],
    [e.EventType.customizeClaimFinalizationSettings]: [e.Hook.claimFinalized],
    [e.EventType.shopNow]: [e.Hook.claimLineItemReview],
    // checkout + theme app + registration
    [e.EventType.productRegistrationSelection]: [
      e.Hook.registrationProductSelection
    ],
    [e.EventType.restockInventory]: [
      e.Hook.claimFinalized,
      e.Hook.returnShipmentWebhook
    ],
    [e.EventType.setOrderShippingTitle]: [e.Hook.claimFinalized],
    [e.EventType.quoteOrderShipment]: [e.Hook.orderCheckoutBegin],
    [e.EventType.quoteOrderShipmentModify]: [e.Hook.orderCheckoutQuoteShipping],
    [e.EventType.quoteOrderShipmentParcel]: [e.Hook.orderCheckoutQuoteShipping],
    [e.EventType.quoteOrderShipmentDeliveryEstimate]: [
      e.Hook.orderCheckoutQuoteShipping
    ],
    [e.EventType.registrationDiscountIncentive]: [e.Hook.registrationCreated],
    [e.EventType.customizeReturnShipment]: [e.Hook.returnShipmentQuote],
    [e.EventType.merchantPaidShippingProtection]: [e.Hook.orderCreated],
    [e.EventType.createGorgiasTicket]: [e.Hook.claimCreated, e.Hook.claimFinalized],
    [e.EventType.applyLineItemFee]: [e.Hook.beforeClaimSubmission],
    [e.EventType.omitResolutionMethods]: [e.Hook.afterReasonSelection],
    [e.EventType.shipClaimReorderLocations]: [e.Hook.shippingClaimLookup],
    [e.EventType.shipClaimAllowedResolutions]: [e.Hook.shippingClaimLookup],
    [e.EventType.shipClaimSlaAlert]: [e.Hook.shippingClaimLookup],
    [e.EventType.shipClaimReorderShipping]: [e.Hook.shippingClaimLookup],
    [e.EventType.shipApplyOrderTags]: [e.Hook.shippingClaimFinalized]
  }, e.eventsForHook = Object.values(e.Hook).reduce((z, Ue) => (z[Ue] = Object.values(e.EventType).filter((st) => e.hooksForEvent[st].includes(Ue)), z), {});
  const he = [
    n.registrationEstimatedPurchaseDate,
    n.registrationChannel,
    n.registrationDaysSincePurchaseEstimate
  ], ge = [
    ...he,
    n.registrationEmailMarketingConsentCollected,
    n.registrationNewCustomerCreated
  ];
  e.orderFacts = [
    n.orderIsGlobalE,
    n.orderShippingLineTitle,
    n.orderFinancialStatus,
    n.orderDiscountCode,
    n.orderCreated,
    n.orderCountry,
    n.orderProvince,
    n.orderGateway,
    n.orderTotal,
    n.orderTags,
    n.customerTags,
    n.orderNumber,
    n.customerEmail,
    n.orderChannel,
    n.orderProtectedByCorso,
    n.orderDaysSinceCreated,
    n.statusCustomer,
    n.customerTotalOrderCountAllTime,
    n.orderFulfillmentDisplayStatus,
    n.orderCanceled,
    n.orderFulfillmentLocationId,
    ...ge
  ], e.lineItemFacts = [
    n.productTags,
    n.orderLineItemCustomPropertyName,
    n.productTypes,
    n.productCollections,
    n.productVendor,
    n.productSku,
    n.productGroupId,
    n.orderLineItemCompareAtPricePercentage
  ], e.claimLineItemFacts = [
    n.reasonId,
    n.reasonCategoryCode,
    n.reasonDetailId,
    n.claimLineItemRequestedResolutionMethod,
    n.claimLineItemInspectionGrade,
    n.claimLineItemTotalQuantity,
    n.returnShipmentLocationId,
    n.claimLineItemWasResolvedExternally,
    ...e.lineItemFacts
  ], e.shippingClaimFacts = [
    n.shippingClaimTotal,
    n.shippingClaimResolutionMethod,
    n.shippingClaimReason,
    n.shippingClaimLineItemReorderSku
  ];
  const de = [n.claimType, n.claimTotal], xe = [
    ...de,
    n.claimIsGiftReturn,
    n.claimRiskLevel,
    n.claimIsShopNow
  ];
  e.factsForHook = {
    [e.Hook.orderCreated]: [
      n.orderShippingLineTitle,
      n.orderTags,
      n.orderChannel,
      n.orderTotal,
      n.orderRechargeProtectedPrepaid
    ],
    [e.Hook.returnShipmentQuote]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      ...de,
      n.exchangeOrderTotal,
      n.claimLineItemCustomFieldResponse
    ],
    [e.Hook.orderLookup]: [...e.orderFacts, ...e.lineItemFacts],
    [e.Hook.afterReasonSelection]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      ...de
    ],
    [e.Hook.claimLineItemReview]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      ...de,
      n.exchangeOrderTotal
    ],
    [e.Hook.beforeClaimSubmission]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      ...de,
      n.claimIsShopNow,
      n.exchangeOrderTotal,
      n.claimLineItemCustomFieldResponse
    ],
    [e.Hook.returnShipmentCreated]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      n.claimLineItemTotal,
      n.claimLineItemCustomFieldResponse,
      ...xe
    ],
    [e.Hook.orderCheckoutBegin]: [n.orderCountry, n.orderProvince],
    [e.Hook.claimCreated]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      ...xe,
      n.claimLineItemCustomFieldResponse,
      n.customerTotalWarrantyCountLastYear
    ],
    [e.Hook.beforeClaimLineItemInspection]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      n.claimType,
      n.claimLineItemCustomFieldResponse
    ],
    [e.Hook.returnShipmentWebhook]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      ...xe,
      n.customerTotalReturnCountLastYear,
      n.returnShipmentStatus,
      n.claimLineItemCustomFieldResponse
    ],
    [e.Hook.rmaWebhook]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      ...xe,
      n.rmaStatus,
      n.rmaAllItemsReceived,
      n.rmaDisposition,
      n.claimLineItemCustomFieldResponse
    ],
    [e.Hook.claimFinalized]: [
      ...e.orderFacts,
      ...e.claimLineItemFacts,
      ...xe,
      n.claimTags
    ],
    [e.Hook.shippingClaimLookup]: [
      ...e.orderFacts,
      ...e.shippingClaimFacts,
      n.userRole,
      n.productGroupId
    ],
    [e.Hook.registrationProductSelection]: he,
    [e.Hook.orderCheckoutQuoteShipping]: [
      n.productGroupId,
      n.customerTags,
      n.orderFulfillmentLocationId,
      n.intelligemsTestGroupId,
      n.productSku,
      n.productVendor,
      n.orderCountry,
      n.orderProvince,
      n.customerSegmentId,
      n.giftCardIssuedByCorso
    ],
    [e.Hook.exchangeProductSelection]: [n.productGroupId, n.productTags],
    [e.Hook.registrationCreated]: [
      ...ge,
      ...e.lineItemFacts,
      n.customerEmail
    ],
    [e.Hook.shippingClaimFinalized]: [...e.orderFacts, ...e.shippingClaimFacts]
  };
  function ce(z) {
    const Ue = e.factValueType[z];
    return e.valueOperators[Ue];
  }
  e.operatorForFact = ce;
  function je(z) {
    const Ue = e.factValueType[z];
    return e.valueTypeSchema[Ue];
  }
  e.valueSchemaForFact = je, e.eventSchema = We([
    e.eventSetOrderShippingTitle,
    e.eventOrderEditing,
    e.eventOfferAdvancedExchange,
    e.eventModifyResolutionWindow,
    e.eventOfferInstantExchange,
    e.eventApplyClaimTags,
    e.eventAllowClaimTypeSelection,
    e.eventCollectCustomFields,
    e.eventAutoFinalizeClaim,
    e.eventPolicyEnforcement,
    e.eventClaimFinalizationSettings,
    e.eventApplyFee,
    e.eventModifyIncentives,
    e.eventChargeForReturnLabel,
    e.eventChargeForExchangeOrderShipping,
    e.eventAllowCustomerToKeepItem,
    e.eventProductRegistrationSelection,
    e.eventReturnShippingConfig,
    e.eventApplyOrderTags,
    e.eventCustomizeClaimLineItemInspection,
    e.eventQuoteOrderShipment,
    e.eventQuoteOrderShipmentModify,
    e.eventQuoteOrderShipmentParcel,
    e.eventQuoteOrderShipmentDeliveryEstimate,
    e.eventRestockInventory,
    e.eventShopNow,
    e.eventRegistrationDiscountIncentive,
    e.eventCustomizeReturnShipment,
    e.eventMerchantPaidProtection,
    e.eventCreateGorgiasTicket,
    e.eventRightToWithdraw,
    e.eventApplyLineItemFee,
    e.eventOmitResolutionMethods,
    e.eventSpcAllowedResolutions,
    e.eventSpcAllowedReorderLocations,
    e.eventSpcSlaNotification,
    e.eventSpcReorderShipping,
    e.eventSpcApplyOrderTags
  ]), e.eventsSchemaArray = O(e.eventSchema), e.ruleSchema = y({
    priority: w("Must be a number").positive("Must be greater than zero").int("Must be a whole number"),
    // ! 1 is highest priority, with decreasing priority as the number increases
    conditions: We([x, b]),
    event: e.eventSchema,
    storeRuleId: w().optional()
  });
})(D || (D = {}));
const er = y({
  amount: p(),
  currencyCode: p()
});
O(D.orderEditAction);
const A8 = y({
  editType: P(`${D.OrderEditType.CANCEL_ORDER}`),
  action: D.orderEditCancelOrderActionSchema,
  stagedEdits: em().optional()
}), k8 = y({
  editType: P(`${D.OrderEditType.UPDATE_SHIPPING_ADDRESS}`),
  action: D.orderEditUpdateAddressActionSchema,
  stagedEdits: y({
    updatedShippingAddress: Xi,
    // present only when shouldRecalculateTaxesOnAddressEdit ran at stage
    originalTotal: er.optional(),
    calculatedTotal: er.optional(),
    additionalPaymentCollectionUrl: Cn().nullish()
  })
}), D8 = y({
  editType: P(`${D.OrderEditType.REMOVE_PACKAGE_PROTECTION}`),
  action: D.orderEditRemovePackageProtection,
  stagedEdits: em().optional()
}), P8 = y({
  editType: P(`${D.OrderEditType.MODIFY_QUANTITY}`),
  action: D.orderEditModifyQuantityActionSchema,
  stagedEdits: y({
    originalTotal: er,
    calculatedTotal: er,
    additionalPaymentCollectionUrl: Cn().nullable(),
    lineItemDeltas: O(y({
      storeOrderLineItemId: w(),
      newQuantity: w().int().nonnegative(),
      previousQuantity: w().int().nonnegative()
    }))
  })
}), N8 = y({
  editType: P(`${D.OrderEditType.UPDATE_EMAIL}`),
  action: D.orderEditUpdateEmailActionSchema,
  stagedEdits: y({
    email: Ki()
  })
}), M8 = y({
  editType: P(`${D.OrderEditType.UPDATE_SHIPPING_LINE}`),
  action: D.orderEditUpdateShippingLineActionSchema,
  stagedEdits: y({
    selectedShippingLine: y({
      title: p(),
      price: p()
    }),
    previousShippingLine: y({
      title: p(),
      price: p()
    }),
    originalTotal: er,
    calculatedTotal: er,
    additionalPaymentCollectionUrl: Cn().nullable()
  })
}), F8 = y({
  editType: P(`${D.OrderEditType.ADD_DISCOUNT_CODE}`),
  action: D.orderEditAddDiscountCodeActionSchema,
  stagedEdits: y({
    code: p().trim().min(1).max(64),
    originalTotal: er,
    calculatedTotal: er,
    refundAmount: er
  })
}), tc = ke("editType", [
  A8,
  k8,
  D8,
  P8,
  N8,
  M8,
  F8
]), xa = {
  appliedOrderEditId: w(),
  ok: P(!0)
}, L8 = ke("editType", [
  A8.extend(xa),
  k8.extend(xa),
  D8.extend(xa),
  P8.extend(xa),
  N8.extend(xa),
  M8.extend(xa),
  F8.extend(xa)
]), UZ = y({
  ok: P(!1),
  message: p()
});
We([
  L8,
  UZ
]);
const Ca = y({
  ok: N(),
  message: p()
}), Bl = ne(["STORE_CREDIT", "ORIGINAL_PAYMENT"]);
ke("editType", [
  Ca.extend({
    editType: P(`${D.OrderEditType.CANCEL_ORDER}`),
    refundMethod: Bl.nullish()
  }),
  Ca.extend({
    editType: P(`${D.OrderEditType.UPDATE_SHIPPING_ADDRESS}`),
    additionalPaymentCollectionUrl: Cn().nullish()
  }),
  Ca.extend({
    editType: P(`${D.OrderEditType.REMOVE_PACKAGE_PROTECTION}`),
    refundedAmount: er.nullish(),
    refundMethod: Bl.nullish()
  }),
  Ca.extend({
    editType: P(`${D.OrderEditType.MODIFY_QUANTITY}`),
    additionalPaymentCollectionUrl: Cn().nullish(),
    refundedAmount: er.nullish(),
    refundMethod: Bl.nullish()
  }),
  Ca.extend({
    editType: P(`${D.OrderEditType.UPDATE_EMAIL}`)
  }),
  Ca.extend({
    editType: P(`${D.OrderEditType.UPDATE_SHIPPING_LINE}`),
    additionalPaymentCollectionUrl: Cn().nullish(),
    refundedAmount: er.nullish(),
    refundMethod: Bl.nullish()
  }),
  Ca.extend({
    editType: P(`${D.OrderEditType.ADD_DISCOUNT_CODE}`),
    refundedAmount: er.nullish(),
    refundMethod: Bl.nullish()
  })
]);
const $8 = y({
  editType: P(`${D.OrderEditType.UPDATE_SHIPPING_LINE}`),
  action: D.orderEditUpdateShippingLineActionSchema
}), WZ = $8.extend({
  prepared: y({
    quotes: O(y({
      title: p(),
      price: er,
      deltaFromCurrent: p(),
      newShippingTotal: er
    }))
  })
});
ke("editType", [
  $8
]);
const HZ = ke("editType", [
  WZ
]), zi = y({
  idFromPlatform: p(),
  price: Ee(),
  quantity: w(),
  grams: w(),
  // this is the title of the product technically / usually displayed with options
  title: p(),
  options: O(y({ name: p(), value: p() })),
  // this is the title of the variant, which is a combination of the product title and the options
  titleWithOptions: p(),
  optionsValueString: p(),
  sku: p().nullish(),
  imgUrl: p().nullish(),
  barcode: p().nullish()
}), lm = zi.extend({
  id: w()
}), iu = y({
  id: w(),
  title: p(),
  idFromPlatform: p(),
  imgUrl: p().nullable(),
  vendor: p().nullish(),
  productType: p().nullish(),
  tags: O(p()).nullish(),
  variants: O(lm)
}), qZ = lm, z8 = iu, j8 = y({
  id: w(),
  name: p()
}), B8 = y({
  id: w(),
  name: p()
}), G8 = y({
  id: w(),
  name: p()
}), Js = y({
  id: w(),
  name: X.nonEmptyString,
  types: O(j8),
  tags: O(B8),
  collections: O(G8),
  lastUpdatedOn: X.optionalizedString,
  createdOn: p().optional()
}), YZ = iu.pick({
  id: !0,
  title: !0,
  idFromPlatform: !0,
  imgUrl: !0,
  productType: !0
}).extend({
  createdOn: p(),
  status: p().nullable(),
  isOffPlatform: N()
}), j6 = O(YZ), KZ = iu.extend({
  createdOn: p(),
  handle: p().nullable(),
  status: p().nullable(),
  isOffPlatform: N(),
  /** Null for off-platform products, which have no platform admin to link to. */
  platformAdminUrl: p().nullable()
}), ZZ = O(Js.pick({ id: !0, name: !0 })), XZ = O(y({ id: w(), name: p() })), JZ = y({
  title: X.nonEmptyString,
  status: $e(Li),
  productType: X.nonEmptyString.nullable(),
  vendor: X.nonEmptyString.nullable(),
  tags: O(X.nonEmptyString)
}), QZ = iu.pick({
  id: !0,
  title: !0,
  idFromPlatform: !0,
  imgUrl: !0
}).merge(y({
  variants: O(lm.pick({
    id: !0,
    title: !0,
    idFromPlatform: !0,
    imgUrl: !0,
    sku: !0
  }))
})), eX = Js.omit({ id: !0 }), tX = y({
  csv: p().min(1),
  shouldDedupeBySku: N()
}), nX = y({ rowCount: w() }), V8 = y({ name: p(), position: w() }), rX = O(V8), U8 = y({
  idFromPlatform: p(),
  name: p(),
  imageUrl: p().nullable(),
  hasOnlyDefaultVariant: N(),
  createdOn: p().optional(),
  productType: p().optional()
}), oX = U8.extend({
  options: O(V8.merge(y({ values: O(p()) }))),
  variants: O(zi)
}), iX = y({
  name: p(),
  values: O(p()),
  type: P("option")
}), H0 = y({
  customerRecommendationMessage: p().optional(),
  method: ne([
    "sameVariant",
    "historicalExchange",
    "aiVariantSwap",
    "aiPopular",
    "aiProductType"
  ]),
  product: U8,
  variant: zi
});
y({
  variantIdFromPlatform: p().optional(),
  reasonId: Ee().optional(),
  comment: p().optional(),
  reasonDetailId: Ee().optional(),
  countryCode: p().optional(),
  isExchangeOfExchange: We([P("true"), P("false")]).transform((e) => e === "true").optional()
});
const W8 = y({
  exchangeRecommendation: H0.optional(),
  advancedExchangeMethod: D.advancedExchangeMethodUnion,
  isFilterAndSearchEnabled: N(),
  isNoAdjustmentVariantExchangeEnabled: N(),
  filters: O(iX).optional(),
  products: O(oX)
}), aX = y({
  id: w(),
  title: p(),
  description: p().optional()
}), H8 = ne([
  "Authorized",
  "Captured",
  "Refunded",
  "Expired"
]), sX = {
  INCENTIVE: "INCENTIVE",
  SUBTOTAL: "SUBTOTAL",
  PAYMENT: "PAYMENT",
  SHIPPING: "SHIPPING",
  RETURN_SHIPPING: "RETURN_SHIPPING",
  SHOP_NOW_INCENTIVE: "SHOP_NOW_INCENTIVE",
  FEE: "FEE",
  LINE_ITEM_FEE: "LINE_ITEM_FEE",
  TAX: "TAX",
  // a positive balance under the Stripe minimum credited back, or an exchange held to the delta the customer was charged
  ADJUSTMENT: "ADJUSTMENT"
}, q8 = y({
  type: ne(sX),
  label: p(),
  amount: w()
}), gl = We([p(), w()]), lr = w().nonnegative(), q0 = ne(rm), lX = y({
  idFromPlatform: p(),
  price: lr,
  quantity: w().int().positive()
}), cX = y({
  id: gl,
  quantity: w().int().positive(),
  // per unit; the adapter owns dividing a line-total tax down
  unitPrice: lr,
  unitTax: lr,
  requestedResolutionMethod: ne(rt),
  resolutionMethod: ne(rt).nullable(),
  state: ne(["open", "denied", "canceled", "finalized"]),
  // the merchant's issued amount when it differs from the returned value
  creditAmountOverride: lr.nullable(),
  // what the customer was shown as owed at submission; reported as requested over the recomputed value
  storedRequestedAmount: lr.nullable(),
  // deductions already taken from this line by an earlier finalization
  previouslyDeducted: lr,
  outstandingCreditFinalized: N(),
  exchange: y({
    items: O(lX),
    // whether exchanged items are worth their own price or the returned line's (a like-for-like replacement)
    priceBasis: ne(["exchangedItems", "returnedLine"]),
    isShopNow: N()
  }).nullable(),
  // how a downsell is paid back when the line names it
  downsellMethod: q0.nullable(),
  // what the customer was charged or promised for the exchange; the money follows it over the recomputed delta
  storedExchangeDelta: w().nullable(),
  fees: O(y({ amount: lr, label: p() })),
  resolvedExternally: N()
}), Y8 = y({
  handlingFee: y({ amount: lr, label: p() }).nullable(),
  returnShipping: lr,
  exchangeShipping: lr,
  giftCardIncentive: lr,
  shopNowIncentive: lr,
  // how credit goes back to the customer when a line does not say
  aggregateCreditResolutionMethod: q0,
  customerPayment: y({
    status: H8,
    amount: lr,
    refundedAmount: lr
  }).nullable(),
  exchangeMethod: ne(["instant", "standard"]),
  lineItems: O(cX)
}), uX = y({
  id: gl,
  // set on exchanged items, so a deduction can be shown as the new item rather than the returned one
  idFromPlatform: p().optional(),
  quantity: w(),
  unitPrice: w(),
  unitTax: w()
}), B6 = y({
  lineItems: O(uX),
  sections: O(q8),
  total: w()
}), K8 = ne(["pending", "issued"]), dX = y({
  kind: P("credit"),
  id: gl,
  status: K8,
  method: ne([
    rt.refund,
    rt.giftCard,
    rt.other
  ]),
  requestedAmount: w(),
  deductedAmount: w(),
  amount: w(),
  wasZeroedThroughDeduction: N(),
  // a downsell paid back to the customer, alongside the exchange outcome for the same line
  isPartialExchangeCredit: N(),
  resolvedExternally: N()
}), fX = y({
  kind: P("exchange"),
  id: gl,
  status: K8,
  method: ne([
    rt.variantExchange,
    rt.replacementOrder
  ]),
  returnedValue: w(),
  exchangedValue: w(),
  // positive is an upsell the customer owes, negative a downsell they are owed
  exchangeDelta: w(),
  // the persisted delta finalization acts on; differs from exchangeDelta when the stored figure is stale
  settledDelta: w().nullable(),
  downsellMethod: q0.nullable(),
  isShopNow: N(),
  resolvedExternally: N()
}), mX = y({
  kind: P("none"),
  id: gl,
  method: ne([
    rt.repair,
    rt.other
  ])
}), pX = y({
  kind: P("excluded"),
  id: gl,
  reason: ne([
    "denied",
    "canceled",
    "warrantyReview",
    "missingExchangeItems"
  ])
}), hX = ke("kind", [
  dX,
  fX,
  mX,
  pX
]), Z8 = y({
  credits: B6,
  deductions: B6,
  // deductions minus credits: positive the customer owes, negative the customer is owed
  balance: w(),
  payment: y({
    intentAmount: w(),
    waivedAmount: w()
  }),
  lines: O(hX),
  // deductions the credit lines could not absorb
  unallocatedDeduction: w(),
  // what the customer gets across the whole claim, split by whether it has been issued yet
  totals: y({
    refund: w(),
    giftCard: w(),
    issued: y({ refund: w(), giftCard: w() }),
    pending: y({ refund: w(), giftCard: w() })
  }),
  benefit: y({
    newRevenue: w(),
    retainedRevenue: w()
  })
}), gX = Z8.extend({
  calculatedOn: p(),
  input: Y8
}), ko = {
  Text: "Text",
  Number: "Number",
  Date: "Date",
  Select: "Select",
  MultiSelect: "MultiSelect"
}, X8 = O(y({
  url: Cn(),
  caption: Nc(p().max(150, {
    message: "Caption must be 150 characters or less"
  }))
})).max(4, { message: "A custom field can have at most 4 reference images" }), vl = y({
  id: w(),
  displayName: p().max(30, {
    message: "Name must be less than 30 characters"
  }),
  description: p(),
  options: X.csv.optional(),
  referenceImages: X8.optional(),
  createdOn: p().optional(),
  valueType: We([
    P(`${ko.Text}`),
    P(`${ko.Number}`),
    P(`${ko.Date}`),
    P(`${ko.Select}`),
    P(`${ko.MultiSelect}`)
  ])
}), vX = vl.omit({ id: !0 }), yX = vl.omit({ valueType: !0 }), J8 = vl.pick({
  id: !0,
  description: !0,
  displayName: !0,
  referenceImages: !0
}).merge(y({
  required: N(),
  valueType: We([
    P(`${ko.Select}`),
    P(`${ko.MultiSelect}`)
  ]),
  options: p().array()
})), Y0 = vl.pick({
  id: !0,
  displayName: !0,
  description: !0,
  referenceImages: !0
}).merge(y({
  required: N(),
  valueType: We([
    P(`${ko.Text}`),
    P(`${ko.Number}`),
    P(`${ko.Date}`)
  ])
})), K0 = O(We([Y0, J8])), bX = y({
  isDefaultCommentFieldRequired: N().optional(),
  showDefaultCommentField: N(),
  isMediaUploadRequired: N(),
  mediaUploadInstructions: p().optional(),
  minimumMediaUploadAmount: w().optional(),
  allowedContentTypes: D.eventCollectCustomFieldsParams.shape.allowedContentTypes,
  customFields: K0
}), Q8 = y({
  type: P("collectCustomFields"),
  params: bX
}), au = vl.omit({ options: !0, referenceImages: !0 }).merge(y({ value: p() })), e5 = au.pick({
  id: !0,
  value: !0
}), SX = {
  //* shipment evidence — the headline group for a shipping-protection product
  reasonVsTracking: "reasonVsTracking",
  parcelScope: "parcelScope",
  carrierCorroboration: "carrierCorroboration",
  claimTiming: "claimTiming",
  alreadyMadeWhole: "alreadyMadeWhole",
  //* financial history, from one Shopify orders-by-email call
  chargebackOverlap: "chargebackOverlap",
  chargebackHistory: "chargebackHistory",
  refundOverlap: "refundOverlap",
  returnElsewhere: "returnElsewhere",
  refundHabit: "refundHabit",
  //* customer standing
  accountAge: "accountAge",
  priorDeniedClaim: "priorDeniedClaim",
  claimRateVsOrders: "claimRateVsOrders",
  crossDomainHistory: "crossDomainHistory",
  priorHighRiskClaim: "priorHighRiskClaim",
  //* identifier fan-out, read across both claim domains
  emailReuseStore: "emailReuse-store",
  emailReuseGlobal: "emailReuse-global",
  deviceFanOut: "deviceFanOut",
  ipFanOut: "ipFanOut",
  addressFanOut: "addressFanOut",
  //* claim shape
  claimCoverage: "claimCoverage",
  evidenceProvided: "evidenceProvided",
  mediaReuse: "mediaReuse",
  mediaSimilarity: "mediaSimilarity",
  reshipAddressChange: "reshipAddressChange",
  //* fingerprint device intelligence
  botDetection: "botDetection",
  fingerprintSuspectScore: "fingerprintSuspectScore",
  anonymizedNetwork: "anonymizedNetwork",
  ipReputation: "ipReputation",
  browserTampering: "browserTampering",
  fingerprintVelocity: "fingerprintVelocity",
  geoDistance: "geoDistance",
  ipAddress: "ipAddress",
  isMerchantCreated: "isMerchantCreated"
}, t5 = y({
  level: Hn($0),
  aggregateScore: w(),
  // optional: rows written before provenance was recorded have neither
  calculatedOn: p().optional(),
  modelVersion: p().optional(),
  facts: O(y({
    factor: Hn(SX),
    score: w(),
    justification: p(),
    sentiment: Hn(h8)
  }))
}), n5 = y({
  orderDiscounts: N(),
  productDiscounts: N(),
  shippingDiscounts: N()
}), r5 = y({
  percentage: w().min(0).max(100)
}), o5 = y({
  amount: p()
  // Shopify uses string for money amounts
}), i5 = ke("kind", [
  y({
    kind: P("quantity"),
    quantity: y({
      greaterThanOrEqualToQuantity: p()
    })
  }),
  y({
    kind: P("subtotal"),
    subtotal: y({
      greaterThanOrEqualToSubtotal: p()
    })
  })
]), a5 = y({
  kind: P("amountOffOrder"),
  combinesWith: n5,
  minimumRequirement: i5.optional(),
  customerGets: y({
    value: We([
      r5,
      o5.extend({ appliesOnEachItem: P(!1) })
    ])
  })
}), s5 = y({
  kind: P("amountOffProduct"),
  combinesWith: n5,
  customerGets: y({
    items: y({
      collections: y({
        add: O(w().int().positive()).min(1, "Select at least one collection.")
      })
    }),
    value: We([
      r5,
      // `appliesOnEachItem: true` is valid here because items is always scoped.
      o5.extend({ appliesOnEachItem: N() })
    ])
  }),
  minimumRequirement: i5.optional()
}), Z0 = y({
  mutation: P("discountCodeBasicCreate").default("discountCodeBasicCreate"),
  parameters: ke("kind", [
    a5,
    s5
  ])
}), l5 = y({
  id: w(),
  title: p(),
  discountDefinition: Z0
});
//! this file contains namespaced schemas for the dbJson fields
var qn;
(function(e) {
  (function(t) {
    const n = y({
      at: p(),
      tool: p().nullable(),
      message: p(),
      cause: p().optional(),
      context: uo().optional()
    });
    t.storeAgentMessageMetadataSchema = cr.messageMetadataSchema.extend({
      errors: O(n).optional()
    });
  })(e.StoreAgentConversation || (e.StoreAgentConversation = {})), (function(t) {
    t.featureFlags = y({
      mcpServer: N().default(!1).meta({
        title: "MCP Server",
        description: "When enabled, Settings > Developer shows the MCP Server card: how to connect Claude or ChatGPT to Corso, and the connections this user has authorized."
      })
    });
  })(e.Store || (e.Store = {})), (function(t) {
    t.WarrantyProgramName = {
      warranty: "Warranty",
      guarantee: "Guarantee"
    }, t.customerUiConfigSchema = y({
      merchantPrimaryColor: p(),
      merchantLogoUrl: p(),
      merchantBackgroundUrl: p().nullable(),
      merchantFaviconUrl: p(),
      footerText: p(),
      isReturnPhoneRequired: N().optional(),
      isWarrantyPhoneRequired: N().optional(),
      isRegistrationPhoneRequired: N().optional(),
      //! ---- any additional properties should be added as optional
      orderHubStartRequestTitleText: X.optionalizedString,
      orderHubStartRequestDetailText: X.optionalizedString,
      warrantyProgramName: Hn(t.WarrantyProgramName).default("Warranty").optional(),
      orderNumberDescriptionText: X.optionalizedString,
      orderLookupDetailText: X.optionalizedString,
      orderLookupGiftReturnDetailText: X.optionalizedString,
      merchantBackgroundColor: X.optionalizedString,
      merchantPageTitle: X.optionalizedString,
      // refund + gift card text
      offerGiftCardDetailText: X.optionalizedString,
      offerRefundDetailText: X.optionalizedString,
      // green returns // allow customer to keep item
      noReturnRequiredItemsDetailText: X.optionalizedString,
      noReturnRequiredItemsHeadline: X.optionalizedString,
      warrantyItemsDetailText: X.optionalizedString,
      hideLabelDownloadWhenQrCodeIsPresent: N().optional(),
      // registrations
      orderLookupRegistrationText: X.optionalizedString,
      emailMarketingConsentText: X.optionalizedString,
      emailMarketingConsentDescriptionText: X.optionalizedString,
      emailMarketingConsentPolicyUrlTextTitle: X.optionalizedString,
      identifyProductUrl: X.optionalizedString,
      identifyProductUrlButtonText: X.optionalizedString,
      identifyProductDetailText: X.optionalizedString,
      identifyProductFormPlaceholder: X.optionalizedString,
      registrationSubmissionText: X.optionalizedString,
      registrationCountryCodes: O(Hn(E)).default([]).optional(),
      // resolution component settings (picking between moneyBack, exchange, or storeCredit)
      shouldPrioritizeCredit: N().optional(),
      creditHeadlineText: X.optionalizedString,
      creditDetailText: X.optionalizedString,
      // exchange of exchange, where the credit owed is not final until review
      originatingOrderCreditTitleText: X.optionalizedString,
      originatingOrderCreditDetailText: X.optionalizedString,
      // order editing
      orderEditDescriptionText: X.optionalizedString,
      orderEditExpiredDescriptionText: X.optionalizedString,
      customCss: X.optionalizedString
    }), t.defaultStoreUiTheme = {
      merchantPrimaryColor: "#000000",
      merchantLogoUrl: "https://cdn.corso.com/img/crew-ui-corso-logo.svg",
      merchantBackgroundUrl: null,
      merchantFaviconUrl: "https://cdn.corso.com/img/crew-ui-corso-logo.svg",
      footerText: ""
    };
  })(e.StoreUiConfig || (e.StoreUiConfig = {})), (function(t) {
    t.giftCardAttributes = y({
      message: X.nullifiedString,
      templateSuffix: X.nullifiedString
    }), t.frontReportTags = O(y({
      name: p(),
      id: p(),
      description: p().optional().nullable()
    })), t.orderEditingWindowOverride = y({
      label: X.nullifiedString,
      // null defers to the store's timezone; without either the override can't be placed in a week
      ianaTimezone: Ao(p().refine((n) => Intl.supportedValuesOf("timeZone").includes(n), "Must be a valid IANA timezone")),
      // ! min(1) rather than nonempty() so the inferred type stays number[] instead of a tuple
      daysOfWeek: O(w().int().min(0).max(6)).min(1, "Select at least one day"),
      // 0 = Sunday
      startMinuteOfDay: w().int().min(0).max(1439),
      endMinuteOfDay: w().int().min(1).max(1440),
      windowMinutes: w().int().min(0)
    }).refine(({ startMinuteOfDay: n, endMinuteOfDay: r }) => r > n, {
      message: "End time must be after start time",
      path: ["endMinuteOfDay"]
    }), t.orderEditingWindowOverrides = O(t.orderEditingWindowOverride);
  })(e.StoreSettings || (e.StoreSettings = {})), (function(t) {
    t.selectedOptionsSchema = O(y({ name: p(), value: p() }));
  })(e.StoreOrderLineItem || (e.StoreOrderLineItem = {})), (function(t) {
    t.filtersSchema = DK;
  })(e.StoreUiView || (e.StoreUiView = {})), (function(t) {
    t.customInstructionsSchema = y({
      fileUrl: Cn().optional(),
      fileUrlCta: p().optional(),
      parcelName: p().optional()
    });
  })(e.ClaimLineItemShipment || (e.ClaimLineItemShipment = {})), (function(t) {
    t.variantExchangeLineItemSchema = zi.partial().extend({
      idFromPlatform: zi.shape.idFromPlatform,
      price: zi.shape.price,
      quantity: zi.shape.quantity
    }), t.replacementOrderLineItems = y({
      replacementItems: O(t.variantExchangeLineItemSchema)
    }), t.exchangeRecommendationSchema = H0;
  })(e.ClaimLineItem || (e.ClaimLineItem = {})), (function(t) {
    t.options = O(y({ name: p(), position: w() }));
  })(e.StoreProduct || (e.StoreProduct = {})), (function(t) {
    t.replacementItemSchema = y({
      // entries written before merchants could manage these have no id; readers
      // fall back to idFromPlatform so the older rows stay addressable
      id: p().optional(),
      name: p().nullish(),
      sku: p().nullish(),
      idFromPlatform: p(),
      price: w().nullish(),
      quantity: w(),
      imgUrl: p().nullish(),
      tax: Ps(),
      options: O(y({ name: p(), value: p() })).optional()
    }), t.replacementItemDbSchema = y({
      items: O(t.replacementItemSchema)
    }), t.riskAssessmentSchema = t5;
  })(e.ShipProtectClaim || (e.ShipProtectClaim = {})), (function(t) {
    t.selectedOptionsAsRecord = nu(p(), p()), t.selectedOptionsAsNameValue = O(y({ name: p(), value: p() }));
  })(e.StoreProductVariant || (e.StoreProductVariant = {})), (function(t) {
    t.widgetConfigSchema = BZ;
  })(e.StoreShipProtectSettings || (e.StoreShipProtectSettings = {})), (function(t) {
    t.claimRiskAssessmentSchema = g8, t.calculationSchema = gX, t.calculationInputSchema = Y8, t.calculationResultSchema = Z8;
  })(e.Claim || (e.Claim = {})), (function(t) {
    t.filters = hl, t.jsonDefinition = pl;
  })(e.StoreDataExportDefinition || (e.StoreDataExportDefinition = {})), (function(t) {
    const n = y({
      "5_minutes": w(),
      "1_hour": w(),
      "24_hours": w()
    }).nullish();
    t.fingerprintEventRawSchema = y({
      event_id: p(),
      timestamp: w().nullish(),
      environment_id: p().nullish(),
      sdk: y({ platform: p(), version: p() }).nullish(),
      replayed: N().nullish(),
      identification: y({
        visitor_id: p().nullish(),
        confidence: y({ score: w(), version: p() }).nullish(),
        visitor_found: N().nullish(),
        first_seen_at: w().nullish(),
        last_seen_at: w().nullish()
      }).nullish(),
      url: p().nullish(),
      ip_address: p().nullish(),
      user_agent: p().nullish(),
      browser_details: y({
        browser_name: p().nullish(),
        browser_major_version: p().nullish(),
        browser_full_version: p().nullish(),
        os: p().nullish(),
        os_version: p().nullish(),
        device: p().nullish()
      }).nullish(),
      bot: ne(["not_detected", "good", "bad"]).nullish(),
      bot_info: y({
        name: p().nullish(),
        confidence: p().nullish()
      }).nullish(),
      developer_tools: N().nullish(),
      ip_blocklist: y({
        email_spam: N().nullish(),
        attack_source: N().nullish(),
        tor_node: N().nullish()
      }).nullish(),
      ip_info: y({
        v4: y({
          address: p().nullish(),
          geolocation: y({
            accuracy_radius: w().nullish(),
            latitude: w().nullish(),
            longitude: w().nullish(),
            postal_code: p().nullish(),
            timezone: p().nullish(),
            city_name: p().nullish(),
            country_code: p().nullish(),
            country_name: p().nullish(),
            continent_code: p().nullish(),
            continent_name: p().nullish(),
            subdivisions: O(y({
              iso_code: p().nullish(),
              name: p().nullish()
            })).nullish()
          }),
          asn: p().nullish(),
          asn_name: p().nullish(),
          asn_network: p().nullish(),
          datacenter_result: N(),
          datacenter_name: p().nullish()
        })
      }).nullish(),
      proxy: N().nullish(),
      proxy_confidence: p().nullish(),
      incognito: N().nullish(),
      privacy_settings: N().nullish(),
      suspect_score: w().nullish(),
      tampering: N().nullish(),
      tampering_details: y({
        anomaly_score: w().nullish(),
        anti_detect_browser: N().nullish()
      }).nullish(),
      velocity: y({
        distinct_ip: n,
        distinct_country: n,
        events: n,
        ip_events: n,
        // only populated when the client passes a linkedId
        distinct_linked_id: n,
        distinct_ip_by_linked_id: n,
        distinct_visitor_id_by_linked_id: n
      }).nullish(),
      high_activity_device: N().nullish(),
      virtual_machine: N().nullish(),
      vpn: N().nullish(),
      vpn_confidence: p().nullish(),
      vpn_origin_country: p().nullish(),
      vpn_origin_timezone: p().nullish(),
      vpn_methods: y({
        timezone_mismatch: N().nullish(),
        public_vpn: N().nullish(),
        auxiliary_mobile: N().nullish(),
        os_mismatch: N().nullish(),
        relay: N().nullish()
      }).nullish()
    }).passthrough();
  })(e.ClaimRiskEvent || (e.ClaimRiskEvent = {})), (function(t) {
    const n = y({
      avgResponseTimeMinutes: w().default(0),
      totalCsatScoresCollected: w().default(0),
      messagesSent: w().default(0),
      messagesReceived: w().default(0),
      csatScorePercent: w().default(0),
      newConversations: w().default(0)
    }), r = y({
      rating: w(),
      comment: p(),
      customerName: p(),
      standoutScore: w().default(0)
    });
    t.reportRawSchema = y({
      id: p(),
      month: p(),
      year: p(),
      fromDate: p(),
      toDate: p(),
      metrics: n,
      reviews: O(r)
    });
  })(e.FrontReport || (e.FrontReport = {})), (function(t) {
    t.jsonDefinition = Z0;
  })(e.StoreDiscountDefinition || (e.StoreDiscountDefinition = {})), (function(t) {
    t.referenceImagesSchema = X8;
  })(e.CustomField || (e.CustomField = {})), (function(t) {
    t.trackingInfo = O(y({
      trackingInfoNumber: p(),
      trackingInfoUrl: p().nullish(),
      trackingInfoCompany: p().nullish()
    }));
  })(e.StoreOrderFulfillment || (e.StoreOrderFulfillment = {})), (function(t) {
    t.fulfillmentOrders = O(p());
  })(e.StoreOrderEditFulfillmentHold || (e.StoreOrderEditFulfillmentHold = {})), (function(t) {
    const n = y({ amount: p(), currencyCode: p() }), r = {
      UPDATE_SHIPPING_ADDRESS: tc.options[1].shape.stagedEdits,
      MODIFY_QUANTITY: tc.options[3].shape.stagedEdits,
      UPDATE_SHIPPING_LINE: tc.options[5].shape.stagedEdits,
      ADD_DISCOUNT_CODE: tc.options[6].shape.stagedEdits
    };
    t.detail = {
      [D.OrderEditType.CANCEL_ORDER]: y({
        isCancelled: N(),
        restocked: N(),
        wasCustomerNotified: N()
      }),
      [D.OrderEditType.UPDATE_SHIPPING_ADDRESS]: r.UPDATE_SHIPPING_ADDRESS.extend({
        cancelledOriginal: N().optional(),
        recreatedOrderIdFromPlatform: p().optional()
      }),
      [D.OrderEditType.REMOVE_PACKAGE_PROTECTION]: y({
        success: N()
      }),
      [D.OrderEditType.MODIFY_QUANTITY]: r.MODIFY_QUANTITY.extend({
        success: N(),
        refundedAmount: n.nullish(),
        additionalPaymentCollectionUrl: X.optionalizedString
      }),
      [D.OrderEditType.UPDATE_EMAIL]: y({
        previousEmail: Ki().nullable(),
        newEmail: Ki()
      }),
      [D.OrderEditType.UPDATE_SHIPPING_LINE]: r.UPDATE_SHIPPING_LINE.extend({
        refundedAmount: n.nullish(),
        additionalPaymentCollectionUrl: X.optionalizedString,
        previousShippingLine: r.UPDATE_SHIPPING_LINE.shape.previousShippingLine.optional()
      }),
      [D.OrderEditType.ADD_DISCOUNT_CODE]: r.ADD_DISCOUNT_CODE.extend({
        success: N(),
        refundedAmount: n.nullish(),
        abandonedOn: p().nullish()
      })
    };
  })(e.StoreOrderAppliedEdit || (e.StoreOrderAppliedEdit = {}));
})(qn || (qn = {}));
const X0 = y({
  isExtendedAuthAllowed: N(),
  idFromPlatform: p(),
  // account_id
  id: w()
}), xX = y({
  storeId: w(),
  storeSlug: p(),
  storeUrl: p().optional(),
  storeName: p().optional(),
  storefrontId: p(),
  isActive: N(),
  exchangeOrderPrefix: p().optional(),
  isClaimImageFromCustomerRequired: N(),
  /** parsed, so the UI always receives every flag with its default */
  featureFlags: qn.Store.featureFlags,
  stripeConfig: X0.optional(),
  localizeKey: p().optional(),
  registrations: y({
    isEnabled: N(),
    isAutomatedRegistrationEnabled: N(),
    shouldCollectProofOfPurchase: N(),
    shouldCollectAddress: N(),
    emailMarketingConsentPolicyUrl: p().optional(),
    shouldCollectRegistrationEmailMarketingConsent: N(),
    isStartWarrantyClaimEnabled: N(),
    customFields: K0,
    storeSalesChannels: O(y({
      id: w(),
      name: p()
    }))
  }),
  orderEditing: y({
    isEnabled: N(),
    /** When true, customer refunds from order edits are issued as store credit instead of returning to original payment. */
    useStoreCreditRefund: N()
  }),
  tracking: y({
    isEnabled: N()
  }),
  warranty: y({
    isEnabled: N()
  }),
  return: y({
    isEnabled: N(),
    isGiftReturnEnabled: N(),
    isGiftCardEnabled: N(),
    isExchangeEnabled: N(),
    isRefundEnabled: N(),
    isClaimLineageEnabled: N()
  }),
  theme: qn.StoreUiConfig.customerUiConfigSchema
}), CX = $e(Ro), J0 = y({
  id: w(),
  name: p(),
  isDeleted: N()
  // soft delete, will not show in UI but retained for historical purposes
}), c5 = J0.omit({ id: !0 }).merge(y({ id: w().optional() })), wX = J0.omit({
  id: !0,
  isDeleted: !0
}), ja = y({
  id: w(),
  name: X.nonEmptyString,
  isDeleted: N(),
  // soft delete, will not show in UI but retained for historical purposes
  claimReasonDetails: O(J0),
  category: y({
    code: CX,
    name: p()
  })
}), EX = ja.omit({
  category: !0,
  claimReasonDetails: !0
}).merge(y({ claimReasonDetails: O(c5) })), IX = ja.omit({
  id: !0,
  claimReasonDetails: !0,
  isDeleted: !0
}).merge(y({ claimReasonDetails: O(wX) })), Q0 = y({
  id: w(),
  claimType: $e(nm),
  name: X.nonEmptyString,
  isDefault: N(),
  storeProductGroup: Js.optional(),
  claimReasons: O(ja).min(1, "At least one claim reason is required.")
}), RX = Q0.pick({
  id: !0,
  claimReasons: !0,
  isDefault: !0,
  storeProductGroup: !0,
  name: !0,
  claimType: !0
}), TX = Q0.omit({
  id: !0,
  storeProductGroup: !0
}).merge(y({ storeProductGroup: Js })), ev = y({
  id: w(),
  // id on store inspection classification
  name: p(),
  // name on store inspection classification
  // code on the inspection classification
  inspectionGradeCode: $e(to)
}), _X = ev.pick({
  id: !0
}), u5 = y({
  name: p(),
  customFields: K0,
  inspectionInstructions: X.optionalizedString,
  shouldCollectInspectionGrade: N(),
  showInspectionComment: N(),
  showInspectionMediaUpload: N()
}), OX = y({
  inspectionGrades: O(ev),
  templates: O(u5)
}), kd = {
  exact: "exact",
  ambiguous: "ambiguous",
  unresolved: "unresolved"
}, la = y({
  id: w(),
  exchangeLineItemIdFromPlatform: p().optional(),
  // the id of the line item on the platform
  idFromPlatform: p(),
  isCorsoProduct: N(),
  // the name on the storeOrderLineItem (typically refers to the product name including the variant options)
  productIdFromPlatform: p(),
  variantIdFromPlatform: p().nullable(),
  // ? ideally someday maybe this isn't nullable, for now this will work fine
  name: p().nullable(),
  optionsFromPlatform: O(y({ name: p(), value: p() })),
  // the quantity of the line item
  currentQuantity: w(),
  quantity: w(),
  // the ACTUAL price paid for a single quantity of the line item, inclusive of discounts
  // essentially represents the "unit" price of the line item for a single quantity
  unitPrice: w(),
  unitListPrice: w().optional(),
  // the price of the line item before any discounts were applied
  unitTax: w(),
  // the amount of tax paid for a single quantity of the line item
  /**
   * Only on a $0 line of an exchange order under claim lineage: how confidently `unitPrice` and
   * `unitTax` were traced back to the order the customer paid on. `exact` means they were replaced
   * with the paid values; anything else leaves the line at $0.
   */
  exchangeValueTrace: ne(kd).optional(),
  imgUrl: p().nullable(),
  fulfillmentServiceName: p().optional(),
  sku: p().optional(),
  grams: w(),
  barcode: p().optional()
}), d5 = y({
  id: w(),
  displayName: p(),
  amount: w().nonnegative(),
  storeRuleId: w().optional(),
  storeRuleName: p().optional()
}), AX = y({
  amount: w().nonnegative()
}), f5 = y({
  id: w(),
  url: p()
}), kX = f5.omit({
  id: !0,
  url: !0
}).merge(y({ filename: p() })), tv = y({
  id: w(),
  createdOn: p(),
  name: p(),
  comment: X.nullifiedString.optional(),
  images: O(f5),
  customFields: O(au),
  storeInspectionGrade: ev.optional()
}), DX = tv.omit({
  id: !0,
  images: !0,
  storeInspectionGrade: !0,
  customFields: !0,
  createdOn: !0
}).merge(y({
  storeInspectionGrade: _X.optional(),
  images: O(kX).optional(),
  customFields: O(y({ id: w(), value: p() }))
})), { variantExchangeLineItemSchema: Ba } = qn.ClaimLineItem, PX = Ba.pick({
  idFromPlatform: !0,
  quantity: !0
}).extend({
  price: Ee().default(0)
}), ca = y({
  id: w(),
  finalizedOn: p().nullable(),
  canceledOn: p().optional(),
  wasOutsideEligibilityWindow: N().optional(),
  deniedOn: p().optional(),
  returnLineItemIdFromPlatform: p().nullable(),
  wasResolvedExternally: N().optional(),
  suggestedWarrantyReplacementItem: lm.optional(),
  // ! all line item claims
  noteToCustomer: p().optional(),
  errors: O(p()).optional(),
  fees: O(d5).optional(),
  requestedResolutionMethodEnum: Hn(rt),
  resolutionMethodEnum: Hn(rt).optional(),
  inspections: O(tv),
  /**
   * @deprecated use media
   */
  images: O(p()).optional(),
  media: O(y({
    url: p(),
    // id on relationship
    claimLineItemImageId: w(),
    filename: p()
  })).optional(),
  comments: p().nullable(),
  // ? noteFromCustomer
  originalStoreOrderLineItemId: w(),
  originalStoreOrderLineItem: la,
  deductedAmount: w().optional(),
  exchangeDeltaAmount: w().optional(),
  isShopNow: N().optional(),
  // * is this a shop now claim
  outstandingAmountFinalizedOn: p().optional(),
  exchangeRecommendation: H0.optional(),
  wasExchangeRecommendationAccepted: N().optional(),
  variantExchangeAmountResolutionMethodEnum: Hn(rm).optional(),
  status: y({
    id: w(),
    name: p(),
    code: $e(Qn),
    detail: y({
      id: w(),
      name: p(),
      code: $e(wt)
    })
  }),
  customFields: O(au),
  reason: y({
    id: w(),
    name: p(),
    category: ja.shape.category,
    detail: y({
      id: w(),
      name: p()
    }).optional()
    // ! detail will always remain optional on the reason as it's not required
  }),
  updatedOn: p().optional(),
  createdOn: p(),
  // ! Variant Exchange Line Item Claims
  variantExchangeLineItem: Ba.optional(),
  // resolved from the catalog at finalization; the exchange snapshot itself has no product id
  exchangeToProductIdFromPlatform: p().optional(),
  replacementItems: O(Ba).optional(),
  // ! Monetary Claims (Refund, Gift Card)
  quantity: w(),
  unitPrice: w(),
  unitTax: w(),
  amount: w().optional(),
  // issued monetary value of the claim line item applies to refunds and gift cards
  requestedAmount: w().optional()
  // requested monetary value of the claim line item applies to refunds and gift cards
}), cm = ca.pick({
  comments: !0,
  originalStoreOrderLineItemId: !0,
  quantity: !0,
  unitPrice: !0,
  unitTax: !0,
  requestedResolutionMethodEnum: !0,
  images: !0,
  exchangeDeltaAmount: !0,
  variantExchangeAmountResolutionMethodEnum: !0,
  replacementItems: !0,
  exchangeRecommendation: !0,
  wasExchangeRecommendationAccepted: !0,
  wasOutsideEligibilityWindow: !0
}).merge(y({
  variantExchangeLineItem: Ba.pick({
    idFromPlatform: !0,
    quantity: !0,
    price: !0,
    imgUrl: !0,
    options: !0,
    title: !0
  }).optional(),
  customFields: O(e5).optional(),
  reasonId: w(),
  reasonDetailId: w().optional(),
  reasonCategoryCode: $e(Ro),
  advancedExchangeMethod: D.advancedExchangeMethodUnion.optional(),
  fees: O(d5.omit({
    id: !0
  })).optional()
})), um = cm.extend({
  id: p(),
  grams: Ee(),
  originalStoreOrderLineItem: la.pick({
    name: !0,
    optionsFromPlatform: !0,
    imgUrl: !0
  }).extend({
    idFromPlatform: p().nullable()
  })
}), m5 = um.pick({
  id: !0,
  quantity: !0,
  unitPrice: !0,
  unitTax: !0,
  requestedResolutionMethodEnum: !0
}).merge(la.pick({
  name: !0,
  imgUrl: !0,
  optionsFromPlatform: !0
})), NX = m5.pick({
  id: !0
}).merge(cm.pick({
  variantExchangeAmountResolutionMethodEnum: !0,
  exchangeDeltaAmount: !0
})).merge(y({
  requestedResolutionMethodEnum: ne([
    rt.variantExchange,
    rt.giftCard,
    rt.refund,
    rt.other,
    rt.warrantyReview,
    rt.replacementOrder
  ])
})), Ju = y({
  wasResolvedExternally: N().default(!1)
}), MX = y({
  variantExchangeLineItem: PX,
  resolutionMethod: P(`${rt.variantExchange}`)
}), FX = y({
  resolutionMethod: P(`${rt.repair}`)
}), p5 = y({ amount: w() }), LX = y({
  resolutionMethod: P(`${rt.refund}`)
}).merge(p5), $X = y({
  resolutionMethod: P(`${rt.giftCard}`)
}).merge(p5), zX = y({
  resolutionMethod: P(`${rt.replacementOrder}`)
}).merge(qn.ClaimLineItem.replacementOrderLineItems), jX = ke("resolutionMethod", [
  MX.merge(Ju),
  LX.merge(Ju),
  $X.merge(Ju),
  zX.merge(Ju),
  FX
]), BX = y({
  // ? these values come from the claim status helper... should we use the enum here?
  claimStatusDetailCode: We([
    P(`${wt.wrongItem}`),
    P(`${wt.itemNotReturned}`),
    P(`${wt.noncompliantReturn}`),
    P(`${wt.notCoveredUnderWarranty}`),
    P(`${wt.noActionTaken}`)
  ])
}), GX = y({
  // ? these values come from the claim status helper... should we use the enum here?
  claimStatusDetailCode: We([
    P(`${wt.noActionTaken}`),
    P(`${wt.itemNotReturned}`)
  ])
}), VX = ke("kind", [
  y({
    kind: P("reason"),
    reason: y({
      id: w(),
      detailId: w().nullable()
    })
  }),
  y({
    kind: P("note"),
    noteToCustomer: X.nullifiedString
  }),
  y({
    kind: P("approved"),
    approval: jX
  }),
  y({ kind: P("denied"), denial: BX }),
  y({
    // american english spelling around cancel uses one l as a verb, 'canceled', and but two l's as a noun, 'cancellation'
    kind: P("canceled"),
    cancellation: GX
  })
]), Qs = ca.pick({
  id: !0,
  noteToCustomer: !0,
  errors: !0,
  quantity: !0,
  returnLineItemIdFromPlatform: !0,
  deductedAmount: !0
}).extend({
  wasZeroedThroughDeduction: N().optional(),
  isPartialExchangeCredit: N().optional()
}), UX = Qs.merge(y({
  claimStatusDetailCode: p()
  // ! note to future us, we should make this use the enum values someday
})), h5 = Qs.merge(y({
  resolutionMethodEnum: P(`${rt.variantExchange}`)
})).merge(ca.pick({
  exchangeDeltaAmount: !0,
  variantExchangeLineItem: !0
}).required()), g5 = Qs.merge(y({
  resolutionMethodEnum: P(`${rt.replacementOrder}`),
  replacementItems: O(Ba)
}).merge(ca.pick({
  isShopNow: !0,
  exchangeDeltaAmount: !0
}).required())), nv = Qs.merge(y({
  amount: w(),
  requestedAmount: w()
})).merge(Qs).required({
  deductedAmount: !0
}), v5 = nv.merge(y({
  resolutionMethodEnum: P(`${rt.giftCard}`)
})), y5 = nv.merge(y({
  resolutionMethodEnum: P(`${rt.refund}`)
})), b5 = nv.merge(y({
  resolutionMethodEnum: P(`${rt.other}`)
})), S5 = Qs.merge(y({
  resolutionMethodEnum: P(`${rt.repair}`)
})), WX = ke("resolutionMethodEnum", [
  y5,
  v5,
  h5,
  g5,
  b5,
  S5
]), G6 = y({
  refunds: O(y5),
  giftCards: O(v5),
  variantExchanges: O(h5),
  replacementOrders: O(g5),
  other: O(b5),
  repairs: O(S5)
}), HX = y({
  claimLineItems: y({
    approved: G6,
    approvedWithExternalResolution: G6.pick({
      refunds: !0,
      giftCards: !0,
      variantExchanges: !0,
      replacementOrders: !0,
      other: !0
    }).optional(),
    denied: O(UX)
  })
}), qX = {
  Customer_App: "Customer_App",
  Merchant_App: "Merchant_App",
  Retool: "Retool",
  Gorgias_Ticket_Widget: "Gorgias_Ticket_Widget",
  Zowie_Inbox_Integration: "Zowie_Inbox_Integration",
  Gladly_Hero_Integration: "Gladly_Hero_Integration",
  Kustomer_App_Integration: "Kustomer_App_Integration",
  Zendesk_App_Integration: "Zendesk_App_Integration",
  Public_API: "Public_API"
}, mf = ne(qX), x5 = {
  Customer_App: "Customer Portal",
  Gladly_Hero_Integration: "Gladly Hero Integration",
  Merchant_App: "Merchant Admin App",
  Gorgias_Ticket_Widget: "Gorgias Ticket Widget",
  Retool: "Corso Concierge Team",
  Zowie_Inbox_Integration: "Zowie Inbox Integration",
  Kustomer_App_Integration: "Kustomer App Integration",
  Zendesk_App_Integration: "Zendesk App Integration",
  Public_API: "Corso Commerce API"
}, C5 = mf.extract([
  "Merchant_App",
  "Kustomer_App_Integration",
  "Zendesk_App_Integration"
]), Ja = y({
  id: p(),
  carrier: p(),
  cost: w(),
  service: p(),
  carrierAccountId: p(),
  currency: p()
}), w5 = y({
  iconImgUrl: p(),
  storeRuleId: w().nullable(),
  returnLocation: y({
    id: w()
  })
}), YX = y({
  type: P(Tr.label),
  provider: We([
    P($o.easyPost),
    P($o.vesyl)
  ]),
  shipmentFromPlatform: y({
    id: p(),
    rate: Ja
  })
}).merge(w5), KX = y({
  type: P(Tr.packingSlip)
}).merge(w5), ZX = {
  "return-bar": "return-bar"
}, XX = y({
  // happy returns' own location id, not always present on their response
  idFromPlatform: p().nullish(),
  name: p(),
  timeZone: p().nullish(),
  hoursMayVary: N().nullish(),
  distance: w().nullish(),
  mapUrl: p().nullish(),
  address: y({
    name: p().nullish(),
    address: p().nullish(),
    address2: p().nullish(),
    city: p().nullish(),
    state: p().nullish(),
    zipcode: p().nullish(),
    countryCode: p().nullish()
  }),
  openingHours: O(y({
    // 1 = Monday ... 7 = Sunday
    dayOfWeek: w().nullish(),
    openingTime: p().nullish(),
    closingTime: p().nullish()
  })).default([]),
  promotions: O(y({
    label: p(),
    value: p()
  })).default([])
}), JX = y({
  type: P(Tr.consolidatedDropoff),
  provider: P($o.happyReturns),
  retailerId: p(),
  idFromPlatform: P(ZX["return-bar"]),
  dropoffLocations: O(XX)
}), QX = y({
  type: P(Tr.label),
  provider: P($o.globalE),
  globalEOrderId: p(),
  globalEShippingMethodId: w(),
  storeRuleId: w().nullable(),
  shipmentFromPlatform: y({
    id: w(),
    rate: Ja.pick({
      cost: !0,
      currency: !0,
      carrier: !0,
      service: !0
    }).extend({
      originalRateCost: w().optional(),
      originalRateCurrency: p().optional()
    })
  }),
  returnLocation: y({
    id: w()
  })
}), dm = We([
  KX,
  QX,
  YX,
  JX
]), eJ = y({
  date: p(),
  message: p(),
  status: $e(Gn),
  location: y({
    city: p().nullable(),
    state: p().nullable(),
    country: p().nullable(),
    zip: p().nullable()
  })
}), E5 = y({
  iconImgUrl: p(),
  name: p(),
  trackingCode: p(),
  trackingUrl: p().nullable()
}), rv = y({
  status: $e(Gn),
  statusDetail: p().optional(),
  idFromPlatform: p(),
  carrier: E5,
  estimatedDeliveryDate: p().nullable(),
  details: O(eJ)
}), tJ = y({
  id: w(),
  fulfillmentId: w(),
  fulfilledFrom: p().nullable(),
  tracker: rv,
  lineItems: O(la.pick({
    id: !0,
    name: !0,
    sku: !0,
    quantity: !0,
    imgUrl: !0,
    optionsFromPlatform: !0
  }))
}), nJ = O(tJ), I5 = y({
  claimId: w(),
  returnShipment: dm
}), rJ = y({
  latestStatus: $e(Gn),
  carrier: E5
}), oJ = y({
  fileUrl: Cn().optional(),
  fileUrlCta: p().optional(),
  parcelName: p().optional()
}), ov = y({
  returnShipmentId: w(),
  createdOn: p(),
  shipmentExpiresOn: p(),
  toAddress: uf,
  fromAddress: uf,
  isReturnShipment: N(),
  customInstructions: oJ.optional(),
  returnShipmentPdfAssetUrl: p().optional(),
  claimLineItems: O(ca)
}), iJ = ov.extend({
  returnShipmentType: P(Tr.packingSlip)
}), aJ = ov.extend({
  returnShipmentType: P(Tr.label),
  provider: ne($o).optional(),
  tracker: rJ.optional(),
  inTransitOn: p().optional(),
  carrierName: p().optional(),
  carrierServiceName: p().optional(),
  carrierTrackingCode: p().optional(),
  qrCodeDetail: y({
    url: p(),
    returnToName: p(),
    carrier: p(),
    carrierIconImgUrl: p()
  }).optional(),
  rmaId: p().optional(),
  rmaNumber: p().optional(),
  rmaProvider: ne(Ei).optional()
}), sJ = ov.pick({
  createdOn: !0,
  returnShipmentId: !0,
  fromAddress: !0,
  shipmentExpiresOn: !0,
  claimLineItems: !0
}).extend({
  returnShipmentType: P(Tr.consolidatedDropoff),
  provider: P($o.happyReturns),
  // ? Happy returns QR code
  returnShipmentPdfAssetUrl: p(),
  consolidatedDropoffCode: p(),
  isReturnShipment: P(!0),
  appleWalletPassUrl: p().optional(),
  googleWalletPassUrl: p().optional()
}), R5 = ke("returnShipmentType", [
  iJ,
  aJ,
  sJ
]);
y({
  id: p().nullable(),
  carrier: p().nullable(),
  cost: w().nullable()
});
const lJ = y({
  fromCustomer: dm.array(),
  toCustomer: Ja.nullable()
}), iv = y({
  toAddressId: w(),
  fromAddressId: w()
}), cJ = iv.merge(y({
  claimId: w(),
  returnShipmentType: P(Tr.label),
  rate: Ja,
  shipmentIdFromPlatform: p()
})), uJ = iv.merge(y({
  claimId: w(),
  returnShipmentType: P(Tr.packingSlip)
})), dJ = y({
  claimId: w(),
  returnShipmentType: P(Tr.consolidatedDropoff)
}), fJ = ke("returnShipmentType", [
  uJ,
  cJ,
  dJ
]), mJ = iv.merge(y({
  weightInOunces: w(),
  parcel: y({
    length: w(),
    width: w(),
    height: w()
  }).optional()
})), pJ = y({
  kind: P("success"),
  shipmentIdFromPlatform: p(),
  rates: O(Ja)
}), hJ = y({
  kind: P("failure"),
  errors: p().array()
}), gJ = ke("kind", [
  y({
    kind: P("EasyPost_Vesyl"),
    toAddressId: w(),
    fromAddressId: w()
  }),
  y({
    kind: P("Global_E"),
    globalEOrderId: p()
  })
]), vJ = ke("kind", [
  pJ,
  hJ
]);
var Og;
(function(e) {
  e.email = "email", e.shipment = "shipment", e.processing = "processing", e.simple = "simple", e.money = "money", e.comment = "comment", e.edit = "edit", e.shopify = "shopify", e.warning = "warning", e.ai = "ai";
})(Og || (Og = {}));
const yJ = y({
  kind: P("text"),
  label: p(),
  value: p()
}), bJ = y({
  kind: P("money"),
  label: p(),
  amount: w()
}), SJ = y({
  kind: P("date"),
  label: p(),
  date: ru()
}), xJ = y({
  kind: P("link"),
  label: p(),
  url: Cn(),
  urlLabel: p()
}), T5 = y({
  email: p(),
  firstName: p().nullish(),
  lastName: p().nullish(),
  id: w()
}), _5 = y({
  id: p().uuid(),
  datetime: p(),
  message: p(),
  type: $e(Og),
  subject: p().optional(),
  user: T5.optional(),
  meta: O(ke("kind", [yJ, bJ, SJ, xJ])).optional()
}), av = O(_5), V6 = _5, Ag = av, ki = y({
  id: w(),
  name: p()
});
ki.omit({ id: !0 });
const O5 = la.pick({
  id: !0,
  idFromPlatform: !0,
  variantIdFromPlatform: !0,
  imgUrl: !0,
  name: !0,
  quantity: !0,
  unitPrice: !0,
  unitTax: !0,
  sku: !0,
  optionsFromPlatform: !0
}), A5 = y({
  id: w(),
  amount: w(),
  shippingFee: w(),
  handlingFee: w(),
  createdOn: p(),
  isRefundPending: N(),
  wasResolvedExternally: N()
}), k5 = y({
  id: w(),
  idFromPlatform: p(),
  orderNameFromPlatform: p(),
  createdOn: p(),
  lineItems: O(O5),
  platformAdminUrl: p(),
  wasResolvedExternally: N(),
  isOriginalOrder: N(),
  wasShopNow: N().optional()
}), CJ = y({
  refunds: O(A5),
  //! crewClaimGiftCard table
  giftCards: O(y({
    id: w(),
    amount: w(),
    incentiveAmount: w(),
    createdOn: p(),
    platformAdminUrl: p().optional(),
    orderNameFromPlatform: p().optional(),
    wasResolvedExternally: N(),
    type: We([
      P("Gift_Card"),
      P("Gift_Card_Order"),
      P("Store_Credit")
    ]).optional()
  })),
  //! crewClaimExchangeOrder table
  exchangeOrders: O(k5.extend({
    lineItems: O(O5.extend({
      productIdFromPlatform: p().optional(),
      // a line can fulfill several claim line items when they exchange into the same variant
      claimLineItemIds: O(w())
    }))
  }))
}), wJ = y({
  refund: A5.optional(),
  // `id` is the reorder row, so the store order is carried separately for tracking lookups
  exchangeOrder: k5.extend({ storeOrderId: w() }).optional()
}), sv = y({
  id: w(),
  idFromPlatform: p(),
  amount: w(),
  // ! non refundable amount (IE, fees, shipping, etc.)
  // only recorded for refunds issued after the column existed; older refunds are assumed to be the whole capture
  refundedAmount: w().optional(),
  note: p().optional(),
  currencyCode: p(),
  status: H8,
  authorizationExpiresOn: p().nullable(),
  capturedOn: p().nullable()
}), EJ = y({
  idFromPlatform: p(),
  amount: w(),
  // ! non refundable amount (IE, fees, shipping, etc.)
  authorizedAmount: w().optional(),
  // ! refundable amount (IE, anything that is not a fee, the value of the instant exchange)
  currencyCode: p()
}).merge(y({ stripeConfig: X0 })), IJ = y({
  totals: y({
    giftCard: w(),
    refund: w()
  })
}).merge(y({
  approvedLineItems: O(ca.pick({
    id: !0,
    quantity: !0,
    amount: !0,
    resolutionMethodEnum: !0
  }).extend({
    estimatedAmount: w().optional(),
    wasZeroedThroughDeduction: N().optional()
  }))
})), ua = y({
  id: w(),
  isGiftReturn: N().optional(),
  customerId: w().optional(),
  resolutionSummary: CJ.optional(),
  // TODO make non-optional
  externalId: p(),
  linkToCustomerUi: p().optional(),
  returnIdFromPlatform: p().nullable(),
  source: mf.optional(),
  // ? Since everything is assumed store, this is also assumed store
  currencyCode: ne(V),
  // todo: consolidate with order.ts storeOrderClaim
  originalStoreOrder: y({
    id: w(),
    idFromPlatform: p(),
    customerIdFromPlatform: p().optional(),
    orderNo: p().optional(),
    orderNumber: p().optional(),
    currencyCode: p(),
    createdOn: p(),
    platformAdminUrl: p().optional(),
    customerCurrencyConversionRate: w().optional(),
    wasCreatedFromRegistration: N(),
    isExchangeOfExchange: N(),
    taxRate: w().optional(),
    customerEmail: p().optional(),
    shippingAddress: Xi.optional(),
    registration: y({
      id: w(),
      externalId: p(),
      proofOfPurchaseFileUrls: O(p()),
      registrationChannel: p().optional()
    }).optional()
  }),
  // whether or not the original order was modified, by the addition of one or more new line items
  // related to the new exchange functionality
  wasOriginalOrderModified: N(),
  isInstantExchange: N(),
  noteToCustomer: X.optionalizedString,
  customerEmail: p(),
  /**
   * @deprecated used customer.firstName + customer.lastName
   */
  customerName: p().optional(),
  customer: y({
    firstName: p().optional(),
    lastName: p().optional()
  }).optional(),
  shippingAddress: Wr,
  billingAddress: Wr,
  claimRollup: y({
    name: p(),
    code: $e($s)
  }),
  timeline: Ag.optional(),
  // * total fee amount applied to the claim, to be used on a new order or deducted from a refund
  //* optional handling fee for refunds
  feeApplied: w(),
  feeName: p().optional(),
  returnShippingAmountApplied: w(),
  exchangeOrderShippingAmountApplied: w(),
  // ! this can be deducted from a refund // or collected with stripe
  // * gift card  incentive offered
  giftCardIncentiveAmountApplied: w(),
  // * conditional shipping amount charged based on store_setting of orderValueThresholdForFreeShipping applies to NEW ORDER (variant_exchange)
  shopNowIncentiveAmountApplied: w().optional(),
  // * incentive amount applied to the claim, to be used on a new order
  // how credit goes back to the customer when a line does not say; absent on claims created before it was recorded
  aggregateCreditResolutionMethod: ne(rm).optional(),
  customerPayment: sv.optional(),
  // ? rename to claimTypeEnum to be consistent with other enum names
  claimType: $e(nm),
  claimLineItems: O(ca),
  //* claim return shipments are associated with a line_item, adding them here elevates the concept that a claim can have multiple shipments spread across N number of line items
  //* for all intents and purposes the length of this array should be 1, until we build out the ability to split out line items into separate return shipments
  claimReturnShipments: O(R5),
  globalEOrderId: p().optional(),
  createdOn: p(),
  updatedOn: p().optional(),
  finalizedOn: p().optional(),
  requestSummary: IJ.optional(),
  tags: O(p()).optional()
}), pf = ua.pick({
  id: !0,
  externalId: !0,
  createdOn: !0,
  customerEmail: !0,
  claimType: !0
}).merge(y({
  claimRollupStatusCode: $e($s),
  customerName: p(),
  resolutionMethods: O($e(rt)),
  lineItemHasError: N(),
  tags: p().array(),
  storeId: w(),
  storeName: p()
})), lv = O(pf), RJ = y({ count: w() }), D5 = ua.omit({
  claimReturnShipments: !0,
  id: !0,
  globalEOrderId: !0,
  isInstantExchange: !0,
  externalId: !0,
  updatedOn: !0,
  createdOn: !0,
  claimLineItems: !0,
  claimRollup: !0,
  originalStoreOrder: !0,
  noteToCustomer: !0,
  timeline: !0,
  customerPayment: !0,
  returnIdFromPlatform: !0,
  shippingAddress: !0,
  billingAddress: !0,
  wasOriginalOrderModified: !0,
  requestSummary: !0,
  resolutionSummary: !0,
  currencyCode: !0
}).merge(y({
  /** @deprecated Need to unify claim source schemas. */
  // TODO unify claim source schemas
  source: We([
    P("Customer_App"),
    P("Merchant_App"),
    P("Kustomer_App_Integration"),
    P("Zendesk_App_Integration")
  ]),
  originalStoreOrderId: w(),
  claimLineItems: O(cm).min(1),
  customerPayment: EJ.optional(),
  shippingAddress: Tg,
  billingAddress: Tg.optional(),
  fingerprint: v8.optional(),
  shipment: I5.shape.returnShipment.optional(),
  shopNowId: p().optional()
})), TJ = ua.pick({
  id: !0,
  shippingAddress: !0,
  customerEmail: !0
}), _J = ua.pick({
  feeApplied: !0,
  returnShippingAmountApplied: !0,
  exchangeOrderShippingAmountApplied: !0
}), fm = y({
  emailType: $e(cf),
  subject: p(),
  header: p(),
  body: p()
}), P5 = ua.pick({
  id: !0,
  noteToCustomer: !0,
  giftCardIncentiveAmountApplied: !0,
  feeApplied: !0,
  returnShippingAmountApplied: !0,
  billingAddress: !0,
  shippingAddress: !0,
  customerEmail: !0,
  externalId: !0,
  exchangeOrderShippingAmountApplied: !0,
  originalStoreOrder: !0,
  claimType: !0,
  createdOn: !0,
  returnIdFromPlatform: !0,
  wasOriginalOrderModified: !0,
  globalEOrderId: !0,
  tags: !0
}).extend({
  claimLineItems: HX.shape.claimLineItems
}), N5 = y({
  notifyCustomerByEmail: fm.optional(),
  originOrder: y({
    idFromPlatform: p(),
    name: p().nullable()
  }).optional(),
  claim: P5,
  /** @deprecated Need to unify claim source schemas. */
  // TODO unify claim source schemas
  finalizationSource: We([
    P("Merchant_App"),
    P("Kustomer_App_Integration"),
    P("Zendesk_App_Integration")
  ])
}), OJ = y({
  notifyCustomerByEmail: fm,
  claim: P5.pick({
    shippingAddress: !0,
    externalId: !0,
    customerEmail: !0,
    id: !0
  })
}), AJ = y({
  id: w(),
  idFromPlatform: p(),
  currencyCode: p(),
  createdOn: p(),
  customerCurrencyConversionRate: w().optional(),
  platformAdminUrl: p().optional(),
  orderNo: p(),
  shippingTitle: X.optionalizedString,
  shippingAddress: Wr.optional(),
  orderTotal: w().optional(),
  shippingPrice: w().optional(),
  wasShippingProtected: N(),
  tags: O(p()).optional(),
  isGlobalE: N()
}), kJ = y({
  finalizationSource: C5,
  useGiftCard: N(),
  reorderShippingTitle: p().optional()
}), DJ = VK.nullable(), PJ = O(y({
  idFromPlatform: p(),
  quantity: Ee().int().positive()
})), kg = y({
  quantity: w(),
  unitPrice: w().nullable(),
  sku: p().nullable(),
  name: p().nullable(),
  imgUrl: p().nullish(),
  optionsFromPlatform: O(y({ name: p(), value: p() }))
}), NJ = ke("kind", [
  kg.extend({
    kind: P("line_item"),
    id: w(),
    storeOrderLineItemId: w(),
    tags: O($e(yK))
  }),
  kg.extend({
    kind: P("replacement_item"),
    id: p()
  })
]), MJ = y({
  status: $e(jr),
  resolutionMethod: $e(Zi)
}), FJ = Tg, U6 = y({
  quantityNeeded: w(),
  inventoryExists: N(),
  locations: O(y({
    quantity: w(),
    isAvailable: N(),
    locationName: p()
  }))
}), LJ = ke("kind", [
  U6.extend({
    kind: P("line_item"),
    id: w()
  }),
  U6.extend({
    kind: P("replacement_item"),
    id: p()
  })
]), $J = O(LJ), M5 = y({
  id: w(),
  createdOn: p(),
  storeContacts: O(y({
    email: p(),
    name: p()
  })),
  hasBeenInvoiced: N(),
  financialSummary: y({
    // ? the total value of the claim as we see it, eg the cost of the line items.
    totalValue: w(),
    // ? the up to date estimate of what Shopify indicates can be refunded against the order, (useful to see / understand)
    // omitted when the platform could not be reached, so it reads as unknown rather than zero
    refundableAmount: w().optional(),
    // order contains chargeback
    hasChargeback: N()
  }),
  noteFromCustomer: p().optional(),
  noteFromMerchant: p().optional(),
  linkToCustomerUi: p().optional(),
  resolutionSummary: wJ.optional(),
  resolvedOn: p().nullable(),
  customerId: w().optional(),
  resolvedIn: mf.optional(),
  source: mf.optional(),
  reason: $e(Xt),
  status: $e(jr),
  resolutionMethod: $e(Zi),
  shippingAddress: Wr.optional(),
  images: O(p()).optional(),
  // ? in the shipping claim sense this represents the original order and the claimed lineItems
  originalStoreOrder: AJ,
  customerName: p().nullable(),
  customerEmail: p().nullable(),
  shippingClaimLineItems: O(NJ),
  // lines taken off the claim since it was filed; display only, never totalled
  removedLineItems: O(kg.extend({ id: w() })),
  timeline: av.optional()
}), mm = y({
  id: w(),
  createdOn: p(),
  noteFromCustomer: X.optionalizedString,
  reason: $e(Xt),
  status: $e(jr),
  shippingAddress: Wr.optional(),
  originalStoreOrder: y({
    id: Ee(),
    lineItems: O(y({
      id: Ee(),
      quantity: Ee()
    }))
  })
}), zJ = mm.pick({
  reason: !0,
  noteFromCustomer: !0,
  originalStoreOrder: !0,
  shippingAddress: !0
}).merge(y({
  images: O(p()).optional(),
  fingerprint: v8.optional()
})), F5 = mm.pick({
  reason: !0,
  noteFromCustomer: !0,
  shippingAddress: !0,
  originalStoreOrder: !0
}).merge(y({
  resolutionMethod: $e(Zi),
  notifyCustomer: N().optional(),
  noteFromMerchant: X.optionalizedString,
  source: C5.optional()
})), L5 = M5.pick({
  id: !0,
  status: !0,
  reason: !0,
  resolutionMethod: !0,
  createdOn: !0,
  customerName: !0,
  customerEmail: !0
}).extend({
  storeId: w(),
  storeName: p(),
  tags: p().array()
}), pm = O(L5);
y({
  // a term searches OpenSearch across the platform instead of listing; the other filters don't apply
  searchTerm: X.optionalizedString,
  // a start date keeps every query inside an index range of `created_on`
  createdOn: Xa.refine((e) => e.kind === "preset" || e.range.start !== null, "A custom date range needs a start date"),
  statuses: O($e(jr)).min(1).optional(),
  claimReasons: O($e(Xt)).min(1).optional(),
  resolutionMethods: O($e(Zi)).min(1).optional(),
  orderBy: ne(["asc", "desc"]),
  cursor: y({ id: w(), direction: ne(["next", "prev"]) }).nullable()
});
y({ data: pm, pageInfo: Jo });
const jJ = {
  Returns: "Returns",
  Warranties: "Warranties",
  Registrations: "Registrations",
  ShippingProtection: "Shipping Protection",
  Tracking: "Tracking"
}, BJ = y({
  id: w(),
  name: p().nullable(),
  allowReorder: N()
}), GJ = y({
  id: w(),
  name: p().nullable(),
  allowReorder: N()
}), $5 = y({
  id: w(),
  firstName: p(),
  lastName: p(),
  phone: p(),
  email: p(),
  type: ne(hg)
});
y({
  userId: w(),
  firstName: p().nullable(),
  lastName: p().nullable(),
  email: p(),
  roleCode: ne(Wt),
  createdOn: p()
});
const VJ = y({
  id: w(),
  name: p(),
  myShopifyDomain: p(),
  enabledFeatures: O(ne(jJ)),
  externalStorefrontId: p().nullable(),
  isAppInstalled: N(),
  defaultProtectSetId: w().nullable(),
  protectSetIds: O(w()),
  sharedSlackChannelId: p().nullable(),
  createdOn: p().nullable(),
  updatedOn: p().nullable()
});
y({
  id: w(),
  createdOn: p(),
  fromDate: p().nullable(),
  toDate: p().nullable(),
  totalAmount: w(),
  protectedOrderCount: w(),
  reorderCount: w(),
  refundCount: w(),
  currencyCode: p().nullable(),
  paidOn: p().nullable(),
  billingProvider: p().nullable(),
  commissionCalculations: O(y({
    id: w(),
    amount: w(),
    projectedAmount: w(),
    wasDeductedFromInvoice: N(),
    commissionPayeeName: p()
  })),
  adjustments: O(y({
    id: w(),
    notes: p().nullable(),
    adjustmentType: p().nullable(),
    amount: w(),
    internalNotes: p().nullable()
  })),
  sections: O(y({
    id: w(),
    name: p(),
    amount: w(),
    supportingDocumentPath: p().nullable()
  }))
});
const UJ = y({
  isUnprotectedOrderClaimPermitted: N()
}), z5 = We([
  P(`${lf.crew}`),
  P(`${lf.gsp}`)
]), j5 = y({
  id: w(),
  provider: P(`${sf.stripe}`),
  email: p(),
  name: p(),
  stripeCustomerId: p(),
  appType: z5
}), B5 = y({
  id: w(),
  provider: P(`${sf.shopifySubscription}`),
  appType: z5
}), WJ = ke("provider", [
  j5,
  B5
]);
ke("provider", [
  j5.omit({ appType: !0, stripeCustomerId: !0, id: !0 }),
  B5.omit({ appType: !0, id: !0 })
]);
const G5 = y({
  id: w(),
  payeeName: p(),
  payeeType: p(),
  startDate: p(),
  endDate: p().nullable(),
  createdOn: p(),
  rate: w(),
  notes: p().nullable(),
  method: ne(["Topline", "Traditional"]),
  // deducted = isDeductedFromInvoice = true
  collectionMethod: ne(["Deducted", "Postpaid"]),
  isActive: N()
}), HJ = G5.pick({
  method: !0,
  collectionMethod: !0,
  startDate: !0,
  notes: !0,
  rate: !0
}).extend({
  payeeName: p(),
  endDate: p().min(1, "End Date is required"),
  payeeType: ne(pg)
});
HJ.pick({
  startDate: !0,
  endDate: !0
});
const V5 = y({
  id: w(),
  name: p(),
  code: ne(to)
});
y({
  termInMonths: w(),
  name: p(),
  frequency: We([P("Monthly"), P("Weekly")]),
  startDate: p(),
  amount: w(),
  minimumAmount: w(),
  gspDiscount: w()
});
const kp = y({
  id: w(),
  amount: w(),
  name: p(),
  type: ne({
    Billing_Period_Charge_Minimum: "Billing_Period_Charge_Minimum",
    Billing_Period_Charge: "Billing_Period_Charge",
    GSP_Discount: "GSP_Discount"
  })
}), qJ = y({
  id: w(),
  endDate: p().nullable(),
  startDate: p(),
  isUsed: N(),
  isTrial: N(),
  isActive: N(),
  frequency: We([P("Monthly"), P("Weekly")]),
  crewChargeMinimum: kp.nullable(),
  gspCharge: kp.nullable(),
  crewCharge: kp.nullable(),
  createdOn: p()
}), YJ = y({
  id: w(),
  name: p()
});
y({
  appHandle: ne(w8),
  firstSeen: p().nullable(),
  lastSeen: p().nullable(),
  heartbeatCount: w(),
  locations: O(y({
    location: p(),
    firstSeen: p(),
    lastSeen: p(),
    heartbeatCount: w()
  }))
});
const KJ = VJ.extend({
  shippingProtectionSettings: UJ,
  featureFlags: qn.Store.featureFlags,
  frontReportTags: qn.StoreSettings.frontReportTags,
  verifiedEmailDomain: Ao(p().toLowerCase().regex(nU, "Must be a valid domain.")),
  agency: YJ.nullable(),
  // TODO: canidates to move to their own get requests.
  commissionArrangements: O(G5),
  billingProviders: O(WJ),
  inspectionGrades: O(V5),
  invoiceDefinitions: O(qJ),
  fulfillmentLocations: O(BJ),
  contacts: O($5),
  shippingLines: O(GJ)
}), Yo = {
  base: KJ,
  storeContact: $5,
  inspectionGrade: V5
}, ZJ = {
  Home: "Home",
  Product: "Product",
  Settings: "Settings"
}, XJ = {
  Info: "Info",
  Warning: "Warning"
}, cv = y({
  id: w(),
  severity: ne(XJ),
  category: ne(ZJ),
  // potentially make this an enum
  subject: p(),
  message: p(),
  url: p().nullable(),
  createdOn: p(),
  readOn: p().nullable()
}), JJ = cv.pick({
  readOn: !0
}), U5 = cv.omit({
  id: !0,
  createdOn: !0,
  readOn: !0
}), W6 = {
  all: "all",
  stores: "stores"
}, QJ = ke("kind", [
  y({ kind: P(W6.all) }),
  y({
    kind: P(W6.stores),
    storeIds: O(w()).min(1, "Select at least one store")
  })
]);
U5.extend({
  subject: p().min(1, "Subject is required"),
  message: p().min(1, "Message is required"),
  target: QJ
});
y({ storeCount: w() });
const W5 = y({
  id: w(),
  email: p(),
  firstName: p().nullable(),
  lastName: p().nullable(),
  createdOn: p(),
  idFromPlatform: p()
});
W5.extend({
  roleCode: ne(Wt).nullable()
});
W5.extend({
  storeUserRoles: O(y({
    id: w(),
    roleCode: ne(Wt),
    storeId: w(),
    storeName: p()
  })),
  organizationUserRoles: O(y({
    id: w(),
    roleCode: ne(Wt),
    organizationId: w(),
    organizationName: p()
  }))
});
const H5 = "/store", eQ = "/organization", q5 = `${eQ}/:organizationId`, tQ = `${q5}/store`, nQ = `${q5}/user`;
y({ organizationId: Ee() });
y({ setId: Ee() });
y({
  setId: Ee(),
  unitId: Ee()
});
const rQ = "/user", oQ = "/user/:userId", iQ = "/agency", aQ = "/front-tag", sQ = "/sidekick/conversation", lQ = `${sQ}/:conversationId`;
iQ + "", O(y({
  id: w(),
  name: p()
})), aQ + "", Yo.base.shape.frontReportTags, lQ + "", y({ conversationId: Ee() }), H5 + "", y({ searchTerm: p().optional() }), rQ + "", y({ searchTerm: p().optional() }), oQ + "", y({ userId: Ee() }), tQ + "", y({ storeId: w() }), y({ storeId: w() }), nQ + "", O6.userList.pick({
  email: !0,
  firstName: !0,
  lastName: !0,
  roleCode: !0
}), O6.userList.pick({ email: !0 });
const Pr = `${H5}/:storeId`, cQ = `${Pr}/pricing-set`, uQ = `${Pr}/location/:locationId`, dQ = `${Pr}/shipping-line/:shippingLineId`, Y5 = `${Pr}/contact`, fQ = `${Y5}/:contactId`, mQ = `${Pr}/agency`, pQ = `${Pr}/ship-protect-settings`, hQ = `${Pr}/front-settings`, gQ = `${Pr}/feature-flags`, vQ = `${Pr}/email-settings`, yQ = `${Pr}/inspection-grade`, bQ = `${Pr}/inspection-grade/:inspectionGradeId`, SQ = `${Pr}/invoice-definition`, xQ = `${SQ}/:invoiceDefinitionId`, CQ = `${Pr}/commission-arrangement`, wQ = `${CQ}/:commissionArrangementId`, Dp = y({ storeId: Ee() });
cQ + "", y({ shipProtectSetId: w() }), uQ + "", y({
  storeId: Ee(),
  locationId: Ee()
}), y({ allowReorder: N() }), dQ + "", y({
  storeId: Ee(),
  shippingLineId: Ee()
}), y({ allowReorder: N() }), Y5 + "", Yo.storeContact.omit({ id: !0 }), fQ + "", y({
  storeId: Ee(),
  contactId: Ee()
}), Yo.storeContact.omit({ id: !0 }), y({
  storeId: Ee(),
  contactId: Ee()
}), mQ + "", y({ agencyId: w().nullable() }), pQ + "", Yo.base.shape.shippingProtectionSettings, gQ + "", Yo.base.pick({ featureFlags: !0 }), hQ + "", y({
  frontReportTags: Yo.base.shape.frontReportTags
}), vQ + "", Yo.base.pick({ verifiedEmailDomain: !0 }), yQ + "", Yo.inspectionGrade.omit({
  id: !0
}), bQ + "", Yo.inspectionGrade.omit({
  id: !0,
  code: !0
}), Dp.extend({ inspectionGradeId: Ee() }), xQ + "", y({ extensionInDays: w() }), Dp.extend({
  invoiceDefinitionId: Ee()
}), wQ + "", Dp.extend({
  commissionArrangementId: Ee()
});
const ht = p().toLowerCase().regex(/^#[0-9a-f]{6}$/, "Enter a 6-digit hex color, e.g. #1a1a1a"), H6 = p().regex(/^(?:'[A-Za-z0-9 ]+', (?:sans-serif|serif|monospace|cursive)|system-ui, sans-serif)$/, "Use a Google Fonts family or the system font"), Di = {
  none: "none",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl"
}, K5 = {
  standard: "standard",
  halo: "halo"
}, Z5 = {
  light: "300",
  regular: "400",
  medium: "500",
  semiBold: "600"
}, EQ = {
  pageBackground: "pageBackground",
  buttonPrimaryBg: "buttonPrimaryBg"
}, IQ = eY(ne(EQ), O(ht).max(3)), Dg = y({
  // Brand
  buttonPrimaryBg: ht.describe("Brand color: filled buttons, checked checkboxes and radios, field focus rings."),
  // --color-brand
  buttonPrimaryText: ht.describe("Text and icons on filled buttons."),
  // --color-on-brand
  brandContainerColor: ht.describe("Soft brand tint behind selected options and chips."),
  // --color-brand-container
  onBrandContainerColor: ht.describe("Text on the soft brand tint."),
  // --color-on-brand-container
  // Plain
  plainColor: ht.default("#5e5e5e").describe("Secondary (plain) buttons and the button loading spinner."),
  // --color-plain
  buttonOutlineText: ht.describe("Text of outlined buttons."),
  // corso-button[outlined] text
  onPlainColor: ht.describe("Text on secondary (plain) buttons."),
  // --color-on-plain
  plainContainerColor: ht.describe("Soft tint for secondary states."),
  // --color-plain-container
  onPlainContainerColor: ht.describe("Text on the soft secondary tint."),
  // --color-on-plain-container
  buttonOutlineBorder: ht.describe("Border of outlined buttons."),
  // corso-button[outlined] border
  // Emphasis
  emphasisColor: ht.describe("Positive and highlight badges and alerts."),
  // --color-emphasis
  onEmphasisColor: ht.describe("Text on positive and highlight badges."),
  // --color-on-emphasis
  emphasisContainerColor: ht.describe("Soft tint behind positive and highlight alerts."),
  // --color-emphasis-container
  onEmphasisContainerColor: ht.describe("Text in positive and highlight alerts."),
  // --color-on-emphasis-container
  // Critical
  criticalColor: ht.describe("Errors: error text, invalid field outlines, destructive buttons."),
  // --color-critical
  onCriticalColor: ht.describe("Text on destructive buttons."),
  // --color-on-critical
  criticalContainerColor: ht.describe("Soft tint behind error alerts."),
  // --color-critical-container
  onCriticalContainerColor: ht.describe("Text in error alerts."),
  // --color-on-critical-container
  // Surfaces
  surfaceColor: ht.describe("The page behind everything; on an embedded portal, glass makes it transparent."),
  // --color-surface
  surfaceContainerLowestColor: ht.describe("Cards: the inner page card, header, collapsible rows, product popovers."),
  // --color-surface-container-lowest
  surfaceContainerLowColor: ht.describe("Dropdown lists, the file drop area, summary line-item groups, chips."),
  // --color-surface-container-low
  surfaceContainerColor: ht.describe("The main content panel around the page card."),
  // --color-surface-container
  surfaceContainerHighColor: ht.describe("Raised bits: the quantity badge, the pending-button overlay."),
  // --color-surface-container-high
  surfaceContainerHighestColor: ht.describe("The most raised bits, such as pressed states."),
  // --color-surface-container-highest
  // On surface / text
  textPrimaryColor: ht.describe("Body text and headings everywhere."),
  // --color-on-surface
  textSecondaryColor: ht.describe("Muted text: hints, captions, secondary details."),
  // --color-on-surface-variant
  brandTextColor: ht.describe("Links and brand-colored text accents, and ghost buttons."),
  // .text-brand
  // Outline
  inputBorderColor: ht.describe("Outlines of inputs, text areas and dropdowns, the dashed file-drop border, the default focus outline."),
  // --color-outline
  borderColor: ht.describe("Dividers and card and product outlines."),
  // --color-outline-variant
  // Inverse & scrim
  inverseSurfaceColor: ht.describe("Tooltips and toasts."),
  // --color-inverse-surface
  inverseOnSurfaceColor: ht.describe("Text in tooltips and toasts."),
  // --color-inverse-on-surface
  scrimColor: ht.describe("The backdrop behind modals."),
  // --color-scrim
  // Typography — each size is the `md` step; the generator derives lg/sm from it
  fontFamily: H6.describe("Body text, labels, buttons and inputs."),
  // --font-body-family
  headingFontFamily: H6.describe("Page, card and section titles."),
  // --font-heading-family
  headingSize: w().int().min(16).max(40).describe("Page title size in px; card titles and larger headings scale from it."),
  subheadingSize: w().int().min(12).max(24).describe("Section title size in px."),
  bodySize: w().int().min(11).max(18).describe("Body text size in px; keep it at 14 or more so hints stay readable on phones."),
  labelSize: w().int().min(9).max(16).describe("Button, field-label and line-item title size in px."),
  fontWeight: ne(Z5).describe("Text weight; medium steps never go below 500."),
  // Borders & shapes
  borderRadius: w().int().min(0).max(24).describe("Corner radius in px of the panels, cards, dropdowns and the file drop area."),
  buttonBorderRadius: w().int().min(0).max(24).describe("Corner radius in px of buttons; 24 reads as a pill."),
  fieldBorderRadius: w().int().min(0).max(24).default(8).describe("Corner radius in px of inputs, text areas and dropdown fields."),
  cardBorders: N().default(!0).describe("Keep the edge around the panels and cards; false removes it."),
  cardSurfaces: N().default(!0).describe("Paint the panel and card backgrounds; false leaves an open, card-free layout sitting on the page."),
  flatDisclosures: N().default(!1).describe("Show collapsible rows (items, tracking) as flat rows split by a hairline instead of filled boxes."),
  inputBackgroundColor: ht.describe("Background of inputs, dropdowns, the file drop area and radio cards."),
  // Shadows & effects
  shadowLevel: ne(Di).describe("How strongly the panels and cards float; dropdowns sit one step heavier."),
  shadowStyle: ne(K5).describe("standard is a plain drop shadow; halo adds a hairline ring and a wide soft glow."),
  backdropBlur: N().describe("Glass: frosted, translucent panels and cards over the page."),
  glassOpacity: w().min(0.1).max(1).describe("With glass, how opaque the outer panels and the header are. Lower reads glassier but harder."),
  glassCardOpacity: w().min(0.1).max(1).optional().describe("With glass, how opaque the inner page card is, on its own; left out, it sits 0.1 more opaque than the panels. Lower lets the panel show through, as a stacked pane."),
  glassHighlight: N().default(!1).describe("With glass, a thin white highlight along the top edge of the panels and the page card."),
  // Spacing
  /** Free-form CSS padding shorthand for `corso-page`, e.g. `24px` or `10px 5px 15px 20px`. */
  cardPadding: p().max(64).describe("Padding inside the page card, as CSS padding: 24px, or 10px 5px 15px 20px."),
  appBodyPaddingY: w().int().min(0).max(200).describe("Space in px above and below the portal, on its own URL and embedded in the merchant’s site."),
  sectionSpacing: w().int().min(8).max(32).describe("Gap in px between the parts of a page section."),
  // Page
  pageBackground: ht.describe("Page color behind the portal on its own URL; glass leaves the merchant’s page showing when embedded."),
  pageBackgroundImage: We([P(""), Cn()]).describe("A photo URL to cover the page with, or empty for none."),
  pageBackgroundFocalX: w().min(0).max(100).describe("Horizontal focus of the page photo, 0–100%."),
  pageBackgroundFocalY: w().min(0).max(100).describe("Vertical focus of the page photo, 0–100%."),
  gradients: IQ.describe("Up to 3 extra colors that turn pageBackground or buttonPrimaryBg into a diagonal gradient.")
});
Z5.regular, Di.sm, K5.standard;
const ys = {
  glass: "Glass",
  frosted: "Frosted",
  compact: "Compact",
  editorial: "Editorial",
  dark: "Dark",
  ladyBird: "Lady Bird"
};
ys.glass + "", Di.md, ys.frosted + "", Di.md, ys.compact + "", Di.none, ys.editorial + "", Di.md, ys.dark + "", Di.md, ys.ladyBird + "", Di.none;
Dg.extend({ embedded: N().optional() });
const Pi = {
  // ? accounts used by the Corso EasyPost Config
  UPSDAP: "UPSDAP",
  USPS: "USPS",
  FedExDefault: "FedExDefault",
  FedEx: "FedEx",
  UPS: "UPS",
  CanadaPost: "CanadaPost"
}, uv = {
  /** USPS */
  USPS_First: "USPS_First",
  USPS_GroundAdvantage: "USPS_GroundAdvantage",
  USPS_MediaMail: "USPS_MediaMail",
  USPS_Priority: "USPS_Priority",
  USPS_Express: "USPS_Express",
  USPS_PriorityMailInternational: "USPS_PriorityMailInternational",
  USPS_MailExpressInternational: "USPS_ExpressMailInternational",
  USPS_FirstClassPackageInternationalService: "USPS_FirstClassPackageInternationalService",
  /** UPSDAP */
  UPSDAP_Ground: "UPSDAP_Ground",
  UPSDAP_UPSStandard: "UPSDAP_UPSStandard",
  UPSDAP_Express: "UPSDAP_Express",
  UPSDAP_NextDayAir: "UPSDAP_NextDayAir",
  UPSDAP_2ndDayAir: "UPSDAP_2ndDayAir",
  UPSDAP_3DaySelect: "UPSDAP_3DaySelect",
  /** FedEx Default Account */
  FedExDefault_FEDEX_GROUND: "FedExDefault_FEDEX_GROUND",
  FedExDefault_FEDEX_2_DAY: "FedExDefault_FEDEX_2_DAY",
  FedExDefault_STANDARD_OVERNIGHT: "FedExDefault_STANDARD_OVERNIGHT",
  FedExDefault_FEDEX_INTERNATIONAL_PRIORITY: "FedExDefault_FEDEX_INTERNATIONAL_PRIORITY",
  FedExDefault_INTERNATIONAL_ECONOMY: "FedExDefault_INTERNATIONAL_ECONOMY",
  FedExDefault_GROUND_HOME_DELIVERY: "FedExDefault_GROUND_HOME_DELIVERY",
  FedExDefault_FEDEX_INTERNATIONAL_CONNECT_PLUS: "FedExDefault_FEDEX_INTERNATIONAL_CONNECT_PLUS",
  /** END OF CORSO PROVIDED RATES */
  /** Brand Owned FedEx Accounts */
  FedEx_FEDEX_GROUND: "FedEx_FEDEX_GROUND",
  FedEx_FEDEX_2_DAY: "FedEx_FEDEX_2_DAY",
  FedEx_STANDARD_OVERNIGHT: "FedEx_STANDARD_OVERNIGHT",
  FedEx_FEDEX_INTERNATIONAL_PRIORITY: "FedEx_FEDEX_INTERNATIONAL_PRIORITY",
  FedEx_INTERNATIONAL_ECONOMY: "FedEx_INTERNATIONAL_ECONOMY",
  FedEx_GROUND_HOME_DELIVERY: "FedEx_GROUND_HOME_DELIVERY",
  FedEx_FEDEX_INTERNATIONAL_CONNECT_PLUS: "FedEx_FEDEX_INTERNATIONAL_CONNECT_PLUS",
  /** UPS */
  UPS_Ground: "UPS_Ground",
  UPS_UPSStandard: "UPS_UPSStandard",
  UPS_Express: "UPS_Express",
  UPS_NextDayAir: "UPS_NextDayAir",
  UPS_2ndDayAir: "UPS_2ndDayAir",
  UPS_3DaySelect: "UPS_3DaySelect",
  /** Canada Post */
  CanadaPost_ExpeditedParcel: "CanadaPost_ExpeditedParcel",
  CanadaPost_RegularParcel: "CanadaPost_RegularParcel",
  CanadaPost_Xpresspost: "CanadaPost_Xpresspost"
}, RQ = {
  API: "API",
  RATE_TABLE: "RATE_TABLE"
}, Qu = 128, Pp = w().nonnegative().pipe(X.decimal(8, 2, "Value too large")), Pg = y({
  id: w(),
  // optional because it's only used for calculated rates
  carrierService: Hn(uv).optional(),
  carrierRetrievalMethod: Hn(RQ).optional(),
  name: X.insuranceString(Qu),
  description: X.nullifiedInsuranceString(Qu),
  price: Pp,
  currencyCode: Hn(V),
  type: We([
    P("Flat"),
    P("Order_Total"),
    P("Item_Weight")
  ]),
  minAmount: Pp.nullable(),
  maxAmount: Pp.nullable(),
  isPlusRate: N(),
  plusName: X.nullifiedInsuranceString(Qu),
  plusDescription: X.nullifiedInsuranceString(Qu),
  shouldShowOriginalRate: N(),
  createdOn: p().optional(),
  shippingDiscount: D.shippingDiscount.optional(),
  carrierDeliveryEstimate: y({
    deliveryDays: w().optional(),
    deliveryDate: p().optional()
  }).optional(),
  deliveryEstimate: C8.merge(y({
    displayLocation: D.estimatedDeliveryDisplayLocationUnion
  })).optional()
}), TQ = Pg.omit({
  id: !0,
  createdOn: !0
});
Pi.USPS + "", Pi.USPS, Pi.UPSDAP + "", Pi.UPSDAP, Pi.FedExDefault + "", Pi.FedExDefault;
const X5 = y({
  clientMessage: p(),
  success: N().optional()
}), hm = y({
  id: w(),
  claimType: $e(nm),
  calculatedLineItems: O(um),
  shopNowIncentiveAmountApplied: w().optional(),
  returnShipment: dm.nullish(),
  toCustomerRate: Ja.nullish(),
  exchangeMethod: We([P("instant"), P("standard")]).optional(),
  creditResolutionMethod: Hn(rm).optional()
});
hm.omit({
  returnShipment: !0,
  toCustomerRate: !0
}).extend({
  address: Wr.optional(),
  email: p().optional()
});
hm.omit({
  returnShipment: !0,
  toCustomerRate: !0
}).extend({
  email: p(),
  address: Wr,
  globalEOrderId: p().optional()
});
hm.omit({
  returnShipment: !0,
  toCustomerRate: !0,
  calculatedLineItems: !0
}).extend({
  calculatedLineItems: O(um.omit({
    requestedResolutionMethodEnum: !0,
    id: !0,
    originalStoreOrderLineItem: !0
  }))
});
const _Q = y({
  eventPolicyEnforcement: D.eventPolicyEnforcement.nullable(),
  eventCustomFields: Q8.nullable(),
  omittedResolutionMethods: D.omittedResolutionMethodOptions.optional()
}), q6 = y({
  total: w(),
  lineItems: O(m5),
  sections: O(q8)
}), OQ = y({
  calculatedLineItemId: p(),
  storeRuleId: w().optional(),
  fee: y({
    amount: w(),
    displayName: p()
  })
}), AQ = y({
  credits: q6,
  deductions: q6,
  lineItemApplications: O(NX),
  lineItemFeeApplications: O(OQ),
  balance: w(),
  paymentIntent: y({
    clientSecret: p(),
    amount: w(),
    idFromPlatform: p()
  }).optional()
}), ed = y({
  lastEligibleDate: p().nullish(),
  isEligible: N()
}), dv = la.merge(y({
  // the exchangeLineItemId representing a modification to the original order's line items
  exchangeLineItemIdFromPlatform: p().optional(),
  ineligibleLineItemFootnote: X.optionalizedString,
  automationMadeIneligibleOn: p().optional(),
  productTagsAtPurchase: O(p()).optional(),
  eligibilityStoreRuleId: w().optional(),
  return: y({
    claimReasons: O(ja),
    isFinalSale: N(),
    isExchangeOnly: N(),
    exchange: ed,
    giftCard: ed,
    refund: ed
  }),
  warranty: ed.extend({
    claimReasons: O(ja),
    isIneligibleWarrantyClaimAllowed: N().optional(),
    ineligibleWarrantyClaimTitle: p().optional(),
    ineligibleWarrantyClaimDisclaimer: p().optional()
  })
})), kQ = rv.merge(y({ lineItemsInShipment: dv.array() })), DQ = y({
  id: w(),
  isFulfilled: N(),
  destinationAddress: Xi.nullable(),
  tracker: kQ.optional()
}), PQ = y({
  reason: Hn(Xt),
  headline: p(),
  description: p(),
  buttonText: p()
}), J5 = y({
  storeId: w(),
  storeSlug: p(),
  canceledOn: p().optional(),
  storeName: p(),
  countryCode: p().optional(),
  storefrontId: p(),
  isGiftReturn: N().optional(),
  id: w(),
  idFromPlatform: p(),
  isExchangeOfExchange: N().optional(),
  orderNo: p(),
  email: p(),
  currencyCode: p(),
  lineItems: O(la).min(1),
  shippingAddress: Xi.nullable(),
  billingAddress: Xi.nullable(),
  wasShippingProtected: N(),
  isUnprotectedShippingClaimPermitted: N(),
  shippingTitle: p().optional(),
  shippingPrice: p().optional(),
  claims: O(ua).optional(),
  // crewClaims
  shippingClaims: O(mm).optional(),
  // gspClaims
  shippingClaimReasons: O(ne(Xt)),
  shippingClaimReasonOverrides: O(PQ).optional(),
  customerCurrencyConversionRate: w().optional(),
  platformAdminUrl: p().optional(),
  wasCreatedFromRegistration: N(),
  /** The order is a replacement Corso created to resolve a shipping claim. */
  wasCreatedFromReorder: N().optional(),
  isShippingClaimImgRequired: N(),
  createdOn: p()
}), fv = J5.omit({ lineItems: !0 }).merge(y({
  globalEOrderId: p().optional(),
  startGiftReturnUrl: p().optional(),
  // when every return and warranty window started counting, per the store's window start event
  windowStartsOn: p().optional(),
  returnUntil: p().optional(),
  warrantyUntil: p().optional(),
  editUntil: p().optional(),
  isOrderEditable: N().optional(),
  isOrderFulfilled: N(),
  fulfillments: DQ.array(),
  lineItems: O(dv).min(1),
  offerInstantExchange: D.eventOfferInstantExchangeParams.optional(),
  allowClaimTypeSelection: D.eventAllowClaimTypeSelection.optional(),
  rightToWithdraw: D.eventRightToWithdraw.shape.params.optional()
})), NQ = fv.pick({
  id: !0,
  orderNo: !0,
  idFromPlatform: !0,
  createdOn: !0
}).merge(y({
  customerEmail: p(),
  customerName: p().nullable(),
  storeId: w(),
  storeName: p()
})), MQ = O(NQ), FQ = ne([
  "exact_sku",
  "exact_barcode",
  "exact_metafield",
  "unmatched",
  "ai_match",
  "exact_name_options",
  "open_search"
]), Q5 = ne(["high", "medium", "low"]), Y6 = z8.shape.variants.element.extend({
  matchedWith: FQ.optional(),
  confidence: Q5.optional()
}), eE = y({
  name: p(),
  quantity: w(),
  sku: p().nullable(),
  barcode: p().nullish(),
  options: O(y({ name: p(), value: p() })),
  price: w().nullable(),
  currencyCode: p().nullable(),
  vendor: p().nullish(),
  productType: p().nullish(),
  keywordsAboutProduct: O(p()).optional(),
  confidence: Q5.optional(),
  bundleComponents: O(p()).nullish()
}), tE = y({
  extractedProductCount: w().optional(),
  candidateCount: w().optional(),
  candidatesFitInContext: N().optional(),
  priceFilteredCount: w().optional(),
  suggestedVariants: O(Y6).optional(),
  possibleVariants: O(Y6).optional()
}).optional(), LQ = tE, nE = y({
  wasExtractionSuccessful: N().optional(),
  message: p().optional(),
  referrer: X.optionalizedString,
  productMatchMetadata: tE.optional(),
  metadata: y({
    extractedProductData: O(eE).optional(),
    rawExtraction: uo().optional(),
    documentClassification: O(p()).optional(),
    fileMetadata: O(y({
      type: p()
    })).optional(),
    extractionModel: p().optional(),
    tokenUsage: y({
      prompt: w(),
      completion: w()
    }).optional(),
    extractionLatencyMs: w().optional()
  }).optional(),
  firstName: p().optional(),
  lastName: p().optional(),
  estimatedPurchaseDate: p().optional(),
  orderNumber: p().optional(),
  email: p().optional(),
  address: Xi.optional(),
  storeSalesChannel: y({
    id: w(),
    name: p()
  }).optional(),
  customFields: O(au.pick({ id: !0, value: !0 })).optional()
}), su = y({
  id: w(),
  externalId: p(),
  customerProvidedOrderNumber: p().optional(),
  createdOn: p(),
  customFields: O(au).optional(),
  estimatedPurchaseDate: p().nullish(),
  registrationChannelName: p(),
  proofOfPurchaseFileUrls: O(p()),
  emailMarketingConsentCollectedOn: p().optional(),
  customerIdFromPlatform: p().optional(),
  claims: O(y({
    id: w(),
    externalId: p(),
    claimType: $e(nm)
  })),
  firstName: p(),
  lastName: p(),
  suggestedRegistration: nE.nullish(),
  wasCustomerCreatedOnPlatform: N().optional(),
  wasEmailMarketingConsentUpdatedOnPlatform: N().optional(),
  // ! properties that live on the order
  orderIdFromPlatform: p(),
  address: Wr.optional(),
  lineItems: O(la),
  email: p(),
  orderNumber: p().optional(),
  referrer: X.optionalizedString,
  canceledOn: p().optional(),
  kobjectIdFromPlatform: p().optional(),
  storeSalesChannelId: w().optional(),
  salesChannelCode: p().optional(),
  discountIncentive: y({
    code: p(),
    message: p().optional(),
    redemptionUrl: p(),
    expiresOn: p().optional(),
    redeemedOn: p().optional(),
    orderTotal: w().optional(),
    orderNo: p().optional(),
    orderCreatedOn: p().optional(),
    platformAdminUrl: p().optional()
  }).optional(),
  timeline: av.optional()
}), $Q = su.pick({
  estimatedPurchaseDate: !0,
  address: !0
}).merge(y({
  storeProductVariants: O(y({
    idFromPlatform: p(),
    quantity: w()
  })).optional(),
  lineItemIdToRemove: w().optional(),
  storeSalesChannelId: w().optional()
})), rE = su.pick({
  registrationChannelName: !0,
  createdOn: !0,
  externalId: !0,
  id: !0,
  canceledOn: !0
}).merge(y({
  customerEmail: p(),
  customerName: p().nullable(),
  tags: O(p()),
  storeId: w(),
  storeName: p()
})), zQ = O(rE), jQ = su.omit({
  claims: !0,
  externalId: !0,
  orderIdFromPlatform: !0,
  createdOn: !0,
  registrationChannelName: !0,
  proofOfPurchaseFileUrls: !0,
  estimatedPurchaseDate: !0,
  id: !0,
  lineItems: !0,
  customFields: !0
}).merge(y({
  firstName: p(),
  lastName: p(),
  storeProductVariants: O(qZ.pick({
    id: !0
  }).merge(y({ quantity: w() }))),
  storeSalesChannelId: w(),
  estimatedPurchaseDate: p(),
  proofOfPurchaseFilenames: O(p()).optional(),
  customFields: O(e5)
})), BQ = y({
  storeSalesChannelName: p(),
  estimatedPurchaseDate: p(),
  extractedProductData: O(eE)
}), GQ = y({
  proofOfPurchaseFiles: O(y({
    src: p(),
    type: p()
  })),
  shouldCollectAddress: N(),
  offeredCustomFields: O(Y0.pick({
    id: !0,
    description: !0,
    displayName: !0
  })),
  offeredSalesChannels: O(y({
    id: w(),
    name: p()
  }))
}), oE = y({
  // URL to use when reading the object
  url: p(),
  uploadFilename: p(),
  // URL to use when uploading the object
  signedUploadUrl: p(),
  signedUploadProxyUrl: p()
}), VQ = y({
  clientSecret: p()
}), UQ = y({
  amount: w(),
  // amount in dollars // API will handle conversion to cents
  currencyCode: p(),
  stripeConfig: X0,
  customerEmail: p()
}), WQ = 3600, Np = y({
  amount: w(),
  currencyCode: $e(V)
}), mv = y({
  id: p(),
  claimId: w().optional(),
  returnToCustomerAppUrl: p(),
  startShoppingIdUrl: p(),
  cancelShoppingIdUrl: p(),
  lineItems: O(Ba),
  // the sum of any line_items scheduled to be gift_card or refund
  returnCredit: Np,
  // the offered incentive amount
  returnCreditIncentive: Np,
  returnCreditIncentiveApplied: Np,
  orderIdFromPlatform: p().optional(),
  orderNumber: p().optional(),
  customerEmail: p().optional(),
  createdOn: p().optional(),
  completedOn: p().optional()
}), K6 = y({
  orderIdFromPlatform: p()
}), HQ = mv.pick({
  // configured by the underlying pegasus rule
  returnCreditIncentive: !0,
  returnCredit: !0
}).extend({
  orderIdFromPlatform: p(),
  customerAppHostConfig: ke("type", [
    y({
      type: P("standalone"),
      slug: p()
    }).merge(K6),
    y({
      type: P("embedded"),
      parentHostUrl: p().url()
    }).merge(K6)
  ]),
  shopNowEvent: D.shopNowEventParams
}), qQ = mv.pick({
  lineItems: !0,
  returnCreditIncentiveApplied: !0
}), YQ = [
  "--color-brand",
  "--color-on-brand",
  "--color-brand-container",
  "--color-on-brand-container",
  "--color-plain",
  "--color-on-plain",
  "--color-plain-container",
  "--color-on-plain-container",
  "--color-emphasis",
  "--color-on-emphasis",
  "--color-emphasis-container",
  "--color-on-emphasis-container",
  "--color-critical",
  "--color-on-critical",
  "--color-critical-container",
  "--color-on-critical-container",
  "--color-surface",
  "--color-surface-container-lowest",
  "--color-surface-container-low",
  "--color-surface-container",
  "--color-surface-container-high",
  "--color-surface-container-highest",
  "--color-on-surface",
  "--color-on-surface-variant",
  "--color-outline",
  "--color-outline-variant",
  "--color-inverse-surface",
  "--color-inverse-on-surface",
  "--color-scrim",
  "--color-shadow",
  "--state-disabled-mix",
  "--state-hovered-mix",
  "--state-active-mix",
  "--state-focused-mix",
  "--state-focused-outline-color",
  "--state-focused-outline-width",
  "--state-focused-outline-offset"
], KQ = ["--field-shadow"], ZQ = [
  "--font-heading-family",
  "--font-body-family",
  "--heading-family-lg",
  "--heading-size-lg",
  "--heading-weight-lg",
  "--heading-leading-lg",
  "--heading-tracking-lg",
  "--heading-opsz-lg",
  "--heading-family-md",
  "--heading-size-md",
  "--heading-weight-md",
  "--heading-leading-md",
  "--heading-tracking-md",
  "--heading-opsz-md",
  "--heading-family-sm",
  "--heading-size-sm",
  "--heading-weight-sm",
  "--heading-leading-sm",
  "--heading-tracking-sm",
  "--heading-opsz-sm",
  "--subheading-family-lg",
  "--subheading-size-lg",
  "--subheading-weight-lg",
  "--subheading-leading-lg",
  "--subheading-tracking-lg",
  "--subheading-opsz-lg",
  "--subheading-family-md",
  "--subheading-size-md",
  "--subheading-weight-md",
  "--subheading-leading-md",
  "--subheading-tracking-md",
  "--subheading-opsz-md",
  "--subheading-family-sm",
  "--subheading-size-sm",
  "--subheading-weight-sm",
  "--subheading-leading-sm",
  "--subheading-tracking-sm",
  "--subheading-opsz-sm",
  "--body-family-lg",
  "--body-size-lg",
  "--body-weight-lg",
  "--body-leading-lg",
  "--body-tracking-lg",
  "--body-opsz-lg",
  "--body-family-md",
  "--body-size-md",
  "--body-weight-md",
  "--body-leading-md",
  "--body-tracking-md",
  "--body-opsz-md",
  "--body-family-sm",
  "--body-size-sm",
  "--body-weight-sm",
  "--body-leading-sm",
  "--body-tracking-sm",
  "--body-opsz-sm",
  "--label-family-lg",
  "--label-size-lg",
  "--label-weight-lg",
  "--label-leading-lg",
  "--label-tracking-lg",
  "--label-opsz-lg",
  "--label-family-md",
  "--label-size-md",
  "--label-weight-md",
  "--label-leading-md",
  "--label-tracking-md",
  "--label-opsz-md",
  "--label-family-sm",
  "--label-size-sm",
  "--label-weight-sm",
  "--label-leading-sm",
  "--label-tracking-sm",
  "--label-opsz-sm",
  "--heading-text-transform",
  "--subheading-text-transform",
  "--body-text-transform",
  "--label-text-transform",
  "--button-text-transform"
], XQ = [
  /** Utility Classes for heading-* */
  "heading-lg",
  "heading-md",
  "heading-sm",
  /** Utility Classes for subheading-* */
  "subheading-lg",
  "subheading-md",
  "subheading-sm",
  /** Utility Classes for body-* */
  "body-lg",
  "body-md",
  "body-sm",
  /** Utility Classes for label-* */
  "label-lg",
  "label-md",
  "label-sm"
], JQ = [
  "corso-app-body",
  "corso-app-content",
  "corso-app-footer",
  "corso-app-header",
  "corso-app-shell",
  "corso-button",
  "corso-combobox",
  "corso-combobox-listbox",
  "corso-combobox-option",
  "corso-combobox-search",
  "corso-description-list",
  "corso-disclosure",
  "corso-divide",
  "corso-divider",
  "corso-dropzone",
  "corso-field",
  "corso-icon-button",
  "corso-input",
  "corso-link",
  "corso-media",
  "corso-page",
  "corso-page-section",
  "corso-product-filter-popover",
  "corso-product-image",
  "corso-product-search-popover",
  "corso-radio-button-option",
  "corso-radio-card-option",
  "corso-radio-group",
  "corso-textarea"
], QQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  colorsProperties: YQ,
  dataComponentValues: JQ,
  elevationProperties: KQ,
  typographyProperties: ZQ,
  typographyUtilityClasses: XQ
}, Symbol.toStringTag, { value: "Module" }));
var Dt;
(function(e) {
  e.REF_QUERY_PARAM = "ref", e.frontEndUrlPaths = [
    // SLUG branded URLS
    ":slug/claim/overview/:claimExternalId",
    // CREW claim overview
    ":slug/order/:idFromPlatform",
    // order hub
    ":slug/reorder/:idFromPlatform",
    // branded start a gsp reorder
    ":slug/reorder/:idFromPlatform/claim/:shippingClaimId",
    // shipping claim overview
    "reorder/:idFromPlatform",
    // start a reorder without a slug
    ":slug/register",
    // branded registration page
    // TODO: implement the generation of these, just including here to document the URLs the back-end expects
    ":slug/order/:idFromPlatform/return/shop/:shopNowId/complete",
    // branded shop now complete
    ":slug/order/:idFromPlatform/return/shop"
    // base shop now URL
  ], e.EmbeddedWindowEvent = {
    CORSO_HEIGHT_CHANGE: "CORSO_HEIGHT_CHANGE",
    CORSO_REQUEST_PARENT_LOCATION: "CORSO_REQUEST_PARENT_LOCATION",
    CORSO_PARENT_LOCATION: "CORSO_PARENT_LOCATION",
    CORSO_REQUEST_NAVIGATION: "CORSO_REQUEST_NAVIGATION"
  };
  const t = y({
    type: P(e.EmbeddedWindowEvent.CORSO_HEIGHT_CHANGE),
    height: w().min(0)
  }), n = y({
    type: P(e.EmbeddedWindowEvent.CORSO_REQUEST_PARENT_LOCATION)
  }), r = y({
    type: P(e.EmbeddedWindowEvent.CORSO_PARENT_LOCATION),
    location: p().url()
  }), o = y({
    type: P(e.EmbeddedWindowEvent.CORSO_REQUEST_NAVIGATION),
    url: p().url()
  });
  e.embeddedMessageSchema = ke("type", [
    t,
    n,
    r,
    o
  ]), e.variantExchangeSchema = W8, e.AdvancedExchangeMethodSchema = D.advancedExchangeMethodUnion, e.AdvancedExchangeMethod = D.AdvancedExchangeMethod, e.orderEditAction = D.orderEditAction, e.orderEditStagedIdSchema = L8, e.orderEditStagedSchema = tc, e.orderEditPreparedSchema = HZ, e.OrderEditType = D.OrderEditType, e.orderEditActionSchema = D.orderEditAction, e.orderEditCancelOrderActionSchema = D.orderEditCancelOrderActionSchema, e.orderEditUpdateAddressActionSchema = D.orderEditUpdateAddressActionSchema, e.orderEditRemovePackageProtection = D.orderEditRemovePackageProtection, e.orderEditModifyQuantityActionSchema = D.orderEditModifyQuantityActionSchema, e.orderEditUpdateEmailActionSchema = D.orderEditUpdateEmailActionSchema, e.orderEditUpdateShippingLineActionSchema = D.orderEditUpdateShippingLineActionSchema, e.orderEditAddDiscountCodeActionSchema = D.orderEditAddDiscountCodeActionSchema, e.variantExchangeOptionsSchema = zi, e.variantExchangeProductOptionsSchema = rX, e.collectionSchema = aX, e.paymentIntentSchema = VQ, e.paymentIntentCreateSchema = UQ, e.customFieldSelectSchema = J8, e.customFieldGeneralSchema = Y0, e.collectCustomFieldEventSchema = Q8, e.claimSchema = ua, e.claimTagSchema = ki, e.variantExchangeLineItemSchema = Ba, e.claimAddressSchema = Wr, e.claimCreateSchema = D5, e.claimLineItemCreateSchema = cm, e.registrationSchema = su, e.registrationCreateSchema = jQ, e.registrationProductSchema = z8, e.suggestedRegistrationSchema = nE, e.registrationAnalysisRequestSchema = GQ, e.registrationAnalysisProductRequestSchema = BQ, e.suggestedVariantsResponseSchema = LQ, e.orderSchema = fv, e.crewOrderLineItemSchema = dv, e.orderAddressSchema = Xi, e.orderTrackerSchema = rv, e.signedUrlSchema = oE, e.settingsSchema = xX, e.shipmentQuoteSchema = lJ, e.shipmentRateSchema = Ja, e.shipmentMethodSchema = dm, e.shipmentCreateSchema = I5, e.shipmentSchema = R5, e.locationAddressSchema = uf, e.apiClientRespSchema = X5, e.shippingClaimSchema = mm, e.shippingClaimCreateCustomerSchema = zJ, e.shippingClaimCreateMerchantSchema = F5, e.gspOrderSchema = J5, e.calculatedOrderSchema = hm, e.calculatedOrderLineItemSchema = um, e.calculatedAfterReasonSelectionSchema = _Q, e.calculatedBeforeClaimSubmissionSchema = AQ, e.shopNowEventParamsSchema = D.shopNowEventParams, e.shopNowSessionSchema = mv, e.shopNowSessionCreateSchema = HQ, e.shopNowSessionUpdateSchema = qQ, e.shopNowExpirySeconds = WQ, e.theme = QQ, e.cssCustomProperties = {
    fontHeadingFamily: "font-heading-family",
    fontBodyFamily: "font-body-family"
  };
})(Dt || (Dt = {}));
y({
  slug: p()
});
const lu = y({
  storefrontId: p()
});
y({
  idFromPlatform: p()
}).merge(lu);
y({ claimExternalId: SY() }).merge(lu);
y({ claimId: Ee() }).merge(lu);
const eee = y({
  idFromPlatform: p(),
  isGiftReturn: p().transform((e) => e === "true").optional()
}), tee = y({
  orderNo: p()
}), nee = y({
  emailOrPostalCode: p()
}).merge(tee), ree = y({
  orderOrTrackingNumber: p(),
  shippingPostalCode: p(),
  isGiftReturn: P("true")
});
We([
  eee,
  nee,
  ree
]);
y({
  filename: O8,
  destination: We([
    P("gspClaimImg"),
    P("crewClaimImg"),
    P("crewProofOfPurchase")
  ])
});
const oee = "/protection/order", iee = "/settings/:slug", bi = "/:storefrontId", pv = `${bi}/registration`, aee = `${pv}/product`, iE = `${pv}/analyze`, see = `${iE}/product`, lee = `${bi}/automations`, cee = `${lee}/after-reason-selection`, uee = `${bi}/create-payment-intent`, dee = `${bi}/signed-url`, hv = `${bi}/order`, fee = `${bi}/product/exchange-options/:idFromPlatform`, aE = `${bi}/claim`, mee = `${aE}/:claimExternalId`, sE = `${bi}/shipping-protection/claim`, pee = `${sE}/:shippingClaimId`, lE = `${bi}/return-shipment`, hee = `${lE}/quote`, gv = `${hv}/calculate`, gee = `${hv}/withdraw`, vee = `${gv}/after-reason-selection`, yee = `${gv}/before-claim-submission`, bee = `${gv}/claim-line-item-review`;
lu.extend({
  storeOrderId: Ee()
});
lu.extend({
  shopNowId: p()
});
//! all endpoints exposed by the crewUiApi are at a base path of `/v1/shop/crew/`
//! storefrontId is returned in the call to settings, and all subsequent calls require it
oee + "", Dt.gspOrderSchema, iee + "", Dt.settingsSchema, gee + "", y({
  isDefective: N(),
  storeOrderId: Ee(),
  address: Dt.claimAddressSchema
}), y({
  claimExternalId: p()
}), vee + "", Dt.calculatedAfterReasonSelectionSchema, bee + "", y({
  offerShopNow: D.shopNowEventParams.optional()
}), yee + "", Dt.calculatedOrderSchema, Dt.calculatedBeforeClaimSubmissionSchema, pv + "", Dt.registrationCreateSchema, Dt.registrationSchema, iE + "", Dt.registrationAnalysisRequestSchema, Dt.suggestedRegistrationSchema, see + "", Dt.registrationAnalysisProductRequestSchema, Dt.suggestedVariantsResponseSchema, cee + "", y({
  originalStoreOrderLineItemId: Ee()
}), aee + "", y({
  storeSalesChannelName: p(),
  estimatedPurchaseDate: p(),
  searchTerm: p()
}), O(Dt.registrationProductSchema), sE + "", Dt.shippingClaimCreateCustomerSchema, Dt.shippingClaimSchema, aE + "", Dt.claimCreateSchema, Dt.claimSchema, hv + "", Dt.orderSchema, mee + "", Dt.claimSchema, pee + "", Dt.shippingClaimSchema, fee + "", Dt.variantExchangeSchema, lE + "", Dt.shipmentCreateSchema, hee + "", Dt.shipmentQuoteSchema, dee + "", Dt.signedUrlSchema, uee + "", Dt.paymentIntentCreateSchema, Dt.paymentIntentSchema;
y({
  orderId: p(),
  shopNowId: p(),
  isGiftReturn: sg(),
  isOrderEdit: sg()
}).partial();
y({
  slaAlerts: O(D.eventSpcSlaNotification.shape.params.shape.alert),
  reorderLocations: O(y({
    id: w(),
    name: p(),
    idFromPlatform: p()
  })),
  // ? were the locations provider by returning all configured in DB or limited by an automation
  reorderLocationProvider: We([P("all"), P("automation")]),
  minInventoryAvailable: w(),
  isFinalizeBlocked: N(),
  isGiftCardEnabled: N(),
  reorderShipping: D.eventSpcReorderShipping.shape.params.optional(),
  resolutionMethods: D.eventSpcAllowedResolutions.shape.params.shape.shippingClaimResolutionMethods
});
const See = y({
  id: w(),
  name: p().nullable(),
  imgUrl: p().nullable(),
  sku: p().nullable(),
  quantity: w(),
  unitPrice: w().nullable(),
  unitTax: w().nullable()
}), Z6 = y({
  id: w(),
  nameFromPlatform: p().nullable(),
  orderNumber: p().nullable(),
  idFromPlatform: p(),
  createdOn: p(),
  platformAdminUrl: p(),
  wasResolvedExternally: N(),
  lineItems: O(See)
}), xee = y({
  id: w(),
  name: p().nullable(),
  imgUrl: p().nullable(),
  sku: p().nullable(),
  quantity: w(),
  unitPrice: w(),
  isShopNow: N()
}), Cee = sv.pick({
  id: !0,
  idFromPlatform: !0,
  status: !0,
  amount: !0,
  capturedOn: !0,
  authorizationExpiresOn: !0,
  currencyCode: !0
}), X6 = y({
  id: w(),
  externalId: p(),
  originalStoreOrderId: w(),
  createdOn: p(),
  customerPayment: Cee.nullable(),
  refundsIssued: w(),
  giftCardsIssued: w(),
  lineItems: O(xee)
}), wee = y({
  availableAmount: w().nullable(),
  refundAmount: w(),
  canCoverRefund: N()
}), Eee = ke("matched", [
  y({
    lineItemId: w(),
    matched: P(kd.exact),
    /** What one unit of the traced line is worth on the originating order, prorated across the exchange. */
    unitPrice: w(),
    unitTax: w(),
    suggestedAmount: w(),
    originatingOrderId: w()
  }),
  y({
    lineItemId: w(),
    matched: ne([kd.ambiguous, kd.unresolved]),
    unitPrice: Ps(),
    unitTax: Ps(),
    suggestedAmount: Ps(),
    originatingOrderId: Ps()
  })
]), Iee = y({
  currencyCode: p(),
  originalOrder: Z6,
  hops: O(y({
    claim: X6,
    exchangeOrder: Z6
  })),
  inputClaim: X6,
  lineTraces: O(Eee).describe("One per claim line item (lineItemId). exact: the line was traced to what the customer paid on originatingOrderId, and suggestedAmount is its credit. ambiguous (more than one earlier item matched) or unresolved (nothing in the chain matched): the amounts are null. With Claim Lineage on, that line stays at the $0 the exchange order was created at and the claim timeline says it could not be updated, so the merchant should enter what the customer paid on the line in the claim, using the original order in this lineage."),
  originRefund: wee.nullable().describe("Whether the original order can take this claim’s refunds, read live from the store platform. Null when the claim has no refund or the original order was resolved outside Corso. canCoverRefund false with an availableAmount: the original order has less left to refund than refundAmount, so finalizing still refunds it but the platform may reject or cap the refund; the merchant can lower the refund or issue store credit instead. availableAmount null: the original order could not be read, so whether it covers the refund is unknown, not a no."),
  truncated: N().describe("The chain was too long or could not be read to the end, so originalOrder may itself be an exchange order rather than the one the customer paid on, and $0 lines are unresolved. The merchant should value those lines by hand.")
}), Ree = y({
  id: w(),
  name: p(),
  namespace: p(),
  key: p(),
  createdOn: p()
}), cE = y({
  idFromPlatform: p(),
  name: p(),
  namespace: p(),
  key: p(),
  description: p().nullable()
}), Tee = cE.pick({
  idFromPlatform: !0
}), vv = y({
  id: w(),
  name: p().min(5, "Name must be at least 5 characters"),
  clientId: p(),
  createdOn: p(),
  updatedOn: p().optional()
}), _ee = vv.pick({
  name: !0
}), Oee = vv.extend({
  clientSecret: p()
}), uE = y({
  id: w(),
  clientId: p(),
  /** The client's display name in Auth0; null until the first lookup. */
  name: p().nullable(),
  createdOn: p(),
  lastUsedOn: p()
}), Aee = y({
  grants: O(uE)
}), dE = y({
  id: w(),
  name: X.nonEmptyString,
  customsSignerName: p().optional(),
  isQuickShipEnabled: N(),
  isGlobalEManaged: N(),
  address: uf
}), kee = dE.omit({
  id: !0,
  isGlobalEManaged: !0
}), hf = y({
  id: w(),
  isEnabled: N(),
  name: X.nonEmptyString,
  hook: $e(D.Hook),
  rule: D.ruleSchema,
  createdOn: p()
});
hf.omit({ createdOn: !0 });
const Dee = hf.omit({ id: !0, createdOn: !0 }), Vt = (e) => {
  const t = D.valueSchemaForFact(e).element, n = y({ label: p(), value: t });
  return We([
    // flat options
    O(n),
    // grouped options
    O(y({
      label: p(),
      options: O(n)
    }))
  ]);
}, Pee = y({
  [D.ArrayFactType.arbitrary]: y({
    [D.Fact.orderTags]: D.valueSchemaForFact(D.Fact.orderTags),
    [D.Fact.orderShippingLineTitle]: D.valueSchemaForFact(D.Fact.orderShippingLineTitle),
    [D.Fact.customerTags]: D.valueSchemaForFact(D.Fact.customerTags),
    [D.Fact.rmaStatus]: D.valueSchemaForFact(D.Fact.rmaStatus),
    [D.Fact.productTags]: D.valueSchemaForFact(D.Fact.productTags),
    [D.Fact.productTypes]: D.valueSchemaForFact(D.Fact.productTypes),
    [D.Fact.productCollections]: D.valueSchemaForFact(D.Fact.productCollections),
    [D.Fact.orderNumber]: D.valueSchemaForFact(D.Fact.orderNumber),
    [D.Fact.customerEmail]: D.valueSchemaForFact(D.Fact.customerEmail),
    [D.Fact.orderDiscountCode]: D.valueSchemaForFact(D.Fact.orderDiscountCode),
    [D.Fact.productVendor]: D.valueSchemaForFact(D.Fact.productVendor),
    [D.Fact.productSku]: D.valueSchemaForFact(D.Fact.productSku),
    [D.Fact.intelligemsTestGroupId]: D.valueSchemaForFact(D.Fact.intelligemsTestGroupId),
    [D.Fact.orderLineItemCustomPropertyName]: D.valueSchemaForFact(D.Fact.orderLineItemCustomPropertyName),
    [D.Fact.claimTags]: D.valueSchemaForFact(D.Fact.claimTags),
    [D.Fact.shippingClaimLineItemReorderSku]: D.valueSchemaForFact(D.Fact.shippingClaimLineItemReorderSku)
  }),
  [D.ArrayFactType.definite]: y({
    [D.Fact.orderCountry]: Vt(D.Fact.orderCountry),
    [D.Fact.shippingClaimResolutionMethod]: Vt(D.Fact.shippingClaimResolutionMethod),
    [D.Fact.userRole]: Vt(D.Fact.userRole),
    [D.Fact.orderProvince]: Vt(D.Fact.orderProvince),
    [D.Fact.claimLineItemRequestedResolutionMethod]: Vt(D.Fact.claimLineItemRequestedResolutionMethod),
    [D.Fact.returnShipmentStatus]: Vt(D.Fact.returnShipmentStatus),
    [D.Fact.reasonId]: Vt(D.Fact.reasonId),
    [D.Fact.reasonCategoryCode]: Vt(D.Fact.reasonCategoryCode),
    [D.Fact.reasonDetailId]: Vt(D.Fact.reasonDetailId),
    [D.Fact.claimType]: Vt(D.Fact.claimType),
    [D.Fact.orderChannel]: Vt(D.Fact.orderChannel),
    [D.Fact.claimLineItemCustomFieldResponse]: Vt(D.Fact.claimLineItemCustomFieldResponse),
    [D.Fact.orderGateway]: Vt(D.Fact.orderGateway),
    [D.Fact.registrationChannel]: Vt(D.Fact.registrationChannel),
    [D.Fact.orderFulfillmentLocationId]: Vt(D.Fact.orderFulfillmentLocationId),
    [D.Fact.productGroupId]: Vt(D.Fact.productGroupId),
    [D.Fact.customerSegmentId]: Vt(D.Fact.customerSegmentId),
    [D.Fact.orderFulfillmentDisplayStatus]: Vt(D.Fact.orderFulfillmentDisplayStatus),
    [D.Fact.orderFinancialStatus]: Vt(D.Fact.orderFinancialStatus),
    [D.Fact.claimLineItemInspectionGrade]: Vt(D.Fact.claimLineItemInspectionGrade),
    [D.Fact.returnShipmentLocationId]: Vt(D.Fact.returnShipmentLocationId),
    [D.Fact.rmaDisposition]: Vt(D.Fact.rmaDisposition),
    [D.Fact.claimRiskLevel]: Vt(D.Fact.claimRiskLevel),
    [D.Fact.shippingClaimReason]: Vt(D.Fact.shippingClaimReason)
  })
}), fE = {
  Claim_Created: "Claim_Created",
  Claim_Finalized: "Claim_Finalized",
  Claim_Updated: "Claim_Updated",
  Shipping_Claim_Created: "Shipping_Claim_Created",
  Shipping_Claim_Finalized: "Shipping_Claim_Finalized",
  Shipping_Claim_Updated: "Shipping_Claim_Updated",
  Registration_Created: "Registration_Created"
}, gm = {
  Pending: "Pending",
  Processing: "Processing",
  Delivered: "Delivered",
  Failed: "Failed"
}, yv = ne(fE), mE = y({
  id: w(),
  topic: yv,
  isEnabled: N()
}), pE = y({
  topic: yv,
  isEnabled: N()
}), hE = y({
  id: w(),
  isEnabled: N()
}), Nee = y({
  id: w(),
  name: p(),
  endpointUrl: Cn(),
  hmacSignatureSecret: p(),
  configWebhookEvents: O(mE)
}), Mee = y({
  name: X.nonEmptyString,
  endpointUrl: Cn(),
  configWebhookEvents: O(pE).min(1, "At least one topic must be selected")
}), Fee = y({
  name: X.nonEmptyString.optional(),
  endpointUrl: Cn().optional(),
  configWebhookEvents: O(hE).optional()
});
y({
  isEnabled: N()
});
const gE = y({
  id: w(),
  topic: p().nullable(),
  status: ne(gm),
  payload: uo().nullable(),
  responseStatus: w().nullable(),
  responseBody: p().nullable(),
  responseContentType: p().nullable(),
  createdOn: p(),
  lastAttemptOn: p().nullable(),
  nextRetryOn: p().nullable(),
  attempts: w(),
  canRetry: N()
}), vE = {
  success: "2xx",
  redirect: "3xx",
  clientError: "4xx",
  serverError: "5xx",
  noResponse: "none"
}, Lee = 90, $ee = 7, yE = y({
  statuses: O(ne(gm)).min(1).optional(),
  topics: O(yv).min(1).optional(),
  createdOn: ou.optional(),
  responseBuckets: O(ne(vE)).min(1).optional()
}), zee = y({
  filters: yE,
  cursor: y({
    id: w(),
    direction: We([P("next"), P("prev")])
  }).nullable(),
  orderBy: We([P("asc"), P("desc")]),
  take: w().default(50)
}), jee = y({
  data: O(gE),
  pageInfo: Jo,
  // counted over the same filters as `data`, so the tiles always reconcile with the rows
  statusCounts: nu(ne(gm), w())
}), Bee = y({
  id: w(),
  createdOn: p(),
  toDate: p(),
  fromDate: p(),
  invoicePdfUrl: p().nullish(),
  totalAmount: w(),
  isMonthlyCrew: N(),
  ordersCsvUrl: p().nullish(),
  reordersCsvUrl: p().nullish(),
  refundsCsvUrl: p().nullish(),
  adjustmentsCsvUrl: p().nullish(),
  /** In USD, signed as the invoice applies them: credits such as refunds and revenue share are negative */
  sections: O(y({ name: ne(mg), amount: w() }))
}), Gee = y({
  firstName: p(),
  lastName: p(),
  email: p().email(),
  estimatedAnnualReturns: w()
  // estimatedAnnualWarranties: z.number(),
}), Vee = qn.StoreUiConfig.customerUiConfigSchema, Uee = X.nonNegativeNumber.lt(1e4, {
  message: "Must be less than 10,000"
}), Hr = p().nullable(), fo = p().trim(), go = (e, t) => ({
  connect: y({
    action: P("connect"),
    ...e,
    ...t
  }),
  rotateSecret: y({
    action: P("rotateSecret"),
    ...e,
    ...t
  }),
  configure: y({ action: P("configure"), ...e })
}), yl = y({ action: P("disconnect") }), bE = y({
  id: w(),
  name: p(),
  // display name - non-editable
  sendAfterDays: w().nullable(),
  header: X.nonEmptyString,
  subject: X.nonEmptyString,
  body: X.nonEmptyString
}), Wee = bE.merge(y({
  isEnabled: N(),
  type: $e(yg)
})), Hee = bE.merge(y({
  type: $e(cf)
})), qee = y({
  isNewClaimEmailEnabled: N(),
  emailsForNewClaim: X.nullifiedEmailList,
  isClaimReceivedEmailEnabled: N(),
  emailsForClaimReceived: X.nullifiedEmailList,
  emailsForFinalizationFailure: X.nullifiedEmailList,
  isFailureToFinalizeEmailEnabled: N()
}), Yee = y({
  emailSendFrom: X.nullifiedEmail,
  emailSendFromName: X.nullifiedString,
  emailReplyTo: X.nullifiedEmail,
  emailReplyToName: X.nullifiedString,
  verifiedEmailDomain: p().nullable(),
  isAutoFinalizeEmailEnabled: N(),
  storeEmailTemplates: y({
    automatedEmailTemplates: O(Wee),
    finalizeEmailTemplates: O(Hee)
  })
}).superRefine(({ verifiedEmailDomain: e, emailSendFrom: t }, n) => {
  if (!t)
    return;
  Ki().endsWith(`@${e}`).or(P("noreply@corso.com")).safeParse(t).success || n.addIssue({
    code: "custom",
    path: ["emailSendFrom"],
    message: `Email send from must be a valid email address ending with ${e}.`
  });
}), SE = y({
  appSubscriptionStatus: $e(Sg),
  appSubscriptionConfirmationUrl: p(),
  isActive: N()
  // * is the store active (payment method configured, able to create claims)
}), Kee = y({
  startOauthUrl: p(),
  connected: P(!1)
}), xE = y({
  disconnectOauthUrl: p(),
  isEnabled: N(),
  isOrderTrackingEnabled: N(),
  connected: P(!0)
}), Zee = ke("connected", [
  Kee,
  xE
]), Xee = y({
  startOauthUrl: p(),
  connected: P(!1)
}), Jee = y({
  idFromPlatform: p(),
  connected: P(!0)
}), Qee = ke("connected", [
  Xee,
  Jee
]), ete = y({
  id: w(),
  shouldCreateRma: N(),
  maskedAccessToken: Hr
}), Dd = go({ shouldCreateRma: N() }, { accessToken: X.nonEmptyString }), tte = ke("action", [
  Dd.connect,
  Dd.rotateSecret,
  Dd.configure,
  yl
]), nte = Dd.connect.omit({ action: !0 }).extend({ accessToken: fo }), rte = y({
  id: w(),
  shouldCreateRma: N(),
  maskedRefreshToken: Hr
}), Pd = go({ shouldCreateRma: N() }, { refreshToken: X.nonEmptyString }), ote = ke("action", [
  Pd.connect,
  Pd.rotateSecret,
  Pd.configure,
  yl
]), ite = Pd.connect.omit({ action: !0 }).extend({ refreshToken: fo }), ate = y({
  id: w(),
  username: p(),
  maskedPassword: Hr,
  shouldCreateRma: N()
}), Nd = go({
  username: X.nonEmptyString,
  shouldCreateRma: N()
}, { password: X.nonEmptyString }), ste = ke("action", [
  Nd.connect,
  Nd.rotateSecret,
  Nd.configure,
  yl
]), lte = Nd.connect.omit({ action: !0 }).extend({ password: fo }), cte = y({
  id: w(),
  urlSlug: p(),
  maskedApiToken: Hr,
  shouldCreateRma: N()
}), Md = go({
  urlSlug: X.nonEmptyString,
  shouldCreateRma: N()
}, { apiToken: X.nonEmptyString }), ute = ke("action", [
  Md.connect,
  Md.rotateSecret,
  Md.configure,
  yl
]), dte = Md.connect.omit({ action: !0 }).extend({ apiToken: fo }), fte = y({
  id: w(),
  username: p(),
  maskedPassword: Hr,
  endpoint: p(),
  shouldCreateRma: N()
}), Fd = go({
  username: p(),
  endpoint: p(),
  shouldCreateRma: N()
}, { password: X.nonEmptyString }), mte = ke("action", [
  Fd.connect,
  Fd.rotateSecret,
  Fd.configure,
  yl
]), pte = Fd.connect.omit({ action: !0 }).extend({ password: fo }), hte = y({
  id: w(),
  maskedAccessToken: Hr
}), Ng = go({}, { accessToken: X.nonEmptyString }), gte = ke("action", [
  Ng.connect,
  Ng.rotateSecret,
  yl
]), vte = Ng.connect.omit({
  action: !0
}), yte = y({
  account: p(),
  scopes: p(),
  appUrl: p(),
  updateRequired: N(),
  teams: O(y({ id: w(), name: p() })).optional(),
  connected: P(!0)
}), bte = y({
  appUrl: p(),
  connected: P(!1)
}), Ste = ke("connected", [
  yte,
  bte
]), xte = y({
  id: w(),
  maskedApiKey: Hr,
  appIdVersion: p().nullable(),
  isEnabled: N(),
  triggerResync: N().optional(),
  appSettings: O(y({
    label: p(),
    key: We([
      P("storeId"),
      P("configId"),
      P("token")
    ]),
    value: p()
  }))
}), CE = y({
  id: w(),
  subdomain: p(),
  installationId: p()
}), fc = y({
  id: w(),
  idFromPlatform: p(),
  name: p(),
  ccsDetail: y({
    carrierCode: ne(Pi),
    services: O(ne(uv))
  }).optional()
}), gf = y({
  provider: We([
    P($o.easyPost),
    P($o.vesyl)
  ]),
  maskedApiKey: Hr,
  carriers: O(fc),
  enabledCarriers: O(fc),
  enabledCarriersMerchant: O(fc),
  isEnabled: N(),
  isCarrierCalculatedServiceEnabled: N()
}), wE = y({
  id: w(),
  startReturnUrl: p().optional(),
  idFromPlatform: p()
}), Cte = y({
  id: w(),
  maskedApiKey: Hr,
  isEnabled: N()
}), Ld = go({ isEnabled: N() }, { apiKey: X.nonEmptyString }), wte = y({
  id: w(),
  maskedAccessToken: Hr,
  webhookUrl: p(),
  isEnabled: N(),
  // Skio generates this when the webhook URL is registered, so it round-trips
  webhookToken: p()
}), $d = go({ isEnabled: N(), webhookToken: p() }, { accessToken: X.nonEmptyString }), Ete = ke("action", [
  $d.connect,
  $d.rotateSecret,
  $d.configure
]), Ite = $d.connect.omit({ action: !0 }).extend({ accessToken: fo }), Rte = y({
  id: w()
}), Tte = y({ id: w() }), _te = y({
  id: w(),
  startRegistrationUrl: p()
}), Ote = y({ id: w() }), EE = y({
  id: w(),
  isEnabled: N(),
  merchantGuid: p(),
  replacementOrderShippingTitle: X.optionalizedString
}), IE = y({
  id: w(),
  shouldCreateRma: N()
}), RE = y({
  id: w(),
  retailerId: p(),
  isEnabled: N()
}), TE = y({
  id: w(),
  isEnabled: N(),
  corsoWebhookUrl: p(),
  maskedWebhookToken: Hr,
  // a string in and a string out, so react-hook-form can infer the field type
  webhookId: p().transform((e) => {
    const t = e.trim(), n = t.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi);
    return (n == null ? void 0 : n[n.length - 1]) ?? t;
  }).pipe(p().uuid({
    message: "Please provide a valid webhook ID or a URL containing one (e.g., 123e4567-e89b-12d3-a456-426614174000)"
  })),
  maskedHmacSignatureSecret: Hr
}), vf = go({
  isEnabled: N(),
  webhookId: TE.shape.webhookId
}, {
  webhookToken: X.nonEmptyString,
  hmacSignatureSecret: X.nonEmptyString
}), Ate = vf.rotateSecret.extend({
  webhookToken: X.nonEmptyString.optional(),
  hmacSignatureSecret: X.nonEmptyString.optional()
}).refine(({ webhookToken: e, hmacSignatureSecret: t }) => !!e || !!t, { message: "Provide a new webhook token or HMAC signature secret." }), kte = vf.connect.omit({ action: !0 }).extend({
  webhookToken: fo,
  hmacSignatureSecret: fo
}), Dte = y({
  appSubscription: SE,
  stripeConfig: Qee,
  klaviyoConfig: Zee,
  happyReturnsConfig: RE.nullable(),
  twoBoxesConfig: TE.nullable(),
  logiwaConfig: IE.nullable(),
  kustomerConfig: xte.nullable(),
  zendeskConfig: CE.nullable(),
  vesylConfig: gf.nullable(),
  rechargeConfig: Cte.nullable(),
  shipHeroConfig: rte.nullable(),
  gorgiasConfig: Ste,
  shipBobConfig: ete.nullable(),
  statusConfig: wE.nullable(),
  gladlyConfig: Rte.nullable(),
  easyPostConfig: gf.nullable(),
  blueBoxConfig: ate.nullable(),
  masonHubConfig: cte.nullable(),
  sendLaneConfig: hte.nullable(),
  zowieConfig: Ote.nullable(),
  globalEConfig: EE.nullable(),
  brijConfig: _te.nullable(),
  localizeConfig: Tte.nullable(),
  xbFulfillmentConfig: fte.nullable(),
  skioConfig: wte.nullable()
}), _E = y({
  statusConfig: wE.omit({
    id: !0,
    startReturnUrl: !0
  }).merge(y({
    disconnect: N().optional()
  })),
  kind: P("statusConfig")
}), zd = go({
  provider: gf.shape.provider,
  isEnabled: N(),
  isCarrierCalculatedServiceEnabled: N(),
  enabledCarriers: O(fc.omit({ ccsDetail: !0 })),
  enabledCarriersMerchant: O(fc.omit({ ccsDetail: !0 }))
}, { apiKey: X.nonEmptyString }), bv = ke("action", [
  zd.connect,
  zd.rotateSecret,
  zd.configure
]), Pte = zd.connect.omit({ action: !0 }).extend({ apiKey: fo }), OE = y({
  kind: P("rechargeConfig"),
  rechargeConfig: ke("action", [
    Ld.connect,
    Ld.rotateSecret,
    Ld.configure
  ])
}), Nte = Ld.connect.omit({ action: !0 }).extend({ apiKey: fo }), AE = y({
  kind: P("vesylConfig"),
  vesylConfig: bv
}), kE = y({
  kind: P("easyPostConfig"),
  easyPostConfig: bv
}), Mte = y({
  provider: We([
    P($o.easyPost),
    P($o.vesyl)
  ])
}), DE = y({
  shipHeroConfig: ote,
  kind: P("shipHeroConfig")
}), PE = y({
  shipBobConfig: tte,
  kind: P("shipBobConfig")
}), NE = y({
  blueBoxConfig: ste,
  kind: P("blueBoxConfig")
}), ME = y({
  masonHubConfig: ute,
  kind: P("masonHubConfig")
}), FE = y({
  sendLaneConfig: gte,
  kind: P("sendLaneConfig")
}), LE = y({
  klaviyoConfig: xE.omit({
    connected: !0,
    disconnectOauthUrl: !0
  }),
  kind: P("klaviyoConfig")
}), Fte = y({
  metrics: O($e(d8)).min(1),
  claimExternalId: p().trim().optional()
}), Lte = y({
  metric: $e(d8),
  status: ne(["sent", "skipped", "failed"]),
  detail: p().optional()
}), $te = O(Lte), $E = y({
  xbFulfillmentConfig: mte,
  kind: P("xbFulfillmentConfig")
}), zE = y({
  skioConfig: Ete,
  kind: P("skioConfig")
}), jd = go({
  isEnabled: N(),
  triggerResync: N().optional()
}, { apiKey: X.nonEmptyString }), jE = y({
  kind: P("kustomerConfig"),
  kustomerConfig: ke("action", [
    jd.connect,
    jd.rotateSecret,
    jd.configure
  ])
}), zte = jd.connect.omit({ action: !0 }).extend({ apiKey: fo }), jte = y({
  kind: P("zendeskConfig"),
  zendeskConfig: CE.omit({ id: !0 })
}), BE = y({
  logiwaConfig: IE.omit({ id: !0 }),
  kind: P("logiwaConfig")
}), GE = y({
  happyReturnsConfig: RE.omit({ id: !0, retailerId: !0 }),
  kind: P("happyReturnsConfig")
}), VE = y({
  twoBoxesConfig: ke("action", [
    vf.connect,
    Ate,
    vf.configure
  ]),
  kind: P("twoBoxesConfig")
}), UE = y({
  globalEConfig: EE.omit({ id: !0 }).extend({ merchantGuid: X.nonEmptyString }),
  kind: P("globalEConfig")
}), Bte = ke("kind", [
  DE,
  VE,
  AE,
  kE,
  PE,
  _E,
  OE,
  NE,
  ME,
  FE,
  LE,
  $E,
  zE,
  jE,
  jte,
  BE,
  UE,
  GE
]), Gte = y({
  isReturnsEnabled: N(),
  isGiftReturnEnabled: N(),
  isReturnProcessApiEnabled: N(),
  allowClaimsOnPartiallyFulfilledOrders: N(),
  returnPolicyUrl: X.nullifiedUrl,
  isReturnInspectionEnabled: N(),
  claimWindowStartEvent: ne(ec),
  inventoryBehavior: ne(Od),
  shouldConsolidateOrdersAtFinalization: N(),
  isClaimImageFromCustomerRequired: N(),
  exchangeOrderPrefix: X.nullifiedString,
  returnOrderPrefix: X.nullifiedString,
  replacementOrderDiscountCode: X.nullifiedString,
  exchangeOrderDiscountCode: X.nullifiedString,
  defaultReturnExpirationDays: X.policyDays
}), Vte = y({
  refundValidityDays: X.policyDays
}), Ute = Dw(y({
  giftCardValidityDays: X.policyDays,
  giftCardProductIdFromPlatform: X.nullifiedString,
  giftCardOrderPrefix: X.nullifiedString,
  giftCardType: ne(dc),
  giftCardAttributes: qn.StoreSettings.giftCardAttributes,
  giftCardExpirationDays: X.nonNegativeNumber.nullable()
}), ke("giftCardIncentiveType", [
  y({
    giftCardIncentiveType: P(Qr.fixed),
    giftCardIncentiveAmount: Uee
  }),
  y({
    giftCardIncentiveType: P(Qr.percent),
    giftCardIncentiveAmount: w().min(0).max(100)
    // TODO make this a value between 0 and 1 with a maximum of 2 fractional digits to match the database schema
  }),
  y({
    giftCardIncentiveType: P(Qr.none),
    giftCardIncentiveAmount: X.nonNegativeNumber
  })
])), Wte = y({
  variantExchangeValidityDays: X.policyDays,
  variantExchangeShippingTitle: X.nullifiedString,
  minInventoryAvailableToCustomer: X.nonNegativeNumber,
  /** @deprecated inert when `isClaimLineageEnabled`; remove once claim lineage is on for every store */
  isExchangeOfExchangeAllowed: N(),
  /** @deprecated inert when `isClaimLineageEnabled`; remove once claim lineage is on for every store */
  isExchangeOfExchangeCreditEnabled: N(),
  isClaimLineageEnabled: N(),
  isExchangeRecommendationEnabled: N()
}), Hte = y({
  // main setting control for registrations
  isRegistrationEnabled: N(),
  shouldCollectRegistrationEmailMarketingConsent: N(),
  emailMarketingConsentPolicyUrl: X.nullifiedUrl,
  useProductListPriceOnRegistration: N(),
  shouldCollectRegistrationProofOfPurchase: N(),
  shouldCollectRegistrationAddress: N(),
  isRegistrationWarrantyClaimEnabled: N(),
  isAutomatedRegistrationEnabled: N(),
  customFields: O(y({
    id: w(),
    name: p(),
    isRequired: N()
  })),
  // sales channels where product registration is offered
  offeredSalesChannels: O(p()),
  // all possible sales channels
  salesChannelOptions: O(y({
    id: w(),
    name: p()
  }))
}), qte = y({
  isOrderEditingEnabled: N(),
  orderEditingWindowMinutes: w().min(0),
  orderEditingWindowOverrides: qn.StoreSettings.orderEditingWindowOverrides.default([]),
  shouldHoldOrdersWithinEditWindow: N(),
  orderHoldReleaseTag: p().default("CORSO-OE-HOLD"),
  shouldUseCreditRefundForOrderEdits: N(),
  isRevertUnpaidEditsEnabled: N()
}), Yte = y({
  isTrackingEnabled: N(),
  trackingEventProvider: ne(vg)
}), Kte = y({
  isWarrantiesEnabled: N(),
  warrantyPolicyUrl: X.nullifiedUrl,
  defaultWarrantyDays: X.policyDays,
  isWarrantyInspectionEnabled: N(),
  warrantyOrderPrefix: X.nullifiedString,
  isMultipleWarrantyClaimsAllowed: N(),
  defaultWarrantyRequestedResolutionMethod: ne(rt),
  warrantyGiftCardType: ne(dc)
}), Zte = y({
  idFromPlatform: p(),
  rangeStart: w(),
  rangeEnd: w(),
  productVariant: y({
    price: p(),
    title: p(),
    options: O(y({ name: p(), value: p() })),
    imgUrl: p().nullable(),
    sku: p().nullable(),
    deletedOnPlatform: N().optional()
  }).optional(),
  implementationType: We([
    ne(["Shipping_Line"]),
    ne(["Product_Variant"])
  ])
}), WE = y({
  isWidgetProtectionConfigured: N(),
  isZeroDollarReorderEnabled: N(),
  shipProtectOrderTag: p().nullable(),
  isCheckoutPlusEnabled: N(),
  isCheckoutPlusScriptConfigured: N(),
  // ? theme app embed
  activateCheckoutPlusEmbedUrl: p(),
  zeroDollarReorderDiscountTitle: p().nullable(),
  /**
   * @deprecated
   */
  checkoutPlusScriptUrl: p().nullable(),
  accessScopes: O(p()),
  // ? used to determine which scopes are enabled for the store
  // ? Shipping Plus Protection
  isShippingLineProtectionOffered: N(),
  isCarrierServiceConfigured: N(),
  isApplicationDiscountConfigured: N(),
  isRefundMultipleGspEnabled: N(),
  // ? related to both types of protection
  isClaimImageFromCustomerRequired: N(),
  fulfillmentStrategy: ne(zs),
  shouldSendPurchaseConfirmation: N(),
  offeredClaimReasons: O(ne(Xt)),
  giftCardProductIdFromPlatform: X.nullifiedString,
  shipProtectSet: y({
    units: O(Zte),
    name: p(),
    code: p(),
    maxProtectionValue: w(),
    minProtectionValue: w(),
    product: y({
      idFromPlatform: p(),
      title: p(),
      platformUrl: p()
    })
  }),
  widgetConfig: qn.StoreShipProtectSettings.widgetConfigSchema
}), Xte = y({
  email: Yee,
  returns: Gte,
  refunds: Vte,
  giftCards: Ute,
  variantExchanges: Wte,
  warranties: Kte,
  notifications: qee,
  shippingProtection: WE,
  registrations: Hte,
  orderEditing: qte,
  tracking: Yte,
  inspectionGrades: O(y({
    id: w(),
    name: p(),
    code: ne(to)
  }))
}), Jte = Dte, Qte = Bte, Mp = {
  originalStoreOrderId: w().optional(),
  kustomerEventId: p().nullable()
}, ene = y({
  id: w(),
  firstName: p().nullable(),
  lastName: p().nullable(),
  email: p().nullable(),
  phone: p().nullable(),
  totalOrders: w(),
  orders: O(y({
    orderNo: p(),
    idFromPlatform: p(),
    createdOn: p(),
    orderTotal: p(),
    claims: O(pf.extend(Mp)),
    shipProtectClaims: O(L5.extend(Mp))
  })),
  registrations: O(rE.extend(Mp)),
  claims: lv,
  shippingClaims: pm
}), tne = y({
  email: p(),
  claims: lv,
  shippingClaims: pm
}), nne = y({
  storeId: w(),
  hasCompletedOnboarding: N(),
  userEmails: O(p())
}), rne = {
  ShopifyPlus: "Shopify Plus",
  BasicAppDevelopment: "Basic App Development",
  Basic: "Basic",
  Advanced: "Advanced",
  Shopify: "Shopify",
  DeveloperPreview: "Developer Preview",
  PauseAndBuild: "Pause and Build",
  ShopifyPlusPartnerSandbox: "Shopify Plus Partner Sandbox",
  PlusTrial: "Plus Trial",
  Frozen: "Frozen",
  Development: "Development",
  Staff: "Staff",
  StaffBusiness: "Staff Business",
  ShopifyStarter: "Shopify Starter",
  Cancelled: "Cancelled",
  OpenLearning: "Open Learning",
  Custom: "Custom",
  ShopifyAlumni: "Shopify Alumni",
  Trial: "Trial",
  Grow: "Grow",
  ShopifyPlusAppDevelopment: "Shopify Plus App Development",
  AdvancedAppDevelopment: "Advanced App Development",
  GrowAppDevelopment: "Grow App Development"
}, one = y({
  id: w(),
  name: p(),
  shopifyPlan: ne(rne).nullable(),
  estimatedAnnualReturns: w().optional(),
  invoiceDefinition: y({
    endDate: p(),
    id: w()
  }).optional(),
  ianaTimezone: p().optional(),
  customerAppUrl: p(),
  currencyCode: p(),
  currencySymbol: p(),
  isTest: N().optional(),
  isCrewInstalled: N(),
  featureFlags: qn.Store.featureFlags,
  url: p().optional()
}), HE = y({
  storeId: w(),
  roleCode: $e(Wt),
  store: one
}), qE = y({
  email: p().trim().email("Invalid email"),
  firstName: p().min(1, "First name is required"),
  lastName: p().min(1, "Last name is required")
}), ine = y({
  roleCode: $e(Wt),
  organizationId: w(),
  storeIds: O(w()),
  organizationName: p(),
  isCorsoOrg: N()
}), YE = y({
  id: w(),
  idFromPlatform: p(),
  storeUserRoles: O(HE),
  organizationUserRoles: O(ine)
}).merge(qE);
//! not to future use, the merchant admin operates with a single role for a user
const Sv = YE.omit({
  storeUserRoles: !0,
  organizationUserRoles: !0,
  idFromPlatform: !0
}).merge(y({
  storeUserRole: HE.omit({ store: !0 }),
  organizations: O(y({
    organizationId: w(),
    organizationName: p()
  })).optional()
})), ane = Sv.omit({
  id: !0,
  organizations: !0
}).required(), xv = qE, KE = xv.merge(y({
  estimatedAnnualClaims: p(),
  phone: p().optional(),
  productsOfInterest: O(p()).min(1, "Select at least one product")
})), sne = ke("isOnboardingComplete", [
  xv.merge(y({ isOnboardingComplete: P(!0) })),
  KE.merge(y({ isOnboardingComplete: P(!1) }))
]), lne = Sv.pick({
  id: !0,
  firstName: !0,
  lastName: !0,
  email: !0,
  storeUserRole: !0
}).required();
var W;
(function(e) {
  e.frontEndUrlPaths = [
    ":storeId/settings/integrations",
    // ? used by the API to redirect to the merchant-ui after app subscription generation + stripe subscription
    ":storeId/claims/:claimType/:claimId",
    // ? used by the API to redirect to a specific claim in the merchant-ui
    ":storeId/registrations/:registrationId",
    // ? used by the API to redirect to a specific registration in the merchant-ui
    ":storeId/settings/email",
    ":storeId/settings/shipping-policies",
    ":storeId/claims/shipping/:shippingClaimId",
    // ? deep link to a specific shipping (GSP) claim in the merchant-ui
    ":storeId/orders/lookup/:idFromPlatform",
    // ? deep link to a specific order in the merchant-ui
    ":storeId/settings/automations/edit/:storeRuleId"
    // ? deep link to a specific automation in the merchant-ui
  ], e.shippingClaimCreatedTimelineEventTitle = "Created shipping claim.", e.ORDER_PREFIX_DEFAULT = {
    exchange: "#C-EX-",
    returnReplacement: "#C-RO-",
    warrantyReplacement: "#C-WR-",
    giftCard: "#C-GC-"
  }, e.CREW_DISCOUNT_CODE = "crew-discount", e.MERCHANT_APP_JWT_QUERY_KEY = "accessCode", e.invoiceSchema = Bee, e.storeIdentityGrantSchema = vv, e.storeIdentityGrantCreateSchema = _ee, e.storeIdentityGrantWithClientSecretSchema = Oee, e.userMcpIdentityGrantSchema = uE, e.userMcpIdentityGrantsSchema = Aee, e.Carrier = Pi, e.CarrierService = uv, e.protectionRateSchema = Pg, e.protectionRateUpdateSchema = Pg, e.protectionRateCreateSchema = TQ, e.storeCustomerSchema = ene, e.conciergeCustomerSchema = tne, e.userAccessCodeSchema = nne, e.appSubscriptionSchema = SE, e.userWithStoreUserRolesSchema = YE, e.storeUserSchema = Sv, e.storeUserCreateSchema = ane, e.storeUserUpdateSchema = lne, e.signedUrlSchema = oE, e.returnLocationSchema = dE, e.returnLocationCreateSchema = kee, e.inspectionTemplateSchema = u5, e.claimInspectionSettingsSchema = OX, e.claimFinalizePayloadSchema = N5, e.ClaimFinalizeApprovedLineItemSchema = WX, e.claimTimelineSchema = Ag, e.claimTimelineEventSchema = V6, e.timelineSchema = Ag, e.timelineEventSchema = V6, e.timelineUserSchema = T5, e.claimNotifyByEmailSchema = fm, e.claimNeedsMoreInfoSchema = OJ, e.claimReasonSchema = ja, e.claimReasonCreateSchema = IX, e.claimReasonUpdateSchema = EX, e.claimReasonDetailUpdateSchema = c5, e.claimReasonGroupSchema = Q0, e.claimReasonGroupUpdateSchema = RX, e.claimReasonGroupCreateSchema = TX, e.claimSchema = ua, e.claimUpdateCustomerInfoSchema = TJ, e.claimUpdateRefundHandlingFeeSchema = _J, e.claimTagSchema = ki, e.claimTagCreateSchema = ki.omit({ id: !0 }), e.shippingClaimTagSchema = ki, e.shippingClaimTagCreateSchema = ki.omit({ id: !0 }), e.registrationTagSchema = ki, e.registrationTagCreateSchema = ki.omit({ id: !0 }), e.claimMinimumDataSchema = pf, e.claimListSchema = lv, e.claimListCountSchema = RJ, e.claimListItemSchema = pf, e.claimLineItemSchema = ca, e.claimShipmentQuoteAndBuySchema = gJ, e.claimReturnShipmentCreateSchema = fJ, e.claimReturnShipmentQuoteSchema = mJ, e.claimReturnShipmentQuoteResponse = vJ, e.claimLineItemInspectionSchema = tv, e.claimLineItemInspectionCreateSchema = DX, e.claimAddressSchema = Wr, e.verifyAddressResponseSchema = HK, e.claimCustomerPaymentSchema = sv, e.settingsConfigSchema = Xte, e.orderShipmentsSchema = nJ, e.settingsThemeSchema = Vee, e.settingsIntegrationSchema = Jte, e.shipProtectSettingsSchema = WE, e.blueBoxUpdateSchema = NE, e.masonHubUpdateSchema = ME, e.shipBobUpdateSchema = PE, e.shipHeroUpdateSchema = DE, e.skioConfigUpdateSchema = zE, e.kustomerConfigUpdateSchema = jE, e.xBFulfillmentUpdateSchema = $E, e.klaviyoConfigUpdateSchema = LE, e.klaviyoTestEventSchema = Fte, e.klaviyoTestEventResponseSchema = $te, e.sendlaneUpdateSchema = FE, e.shippingProviderUpdateSchema = bv, e.shippingProviderSchema = gf, e.shippingProviderRefreshSchema = Mte, e.vesylUpdateSchema = AE, e.rechargeUpdateSchema = OE, e.easyPostUpdateSchema = kE, e.statusConfigUpdateSchema = _E, e.logiwaUpdateSchema = BE, e.twoBoxesUpdateSchema = VE, e.globalEUpdateSchema = UE, e.happyReturnsUpdateSchema = GE, e.settingsIntegrationUpdateSchema = Qte, e.shipHeroConfigFormSchema = ite, e.shipBobConfigFormSchema = nte, e.blueBoxConfigFormSchema = lte, e.masonHubConfigFormSchema = dte, e.xbFulfillmentConfigFormSchema = pte, e.sendLaneConfigFormSchema = vte, e.skioConfigFormSchema = Ite, e.kustomerConfigFormSchema = zte, e.twoBoxesConfigFormSchema = kte, e.rechargeConfigFormSchema = Nte, e.shippingProviderFormSchema = Pte, e.ConfigWebhookTopic = fE, e.ConfigWebhookDeliveryStatus = gm, e.configWebhookSchema = Nee, e.configWebhookCreateSchema = Mee, e.configWebhookUpdateSchema = Fee, e.configWebhookEventSchema = mE, e.configWebhookEventCreateSchema = pE, e.configWebhookEventUpdateSchema = hE, e.configWebhookDeliverySchema = gE, e.ConfigWebhookDeliveryResponseBucket = vE, e.configWebhookDeliveryFiltersSchema = yE, e.configWebhookDeliverySearchReqSchema = zee, e.configWebhookDeliverySearchRespSchema = jee, e.CONFIG_WEBHOOK_DELIVERY_MAX_LOOKBACK_DAYS = Lee, e.CONFIG_WEBHOOK_DELIVERY_DEFAULT_LOOKBACK_DAYS = $ee, e.storeProductSchema = iu, e.storeProductListSchema = j6, e.storeProductDetailSchema = KZ, e.storeProductTypeSchema = j8, e.storeProductTagSchema = B8, e.storeProductCollectionSchema = G8, e.storeProductGroupSchema = Js, e.storeProductGroupCreateSchema = eX, e.storeProductImportSchema = tX, e.storeProductImportAcceptedSchema = nX, e.storeProductUpdateSchema = JZ, e.storeProductGroupMembershipSchema = ZZ, e.storeProductRegistrationChannelsSchema = XZ, e.storeProductsForGroupSchema = QZ, e.storeProductGroupUpdateSchema = Js, e.apiClientRespSchema = X5, e.merchantOnboardSchema = Gee, e.arrayFactDataSchema = Pee, e.storeRuleSchema = hf, e.storeRuleUpdateSchema = hf, e.storeRuleCreateSchema = Dee, e.customFieldSchema = vl, e.customFieldCreateSchema = vX, e.customFieldUpdateSchema = yX, e.storeMetafieldSchema = Ree, e.platformMetafieldSchema = cE, e.storeMetafieldCreateSchema = Tee, e.claimLineItemUpdateSchema = VX, e.claimLineItemFeeUpdateSchema = AX, e.crewOrderSchema = fv, e.claimCreateSchema = D5, e.variantExchangeResponseSchema = W8, e.shippingClaimSchema = M5, e.shippingClaimMessagesSchema = DJ, e.shippingClaimListSchema = pm, e.shippingClaimFinalizeSchema = kJ, e.shippingClaimCreateSchema = F5, e.shippingClaimLineItemAddSchema = PJ, e.shippingClaimInventoryLevelsSchema = $J, e.shippingClaimUpdateSchema = MJ, e.shippingClaimUpdateCustomerInfoSchema = FJ, e.storeUserSignupCreateSchema = sne, e.storeUserSignUpSchema = xv, e.storeUserSignUpAndOnboardSchema = KE, e.registrationSchema = su, e.registrationUpdateSchema = $Q, e.registrationListSchema = zQ, e.searchReqSchema = AK, e.conciergeSearchReqSchema = kK, e.MAX_SEARCH_TERM_LENGTH = 100, e.searchRespSchema = ke("kind", [
    y({
      data: e.shippingClaimListSchema,
      kind: P(Qt.Shipping),
      pageInfo: Jo
    }),
    y({
      data: MQ,
      kind: P(Qt.Order),
      pageInfo: Jo
    }),
    y({
      data: e.claimListSchema,
      kind: P(Qt.Return),
      pageInfo: Jo
    }),
    y({
      data: e.claimListSchema,
      kind: P(Qt.Warranty),
      pageInfo: Jo
    }),
    y({
      data: e.registrationListSchema,
      kind: P(Qt.Registration),
      pageInfo: Jo
    }),
    y({
      data: j6,
      kind: P("Product"),
      pageInfo: Jo
    })
  ]), e.searchViewSchema = PK, e.searchViewDateSchema = Xa, e.reportFilters = hl, e.reportDefinition = pl, e.reportInlineRun = FK, e.reportDefinitionCreate = x8, e.reportDefinitionUpdate = LK, e.reportDefinitionResponseSchema = $K, e.storeAlertSchema = cv, e.storeAlertUpdateSchema = JJ, e.storeAlertCreateSchema = U5, e.widgetRefSchema = y({
    ref: ne(["corso-concierge", "kustomer", "zendesk"])
  });
  const t = e.widgetRefSchema.safeExtend({
    email: Ki()
  }), n = t.safeExtend({
    ref: P("corso-concierge"),
    // provided as a query parameter by Front, which is the current integration context our agents use; https://dev.frontapp.com/docs/security#token-verification
    auth_secret: p().nonempty()
  }), r = t.safeExtend({
    ref: P("kustomer"),
    // these are intended to be usable as a pattern for all integrations
    configId: Ee(),
    token: p().nonempty()
  }), o = t.safeExtend({
    ref: P("zendesk"),
    /** `origin` provided a query parameter by Zendesk to the `iframe`d app */
    origin: Cn().regex(/^https?:\/\/(?<subdomain>.*)\.zendesk\.com/, {
      message: "Invalid Zendesk Origin URL"
    }),
    installationId: p()
  });
  e.tokenAuthSchema = ke("ref", [
    // TODO assertion verifying that each ref is present
    n,
    r,
    o
  ]), e.kustomerCardSearchSchema = r.safeExtend({
    customerEmail: p(),
    customerId: p(),
    customerName: p(),
    appIdVersion: p()
  }), e.claimRiskAssessmentSchema = g8, e.shippingClaimRiskAssessmentSchema = t5, e.claimOrderLineageSchema = Iee, e.storeDiscountDefinitionSchema = l5, e.discountDefinitionSchema = Z0, e.amountOffOrderRawSchema = a5, e.amountOffProductRawSchema = s5;
})(W || (W = {}));
const cne = {
  syncShippingZones: "syncShippingZones",
  createCheckoutPlusScript: "createCheckoutPlusScript",
  deleteCheckoutPlusScript: "deleteCheckoutPlusScript",
  checkoutPlusProducts: "checkoutPlusProducts",
  bulkUpdateDiscounts: "bulkUpdateDiscounts"
}, ZE = "/user", une = `${ZE}/token/login`, XE = `${ZE}/:idFromPlatform`, dne = y({ idFromPlatform: p() }), fne = `${XE}/mcp-identity-grant`;
dne.extend({
  identityGrantId: Ee()
});
const mne = "/merchant-paid-protect-set", pne = "/users";
y({ accessCode: p() });
const hne = "/signed-url", yn = "/:storeId", Gt = y({ storeId: Ee() }), gne = `${yn}/search`, vne = `${yn}/report`, yne = "/concierge/search", bne = "/concierge/customer", Sne = `${vne}/front`, xne = ne(nK), Cne = y({ entity: xne }).merge(Gt);
y({ definitionId: Ee() }).merge(Cne);
y({ definitionId: Ee() }).merge(Gt);
y({ viewId: Ee() }).merge(Gt);
y({ tagId: Ee() }).merge(Gt);
const vm = `${yn}/shipping-protection`, wne = `${vm}/configure`, Ene = `${vm}/checkout-plus-embed`, JE = `${vm}/rate`, Ine = `${JE}/:rateId`;
Gt.merge(y({ rateId: Ee() }));
const Cv = `${vm}/claim`, QE = `${yn}/registration`, wv = `${QE}/:registrationId`, Rne = `${QE}/tags`, Tne = `${wv}/tags`, _ne = `${wv}/timeline`;
y({ idFromPlatform: Ee() }).merge(Gt);
y({ storeProductId: Ee() }).merge(Gt);
const eI = `${yn}/custom-field`, One = `${eI}/:customFieldId`, Ev = `${yn}/metafield`, Ane = `${Ev}/platform`, kne = `${Ev}/:metafieldId`, tI = `${yn}/automation`, Dne = `${tI}/:automationId`, Pne = `${yn}/fact/values`, Nne = `${yn}/invoice`, Mne = `${yn}/customer-payment`, Fne = `${Mne}/:customerPaymentId`, Lne = `${Fne}/refund`, ym = `${yn}/settings`, $ne = `${ym}/theme`, zne = `${ym}/config`, Iv = `${ym}/integrations`, nI = `${ym}/identity-grant`, jne = `${nI}/:identityGrantId`, Bne = `${Iv}/shipping-provider/refresh`, Gne = `${Iv}/klaviyo/test`, Vne = `${yn}/order`, rI = `${Vne}/:storeOrderId`, Une = `${rI}/tracking`, Wne = `${rI}/line-item/:lineItemId`, Rv = `${yn}/claim`, Hne = `${Rv}/tags`, qne = `${yn}/customer`, vo = `${Rv}/:claimId`, Yne = `${vo}/fees`, Kne = `${vo}/risk`, Zne = `${vo}/customer-info`, Xne = `${vo}/tags`, Jne = `${vo}/timeline`, Qne = `${vo}/order-lineage`, ere = `${vo}/finalize`, Tv = `${vo}/shipment`, tre = `${Tv}/quote`, nre = `${Tv}/quote-and-create`, rre = `${vo}/request-info`, ore = `${vo}/line-item`, bm = `${ore}/:claimLineItemId`, ire = `${bm}/fee/:claimLineItemFeeId`, oI = `${bm}/media`, are = `${oI}/:claimLineItemImageId`, iI = `${bm}/inspection`, sre = `${iI}/settings`, rr = `${Cv}/:shippingClaimId`, lre = `${rr}/finalize`, cre = `${rr}/close`, ure = `${rr}/manual-refund`, dre = `${rr}/refund-shipping`, fre = `${rr}/manual-reorder`, mre = `${rr}/restore`, pre = `${rr}/timeline`, hre = `${rr}/messages`, gre = `${rr}/customer-info`, aI = `${rr}/line-item`, vre = `${aI}/:shippingClaimLineItemId`, yre = `${rr}/replacement-item/:replacementItemId`, bre = `${rr}/inventory-levels`, Sre = `${rr}/risk`, xre = `${rr}/tags`, Cre = `${Cv}/tags`, sI = `${yn}/return-location`, wre = `${sI}/:returnLocationId`, Ere = `${yn}/fulfillment-location`, lI = `${yn}/discount-definition`, Ire = `${lI}/:storeDiscountDefinitionId`, _v = `${yn}/claim-reason`, Rre = `${_v}/:claimReasonId`, cI = `${_v}/group`, Tre = `${cI}/:claimReasonGroupId`, Qa = `${yn}/product`, _re = `${Qa}/tag`, Ore = `${Qa}/type`, Are = `${Qa}/collection`, uI = `${Qa}/group`, kre = `${Qa}/import`, dI = `${uI}/:groupId`, Dre = `${dI}/list-products`, Ov = `${Qa}/:storeProductId`, Pre = `${Ov}/group`, Nre = `${Ov}/registration-channel`, Av = `${yn}/user`, Mre = `${Av}/sign-up`, Sm = `${Av}/:userId`, Fre = `${Sm}/reset-password`, fI = `${Sm}/conversations`, Lre = Gt.merge(y({ userId: Ee() })), mI = `${fI}/:conversationId`, $re = y({ conversationId: Ee() }).merge(Lre), zre = `${mI}/message/:messageId`;
y({ messageId: Ee() }).merge($re);
y({
  filename: O8,
  path: ne([
    "claimLineItem",
    "claimLineItemInspection",
    "customFieldReferenceImage"
  ])
});
y({
  searchTerm: p().optional(),
  take: Ee().optional(),
  fulfillmentLocationIdFromPlatform: p().optional(),
  applyInventory: sg().optional()
});
y({ automationId: Ee() }).merge(Gt);
y({
  customFieldId: Ee()
}).merge(Gt);
y({ metafieldId: Ee() }).extend(Gt.shape);
y({
  customerPaymentId: Ee()
}).merge(Gt);
const jre = y({ claimId: Ee() }).merge(Gt), pI = y({ shippingClaimId: Ee() }).merge(Gt);
pI.extend({
  shippingClaimLineItemId: Ee()
});
pI.extend({
  replacementItemId: p()
});
y({ registrationId: Ee() }).merge(Gt);
const kv = jre.merge(y({ claimLineItemId: Ee() }));
kv.merge(y({ claimInspectionId: Ee() }));
kv.merge(y({ claimLineItemFeeId: Ee() }));
y({ claimReasonId: Ee() }).merge(Gt);
y({ claimReasonGroupId: Ee() }).merge(Gt);
y({ returnLocationId: p() }).merge(Gt);
y({
  userId: Ee()
}).merge(Gt);
y({
  groupId: Ee()
}).merge(Gt);
We([
  y({
    idFromPlatform: p()
  }),
  y({
    emailOrPostalCode: p(),
    orderNo: p()
  })
]);
const Bre = y({ storeOrderId: Ee() }).merge(Gt);
Bre.extend({
  lineItemId: Ee()
});
const hI = `${Sm}/alert`, Gre = `${hI}/:alertId`;
y({ alertId: Ee(), userId: Ee() }).merge(Gt);
const gI = y({ webhookId: Ee() }).merge(Gt);
y({ eventId: Ee() }).merge(gI);
y({ deliveryId: Ee() }).extend(gI.shape);
hI + "", O(W.storeAlertSchema), W.storeAlertUpdateSchema, O(W.storeAlertSchema), Gre + "", W.storeAlertUpdateSchema, W.storeAlertSchema;
wv + "", W.registrationSchema, W.registrationUpdateSchema, W.registrationSchema, Rne + "", O(W.registrationTagSchema), W.registrationTagCreateSchema, W.registrationTagSchema, Tne + "", O(W.registrationTagSchema), O(W.registrationTagCreateSchema), O(W.registrationTagSchema), _ne + "", W.timelineEventSchema;
lI + "", l5.omit({ id: !0 }), Ire + "", y({ storeDiscountDefinitionId: Ee() }).merge(Gt);
qne + "", y({
  email: p()
}), W.storeCustomerSchema;
Cre + "", O(W.shippingClaimTagSchema), W.shippingClaimTagCreateSchema, W.shippingClaimTagSchema, xre + "", O(W.shippingClaimTagSchema), O(W.shippingClaimTagCreateSchema), O(W.shippingClaimTagSchema), Cv + "", W.shippingClaimCreateSchema, W.shippingClaimSchema, rr + "", W.shippingClaimSchema, W.shippingClaimUpdateSchema, W.shippingClaimSchema, aI + "", W.shippingClaimLineItemAddSchema, W.shippingClaimSchema, vre + "", W.shippingClaimSchema, yre + "", W.shippingClaimSchema, bre + "", W.shippingClaimInventoryLevelsSchema, Sre + "", W.shippingClaimRiskAssessmentSchema.nullable(), gre + "", W.shippingClaimUpdateCustomerInfoSchema, W.shippingClaimSchema, hre + "", W.shippingClaimMessagesSchema, pre + "", W.timelineEventSchema, lre + "", W.shippingClaimFinalizeSchema, W.shippingClaimSchema, cre + "", y({
  comment: p().optional(),
  status: We([
    P(jr.closedResolved),
    P(jr.closedDenied)
  ])
}), W.shippingClaimSchema, mre + "", y({
  comment: p().optional()
}), W.shippingClaimSchema, ure + "", y({
  amount: w().positive(),
  comment: p().optional()
}), W.shippingClaimSchema, fre + "", y({
  storeOrderId: w(),
  comment: p().optional()
}), W.shippingClaimSchema, dre + "", y({
  comment: p().optional()
}), W.shippingClaimSchema;
Rv + "", W.claimSchema, vo + "", W.claimSchema, ere + "", y({
  notifyCustomerByEmail: fm.optional(),
  noteToCustomer: X.optionalizedString,
  finalizationSource: N5.shape.finalizationSource
});
Kne + "", W.claimRiskAssessmentSchema.nullable(), Qne + "", W.claimOrderLineageSchema, Zne + "", W.claimUpdateCustomerInfoSchema, W.claimSchema, Yne + "", W.claimUpdateRefundHandlingFeeSchema, W.claimSchema, Xne + "", O(W.claimTagSchema), O(W.claimTagCreateSchema), O(W.claimTagSchema), rre + "", W.claimNeedsMoreInfoSchema, Tv + "", W.claimReturnShipmentCreateSchema, W.claimSchema, nre + "", W.claimShipmentQuoteAndBuySchema, tre + "", W.claimReturnShipmentQuoteSchema, W.claimReturnShipmentQuoteResponse, oI + "", y({
  filename: p()
}), W.claimSchema, are + "", y({ claimLineItemImageId: Ee() }).merge(kv), bm + "", W.claimLineItemUpdateSchema, W.claimSchema, ire + "", W.claimLineItemFeeUpdateSchema, W.claimSchema, W.claimSchema, iI + "", W.claimLineItemInspectionCreateSchema, W.claimLineItemInspectionSchema, Jne + "", W.claimTimelineEventSchema, _v + "", O(W.claimReasonSchema), W.claimReasonCreateSchema, W.claimReasonSchema, Rre + "", W.claimReasonUpdateSchema, W.claimReasonSchema, cI + "", O(W.claimReasonGroupSchema), W.claimReasonGroupCreateSchema, W.claimReasonGroupSchema, Tre + "", W.claimReasonGroupUpdateSchema, W.claimReasonGroupSchema, W.apiClientRespSchema, sre + "", W.claimInspectionSettingsSchema;
const Vre = "/organization/:organizationId/analytics", Ure = `${Vre}/currencies`;
y({ currency: p() });
y({
  organizationId: Ee()
});
Ure + "", y({ currencies: O(p()) });
yne + "", W.conciergeSearchReqSchema, W.searchRespSchema, bne + "", y({
  email: p()
}), W.conciergeCustomerSchema;
gne + "", W.searchReqSchema, W.searchRespSchema, Sne + "", O(qn.FrontReport.reportRawSchema), pne + "", W.userAccessCodeSchema, hne + "", W.signedUrlSchema, Lne + "", W.claimCustomerPaymentSchema;
Pne + "", W.arrayFactDataSchema;
tI + "", O(W.storeRuleSchema), W.storeRuleCreateSchema, W.storeRuleSchema;
Dne + "", W.storeRuleSchema, W.storeRuleUpdateSchema, W.storeRuleSchema, W.apiClientRespSchema;
nI + "", W.storeIdentityGrantCreateSchema, W.storeIdentityGrantWithClientSecretSchema, O(W.storeIdentityGrantSchema), jne + "", Gt.merge(y({ identityGrantId: Ee() }));
JE + "", W.protectionRateCreateSchema, W.protectionRateSchema, W.protectionRateSchema.array(), Ine + "", W.protectionRateUpdateSchema, W.protectionRateSchema, wne + "", y({
  method: $e(cne)
}), W.shipProtectSettingsSchema, Ene + "", y({ isActive: N() }), Nne + "", W.invoiceSchema.array(), Une + "", W.orderShipmentsSchema, Wne + "", y({
  madeIneligibleOn: p().nullable()
}), XE + "", W.userWithStoreUserRolesSchema, fne + "", W.userMcpIdentityGrantsSchema, mne + "", O(y({
  id: w(),
  chargeAmount: w()
})), une + "", W.tokenAuthSchema, y({
  user: W.userWithStoreUserRolesSchema,
  // signed session token the widget UI carries as a Bearer, since the
  // Kustomer/Zendesk flow has no Auth0 token
  sessionToken: p()
}), eI + "", O(W.customFieldSchema), W.customFieldCreateSchema, W.customFieldSchema, One + "", W.customFieldSchema, W.customFieldUpdateSchema, W.customFieldSchema, W.apiClientRespSchema, Ev + "", O(W.storeMetafieldSchema), W.storeMetafieldCreateSchema, W.storeMetafieldSchema, Ane + "", O(W.platformMetafieldSchema), kne + "", W.apiClientRespSchema, Hne + "", O(W.claimTagSchema), W.claimTagCreateSchema, W.claimTagSchema, $ne + "", W.settingsThemeSchema, W.settingsThemeSchema, W.settingsThemeSchema, Iv + "", W.settingsIntegrationSchema, W.settingsIntegrationUpdateSchema, W.settingsIntegrationSchema, Gne + "", W.klaviyoTestEventSchema, W.klaviyoTestEventResponseSchema, Bne + "", W.shippingProviderRefreshSchema, W.shippingProviderSchema, zne + "", W.settingsConfigSchema, W.settingsConfigSchema, W.settingsConfigSchema, Qa + "", O(W.storeProductSchema), kre + "", W.storeProductImportSchema, W.storeProductImportAcceptedSchema, Ov + "", W.storeProductDetailSchema, W.storeProductUpdateSchema, W.storeProductDetailSchema, Pre + "", W.storeProductGroupMembershipSchema, Nre + "", W.storeProductRegistrationChannelsSchema, _re + "", O(W.storeProductTagSchema), Are + "", O(W.storeProductCollectionSchema), Ore + "", O(W.storeProductTypeSchema), uI + "", O(W.storeProductGroupSchema), W.storeProductGroupCreateSchema, W.storeProductGroupSchema, dI + "", W.storeProductGroupUpdateSchema, W.storeProductGroupSchema, W.apiClientRespSchema, Dre + "", O(W.storeProductsForGroupSchema), sI + "", O(W.returnLocationSchema), W.returnLocationCreateSchema, W.returnLocationSchema, wre + "", W.returnLocationSchema, W.returnLocationSchema, W.apiClientRespSchema, Ere + "", O(y({
  id: w(),
  name: p(),
  idFromPlatform: p(),
  isCorsoReorderEnabled: N()
})), Av + "", O(W.storeUserSchema), W.storeUserCreateSchema, W.storeUserSchema, Mre + "", W.storeUserSignupCreateSchema, W.storeUserSignupCreateSchema, Sm + "", W.storeUserUpdateSchema, W.storeUserSchema, W.apiClientRespSchema, Fre + "", W.storeUserSchema, W.storeUserSchema;
fI + "", O(cr.conversationSchema), y({ conversationId: w() }), mI + "", cr.conversationWithMessagesSchema, cr.chatRequestSchema, cr.renameSchema, cr.conversationSchema, zre + "", cr.feedbackSchema;
var ut;
(function(e) {
  e.Tool = {
    // ── Any role (Admin, Corso Admin, Staff) ──
    // every store the user holds a role on, with that role
    listStores: "list_stores",
    // records: orders, returns, warranties, shipping claims and registrations
    listOrders: "list_orders",
    getOrder: "get_order",
    getOrderFulfillments: "get_order_fulfillments",
    // what each line item can still be returned or warrantied for, and until when, as the customer portal computes it
    getOrderEligibility: "get_order_eligibility",
    listClaims: "list_claims",
    getClaim: "get_claim",
    // the ledger's calculation, the customer's card payment and what was issued: how money moved on one claim
    getClaimMoney: "get_claim_money",
    // the claim risk card: the last stored fraud risk assessment and its reasons
    getClaimRisk: "get_claim_risk",
    // an exchange of an exchange traced back to the order the customer paid for, as the claim lineage modal shows it
    getClaimLineage: "get_claim_lineage",
    listShippingClaims: "list_shipping_claims",
    getShippingClaim: "get_shipping_claim",
    listRegistrations: "list_registrations",
    getRegistration: "get_registration",
    // automations, read only: Staff answer "why did this happen to this order" from them
    listAutomations: "list_automations",
    getAutomation: "get_automation",
    // the facts automations read for an order, and a dry run of one trigger's automations against them
    getOrderFacts: "get_order_facts",
    evaluateAutomations: "evaluate_automations",
    // Corso Help, the same for every store, so a role on any one store is enough
    // built-in name: ChatGPT's knowledge-source contract (deep research, company knowledge) calls `search` and `fetch`
    search: "search",
    // built-in name: returns the full article for a `search` hit's id
    fetch: "fetch",
    listHelpArticles: "list_help_articles",
    // ── Admin or Corso Admin (the Corso app's AdminProtector) ──
    // analytics: read-only ClickHouse SQL, scoped to the store by the mcp_reader row policy
    describeData: "describe_data",
    query: "query",
    // store setup, read only
    getStoreSettings: "get_store_settings",
    listReturnLocations: "list_return_locations",
    listClaimReasons: "list_claim_reasons",
    listProductGroups: "list_product_groups",
    listCustomFields: "list_custom_fields",
    listShippingPlusRates: "list_shipping_plus_rates",
    listIntegrations: "list_integrations",
    listStoreUsers: "list_store_users",
    // ── Corso staff only: registered just for Corso org members ──
    // presets and the store's current look, to ask the user before generating
    describePortalStyle: "describe_portal_style",
    // a website's palette, font and corner radius, to match the portal to it
    importBrandFromSite: "import_brand_from_site",
    // customer portal Custom CSS from a theme, shown for the user to approve; save_portal_css writes it
    generatePortalCss: "generate_portal_css",
    // writes the generated CSS and the matching saved colors, only after the user says yes
    savePortalCss: "save_portal_css",
    // puts back the Custom CSS and colors from before a save, only after the user says yes
    revertPortalCss: "revert_portal_css",
    // a store's portal check-up: CSS outside the theming contract, readability, and drift from the saved colors
    auditPortalCss: "audit_portal_css"
  };
  const t = {
    // Corso Help is public, so reading it needs no store
    anyone: [],
    anyStoreRole: [Wt.admin, Wt.corsoAdmin, Wt.staff],
    // the merchant app's AdminProtector
    storeAdmin: [Wt.admin, Wt.corsoAdmin]
  };
  e.toolRoles = {
    [e.Tool.listStores]: t.anyStoreRole,
    [e.Tool.listOrders]: t.anyStoreRole,
    [e.Tool.getOrder]: t.anyStoreRole,
    [e.Tool.getOrderFulfillments]: t.anyStoreRole,
    [e.Tool.getOrderEligibility]: t.anyStoreRole,
    [e.Tool.listClaims]: t.anyStoreRole,
    [e.Tool.getClaim]: t.anyStoreRole,
    [e.Tool.getClaimMoney]: t.anyStoreRole,
    [e.Tool.getClaimRisk]: t.anyStoreRole,
    [e.Tool.getClaimLineage]: t.anyStoreRole,
    [e.Tool.listShippingClaims]: t.anyStoreRole,
    [e.Tool.getShippingClaim]: t.anyStoreRole,
    [e.Tool.listRegistrations]: t.anyStoreRole,
    [e.Tool.getRegistration]: t.anyStoreRole,
    [e.Tool.listAutomations]: t.anyStoreRole,
    [e.Tool.getAutomation]: t.anyStoreRole,
    [e.Tool.getOrderFacts]: t.anyStoreRole,
    [e.Tool.evaluateAutomations]: t.anyStoreRole,
    [e.Tool.search]: t.anyone,
    [e.Tool.fetch]: t.anyone,
    [e.Tool.listHelpArticles]: t.anyone,
    [e.Tool.describeData]: t.storeAdmin,
    [e.Tool.query]: t.storeAdmin,
    [e.Tool.getStoreSettings]: t.storeAdmin,
    [e.Tool.listReturnLocations]: t.storeAdmin,
    [e.Tool.listClaimReasons]: t.storeAdmin,
    [e.Tool.listProductGroups]: t.storeAdmin,
    [e.Tool.listCustomFields]: t.storeAdmin,
    [e.Tool.listShippingPlusRates]: t.storeAdmin,
    [e.Tool.listIntegrations]: t.storeAdmin,
    [e.Tool.listStoreUsers]: t.storeAdmin,
    [e.Tool.describePortalStyle]: t.storeAdmin,
    [e.Tool.importBrandFromSite]: t.storeAdmin,
    [e.Tool.generatePortalCss]: t.storeAdmin,
    [e.Tool.savePortalCss]: t.storeAdmin,
    [e.Tool.revertPortalCss]: t.storeAdmin,
    [e.Tool.auditPortalCss]: t.storeAdmin
  }, e.callToolResultSchema = y({
    content: O(Aw({ type: p(), text: p().optional() })),
    structuredContent: uo().optional(),
    isError: N().optional()
  }), e.queryResultSchema = y({
    columns: O(y({ name: p(), type: p() })),
    rows: O(O(uo())),
    rowCount: w(),
    truncated: N(),
    elapsedSeconds: w().optional(),
    rowsRead: w().optional()
  }), e.helpSearchResultSchema = y({
    results: O(y({
      id: p().describe("Pass to fetch for the full article."),
      title: p(),
      url: p(),
      text: p().describe("A relevant snippet.")
    }))
  }), e.CssFindingSeverity = {
    // breaks, hides or disables part of the portal, or makes it unreadable
    harmful: "harmful",
    // works today but sits outside the contract, so a portal change can break it silently
    brittle: "brittle"
  }, e.cssFindingSchema = y({
    severity: ne(e.CssFindingSeverity),
    line: w(),
    selector: p().optional(),
    declaration: p().optional(),
    issue: p().describe("What is wrong and what it does to the portal.")
  });
  const n = y({
    pair: p(),
    text: p().describe("The text color, hex."),
    background: p().describe("What it sits on, hex (glass already blended over the page)."),
    suggestedText: p().optional().describe("When it fails: a plain white or dark text color that would pass. A suggestion only; never apply it unasked."),
    ratio: w().describe("Over the theme’s page color."),
    minimum: w(),
    passes: N(),
    overDarkPage: w().optional().describe("Glass surfaces only: the ratio over a black page, the worst a photo or an embedded merchant page could do."),
    dependsOnSite: N().optional().describe("Embedded only: in the merchant’s site this text sits on their page, so ratio holds only on the portal’s own URL.")
  });
  e.portalCssResultSchema = y({
    css: p().describe("The complete Custom CSS, ready to paste over what is saved: the generated block plus keptCss."),
    startedFrom: ne(["existing_css", "imported_css", "preset", "saved_colors"]).describe("existing_css: the theme read back from CSS this tool generated before. imported_css: what was read from CSS written by hand or in another tool (see imported), on Default with the saved colors. preset: the preset asked for, with its own colors. saved_colors: the Default preset with the store’s saved brand and background colors."),
    theme: Dg.describe("Every theme field the CSS was built from."),
    imported: O(p()).describe("What was read from hand-written CSS into the theme, and what couldn’t be."),
    needsDecision: N().describe("true: css is empty until the user decides what happens to handWrittenCss (existingCss) or to the conflicts (conflicts)."),
    handWrittenCss: p().describe("Saved CSS this tool didn’t write: all of it, or what was added around or edited inside the block it wrote."),
    removedByHand: O(y({ selector: p(), property: p() })).describe("Declarations deleted by hand from the block this tool wrote; the new look puts them back unless the user keeps their CSS."),
    conflicts: O(y({
      selector: p(),
      property: p(),
      existing: p(),
      generated: p()
    })).describe("Where handWrittenCss and the new theme set the same thing to different values."),
    keptCss: p().describe("The part of handWrittenCss carried into css, after the existingCss and conflicts choices."),
    keptCssFindings: O(e.cssFindingSchema).describe("audit_portal_css on keptCss."),
    replacedCss: p().describe("handWrittenCss left out of css because existingCss was replace."),
    contrast: O(n),
    unsupported: O(y({ request: p(), reason: p() })).describe("Asks Custom CSS can’t express, logged for Corso engineering."),
    portalUrl: p().nullable().describe("The store’s customer portal, to look at the result."),
    links: y({ appUrl: p(), helpUrl: p() })
  }), e.portalStyleSummarySchema = y({
    presets: O(y({ name: p(), description: p() })),
    current: y({
      primaryColor: p().nullable(),
      backgroundColor: p().nullable(),
      customCss: ne(["none", "from_this_tool", "edited_by_hand", "hand_written"]).describe("Where the saved Custom CSS came from: none, generated by this tool, generated then edited by hand, or written by hand."),
      theme: Dg.optional().describe("The theme this tool last generated, when it did.")
    }),
    contrast: O(n).describe("How readable the portal is today, from the saved CSS and colors."),
    portalUrl: p().nullable().describe("The store’s customer portal, to look at the result."),
    links: y({ appUrl: p(), helpUrl: p() })
  });
  const r = (o) => p().nullable().describe(`The site’s ${o} color as hex, or null.`);
  e.brandImportSchema = y({
    url: p(),
    colorScheme: ne(["light", "dark"]).nullable().describe("Whether the site is light or dark overall."),
    colors: y({
      primary: r("primary brand (main buttons)"),
      secondary: r("secondary"),
      accent: r("accent"),
      background: r("page background"),
      textPrimary: r("main text"),
      textSecondary: r("muted text"),
      link: r("link"),
      error: r("error")
    }),
    fonts: y({
      body: p().nullable().describe("Its body font family name."),
      heading: p().nullable().describe("Its heading font family name.")
    }),
    borderRadius: y({
      button: w().nullable().describe("Its button corner radius in px."),
      default: w().nullable().describe("Its default card and panel corner radius in px.")
    }),
    logoUrl: p().nullable()
  }), e.portalCssSaveSchema = y({
    css: p(),
    primaryColor: p(),
    backgroundColor: p(),
    emailHeaderColorChanged: N().describe("The saved primary color changed, which also recolors the header of every customer email."),
    portalUrl: p().nullable().describe("The store’s customer portal, to look at the result."),
    links: y({ appUrl: p(), helpUrl: p() })
  }), e.portalCssRevertSchema = y({
    restoredFrom: p().describe("When the look that was replaced had been saved over, ISO."),
    remaining: w().describe("How many earlier looks can still be put back."),
    primaryColor: p(),
    backgroundColor: p().optional(),
    emailHeaderColorChanged: N().describe("The saved primary color changed back, which also recolors the header of every customer email."),
    portalUrl: p().nullable().describe("The store’s customer portal, to look at the result."),
    links: y({ appUrl: p(), helpUrl: p() })
  }), e.portalCssAuditSchema = y({
    source: ne(["saved", "provided"]).describe("saved: the store’s Custom CSS. provided: the css passed in."),
    findings: O(e.cssFindingSchema),
    storeFindings: O(y({
      severity: ne(e.CssFindingSeverity),
      issue: p()
    })).describe("Problems with the look as a whole rather than one line of CSS."),
    contrast: O(n).describe("Saved only: how readable the portal is today."),
    portalUrl: p().nullable().describe("The store’s customer portal, to look at the result."),
    links: y({ appUrl: p(), helpUrl: p() })
  });
})(ut || (ut = {}));
ut.Tool.listStores + "", ut.Tool.listOrders + "", ut.Tool.getOrder + "", ut.Tool.getOrderFulfillments + "", ut.Tool.getOrderEligibility + "", ut.Tool.listClaims + "", ut.Tool.getClaim + "", ut.Tool.getClaimMoney + "", ut.Tool.getClaimRisk + "", ut.Tool.getClaimLineage + "", ut.Tool.listShippingClaims + "", ut.Tool.getShippingClaim + "", ut.Tool.listRegistrations + "", ut.Tool.getRegistration + "", ut.Tool.search + "", ut.Tool.fetch + "", ut.Tool.listHelpArticles + "", ut.Tool.describeData + "", ut.Tool.query + "", ut.Tool.getStoreSettings + "", ut.Tool.listAutomations + "", ut.Tool.getAutomation + "", ut.Tool.getOrderFacts + "", ut.Tool.evaluateAutomations + "", ut.Tool.listReturnLocations + "", ut.Tool.listClaimReasons + "", ut.Tool.listProductGroups + "", ut.Tool.listCustomFields + "", ut.Tool.listShippingPlusRates + "", ut.Tool.listIntegrations + "", ut.Tool.listStoreUsers + "", ut.Tool.describePortalStyle + "", ut.Tool.importBrandFromSite + "", ut.Tool.savePortalCss + "", ut.Tool.revertPortalCss + "", ut.Tool.generatePortalCss + "", ut.Tool.auditPortalCss + "";
const J6 = Object.values(vK), Wre = [
  ["Return or warranty status", bg],
  [
    "Line item status",
    Object.fromEntries(J6.map(({ code: e, name: t }) => [e, t]))
  ],
  [
    "Line item status detail",
    Object.fromEntries(J6.flatMap(({ claimStatusDetail: e }) => e).map(({ code: e, name: t }) => [e, t]))
  ],
  ["Resolution", Ad],
  ["Return shipment method", lK],
  ["RMA provider", cK],
  ["Tracking status", SK],
  ["Created from", x5],
  ["Shipping claim status", f8],
  ["Shipping claim reason", m8],
  ["Shipping claim resolution", bK]
];
Object.fromEntries(Wre.flatMap(([, e]) => Object.entries(e)));
D.EventType.rightToWithdraw + "", D.EventType.offerAdvancedExchange + "", D.EventType.customizeClaimLineItemInspection + "", D.EventType.allowClaimTypeSelection + "", D.EventType.omitResolutionMethods + "", D.EventType.modifyResolutionWindow + "", D.EventType.autoFinalizeClaim + "", D.EventType.askAPolicyEnforcingQuestion + "", D.EventType.offerInstantExchange + "", D.EventType.collectCustomFields + "", D.EventType.applyClaimTags + "", D.EventType.customizeClaimFinalizationSettings + "", D.EventType.modifyIncentives + "", D.EventType.applyFee + "", D.EventType.applyLineItemFee + "", D.EventType.chargeForReturnLabel + "", D.EventType.chargeForExchangeOrderShipping + "", D.EventType.allowCustomerToKeepItem + "", D.EventType.productRegistrationSelection + "", D.EventType.returnShippingConfig + "", D.EventType.applyOrderTags + "", D.EventType.quoteOrderShipment + "", D.EventType.quoteOrderShipmentModify + "", D.EventType.quoteOrderShipmentParcel + "", D.EventType.quoteOrderShipmentDeliveryEstimate + "", D.EventType.orderEditing + "", D.EventType.restockInventory + "", D.EventType.shopNow + "", D.EventType.registrationDiscountIncentive + "", D.EventType.customizeReturnShipment + "", D.EventType.merchantPaidShippingProtection + "", D.EventType.createGorgiasTicket + "", D.EventType.setOrderShippingTitle + "", D.EventType.shipClaimAllowedResolutions + "", D.EventType.shipClaimReorderLocations + "", D.EventType.shipClaimSlaAlert + "", D.EventType.shipClaimReorderShipping + "", D.EventType.shipApplyOrderTags + "", D.Hook.orderLookup + "", D.Hook.claimCreated + "", D.Hook.rmaWebhook + "", D.Hook.returnShipmentWebhook + "", D.Hook.afterReasonSelection + "", D.Hook.claimFinalized + "", D.Hook.beforeClaimSubmission + "", D.Hook.returnShipmentCreated + "", D.Hook.registrationProductSelection + "", D.Hook.returnShipmentQuote + "", D.Hook.beforeClaimLineItemInspection + "", D.Hook.orderCheckoutBegin + "", D.Hook.orderCheckoutQuoteShipping + "", D.Hook.exchangeProductSelection + "", D.Hook.claimLineItemReview + "", D.Hook.registrationCreated + "", D.Hook.orderCreated + "", D.Hook.shippingClaimLookup + "", D.Hook.shippingClaimFinalized + "", D.Fact.customerTotalWarrantyCountLastYear + "", D.Fact.claimRiskLevel + "", D.Fact.customerSegmentId + "", D.Fact.customerTotalReturnCountLastYear + "", D.Fact.productVendor + "", D.Fact.orderFulfillmentLocationId + "", D.Fact.orderDiscountCode + "", D.Fact.customerEmail + "", D.Fact.orderCreated + "", D.Fact.orderCountry + "", D.Fact.orderProvince + "", D.Fact.orderTotal + "", D.Fact.orderTags + "", D.Fact.claimLineItemTotal + "", D.Fact.customerTags + "", D.Fact.rmaStatus + "", D.Fact.rmaAllItemsReceived + "", D.Fact.returnShipmentStatus + "", D.Fact.productTags + "", D.Fact.productTypes + "", D.Fact.claimType + "", D.Fact.reasonCategoryCode + "", D.Fact.reasonId + "", D.Fact.reasonDetailId + "", D.Fact.orderNumber + "", D.Fact.orderChannel + "", D.Fact.orderProtectedByCorso + "", D.Fact.claimLineItemRequestedResolutionMethod + "", D.Fact.claimLineItemInspectionGrade + "", D.Fact.exchangeOrderTotal + "", D.Fact.productCollections + "", D.Fact.claimLineItemCustomFieldResponse + "", D.Fact.orderDaysSinceCreated + "", D.Fact.statusCustomer + "", D.Fact.orderGateway + "", D.Fact.registrationChannel + "", D.Fact.registrationDaysSincePurchaseEstimate + "", D.Fact.registrationEstimatedPurchaseDate + "", D.Fact.claimTotal + "", D.Fact.productSku + "", D.Fact.productGroupId + "", D.Fact.customerTotalOrderCountAllTime + "", D.Fact.orderLineItemCompareAtPricePercentage + "", D.Fact.intelligemsTestGroupId + "", D.Fact.orderCanceled + "", D.Fact.orderFulfillmentDisplayStatus + "", D.Fact.orderFinancialStatus + "", D.Fact.returnShipmentLocationId + "", D.Fact.claimLineItemTotalQuantity + "", D.Fact.rmaDisposition + "", D.Fact.claimIsGiftReturn + "", D.Fact.claimLineItemWasResolvedExternally + "", D.Fact.claimIsShopNow + "", D.Fact.giftCardIssuedByCorso + "", D.Fact.orderLineItemCustomPropertyName + "", D.Fact.registrationEmailMarketingConsentCollected + "", D.Fact.registrationNewCustomerCreated + "", D.Fact.orderShippingLineTitle + "", D.Fact.orderRechargeProtectedPrepaid + "", D.Fact.claimTags + "", D.Fact.orderIsGlobalE + "", D.Fact.shippingClaimTotal + "", D.Fact.shippingClaimResolutionMethod + "", D.Fact.shippingClaimReason + "", D.Fact.shippingClaimLineItemReorderSku + "", D.Fact.userRole + "", D.Operator.equal + "", D.Operator.notEqual + "", D.Operator.lessThan + "", D.Operator.greaterThan + "", D.Operator.in + "", D.Operator.notIn + "", D.Operator.contains + "", D.Operator.doesNotContain + "";
D.EventType.offerAdvancedExchange + "", D.EventType.returnShippingConfig + "", D.EventType.modifyResolutionWindow + "", D.EventType.autoFinalizeClaim + "", D.EventType.askAPolicyEnforcingQuestion + "", D.EventType.offerInstantExchange + "", D.EventType.allowClaimTypeSelection + "", D.EventType.collectCustomFields + "", D.EventType.applyClaimTags + "", D.EventType.applyOrderTags + "", D.EventType.customizeClaimFinalizationSettings + "", D.EventType.modifyIncentives + "", D.EventType.applyFee + "", D.EventType.applyLineItemFee + "", D.EventType.chargeForReturnLabel + "", D.EventType.chargeForExchangeOrderShipping + "", D.EventType.allowCustomerToKeepItem + "", D.EventType.productRegistrationSelection + "", D.EventType.customizeClaimLineItemInspection + "", D.EventType.quoteOrderShipment + "", D.EventType.quoteOrderShipmentModify + "", D.EventType.quoteOrderShipmentParcel + "", D.EventType.quoteOrderShipmentDeliveryEstimate + "", D.EventType.orderEditing + "", D.EventType.restockInventory + "", D.EventType.shopNow + "", D.EventType.registrationDiscountIncentive + "", D.EventType.customizeReturnShipment + "", D.EventType.merchantPaidShippingProtection + "", D.EventType.createGorgiasTicket + "", D.EventType.rightToWithdraw + "", D.EventType.omitResolutionMethods + "", D.EventType.setOrderShippingTitle + "", D.EventType.shipClaimAllowedResolutions + "", D.EventType.shipClaimReorderLocations + "", D.EventType.shipClaimSlaAlert + "", D.EventType.shipClaimReorderShipping + "", D.EventType.shipApplyOrderTags + "";
D.Hook.orderLookup + "", D.Hook.afterReasonSelection + "", D.Hook.exchangeProductSelection + "", D.Hook.returnShipmentQuote + "", D.Hook.beforeClaimSubmission + "", D.Hook.claimCreated + "", D.Hook.returnShipmentCreated + "", D.Hook.rmaWebhook + "", D.Hook.returnShipmentWebhook + "", D.Hook.beforeClaimLineItemInspection + "", D.Hook.claimFinalized + "", D.Hook.claimLineItemReview + "";
var Q6;
(function(e) {
  e.noReturnZoneSetupForCountry = "It appears we cannot accept returns from your country automatically. Please reach out for help with this return";
})(Q6 || (Q6 = {}));
qn.StoreUiConfig.WarrantyProgramName.guarantee + "";
qn.StoreUiConfig.WarrantyProgramName.guarantee + "";
var e4;
(function(e) {
  e.addressSchema = y({
    street1: p(),
    street2: p().optional(),
    city: p(),
    state: p().optional(),
    zip: p().optional(),
    country: p(),
    company: p().optional(),
    phone: p().optional(),
    name: p()
  }), e.vesylShipmentOptionsSchema = y({
    create_and_buy: N(),
    // omitted when a carrier rejects our requested format, leaving the carrier default
    label_format: p().optional(),
    print_custom: O(y({ value: p().nullable() })),
    currency: p().optional(),
    // ? Added as an outage prevention option
    label_broker: N().optional()
  }), e.easyPostShipmentOptionsSchema = y({
    currency: p().optional(),
    print_custom_1: p().nullable(),
    // omitted when a carrier rejects our requested format, leaving the carrier default
    label_format: p().optional()
  }), e.customsInfoSchema = y({
    eel_pfc: p(),
    customs_certify: N(),
    customs_signer: p(),
    contents_type: p(),
    contents_explanation: p(),
    restriction_type: p(),
    restriction_comments: p(),
    customs_items: O(y({
      description: p(),
      quantity: w(),
      weight: w(),
      value: w(),
      hs_tariff_number: p(),
      origin_country: p()
    }))
  });
  const t = y({
    length: w().optional(),
    width: w().optional(),
    height: w().optional(),
    weight: w()
  });
  e.shipmentCreateSchema = y({
    from_address: e.addressSchema,
    to_address: e.addressSchema,
    customs_info: e.customsInfoSchema.nullable(),
    parcel: t,
    options: We([
      e.vesylShipmentOptionsSchema,
      e.easyPostShipmentOptionsSchema
    ])
  });
})(e4 || (e4 = {}));
var t4;
(function(e) {
  e.FinancialStatus = {
    pending: "pending",
    authorized: "authorized",
    partially_paid: "partially_paid",
    paid: "paid",
    partially_refunded: "partially_refunded",
    refunded: "refunded",
    voided: "voided"
  }, e.financialStatusLabel = {
    pending: "Pending",
    authorized: "Authorized",
    partially_paid: "Partially Paid",
    paid: "Paid",
    partially_refunded: "Partially Refunded",
    refunded: "Refunded",
    voided: "Voided"
  }, e.DisplayFulfillmentStatus = {
    //! unfulfilled is not real, on Shopify this is represented by null/undefined
    unfulfilled: "unfulfilled",
    fulfilled: "fulfilled",
    partial: "partial",
    restocked: "restocked"
  }, e.displayFulfillmentStatusLabel = {
    unfulfilled: "Unfulfilled",
    fulfilled: "Fulfilled",
    partial: "Partially Fulfilled",
    restocked: "Restocked"
  }, e.FulfillmentEventStatus = {
    attempted_delivery: "attempted_delivery",
    carrier_picked_up: "carrier_picked_up",
    confirmed: "confirmed",
    delayed: "delayed",
    delivered: "delivered",
    failure: "failure",
    in_transit: "in_transit",
    label_printed: "label_printed",
    label_purchased: "label_purchased",
    out_for_delivery: "out_for_delivery",
    picked_up: "picked_up",
    ready_for_pickup: "ready_for_pickup"
  };
})(t4 || (t4 = {}));
const Hre = {
  [ei.today]: {},
  [ei.last7Days]: { days: 7 },
  [ei.last30Days]: { days: 30 },
  [ei.last90Days]: { days: 90 },
  [ei.last12Months]: { months: 12 }
}, qre = (e, t = /* @__PURE__ */ new Date()) => {
  if (e.kind === "preset")
    return {
      start: li(xj(t, Hre[e.preset])).toISOString(),
      end: null
    };
  const n = e.range.start ? li(new Date(e.range.start)).toISOString() : null, r = e.range.end ? q3(new Date(e.range.end)).toISOString() : null;
  return { start: n, end: r };
}, js = {
  day: "day",
  week: "week",
  month: "month"
}, vI = (e) => {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?Z$/.test(e))
    return !1;
  const t = Date.parse(e);
  return !Number.isNaN(t) && new Date(t).toISOString().slice(0, 10) === e.slice(0, 10);
}, Yre = (e) => {
  const t = e.toISOString();
  if (!vI(t)) throw new Error(`Invalid chart date: ${t}`);
  return t;
}, Kre = {
  [js.day]: {
    tick: (e) => dt.date(e, { month: "short", day: "numeric" }),
    label: (e) => dt.date(e, { month: "short", day: "numeric", year: "numeric" })
  },
  [js.week]: {
    tick: (e) => dt.date(e, { month: "short", day: "numeric" }),
    label: (e) => `Week of ${dt.date(e, { month: "short", day: "numeric", year: "numeric" })}`
  },
  [js.month]: {
    tick: (e) => dt.date(e, { month: "short", year: "numeric" }),
    label: (e) => dt.date(e, { month: "long", year: "numeric" })
  }
}, Fp = (e, t, n) => vI(e) ? Kre[t][n](new Date(e)) : e;
function Re(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Zre(e, t) {
  const n = S.createContext(t);
  function r(i) {
    const { children: a, ...s } = i, l = S.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ f.jsx(n.Provider, { value: l, children: a });
  }
  function o(i) {
    const a = S.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [r, o];
}
function Vo(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = S.createContext(a), l = n.length;
    n = [...n, a];
    function c(d) {
      const { scope: m, children: h, ...v } = d, g = (m == null ? void 0 : m[e][l]) || s, x = S.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ f.jsx(g.Provider, { value: x, children: h });
    }
    function u(d, m) {
      const h = (m == null ? void 0 : m[e][l]) || s, v = S.useContext(h);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [c, u];
  }
  const o = () => {
    const i = n.map((a) => S.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return S.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, Xre(o, ...t)];
}
function Xre(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return S.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Jre = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], at = Jre.reduce((e, t) => {
  const n = S.forwardRef((r, o) => {
    const { asChild: i, ...a } = r, s = i ? si : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f.jsx(s, { ...a, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Dv(e, t) {
  e && cl.flushSync(() => e.dispatchEvent(t));
}
function Pv(e) {
  const t = e + "CollectionProvider", [n, r] = Vo(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (h) => {
    const { scope: v, children: g } = h, x = H.useRef(null), b = H.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ f.jsx(o, { scope: v, itemMap: b, collectionRef: x, children: g });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = H.forwardRef(
    (h, v) => {
      const { scope: g, children: x } = h, b = i(s, g), C = mt(v, b.collectionRef);
      return /* @__PURE__ */ f.jsx(si, { ref: C, children: x });
    }
  );
  l.displayName = s;
  const c = e + "CollectionItemSlot", u = "data-radix-collection-item", d = H.forwardRef(
    (h, v) => {
      const { scope: g, children: x, ...b } = h, C = H.useRef(null), I = mt(v, C), T = i(c, g);
      return H.useEffect(() => (T.itemMap.set(C, { ref: C, ...b }), () => void T.itemMap.delete(C))), /* @__PURE__ */ f.jsx(si, { [u]: "", ref: I, children: x });
    }
  );
  d.displayName = c;
  function m(h) {
    const v = i(e + "CollectionConsumer", h);
    return H.useCallback(() => {
      const x = v.collectionRef.current;
      if (!x) return [];
      const b = Array.from(x.querySelectorAll(`[${u}]`));
      return Array.from(v.itemMap.values()).sort(
        (T, R) => b.indexOf(T.ref.current) - b.indexOf(R.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: d },
    m,
    r
  ];
}
var An = globalThis != null && globalThis.document ? S.useLayoutEffect : () => {
}, Qre = S.useId || (() => {
}), eoe = 0;
function _r(e) {
  const [t, n] = S.useState(Qre());
  return An(() => {
    n((r) => r ?? String(eoe++));
  }, [e]), t ? `radix-${t}` : "";
}
function tr(e) {
  const t = S.useRef(e);
  return S.useEffect(() => {
    t.current = e;
  }), S.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function di({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = toe({ defaultProp: t, onChange: n }), i = e !== void 0, a = i ? e : r, s = tr(n), l = S.useCallback(
    (c) => {
      if (i) {
        const d = typeof c == "function" ? c(e) : c;
        d !== e && s(d);
      } else
        o(c);
    },
    [i, e, o, s]
  );
  return [a, l];
}
function toe({
  defaultProp: e,
  onChange: t
}) {
  const n = S.useState(e), [r] = n, o = S.useRef(r), i = tr(t);
  return S.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var noe = S.createContext(void 0);
function xm(e) {
  const t = S.useContext(noe);
  return e || t || "ltr";
}
var Lp = "rovingFocusGroup.onEntryFocus", roe = { bubbles: !1, cancelable: !0 }, Cm = "RovingFocusGroup", [Mg, yI, ooe] = Pv(Cm), [ioe, wm] = Vo(
  Cm,
  [ooe]
), [aoe, soe] = ioe(Cm), bI = S.forwardRef(
  (e, t) => /* @__PURE__ */ f.jsx(Mg.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f.jsx(Mg.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ f.jsx(loe, { ...e, ref: t }) }) })
);
bI.displayName = Cm;
var loe = S.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, m = S.useRef(null), h = mt(t, m), v = xm(i), [g = null, x] = di({
    prop: a,
    defaultProp: s,
    onChange: l
  }), [b, C] = S.useState(!1), I = tr(c), T = yI(n), R = S.useRef(!1), [A, _] = S.useState(0);
  return S.useEffect(() => {
    const k = m.current;
    if (k)
      return k.addEventListener(Lp, I), () => k.removeEventListener(Lp, I);
  }, [I]), /* @__PURE__ */ f.jsx(
    aoe,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: o,
      currentTabStopId: g,
      onItemFocus: S.useCallback(
        (k) => x(k),
        [x]
      ),
      onItemShiftTab: S.useCallback(() => C(!0), []),
      onFocusableItemAdd: S.useCallback(
        () => _((k) => k + 1),
        []
      ),
      onFocusableItemRemove: S.useCallback(
        () => _((k) => k - 1),
        []
      ),
      children: /* @__PURE__ */ f.jsx(
        at.div,
        {
          tabIndex: b || A === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: Re(e.onMouseDown, () => {
            R.current = !0;
          }),
          onFocus: Re(e.onFocus, (k) => {
            const M = !R.current;
            if (k.target === k.currentTarget && M && !b) {
              const j = new CustomEvent(Lp, roe);
              if (k.currentTarget.dispatchEvent(j), !j.defaultPrevented) {
                const G = T().filter((Y) => Y.focusable), U = G.find((Y) => Y.active), B = G.find((Y) => Y.id === g), ee = [U, B, ...G].filter(
                  Boolean
                ).map((Y) => Y.ref.current);
                CI(ee, u);
              }
            }
            R.current = !1;
          }),
          onBlur: Re(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), SI = "RovingFocusGroupItem", xI = S.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      ...a
    } = e, s = _r(), l = i || s, c = soe(SI, n), u = c.currentTabStopId === l, d = yI(n), { onFocusableItemAdd: m, onFocusableItemRemove: h } = c;
    return S.useEffect(() => {
      if (r)
        return m(), () => h();
    }, [r, m, h]), /* @__PURE__ */ f.jsx(
      Mg.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ f.jsx(
          at.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...a,
            ref: t,
            onMouseDown: Re(e.onMouseDown, (v) => {
              r ? c.onItemFocus(l) : v.preventDefault();
            }),
            onFocus: Re(e.onFocus, () => c.onItemFocus(l)),
            onKeyDown: Re(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const g = doe(v, c.orientation, c.dir);
              if (g !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let b = d().filter((C) => C.focusable).map((C) => C.ref.current);
                if (g === "last") b.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && b.reverse();
                  const C = b.indexOf(v.currentTarget);
                  b = c.loop ? foe(b, C + 1) : b.slice(C + 1);
                }
                setTimeout(() => CI(b));
              }
            })
          }
        )
      }
    );
  }
);
xI.displayName = SI;
var coe = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function uoe(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function doe(e, t, n) {
  const r = uoe(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return coe[r];
}
function CI(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function foe(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var wI = bI, EI = xI;
function II(e) {
  const [t, n] = S.useState(void 0);
  return An(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, s = c.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function RI(e) {
  const t = S.useRef({ value: e, previous: e });
  return S.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function moe(e, t) {
  return S.useReducer((n, r) => t[n][r] ?? n, e);
}
var yo = (e) => {
  const { present: t, children: n } = e, r = poe(t), o = typeof n == "function" ? n({ present: r.isPresent }) : S.Children.only(n), i = mt(r.ref, hoe(o));
  return typeof n == "function" || r.isPresent ? S.cloneElement(o, { ref: i }) : null;
};
yo.displayName = "Presence";
function poe(e) {
  const [t, n] = S.useState(), r = S.useRef({}), o = S.useRef(e), i = S.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = moe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return S.useEffect(() => {
    const c = td(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [s]), An(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const m = i.current, h = td(c);
      e ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && m !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), An(() => {
    if (t) {
      const c = (d) => {
        const h = td(r.current).includes(d.animationName);
        d.target === t && h && cl.flushSync(() => l("ANIMATION_END"));
      }, u = (d) => {
        d.target === t && (i.current = td(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: S.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function td(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function hoe(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Nv = "Radio", [goe, TI] = Vo(Nv), [voe, yoe] = goe(Nv), _I = S.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: i,
      disabled: a,
      value: s = "on",
      onCheck: l,
      ...c
    } = e, [u, d] = S.useState(null), m = mt(t, (g) => d(g)), h = S.useRef(!1), v = u ? !!u.closest("form") : !0;
    return /* @__PURE__ */ f.jsxs(voe, { scope: n, checked: o, disabled: a, children: [
      /* @__PURE__ */ f.jsx(
        at.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": kI(o),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: s,
          ...c,
          ref: m,
          onClick: Re(e.onClick, (g) => {
            o || l == null || l(), v && (h.current = g.isPropagationStopped(), h.current || g.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ f.jsx(
        boe,
        {
          control: u,
          bubbles: !h.current,
          name: r,
          value: s,
          checked: o,
          required: i,
          disabled: a,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
_I.displayName = Nv;
var OI = "RadioIndicator", AI = S.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, i = yoe(OI, n);
    return /* @__PURE__ */ f.jsx(yo, { present: r || i.checked, children: /* @__PURE__ */ f.jsx(
      at.span,
      {
        "data-state": kI(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
AI.displayName = OI;
var boe = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, i = S.useRef(null), a = RI(n), s = II(t);
  return S.useEffect(() => {
    const l = i.current, c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (a !== n && d) {
      const m = new Event("click", { bubbles: r });
      d.call(l, n), l.dispatchEvent(m);
    }
  }, [a, n, r]), /* @__PURE__ */ f.jsx(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function kI(e) {
  return e ? "checked" : "unchecked";
}
var Soe = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Mv = "RadioGroup", [xoe] = Vo(Mv, [
  wm,
  TI
]), DI = wm(), PI = TI(), [Coe, woe] = xoe(Mv), NI = S.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: i,
      required: a = !1,
      disabled: s = !1,
      orientation: l,
      dir: c,
      loop: u = !0,
      onValueChange: d,
      ...m
    } = e, h = DI(n), v = xm(c), [g, x] = di({
      prop: i,
      defaultProp: o,
      onChange: d
    });
    return /* @__PURE__ */ f.jsx(
      Coe,
      {
        scope: n,
        name: r,
        required: a,
        disabled: s,
        value: g,
        onValueChange: x,
        children: /* @__PURE__ */ f.jsx(
          wI,
          {
            asChild: !0,
            ...h,
            orientation: l,
            dir: v,
            loop: u,
            children: /* @__PURE__ */ f.jsx(
              at.div,
              {
                role: "radiogroup",
                "aria-required": a,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: v,
                ...m,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
NI.displayName = Mv;
var MI = "RadioGroupItem", FI = S.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, i = woe(MI, n), a = i.disabled || r, s = DI(n), l = PI(n), c = S.useRef(null), u = mt(t, c), d = i.value === o.value, m = S.useRef(!1);
    return S.useEffect(() => {
      const h = (g) => {
        Soe.includes(g.key) && (m.current = !0);
      }, v = () => m.current = !1;
      return document.addEventListener("keydown", h), document.addEventListener("keyup", v), () => {
        document.removeEventListener("keydown", h), document.removeEventListener("keyup", v);
      };
    }, []), /* @__PURE__ */ f.jsx(
      EI,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: d,
        children: /* @__PURE__ */ f.jsx(
          _I,
          {
            disabled: a,
            required: i.required,
            checked: d,
            ...l,
            ...o,
            name: i.name,
            ref: u,
            onCheck: () => i.onValueChange(o.value),
            onKeyDown: Re((h) => {
              h.key === "Enter" && h.preventDefault();
            }),
            onFocus: Re(o.onFocus, () => {
              var h;
              m.current && ((h = c.current) == null || h.click());
            })
          }
        )
      }
    );
  }
);
FI.displayName = MI;
var Eoe = "RadioGroupIndicator", LI = S.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = PI(n);
    return /* @__PURE__ */ f.jsx(AI, { ...o, ...r, ref: t });
  }
);
LI.displayName = Eoe;
var Fv = NI, Lv = FI, Ioe = LI;
const ur = Symbol.for("@ts-pattern/matcher"), $I = Symbol.for("@ts-pattern/isVariadic"), yf = "@ts-pattern/anonymous-select-key", Fg = (e) => !!(e && typeof e == "object"), Bd = (e) => e && !!e[ur], Dn = (e, t, n) => {
  if (Bd(e)) {
    const r = e[ur](), { matched: o, selections: i } = r.match(t);
    return o && i && Object.keys(i).forEach((a) => n(a, i[a])), o;
  }
  if (Fg(e)) {
    if (!Fg(t)) return !1;
    if (Array.isArray(e)) {
      if (!Array.isArray(t)) return !1;
      let r = [], o = [], i = [];
      for (const a of e.keys()) {
        const s = e[a];
        Bd(s) && s[$I] ? i.push(s) : i.length ? o.push(s) : r.push(s);
      }
      if (i.length) {
        if (i.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
        if (t.length < r.length + o.length) return !1;
        const a = t.slice(0, r.length), s = o.length === 0 ? [] : t.slice(-o.length), l = t.slice(r.length, o.length === 0 ? 1 / 0 : -o.length);
        return r.every((c, u) => Dn(c, a[u], n)) && o.every((c, u) => Dn(c, s[u], n)) && (i.length === 0 || Dn(i[0], l, n));
      }
      return e.length === t.length && e.every((a, s) => Dn(a, t[s], n));
    }
    return Reflect.ownKeys(e).every((r) => {
      const o = e[r];
      return (r in t || Bd(i = o) && i[ur]().matcherType === "optional") && Dn(o, t[r], n);
      var i;
    });
  }
  return Object.is(t, e);
}, Er = (e) => {
  var t, n, r;
  return Fg(e) ? Bd(e) ? (t = (n = (r = e[ur]()).getSelectionKeys) == null ? void 0 : n.call(r)) != null ? t : [] : Array.isArray(e) ? Mc(e, Er) : Mc(Object.values(e), Er) : [];
}, Mc = (e, t) => e.reduce((n, r) => n.concat(t(r)), []);
function Roe(...e) {
  if (e.length === 1) {
    const [t] = e;
    return (n) => Dn(t, n, () => {
    });
  }
  if (e.length === 2) {
    const [t, n] = e;
    return Dn(t, n, () => {
    });
  }
  throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${e.length}.`);
}
function Pn(e) {
  return Object.assign(e, { optional: () => $v(e), and: (t) => jt(e, t), or: (t) => zI(e, t), select: (t) => t === void 0 ? Fc(e) : Fc(t, e) });
}
function Lg(e) {
  return Object.assign(((t) => Object.assign(t, { [Symbol.iterator]() {
    let n = 0;
    const r = [{ value: Object.assign(t, { [$I]: !0 }), done: !1 }, { done: !0, value: void 0 }];
    return { next: () => {
      var o;
      return (o = r[n++]) != null ? o : r.at(-1);
    } };
  } }))(e), { optional: () => Lg($v(e)), select: (t) => Lg(t === void 0 ? Fc(e) : Fc(t, e)) });
}
function $v(e) {
  return Pn({ [ur]: () => ({ match: (t) => {
    let n = {};
    const r = (o, i) => {
      n[o] = i;
    };
    return t === void 0 ? (Er(e).forEach((o) => r(o, void 0)), { matched: !0, selections: n }) : { matched: Dn(e, t, r), selections: n };
  }, getSelectionKeys: () => Er(e), matcherType: "optional" }) });
}
const Toe = (e, t) => {
  for (const n of e) if (!t(n)) return !1;
  return !0;
}, _oe = (e, t) => {
  for (const [n, r] of e.entries()) if (!t(r, n)) return !1;
  return !0;
};
function jt(...e) {
  return Pn({ [ur]: () => ({ match: (t) => {
    let n = {};
    const r = (o, i) => {
      n[o] = i;
    };
    return { matched: e.every((o) => Dn(o, t, r)), selections: n };
  }, getSelectionKeys: () => Mc(e, Er), matcherType: "and" }) });
}
function zI(...e) {
  return Pn({ [ur]: () => ({ match: (t) => {
    let n = {};
    const r = (o, i) => {
      n[o] = i;
    };
    return Mc(e, Er).forEach((o) => r(o, void 0)), { matched: e.some((o) => Dn(o, t, r)), selections: n };
  }, getSelectionKeys: () => Mc(e, Er), matcherType: "or" }) });
}
function Ct(e) {
  return { [ur]: () => ({ match: (t) => ({ matched: !!e(t) }) }) };
}
function Fc(...e) {
  const t = typeof e[0] == "string" ? e[0] : void 0, n = e.length === 2 ? e[1] : typeof e[0] == "string" ? void 0 : e[0];
  return Pn({ [ur]: () => ({ match: (r) => {
    let o = { [t ?? yf]: r };
    return { matched: n === void 0 || Dn(n, r, (i, a) => {
      o[i] = a;
    }), selections: o };
  }, getSelectionKeys: () => [t ?? yf].concat(n === void 0 ? [] : Er(n)) }) });
}
function wo(e) {
  return typeof e == "number";
}
function Ii(e) {
  return typeof e == "string";
}
function Ri(e) {
  return typeof e == "bigint";
}
const jI = Pn(Ct(function(e) {
  return !0;
})), Ooe = jI, Ti = (e) => Object.assign(Pn(e), { startsWith: (t) => {
  return Ti(jt(e, (n = t, Ct((r) => Ii(r) && r.startsWith(n)))));
  var n;
}, endsWith: (t) => {
  return Ti(jt(e, (n = t, Ct((r) => Ii(r) && r.endsWith(n)))));
  var n;
}, minLength: (t) => Ti(jt(e, ((n) => Ct((r) => Ii(r) && r.length >= n))(t))), length: (t) => Ti(jt(e, ((n) => Ct((r) => Ii(r) && r.length === n))(t))), maxLength: (t) => Ti(jt(e, ((n) => Ct((r) => Ii(r) && r.length <= n))(t))), includes: (t) => {
  return Ti(jt(e, (n = t, Ct((r) => Ii(r) && r.includes(n)))));
  var n;
}, regex: (t) => {
  return Ti(jt(e, (n = t, Ct((r) => Ii(r) && !!r.match(n)))));
  var n;
} }), Aoe = Ti(Ct(Ii)), Eo = (e) => Object.assign(Pn(e), { between: (t, n) => Eo(jt(e, ((r, o) => Ct((i) => wo(i) && r <= i && o >= i))(t, n))), lt: (t) => Eo(jt(e, ((n) => Ct((r) => wo(r) && r < n))(t))), gt: (t) => Eo(jt(e, ((n) => Ct((r) => wo(r) && r > n))(t))), lte: (t) => Eo(jt(e, ((n) => Ct((r) => wo(r) && r <= n))(t))), gte: (t) => Eo(jt(e, ((n) => Ct((r) => wo(r) && r >= n))(t))), int: () => Eo(jt(e, Ct((t) => wo(t) && Number.isInteger(t)))), finite: () => Eo(jt(e, Ct((t) => wo(t) && Number.isFinite(t)))), positive: () => Eo(jt(e, Ct((t) => wo(t) && t > 0))), negative: () => Eo(jt(e, Ct((t) => wo(t) && t < 0))) }), koe = Eo(Ct(wo)), _i = (e) => Object.assign(Pn(e), { between: (t, n) => _i(jt(e, ((r, o) => Ct((i) => Ri(i) && r <= i && o >= i))(t, n))), lt: (t) => _i(jt(e, ((n) => Ct((r) => Ri(r) && r < n))(t))), gt: (t) => _i(jt(e, ((n) => Ct((r) => Ri(r) && r > n))(t))), lte: (t) => _i(jt(e, ((n) => Ct((r) => Ri(r) && r <= n))(t))), gte: (t) => _i(jt(e, ((n) => Ct((r) => Ri(r) && r >= n))(t))), positive: () => _i(jt(e, Ct((t) => Ri(t) && t > 0))), negative: () => _i(jt(e, Ct((t) => Ri(t) && t < 0))) }), Doe = _i(Ct(Ri)), Poe = Pn(Ct(function(e) {
  return typeof e == "boolean";
})), Noe = Pn(Ct(function(e) {
  return typeof e == "symbol";
})), Moe = Pn(Ct(function(e) {
  return e == null;
})), Foe = Pn(Ct(function(e) {
  return e != null;
}));
var Ft = { __proto__: null, matcher: ur, optional: $v, array: function(...e) {
  return Lg({ [ur]: () => ({ match: (t) => {
    if (!Array.isArray(t)) return { matched: !1 };
    if (e.length === 0) return { matched: !0 };
    const n = e[0];
    let r = {};
    if (t.length === 0) return Er(n).forEach((i) => {
      r[i] = [];
    }), { matched: !0, selections: r };
    const o = (i, a) => {
      r[i] = (r[i] || []).concat([a]);
    };
    return { matched: t.every((i) => Dn(n, i, o)), selections: r };
  }, getSelectionKeys: () => e.length === 0 ? [] : Er(e[0]) }) });
}, set: function(...e) {
  return Pn({ [ur]: () => ({ match: (t) => {
    if (!(t instanceof Set)) return { matched: !1 };
    let n = {};
    if (t.size === 0) return { matched: !0, selections: n };
    if (e.length === 0) return { matched: !0 };
    const r = (i, a) => {
      n[i] = (n[i] || []).concat([a]);
    }, o = e[0];
    return { matched: Toe(t, (i) => Dn(o, i, r)), selections: n };
  }, getSelectionKeys: () => e.length === 0 ? [] : Er(e[0]) }) });
}, map: function(...e) {
  return Pn({ [ur]: () => ({ match: (t) => {
    if (!(t instanceof Map)) return { matched: !1 };
    let n = {};
    if (t.size === 0) return { matched: !0, selections: n };
    const r = (s, l) => {
      n[s] = (n[s] || []).concat([l]);
    };
    if (e.length === 0) return { matched: !0 };
    var o;
    if (e.length === 1) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${(o = e[0]) == null ? void 0 : o.toString()}`);
    const [i, a] = e;
    return { matched: _oe(t, (s, l) => {
      const c = Dn(i, l, r), u = Dn(a, s, r);
      return c && u;
    }), selections: n };
  }, getSelectionKeys: () => e.length === 0 ? [] : [...Er(e[0]), ...Er(e[1])] }) });
}, intersection: jt, union: zI, not: function(e) {
  return Pn({ [ur]: () => ({ match: (t) => ({ matched: !Dn(e, t, () => {
  }) }), getSelectionKeys: () => [], matcherType: "not" }) });
}, when: Ct, select: Fc, any: jI, _: Ooe, string: Aoe, number: koe, bigint: Doe, boolean: Poe, symbol: Noe, nullish: Moe, nonNullable: Foe, instanceOf: function(e) {
  return Pn(Ct(/* @__PURE__ */ (function(t) {
    return (n) => n instanceof t;
  })(e)));
}, shape: function(e) {
  return Pn(Ct(Roe(e)));
} };
let Loe = class extends Error {
  constructor(t) {
    let n;
    try {
      n = JSON.stringify(t);
    } catch {
      n = t;
    }
    super(`Pattern matching error: no pattern matches value ${n}`), this.input = void 0, this.input = t;
  }
};
const $g = { matched: !1, value: void 0 };
function ze(e) {
  return new bf(e, $g);
}
class bf {
  constructor(t, n) {
    this.input = void 0, this.state = void 0, this.input = t, this.state = n;
  }
  with(...t) {
    if (this.state.matched) return this;
    const n = t[t.length - 1], r = [t[0]];
    let o;
    t.length === 3 && typeof t[1] == "function" ? o = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
    let i = !1, a = {};
    const s = (c, u) => {
      i = !0, a[c] = u;
    }, l = !r.some((c) => Dn(c, this.input, s)) || o && !o(this.input) ? $g : { matched: !0, value: n(i ? yf in a ? a[yf] : a : this.input, this.input) };
    return new bf(this.input, l);
  }
  when(t, n) {
    if (this.state.matched) return this;
    const r = !!t(this.input);
    return new bf(this.input, r ? { matched: !0, value: n(this.input, this.input) } : $g);
  }
  otherwise(t) {
    return this.state.matched ? this.state.value : t(this.input);
  }
  exhaustive(t = $oe) {
    return this.state.matched ? this.state.value : t(this.input);
  }
  run() {
    return this.exhaustive();
  }
  returnType() {
    return this;
  }
}
function $oe(e) {
  throw new Loe(e);
}
const n4 = (e) => e.reduce((t, n) => t + n, 0), zoe = {
  sum: n4,
  average: (e) => e.length > 0 ? n4(e) / e.length : 0,
  latest: (e) => e.at(-1) ?? 0
}, r4 = [
  "grid-cols-1",
  "grid-cols-1 @xs:grid-cols-2",
  "grid-cols-1 @md:grid-cols-3",
  "grid-cols-1 @xs:grid-cols-2 @2xl:grid-cols-4"
], joe = ({
  series: e,
  value: t,
  onValueChange: n,
  label: r = "Chart series",
  valueFormatter: o = dt.count,
  className: i
}) => /* @__PURE__ */ f.jsx(
  Fv,
  {
    "aria-label": r,
    value: t,
    onValueChange: (a) => {
      const s = e.find(({ key: l }) => l === a);
      s && n(s.key);
    },
    className: oe(
      // tiles are ruled by outlines meeting in the gaps, the outer ones clipped away
      "grid min-w-0 gap-px overflow-hidden",
      r4[Math.min(e.length, r4.length) - 1],
      i
    ),
    children: e.map((a) => {
      const s = ze(a.total).with(void 0, () => "—").otherwise((l) => o(l));
      return /* @__PURE__ */ f.jsxs(
        Lv,
        {
          value: a.key,
          "aria-label": `${a.label} ${s}`,
          className: "flex min-w-0 cursor-pointer flex-col items-start gap-2 px-4 py-5 text-left outline-1 outline-neutral-200 transition-colors hover:bg-neutral-50 focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:outline-hidden focus-visible:ring-inset data-[state=checked]:bg-neutral-100 @xl:px-6",
          children: [
            /* @__PURE__ */ f.jsxs("span", { className: "flex items-center gap-2 text-xs text-neutral-600", children: [
              /* @__PURE__ */ f.jsx(
                "span",
                {
                  "aria-hidden": !0,
                  className: "size-2 shrink-0 rounded-sm",
                  style: { backgroundColor: a.color }
                }
              ),
              a.label
            ] }),
            /* @__PURE__ */ f.jsx("span", { className: "text-2xl leading-none font-semibold text-neutral-900 tabular-nums", children: s })
          ]
        },
        a.key
      );
    })
  }
);
var o4 = 1, Boe = 0.9, Goe = 0.8, Voe = 0.17, $p = 0.1, zp = 0.999, Uoe = 0.9999, Woe = 0.99, Hoe = /[\\\/_+.#"@\[\(\{&]/, qoe = /[\\\/_+.#"@\[\(\{&]/g, Yoe = /[\s-]/, BI = /[\s-]/g;
function zg(e, t, n, r, o, i, a) {
  if (i === t.length) return o === e.length ? o4 : Woe;
  var s = `${o},${i}`;
  if (a[s] !== void 0) return a[s];
  for (var l = r.charAt(i), c = n.indexOf(l, o), u = 0, d, m, h, v; c >= 0; ) d = zg(e, t, n, r, c + 1, i + 1, a), d > u && (c === o ? d *= o4 : Hoe.test(e.charAt(c - 1)) ? (d *= Goe, h = e.slice(o, c - 1).match(qoe), h && o > 0 && (d *= Math.pow(zp, h.length))) : Yoe.test(e.charAt(c - 1)) ? (d *= Boe, v = e.slice(o, c - 1).match(BI), v && o > 0 && (d *= Math.pow(zp, v.length))) : (d *= Voe, o > 0 && (d *= Math.pow(zp, c - o))), e.charAt(c) !== t.charAt(i) && (d *= Uoe)), (d < $p && n.charAt(c - 1) === r.charAt(i + 1) || r.charAt(i + 1) === r.charAt(i) && n.charAt(c - 1) !== r.charAt(i)) && (m = zg(e, t, n, r, c + 1, i + 2, a), m * $p > d && (d = m * $p)), d > u && (u = d), c = n.indexOf(l, c + 1);
  return a[s] = u, u;
}
function i4(e) {
  return e.toLowerCase().replace(BI, " ");
}
function Koe(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, zg(e, t, i4(e), i4(t), 0, 0, {});
}
function nr() {
  return nr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nr.apply(null, arguments);
}
function Bs(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}
function Zoe(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function GI(...e) {
  return (t) => e.forEach(
    (n) => Zoe(n, t)
  );
}
function cu(...e) {
  return Ke(GI(...e), e);
}
function Xoe(e, t) {
  const n = /* @__PURE__ */ Nn(t);
  function r(i) {
    const { children: a, ...s } = i, l = Be(
      () => s,
      Object.values(s)
    );
    return /* @__PURE__ */ Lt(n.Provider, {
      value: l
    }, a);
  }
  function o(i) {
    const a = On(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [
    r,
    o
  ];
}
function Joe(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = /* @__PURE__ */ Nn(a), l = n.length;
    n = [
      ...n,
      a
    ];
    function c(d) {
      const { scope: m, children: h, ...v } = d, g = (m == null ? void 0 : m[e][l]) || s, x = Be(
        () => v,
        Object.values(v)
      );
      return /* @__PURE__ */ Lt(g.Provider, {
        value: x
      }, h);
    }
    function u(d, m) {
      const h = (m == null ? void 0 : m[e][l]) || s, v = On(h);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [
      c,
      u
    ];
  }
  const o = () => {
    const i = n.map((a) => /* @__PURE__ */ Nn(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return Be(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: l
          }
        }),
        [
          s,
          l
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    Qoe(o, ...t)
  ];
}
function Qoe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return {
          ...s,
          ...d
        };
      }, {});
      return Be(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const jg = globalThis != null && globalThis.document ? oa : () => {
}, eie = S.useId || (() => {
});
let tie = 0;
function jp(e) {
  const [t, n] = S.useState(eie());
  return jg(() => {
    n(
      (r) => r ?? String(tie++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Ga(e) {
  const t = He(e);
  return Le(() => {
    t.current = e;
  }), Be(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function nie({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = rie({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : r, s = Ga(n), l = Ke((c) => {
    if (i) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && s(d);
    } else o(c);
  }, [
    i,
    e,
    o,
    s
  ]);
  return [
    a,
    l
  ];
}
function rie({ defaultProp: e, onChange: t }) {
  const n = Fe(e), [r] = n, o = He(r), i = Ga(t);
  return Le(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const zv = /* @__PURE__ */ It((e, t) => {
  const { children: n, ...r } = e, o = Aa.toArray(n), i = o.find(iie);
  if (i) {
    const a = i.props.children, s = o.map((l) => l === i ? Aa.count(a) > 1 ? Aa.only(null) : /* @__PURE__ */ Wd(a) ? a.props.children : null : l);
    return /* @__PURE__ */ Lt(Bg, nr({}, r, {
      ref: t
    }), /* @__PURE__ */ Wd(a) ? /* @__PURE__ */ N1(a, void 0, s) : null);
  }
  return /* @__PURE__ */ Lt(Bg, nr({}, r, {
    ref: t
  }), n);
});
zv.displayName = "Slot";
const Bg = /* @__PURE__ */ It((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Wd(n) ? /* @__PURE__ */ N1(n, {
    ...aie(r, n.props),
    ref: t ? GI(t, n.ref) : n.ref
  }) : Aa.count(n) > 1 ? Aa.only(null) : null;
});
Bg.displayName = "SlotClone";
const oie = ({ children: e }) => /* @__PURE__ */ Lt(ll, null, e);
function iie(e) {
  return /* @__PURE__ */ Wd(e) && e.type === oie;
}
function aie(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      i(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const sie = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Kr = sie.reduce((e, t) => {
  const n = /* @__PURE__ */ It((r, o) => {
    const { asChild: i, ...a } = r, s = i ? zv : t;
    return Le(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Lt(s, nr({}, a, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function lie(e, t) {
  e && F1(
    () => e.dispatchEvent(t)
  );
}
function cie(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ga(e);
  Le(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Gg = "dismissableLayer.update", uie = "dismissableLayer.pointerDownOutside", die = "dismissableLayer.focusOutside";
let a4;
const fie = /* @__PURE__ */ Nn({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), mie = /* @__PURE__ */ It((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: a, onInteractOutside: s, onDismiss: l, ...c } = e, u = On(fie), [d, m] = Fe(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, v] = Fe({}), g = cu(
    t,
    (k) => m(k)
  ), x = Array.from(u.layers), [b] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), C = x.indexOf(b), I = d ? x.indexOf(d) : -1, T = u.layersWithOutsidePointerEventsDisabled.size > 0, R = I >= C, A = pie((k) => {
    const M = k.target, j = [
      ...u.branches
    ].some(
      (G) => G.contains(M)
    );
    !R || j || (i == null || i(k), s == null || s(k), k.defaultPrevented || l == null || l());
  }, h), _ = hie((k) => {
    const M = k.target;
    [
      ...u.branches
    ].some(
      (G) => G.contains(M)
    ) || (a == null || a(k), s == null || s(k), k.defaultPrevented || l == null || l());
  }, h);
  return cie((k) => {
    I === u.layers.size - 1 && (o == null || o(k), !k.defaultPrevented && l && (k.preventDefault(), l()));
  }, h), Le(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (a4 = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), s4(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = a4);
      };
  }, [
    d,
    h,
    r,
    u
  ]), Le(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), s4());
  }, [
    d,
    u
  ]), Le(() => {
    const k = () => v({});
    return document.addEventListener(Gg, k), () => document.removeEventListener(Gg, k);
  }, []), /* @__PURE__ */ Lt(Kr.div, nr({}, c, {
    ref: g,
    style: {
      pointerEvents: T ? R ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Bs(e.onFocusCapture, _.onFocusCapture),
    onBlurCapture: Bs(e.onBlurCapture, _.onBlurCapture),
    onPointerDownCapture: Bs(e.onPointerDownCapture, A.onPointerDownCapture)
  }));
});
function pie(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ga(e), r = He(!1), o = He(() => {
  });
  return Le(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          VI(uie, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, {
          once: !0
        })) : c();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function hie(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ga(e), r = He(!1);
  return Le(() => {
    const o = (i) => {
      i.target && !r.current && VI(die, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function s4() {
  const e = new CustomEvent(Gg);
  document.dispatchEvent(e);
}
function VI(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? lie(o, i) : o.dispatchEvent(i);
}
const Bp = "focusScope.autoFocusOnMount", Gp = "focusScope.autoFocusOnUnmount", l4 = {
  bubbles: !1,
  cancelable: !0
}, gie = /* @__PURE__ */ It((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...a } = e, [s, l] = Fe(null), c = Ga(o), u = Ga(i), d = He(null), m = cu(
    t,
    (g) => l(g)
  ), h = He({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Le(() => {
    if (r) {
      let g = function(I) {
        if (h.paused || !s) return;
        const T = I.target;
        s.contains(T) ? d.current = T : Oi(d.current, {
          select: !0
        });
      }, x = function(I) {
        if (h.paused || !s) return;
        const T = I.relatedTarget;
        T !== null && (s.contains(T) || Oi(d.current, {
          select: !0
        }));
      }, b = function(I) {
        if (document.activeElement === document.body)
          for (const R of I) R.removedNodes.length > 0 && Oi(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", x);
      const C = new MutationObserver(b);
      return s && C.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", x), C.disconnect();
      };
    }
  }, [
    r,
    s,
    h.paused
  ]), Le(() => {
    if (s) {
      u4.add(h);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const b = new CustomEvent(Bp, l4);
        s.addEventListener(Bp, c), s.dispatchEvent(b), b.defaultPrevented || (vie(Cie(UI(s)), {
          select: !0
        }), document.activeElement === g && Oi(s));
      }
      return () => {
        s.removeEventListener(Bp, c), setTimeout(() => {
          const b = new CustomEvent(Gp, l4);
          s.addEventListener(Gp, u), s.dispatchEvent(b), b.defaultPrevented || Oi(g ?? document.body, {
            select: !0
          }), s.removeEventListener(Gp, u), u4.remove(h);
        }, 0);
      };
    }
  }, [
    s,
    c,
    u,
    h
  ]);
  const v = Ke((g) => {
    if (!n && !r || h.paused) return;
    const x = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
    if (x && b) {
      const C = g.currentTarget, [I, T] = yie(C);
      I && T ? !g.shiftKey && b === T ? (g.preventDefault(), n && Oi(I, {
        select: !0
      })) : g.shiftKey && b === I && (g.preventDefault(), n && Oi(T, {
        select: !0
      })) : b === C && g.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ Lt(Kr.div, nr({
    tabIndex: -1
  }, a, {
    ref: m,
    onKeyDown: v
  }));
});
function vie(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Oi(r, {
      select: t
    }), document.activeElement !== n) return;
}
function yie(e) {
  const t = UI(e), n = c4(t, e), r = c4(t.reverse(), e);
  return [
    n,
    r
  ];
}
function UI(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function c4(e, t) {
  for (const n of e)
    if (!bie(n, {
      upTo: t
    })) return n;
}
function bie(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Sie(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Oi(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Sie(e) && t && e.select();
  }
}
const u4 = xie();
function xie() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = d4(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = d4(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function d4(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Cie(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const wie = /* @__PURE__ */ It((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ M1.createPortal(/* @__PURE__ */ Lt(Kr.div, nr({}, o, {
    ref: t
  })), r) : null;
});
function Eie(e, t) {
  return QS((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Em = (e) => {
  const { present: t, children: n } = e, r = Iie(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Aa.only(n), i = cu(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ N1(o, {
    ref: i
  }) : null;
};
Em.displayName = "Presence";
function Iie(e) {
  const [t, n] = Fe(), r = He({}), o = He(e), i = He("none"), a = e ? "mounted" : "unmounted", [s, l] = Eie(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Le(() => {
    const c = nd(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [
    s
  ]), jg(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const m = i.current, h = nd(c);
      e ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && m !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    l
  ]), jg(() => {
    if (t) {
      const c = (d) => {
        const h = nd(r.current).includes(d.animationName);
        d.target === t && h && F1(
          () => l("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (i.current = nd(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Ke((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function nd(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let Vp = 0;
function Rie() {
  Le(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : f4()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : f4()), Vp++, () => {
      Vp === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Vp--;
    };
  }, []);
}
function f4() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Wn = function() {
  return Wn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Wn.apply(this, arguments);
};
function jv(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function WI(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var mc = "right-scroll-bar-position", pc = "width-before-scroll-bar", Tie = "with-scroll-bars-hidden", _ie = "--removed-body-scroll-bar-size";
function Up(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Oie(e, t) {
  var n = Fe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Aie = typeof window < "u" ? S.useLayoutEffect : S.useEffect, m4 = /* @__PURE__ */ new WeakMap();
function HI(e, t) {
  var n = Oie(null, function(r) {
    return e.forEach(function(o) {
      return Up(o, r);
    });
  });
  return Aie(function() {
    var r = m4.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(s) {
        i.has(s) || Up(s, null);
      }), i.forEach(function(s) {
        o.has(s) || Up(s, a);
      });
    }
    m4.set(n, e);
  }, [e]), n;
}
function kie(e) {
  return e;
}
function Die(e, t) {
  t === void 0 && (t = kie);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var l = function() {
        var u = a;
        a = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          a.push(u), c();
        },
        filter: function(u) {
          return a = a.filter(u), n;
        }
      };
    }
  };
  return o;
}
function qI(e) {
  e === void 0 && (e = {});
  var t = Die(null);
  return t.options = Wn({ async: !0, ssr: !1 }, e), t;
}
var YI = function(e) {
  var t = e.sideCar, n = jv(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return S.createElement(r, Wn({}, n));
};
YI.isSideCarExport = !0;
function KI(e, t) {
  return e.useMedium(t), YI;
}
var ZI = qI(), Wp = function() {
}, Im = S.forwardRef(function(e, t) {
  var n = S.useRef(null), r = S.useState({
    onScrollCapture: Wp,
    onWheelCapture: Wp,
    onTouchMoveCapture: Wp
  }), o = r[0], i = r[1], a = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, m = e.sideCar, h = e.noIsolation, v = e.inert, g = e.allowPinchZoom, x = e.as, b = x === void 0 ? "div" : x, C = jv(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), I = m, T = HI([n, t]), R = Wn(Wn({}, C), o);
  return S.createElement(
    S.Fragment,
    null,
    u && S.createElement(I, { sideCar: ZI, removeScrollBar: c, shards: d, noIsolation: h, inert: v, setCallbacks: i, allowPinchZoom: !!g, lockRef: n }),
    a ? S.cloneElement(S.Children.only(s), Wn(Wn({}, R), { ref: T })) : S.createElement(b, Wn({}, R, { className: l, ref: T }), s)
  );
});
Im.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Im.classNames = {
  fullWidth: pc,
  zeroRight: mc
};
var Pie = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Nie() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Pie();
  return t && e.setAttribute("nonce", t), e;
}
function Mie(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Fie(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Lie = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Nie()) && (Mie(t, n), Fie(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, $ie = function() {
  var e = Lie();
  return function(t, n) {
    S.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Bv = function() {
  var e = $ie(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, zie = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Hp = function(e) {
  return parseInt(e || "", 10) || 0;
}, jie = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Hp(n), Hp(r), Hp(o)];
}, Bie = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return zie;
  var t = jie(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Gie = Bv(), Gs = "data-scroll-locked", Vie = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Tie, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Gs, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(mc, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(pc, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(mc, " .").concat(mc, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(pc, " .").concat(pc, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Gs, `] {
    `).concat(_ie, ": ").concat(s, `px;
  }
`);
}, p4 = function() {
  var e = parseInt(document.body.getAttribute(Gs) || "0", 10);
  return isFinite(e) ? e : 0;
}, Uie = function() {
  S.useEffect(function() {
    return document.body.setAttribute(Gs, (p4() + 1).toString()), function() {
      var e = p4() - 1;
      e <= 0 ? document.body.removeAttribute(Gs) : document.body.setAttribute(Gs, e.toString());
    };
  }, []);
}, XI = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Uie();
  var i = S.useMemo(function() {
    return Bie(o);
  }, [o]);
  return S.createElement(Gie, { styles: Vie(i, !t, o, n ? "" : "!important") });
}, Vg = !1;
if (typeof window < "u")
  try {
    var rd = Object.defineProperty({}, "passive", {
      get: function() {
        return Vg = !0, !0;
      }
    });
    window.addEventListener("test", rd, rd), window.removeEventListener("test", rd, rd);
  } catch {
    Vg = !1;
  }
var bs = Vg ? { passive: !1 } : !1, Wie = function(e) {
  return e.tagName === "TEXTAREA";
}, JI = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Wie(e) && n[t] === "visible")
  );
}, Hie = function(e) {
  return JI(e, "overflowY");
}, qie = function(e) {
  return JI(e, "overflowX");
}, h4 = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = QI(e, n);
    if (r) {
      var o = eR(e, n), i = o[1], a = o[2];
      if (i > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, Yie = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Kie = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, QI = function(e, t) {
  return e === "v" ? Hie(t) : qie(t);
}, eR = function(e, t) {
  return e === "v" ? Yie(t) : Kie(t);
}, Zie = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Xie = function(e, t, n, r, o) {
  var i = Zie(e, window.getComputedStyle(t).direction), a = i * r, s = n.target, l = t.contains(s), c = !1, u = a > 0, d = 0, m = 0;
  do {
    var h = eR(e, s), v = h[0], g = h[1], x = h[2], b = g - x - i * v;
    (v || b) && QI(e, s) && (d += b, m += v), s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && d === 0 || !u && m === 0) && (c = !0), c;
}, od = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, g4 = function(e) {
  return [e.deltaX, e.deltaY];
}, v4 = function(e) {
  return e && "current" in e ? e.current : e;
}, Jie = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Qie = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, eae = 0, Ss = [];
function tae(e) {
  var t = S.useRef([]), n = S.useRef([0, 0]), r = S.useRef(), o = S.useState(eae++)[0], i = S.useState(function() {
    return Bv();
  })[0], a = S.useRef(e);
  S.useEffect(function() {
    a.current = e;
  }, [e]), S.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = WI([e.lockRef.current], (e.shards || []).map(v4), !0).filter(Boolean);
      return g.forEach(function(x) {
        return x.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(x) {
          return x.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = S.useCallback(function(g, x) {
    if ("touches" in g && g.touches.length === 2)
      return !a.current.allowPinchZoom;
    var b = od(g), C = n.current, I = "deltaX" in g ? g.deltaX : C[0] - b[0], T = "deltaY" in g ? g.deltaY : C[1] - b[1], R, A = g.target, _ = Math.abs(I) > Math.abs(T) ? "h" : "v";
    if ("touches" in g && _ === "h" && A.type === "range")
      return !1;
    var k = h4(_, A);
    if (!k)
      return !0;
    if (k ? R = _ : (R = _ === "v" ? "h" : "v", k = h4(_, A)), !k)
      return !1;
    if (!r.current && "changedTouches" in g && (I || T) && (r.current = R), !R)
      return !0;
    var M = r.current || R;
    return Xie(M, x, g, M === "h" ? I : T);
  }, []), l = S.useCallback(function(g) {
    var x = g;
    if (!(!Ss.length || Ss[Ss.length - 1] !== i)) {
      var b = "deltaY" in x ? g4(x) : od(x), C = t.current.filter(function(R) {
        return R.name === x.type && R.target === x.target && Jie(R.delta, b);
      })[0];
      if (C && C.should) {
        x.cancelable && x.preventDefault();
        return;
      }
      if (!C) {
        var I = (a.current.shards || []).map(v4).filter(Boolean).filter(function(R) {
          return R.contains(x.target);
        }), T = I.length > 0 ? s(x, I[0]) : !a.current.noIsolation;
        T && x.cancelable && x.preventDefault();
      }
    }
  }, []), c = S.useCallback(function(g, x, b, C) {
    var I = { name: g, delta: x, target: b, should: C };
    t.current.push(I), setTimeout(function() {
      t.current = t.current.filter(function(T) {
        return T !== I;
      });
    }, 1);
  }, []), u = S.useCallback(function(g) {
    n.current = od(g), r.current = void 0;
  }, []), d = S.useCallback(function(g) {
    c(g.type, g4(g), g.target, s(g, e.lockRef.current));
  }, []), m = S.useCallback(function(g) {
    c(g.type, od(g), g.target, s(g, e.lockRef.current));
  }, []);
  S.useEffect(function() {
    return Ss.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, bs), document.addEventListener("touchmove", l, bs), document.addEventListener("touchstart", u, bs), function() {
      Ss = Ss.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, bs), document.removeEventListener("touchmove", l, bs), document.removeEventListener("touchstart", u, bs);
    };
  }, []);
  var h = e.removeScrollBar, v = e.inert;
  return S.createElement(
    S.Fragment,
    null,
    v ? S.createElement(i, { styles: Qie(o) }) : null,
    h ? S.createElement(XI, { gapMode: "margin" }) : null
  );
}
const nae = KI(ZI, tae);
var tR = S.forwardRef(function(e, t) {
  return S.createElement(Im, Wn({}, e, { ref: t, sideCar: nae }));
});
tR.classNames = Im.classNames;
var rae = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, xs = /* @__PURE__ */ new WeakMap(), id = /* @__PURE__ */ new WeakMap(), ad = {}, qp = 0, nR = function(e) {
  return e && (e.host || nR(e.parentNode));
}, oae = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = nR(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, iae = function(e, t, n, r) {
  var o = oae(t, Array.isArray(e) ? e : [e]);
  ad[n] || (ad[n] = /* @__PURE__ */ new WeakMap());
  var i = ad[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(m) {
      if (s.has(m))
        u(m);
      else
        try {
          var h = m.getAttribute(r), v = h !== null && h !== "false", g = (xs.get(m) || 0) + 1, x = (i.get(m) || 0) + 1;
          xs.set(m, g), i.set(m, x), a.push(m), g === 1 && v && id.set(m, !0), x === 1 && m.setAttribute(n, "true"), v || m.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", m, b);
        }
    });
  };
  return u(t), s.clear(), qp++, function() {
    a.forEach(function(d) {
      var m = xs.get(d) - 1, h = i.get(d) - 1;
      xs.set(d, m), i.set(d, h), m || (id.has(d) || d.removeAttribute(r), id.delete(d)), h || d.removeAttribute(n);
    }), qp--, qp || (xs = /* @__PURE__ */ new WeakMap(), xs = /* @__PURE__ */ new WeakMap(), id = /* @__PURE__ */ new WeakMap(), ad = {});
  };
}, uu = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = rae(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), iae(r, o, n, "aria-hidden")) : function() {
    return null;
  };
};
const rR = "Dialog", [oR] = Joe(rR), [aae, es] = oR(rR), sae = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: a = !0 } = e, s = He(null), l = He(null), [c = !1, u] = nie({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ Lt(aae, {
    scope: t,
    triggerRef: s,
    contentRef: l,
    contentId: jp(),
    titleId: jp(),
    descriptionId: jp(),
    open: c,
    onOpenChange: u,
    onOpenToggle: Ke(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    ),
    modal: a
  }, n);
}, iR = "DialogPortal", [lae, aR] = oR(iR, {
  forceMount: void 0
}), cae = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = es(iR, t);
  return /* @__PURE__ */ Lt(lae, {
    scope: t,
    forceMount: n
  }, Aa.map(
    r,
    (a) => /* @__PURE__ */ Lt(Em, {
      present: n || i.open
    }, /* @__PURE__ */ Lt(wie, {
      asChild: !0,
      container: o
    }, a))
  ));
}, Ug = "DialogOverlay", uae = /* @__PURE__ */ It((e, t) => {
  const n = aR(Ug, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = es(Ug, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ Lt(Em, {
    present: r || i.open
  }, /* @__PURE__ */ Lt(dae, nr({}, o, {
    ref: t
  }))) : null;
}), dae = /* @__PURE__ */ It((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = es(Ug, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ Lt(tR, {
      as: zv,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ Lt(Kr.div, nr({
      "data-state": lR(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), el = "DialogContent", fae = /* @__PURE__ */ It((e, t) => {
  const n = aR(el, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = es(el, e.__scopeDialog);
  return /* @__PURE__ */ Lt(Em, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ Lt(mae, nr({}, o, {
    ref: t
  })) : /* @__PURE__ */ Lt(pae, nr({}, o, {
    ref: t
  })));
}), mae = /* @__PURE__ */ It((e, t) => {
  const n = es(el, e.__scopeDialog), r = He(null), o = cu(t, n.contentRef, r);
  return Le(() => {
    const i = r.current;
    if (i) return uu(i);
  }, []), /* @__PURE__ */ Lt(sR, nr({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Bs(e.onCloseAutoFocus, (i) => {
      var a;
      i.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: Bs(e.onPointerDownOutside, (i) => {
      const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || s) && i.preventDefault();
    }),
    onFocusOutside: Bs(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), pae = /* @__PURE__ */ It((e, t) => {
  const n = es(el, e.__scopeDialog), r = He(!1), o = He(!1);
  return /* @__PURE__ */ Lt(sR, nr({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, i), !i.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = i.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), sR = /* @__PURE__ */ It((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, s = es(el, n), l = He(null), c = cu(t, l);
  return Rie(), /* @__PURE__ */ Lt(ll, null, /* @__PURE__ */ Lt(gie, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ Lt(mie, nr({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": lR(s.open)
  }, a, {
    ref: c,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), hae = "DialogTitle";
function lR(e) {
  return e ? "open" : "closed";
}
const gae = "DialogTitleWarning";
Xoe(gae, {
  contentName: el,
  titleName: hae,
  docsSlug: "dialog"
});
const vae = sae, yae = cae, bae = uae, Sae = fae;
var Gl = '[cmdk-group=""]', Yp = '[cmdk-group-items=""]', xae = '[cmdk-group-heading=""]', Gv = '[cmdk-item=""]', y4 = `${Gv}:not([aria-disabled="true"])`, Wg = "cmdk-item-select", Ra = "data-value", Cae = (e, t, n) => Koe(e, t, n), cR = S.createContext(void 0), du = () => S.useContext(cR), uR = S.createContext(void 0), Vv = () => S.useContext(uR), dR = S.createContext(void 0), fR = S.forwardRef((e, t) => {
  let n = _s(() => {
    var F, Z;
    return { search: "", value: (Z = (F = e.value) != null ? F : e.defaultValue) != null ? Z : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = _s(() => /* @__PURE__ */ new Set()), o = _s(() => /* @__PURE__ */ new Map()), i = _s(() => /* @__PURE__ */ new Map()), a = _s(() => /* @__PURE__ */ new Set()), s = mR(e), { label: l, children: c, value: u, onValueChange: d, filter: m, shouldFilter: h, loop: v, disablePointerSelection: g = !1, vimBindings: x = !0, ...b } = e, C = S.useId(), I = S.useId(), T = S.useId(), R = S.useRef(null), A = Pae();
  Va(() => {
    if (u !== void 0) {
      let F = u.trim();
      n.current.value = F, _.emit();
    }
  }, [u]), Va(() => {
    A(6, B);
  }, []);
  let _ = S.useMemo(() => ({ subscribe: (F) => (a.current.add(F), () => a.current.delete(F)), snapshot: () => n.current, setState: (F, Z, se) => {
    var ae, ue, te;
    if (!Object.is(n.current[F], Z)) {
      if (n.current[F] = Z, F === "search") U(), j(), A(1, G);
      else if (F === "value" && (se || A(5, B), ((ae = s.current) == null ? void 0 : ae.value) !== void 0)) {
        let he = Z ?? "";
        (te = (ue = s.current).onValueChange) == null || te.call(ue, he);
        return;
      }
      _.emit();
    }
  }, emit: () => {
    a.current.forEach((F) => F());
  } }), []), k = S.useMemo(() => ({ value: (F, Z, se) => {
    var ae;
    Z !== ((ae = i.current.get(F)) == null ? void 0 : ae.value) && (i.current.set(F, { value: Z, keywords: se }), n.current.filtered.items.set(F, M(Z, se)), A(2, () => {
      j(), _.emit();
    }));
  }, item: (F, Z) => (r.current.add(F), Z && (o.current.has(Z) ? o.current.get(Z).add(F) : o.current.set(Z, /* @__PURE__ */ new Set([F]))), A(3, () => {
    U(), j(), n.current.value || G(), _.emit();
  }), () => {
    i.current.delete(F), r.current.delete(F), n.current.filtered.items.delete(F);
    let se = K();
    A(4, () => {
      U(), (se == null ? void 0 : se.getAttribute("id")) === F && G(), _.emit();
    });
  }), group: (F) => (o.current.has(F) || o.current.set(F, /* @__PURE__ */ new Set()), () => {
    i.current.delete(F), o.current.delete(F);
  }), filter: () => s.current.shouldFilter, label: l || e["aria-label"], disablePointerSelection: g, listId: C, inputId: T, labelId: I, listInnerRef: R }), []);
  function M(F, Z) {
    var se, ae;
    let ue = (ae = (se = s.current) == null ? void 0 : se.filter) != null ? ae : Cae;
    return F ? ue(F, n.current.search, Z) : 0;
  }
  function j() {
    if (!n.current.search || s.current.shouldFilter === !1) return;
    let F = n.current.filtered.items, Z = [];
    n.current.filtered.groups.forEach((ae) => {
      let ue = o.current.get(ae), te = 0;
      ue.forEach((he) => {
        let ge = F.get(he);
        te = Math.max(ge, te);
      }), Z.push([ae, te]);
    });
    let se = R.current;
    ee().sort((ae, ue) => {
      var te, he;
      let ge = ae.getAttribute("id"), de = ue.getAttribute("id");
      return ((te = F.get(de)) != null ? te : 0) - ((he = F.get(ge)) != null ? he : 0);
    }).forEach((ae) => {
      let ue = ae.closest(Yp);
      ue ? ue.appendChild(ae.parentElement === ue ? ae : ae.closest(`${Yp} > *`)) : se.appendChild(ae.parentElement === se ? ae : ae.closest(`${Yp} > *`));
    }), Z.sort((ae, ue) => ue[1] - ae[1]).forEach((ae) => {
      let ue = R.current.querySelector(`${Gl}[${Ra}="${encodeURIComponent(ae[0])}"]`);
      ue == null || ue.parentElement.appendChild(ue);
    });
  }
  function G() {
    let F = ee().find((se) => se.getAttribute("aria-disabled") !== "true"), Z = F == null ? void 0 : F.getAttribute(Ra);
    _.setState("value", Z || void 0);
  }
  function U() {
    var F, Z, se, ae;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let ue = 0;
    for (let te of r.current) {
      let he = (Z = (F = i.current.get(te)) == null ? void 0 : F.value) != null ? Z : "", ge = (ae = (se = i.current.get(te)) == null ? void 0 : se.keywords) != null ? ae : [], de = M(he, ge);
      n.current.filtered.items.set(te, de), de > 0 && ue++;
    }
    for (let [te, he] of o.current) for (let ge of he) if (n.current.filtered.items.get(ge) > 0) {
      n.current.filtered.groups.add(te);
      break;
    }
    n.current.filtered.count = ue;
  }
  function B() {
    var F, Z, se;
    let ae = K();
    ae && (((F = ae.parentElement) == null ? void 0 : F.firstChild) === ae && ((se = (Z = ae.closest(Gl)) == null ? void 0 : Z.querySelector(xae)) == null || se.scrollIntoView({ block: "nearest" })), ae.scrollIntoView({ block: "nearest" }));
  }
  function K() {
    var F;
    return (F = R.current) == null ? void 0 : F.querySelector(`${Gv}[aria-selected="true"]`);
  }
  function ee() {
    var F;
    return Array.from((F = R.current) == null ? void 0 : F.querySelectorAll(y4));
  }
  function Y(F) {
    let Z = ee()[F];
    Z && _.setState("value", Z.getAttribute(Ra));
  }
  function J(F) {
    var Z;
    let se = K(), ae = ee(), ue = ae.findIndex((he) => he === se), te = ae[ue + F];
    (Z = s.current) != null && Z.loop && (te = ue + F < 0 ? ae[ae.length - 1] : ue + F === ae.length ? ae[0] : ae[ue + F]), te && _.setState("value", te.getAttribute(Ra));
  }
  function ye(F) {
    let Z = K(), se = Z == null ? void 0 : Z.closest(Gl), ae;
    for (; se && !ae; ) se = F > 0 ? kae(se, Gl) : Dae(se, Gl), ae = se == null ? void 0 : se.querySelector(y4);
    ae ? _.setState("value", ae.getAttribute(Ra)) : J(F);
  }
  let re = () => Y(ee().length - 1), le = (F) => {
    F.preventDefault(), F.metaKey ? re() : F.altKey ? ye(1) : J(1);
  }, Te = (F) => {
    F.preventDefault(), F.metaKey ? Y(0) : F.altKey ? ye(-1) : J(-1);
  };
  return S.createElement(Kr.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (F) => {
    var Z;
    if ((Z = b.onKeyDown) == null || Z.call(b, F), !F.defaultPrevented) switch (F.key) {
      case "n":
      case "j": {
        x && F.ctrlKey && le(F);
        break;
      }
      case "ArrowDown": {
        le(F);
        break;
      }
      case "p":
      case "k": {
        x && F.ctrlKey && Te(F);
        break;
      }
      case "ArrowUp": {
        Te(F);
        break;
      }
      case "Home": {
        F.preventDefault(), Y(0);
        break;
      }
      case "End": {
        F.preventDefault(), re();
        break;
      }
      case "Enter":
        if (!F.nativeEvent.isComposing && F.keyCode !== 229) {
          F.preventDefault();
          let se = K();
          if (se) {
            let ae = new Event(Wg);
            se.dispatchEvent(ae);
          }
        }
    }
  } }, S.createElement("label", { "cmdk-label": "", htmlFor: k.inputId, id: k.labelId, style: Mae }, l), Rm(e, (F) => S.createElement(uR.Provider, { value: _ }, S.createElement(cR.Provider, { value: k }, F))));
}), wae = S.forwardRef((e, t) => {
  var n, r;
  let o = S.useId(), i = S.useRef(null), a = S.useContext(dR), s = du(), l = mR(e), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : a == null ? void 0 : a.forceMount;
  Va(() => {
    if (!c) return s.item(o, a == null ? void 0 : a.id);
  }, [c]);
  let u = pR(o, i, [e.value, e.children, i], e.keywords), d = Vv(), m = Ua((A) => A.value && A.value === u.current), h = Ua((A) => c || s.filter() === !1 ? !0 : A.search ? A.filtered.items.get(o) > 0 : !0);
  S.useEffect(() => {
    let A = i.current;
    if (!(!A || e.disabled)) return A.addEventListener(Wg, v), () => A.removeEventListener(Wg, v);
  }, [h, e.onSelect, e.disabled]);
  function v() {
    var A, _;
    g(), (_ = (A = l.current).onSelect) == null || _.call(A, u.current);
  }
  function g() {
    d.setState("value", u.current, !0);
  }
  if (!h) return null;
  let { disabled: x, value: b, onSelect: C, forceMount: I, keywords: T, ...R } = e;
  return S.createElement(Kr.div, { ref: Lc([i, t]), ...R, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!x, "aria-selected": !!m, "data-disabled": !!x, "data-selected": !!m, onPointerMove: x || s.disablePointerSelection ? void 0 : g, onClick: x ? void 0 : v }, e.children);
}), Eae = S.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...i } = e, a = S.useId(), s = S.useRef(null), l = S.useRef(null), c = S.useId(), u = du(), d = Ua((h) => o || u.filter() === !1 ? !0 : h.search ? h.filtered.groups.has(a) : !0);
  Va(() => u.group(a), []), pR(a, s, [e.value, e.heading, l]);
  let m = S.useMemo(() => ({ id: a, forceMount: o }), [o]);
  return S.createElement(Kr.div, { ref: Lc([s, t]), ...i, "cmdk-group": "", role: "presentation", hidden: d ? void 0 : !0 }, n && S.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), Rm(e, (h) => S.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, S.createElement(dR.Provider, { value: m }, h))));
}), Iae = S.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = S.useRef(null), i = Ua((a) => !a.search);
  return !n && !i ? null : S.createElement(Kr.div, { ref: Lc([o, t]), ...r, "cmdk-separator": "", role: "separator" });
}), Rae = S.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, i = Vv(), a = Ua((u) => u.search), s = Ua((u) => u.value), l = du(), c = S.useMemo(() => {
    var u;
    let d = (u = l.listInnerRef.current) == null ? void 0 : u.querySelector(`${Gv}[${Ra}="${encodeURIComponent(s)}"]`);
    return d == null ? void 0 : d.getAttribute("id");
  }, []);
  return S.useEffect(() => {
    e.value != null && i.setState("search", e.value);
  }, [e.value]), S.createElement(Kr.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": c, id: l.inputId, type: "text", value: o ? e.value : a, onChange: (u) => {
    o || i.setState("search", u.target.value), n == null || n(u.target.value);
  } });
}), Tae = S.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, i = S.useRef(null), a = S.useRef(null), s = du();
  return S.useEffect(() => {
    if (a.current && i.current) {
      let l = a.current, c = i.current, u, d = new ResizeObserver(() => {
        u = requestAnimationFrame(() => {
          let m = l.offsetHeight;
          c.style.setProperty("--cmdk-list-height", m.toFixed(1) + "px");
        });
      });
      return d.observe(l), () => {
        cancelAnimationFrame(u), d.unobserve(l);
      };
    }
  }, []), S.createElement(Kr.div, { ref: Lc([i, t]), ...o, "cmdk-list": "", role: "listbox", "aria-label": r, id: s.listId }, Rm(e, (l) => S.createElement("div", { ref: Lc([a, s.listInnerRef]), "cmdk-list-sizer": "" }, l)));
}), _ae = S.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: i, container: a, ...s } = e;
  return S.createElement(vae, { open: n, onOpenChange: r }, S.createElement(yae, { container: a }, S.createElement(bae, { "cmdk-overlay": "", className: o }), S.createElement(Sae, { "aria-label": e.label, "cmdk-dialog": "", className: i }, S.createElement(fR, { ref: t, ...s }))));
}), Oae = S.forwardRef((e, t) => Ua((n) => n.filtered.count === 0) ? S.createElement(Kr.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), Aae = S.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...i } = e;
  return S.createElement(Kr.div, { ref: t, ...i, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Rm(e, (a) => S.createElement("div", { "aria-hidden": !0 }, a)));
}), or = Object.assign(fR, { List: Tae, Item: wae, Input: Rae, Group: Eae, Separator: Iae, Dialog: _ae, Empty: Oae, Loading: Aae });
function kae(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function Dae(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function mR(e) {
  let t = S.useRef(e);
  return Va(() => {
    t.current = e;
  }), t;
}
var Va = typeof window > "u" ? S.useEffect : S.useLayoutEffect;
function _s(e) {
  let t = S.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function Lc(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function Ua(e) {
  let t = Vv(), n = () => e(t.snapshot());
  return S.useSyncExternalStore(t.subscribe, n, n);
}
function pR(e, t, n, r = []) {
  let o = S.useRef(), i = du();
  return Va(() => {
    var a;
    let s = (() => {
      var c;
      for (let u of n) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (c = u.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), l = r.map((c) => c.trim());
    i.value(e, s, l), (a = t.current) == null || a.setAttribute(Ra, s), o.current = s;
  }), o;
}
var Pae = () => {
  let [e, t] = S.useState(), n = _s(() => /* @__PURE__ */ new Map());
  return Va(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function Nae(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Rm({ asChild: e, children: t }, n) {
  return e && S.isValidElement(t) ? S.cloneElement(Nae(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var Mae = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
function hR(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = tr(e);
  S.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Fae = "DismissableLayer", Hg = "dismissableLayer.update", Lae = "dismissableLayer.pointerDownOutside", $ae = "dismissableLayer.focusOutside", b4, gR = S.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), fu = S.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, c = S.useContext(gR), [u, d] = S.useState(null), m = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = S.useState({}), v = mt(t, (_) => d(_)), g = Array.from(c.layers), [x] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), b = g.indexOf(x), C = u ? g.indexOf(u) : -1, I = c.layersWithOutsidePointerEventsDisabled.size > 0, T = C >= b, R = Bae((_) => {
      const k = _.target, M = [...c.branches].some((j) => j.contains(k));
      !T || M || (o == null || o(_), a == null || a(_), _.defaultPrevented || s == null || s());
    }, m), A = Gae((_) => {
      const k = _.target;
      [...c.branches].some((j) => j.contains(k)) || (i == null || i(_), a == null || a(_), _.defaultPrevented || s == null || s());
    }, m);
    return hR((_) => {
      C === c.layers.size - 1 && (r == null || r(_), !_.defaultPrevented && s && (_.preventDefault(), s()));
    }, m), S.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (b4 = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), S4(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = b4);
        };
    }, [u, m, n, c]), S.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), S4());
    }, [u, c]), S.useEffect(() => {
      const _ = () => h({});
      return document.addEventListener(Hg, _), () => document.removeEventListener(Hg, _);
    }, []), /* @__PURE__ */ f.jsx(
      at.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: I ? T ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Re(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Re(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Re(
          e.onPointerDownCapture,
          R.onPointerDownCapture
        )
      }
    );
  }
);
fu.displayName = Fae;
var zae = "DismissableLayerBranch", jae = S.forwardRef((e, t) => {
  const n = S.useContext(gR), r = S.useRef(null), o = mt(t, r);
  return S.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ f.jsx(at.div, { ...e, ref: o });
});
jae.displayName = zae;
function Bae(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = tr(e), r = S.useRef(!1), o = S.useRef(() => {
  });
  return S.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          vR(
            Lae,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Gae(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = tr(e), r = S.useRef(!1);
  return S.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && vR($ae, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function S4() {
  const e = new CustomEvent(Hg);
  document.dispatchEvent(e);
}
function vR(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Dv(o, i) : o.dispatchEvent(i);
}
var Kp = "focusScope.autoFocusOnMount", Zp = "focusScope.autoFocusOnUnmount", x4 = { bubbles: !1, cancelable: !0 }, Vae = "FocusScope", mu = S.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = e, [s, l] = S.useState(null), c = tr(o), u = tr(i), d = S.useRef(null), m = mt(t, (g) => l(g)), h = S.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  S.useEffect(() => {
    if (r) {
      let g = function(I) {
        if (h.paused || !s) return;
        const T = I.target;
        s.contains(T) ? d.current = T : Ai(d.current, { select: !0 });
      }, x = function(I) {
        if (h.paused || !s) return;
        const T = I.relatedTarget;
        T !== null && (s.contains(T) || Ai(d.current, { select: !0 }));
      }, b = function(I) {
        if (document.activeElement === document.body)
          for (const R of I)
            R.removedNodes.length > 0 && Ai(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", x);
      const C = new MutationObserver(b);
      return s && C.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", x), C.disconnect();
      };
    }
  }, [r, s, h.paused]), S.useEffect(() => {
    if (s) {
      w4.add(h);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const b = new CustomEvent(Kp, x4);
        s.addEventListener(Kp, c), s.dispatchEvent(b), b.defaultPrevented || (Uae(Kae(yR(s)), { select: !0 }), document.activeElement === g && Ai(s));
      }
      return () => {
        s.removeEventListener(Kp, c), setTimeout(() => {
          const b = new CustomEvent(Zp, x4);
          s.addEventListener(Zp, u), s.dispatchEvent(b), b.defaultPrevented || Ai(g ?? document.body, { select: !0 }), s.removeEventListener(Zp, u), w4.remove(h);
        }, 0);
      };
    }
  }, [s, c, u, h]);
  const v = S.useCallback(
    (g) => {
      if (!n && !r || h.paused) return;
      const x = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
      if (x && b) {
        const C = g.currentTarget, [I, T] = Wae(C);
        I && T ? !g.shiftKey && b === T ? (g.preventDefault(), n && Ai(I, { select: !0 })) : g.shiftKey && b === I && (g.preventDefault(), n && Ai(T, { select: !0 })) : b === C && g.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ f.jsx(at.div, { tabIndex: -1, ...a, ref: m, onKeyDown: v });
});
mu.displayName = Vae;
function Uae(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ai(r, { select: t }), document.activeElement !== n) return;
}
function Wae(e) {
  const t = yR(e), n = C4(t, e), r = C4(t.reverse(), e);
  return [n, r];
}
function yR(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function C4(e, t) {
  for (const n of e)
    if (!Hae(n, { upTo: t })) return n;
}
function Hae(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function qae(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ai(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && qae(e) && t && e.select();
  }
}
var w4 = Yae();
function Yae() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = E4(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = E4(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function E4(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Kae(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Zae = "Portal", pu = S.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, i] = S.useState(!1);
  An(() => i(!0), []);
  const a = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? M1.createPortal(/* @__PURE__ */ f.jsx(at.div, { ...r, ref: t }), a) : null;
});
pu.displayName = Zae;
var Xp = 0;
function Tm() {
  S.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? I4()), document.body.insertAdjacentElement("beforeend", e[1] ?? I4()), Xp++, () => {
      Xp === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Xp--;
    };
  }, []);
}
function I4() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var bR = qI(), Jp = function() {
}, _m = S.forwardRef(function(e, t) {
  var n = S.useRef(null), r = S.useState({
    onScrollCapture: Jp,
    onWheelCapture: Jp,
    onTouchMoveCapture: Jp
  }), o = r[0], i = r[1], a = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, m = e.sideCar, h = e.noIsolation, v = e.inert, g = e.allowPinchZoom, x = e.as, b = x === void 0 ? "div" : x, C = e.gapMode, I = jv(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), T = m, R = HI([n, t]), A = Wn(Wn({}, I), o);
  return S.createElement(
    S.Fragment,
    null,
    u && S.createElement(T, { sideCar: bR, removeScrollBar: c, shards: d, noIsolation: h, inert: v, setCallbacks: i, allowPinchZoom: !!g, lockRef: n, gapMode: C }),
    a ? S.cloneElement(S.Children.only(s), Wn(Wn({}, A), { ref: R })) : S.createElement(b, Wn({}, A, { className: l, ref: R }), s)
  );
});
_m.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
_m.classNames = {
  fullWidth: pc,
  zeroRight: mc
};
var qg = !1;
if (typeof window < "u")
  try {
    var sd = Object.defineProperty({}, "passive", {
      get: function() {
        return qg = !0, !0;
      }
    });
    window.addEventListener("test", sd, sd), window.removeEventListener("test", sd, sd);
  } catch {
    qg = !1;
  }
var Cs = qg ? { passive: !1 } : !1, Xae = function(e) {
  return e.tagName === "TEXTAREA";
}, SR = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Xae(e) && n[t] === "visible")
  );
}, Jae = function(e) {
  return SR(e, "overflowY");
}, Qae = function(e) {
  return SR(e, "overflowX");
}, R4 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = xR(e, r);
    if (o) {
      var i = CR(e, r), a = i[1], s = i[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, ese = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, tse = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, xR = function(e, t) {
  return e === "v" ? Jae(t) : Qae(t);
}, CR = function(e, t) {
  return e === "v" ? ese(t) : tse(t);
}, nse = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, rse = function(e, t, n, r, o) {
  var i = nse(e, window.getComputedStyle(t).direction), a = i * r, s = n.target, l = t.contains(s), c = !1, u = a > 0, d = 0, m = 0;
  do {
    var h = CR(e, s), v = h[0], g = h[1], x = h[2], b = g - x - i * v;
    (v || b) && xR(e, s) && (d += b, m += v), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(m) < 1) && (c = !0), c;
}, ld = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, T4 = function(e) {
  return [e.deltaX, e.deltaY];
}, _4 = function(e) {
  return e && "current" in e ? e.current : e;
}, ose = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, ise = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ase = 0, ws = [];
function sse(e) {
  var t = S.useRef([]), n = S.useRef([0, 0]), r = S.useRef(), o = S.useState(ase++)[0], i = S.useState(Bv)[0], a = S.useRef(e);
  S.useEffect(function() {
    a.current = e;
  }, [e]), S.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = WI([e.lockRef.current], (e.shards || []).map(_4), !0).filter(Boolean);
      return g.forEach(function(x) {
        return x.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(x) {
          return x.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = S.useCallback(function(g, x) {
    if ("touches" in g && g.touches.length === 2)
      return !a.current.allowPinchZoom;
    var b = ld(g), C = n.current, I = "deltaX" in g ? g.deltaX : C[0] - b[0], T = "deltaY" in g ? g.deltaY : C[1] - b[1], R, A = g.target, _ = Math.abs(I) > Math.abs(T) ? "h" : "v";
    if ("touches" in g && _ === "h" && A.type === "range")
      return !1;
    var k = R4(_, A);
    if (!k)
      return !0;
    if (k ? R = _ : (R = _ === "v" ? "h" : "v", k = R4(_, A)), !k)
      return !1;
    if (!r.current && "changedTouches" in g && (I || T) && (r.current = R), !R)
      return !0;
    var M = r.current || R;
    return rse(M, x, g, M === "h" ? I : T);
  }, []), l = S.useCallback(function(g) {
    var x = g;
    if (!(!ws.length || ws[ws.length - 1] !== i)) {
      var b = "deltaY" in x ? T4(x) : ld(x), C = t.current.filter(function(R) {
        return R.name === x.type && (R.target === x.target || x.target === R.shadowParent) && ose(R.delta, b);
      })[0];
      if (C && C.should) {
        x.cancelable && x.preventDefault();
        return;
      }
      if (!C) {
        var I = (a.current.shards || []).map(_4).filter(Boolean).filter(function(R) {
          return R.contains(x.target);
        }), T = I.length > 0 ? s(x, I[0]) : !a.current.noIsolation;
        T && x.cancelable && x.preventDefault();
      }
    }
  }, []), c = S.useCallback(function(g, x, b, C) {
    var I = { name: g, delta: x, target: b, should: C, shadowParent: lse(b) };
    t.current.push(I), setTimeout(function() {
      t.current = t.current.filter(function(T) {
        return T !== I;
      });
    }, 1);
  }, []), u = S.useCallback(function(g) {
    n.current = ld(g), r.current = void 0;
  }, []), d = S.useCallback(function(g) {
    c(g.type, T4(g), g.target, s(g, e.lockRef.current));
  }, []), m = S.useCallback(function(g) {
    c(g.type, ld(g), g.target, s(g, e.lockRef.current));
  }, []);
  S.useEffect(function() {
    return ws.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, Cs), document.addEventListener("touchmove", l, Cs), document.addEventListener("touchstart", u, Cs), function() {
      ws = ws.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, Cs), document.removeEventListener("touchmove", l, Cs), document.removeEventListener("touchstart", u, Cs);
    };
  }, []);
  var h = e.removeScrollBar, v = e.inert;
  return S.createElement(
    S.Fragment,
    null,
    v ? S.createElement(i, { styles: ise(o) }) : null,
    h ? S.createElement(XI, { gapMode: e.gapMode }) : null
  );
}
function lse(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const cse = KI(bR, sse);
var hu = S.forwardRef(function(e, t) {
  return S.createElement(_m, Wn({}, e, { ref: t, sideCar: cse }));
});
hu.classNames = _m.classNames;
var Uv = "Dialog", [wR] = Vo(Uv), [use, bo] = wR(Uv), ER = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !0
  } = e, s = S.useRef(null), l = S.useRef(null), [c = !1, u] = di({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ f.jsx(
    use,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: _r(),
      titleId: _r(),
      descriptionId: _r(),
      open: c,
      onOpenChange: u,
      onOpenToggle: S.useCallback(() => u((d) => !d), [u]),
      modal: a,
      children: n
    }
  );
};
ER.displayName = Uv;
var IR = "DialogTrigger", RR = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bo(IR, n), i = mt(t, o.triggerRef);
    return /* @__PURE__ */ f.jsx(
      at.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": qv(o.open),
        ...r,
        ref: i,
        onClick: Re(e.onClick, o.onOpenToggle)
      }
    );
  }
);
RR.displayName = IR;
var Wv = "DialogPortal", [dse, TR] = wR(Wv, {
  forceMount: void 0
}), _R = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = bo(Wv, t);
  return /* @__PURE__ */ f.jsx(dse, { scope: t, forceMount: n, children: S.Children.map(r, (a) => /* @__PURE__ */ f.jsx(yo, { present: n || i.open, children: /* @__PURE__ */ f.jsx(pu, { asChild: !0, container: o, children: a }) })) });
};
_R.displayName = Wv;
var Sf = "DialogOverlay", OR = S.forwardRef(
  (e, t) => {
    const n = TR(Sf, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = bo(Sf, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ f.jsx(yo, { present: r || i.open, children: /* @__PURE__ */ f.jsx(fse, { ...o, ref: t }) }) : null;
  }
);
OR.displayName = Sf;
var fse = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bo(Sf, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ f.jsx(hu, { as: si, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ f.jsx(
        at.div,
        {
          "data-state": qv(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Wa = "DialogContent", AR = S.forwardRef(
  (e, t) => {
    const n = TR(Wa, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = bo(Wa, e.__scopeDialog);
    return /* @__PURE__ */ f.jsx(yo, { present: r || i.open, children: i.modal ? /* @__PURE__ */ f.jsx(mse, { ...o, ref: t }) : /* @__PURE__ */ f.jsx(pse, { ...o, ref: t }) });
  }
);
AR.displayName = Wa;
var mse = S.forwardRef(
  (e, t) => {
    const n = bo(Wa, e.__scopeDialog), r = S.useRef(null), o = mt(t, n.contentRef, r);
    return S.useEffect(() => {
      const i = r.current;
      if (i) return uu(i);
    }, []), /* @__PURE__ */ f.jsx(
      kR,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Re(e.onCloseAutoFocus, (i) => {
          var a;
          i.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: Re(e.onPointerDownOutside, (i) => {
          const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: Re(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), pse = S.forwardRef(
  (e, t) => {
    const n = bo(Wa, e.__scopeDialog), r = S.useRef(!1), o = S.useRef(!1);
    return /* @__PURE__ */ f.jsx(
      kR,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, i), i.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), kR = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, s = bo(Wa, n), l = S.useRef(null), c = mt(t, l);
    return Tm(), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx(
        mu,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ f.jsx(
            fu,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": qv(s.open),
              ...a,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(hse, { titleId: s.titleId }),
        /* @__PURE__ */ f.jsx(vse, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Hv = "DialogTitle", DR = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bo(Hv, n);
    return /* @__PURE__ */ f.jsx(at.h2, { id: o.titleId, ...r, ref: t });
  }
);
DR.displayName = Hv;
var PR = "DialogDescription", NR = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bo(PR, n);
    return /* @__PURE__ */ f.jsx(at.p, { id: o.descriptionId, ...r, ref: t });
  }
);
NR.displayName = PR;
var MR = "DialogClose", FR = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = bo(MR, n);
    return /* @__PURE__ */ f.jsx(
      at.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Re(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
FR.displayName = MR;
function qv(e) {
  return e ? "open" : "closed";
}
var LR = "DialogTitleWarning", [Ove, $R] = Zre(LR, {
  contentName: Wa,
  titleName: Hv,
  docsSlug: "dialog"
}), hse = ({ titleId: e }) => {
  const t = $R(LR), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return S.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, gse = "DialogDescriptionWarning", vse = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${$R(gse).contentName}}.`;
  return S.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, zR = ER, jR = RR, BR = _R, Yv = OR, Kv = AR, Zv = DR, Xv = NR, GR = FR;
const Jv = zR, yse = jR, bse = BR, Sse = GR, VR = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  Yv,
  {
    ref: n,
    className: oe(
      "fixed inset-0 z-50 bg-black/80 backdrop-blur-xs duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
VR.displayName = Yv.displayName;
const Om = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f.jsxs(bse, { children: [
  /* @__PURE__ */ f.jsx(VR, {}),
  /* @__PURE__ */ f.jsxs(
    Kv,
    {
      ref: r,
      className: oe(
        "fixed top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2",
        "group grid max-h-full w-full max-w-lg grid-flow-dense gap-4 overflow-y-auto rounded-lg rounded-t-lg border border-neutral-200 bg-white p-6 shadow-lg",
        "duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-90 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-90",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ f.jsxs(
          Sse,
          {
            className: oe(
              "absolute top-1 right-1 flex rounded-md p-1.5 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none",
              "bg-white ring-offset-white group-data-[state=open]:text-neutral-500 focus:ring-neutral-950"
            ),
            children: [
              /* @__PURE__ */ f.jsx(Ve, { icon: "close", className: "size-4" }),
              /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Close" })
            ]
          }
        )
      ]
    }
  )
] }));
Om.displayName = Kv.displayName;
function UR({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: oe(
        "flex flex-col space-y-1.5 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
UR.displayName = "DialogHeader";
function WR({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: oe(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        e
      ),
      ...t
    }
  );
}
WR.displayName = "DialogFooter";
const Qv = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  Zv,
  {
    ref: n,
    className: oe(
      "text-lg leading-none font-semibold tracking-tight",
      e
    ),
    ...t
  }
));
Qv.displayName = Zv.displayName;
const HR = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  Xv,
  {
    ref: n,
    className: oe("text-sm text-neutral-500", e),
    ...t
  }
));
HR.displayName = Xv.displayName;
const Ave = or.Loading, Am = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  or,
  {
    ref: n,
    className: oe(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-white text-neutral-950",
      e
    ),
    ...t
  }
));
Am.displayName = or.displayName;
function kve({ children: e, ...t }) {
  return /* @__PURE__ */ f.jsx(Jv, { ...t, children: /* @__PURE__ */ f.jsx(Om, { className: "overflow-hidden p-0 shadow-lg", children: /* @__PURE__ */ f.jsx(Am, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-neutral-500 [&_[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: e }) }) });
}
const e2 = S.forwardRef(({ className: e, ...t }, n) => (
  // oxlint-disable-next-line react/no-unknown-property -- used for styling in `CommandDialog` // probably should be a data attribute
  /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-2 border-b px-3", "cmdk-input-wrapper": "", children: [
    /* @__PURE__ */ f.jsx(Ve, { icon: "search", className: "shrink-0 opacity-50" }),
    /* @__PURE__ */ f.jsx(
      or.Input,
      {
        ref: n,
        className: oe(
          "flex w-full rounded-md border-none bg-transparent px-0 py-3 text-sm ring-0 outline-hidden placeholder:text-neutral-500 focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50",
          e
        ),
        ...t
      }
    )
  ] })
));
e2.displayName = or.Input.displayName;
const t2 = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  or.List,
  {
    ref: n,
    className: oe("max-h-[300px] overflow-x-hidden overflow-y-auto", e),
    ...t
  }
));
t2.displayName = or.List.displayName;
const n2 = S.forwardRef((e, t) => /* @__PURE__ */ f.jsx(
  or.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm text-pretty",
    ...e
  }
));
n2.displayName = or.Empty.displayName;
const xf = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  or.Group,
  {
    ref: n,
    className: oe(
      "overflow-hidden p-1 text-neutral-950 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-neutral-500",
      e
    ),
    ...t
  }
));
xf.displayName = or.Group.displayName;
const xse = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  or.Separator,
  {
    ref: n,
    className: oe("-mx-1 h-px bg-neutral-200", e),
    ...t
  }
));
xse.displayName = or.Separator.displayName;
const _a = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  or.Item,
  {
    ref: n,
    className: oe(
      "relative flex cursor-default items-center rounded-xs px-2 py-1.5 text-sm outline-hidden select-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 data-[selected='true']:bg-neutral-100 data-[selected=true]:text-neutral-900",
      e
    ),
    ...t
  }
));
_a.displayName = or.Item.displayName;
function Cse({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ f.jsx(
    "span",
    {
      className: oe(
        "ml-auto text-xs tracking-widest text-neutral-500",
        e
      ),
      ...t
    }
  );
}
Cse.displayName = "CommandShortcut";
const wse = ["top", "right", "bottom", "left"], Mo = Math.min, Cr = Math.max, Cf = Math.round, cd = Math.floor, Ji = (e) => ({
  x: e,
  y: e
}), Ese = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ise = {
  start: "end",
  end: "start"
};
function Yg(e, t, n) {
  return Cr(e, Mo(t, n));
}
function fi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function mi(e) {
  return e.split("-")[0];
}
function bl(e) {
  return e.split("-")[1];
}
function r2(e) {
  return e === "x" ? "y" : "x";
}
function o2(e) {
  return e === "y" ? "height" : "width";
}
function Qi(e) {
  return ["top", "bottom"].includes(mi(e)) ? "y" : "x";
}
function i2(e) {
  return r2(Qi(e));
}
function Rse(e, t, n) {
  n === void 0 && (n = !1);
  const r = bl(e), o = i2(e), i = o2(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = wf(a)), [a, wf(a)];
}
function Tse(e) {
  const t = wf(e);
  return [Kg(e), t, Kg(t)];
}
function Kg(e) {
  return e.replace(/start|end/g, (t) => Ise[t]);
}
function _se(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function Ose(e, t, n, r) {
  const o = bl(e);
  let i = _se(mi(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(Kg)))), i;
}
function wf(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ese[t]);
}
function Ase(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function qR(e) {
  return typeof e != "number" ? Ase(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ef(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function O4(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Qi(t), a = i2(t), s = o2(a), l = mi(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, m = r[s] / 2 - o[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (bl(t)) {
    case "start":
      h[a] -= m * (n && c ? -1 : 1);
      break;
    case "end":
      h[a] += m * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const kse = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = O4(c, r, l), m = r, h = {}, v = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: x,
      fn: b
    } = s[g], {
      x: C,
      y: I,
      data: T,
      reset: R
    } = await b({
      x: u,
      y: d,
      initialPlacement: r,
      placement: m,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = C ?? u, d = I ?? d, h = {
      ...h,
      [x]: {
        ...h[x],
        ...T
      }
    }, R && v <= 50 && (v++, typeof R == "object" && (R.placement && (m = R.placement), R.rects && (c = R.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : R.rects), {
      x: u,
      y: d
    } = O4(c, m, l)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: m,
    strategy: o,
    middlewareData: h
  };
};
async function $c(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: m = !1,
    padding: h = 0
  } = fi(t, e), v = qR(h), x = s[m ? d === "floating" ? "reference" : "floating" : d], b = Ef(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(x))) == null || n ? x : x.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), C = d === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, I = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), T = await (i.isElement == null ? void 0 : i.isElement(I)) ? await (i.getScale == null ? void 0 : i.getScale(I)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = Ef(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: I,
    strategy: l
  }) : C);
  return {
    top: (b.top - R.top + v.top) / T.y,
    bottom: (R.bottom - b.bottom + v.bottom) / T.y,
    left: (b.left - R.left + v.left) / T.x,
    right: (R.right - b.right + v.right) / T.x
  };
}
const Dse = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = fi(e, t) || {};
    if (c == null)
      return {};
    const d = qR(u), m = {
      x: n,
      y: r
    }, h = i2(o), v = o2(h), g = await a.getDimensions(c), x = h === "y", b = x ? "top" : "left", C = x ? "bottom" : "right", I = x ? "clientHeight" : "clientWidth", T = i.reference[v] + i.reference[h] - m[h] - i.floating[v], R = m[h] - i.reference[h], A = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let _ = A ? A[I] : 0;
    (!_ || !await (a.isElement == null ? void 0 : a.isElement(A))) && (_ = s.floating[I] || i.floating[v]);
    const k = T / 2 - R / 2, M = _ / 2 - g[v] / 2 - 1, j = Mo(d[b], M), G = Mo(d[C], M), U = j, B = _ - g[v] - G, K = _ / 2 - g[v] / 2 + k, ee = Yg(U, K, B), Y = !l.arrow && bl(o) != null && K !== ee && i.reference[v] / 2 - (K < U ? j : G) - g[v] / 2 < 0, J = Y ? K < U ? K - U : K - B : 0;
    return {
      [h]: m[h] + J,
      data: {
        [h]: ee,
        centerOffset: K - ee - J,
        ...Y && {
          alignmentOffset: J
        }
      },
      reset: Y
    };
  }
}), Pse = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: m,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: g = !0,
        ...x
      } = fi(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const b = mi(o), C = Qi(s), I = mi(s) === s, T = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), R = m || (I || !g ? [wf(s)] : Tse(s)), A = v !== "none";
      !m && A && R.push(...Ose(s, g, v, T));
      const _ = [s, ...R], k = await $c(t, x), M = [];
      let j = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && M.push(k[b]), d) {
        const K = Rse(o, a, T);
        M.push(k[K[0]], k[K[1]]);
      }
      if (j = [...j, {
        placement: o,
        overflows: M
      }], !M.every((K) => K <= 0)) {
        var G, U;
        const K = (((G = i.flip) == null ? void 0 : G.index) || 0) + 1, ee = _[K];
        if (ee)
          return {
            data: {
              index: K,
              overflows: j
            },
            reset: {
              placement: ee
            }
          };
        let Y = (U = j.filter((J) => J.overflows[0] <= 0).sort((J, ye) => J.overflows[1] - ye.overflows[1])[0]) == null ? void 0 : U.placement;
        if (!Y)
          switch (h) {
            case "bestFit": {
              var B;
              const J = (B = j.filter((ye) => {
                if (A) {
                  const re = Qi(ye.placement);
                  return re === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  re === "y";
                }
                return !0;
              }).map((ye) => [ye.placement, ye.overflows.filter((re) => re > 0).reduce((re, le) => re + le, 0)]).sort((ye, re) => ye[1] - re[1])[0]) == null ? void 0 : B[0];
              J && (Y = J);
              break;
            }
            case "initialPlacement":
              Y = s;
              break;
          }
        if (o !== Y)
          return {
            reset: {
              placement: Y
            }
          };
      }
      return {};
    }
  };
};
function A4(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function k4(e) {
  return wse.some((t) => e[t] >= 0);
}
const Nse = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = fi(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await $c(t, {
            ...o,
            elementContext: "reference"
          }), a = A4(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: k4(a)
            }
          };
        }
        case "escaped": {
          const i = await $c(t, {
            ...o,
            altBoundary: !0
          }), a = A4(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: k4(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Mse(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = mi(n), s = bl(n), l = Qi(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, u = i && l ? -1 : 1, d = fi(t, e);
  let {
    mainAxis: m,
    crossAxis: h,
    alignmentAxis: v
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return s && typeof v == "number" && (h = s === "end" ? v * -1 : v), l ? {
    x: h * u,
    y: m * c
  } : {
    x: m * c,
    y: h * u
  };
}
const Fse = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, l = await Mse(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, Lse = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (x) => {
            let {
              x: b,
              y: C
            } = x;
            return {
              x: b,
              y: C
            };
          }
        },
        ...l
      } = fi(e, t), c = {
        x: n,
        y: r
      }, u = await $c(t, l), d = Qi(mi(o)), m = r2(d);
      let h = c[m], v = c[d];
      if (i) {
        const x = m === "y" ? "top" : "left", b = m === "y" ? "bottom" : "right", C = h + u[x], I = h - u[b];
        h = Yg(C, h, I);
      }
      if (a) {
        const x = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", C = v + u[x], I = v - u[b];
        v = Yg(C, v, I);
      }
      const g = s.fn({
        ...t,
        [m]: h,
        [d]: v
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, $se = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = fi(e, t), u = {
        x: n,
        y: r
      }, d = Qi(o), m = r2(d);
      let h = u[m], v = u[d];
      const g = fi(s, t), x = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const I = m === "y" ? "height" : "width", T = i.reference[m] - i.floating[I] + x.mainAxis, R = i.reference[m] + i.reference[I] - x.mainAxis;
        h < T ? h = T : h > R && (h = R);
      }
      if (c) {
        var b, C;
        const I = m === "y" ? "width" : "height", T = ["top", "left"].includes(mi(o)), R = i.reference[d] - i.floating[I] + (T && ((b = a.offset) == null ? void 0 : b[d]) || 0) + (T ? 0 : x.crossAxis), A = i.reference[d] + i.reference[I] + (T ? 0 : ((C = a.offset) == null ? void 0 : C[d]) || 0) - (T ? x.crossAxis : 0);
        v < R ? v = R : v > A && (v = A);
      }
      return {
        [m]: h,
        [d]: v
      };
    }
  };
}, zse = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: a = () => {
        },
        ...s
      } = fi(e, t), l = await $c(t, s), c = mi(n), u = bl(n), d = Qi(n) === "y", {
        width: m,
        height: h
      } = r.floating;
      let v, g;
      c === "top" || c === "bottom" ? (v = c, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = c, v = u === "end" ? "top" : "bottom");
      const x = h - l.top - l.bottom, b = m - l.left - l.right, C = Mo(h - l[v], x), I = Mo(m - l[g], b), T = !t.middlewareData.shift;
      let R = C, A = I;
      if (d ? A = u || T ? Mo(I, b) : b : R = u || T ? Mo(C, x) : x, T && !u) {
        const k = Cr(l.left, 0), M = Cr(l.right, 0), j = Cr(l.top, 0), G = Cr(l.bottom, 0);
        d ? A = m - 2 * (k !== 0 || M !== 0 ? k + M : Cr(l.left, l.right)) : R = h - 2 * (j !== 0 || G !== 0 ? j + G : Cr(l.top, l.bottom));
      }
      await a({
        ...t,
        availableWidth: A,
        availableHeight: R
      });
      const _ = await o.getDimensions(i.floating);
      return m !== _.width || h !== _.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Sl(e) {
  return YR(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Or(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Si(e) {
  var t;
  return (t = (YR(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function YR(e) {
  return e instanceof Node || e instanceof Or(e).Node;
}
function mo(e) {
  return e instanceof Element || e instanceof Or(e).Element;
}
function zo(e) {
  return e instanceof HTMLElement || e instanceof Or(e).HTMLElement;
}
function D4(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Or(e).ShadowRoot;
}
function gu(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = po(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function jse(e) {
  return ["table", "td", "th"].includes(Sl(e));
}
function km(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function a2(e) {
  const t = s2(), n = mo(e) ? po(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Bse(e) {
  let t = ea(e);
  for (; zo(t) && !tl(t); ) {
    if (a2(t))
      return t;
    if (km(t))
      return null;
    t = ea(t);
  }
  return null;
}
function s2() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function tl(e) {
  return ["html", "body", "#document"].includes(Sl(e));
}
function po(e) {
  return Or(e).getComputedStyle(e);
}
function Dm(e) {
  return mo(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ea(e) {
  if (Sl(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    D4(e) && e.host || // Fallback.
    Si(e)
  );
  return D4(t) ? t.host : t;
}
function KR(e) {
  const t = ea(e);
  return tl(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : zo(t) && gu(t) ? t : KR(t);
}
function zc(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = KR(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Or(o);
  return i ? t.concat(a, a.visualViewport || [], gu(o) ? o : [], a.frameElement && n ? zc(a.frameElement) : []) : t.concat(o, zc(o, [], n));
}
function ZR(e) {
  const t = po(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = zo(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = Cf(n) !== i || Cf(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function l2(e) {
  return mo(e) ? e : e.contextElement;
}
function Vs(e) {
  const t = l2(e);
  if (!zo(t))
    return Ji(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = ZR(t);
  let a = (i ? Cf(n.width) : n.width) / r, s = (i ? Cf(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const Gse = /* @__PURE__ */ Ji(0);
function XR(e) {
  const t = Or(e);
  return !s2() || !t.visualViewport ? Gse : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Vse(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Or(e) ? !1 : t;
}
function Ha(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = l2(e);
  let a = Ji(1);
  t && (r ? mo(r) && (a = Vs(r)) : a = Vs(e));
  const s = Vse(i, n, r) ? XR(i) : Ji(0);
  let l = (o.left + s.x) / a.x, c = (o.top + s.y) / a.y, u = o.width / a.x, d = o.height / a.y;
  if (i) {
    const m = Or(i), h = r && mo(r) ? Or(r) : r;
    let v = m, g = v.frameElement;
    for (; g && r && h !== v; ) {
      const x = Vs(g), b = g.getBoundingClientRect(), C = po(g), I = b.left + (g.clientLeft + parseFloat(C.paddingLeft)) * x.x, T = b.top + (g.clientTop + parseFloat(C.paddingTop)) * x.y;
      l *= x.x, c *= x.y, u *= x.x, d *= x.y, l += I, c += T, v = Or(g), g = v.frameElement;
    }
  }
  return Ef({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Use(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = Si(r), s = t ? km(t.floating) : !1;
  if (r === a || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Ji(1);
  const u = Ji(0), d = zo(r);
  if ((d || !d && !i) && ((Sl(r) !== "body" || gu(a)) && (l = Dm(r)), zo(r))) {
    const m = Ha(r);
    c = Vs(r), u.x = m.x + r.clientLeft, u.y = m.y + r.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y
  };
}
function Wse(e) {
  return Array.from(e.getClientRects());
}
function JR(e) {
  return Ha(Si(e)).left + Dm(e).scrollLeft;
}
function Hse(e) {
  const t = Si(e), n = Dm(e), r = e.ownerDocument.body, o = Cr(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Cr(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + JR(e);
  const s = -n.scrollTop;
  return po(r).direction === "rtl" && (a += Cr(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
function qse(e, t) {
  const n = Or(e), r = Si(e), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const c = s2();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function Yse(e, t) {
  const n = Ha(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = zo(e) ? Vs(e) : Ji(1), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function P4(e, t, n) {
  let r;
  if (t === "viewport")
    r = qse(e, n);
  else if (t === "document")
    r = Hse(Si(e));
  else if (mo(t))
    r = Yse(t, n);
  else {
    const o = XR(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Ef(r);
}
function QR(e, t) {
  const n = ea(e);
  return n === t || !mo(n) || tl(n) ? !1 : po(n).position === "fixed" || QR(n, t);
}
function Kse(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = zc(e, [], !1).filter((s) => mo(s) && Sl(s) !== "body"), o = null;
  const i = po(e).position === "fixed";
  let a = i ? ea(e) : e;
  for (; mo(a) && !tl(a); ) {
    const s = po(a), l = a2(a);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || gu(a) && !l && QR(e, a)) ? r = r.filter((u) => u !== a) : o = s, a = ea(a);
  }
  return t.set(e, r), r;
}
function Zse(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? km(t) ? [] : Kse(t, this._c) : [].concat(n), r], s = a[0], l = a.reduce((c, u) => {
    const d = P4(t, u, o);
    return c.top = Cr(d.top, c.top), c.right = Mo(d.right, c.right), c.bottom = Mo(d.bottom, c.bottom), c.left = Cr(d.left, c.left), c;
  }, P4(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Xse(e) {
  const {
    width: t,
    height: n
  } = ZR(e);
  return {
    width: t,
    height: n
  };
}
function Jse(e, t, n) {
  const r = zo(t), o = Si(t), i = n === "fixed", a = Ha(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ji(0);
  if (r || !r && !i)
    if ((Sl(t) !== "body" || gu(o)) && (s = Dm(t)), r) {
      const d = Ha(t, !0, i, t);
      l.x = d.x + t.clientLeft, l.y = d.y + t.clientTop;
    } else o && (l.x = JR(o));
  const c = a.left + s.scrollLeft - l.x, u = a.top + s.scrollTop - l.y;
  return {
    x: c,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Qp(e) {
  return po(e).position === "static";
}
function N4(e, t) {
  return !zo(e) || po(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function e7(e, t) {
  const n = Or(e);
  if (km(e))
    return n;
  if (!zo(e)) {
    let o = ea(e);
    for (; o && !tl(o); ) {
      if (mo(o) && !Qp(o))
        return o;
      o = ea(o);
    }
    return n;
  }
  let r = N4(e, t);
  for (; r && jse(r) && Qp(r); )
    r = N4(r, t);
  return r && tl(r) && Qp(r) && !a2(r) ? n : r || Bse(e) || n;
}
const Qse = async function(e) {
  const t = this.getOffsetParent || e7, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Jse(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function ele(e) {
  return po(e).direction === "rtl";
}
const tle = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Use,
  getDocumentElement: Si,
  getClippingRect: Zse,
  getOffsetParent: e7,
  getElementRects: Qse,
  getClientRects: Wse,
  getDimensions: Xse,
  getScale: Vs,
  isElement: mo,
  isRTL: ele
};
function nle(e, t) {
  let n = null, r;
  const o = Si(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: u,
      width: d,
      height: m
    } = e.getBoundingClientRect();
    if (s || t(), !d || !m)
      return;
    const h = cd(u), v = cd(o.clientWidth - (c + d)), g = cd(o.clientHeight - (u + m)), x = cd(c), C = {
      rootMargin: -h + "px " + -v + "px " + -g + "px " + -x + "px",
      threshold: Cr(0, Mo(1, l)) || 1
    };
    let I = !0;
    function T(R) {
      const A = R[0].intersectionRatio;
      if (A !== l) {
        if (!I)
          return a();
        A ? a(!1, A) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      I = !1;
    }
    try {
      n = new IntersectionObserver(T, {
        ...C,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(T, C);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function rle(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = l2(e), u = o || i ? [...c ? zc(c) : [], ...zc(t)] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), i && b.addEventListener("resize", n);
  });
  const d = c && s ? nle(c, n) : null;
  let m = -1, h = null;
  a && (h = new ResizeObserver((b) => {
    let [C] = b;
    C && C.target === c && h && (h.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var I;
      (I = h) == null || I.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let v, g = l ? Ha(e) : null;
  l && x();
  function x() {
    const b = Ha(e);
    g && (b.x !== g.x || b.y !== g.y || b.width !== g.width || b.height !== g.height) && n(), g = b, v = requestAnimationFrame(x);
  }
  return n(), () => {
    var b;
    u.forEach((C) => {
      o && C.removeEventListener("scroll", n), i && C.removeEventListener("resize", n);
    }), d == null || d(), (b = h) == null || b.disconnect(), h = null, l && cancelAnimationFrame(v);
  };
}
const ole = Fse, ile = Lse, ale = Pse, sle = zse, lle = Nse, M4 = Dse, cle = $se, ule = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: tle,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return kse(e, t, {
    ...o,
    platform: i
  });
};
var Gd = typeof document < "u" ? oa : Le;
function If(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!If(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !If(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function t7(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function F4(e, t) {
  const n = t7(e);
  return Math.round(t * n) / n;
}
function L4(e) {
  const t = S.useRef(e);
  return Gd(() => {
    t.current = e;
  }), t;
}
function dle(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = S.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, h] = S.useState(r);
  If(m, r) || h(r);
  const [v, g] = S.useState(null), [x, b] = S.useState(null), C = S.useCallback((J) => {
    J !== A.current && (A.current = J, g(J));
  }, []), I = S.useCallback((J) => {
    J !== _.current && (_.current = J, b(J));
  }, []), T = i || v, R = a || x, A = S.useRef(null), _ = S.useRef(null), k = S.useRef(u), M = l != null, j = L4(l), G = L4(o), U = S.useCallback(() => {
    if (!A.current || !_.current)
      return;
    const J = {
      placement: t,
      strategy: n,
      middleware: m
    };
    G.current && (J.platform = G.current), ule(A.current, _.current, J).then((ye) => {
      const re = {
        ...ye,
        isPositioned: !0
      };
      B.current && !If(k.current, re) && (k.current = re, cl.flushSync(() => {
        d(re);
      }));
    });
  }, [m, t, n, G]);
  Gd(() => {
    c === !1 && k.current.isPositioned && (k.current.isPositioned = !1, d((J) => ({
      ...J,
      isPositioned: !1
    })));
  }, [c]);
  const B = S.useRef(!1);
  Gd(() => (B.current = !0, () => {
    B.current = !1;
  }), []), Gd(() => {
    if (T && (A.current = T), R && (_.current = R), T && R) {
      if (j.current)
        return j.current(T, R, U);
      U();
    }
  }, [T, R, U, j, M]);
  const K = S.useMemo(() => ({
    reference: A,
    floating: _,
    setReference: C,
    setFloating: I
  }), [C, I]), ee = S.useMemo(() => ({
    reference: T,
    floating: R
  }), [T, R]), Y = S.useMemo(() => {
    const J = {
      position: n,
      left: 0,
      top: 0
    };
    if (!ee.floating)
      return J;
    const ye = F4(ee.floating, u.x), re = F4(ee.floating, u.y);
    return s ? {
      ...J,
      transform: "translate(" + ye + "px, " + re + "px)",
      ...t7(ee.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: ye,
      top: re
    };
  }, [n, s, ee.floating, u.x, u.y]);
  return S.useMemo(() => ({
    ...u,
    update: U,
    refs: K,
    elements: ee,
    floatingStyles: Y
  }), [u, U, K, ee, Y]);
}
const fle = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? M4({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? M4({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, mle = (e, t) => ({
  ...ole(e),
  options: [e, t]
}), ple = (e, t) => ({
  ...ile(e),
  options: [e, t]
}), hle = (e, t) => ({
  ...cle(e),
  options: [e, t]
}), gle = (e, t) => ({
  ...ale(e),
  options: [e, t]
}), vle = (e, t) => ({
  ...sle(e),
  options: [e, t]
}), yle = (e, t) => ({
  ...lle(e),
  options: [e, t]
}), ble = (e, t) => ({
  ...fle(e),
  options: [e, t]
});
var Sle = "Arrow", n7 = S.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ f.jsx(
    at.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ f.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
n7.displayName = Sle;
var xle = n7, c2 = "Popper", [r7, da] = Vo(c2), [Cle, o7] = r7(c2), i7 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = S.useState(null);
  return /* @__PURE__ */ f.jsx(Cle, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
i7.displayName = c2;
var a7 = "PopperAnchor", s7 = S.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = o7(a7, n), a = S.useRef(null), s = mt(t, a);
    return S.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ f.jsx(at.div, { ...o, ref: s });
  }
);
s7.displayName = a7;
var u2 = "PopperContent", [wle, Ele] = r7(u2), l7 = S.forwardRef(
  (e, t) => {
    var te, he, ge, de, xe, ce;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: v,
      ...g
    } = e, x = o7(u2, n), [b, C] = S.useState(null), I = mt(t, (je) => C(je)), [T, R] = S.useState(null), A = II(T), _ = (A == null ? void 0 : A.width) ?? 0, k = (A == null ? void 0 : A.height) ?? 0, M = r + (i !== "center" ? "-" + i : ""), j = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, G = Array.isArray(c) ? c : [c], U = G.length > 0, B = {
      padding: j,
      boundary: G.filter(Rle),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: U
    }, { refs: K, floatingStyles: ee, placement: Y, isPositioned: J, middlewareData: ye } = dle({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...je) => rle(...je, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: x.anchor
      },
      middleware: [
        mle({ mainAxis: o + k, alignmentAxis: a }),
        l && ple({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? hle() : void 0,
          ...B
        }),
        l && gle({ ...B }),
        vle({
          ...B,
          apply: ({ elements: je, rects: z, availableWidth: Ue, availableHeight: st }) => {
            const { width: Rt, height: dn } = z.reference, _t = je.floating.style;
            _t.setProperty("--radix-popper-available-width", `${Ue}px`), _t.setProperty("--radix-popper-available-height", `${st}px`), _t.setProperty("--radix-popper-anchor-width", `${Rt}px`), _t.setProperty("--radix-popper-anchor-height", `${dn}px`);
          }
        }),
        T && ble({ element: T, padding: s }),
        Tle({ arrowWidth: _, arrowHeight: k }),
        m && yle({ strategy: "referenceHidden", ...B })
      ]
    }), [re, le] = d7(Y), Te = tr(v);
    An(() => {
      J && (Te == null || Te());
    }, [J, Te]);
    const F = (te = ye.arrow) == null ? void 0 : te.x, Z = (he = ye.arrow) == null ? void 0 : he.y, se = ((ge = ye.arrow) == null ? void 0 : ge.centerOffset) !== 0, [ae, ue] = S.useState();
    return An(() => {
      b && ue(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ f.jsx(
      "div",
      {
        ref: K.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...ee,
          transform: J ? ee.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ae,
          "--radix-popper-transform-origin": [
            (de = ye.transformOrigin) == null ? void 0 : de.x,
            (xe = ye.transformOrigin) == null ? void 0 : xe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ce = ye.hide) == null ? void 0 : ce.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ f.jsx(
          wle,
          {
            scope: n,
            placedSide: re,
            onArrowChange: R,
            arrowX: F,
            arrowY: Z,
            shouldHideArrow: se,
            children: /* @__PURE__ */ f.jsx(
              at.div,
              {
                "data-side": re,
                "data-align": le,
                ...g,
                ref: I,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: J ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
l7.displayName = u2;
var c7 = "PopperArrow", Ile = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, u7 = S.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = Ele(c7, r), a = Ile[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ f.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ f.jsx(
          xle,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
u7.displayName = c7;
function Rle(e) {
  return e !== null;
}
var Tle = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var x, b, C;
    const { placement: n, rects: r, middlewareData: o } = t, a = ((x = o.arrow) == null ? void 0 : x.centerOffset) !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [c, u] = d7(n), d = { start: "0%", center: "50%", end: "100%" }[u], m = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + s / 2, h = (((C = o.arrow) == null ? void 0 : C.y) ?? 0) + l / 2;
    let v = "", g = "";
    return c === "bottom" ? (v = a ? d : `${m}px`, g = `${-l}px`) : c === "top" ? (v = a ? d : `${m}px`, g = `${r.floating.height + l}px`) : c === "right" ? (v = `${-l}px`, g = a ? d : `${h}px`) : c === "left" && (v = `${r.floating.width + l}px`, g = a ? d : `${h}px`), { data: { x: v, y: g } };
  }
});
function d7(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var vu = i7, yu = s7, Pm = l7, Nm = u7, d2 = "Popover", [f7] = Vo(d2, [
  da
]), bu = da(), [_le, fa] = f7(d2), m7 = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !1
  } = e, s = bu(t), l = S.useRef(null), [c, u] = S.useState(!1), [d = !1, m] = di({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ f.jsx(vu, { ...s, children: /* @__PURE__ */ f.jsx(
    _le,
    {
      scope: t,
      contentId: _r(),
      triggerRef: l,
      open: d,
      onOpenChange: m,
      onOpenToggle: S.useCallback(() => m((h) => !h), [m]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: S.useCallback(() => u(!0), []),
      onCustomAnchorRemove: S.useCallback(() => u(!1), []),
      modal: a,
      children: n
    }
  ) });
};
m7.displayName = d2;
var p7 = "PopoverAnchor", Ole = S.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = fa(p7, n), i = bu(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = o;
    return S.useEffect(() => (a(), () => s()), [a, s]), /* @__PURE__ */ f.jsx(yu, { ...i, ...r, ref: t });
  }
);
Ole.displayName = p7;
var h7 = "PopoverTrigger", g7 = S.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = fa(h7, n), i = bu(n), a = mt(t, o.triggerRef), s = /* @__PURE__ */ f.jsx(
      at.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": x7(o.open),
        ...r,
        ref: a,
        onClick: Re(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? s : /* @__PURE__ */ f.jsx(yu, { asChild: !0, ...i, children: s });
  }
);
g7.displayName = h7;
var f2 = "PopoverPortal", [Ale, kle] = f7(f2, {
  forceMount: void 0
}), v7 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, i = fa(f2, t);
  return /* @__PURE__ */ f.jsx(Ale, { scope: t, forceMount: n, children: /* @__PURE__ */ f.jsx(yo, { present: n || i.open, children: /* @__PURE__ */ f.jsx(pu, { asChild: !0, container: o, children: r }) }) });
};
v7.displayName = f2;
var nl = "PopoverContent", y7 = S.forwardRef(
  (e, t) => {
    const n = kle(nl, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, i = fa(nl, e.__scopePopover);
    return /* @__PURE__ */ f.jsx(yo, { present: r || i.open, children: i.modal ? /* @__PURE__ */ f.jsx(Dle, { ...o, ref: t }) : /* @__PURE__ */ f.jsx(Ple, { ...o, ref: t }) });
  }
);
y7.displayName = nl;
var Dle = S.forwardRef(
  (e, t) => {
    const n = fa(nl, e.__scopePopover), r = S.useRef(null), o = mt(t, r), i = S.useRef(!1);
    return S.useEffect(() => {
      const a = r.current;
      if (a) return uu(a);
    }, []), /* @__PURE__ */ f.jsx(hu, { as: si, allowPinchZoom: !0, children: /* @__PURE__ */ f.jsx(
      b7,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Re(e.onCloseAutoFocus, (a) => {
          var s;
          a.preventDefault(), i.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: Re(
          e.onPointerDownOutside,
          (a) => {
            const s = a.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
            i.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Re(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Ple = S.forwardRef(
  (e, t) => {
    const n = fa(nl, e.__scopePopover), r = S.useRef(!1), o = S.useRef(!1);
    return /* @__PURE__ */ f.jsx(
      b7,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, i), i.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), b7 = S.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: u,
      ...d
    } = e, m = fa(nl, n), h = bu(n);
    return Tm(), /* @__PURE__ */ f.jsx(
      mu,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ f.jsx(
          fu,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: u,
            onEscapeKeyDown: s,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ f.jsx(
              Pm,
              {
                "data-state": x7(m.open),
                role: "dialog",
                id: m.contentId,
                ...h,
                ...d,
                ref: t,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), S7 = "PopoverClose", Nle = S.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = fa(S7, n);
    return /* @__PURE__ */ f.jsx(
      at.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Re(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Nle.displayName = S7;
var Mle = "PopoverArrow", Fle = S.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = bu(n);
    return /* @__PURE__ */ f.jsx(Nm, { ...o, ...r, ref: t });
  }
);
Fle.displayName = Mle;
function x7(e) {
  return e ? "open" : "closed";
}
var Lle = m7, $le = g7, zle = v7, C7 = y7;
const xl = Lle, Cl = $le, ts = S.forwardRef(
  ({
    className: e,
    align: t = "center",
    sideOffset: n = 4,
    collisionPadding: r = 4,
    ...o
  }, i) => /* @__PURE__ */ f.jsx(zle, { children: /* @__PURE__ */ f.jsx(
    C7,
    {
      ref: i,
      align: t,
      sideOffset: n,
      collisionPadding: r,
      className: oe(
        "z-50 max-h-(--radix-popover-content-available-height) w-(--radix-popover-trigger-width) max-w-(--radix-popover-content-available-width) min-w-72 origin-(--radix-popover-content-transform-origin) overflow-auto rounded-md border border-neutral-200 bg-white p-4 text-neutral-950 shadow-md outline-hidden",
        "duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-90 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-90",
        "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...o
    }
  ) })
);
ts.displayName = C7.displayName;
function $4({
  value: e,
  onChange: t,
  ...n
}) {
  return /* @__PURE__ */ f.jsxs(xl, { children: [
    /* @__PURE__ */ f.jsx(Cl, { asChild: !0, children: /* @__PURE__ */ f.jsxs(en, { className: "min-w-fit justify-start", children: [
      /* @__PURE__ */ f.jsx(Ve, { icon: "calendar", className: "mr-2" }),
      e ? e.toLocaleDateString() : /* @__PURE__ */ f.jsx("span", { children: "Pick a Date" })
    ] }) }),
    /* @__PURE__ */ f.jsx(ts, { className: "w-auto p-0", children: /* @__PURE__ */ f.jsx(
      s0,
      {
        autoFocus: !0,
        mode: "single",
        selected: e,
        onSelect: t,
        ...n
      }
    ) })
  ] });
}
function Dve({
  onChange: e,
  value: t,
  ...n
}) {
  return /* @__PURE__ */ f.jsxs(xl, { children: [
    /* @__PURE__ */ f.jsx(Cl, { asChild: !0, children: /* @__PURE__ */ f.jsxs(en, { className: "min-w-fit justify-start font-normal", children: [
      /* @__PURE__ */ f.jsx(Ve, { icon: "calendar", className: "mr-2 shrink-0" }),
      t != null && t.from ? t.to ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        t.from.toLocaleDateString(),
        " -",
        " ",
        t.to.toLocaleDateString()
      ] }) : t.from.toLocaleDateString() : /* @__PURE__ */ f.jsx("span", { children: "Pick a date" })
    ] }) }),
    /* @__PURE__ */ f.jsx(ts, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ f.jsx(
      s0,
      {
        autoFocus: !0,
        mode: "range",
        defaultMonth: t == null ? void 0 : t.from,
        selected: t,
        onSelect: e,
        numberOfMonths: 2,
        ...n
      }
    ) })
  ] });
}
function z4(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function jle({
  renderSummary: e,
  defaultOpen: t = !1,
  children: n
}) {
  const [r, o] = Fe(t);
  return /* @__PURE__ */ f.jsxs(
    "details",
    {
      className: "w-full [&[open]>summary_.simple-summary-icon]:rotate-90",
      open: r,
      onToggle: (i) => o(i.currentTarget.open),
      children: [
        /* @__PURE__ */ f.jsx("summary", { className: "cursor-pointer list-none marker:hidden [&::-webkit-details-marker]:hidden", children: z4(e, r) }),
        z4(n, r)
      ]
    }
  );
}
function w7({ className: e }) {
  return /* @__PURE__ */ f.jsx(
    Ve,
    {
      icon: "chevronRight",
      className: oe(
        "simple-summary-icon block size-4 shrink-0 rotate-0 text-neutral-500 transition-transform duration-75 ease-out",
        e
      )
    }
  );
}
function Pve({ children: e }) {
  return /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-1 p-2", children: [
    e,
    /* @__PURE__ */ f.jsx("div", { className: "ml-auto pl-2", children: /* @__PURE__ */ f.jsx(w7, {}) })
  ] });
}
function Ble() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Be(
    () => (r) => {
      t.forEach((o) => o(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const Mm = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function wl(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function m2(e) {
  return "nodeType" in e;
}
function pr(e) {
  var t, n;
  return e ? wl(e) ? e : m2(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
function p2(e) {
  const {
    Document: t
  } = pr(e);
  return e instanceof t;
}
function Su(e) {
  return wl(e) ? !1 : e instanceof pr(e).HTMLElement;
}
function E7(e) {
  return e instanceof pr(e).SVGElement;
}
function El(e) {
  return e ? wl(e) ? e.document : m2(e) ? p2(e) ? e : Su(e) || E7(e) ? e.ownerDocument : document : document : document;
}
const jo = Mm ? oa : Le;
function h2(e) {
  const t = He(e);
  return jo(() => {
    t.current = e;
  }), Ke(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function Gle() {
  const e = He(null), t = Ke((r, o) => {
    e.current = setInterval(r, o);
  }, []), n = Ke(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, n];
}
function jc(e, t) {
  t === void 0 && (t = [e]);
  const n = He(e);
  return jo(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function xu(e, t) {
  const n = He();
  return Be(
    () => {
      const r = e(n.current);
      return n.current = r, r;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function Rf(e) {
  const t = h2(e), n = He(null), r = Ke(
    (o) => {
      o !== n.current && (t == null || t(o, n.current)), n.current = o;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
function Zg(e) {
  const t = He();
  return Le(() => {
    t.current = e;
  }, [e]), t.current;
}
let eh = {};
function Cu(e, t) {
  return Be(() => {
    if (t)
      return t;
    const n = eh[e] == null ? 0 : eh[e] + 1;
    return eh[e] = n, e + "-" + n;
  }, [e, t]);
}
function I7(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return r.reduce((i, a) => {
      const s = Object.entries(a);
      for (const [l, c] of s) {
        const u = i[l];
        u != null && (i[l] = u + e * c);
      }
      return i;
    }, {
      ...t
    });
  };
}
const Us = /* @__PURE__ */ I7(1), Bc = /* @__PURE__ */ I7(-1);
function Vle(e) {
  return "clientX" in e && "clientY" in e;
}
function g2(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = pr(e.target);
  return t && e instanceof t;
}
function Ule(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = pr(e.target);
  return t && e instanceof t;
}
function Xg(e) {
  if (Ule(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return Vle(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const Gc = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [Gc.Translate.toString(e), Gc.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
}), j4 = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function Wle(e) {
  return e.matches(j4) ? e : e.querySelector(j4);
}
const Hle = {
  display: "none"
};
function qle(e) {
  let {
    id: t,
    value: n
  } = e;
  return H.createElement("div", {
    id: t,
    style: Hle
  }, n);
}
function Yle(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: r = "assertive"
  } = e;
  const o = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return H.createElement("div", {
    id: t,
    style: o,
    role: "status",
    "aria-live": r,
    "aria-atomic": !0
  }, n);
}
function Kle() {
  const [e, t] = Fe("");
  return {
    announce: Ke((r) => {
      r != null && t(r);
    }, []),
    announcement: e
  };
}
const R7 = /* @__PURE__ */ Nn(null);
function Zle(e) {
  const t = On(R7);
  Le(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function Xle() {
  const [e] = Fe(() => /* @__PURE__ */ new Set()), t = Ke((r) => (e.add(r), () => e.delete(r)), [e]);
  return [Ke((r) => {
    let {
      type: o,
      event: i
    } = r;
    e.forEach((a) => {
      var s;
      return (s = a[o]) == null ? void 0 : s.call(a, i);
    });
  }, [e]), t];
}
const Jle = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, Qle = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was moved over droppable area " + n.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was dropped over droppable area " + n.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function ece(e) {
  let {
    announcements: t = Qle,
    container: n,
    hiddenTextDescribedById: r,
    screenReaderInstructions: o = Jle
  } = e;
  const {
    announce: i,
    announcement: a
  } = Kle(), s = Cu("DndLiveRegion"), [l, c] = Fe(!1);
  if (Le(() => {
    c(!0);
  }, []), Zle(Be(() => ({
    onDragStart(d) {
      let {
        active: m
      } = d;
      i(t.onDragStart({
        active: m
      }));
    },
    onDragMove(d) {
      let {
        active: m,
        over: h
      } = d;
      t.onDragMove && i(t.onDragMove({
        active: m,
        over: h
      }));
    },
    onDragOver(d) {
      let {
        active: m,
        over: h
      } = d;
      i(t.onDragOver({
        active: m,
        over: h
      }));
    },
    onDragEnd(d) {
      let {
        active: m,
        over: h
      } = d;
      i(t.onDragEnd({
        active: m,
        over: h
      }));
    },
    onDragCancel(d) {
      let {
        active: m,
        over: h
      } = d;
      i(t.onDragCancel({
        active: m,
        over: h
      }));
    }
  }), [i, t])), !l)
    return null;
  const u = H.createElement(H.Fragment, null, H.createElement(qle, {
    id: r,
    value: o.draggable
  }), H.createElement(Yle, {
    id: s,
    announcement: a
  }));
  return n ? wk(u, n) : u;
}
var xn;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(xn || (xn = {}));
function Tf() {
}
function B4(e, t) {
  return Be(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function tce() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Be(
    () => [...t].filter((r) => r != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const ho = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function T7(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function _7(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return n - r;
}
function nce(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return r - n;
}
function G4(e) {
  let {
    left: t,
    top: n,
    height: r,
    width: o
  } = e;
  return [{
    x: t,
    y: n
  }, {
    x: t + o,
    y: n
  }, {
    x: t,
    y: n + r
  }, {
    x: t + o,
    y: n + r
  }];
}
function O7(e, t) {
  if (!e || e.length === 0)
    return null;
  const [n] = e;
  return n[t];
}
function V4(e, t, n) {
  return t === void 0 && (t = e.left), n === void 0 && (n = e.top), {
    x: t + e.width * 0.5,
    y: n + e.height * 0.5
  };
}
const rce = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const o = V4(t, t.left, t.top), i = [];
  for (const a of r) {
    const {
      id: s
    } = a, l = n.get(s);
    if (l) {
      const c = T7(V4(l), o);
      i.push({
        id: s,
        data: {
          droppableContainer: a,
          value: c
        }
      });
    }
  }
  return i.sort(_7);
}, oce = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const o = G4(t), i = [];
  for (const a of r) {
    const {
      id: s
    } = a, l = n.get(s);
    if (l) {
      const c = G4(l), u = o.reduce((m, h, v) => m + T7(c[v], h), 0), d = Number((u / 4).toFixed(4));
      i.push({
        id: s,
        data: {
          droppableContainer: a,
          value: d
        }
      });
    }
  }
  return i.sort(_7);
};
function ice(e, t) {
  const n = Math.max(t.top, e.top), r = Math.max(t.left, e.left), o = Math.min(t.left + t.width, e.left + e.width), i = Math.min(t.top + t.height, e.top + e.height), a = o - r, s = i - n;
  if (r < o && n < i) {
    const l = t.width * t.height, c = e.width * e.height, u = a * s, d = u / (l + c - u);
    return Number(d.toFixed(4));
  }
  return 0;
}
const ace = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const o = [];
  for (const i of r) {
    const {
      id: a
    } = i, s = n.get(a);
    if (s) {
      const l = ice(s, t);
      l > 0 && o.push({
        id: a,
        data: {
          droppableContainer: i,
          value: l
        }
      });
    }
  }
  return o.sort(nce);
};
function sce(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function A7(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : ho;
}
function lce(e) {
  return function(n) {
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      o[i - 1] = arguments[i];
    return o.reduce((a, s) => ({
      ...a,
      top: a.top + e * s.y,
      bottom: a.bottom + e * s.y,
      left: a.left + e * s.x,
      right: a.right + e * s.x
    }), {
      ...n
    });
  };
}
const cce = /* @__PURE__ */ lce(1);
function uce(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function dce(e, t, n) {
  const r = uce(t);
  if (!r)
    return e;
  const {
    scaleX: o,
    scaleY: i,
    x: a,
    y: s
  } = r, l = e.left - a - (1 - o) * parseFloat(n), c = e.top - s - (1 - i) * parseFloat(n.slice(n.indexOf(" ") + 1)), u = o ? e.width / o : e.width, d = i ? e.height / i : e.height;
  return {
    width: u,
    height: d,
    top: c,
    right: l + u,
    bottom: c + d,
    left: l
  };
}
const fce = {
  ignoreTransform: !1
};
function Il(e, t) {
  t === void 0 && (t = fce);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: c,
      transformOrigin: u
    } = pr(e).getComputedStyle(e);
    c && (n = dce(n, c, u));
  }
  const {
    top: r,
    left: o,
    width: i,
    height: a,
    bottom: s,
    right: l
  } = n;
  return {
    top: r,
    left: o,
    width: i,
    height: a,
    bottom: s,
    right: l
  };
}
function U4(e) {
  return Il(e, {
    ignoreTransform: !0
  });
}
function mce(e) {
  const t = e.innerWidth, n = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: n,
    width: t,
    height: n
  };
}
function pce(e, t) {
  return t === void 0 && (t = pr(e).getComputedStyle(e)), t.position === "fixed";
}
function hce(e, t) {
  t === void 0 && (t = pr(e).getComputedStyle(e));
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((o) => {
    const i = t[o];
    return typeof i == "string" ? n.test(i) : !1;
  });
}
function Fm(e, t) {
  const n = [];
  function r(o) {
    if (t != null && n.length >= t || !o)
      return n;
    if (p2(o) && o.scrollingElement != null && !n.includes(o.scrollingElement))
      return n.push(o.scrollingElement), n;
    if (!Su(o) || E7(o) || n.includes(o))
      return n;
    const i = pr(e).getComputedStyle(o);
    return o !== e && hce(o, i) && n.push(o), pce(o, i) ? n : r(o.parentNode);
  }
  return e ? r(e) : n;
}
function k7(e) {
  const [t] = Fm(e, 1);
  return t ?? null;
}
function th(e) {
  return !Mm || !e ? null : wl(e) ? e : m2(e) ? p2(e) || e === El(e).scrollingElement ? window : Su(e) ? e : null : null;
}
function D7(e) {
  return wl(e) ? e.scrollX : e.scrollLeft;
}
function P7(e) {
  return wl(e) ? e.scrollY : e.scrollTop;
}
function Jg(e) {
  return {
    x: D7(e),
    y: P7(e)
  };
}
var Tn;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(Tn || (Tn = {}));
function N7(e) {
  return !Mm || !e ? !1 : e === document.scrollingElement;
}
function M7(e) {
  const t = {
    x: 0,
    y: 0
  }, n = N7(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, r = {
    x: e.scrollWidth - n.width,
    y: e.scrollHeight - n.height
  }, o = e.scrollTop <= t.y, i = e.scrollLeft <= t.x, a = e.scrollTop >= r.y, s = e.scrollLeft >= r.x;
  return {
    isTop: o,
    isLeft: i,
    isBottom: a,
    isRight: s,
    maxScroll: r,
    minScroll: t
  };
}
const gce = {
  x: 0.2,
  y: 0.2
};
function vce(e, t, n, r, o) {
  let {
    top: i,
    left: a,
    right: s,
    bottom: l
  } = n;
  r === void 0 && (r = 10), o === void 0 && (o = gce);
  const {
    isTop: c,
    isBottom: u,
    isLeft: d,
    isRight: m
  } = M7(e), h = {
    x: 0,
    y: 0
  }, v = {
    x: 0,
    y: 0
  }, g = {
    height: t.height * o.y,
    width: t.width * o.x
  };
  return !c && i <= t.top + g.height ? (h.y = Tn.Backward, v.y = r * Math.abs((t.top + g.height - i) / g.height)) : !u && l >= t.bottom - g.height && (h.y = Tn.Forward, v.y = r * Math.abs((t.bottom - g.height - l) / g.height)), !m && s >= t.right - g.width ? (h.x = Tn.Forward, v.x = r * Math.abs((t.right - g.width - s) / g.width)) : !d && a <= t.left + g.width && (h.x = Tn.Backward, v.x = r * Math.abs((t.left + g.width - a) / g.width)), {
    direction: h,
    speed: v
  };
}
function yce(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: i,
      innerHeight: a
    } = window;
    return {
      top: 0,
      left: 0,
      right: i,
      bottom: a,
      width: i,
      height: a
    };
  }
  const {
    top: t,
    left: n,
    right: r,
    bottom: o
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: r,
    bottom: o,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function F7(e) {
  return e.reduce((t, n) => Us(t, Jg(n)), ho);
}
function bce(e) {
  return e.reduce((t, n) => t + D7(n), 0);
}
function Sce(e) {
  return e.reduce((t, n) => t + P7(n), 0);
}
function xce(e, t) {
  if (t === void 0 && (t = Il), !e)
    return;
  const {
    top: n,
    left: r,
    bottom: o,
    right: i
  } = t(e);
  k7(e) && (o <= 0 || i <= 0 || n >= window.innerHeight || r >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const Cce = [["x", ["left", "right"], bce], ["y", ["top", "bottom"], Sce]];
class v2 {
  constructor(t, n) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const r = Fm(n), o = F7(r);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [i, a, s] of Cce)
      for (const l of a)
        Object.defineProperty(this, l, {
          get: () => {
            const c = s(r), u = o[i] - c;
            return this.rect[l] + u;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class hc {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var r;
        return (r = this.target) == null ? void 0 : r.removeEventListener(...n);
      });
    }, this.target = t;
  }
  add(t, n, r) {
    var o;
    (o = this.target) == null || o.addEventListener(t, n, r), this.listeners.push([t, n, r]);
  }
}
function wce(e) {
  const {
    EventTarget: t
  } = pr(e);
  return e instanceof t ? e : El(e);
}
function nh(e, t) {
  const n = Math.abs(e.x), r = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(n ** 2 + r ** 2) > t : "x" in t && "y" in t ? n > t.x && r > t.y : "x" in t ? n > t.x : "y" in t ? r > t.y : !1;
}
var $r;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})($r || ($r = {}));
function W4(e) {
  e.preventDefault();
}
function Ece(e) {
  e.stopPropagation();
}
var gt;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(gt || (gt = {}));
const L7 = {
  start: [gt.Space, gt.Enter],
  cancel: [gt.Esc],
  end: [gt.Space, gt.Enter, gt.Tab]
}, Ice = (e, t) => {
  let {
    currentCoordinates: n
  } = t;
  switch (e.code) {
    case gt.Right:
      return {
        ...n,
        x: n.x + 25
      };
    case gt.Left:
      return {
        ...n,
        x: n.x - 25
      };
    case gt.Down:
      return {
        ...n,
        y: n.y + 25
      };
    case gt.Up:
      return {
        ...n,
        y: n.y - 25
      };
  }
};
class y2 {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: n
      }
    } = t;
    this.props = t, this.listeners = new hc(El(n)), this.windowListeners = new hc(pr(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add($r.Resize, this.handleCancel), this.windowListeners.add($r.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add($r.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: n
    } = this.props, r = t.node.current;
    r && xce(r), n(ho);
  }
  handleKeyDown(t) {
    if (g2(t)) {
      const {
        active: n,
        context: r,
        options: o
      } = this.props, {
        keyboardCodes: i = L7,
        coordinateGetter: a = Ice,
        scrollBehavior: s = "smooth"
      } = o, {
        code: l
      } = t;
      if (i.end.includes(l)) {
        this.handleEnd(t);
        return;
      }
      if (i.cancel.includes(l)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: c
      } = r.current, u = c ? {
        x: c.left,
        y: c.top
      } : ho;
      this.referenceCoordinates || (this.referenceCoordinates = u);
      const d = a(t, {
        active: n,
        context: r.current,
        currentCoordinates: u
      });
      if (d) {
        const m = Bc(d, u), h = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: v
        } = r.current;
        for (const g of v) {
          const x = t.code, {
            isTop: b,
            isRight: C,
            isLeft: I,
            isBottom: T,
            maxScroll: R,
            minScroll: A
          } = M7(g), _ = yce(g), k = {
            x: Math.min(x === gt.Right ? _.right - _.width / 2 : _.right, Math.max(x === gt.Right ? _.left : _.left + _.width / 2, d.x)),
            y: Math.min(x === gt.Down ? _.bottom - _.height / 2 : _.bottom, Math.max(x === gt.Down ? _.top : _.top + _.height / 2, d.y))
          }, M = x === gt.Right && !C || x === gt.Left && !I, j = x === gt.Down && !T || x === gt.Up && !b;
          if (M && k.x !== d.x) {
            const G = g.scrollLeft + m.x, U = x === gt.Right && G <= R.x || x === gt.Left && G >= A.x;
            if (U && !m.y) {
              g.scrollTo({
                left: G,
                behavior: s
              });
              return;
            }
            U ? h.x = g.scrollLeft - G : h.x = x === gt.Right ? g.scrollLeft - R.x : g.scrollLeft - A.x, h.x && g.scrollBy({
              left: -h.x,
              behavior: s
            });
            break;
          } else if (j && k.y !== d.y) {
            const G = g.scrollTop + m.y, U = x === gt.Down && G <= R.y || x === gt.Up && G >= A.y;
            if (U && !m.x) {
              g.scrollTo({
                top: G,
                behavior: s
              });
              return;
            }
            U ? h.y = g.scrollTop - G : h.y = x === gt.Down ? g.scrollTop - R.y : g.scrollTop - A.y, h.y && g.scrollBy({
              top: -h.y,
              behavior: s
            });
            break;
          }
        }
        this.handleMove(t, Us(Bc(d, this.referenceCoordinates), h));
      }
    }
  }
  handleMove(t, n) {
    const {
      onMove: r
    } = this.props;
    t.preventDefault(), r(n);
  }
  handleEnd(t) {
    const {
      onEnd: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  handleCancel(t) {
    const {
      onCancel: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
y2.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, n) => {
    let {
      keyboardCodes: r = L7,
      onActivation: o
    } = t, {
      active: i
    } = n;
    const {
      code: a
    } = e.nativeEvent;
    if (r.start.includes(a)) {
      const s = i.activatorNode.current;
      return s && e.target !== s ? !1 : (e.preventDefault(), o == null || o({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function H4(e) {
  return !!(e && "distance" in e);
}
function q4(e) {
  return !!(e && "delay" in e);
}
class b2 {
  constructor(t, n, r) {
    var o;
    r === void 0 && (r = wce(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = n;
    const {
      event: i
    } = t, {
      target: a
    } = i;
    this.props = t, this.events = n, this.document = El(a), this.documentListeners = new hc(this.document), this.listeners = new hc(r), this.windowListeners = new hc(pr(a)), this.initialCoordinates = (o = Xg(i)) != null ? o : ho, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: n,
          bypassActivationConstraint: r
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), t.cancel && this.listeners.add(t.cancel.name, this.handleCancel), this.windowListeners.add($r.Resize, this.handleCancel), this.windowListeners.add($r.DragStart, W4), this.windowListeners.add($r.VisibilityChange, this.handleCancel), this.windowListeners.add($r.ContextMenu, W4), this.documentListeners.add($r.Keydown, this.handleKeydown), n) {
      if (r != null && r({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (q4(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay), this.handlePending(n);
        return;
      }
      if (H4(n)) {
        this.handlePending(n);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(t, n) {
    const {
      active: r,
      onPending: o
    } = this.props;
    o(r, t, this.initialCoordinates, n);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: n
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add($r.Click, Ece, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add($r.SelectionChange, this.removeTextSelection), n(t));
  }
  handleMove(t) {
    var n;
    const {
      activated: r,
      initialCoordinates: o,
      props: i
    } = this, {
      onMove: a,
      options: {
        activationConstraint: s
      }
    } = i;
    if (!o)
      return;
    const l = (n = Xg(t)) != null ? n : ho, c = Bc(o, l);
    if (!r && s) {
      if (H4(s)) {
        if (s.tolerance != null && nh(c, s.tolerance))
          return this.handleCancel();
        if (nh(c, s.distance))
          return this.handleStart();
      }
      if (q4(s) && nh(c, s.tolerance))
        return this.handleCancel();
      this.handlePending(s, c);
      return;
    }
    t.cancelable && t.preventDefault(), a(l);
  }
  handleEnd() {
    const {
      onAbort: t,
      onEnd: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleCancel() {
    const {
      onAbort: t,
      onCancel: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleKeydown(t) {
    t.code === gt.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const Rce = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class S2 extends b2 {
  constructor(t) {
    const {
      event: n
    } = t, r = El(n.target);
    super(t, Rce, r);
  }
}
S2.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return !n.isPrimary || n.button !== 0 ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
const Tce = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var Qg;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(Qg || (Qg = {}));
class _ce extends b2 {
  constructor(t) {
    super(t, Tce, El(t.event.target));
  }
}
_ce.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return n.button === Qg.RightClick ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
const rh = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class Oce extends b2 {
  constructor(t) {
    super(t, rh);
  }
  static setup() {
    return window.addEventListener(rh.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(rh.move.name, t);
    };
    function t() {
    }
  }
}
Oce.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    const {
      touches: o
    } = n;
    return o.length > 1 ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
var gc;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(gc || (gc = {}));
var _f;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(_f || (_f = {}));
function Ace(e) {
  let {
    acceleration: t,
    activator: n = gc.Pointer,
    canScroll: r,
    draggingRect: o,
    enabled: i,
    interval: a = 5,
    order: s = _f.TreeOrder,
    pointerCoordinates: l,
    scrollableAncestors: c,
    scrollableAncestorRects: u,
    delta: d,
    threshold: m
  } = e;
  const h = Dce({
    delta: d,
    disabled: !i
  }), [v, g] = Gle(), x = He({
    x: 0,
    y: 0
  }), b = He({
    x: 0,
    y: 0
  }), C = Be(() => {
    switch (n) {
      case gc.Pointer:
        return l ? {
          top: l.y,
          bottom: l.y,
          left: l.x,
          right: l.x
        } : null;
      case gc.DraggableRect:
        return o;
    }
  }, [n, o, l]), I = He(null), T = Ke(() => {
    const A = I.current;
    if (!A)
      return;
    const _ = x.current.x * b.current.x, k = x.current.y * b.current.y;
    A.scrollBy(_, k);
  }, []), R = Be(() => s === _f.TreeOrder ? [...c].reverse() : c, [s, c]);
  Le(
    () => {
      if (!i || !c.length || !C) {
        g();
        return;
      }
      for (const A of R) {
        if ((r == null ? void 0 : r(A)) === !1)
          continue;
        const _ = c.indexOf(A), k = u[_];
        if (!k)
          continue;
        const {
          direction: M,
          speed: j
        } = vce(A, k, C, t, m);
        for (const G of ["x", "y"])
          h[G][M[G]] || (j[G] = 0, M[G] = 0);
        if (j.x > 0 || j.y > 0) {
          g(), I.current = A, v(T, a), x.current = j, b.current = M;
          return;
        }
      }
      x.current = {
        x: 0,
        y: 0
      }, b.current = {
        x: 0,
        y: 0
      }, g();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      T,
      r,
      g,
      i,
      a,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(C),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(h),
      v,
      c,
      R,
      u,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(m)
    ]
  );
}
const kce = {
  x: {
    [Tn.Backward]: !1,
    [Tn.Forward]: !1
  },
  y: {
    [Tn.Backward]: !1,
    [Tn.Forward]: !1
  }
};
function Dce(e) {
  let {
    delta: t,
    disabled: n
  } = e;
  const r = Zg(t);
  return xu((o) => {
    if (n || !r || !o)
      return kce;
    const i = {
      x: Math.sign(t.x - r.x),
      y: Math.sign(t.y - r.y)
    };
    return {
      x: {
        [Tn.Backward]: o.x[Tn.Backward] || i.x === -1,
        [Tn.Forward]: o.x[Tn.Forward] || i.x === 1
      },
      y: {
        [Tn.Backward]: o.y[Tn.Backward] || i.y === -1,
        [Tn.Forward]: o.y[Tn.Forward] || i.y === 1
      }
    };
  }, [n, t, r]);
}
function Pce(e, t) {
  const n = t != null ? e.get(t) : void 0, r = n ? n.node.current : null;
  return xu((o) => {
    var i;
    return t == null ? null : (i = r ?? o) != null ? i : null;
  }, [r, t]);
}
function Nce(e, t) {
  return Be(() => e.reduce((n, r) => {
    const {
      sensor: o
    } = r, i = o.activators.map((a) => ({
      eventName: a.eventName,
      handler: t(a.handler, r)
    }));
    return [...n, ...i];
  }, []), [e, t]);
}
var Vc;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(Vc || (Vc = {}));
var e1;
(function(e) {
  e.Optimized = "optimized";
})(e1 || (e1 = {}));
const Y4 = /* @__PURE__ */ new Map();
function Mce(e, t) {
  let {
    dragging: n,
    dependencies: r,
    config: o
  } = t;
  const [i, a] = Fe(null), {
    frequency: s,
    measure: l,
    strategy: c
  } = o, u = He(e), d = x(), m = jc(d), h = Ke(function(b) {
    b === void 0 && (b = []), !m.current && a((C) => C === null ? b : C.concat(b.filter((I) => !C.includes(I))));
  }, [m]), v = He(null), g = xu((b) => {
    if (d && !n)
      return Y4;
    if (!b || b === Y4 || u.current !== e || i != null) {
      const C = /* @__PURE__ */ new Map();
      for (let I of e) {
        if (!I)
          continue;
        if (i && i.length > 0 && !i.includes(I.id) && I.rect.current) {
          C.set(I.id, I.rect.current);
          continue;
        }
        const T = I.node.current, R = T ? new v2(l(T), T) : null;
        I.rect.current = R, R && C.set(I.id, R);
      }
      return C;
    }
    return b;
  }, [e, i, n, d, l]);
  return Le(() => {
    u.current = e;
  }, [e]), Le(
    () => {
      d || h();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, d]
  ), Le(
    () => {
      i && i.length > 0 && a(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(i)]
  ), Le(
    () => {
      d || typeof s != "number" || v.current !== null || (v.current = setTimeout(() => {
        h(), v.current = null;
      }, s));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [s, d, h, ...r]
  ), {
    droppableRects: g,
    measureDroppableContainers: h,
    measuringScheduled: i != null
  };
  function x() {
    switch (c) {
      case Vc.Always:
        return !1;
      case Vc.BeforeDragging:
        return n;
      default:
        return !n;
    }
  }
}
function $7(e, t) {
  return xu((n) => e ? n || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function Fce(e, t) {
  return $7(e, t);
}
function Lce(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = h2(t), o = Be(() => {
    if (n || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: i
    } = window;
    return new i(r);
  }, [r, n]);
  return Le(() => () => o == null ? void 0 : o.disconnect(), [o]), o;
}
function Lm(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = h2(t), o = Be(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: i
      } = window;
      return new i(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return Le(() => () => o == null ? void 0 : o.disconnect(), [o]), o;
}
function $ce(e) {
  return new v2(Il(e), e);
}
function K4(e, t, n) {
  t === void 0 && (t = $ce);
  const [r, o] = Fe(null);
  function i() {
    o((l) => {
      if (!e)
        return null;
      if (e.isConnected === !1) {
        var c;
        return (c = l ?? n) != null ? c : null;
      }
      const u = t(e);
      return JSON.stringify(l) === JSON.stringify(u) ? l : u;
    });
  }
  const a = Lce({
    callback(l) {
      if (e)
        for (const c of l) {
          const {
            type: u,
            target: d
          } = c;
          if (u === "childList" && d instanceof HTMLElement && d.contains(e)) {
            i();
            break;
          }
        }
    }
  }), s = Lm({
    callback: i
  });
  return jo(() => {
    i(), e ? (s == null || s.observe(e), a == null || a.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (s == null || s.disconnect(), a == null || a.disconnect());
  }, [e]), r;
}
function zce(e) {
  const t = $7(e);
  return A7(e, t);
}
const Z4 = [];
function jce(e) {
  const t = He(e), n = xu((r) => e ? r && r !== Z4 && e && t.current && e.parentNode === t.current.parentNode ? r : Fm(e) : Z4, [e]);
  return Le(() => {
    t.current = e;
  }, [e]), n;
}
function Bce(e) {
  const [t, n] = Fe(null), r = He(e), o = Ke((i) => {
    const a = th(i.target);
    a && n((s) => s ? (s.set(a, Jg(a)), new Map(s)) : null);
  }, []);
  return Le(() => {
    const i = r.current;
    if (e !== i) {
      a(i);
      const s = e.map((l) => {
        const c = th(l);
        return c ? (c.addEventListener("scroll", o, {
          passive: !0
        }), [c, Jg(c)]) : null;
      }).filter((l) => l != null);
      n(s.length ? new Map(s) : null), r.current = e;
    }
    return () => {
      a(e), a(i);
    };
    function a(s) {
      s.forEach((l) => {
        const c = th(l);
        c == null || c.removeEventListener("scroll", o);
      });
    }
  }, [o, e]), Be(() => e.length ? t ? Array.from(t.values()).reduce((i, a) => Us(i, a), ho) : F7(e) : ho, [e, t]);
}
function X4(e, t) {
  t === void 0 && (t = []);
  const n = He(null);
  return Le(
    () => {
      n.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), Le(() => {
    const r = e !== ho;
    r && !n.current && (n.current = e), !r && n.current && (n.current = null);
  }, [e]), n.current ? Bc(e, n.current) : ho;
}
function Gce(e) {
  Le(
    () => {
      if (!Mm)
        return;
      const t = e.map((n) => {
        let {
          sensor: r
        } = n;
        return r.setup == null ? void 0 : r.setup();
      });
      return () => {
        for (const n of t)
          n == null || n();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: n
      } = t;
      return n;
    })
  );
}
function Vce(e, t) {
  return Be(() => e.reduce((n, r) => {
    let {
      eventName: o,
      handler: i
    } = r;
    return n[o] = (a) => {
      i(a, t);
    }, n;
  }, {}), [e, t]);
}
function z7(e) {
  return Be(() => e ? mce(e) : null, [e]);
}
const J4 = [];
function Uce(e, t) {
  t === void 0 && (t = Il);
  const [n] = e, r = z7(n ? pr(n) : null), [o, i] = Fe(J4);
  function a() {
    i(() => e.length ? e.map((l) => N7(l) ? r : new v2(t(l), l)) : J4);
  }
  const s = Lm({
    callback: a
  });
  return jo(() => {
    s == null || s.disconnect(), a(), e.forEach((l) => s == null ? void 0 : s.observe(l));
  }, [e]), o;
}
function Wce(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return Su(t) ? t : e;
}
function Hce(e) {
  let {
    measure: t
  } = e;
  const [n, r] = Fe(null), o = Ke((c) => {
    for (const {
      target: u
    } of c)
      if (Su(u)) {
        r((d) => {
          const m = t(u);
          return d ? {
            ...d,
            width: m.width,
            height: m.height
          } : m;
        });
        break;
      }
  }, [t]), i = Lm({
    callback: o
  }), a = Ke((c) => {
    const u = Wce(c);
    i == null || i.disconnect(), u && (i == null || i.observe(u)), r(u ? t(u) : null);
  }, [t, i]), [s, l] = Rf(a);
  return Be(() => ({
    nodeRef: s,
    rect: n,
    setRef: l
  }), [n, s, l]);
}
const qce = [{
  sensor: S2,
  options: {}
}, {
  sensor: y2,
  options: {}
}], Yce = {
  current: {}
}, Vd = {
  draggable: {
    measure: U4
  },
  droppable: {
    measure: U4,
    strategy: Vc.WhileDragging,
    frequency: e1.Optimized
  },
  dragOverlay: {
    measure: Il
  }
};
class vc extends Map {
  get(t) {
    var n;
    return t != null && (n = super.get(t)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: n
      } = t;
      return !n;
    });
  }
  getNodeFor(t) {
    var n, r;
    return (n = (r = this.get(t)) == null ? void 0 : r.node.current) != null ? n : void 0;
  }
}
const Kce = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new vc(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: Tf
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: Vd,
  measureDroppableContainers: Tf,
  windowRect: null,
  measuringScheduled: !1
}, Zce = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: Tf,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: Tf
}, $m = /* @__PURE__ */ Nn(Zce), j7 = /* @__PURE__ */ Nn(Kce);
function Xce() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new vc()
    }
  };
}
function Jce(e, t) {
  switch (t.type) {
    case xn.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case xn.DragMove:
      return e.draggable.active == null ? e : {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      };
    case xn.DragEnd:
    case xn.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case xn.RegisterDroppable: {
      const {
        element: n
      } = t, {
        id: r
      } = n, o = new vc(e.droppable.containers);
      return o.set(r, n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    case xn.SetDroppableDisabled: {
      const {
        id: n,
        key: r,
        disabled: o
      } = t, i = e.droppable.containers.get(n);
      if (!i || r !== i.key)
        return e;
      const a = new vc(e.droppable.containers);
      return a.set(n, {
        ...i,
        disabled: o
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: a
        }
      };
    }
    case xn.UnregisterDroppable: {
      const {
        id: n,
        key: r
      } = t, o = e.droppable.containers.get(n);
      if (!o || r !== o.key)
        return e;
      const i = new vc(e.droppable.containers);
      return i.delete(n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    default:
      return e;
  }
}
function Qce(e) {
  let {
    disabled: t
  } = e;
  const {
    active: n,
    activatorEvent: r,
    draggableNodes: o
  } = On($m), i = Zg(r), a = Zg(n == null ? void 0 : n.id);
  return Le(() => {
    if (!t && !r && i && a != null) {
      if (!g2(i) || document.activeElement === i.target)
        return;
      const s = o.get(a);
      if (!s)
        return;
      const {
        activatorNode: l,
        node: c
      } = s;
      if (!l.current && !c.current)
        return;
      requestAnimationFrame(() => {
        for (const u of [l.current, c.current]) {
          if (!u)
            continue;
          const d = Wle(u);
          if (d) {
            d.focus();
            break;
          }
        }
      });
    }
  }, [r, t, o, a, i]), null;
}
function eue(e, t) {
  let {
    transform: n,
    ...r
  } = t;
  return e != null && e.length ? e.reduce((o, i) => i({
    transform: o,
    ...r
  }), n) : n;
}
function tue(e) {
  return Be(
    () => ({
      draggable: {
        ...Vd.draggable,
        ...e == null ? void 0 : e.draggable
      },
      droppable: {
        ...Vd.droppable,
        ...e == null ? void 0 : e.droppable
      },
      dragOverlay: {
        ...Vd.dragOverlay,
        ...e == null ? void 0 : e.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e == null ? void 0 : e.draggable, e == null ? void 0 : e.droppable, e == null ? void 0 : e.dragOverlay]
  );
}
function nue(e) {
  let {
    activeNode: t,
    measure: n,
    initialRect: r,
    config: o = !0
  } = e;
  const i = He(!1), {
    x: a,
    y: s
  } = typeof o == "boolean" ? {
    x: o,
    y: o
  } : o;
  jo(() => {
    if (!a && !s || !t) {
      i.current = !1;
      return;
    }
    if (i.current || !r)
      return;
    const c = t == null ? void 0 : t.node.current;
    if (!c || c.isConnected === !1)
      return;
    const u = n(c), d = A7(u, r);
    if (a || (d.x = 0), s || (d.y = 0), i.current = !0, Math.abs(d.x) > 0 || Math.abs(d.y) > 0) {
      const m = k7(c);
      m && m.scrollBy({
        top: d.y,
        left: d.x
      });
    }
  }, [t, a, s, r, n]);
}
const B7 = /* @__PURE__ */ Nn({
  ...ho,
  scaleX: 1,
  scaleY: 1
});
var Ni;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(Ni || (Ni = {}));
const G7 = /* @__PURE__ */ dk(function(t) {
  var n, r, o, i;
  let {
    id: a,
    accessibility: s,
    autoScroll: l = !0,
    children: c,
    sensors: u = qce,
    collisionDetection: d = ace,
    measuring: m,
    modifiers: h,
    ...v
  } = t;
  const g = QS(Jce, void 0, Xce), [x, b] = g, [C, I] = Xle(), [T, R] = Fe(Ni.Uninitialized), A = T === Ni.Initialized, {
    draggable: {
      active: _,
      nodes: k,
      translate: M
    },
    droppable: {
      containers: j
    }
  } = x, G = _ != null ? k.get(_) : null, U = He({
    initial: null,
    translated: null
  }), B = Be(() => {
    var fe;
    return _ != null ? {
      id: _,
      // It's possible for the active node to unmount while dragging
      data: (fe = G == null ? void 0 : G.data) != null ? fe : Yce,
      rect: U
    } : null;
  }, [_, G]), K = He(null), [ee, Y] = Fe(null), [J, ye] = Fe(null), re = jc(v, Object.values(v)), le = Cu("DndDescribedBy", a), Te = Be(() => j.getEnabled(), [j]), F = tue(m), {
    droppableRects: Z,
    measureDroppableContainers: se,
    measuringScheduled: ae
  } = Mce(Te, {
    dragging: A,
    dependencies: [M.x, M.y],
    config: F.droppable
  }), ue = Pce(k, _), te = Be(() => J ? Xg(J) : null, [J]), he = De(), ge = Fce(ue, F.draggable.measure);
  nue({
    activeNode: _ != null ? k.get(_) : null,
    config: he.layoutShiftCompensation,
    initialRect: ge,
    measure: F.draggable.measure
  });
  const de = K4(ue, F.draggable.measure, ge), xe = K4(ue ? ue.parentElement : null), ce = He({
    activatorEvent: null,
    active: null,
    activeNode: ue,
    collisionRect: null,
    collisions: null,
    droppableRects: Z,
    draggableNodes: k,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: j,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), je = j.getNodeFor((n = ce.current.over) == null ? void 0 : n.id), z = Hce({
    measure: F.dragOverlay.measure
  }), Ue = (r = z.nodeRef.current) != null ? r : ue, st = A ? (o = z.rect) != null ? o : de : null, Rt = !!(z.nodeRef.current && z.rect), dn = zce(Rt ? null : de), _t = z7(Ue ? pr(Ue) : null), L = jce(A ? je ?? ue : null), q = Uce(L), Q = eue(h, {
    transform: {
      x: M.x - dn.x,
      y: M.y - dn.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: J,
    active: B,
    activeNodeRect: de,
    containerNodeRect: xe,
    draggingNodeRect: st,
    over: ce.current.over,
    overlayNodeRect: z.rect,
    scrollableAncestors: L,
    scrollableAncestorRects: q,
    windowRect: _t
  }), Se = te ? Us(te, M) : null, ve = Bce(L), me = X4(ve), Ne = X4(ve, [de]), et = Us(Q, me), ot = st ? cce(st, Q) : null, Ot = B && ot ? d({
    active: B,
    collisionRect: ot,
    droppableRects: Z,
    droppableContainers: Te,
    pointerCoordinates: Se
  }) : null, nn = O7(Ot, "id"), [Nt, wn] = Fe(null), kn = Rt ? Q : Us(Q, Ne), hr = sce(kn, (i = Nt == null ? void 0 : Nt.rect) != null ? i : null, de), gr = He(null), vr = Ke(
    (fe, Ie) => {
      let {
        sensor: tt,
        options: Me
      } = Ie;
      if (K.current == null)
        return;
      const kt = k.get(K.current);
      if (!kt)
        return;
      const Et = fe.nativeEvent, Yt = new tt({
        active: K.current,
        activeNode: kt,
        event: Et,
        options: Me,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: ce,
        onAbort(bt) {
          if (!k.get(bt))
            return;
          const {
            onDragAbort: $n
          } = re.current, Zr = {
            id: bt
          };
          $n == null || $n(Zr), C({
            type: "onDragAbort",
            event: Zr
          });
        },
        onPending(bt, Ln, $n, Zr) {
          if (!k.get(bt))
            return;
          const {
            onDragPending: ya
          } = re.current, xo = {
            id: bt,
            constraint: Ln,
            initialCoordinates: $n,
            offset: Zr
          };
          ya == null || ya(xo), C({
            type: "onDragPending",
            event: xo
          });
        },
        onStart(bt) {
          const Ln = K.current;
          if (Ln == null)
            return;
          const $n = k.get(Ln);
          if (!$n)
            return;
          const {
            onDragStart: Zr
          } = re.current, va = {
            activatorEvent: Et,
            active: {
              id: Ln,
              data: $n.data,
              rect: U
            }
          };
          Du(() => {
            Zr == null || Zr(va), R(Ni.Initializing), b({
              type: xn.DragStart,
              initialCoordinates: bt,
              active: Ln
            }), C({
              type: "onDragStart",
              event: va
            }), Y(gr.current), ye(Et);
          });
        },
        onMove(bt) {
          b({
            type: xn.DragMove,
            coordinates: bt
          });
        },
        onEnd: an(xn.DragEnd),
        onCancel: an(xn.DragCancel)
      });
      gr.current = Yt;
      function an(bt) {
        return async function() {
          const {
            active: $n,
            collisions: Zr,
            over: va,
            scrollAdjustedTranslate: ya
          } = ce.current;
          let xo = null;
          if ($n && ya) {
            const {
              cancelDrop: $
            } = re.current;
            xo = {
              activatorEvent: Et,
              active: $n,
              collisions: Zr,
              delta: ya,
              over: va
            }, bt === xn.DragEnd && typeof $ == "function" && await Promise.resolve($(xo)) && (bt = xn.DragCancel);
          }
          K.current = null, Du(() => {
            b({
              type: bt
            }), R(Ni.Uninitialized), wn(null), Y(null), ye(null), gr.current = null;
            const $ = bt === xn.DragEnd ? "onDragEnd" : "onDragCancel";
            if (xo) {
              const pe = re.current[$];
              pe == null || pe(xo), C({
                type: $,
                event: xo
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [k]
  ), Mr = Ke((fe, Ie) => (tt, Me) => {
    const kt = tt.nativeEvent, Et = k.get(Me);
    if (
      // Another sensor is already instantiating
      K.current !== null || // No active draggable
      !Et || // Event has already been captured
      kt.dndKit || kt.defaultPrevented
    )
      return;
    const Yt = {
      active: Et
    };
    fe(tt, Ie.options, Yt) === !0 && (kt.dndKit = {
      capturedBy: Ie.sensor
    }, K.current = Me, vr(tt, Ie));
  }, [k, vr]), Kn = Nce(u, Mr);
  Gce(u), jo(() => {
    de && T === Ni.Initializing && R(Ni.Initialized);
  }, [de, T]), Le(
    () => {
      const {
        onDragMove: fe
      } = re.current, {
        active: Ie,
        activatorEvent: tt,
        collisions: Me,
        over: kt
      } = ce.current;
      if (!Ie || !tt)
        return;
      const Et = {
        active: Ie,
        activatorEvent: tt,
        collisions: Me,
        delta: {
          x: et.x,
          y: et.y
        },
        over: kt
      };
      Du(() => {
        fe == null || fe(Et), C({
          type: "onDragMove",
          event: Et
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [et.x, et.y]
  ), Le(
    () => {
      const {
        active: fe,
        activatorEvent: Ie,
        collisions: tt,
        droppableContainers: Me,
        scrollAdjustedTranslate: kt
      } = ce.current;
      if (!fe || K.current == null || !Ie || !kt)
        return;
      const {
        onDragOver: Et
      } = re.current, Yt = Me.get(nn), an = Yt && Yt.rect.current ? {
        id: Yt.id,
        rect: Yt.rect.current,
        data: Yt.data,
        disabled: Yt.disabled
      } : null, bt = {
        active: fe,
        activatorEvent: Ie,
        collisions: tt,
        delta: {
          x: kt.x,
          y: kt.y
        },
        over: an
      };
      Du(() => {
        wn(an), Et == null || Et(bt), C({
          type: "onDragOver",
          event: bt
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [nn]
  ), jo(() => {
    ce.current = {
      activatorEvent: J,
      active: B,
      activeNode: ue,
      collisionRect: ot,
      collisions: Ot,
      droppableRects: Z,
      draggableNodes: k,
      draggingNode: Ue,
      draggingNodeRect: st,
      droppableContainers: j,
      over: Nt,
      scrollableAncestors: L,
      scrollAdjustedTranslate: et
    }, U.current = {
      initial: st,
      translated: ot
    };
  }, [B, ue, Ot, ot, k, Ue, st, Z, j, Nt, L, et]), Ace({
    ...he,
    delta: M,
    draggingRect: ot,
    pointerCoordinates: Se,
    scrollableAncestors: L,
    scrollableAncestorRects: q
  });
  const qe = Be(() => ({
    active: B,
    activeNode: ue,
    activeNodeRect: de,
    activatorEvent: J,
    collisions: Ot,
    containerNodeRect: xe,
    dragOverlay: z,
    draggableNodes: k,
    droppableContainers: j,
    droppableRects: Z,
    over: Nt,
    measureDroppableContainers: se,
    scrollableAncestors: L,
    scrollableAncestorRects: q,
    measuringConfiguration: F,
    measuringScheduled: ae,
    windowRect: _t
  }), [B, ue, de, J, Ot, xe, z, k, j, Z, Nt, se, L, q, F, ae, _t]), Ce = Be(() => ({
    activatorEvent: J,
    activators: Kn,
    active: B,
    activeNodeRect: de,
    ariaDescribedById: {
      draggable: le
    },
    dispatch: b,
    draggableNodes: k,
    over: Nt,
    measureDroppableContainers: se
  }), [J, Kn, B, de, b, le, k, Nt, se]);
  return H.createElement(R7.Provider, {
    value: I
  }, H.createElement($m.Provider, {
    value: Ce
  }, H.createElement(j7.Provider, {
    value: qe
  }, H.createElement(B7.Provider, {
    value: hr
  }, c)), H.createElement(Qce, {
    disabled: (s == null ? void 0 : s.restoreFocus) === !1
  })), H.createElement(ece, {
    ...s,
    hiddenTextDescribedById: le
  }));
  function De() {
    const fe = (ee == null ? void 0 : ee.autoScrollEnabled) === !1, Ie = typeof l == "object" ? l.enabled === !1 : l === !1, tt = A && !fe && !Ie;
    return typeof l == "object" ? {
      ...l,
      enabled: tt
    } : {
      enabled: tt
    };
  }
}), rue = /* @__PURE__ */ Nn(null), Q4 = "button", oue = "Draggable";
function iue(e) {
  let {
    id: t,
    data: n,
    disabled: r = !1,
    attributes: o
  } = e;
  const i = Cu(oue), {
    activators: a,
    activatorEvent: s,
    active: l,
    activeNodeRect: c,
    ariaDescribedById: u,
    draggableNodes: d,
    over: m
  } = On($m), {
    role: h = Q4,
    roleDescription: v = "draggable",
    tabIndex: g = 0
  } = o ?? {}, x = (l == null ? void 0 : l.id) === t, b = On(x ? B7 : rue), [C, I] = Rf(), [T, R] = Rf(), A = Vce(a, t), _ = jc(n);
  jo(
    () => (d.set(t, {
      id: t,
      key: i,
      node: C,
      activatorNode: T,
      data: _
    }), () => {
      const M = d.get(t);
      M && M.key === i && d.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d, t]
  );
  const k = Be(() => ({
    role: h,
    tabIndex: g,
    "aria-disabled": r,
    "aria-pressed": x && h === Q4 ? !0 : void 0,
    "aria-roledescription": v,
    "aria-describedby": u.draggable
  }), [r, h, g, x, v, u.draggable]);
  return {
    active: l,
    activatorEvent: s,
    activeNodeRect: c,
    attributes: k,
    isDragging: x,
    listeners: r ? void 0 : A,
    node: C,
    over: m,
    setNodeRef: I,
    setActivatorNodeRef: R,
    transform: b
  };
}
function aue() {
  return On(j7);
}
const sue = "Droppable", lue = {
  timeout: 25
};
function cue(e) {
  let {
    data: t,
    disabled: n = !1,
    id: r,
    resizeObserverConfig: o
  } = e;
  const i = Cu(sue), {
    active: a,
    dispatch: s,
    over: l,
    measureDroppableContainers: c
  } = On($m), u = He({
    disabled: n
  }), d = He(!1), m = He(null), h = He(null), {
    disabled: v,
    updateMeasurementsFor: g,
    timeout: x
  } = {
    ...lue,
    ...o
  }, b = jc(g ?? r), C = Ke(
    () => {
      if (!d.current) {
        d.current = !0;
        return;
      }
      h.current != null && clearTimeout(h.current), h.current = setTimeout(() => {
        c(Array.isArray(b.current) ? b.current : [b.current]), h.current = null;
      }, x);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [x]
  ), I = Lm({
    callback: C,
    disabled: v || !a
  }), T = Ke((k, M) => {
    I && (M && (I.unobserve(M), d.current = !1), k && I.observe(k));
  }, [I]), [R, A] = Rf(T), _ = jc(t);
  return Le(() => {
    !I || !R.current || (I.disconnect(), d.current = !1, I.observe(R.current));
  }, [R, I]), Le(
    () => (s({
      type: xn.RegisterDroppable,
      element: {
        id: r,
        key: i,
        disabled: n,
        node: R,
        rect: m,
        data: _
      }
    }), () => s({
      type: xn.UnregisterDroppable,
      key: i,
      id: r
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  ), Le(() => {
    n !== u.current.disabled && (s({
      type: xn.SetDroppableDisabled,
      id: r,
      key: i,
      disabled: n
    }), u.current.disabled = n);
  }, [r, i, n, s]), {
    active: a,
    rect: m,
    isOver: (l == null ? void 0 : l.id) === r,
    node: R,
    over: l,
    setNodeRef: A
  };
}
function uue(e, t, n) {
  const r = {
    ...e
  };
  return t.top + e.y <= n.top ? r.y = n.top - t.top : t.bottom + e.y >= n.top + n.height && (r.y = n.top + n.height - t.bottom), t.left + e.x <= n.left ? r.x = n.left - t.left : t.right + e.x >= n.left + n.width && (r.x = n.left + n.width - t.right), r;
}
const due = (e) => {
  let {
    containerNodeRect: t,
    draggingNodeRect: n,
    transform: r
  } = e;
  return !n || !t ? r : uue(r, n, t);
}, fue = (e) => {
  let {
    transform: t
  } = e;
  return {
    ...t,
    x: 0
  };
};
function x2(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function mue(e, t) {
  return e.reduce((n, r, o) => {
    const i = t.get(r);
    return i && (n[o] = i), n;
  }, Array(e.length));
}
function ud(e) {
  return e !== null && e >= 0;
}
function pue(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function hue(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const V7 = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: r,
    index: o
  } = e;
  const i = x2(t, r, n), a = t[o], s = i[o];
  return !s || !a ? null : {
    x: s.left - a.left,
    y: s.top - a.top,
    scaleX: s.width / a.width,
    scaleY: s.height / a.height
  };
}, dd = {
  scaleX: 1,
  scaleY: 1
}, gue = (e) => {
  var t;
  let {
    activeIndex: n,
    activeNodeRect: r,
    index: o,
    rects: i,
    overIndex: a
  } = e;
  const s = (t = i[n]) != null ? t : r;
  if (!s)
    return null;
  if (o === n) {
    const c = i[a];
    return c ? {
      x: 0,
      y: n < a ? c.top + c.height - (s.top + s.height) : c.top - s.top,
      ...dd
    } : null;
  }
  const l = vue(i, o, n);
  return o > n && o <= a ? {
    x: 0,
    y: -s.height - l,
    ...dd
  } : o < n && o >= a ? {
    x: 0,
    y: s.height + l,
    ...dd
  } : {
    x: 0,
    y: 0,
    ...dd
  };
};
function vue(e, t, n) {
  const r = e[t], o = e[t - 1], i = e[t + 1];
  return r ? n < t ? o ? r.top - (o.top + o.height) : i ? i.top - (r.top + r.height) : 0 : i ? i.top - (r.top + r.height) : o ? r.top - (o.top + o.height) : 0 : 0;
}
const U7 = "Sortable", W7 = /* @__PURE__ */ H.createContext({
  activeIndex: -1,
  containerId: U7,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: V7,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function yue(e) {
  let {
    children: t,
    id: n,
    items: r,
    strategy: o = V7,
    disabled: i = !1
  } = e;
  const {
    active: a,
    dragOverlay: s,
    droppableRects: l,
    over: c,
    measureDroppableContainers: u
  } = aue(), d = Cu(U7, n), m = s.rect !== null, h = Be(() => r.map((A) => typeof A == "object" && "id" in A ? A.id : A), [r]), v = a != null, g = a ? h.indexOf(a.id) : -1, x = c ? h.indexOf(c.id) : -1, b = He(h), C = !pue(h, b.current), I = x !== -1 && g === -1 || C, T = hue(i);
  jo(() => {
    C && v && u(h);
  }, [C, h, v, u]), Le(() => {
    b.current = h;
  }, [h]);
  const R = Be(
    () => ({
      activeIndex: g,
      containerId: d,
      disabled: T,
      disableTransforms: I,
      items: h,
      overIndex: x,
      useDragOverlay: m,
      sortedRects: mue(h, l),
      strategy: o
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g, d, T.draggable, T.droppable, I, h, x, l, m, o]
  );
  return H.createElement(W7.Provider, {
    value: R
  }, t);
}
const bue = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: r,
    overIndex: o
  } = e;
  return x2(n, r, o).indexOf(t);
}, Sue = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: r,
    index: o,
    items: i,
    newIndex: a,
    previousItems: s,
    previousContainerId: l,
    transition: c
  } = e;
  return !c || !r || s !== i && o === a ? !1 : n ? !0 : a !== o && t === l;
}, xue = {
  duration: 200,
  easing: "ease"
}, H7 = "transform", Cue = /* @__PURE__ */ Gc.Transition.toString({
  property: H7,
  duration: 0,
  easing: "linear"
}), wue = {
  roleDescription: "sortable"
};
function Eue(e) {
  let {
    disabled: t,
    index: n,
    node: r,
    rect: o
  } = e;
  const [i, a] = Fe(null), s = He(n);
  return jo(() => {
    if (!t && n !== s.current && r.current) {
      const l = o.current;
      if (l) {
        const c = Il(r.current, {
          ignoreTransform: !0
        }), u = {
          x: l.left - c.left,
          y: l.top - c.top,
          scaleX: l.width / c.width,
          scaleY: l.height / c.height
        };
        (u.x || u.y) && a(u);
      }
    }
    n !== s.current && (s.current = n);
  }, [t, n, r, o]), Le(() => {
    i && a(null);
  }, [i]), i;
}
function q7(e) {
  let {
    animateLayoutChanges: t = Sue,
    attributes: n,
    disabled: r,
    data: o,
    getNewIndex: i = bue,
    id: a,
    strategy: s,
    resizeObserverConfig: l,
    transition: c = xue
  } = e;
  const {
    items: u,
    containerId: d,
    activeIndex: m,
    disabled: h,
    disableTransforms: v,
    sortedRects: g,
    overIndex: x,
    useDragOverlay: b,
    strategy: C
  } = On(W7), I = Iue(r, h), T = u.indexOf(a), R = Be(() => ({
    sortable: {
      containerId: d,
      index: T,
      items: u
    },
    ...o
  }), [d, o, T, u]), A = Be(() => u.slice(u.indexOf(a)), [u, a]), {
    rect: _,
    node: k,
    isOver: M,
    setNodeRef: j
  } = cue({
    id: a,
    data: R,
    disabled: I.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: A,
      ...l
    }
  }), {
    active: G,
    activatorEvent: U,
    activeNodeRect: B,
    attributes: K,
    setNodeRef: ee,
    listeners: Y,
    isDragging: J,
    over: ye,
    setActivatorNodeRef: re,
    transform: le
  } = iue({
    id: a,
    data: R,
    attributes: {
      ...wue,
      ...n
    },
    disabled: I.draggable
  }), Te = Ble(j, ee), F = !!G, Z = F && !v && ud(m) && ud(x), se = !b && J, ae = se && Z ? le : null, te = Z ? ae ?? (s ?? C)({
    rects: g,
    activeNodeRect: B,
    activeIndex: m,
    overIndex: x,
    index: T
  }) : null, he = ud(m) && ud(x) ? i({
    id: a,
    items: u,
    activeIndex: m,
    overIndex: x
  }) : T, ge = G == null ? void 0 : G.id, de = He({
    activeId: ge,
    items: u,
    newIndex: he,
    containerId: d
  }), xe = u !== de.current.items, ce = t({
    active: G,
    containerId: d,
    isDragging: J,
    isSorting: F,
    id: a,
    index: T,
    items: u,
    newIndex: de.current.newIndex,
    previousItems: de.current.items,
    previousContainerId: de.current.containerId,
    transition: c,
    wasDragging: de.current.activeId != null
  }), je = Eue({
    disabled: !ce,
    index: T,
    node: k,
    rect: _
  });
  return Le(() => {
    F && de.current.newIndex !== he && (de.current.newIndex = he), d !== de.current.containerId && (de.current.containerId = d), u !== de.current.items && (de.current.items = u);
  }, [F, he, d, u]), Le(() => {
    if (ge === de.current.activeId)
      return;
    if (ge != null && de.current.activeId == null) {
      de.current.activeId = ge;
      return;
    }
    const Ue = setTimeout(() => {
      de.current.activeId = ge;
    }, 50);
    return () => clearTimeout(Ue);
  }, [ge]), {
    active: G,
    activeIndex: m,
    attributes: K,
    data: R,
    rect: _,
    index: T,
    newIndex: he,
    items: u,
    isOver: M,
    isSorting: F,
    isDragging: J,
    listeners: Y,
    node: k,
    overIndex: x,
    over: ye,
    setNodeRef: Te,
    setActivatorNodeRef: re,
    setDroppableNodeRef: j,
    setDraggableNodeRef: ee,
    transform: je ?? te,
    transition: z()
  };
  function z() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      je || // Or to prevent items jumping to back to their "new" position when items change
      xe && de.current.newIndex === T
    )
      return Cue;
    if (!(se && !g2(U) || !c) && (F || ce))
      return Gc.Transition.toString({
        ...c,
        property: H7
      });
  }
}
function Iue(e, t) {
  var n, r;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e == null ? void 0 : e.draggable) != null ? n : t.draggable,
    droppable: (r = e == null ? void 0 : e.droppable) != null ? r : t.droppable
  };
}
function Of(e) {
  if (!e)
    return !1;
  const t = e.data.current;
  return !!(t && "sortable" in t && typeof t.sortable == "object" && "containerId" in t.sortable && "items" in t.sortable && "index" in t.sortable);
}
const Rue = [gt.Down, gt.Right, gt.Up, gt.Left], Tue = (e, t) => {
  let {
    context: {
      active: n,
      collisionRect: r,
      droppableRects: o,
      droppableContainers: i,
      over: a,
      scrollableAncestors: s
    }
  } = t;
  if (Rue.includes(e.code)) {
    if (e.preventDefault(), !n || !r)
      return;
    const l = [];
    i.getEnabled().forEach((d) => {
      if (!d || d != null && d.disabled)
        return;
      const m = o.get(d.id);
      if (m)
        switch (e.code) {
          case gt.Down:
            r.top < m.top && l.push(d);
            break;
          case gt.Up:
            r.top > m.top && l.push(d);
            break;
          case gt.Left:
            r.left > m.left && l.push(d);
            break;
          case gt.Right:
            r.left < m.left && l.push(d);
            break;
        }
    });
    const c = oce({
      collisionRect: r,
      droppableRects: o,
      droppableContainers: l
    });
    let u = O7(c, "id");
    if (u === (a == null ? void 0 : a.id) && c.length > 1 && (u = c[1].id), u != null) {
      const d = i.get(n.id), m = i.get(u), h = m ? o.get(m.id) : null, v = m == null ? void 0 : m.node.current;
      if (v && h && d && m) {
        const x = Fm(v).some((A, _) => s[_] !== A), b = Y7(d, m), C = _ue(d, m), I = x || !b ? {
          x: 0,
          y: 0
        } : {
          x: C ? r.width - h.width : 0,
          y: C ? r.height - h.height : 0
        }, T = {
          x: h.left,
          y: h.top
        };
        return I.x && I.y ? T : Bc(T, I);
      }
    }
  }
};
function Y7(e, t) {
  return !Of(e) || !Of(t) ? !1 : e.data.current.sortable.containerId === t.data.current.sortable.containerId;
}
function _ue(e, t) {
  return !Of(e) || !Of(t) || !Y7(e, t) ? !1 : e.data.current.sortable.index < t.data.current.sortable.index;
}
function Nve({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ f.jsx(G7, { ...t, children: e });
}
const Oue = Nn(null);
function Mve({ item: e }) {
  const { listeners: t, attributes: n } = q7({ id: e.id });
  return /* @__PURE__ */ f.jsxs("button", { type: "button", ...t, ...n, children: [
    /* @__PURE__ */ f.jsx(
      Ve,
      {
        icon: "gripSolid",
        className: "hidden size-6 cursor-grabbing text-neutral-800 group-data-[dnd-dragging='true']/dnd-sortable-item:block",
        accessibilityLabel: "Dragging"
      }
    ),
    /* @__PURE__ */ f.jsx(
      Ve,
      {
        icon: "grip",
        className: "hidden size-6 cursor-grab text-neutral-400 group-data-[dnd-dragging='false']/dnd-sortable-item:block",
        accessibilityLabel: "Drag"
      }
    )
  ] });
}
function Aue({
  item: e,
  children: t
}) {
  const { transform: n, transition: r, isDragging: o, setNodeRef: i } = q7({
    id: e.id
  });
  return /* @__PURE__ */ f.jsx(
    "li",
    {
      ref: i,
      "data-dnd": "sortable-item",
      "data-dnd-dragging": o,
      className: "group/dnd-sortable-item relative z-0 data-[dnd-dragging='true']:z-10",
      style: {
        transform: Gc.Translate.toString(n),
        transition: r
      },
      children: /* @__PURE__ */ f.jsx(Oue.Provider, { value: e, children: t(e, o) })
    }
  );
}
function Fve({
  items: e,
  children: t,
  onReorder: n
}) {
  const [r, o] = Fe(e);
  Le(() => o(e), [e]);
  const i = B4(S2), a = B4(y2, {
    coordinateGetter: Tue
  }), s = tce(i, a);
  return /* @__PURE__ */ f.jsx(
    G7,
    {
      sensors: s,
      collisionDetection: rce,
      modifiers: [fue, due],
      onDragEnd: ({ active: l, over: c }) => {
        if (l.id === (c == null ? void 0 : c.id)) return;
        const u = r.findIndex((h) => h.id === l.id), d = r.findIndex((h) => h.id === (c == null ? void 0 : c.id));
        if (u === -1 || d === -1) return;
        const m = x2(r, u, d);
        o(m), n == null || n(m);
      },
      children: /* @__PURE__ */ f.jsx(yue, { items: r, strategy: gue, children: /* @__PURE__ */ f.jsx("ol", { className: "space-y-2", children: r.map((l) => /* @__PURE__ */ f.jsx(Aue, { item: l, children: t }, l.id)) }) })
    }
  );
}
function kue(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const K7 = H.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), wu = () => {
  const e = H.useContext(K7);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
kue(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Due() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function Pue() {
  return C2(/^Mac/);
}
function Nue() {
  return C2(/^iPhone/);
}
function eS() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Mue() {
  return C2(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Pue() && navigator.maxTouchPoints > 1;
}
function Z7() {
  return Nue() || Mue();
}
function C2(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Fue = 24, Lue = typeof window < "u" ? oa : Le;
function tS(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const oh = typeof document < "u" && window.visualViewport;
function nS(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function X7(e) {
  for (nS(e) && (e = e.parentElement); e && !nS(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const $ue = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let fd = 0, ih;
function zue(e = {}) {
  let { isDisabled: t } = e;
  Lue(() => {
    if (!t)
      return fd++, fd === 1 && Z7() && (ih = jue()), () => {
        fd--, fd === 0 && (ih == null || ih());
      };
  }, [
    t
  ]);
}
function jue() {
  let e, t = 0, n = (d) => {
    e = X7(d.target), !(e === document.documentElement && e === document.body) && (t = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!e || e === document.documentElement || e === document.body) {
      d.preventDefault();
      return;
    }
    let m = d.changedTouches[0].pageY, h = e.scrollTop, v = e.scrollHeight - e.clientHeight;
    v !== 0 && ((h <= 0 && m > t || h >= v && m < t) && d.preventDefault(), t = m);
  }, o = (d) => {
    let m = d.target;
    t1(m) && m !== document.activeElement && (d.preventDefault(), m.style.transform = "translateY(-2000px)", m.focus(), requestAnimationFrame(() => {
      m.style.transform = "";
    }));
  }, i = (d) => {
    let m = d.target;
    t1(m) && (m.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      m.style.transform = "", oh && (oh.height < window.innerHeight ? requestAnimationFrame(() => {
        rS(m);
      }) : oh.addEventListener("resize", () => rS(m), {
        once: !0
      }));
    }));
  }, a = () => {
    window.scrollTo(0, 0);
  }, s = window.pageXOffset, l = window.pageYOffset, c = tS(Bue(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = tS(Vl(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), Vl(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), Vl(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), Vl(document, "focus", i, !0), Vl(window, "scroll", a));
  return () => {
    c(), u(), window.scrollTo(s, l);
  };
}
function Bue(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Vl(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function rS(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = X7(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, i = e.getBoundingClientRect().bottom;
      const a = n.getBoundingClientRect().bottom + Fue;
      i > a && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function t1(e) {
  return e instanceof HTMLInputElement && !$ue.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function Gue(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Vue(...e) {
  return (t) => e.forEach((n) => Gue(n, t));
}
function J7(...e) {
  return S.useCallback(Vue(...e), e);
}
const Q7 = /* @__PURE__ */ new WeakMap();
function Sn(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([o, i]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, i);
      return;
    }
    r[o] = e.style[o], e.style[o] = i;
  }), !n && Q7.set(e, r);
}
function Uue(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = Q7.get(e);
  n && (e.style[t] = n[t]);
}
const hn = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function md(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[hn(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[hn(t) ? 5 : 4]) : null);
}
function Wue(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function ah(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function Hue(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const Kt = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, eT = 0.4, que = 0.25, Yue = 100, tT = 8, wa = 16, n1 = 26, sh = "vaul-dragging";
function nT(e) {
  const t = H.useRef(e);
  return H.useEffect(() => {
    t.current = e;
  }), H.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function Kue({ defaultProp: e, onChange: t }) {
  const n = H.useState(e), [r] = n, o = H.useRef(r), i = nT(t);
  return H.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function rT({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = Kue({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : r, s = nT(n), l = H.useCallback((c) => {
    if (i) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && s(d);
    } else
      o(c);
  }, [
    i,
    e,
    o,
    s
  ]);
  return [
    a,
    l
  ];
}
function Zue({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: i, onSnapPointChange: a, direction: s = "bottom", container: l, snapToSequentialPoint: c }) {
  const [u, d] = rT({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [m, h] = H.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  H.useEffect(() => {
    function _() {
      h({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", _), () => window.removeEventListener("resize", _);
  }, []);
  const v = H.useMemo(() => u === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    u
  ]), g = H.useMemo(() => {
    var _;
    return (_ = n == null ? void 0 : n.findIndex((k) => k === u)) != null ? _ : null;
  }, [
    n,
    u
  ]), x = n && n.length > 0 && (i || i === 0) && !Number.isNaN(i) && n[i] === u || !n, b = H.useMemo(() => {
    const _ = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var k;
    return (k = n == null ? void 0 : n.map((M) => {
      const j = typeof M == "string";
      let G = 0;
      if (j && (G = parseInt(M, 10)), hn(s)) {
        const B = j ? G : m ? M * _.height : 0;
        return m ? s === "bottom" ? _.height - B : -_.height + B : B;
      }
      const U = j ? G : m ? M * _.width : 0;
      return m ? s === "right" ? _.width - U : -_.width + U : U;
    })) != null ? k : [];
  }, [
    n,
    m,
    l
  ]), C = H.useMemo(() => g !== null ? b == null ? void 0 : b[g] : null, [
    b,
    g
  ]), I = H.useCallback((_) => {
    var k;
    const M = (k = b == null ? void 0 : b.findIndex((j) => j === _)) != null ? k : null;
    a(M), Sn(r.current, {
      transition: `transform ${Kt.DURATION}s cubic-bezier(${Kt.EASE.join(",")})`,
      transform: hn(s) ? `translate3d(0, ${_}px, 0)` : `translate3d(${_}px, 0, 0)`
    }), b && M !== b.length - 1 && i !== void 0 && M !== i && M < i ? Sn(o.current, {
      transition: `opacity ${Kt.DURATION}s cubic-bezier(${Kt.EASE.join(",")})`,
      opacity: "0"
    }) : Sn(o.current, {
      transition: `opacity ${Kt.DURATION}s cubic-bezier(${Kt.EASE.join(",")})`,
      opacity: "1"
    }), d(n == null ? void 0 : n[Math.max(M, 0)]);
  }, [
    r.current,
    n,
    b,
    i,
    o,
    d
  ]);
  H.useEffect(() => {
    if (u || e) {
      var _;
      const k = (_ = n == null ? void 0 : n.findIndex((M) => M === e || M === u)) != null ? _ : -1;
      b && k !== -1 && typeof b[k] == "number" && I(b[k]);
    }
  }, [
    u,
    e,
    n,
    b,
    I
  ]);
  function T({ draggedDistance: _, closeDrawer: k, velocity: M, dismissible: j }) {
    if (i === void 0) return;
    const G = s === "bottom" || s === "right" ? (C ?? 0) - _ : (C ?? 0) + _, U = g === i - 1, B = g === 0, K = _ > 0;
    if (U && Sn(o.current, {
      transition: `opacity ${Kt.DURATION}s cubic-bezier(${Kt.EASE.join(",")})`
    }), !c && M > 2 && !K) {
      j ? k() : I(b[0]);
      return;
    }
    if (!c && M > 2 && K && b && n) {
      I(b[n.length - 1]);
      return;
    }
    const ee = b == null ? void 0 : b.reduce((J, ye) => typeof J != "number" || typeof ye != "number" ? J : Math.abs(ye - G) < Math.abs(J - G) ? ye : J), Y = hn(s) ? window.innerHeight : window.innerWidth;
    if (M > eT && Math.abs(_) < Y * 0.4) {
      const J = K ? 1 : -1;
      if (J > 0 && v && n) {
        I(b[n.length - 1]);
        return;
      }
      if (B && J < 0 && j && k(), g === null) return;
      I(b[g + J]);
      return;
    }
    I(ee);
  }
  function R({ draggedDistance: _ }) {
    if (C === null) return;
    const k = s === "bottom" || s === "right" ? C - _ : C + _;
    (s === "bottom" || s === "right") && k < b[b.length - 1] || (s === "top" || s === "left") && k > b[b.length - 1] || Sn(r.current, {
      transform: hn(s) ? `translate3d(0, ${k}px, 0)` : `translate3d(${k}px, 0, 0)`
    });
  }
  function A(_, k) {
    if (!n || typeof g != "number" || !b || i === void 0) return null;
    const M = g === i - 1;
    if (g >= i && k)
      return 0;
    if (M && !k) return 1;
    if (!x && !M) return null;
    const G = M ? g + 1 : g - 1, U = M ? b[G] - b[G - 1] : b[G + 1] - b[G], B = _ / Math.abs(U);
    return M ? 1 - B : B;
  }
  return {
    isLastSnapPoint: v,
    activeSnapPoint: u,
    shouldFade: x,
    getPercentageDragged: A,
    setActiveSnapPoint: d,
    activeSnapPointIndex: g,
    onRelease: T,
    onDrag: R,
    snapPointsOffset: b
  };
}
const Xue = () => () => {
};
function Jue() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = wu(), i = H.useRef(null), a = Be(() => document.body.style.backgroundColor, []);
  function s() {
    return (window.innerWidth - n1) / window.innerWidth;
  }
  H.useEffect(() => {
    if (t && n) {
      i.current && clearTimeout(i.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      Hue(r && !o ? ah(document.body, {
        background: "black"
      }) : Xue, ah(l, {
        transformOrigin: hn(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Kt.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Kt.EASE.join(",")})`
      }));
      const c = ah(l, {
        borderRadius: `${tT}px`,
        overflow: "hidden",
        ...hn(e) ? {
          transform: `scale(${s()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${s()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), i.current = window.setTimeout(() => {
          a ? document.body.style.background = a : document.body.style.removeProperty("background");
        }, Kt.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    a
  ]);
}
let Ul = null;
function Que({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: i }) {
  const [a, s] = H.useState(() => typeof window < "u" ? window.location.href : ""), l = H.useRef(0), c = H.useCallback(() => {
    if (eS() && Ul === null && e && !i) {
      Ul = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: m } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const h = m - window.innerHeight;
        h && l.current >= m && (document.body.style.top = `${-(l.current + h)}px`);
      }), 300);
    }
  }, [
    e
  ]), u = H.useCallback(() => {
    if (eS() && Ul !== null && !i) {
      const d = -parseInt(document.body.style.top, 10), m = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Ul), window.requestAnimationFrame(() => {
        if (o && a !== window.location.href) {
          s(window.location.href);
          return;
        }
        window.scrollTo(m, d);
      }), Ul = null;
    }
  }, [
    a
  ]);
  return H.useEffect(() => {
    function d() {
      l.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), H.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [
    t,
    u
  ]), H.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && c(), t || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    e,
    r,
    a,
    t,
    n,
    c,
    u
  ]), {
    restorePositionSetting: u
  };
}
function ede({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: i, shouldScaleBackground: a = !1, setBackgroundColorOnScale: s = !0, closeThreshold: l = que, scrollLockTimeout: c = Yue, dismissible: u = !0, handleOnly: d = !1, fadeFromIndex: m = i && i.length - 1, activeSnapPoint: h, setActiveSnapPoint: v, fixed: g, modal: x = !0, onClose: b, nested: C, noBodyStyles: I = !1, direction: T = "bottom", defaultOpen: R = !1, disablePreventScroll: A = !0, snapToSequentialPoint: _ = !1, preventScrollRestoration: k = !1, repositionInputs: M = !0, onAnimationEnd: j, container: G, autoFocus: U = !1 }) {
  var B, K;
  const [ee = !1, Y] = rT({
    defaultProp: R,
    prop: e,
    onChange: (qe) => {
      t == null || t(qe), !qe && !C && et(), setTimeout(() => {
        j == null || j(qe);
      }, Kt.DURATION * 1e3), qe && !x && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), qe || (document.body.style.pointerEvents = "auto");
    }
  }), [J, ye] = H.useState(!1), [re, le] = H.useState(!1), [Te, F] = H.useState(!1), Z = H.useRef(null), se = H.useRef(null), ae = H.useRef(null), ue = H.useRef(null), te = H.useRef(null), he = H.useRef(!1), ge = H.useRef(null), de = H.useRef(0), xe = H.useRef(!1), ce = H.useRef(!R), je = H.useRef(0), z = H.useRef(null), Ue = H.useRef(((B = z.current) == null ? void 0 : B.getBoundingClientRect().height) || 0), st = H.useRef(((K = z.current) == null ? void 0 : K.getBoundingClientRect().width) || 0), Rt = H.useRef(0), dn = H.useCallback((qe) => {
    i && qe === Se.length - 1 && (se.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: _t, activeSnapPointIndex: L, setActiveSnapPoint: q, onRelease: Q, snapPointsOffset: Se, onDrag: ve, shouldFade: me, getPercentageDragged: Ne } = Zue({
    snapPoints: i,
    activeSnapPointProp: h,
    setActiveSnapPointProp: v,
    drawerRef: z,
    fadeFromIndex: m,
    overlayRef: Z,
    onSnapPointChange: dn,
    direction: T,
    container: G,
    snapToSequentialPoint: _
  });
  zue({
    isDisabled: !ee || re || !x || Te || !J || !M || !A
  });
  const { restorePositionSetting: et } = Que({
    isOpen: ee,
    modal: x,
    nested: C ?? !1,
    hasBeenOpened: J,
    preventScrollRestoration: k,
    noBodyStyles: I
  });
  function ot() {
    return (window.innerWidth - n1) / window.innerWidth;
  }
  function Ot(qe) {
    var Ce, De;
    !u && !i || z.current && !z.current.contains(qe.target) || (Ue.current = ((Ce = z.current) == null ? void 0 : Ce.getBoundingClientRect().height) || 0, st.current = ((De = z.current) == null ? void 0 : De.getBoundingClientRect().width) || 0, le(!0), ae.current = /* @__PURE__ */ new Date(), Z7() && window.addEventListener("touchend", () => he.current = !1, {
      once: !0
    }), qe.target.setPointerCapture(qe.pointerId), de.current = hn(T) ? qe.pageY : qe.pageX);
  }
  function nn(qe, Ce) {
    var De;
    let fe = qe;
    const Ie = (De = window.getSelection()) == null ? void 0 : De.toString(), tt = z.current ? md(z.current, T) : null, Me = /* @__PURE__ */ new Date();
    if (fe.tagName === "SELECT" || fe.hasAttribute("data-vaul-no-drag") || fe.closest("[data-vaul-no-drag]"))
      return !1;
    if (T === "right" || T === "left")
      return !0;
    if (se.current && Me.getTime() - se.current.getTime() < 500)
      return !1;
    if (tt !== null && (T === "bottom" ? tt > 0 : tt < 0))
      return !0;
    if (Ie && Ie.length > 0)
      return !1;
    if (te.current && Me.getTime() - te.current.getTime() < c && tt === 0 || Ce)
      return te.current = Me, !1;
    for (; fe; ) {
      if (fe.scrollHeight > fe.clientHeight) {
        if (fe.scrollTop !== 0)
          return te.current = /* @__PURE__ */ new Date(), !1;
        if (fe.getAttribute("role") === "dialog")
          return !0;
      }
      fe = fe.parentNode;
    }
    return !0;
  }
  function Nt(qe) {
    if (z.current && re) {
      const Ce = T === "bottom" || T === "right" ? 1 : -1, De = (de.current - (hn(T) ? qe.pageY : qe.pageX)) * Ce, fe = De > 0, Ie = i && !u && !fe;
      if (Ie && L === 0) return;
      const tt = Math.abs(De), Me = document.querySelector("[data-vaul-drawer-wrapper]"), kt = T === "bottom" || T === "top" ? Ue.current : st.current;
      let Et = tt / kt;
      const Yt = Ne(tt, fe);
      if (Yt !== null && (Et = Yt), Ie && Et >= 1 || !he.current && !nn(qe.target, fe)) return;
      if (z.current.classList.add(sh), he.current = !0, Sn(z.current, {
        transition: "none"
      }), Sn(Z.current, {
        transition: "none"
      }), i && ve({
        draggedDistance: De
      }), fe && !i) {
        const bt = Wue(De), Ln = Math.min(bt * -1, 0) * Ce;
        Sn(z.current, {
          transform: hn(T) ? `translate3d(0, ${Ln}px, 0)` : `translate3d(${Ln}px, 0, 0)`
        });
        return;
      }
      const an = 1 - Et;
      if ((me || m && L === m - 1) && (r == null || r(qe, Et), Sn(Z.current, {
        opacity: `${an}`,
        transition: "none"
      }, !0)), Me && Z.current && a) {
        const bt = Math.min(ot() + Et * (1 - ot()), 1), Ln = 8 - Et * 8, $n = Math.max(0, 14 - Et * 14);
        Sn(Me, {
          borderRadius: `${Ln}px`,
          transform: hn(T) ? `scale(${bt}) translate3d(0, ${$n}px, 0)` : `scale(${bt}) translate3d(${$n}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!i) {
        const bt = tt * Ce;
        Sn(z.current, {
          transform: hn(T) ? `translate3d(0, ${bt}px, 0)` : `translate3d(${bt}px, 0, 0)`
        });
      }
    }
  }
  H.useEffect(() => {
    window.requestAnimationFrame(() => {
      ce.current = !0;
    });
  }, []), H.useEffect(() => {
    var qe;
    function Ce() {
      if (!z.current || !M) return;
      const De = document.activeElement;
      if (t1(De) || xe.current) {
        var fe;
        const Ie = ((fe = window.visualViewport) == null ? void 0 : fe.height) || 0, tt = window.innerHeight;
        let Me = tt - Ie;
        const kt = z.current.getBoundingClientRect().height || 0, Et = kt > tt * 0.8;
        Rt.current || (Rt.current = kt);
        const Yt = z.current.getBoundingClientRect().top;
        if (Math.abs(je.current - Me) > 60 && (xe.current = !xe.current), i && i.length > 0 && Se && L) {
          const an = Se[L] || 0;
          Me += an;
        }
        if (je.current = Me, kt > Ie || xe.current) {
          const an = z.current.getBoundingClientRect().height;
          let bt = an;
          an > Ie && (bt = Ie - (Et ? Yt : n1)), g ? z.current.style.height = `${an - Math.max(Me, 0)}px` : z.current.style.height = `${Math.max(bt, Ie - Yt)}px`;
        } else Due() || (z.current.style.height = `${Rt.current}px`);
        i && i.length > 0 && !xe.current ? z.current.style.bottom = "0px" : z.current.style.bottom = `${Math.max(Me, 0)}px`;
      }
    }
    return (qe = window.visualViewport) == null || qe.addEventListener("resize", Ce), () => {
      var De;
      return (De = window.visualViewport) == null ? void 0 : De.removeEventListener("resize", Ce);
    };
  }, [
    L,
    i,
    Se
  ]);
  function wn(qe) {
    hr(), b == null || b(), qe || Y(!1), setTimeout(() => {
      i && q(i[0]);
    }, Kt.DURATION * 1e3);
  }
  function kn() {
    if (!z.current) return;
    const qe = document.querySelector("[data-vaul-drawer-wrapper]"), Ce = md(z.current, T);
    Sn(z.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Kt.DURATION}s cubic-bezier(${Kt.EASE.join(",")})`
    }), Sn(Z.current, {
      transition: `opacity ${Kt.DURATION}s cubic-bezier(${Kt.EASE.join(",")})`,
      opacity: "1"
    }), a && Ce && Ce > 0 && ee && Sn(qe, {
      borderRadius: `${tT}px`,
      overflow: "hidden",
      ...hn(T) ? {
        transform: `scale(${ot()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${ot()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Kt.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Kt.EASE.join(",")})`
    }, !0);
  }
  function hr() {
    !re || !z.current || (z.current.classList.remove(sh), he.current = !1, le(!1), ue.current = /* @__PURE__ */ new Date());
  }
  function gr(qe) {
    if (!re || !z.current) return;
    z.current.classList.remove(sh), he.current = !1, le(!1), ue.current = /* @__PURE__ */ new Date();
    const Ce = md(z.current, T);
    if (!qe || !nn(qe.target, !1) || !Ce || Number.isNaN(Ce) || ae.current === null) return;
    const De = ue.current.getTime() - ae.current.getTime(), fe = de.current - (hn(T) ? qe.pageY : qe.pageX), Ie = Math.abs(fe) / De;
    if (Ie > 0.05 && (F(!0), setTimeout(() => {
      F(!1);
    }, 200)), i) {
      Q({
        draggedDistance: fe * (T === "bottom" || T === "right" ? 1 : -1),
        closeDrawer: wn,
        velocity: Ie,
        dismissible: u
      }), o == null || o(qe, !0);
      return;
    }
    if (T === "bottom" || T === "right" ? fe > 0 : fe < 0) {
      kn(), o == null || o(qe, !0);
      return;
    }
    if (Ie > eT) {
      wn(), o == null || o(qe, !1);
      return;
    }
    var tt;
    const Me = Math.min((tt = z.current.getBoundingClientRect().height) != null ? tt : 0, window.innerHeight);
    var kt;
    const Et = Math.min((kt = z.current.getBoundingClientRect().width) != null ? kt : 0, window.innerWidth), Yt = T === "left" || T === "right";
    if (Math.abs(Ce) >= (Yt ? Et : Me) * l) {
      wn(), o == null || o(qe, !1);
      return;
    }
    o == null || o(qe, !0), kn();
  }
  H.useEffect(() => (ee && (Sn(document.documentElement, {
    scrollBehavior: "auto"
  }), se.current = /* @__PURE__ */ new Date()), () => {
    Uue(document.documentElement, "scrollBehavior");
  }), [
    ee
  ]);
  function vr(qe) {
    const Ce = qe ? (window.innerWidth - wa) / window.innerWidth : 1, De = qe ? -wa : 0;
    ge.current && window.clearTimeout(ge.current), Sn(z.current, {
      transition: `transform ${Kt.DURATION}s cubic-bezier(${Kt.EASE.join(",")})`,
      transform: hn(T) ? `scale(${Ce}) translate3d(0, ${De}px, 0)` : `scale(${Ce}) translate3d(${De}px, 0, 0)`
    }), !qe && z.current && (ge.current = setTimeout(() => {
      const fe = md(z.current, T);
      Sn(z.current, {
        transition: "none",
        transform: hn(T) ? `translate3d(0, ${fe}px, 0)` : `translate3d(${fe}px, 0, 0)`
      });
    }, 500));
  }
  function Mr(qe, Ce) {
    if (Ce < 0) return;
    const De = (window.innerWidth - wa) / window.innerWidth, fe = De + Ce * (1 - De), Ie = -wa + Ce * wa;
    Sn(z.current, {
      transform: hn(T) ? `scale(${fe}) translate3d(0, ${Ie}px, 0)` : `scale(${fe}) translate3d(${Ie}px, 0, 0)`,
      transition: "none"
    });
  }
  function Kn(qe, Ce) {
    const De = hn(T) ? window.innerHeight : window.innerWidth, fe = Ce ? (De - wa) / De : 1, Ie = Ce ? -wa : 0;
    Ce && Sn(z.current, {
      transition: `transform ${Kt.DURATION}s cubic-bezier(${Kt.EASE.join(",")})`,
      transform: hn(T) ? `scale(${fe}) translate3d(0, ${Ie}px, 0)` : `scale(${fe}) translate3d(${Ie}px, 0, 0)`
    });
  }
  return H.useEffect(() => {
    x || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    x
  ]), /* @__PURE__ */ H.createElement(zR, {
    defaultOpen: R,
    onOpenChange: (qe) => {
      !u && !qe || (qe ? ye(!0) : wn(!0), Y(qe));
    },
    open: ee
  }, /* @__PURE__ */ H.createElement(K7.Provider, {
    value: {
      activeSnapPoint: _t,
      snapPoints: i,
      setActiveSnapPoint: q,
      drawerRef: z,
      overlayRef: Z,
      onOpenChange: t,
      onPress: Ot,
      onRelease: gr,
      onDrag: Nt,
      dismissible: u,
      shouldAnimate: ce,
      handleOnly: d,
      isOpen: ee,
      isDragging: re,
      shouldFade: me,
      closeDrawer: wn,
      onNestedDrag: Mr,
      onNestedOpenChange: vr,
      onNestedRelease: Kn,
      keyboardIsOpen: xe,
      modal: x,
      snapPointsOffset: Se,
      activeSnapPointIndex: L,
      direction: T,
      shouldScaleBackground: a,
      setBackgroundColorOnScale: s,
      noBodyStyles: I,
      container: G,
      autoFocus: U
    }
  }, n));
}
const oT = /* @__PURE__ */ H.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: i, isOpen: a, modal: s, shouldAnimate: l } = wu(), c = J7(t, n), u = r && r.length > 0;
  if (!s)
    return null;
  const d = H.useCallback((m) => o(m), [
    o
  ]);
  return /* @__PURE__ */ H.createElement(Yv, {
    onMouseUp: d,
    ref: c,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": a && u ? "true" : "false",
    "data-vaul-snap-points-overlay": a && i ? "true" : "false",
    "data-vaul-animate": l != null && l.current ? "true" : "false",
    ...e
  });
});
oT.displayName = "Drawer.Overlay";
const iT = /* @__PURE__ */ H.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: i, onPress: a, onRelease: s, onDrag: l, keyboardIsOpen: c, snapPointsOffset: u, activeSnapPointIndex: d, modal: m, isOpen: h, direction: v, snapPoints: g, container: x, handleOnly: b, shouldAnimate: C, autoFocus: I } = wu(), [T, R] = H.useState(!1), A = J7(o, i), _ = H.useRef(null), k = H.useRef(null), M = H.useRef(!1), j = g && g.length > 0;
  Jue();
  const G = (B, K, ee = 0) => {
    if (M.current) return !0;
    const Y = Math.abs(B.y), J = Math.abs(B.x), ye = J > Y, re = [
      "bottom",
      "right"
    ].includes(K) ? 1 : -1;
    if (K === "left" || K === "right") {
      if (!(B.x * re < 0) && J >= 0 && J <= ee)
        return ye;
    } else if (!(B.y * re < 0) && Y >= 0 && Y <= ee)
      return !ye;
    return M.current = !0, !0;
  };
  H.useEffect(() => {
    j && window.requestAnimationFrame(() => {
      R(!0);
    });
  }, []);
  function U(B) {
    _.current = null, M.current = !1, s(B);
  }
  return /* @__PURE__ */ H.createElement(Kv, {
    "data-vaul-drawer-direction": v,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": T ? "true" : "false",
    "data-vaul-snap-points": h && j ? "true" : "false",
    "data-vaul-custom-container": x ? "true" : "false",
    "data-vaul-animate": C != null && C.current ? "true" : "false",
    ...r,
    ref: A,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[d ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (B) => {
      b || (r.onPointerDown == null || r.onPointerDown.call(r, B), _.current = {
        x: B.pageX,
        y: B.pageY
      }, a(B));
    },
    onOpenAutoFocus: (B) => {
      n == null || n(B), I || B.preventDefault();
    },
    onPointerDownOutside: (B) => {
      if (e == null || e(B), !m || B.defaultPrevented) {
        B.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (B) => {
      if (!m) {
        B.preventDefault();
        return;
      }
    },
    onPointerMove: (B) => {
      if (k.current = B, b || (r.onPointerMove == null || r.onPointerMove.call(r, B), !_.current)) return;
      const K = B.pageY - _.current.y, ee = B.pageX - _.current.x, Y = B.pointerType === "touch" ? 10 : 2;
      G({
        x: ee,
        y: K
      }, v, Y) ? l(B) : (Math.abs(ee) > Y || Math.abs(K) > Y) && (_.current = null);
    },
    onPointerUp: (B) => {
      r.onPointerUp == null || r.onPointerUp.call(r, B), _.current = null, M.current = !1, s(B);
    },
    onPointerOut: (B) => {
      r.onPointerOut == null || r.onPointerOut.call(r, B), U(k.current);
    },
    onContextMenu: (B) => {
      r.onContextMenu == null || r.onContextMenu.call(r, B), k.current && U(k.current);
    }
  });
});
iT.displayName = "Drawer.Content";
const tde = 250, nde = 120, aT = /* @__PURE__ */ H.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: i, snapPoints: a, activeSnapPoint: s, setActiveSnapPoint: l, dismissible: c, handleOnly: u, isOpen: d, onPress: m, onDrag: h } = wu(), v = H.useRef(null), g = H.useRef(!1);
  function x() {
    if (g.current) {
      I();
      return;
    }
    window.setTimeout(() => {
      b();
    }, nde);
  }
  function b() {
    if (i || e || g.current) {
      I();
      return;
    }
    if (I(), !a || a.length === 0) {
      c || o();
      return;
    }
    if (s === a[a.length - 1] && c) {
      o();
      return;
    }
    const R = a.findIndex((_) => _ === s);
    if (R === -1) return;
    const A = a[R + 1];
    l(A);
  }
  function C() {
    v.current = window.setTimeout(() => {
      g.current = !0;
    }, tde);
  }
  function I() {
    v.current && window.clearTimeout(v.current), g.current = !1;
  }
  return /* @__PURE__ */ H.createElement("div", {
    onClick: x,
    onPointerCancel: I,
    onPointerDown: (T) => {
      u && m(T), C();
    },
    onPointerMove: (T) => {
      u && h(T);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ H.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
aT.displayName = "Drawer.Handle";
function rde(e) {
  const t = wu(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ H.createElement(BR, {
    container: n,
    ...r
  });
}
const Nr = {
  Root: ede,
  Content: iT,
  Overlay: oT,
  Trigger: jR,
  Portal: rde,
  Handle: aT,
  Close: GR,
  Title: Zv,
  Description: Xv
};
function ode({
  shouldScaleBackground: e = !0,
  ...t
}) {
  return /* @__PURE__ */ f.jsx(
    Nr.Root,
    {
      shouldScaleBackground: e,
      ...t
    }
  );
}
ode.displayName = "Drawer";
const Lve = Nr.Trigger, ide = Nr.Portal, $ve = Nr.Close, ade = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  Nr.Handle,
  {
    ref: n,
    className: oe(
      "data-vaul-handle:mx-auto data-vaul-handle:mt-4 data-vaul-handle:h-2 data-vaul-handle:w-[100px] data-vaul-handle:rounded-full data-vaul-handle:bg-neutral-100",
      e
    ),
    ...t
  }
));
ade.displayName = Nr.Handle.displayName;
const sT = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  Nr.Overlay,
  {
    ref: n,
    className: oe("fixed inset-0 z-50 bg-black/80", e),
    ...t
  }
));
sT.displayName = Nr.Overlay.displayName;
const sde = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f.jsxs(ide, { children: [
  /* @__PURE__ */ f.jsx(sT, {}),
  /* @__PURE__ */ f.jsx(
    Nr.Content,
    {
      "data-vaul-custom-container": "true",
      ref: r,
      className: oe(
        // height or max-height can be overridden to provide a custom height for the content, the overflow of the children ensures that any content that overflows is scrollable
        "fixed inset-x-0 bottom-0 z-50 mt-24 flex max-h-dvh flex-col rounded-t-[10px] border border-neutral-200 bg-white",
        e
      ),
      ...n,
      children: /* @__PURE__ */ f.jsx("div", { className: "overflow-y-auto", children: t })
    }
  )
] }));
sde.displayName = "DrawerContent";
function lde({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: oe("mt-auto flex flex-col gap-2 p-4", e),
      ...t
    }
  );
}
lde.displayName = "DrawerFooter";
const cde = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  Nr.Title,
  {
    ref: n,
    className: oe(
      "text-lg leading-none font-semibold tracking-tight",
      e
    ),
    ...t
  }
));
cde.displayName = Nr.Title.displayName;
const ude = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  Nr.Description,
  {
    ref: n,
    className: oe("text-sm text-neutral-500", e),
    ...t
  }
));
ude.displayName = Nr.Description.displayName;
var r1 = ["Enter", " "], dde = ["ArrowDown", "PageUp", "Home"], lT = ["ArrowUp", "PageDown", "End"], fde = [...dde, ...lT], mde = {
  ltr: [...r1, "ArrowRight"],
  rtl: [...r1, "ArrowLeft"]
}, pde = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Eu = "Menu", [Uc, hde, gde] = Pv(Eu), [ns, cT] = Vo(Eu, [
  gde,
  da,
  wm
]), Iu = da(), uT = wm(), [dT, ma] = ns(Eu), [vde, Ru] = ns(Eu), fT = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: a = !0 } = e, s = Iu(t), [l, c] = S.useState(null), u = S.useRef(!1), d = tr(i), m = xm(o);
  return S.useEffect(() => {
    const h = () => {
      u.current = !0, document.addEventListener("pointerdown", v, { capture: !0, once: !0 }), document.addEventListener("pointermove", v, { capture: !0, once: !0 });
    }, v = () => u.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", v, { capture: !0 }), document.removeEventListener("pointermove", v, { capture: !0 });
    };
  }, []), /* @__PURE__ */ f.jsx(vu, { ...s, children: /* @__PURE__ */ f.jsx(
    dT,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ f.jsx(
        vde,
        {
          scope: t,
          onClose: S.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: u,
          dir: m,
          modal: a,
          children: r
        }
      )
    }
  ) });
};
fT.displayName = Eu;
var yde = "MenuAnchor", w2 = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Iu(n);
    return /* @__PURE__ */ f.jsx(yu, { ...o, ...r, ref: t });
  }
);
w2.displayName = yde;
var E2 = "MenuPortal", [bde, mT] = ns(E2, {
  forceMount: void 0
}), pT = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = ma(E2, t);
  return /* @__PURE__ */ f.jsx(bde, { scope: t, forceMount: n, children: /* @__PURE__ */ f.jsx(yo, { present: n || i.open, children: /* @__PURE__ */ f.jsx(pu, { asChild: !0, container: o, children: r }) }) });
};
pT.displayName = E2;
var Vr = "MenuContent", [Sde, I2] = ns(Vr), hT = S.forwardRef(
  (e, t) => {
    const n = mT(Vr, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = ma(Vr, e.__scopeMenu), a = Ru(Vr, e.__scopeMenu);
    return /* @__PURE__ */ f.jsx(Uc.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f.jsx(yo, { present: r || i.open, children: /* @__PURE__ */ f.jsx(Uc.Slot, { scope: e.__scopeMenu, children: a.modal ? /* @__PURE__ */ f.jsx(xde, { ...o, ref: t }) : /* @__PURE__ */ f.jsx(Cde, { ...o, ref: t }) }) }) });
  }
), xde = S.forwardRef(
  (e, t) => {
    const n = ma(Vr, e.__scopeMenu), r = S.useRef(null), o = mt(t, r);
    return S.useEffect(() => {
      const i = r.current;
      if (i) return uu(i);
    }, []), /* @__PURE__ */ f.jsx(
      R2,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: Re(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Cde = S.forwardRef((e, t) => {
  const n = ma(Vr, e.__scopeMenu);
  return /* @__PURE__ */ f.jsx(
    R2,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), R2 = S.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: m,
      onDismiss: h,
      disableOutsideScroll: v,
      ...g
    } = e, x = ma(Vr, n), b = Ru(Vr, n), C = Iu(n), I = uT(n), T = hde(n), [R, A] = S.useState(null), _ = S.useRef(null), k = mt(t, _, x.onContentChange), M = S.useRef(0), j = S.useRef(""), G = S.useRef(0), U = S.useRef(null), B = S.useRef("right"), K = S.useRef(0), ee = v ? hu : S.Fragment, Y = v ? { as: si, allowPinchZoom: !0 } : void 0, J = (re) => {
      var te, he;
      const le = j.current + re, Te = T().filter((ge) => !ge.disabled), F = document.activeElement, Z = (te = Te.find((ge) => ge.ref.current === F)) == null ? void 0 : te.textValue, se = Te.map((ge) => ge.textValue), ae = Nde(se, le, Z), ue = (he = Te.find((ge) => ge.textValue === ae)) == null ? void 0 : he.ref.current;
      (function ge(de) {
        j.current = de, window.clearTimeout(M.current), de !== "" && (M.current = window.setTimeout(() => ge(""), 1e3));
      })(le), ue && setTimeout(() => ue.focus());
    };
    S.useEffect(() => () => window.clearTimeout(M.current), []), Tm();
    const ye = S.useCallback((re) => {
      var Te, F;
      return B.current === ((Te = U.current) == null ? void 0 : Te.side) && Fde(re, (F = U.current) == null ? void 0 : F.area);
    }, []);
    return /* @__PURE__ */ f.jsx(
      Sde,
      {
        scope: n,
        searchRef: j,
        onItemEnter: S.useCallback(
          (re) => {
            ye(re) && re.preventDefault();
          },
          [ye]
        ),
        onItemLeave: S.useCallback(
          (re) => {
            var le;
            ye(re) || ((le = _.current) == null || le.focus(), A(null));
          },
          [ye]
        ),
        onTriggerLeave: S.useCallback(
          (re) => {
            ye(re) && re.preventDefault();
          },
          [ye]
        ),
        pointerGraceTimerRef: G,
        onPointerGraceIntentChange: S.useCallback((re) => {
          U.current = re;
        }, []),
        children: /* @__PURE__ */ f.jsx(ee, { ...Y, children: /* @__PURE__ */ f.jsx(
          mu,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: Re(i, (re) => {
              var le;
              re.preventDefault(), (le = _.current) == null || le.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ f.jsx(
              fu,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: d,
                onInteractOutside: m,
                onDismiss: h,
                children: /* @__PURE__ */ f.jsx(
                  wI,
                  {
                    asChild: !0,
                    ...I,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: R,
                    onCurrentTabStopIdChange: A,
                    onEntryFocus: Re(l, (re) => {
                      b.isUsingKeyboardRef.current || re.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ f.jsx(
                      Pm,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": DT(x.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...C,
                        ...g,
                        ref: k,
                        style: { outline: "none", ...g.style },
                        onKeyDown: Re(g.onKeyDown, (re) => {
                          const Te = re.target.closest("[data-radix-menu-content]") === re.currentTarget, F = re.ctrlKey || re.altKey || re.metaKey, Z = re.key.length === 1;
                          Te && (re.key === "Tab" && re.preventDefault(), !F && Z && J(re.key));
                          const se = _.current;
                          if (re.target !== se || !fde.includes(re.key)) return;
                          re.preventDefault();
                          const ue = T().filter((te) => !te.disabled).map((te) => te.ref.current);
                          lT.includes(re.key) && ue.reverse(), Dde(ue);
                        }),
                        onBlur: Re(e.onBlur, (re) => {
                          re.currentTarget.contains(re.target) || (window.clearTimeout(M.current), j.current = "");
                        }),
                        onPointerMove: Re(
                          e.onPointerMove,
                          Wc((re) => {
                            const le = re.target, Te = K.current !== re.clientX;
                            if (re.currentTarget.contains(le) && Te) {
                              const F = re.clientX > K.current ? "right" : "left";
                              B.current = F, K.current = re.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
hT.displayName = Vr;
var wde = "MenuGroup", T2 = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ f.jsx(at.div, { role: "group", ...r, ref: t });
  }
);
T2.displayName = wde;
var Ede = "MenuLabel", gT = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ f.jsx(at.div, { ...r, ref: t });
  }
);
gT.displayName = Ede;
var Af = "MenuItem", oS = "menu.itemSelect", zm = S.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = S.useRef(null), a = Ru(Af, e.__scopeMenu), s = I2(Af, e.__scopeMenu), l = mt(t, i), c = S.useRef(!1), u = () => {
      const d = i.current;
      if (!n && d) {
        const m = new CustomEvent(oS, { bubbles: !0, cancelable: !0 });
        d.addEventListener(oS, (h) => r == null ? void 0 : r(h), { once: !0 }), Dv(d, m), m.defaultPrevented ? c.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ f.jsx(
      vT,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: Re(e.onClick, u),
        onPointerDown: (d) => {
          var m;
          (m = e.onPointerDown) == null || m.call(e, d), c.current = !0;
        },
        onPointerUp: Re(e.onPointerUp, (d) => {
          var m;
          c.current || (m = d.currentTarget) == null || m.click();
        }),
        onKeyDown: Re(e.onKeyDown, (d) => {
          const m = s.searchRef.current !== "";
          n || m && d.key === " " || r1.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
zm.displayName = Af;
var vT = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, a = I2(Af, n), s = uT(n), l = S.useRef(null), c = mt(t, l), [u, d] = S.useState(!1), [m, h] = S.useState("");
    return S.useEffect(() => {
      const v = l.current;
      v && h((v.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ f.jsx(
      Uc.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? m,
        children: /* @__PURE__ */ f.jsx(EI, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ f.jsx(
          at.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: c,
            onPointerMove: Re(
              e.onPointerMove,
              Wc((v) => {
                r ? a.onItemLeave(v) : (a.onItemEnter(v), v.defaultPrevented || v.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Re(
              e.onPointerLeave,
              Wc((v) => a.onItemLeave(v))
            ),
            onFocus: Re(e.onFocus, () => d(!0)),
            onBlur: Re(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), Ide = "MenuCheckboxItem", yT = S.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ f.jsx(wT, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ f.jsx(
      zm,
      {
        role: "menuitemcheckbox",
        "aria-checked": kf(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": A2(n),
        onSelect: Re(
          o.onSelect,
          () => r == null ? void 0 : r(kf(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
yT.displayName = Ide;
var bT = "MenuRadioGroup", [Rde, Tde] = ns(
  bT,
  { value: void 0, onValueChange: () => {
  } }
), ST = S.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = tr(r);
    return /* @__PURE__ */ f.jsx(Rde, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ f.jsx(T2, { ...o, ref: t }) });
  }
);
ST.displayName = bT;
var xT = "MenuRadioItem", CT = S.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = Tde(xT, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ f.jsx(wT, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ f.jsx(
      zm,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": A2(i),
        onSelect: Re(
          r.onSelect,
          () => {
            var a;
            return (a = o.onValueChange) == null ? void 0 : a.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
CT.displayName = xT;
var _2 = "MenuItemIndicator", [wT, _de] = ns(
  _2,
  { checked: !1 }
), ET = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = _de(_2, n);
    return /* @__PURE__ */ f.jsx(
      yo,
      {
        present: r || kf(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ f.jsx(
          at.span,
          {
            ...o,
            ref: t,
            "data-state": A2(i.checked)
          }
        )
      }
    );
  }
);
ET.displayName = _2;
var Ode = "MenuSeparator", IT = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ f.jsx(
      at.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
IT.displayName = Ode;
var Ade = "MenuArrow", RT = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Iu(n);
    return /* @__PURE__ */ f.jsx(Nm, { ...o, ...r, ref: t });
  }
);
RT.displayName = Ade;
var O2 = "MenuSub", [kde, TT] = ns(O2), _T = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, i = ma(O2, t), a = Iu(t), [s, l] = S.useState(null), [c, u] = S.useState(null), d = tr(o);
  return S.useEffect(() => (i.open === !1 && d(!1), () => d(!1)), [i.open, d]), /* @__PURE__ */ f.jsx(vu, { ...a, children: /* @__PURE__ */ f.jsx(
    dT,
    {
      scope: t,
      open: r,
      onOpenChange: d,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ f.jsx(
        kde,
        {
          scope: t,
          contentId: _r(),
          triggerId: _r(),
          trigger: s,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
_T.displayName = O2;
var nc = "MenuSubTrigger", OT = S.forwardRef(
  (e, t) => {
    const n = ma(nc, e.__scopeMenu), r = Ru(nc, e.__scopeMenu), o = TT(nc, e.__scopeMenu), i = I2(nc, e.__scopeMenu), a = S.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = i, c = { __scopeMenu: e.__scopeMenu }, u = S.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return S.useEffect(() => u, [u]), S.useEffect(() => {
      const d = s.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [s, l]), /* @__PURE__ */ f.jsx(w2, { asChild: !0, ...c, children: /* @__PURE__ */ f.jsx(
      vT,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": DT(n.open),
        ...e,
        ref: Bf(t, o.onTriggerChange),
        onClick: (d) => {
          var m;
          (m = e.onClick) == null || m.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: Re(
          e.onPointerMove,
          Wc((d) => {
            i.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !a.current && (i.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: Re(
          e.onPointerLeave,
          Wc((d) => {
            var h, v;
            u();
            const m = (h = n.content) == null ? void 0 : h.getBoundingClientRect();
            if (m) {
              const g = (v = n.content) == null ? void 0 : v.dataset.side, x = g === "right", b = x ? -5 : 5, C = m[x ? "left" : "right"], I = m[x ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + b, y: d.clientY },
                  { x: C, y: m.top },
                  { x: I, y: m.top },
                  { x: I, y: m.bottom },
                  { x: C, y: m.bottom }
                ],
                side: g
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(d), d.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Re(e.onKeyDown, (d) => {
          var h;
          const m = i.searchRef.current !== "";
          e.disabled || m && d.key === " " || mde[r.dir].includes(d.key) && (n.onOpenChange(!0), (h = n.content) == null || h.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
OT.displayName = nc;
var AT = "MenuSubContent", kT = S.forwardRef(
  (e, t) => {
    const n = mT(Vr, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = ma(Vr, e.__scopeMenu), a = Ru(Vr, e.__scopeMenu), s = TT(AT, e.__scopeMenu), l = S.useRef(null), c = mt(t, l);
    return /* @__PURE__ */ f.jsx(Uc.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ f.jsx(yo, { present: r || i.open, children: /* @__PURE__ */ f.jsx(Uc.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ f.jsx(
      R2,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var d;
          a.isUsingKeyboardRef.current && ((d = l.current) == null || d.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: Re(e.onFocusOutside, (u) => {
          u.target !== s.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: Re(e.onEscapeKeyDown, (u) => {
          a.onClose(), u.preventDefault();
        }),
        onKeyDown: Re(e.onKeyDown, (u) => {
          var h;
          const d = u.currentTarget.contains(u.target), m = pde[a.dir].includes(u.key);
          d && m && (i.onOpenChange(!1), (h = s.trigger) == null || h.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
kT.displayName = AT;
function DT(e) {
  return e ? "open" : "closed";
}
function kf(e) {
  return e === "indeterminate";
}
function A2(e) {
  return kf(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Dde(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function Pde(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function Nde(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = Pde(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function Mde(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, l = t[i].y, c = t[a].x, u = t[a].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (o = !o);
  }
  return o;
}
function Fde(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return Mde(n, t);
}
function Wc(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Lde = fT, $de = w2, zde = pT, jde = hT, Bde = T2, Gde = gT, Vde = zm, Ude = yT, Wde = ST, Hde = CT, qde = ET, Yde = IT, Kde = RT, Zde = _T, Xde = OT, Jde = kT, k2 = "DropdownMenu", [Qde] = Vo(
  k2,
  [cT]
), Yn = cT(), [efe, PT] = Qde(k2), NT = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: a,
    modal: s = !0
  } = e, l = Yn(t), c = S.useRef(null), [u = !1, d] = di({
    prop: o,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ f.jsx(
    efe,
    {
      scope: t,
      triggerId: _r(),
      triggerRef: c,
      contentId: _r(),
      open: u,
      onOpenChange: d,
      onOpenToggle: S.useCallback(() => d((m) => !m), [d]),
      modal: s,
      children: /* @__PURE__ */ f.jsx(Lde, { ...l, open: u, onOpenChange: d, dir: r, modal: s, children: n })
    }
  );
};
NT.displayName = k2;
var MT = "DropdownMenuTrigger", FT = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = PT(MT, n), a = Yn(n);
    return /* @__PURE__ */ f.jsx($de, { asChild: !0, ...a, children: /* @__PURE__ */ f.jsx(
      at.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: Bf(t, i.triggerRef),
        onPointerDown: Re(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
        }),
        onKeyDown: Re(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
FT.displayName = MT;
var tfe = "DropdownMenuPortal", LT = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Yn(t);
  return /* @__PURE__ */ f.jsx(zde, { ...r, ...n });
};
LT.displayName = tfe;
var $T = "DropdownMenuContent", zT = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = PT($T, n), i = Yn(n), a = S.useRef(!1);
    return /* @__PURE__ */ f.jsx(
      jde,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: Re(e.onCloseAutoFocus, (s) => {
          var l;
          a.current || (l = o.triggerRef.current) == null || l.focus(), a.current = !1, s.preventDefault();
        }),
        onInteractOutside: Re(e.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!o.modal || u) && (a.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
zT.displayName = $T;
var nfe = "DropdownMenuGroup", jT = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
    return /* @__PURE__ */ f.jsx(Bde, { ...o, ...r, ref: t });
  }
);
jT.displayName = nfe;
var rfe = "DropdownMenuLabel", BT = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
    return /* @__PURE__ */ f.jsx(Gde, { ...o, ...r, ref: t });
  }
);
BT.displayName = rfe;
var ofe = "DropdownMenuItem", GT = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
    return /* @__PURE__ */ f.jsx(Vde, { ...o, ...r, ref: t });
  }
);
GT.displayName = ofe;
var ife = "DropdownMenuCheckboxItem", VT = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
  return /* @__PURE__ */ f.jsx(Ude, { ...o, ...r, ref: t });
});
VT.displayName = ife;
var afe = "DropdownMenuRadioGroup", UT = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
  return /* @__PURE__ */ f.jsx(Wde, { ...o, ...r, ref: t });
});
UT.displayName = afe;
var sfe = "DropdownMenuRadioItem", WT = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
  return /* @__PURE__ */ f.jsx(Hde, { ...o, ...r, ref: t });
});
WT.displayName = sfe;
var lfe = "DropdownMenuItemIndicator", HT = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
  return /* @__PURE__ */ f.jsx(qde, { ...o, ...r, ref: t });
});
HT.displayName = lfe;
var cfe = "DropdownMenuSeparator", qT = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
  return /* @__PURE__ */ f.jsx(Yde, { ...o, ...r, ref: t });
});
qT.displayName = cfe;
var ufe = "DropdownMenuArrow", dfe = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
    return /* @__PURE__ */ f.jsx(Kde, { ...o, ...r, ref: t });
  }
);
dfe.displayName = ufe;
var ffe = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: i } = e, a = Yn(t), [s = !1, l] = di({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ f.jsx(Zde, { ...a, open: s, onOpenChange: l, children: n });
}, mfe = "DropdownMenuSubTrigger", YT = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
  return /* @__PURE__ */ f.jsx(Xde, { ...o, ...r, ref: t });
});
YT.displayName = mfe;
var pfe = "DropdownMenuSubContent", KT = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Yn(n);
  return /* @__PURE__ */ f.jsx(
    Jde,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
KT.displayName = pfe;
var hfe = NT, gfe = FT, vfe = LT, ZT = zT, yfe = jT, XT = BT, JT = GT, QT = VT, bfe = UT, e_ = WT, t_ = HT, n_ = qT, Sfe = ffe, r_ = YT, o_ = KT;
const rs = hfe, os = gfe, zve = yfe, jve = Sfe, D2 = bfe, xfe = S.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ f.jsxs(
  r_,
  {
    ref: o,
    className: oe(
      "flex cursor-default items-center rounded-xs px-2 py-1.5 text-xs outline-hidden select-none focus:bg-neutral-100 data-[state=open]:bg-neutral-100",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ f.jsx(Ve, { icon: "chevronRight", className: "ml-auto" })
    ]
  }
));
xfe.displayName = r_.displayName;
const Cfe = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  o_,
  {
    ref: n,
    className: oe(
      "z-50 min-w-32 overflow-hidden rounded-md border border-neutral-200 bg-white p-1 text-neutral-950 shadow-lg",
      "origin-(--radix-dropdown-menu-content-transform-origin) data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
      e
    ),
    ...t
  }
));
Cfe.displayName = o_.displayName;
const pa = S.forwardRef(({ className: e, sideOffset: t = 4, collisionPadding: n = 4, ...r }, o) => /* @__PURE__ */ f.jsx(vfe, { children: /* @__PURE__ */ f.jsx(
  ZT,
  {
    ref: o,
    sideOffset: t,
    collisionPadding: n,
    className: oe(
      "z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-32 overflow-hidden rounded-md border border-neutral-200 bg-white p-1 text-neutral-950 shadow-md",
      "origin-(--radix-dropdown-menu-content-transform-origin) data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
      e
    ),
    ...r
  }
) }));
pa.displayName = ZT.displayName;
const Rr = S.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ f.jsx(
  JT,
  {
    ref: r,
    className: oe(
      "relative flex cursor-default items-center rounded-xs px-2 py-1.5 text-xs outline-hidden transition-colors select-none focus:bg-neutral-100 focus:text-neutral-900 data-disabled:pointer-events-none data-disabled:opacity-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Rr.displayName = JT.displayName;
const wfe = S.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ f.jsxs(
  QT,
  {
    ref: o,
    className: oe(
      "group flex cursor-default items-center gap-2 rounded-xs px-2 py-1.5 text-xs outline-hidden transition-colors select-none focus:bg-neutral-100 focus:text-neutral-900 data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ f.jsx(
        Ve,
        {
          icon: QF,
          className: "size-4 group-data-[state=checked]:hidden group-data-[state=unchecked]:block"
        }
      ),
      /* @__PURE__ */ f.jsx(t_, { children: /* @__PURE__ */ f.jsx(Ve, { icon: EL, className: "size-4" }) }),
      t
    ]
  }
));
wfe.displayName = QT.displayName;
const jm = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f.jsxs(
  e_,
  {
    ref: r,
    className: oe(
      "group flex cursor-default items-center gap-2 rounded-xs px-2 py-1.5 text-xs outline-hidden transition-colors select-none focus:bg-neutral-100 focus:text-neutral-900 data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ f.jsx(
        Ve,
        {
          icon: k3,
          className: "size-4 group-data-[state=checked]:hidden group-data-[state=unchecked]:block"
        }
      ),
      /* @__PURE__ */ f.jsx(t_, { children: /* @__PURE__ */ f.jsx(Ve, { icon: r$, className: "size-4" }) }),
      t
    ]
  }
));
jm.displayName = e_.displayName;
const i_ = S.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ f.jsx(
  XT,
  {
    ref: r,
    className: oe(
      "px-2 py-1.5 text-xs font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
i_.displayName = XT.displayName;
const a_ = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  n_,
  {
    ref: n,
    className: oe("-mx-1 my-1 h-px bg-neutral-100", e),
    ...t
  }
));
a_.displayName = n_.displayName;
function Efe({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ f.jsx(
    "span",
    {
      className: oe("ml-auto text-xs tracking-widest opacity-60", e),
      ...t
    }
  );
}
Efe.displayName = "DropdownMenuShortcut";
var Ife = "Label", s_ = S.forwardRef((e, t) => /* @__PURE__ */ f.jsx(
  at.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
s_.displayName = Ife;
var l_ = s_;
const Rfe = qr(
  "text-xs font-semibold peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), pi = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  l_,
  {
    ref: n,
    className: oe(Rfe(), e),
    ...t
  }
));
pi.displayName = l_.displayName;
const c_ = qr(
  "aspect-square shrink-0 overflow-hidden rounded-md border border-neutral-200",
  {
    variants: {
      size: {
        sm: "size-10",
        md: "size-14"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), o1 = ({
  icon: e,
  label: t,
  size: n
}) => /* @__PURE__ */ f.jsx(
  "span",
  {
    ...t ? { role: "img", "aria-label": t } : { "aria-hidden": !0 },
    className: oe(
      c_({ size: n }),
      "flex items-center justify-center bg-neutral-50 text-neutral-400"
    ),
    children: /* @__PURE__ */ f.jsx(Ve, { icon: e, className: "size-1/2" })
  }
), Tfe = ({
  src: e,
  alt: t,
  size: n
}) => {
  const [r, o] = Fe(!1), [i, a] = Fe(!1), [s, l] = Fe(!1);
  return i ? /* @__PURE__ */ f.jsx(
    o1,
    {
      icon: "imageBroken",
      label: `${t} (failed to load)`,
      size: n
    }
  ) : /* @__PURE__ */ f.jsxs(Jv, { modal: !0, open: r, onOpenChange: o, children: [
    /* @__PURE__ */ f.jsxs(
      yse,
      {
        "aria-busy": !s,
        className: oe(
          c_({ size: n }),
          "block cursor-zoom-in focus-visible:ring-2 focus-visible:ring-corso-blue-600 focus-visible:outline-none",
          !s && "bg-neutral-100 motion-safe:animate-pulse"
        ),
        children: [
          /* @__PURE__ */ f.jsx(
            "img",
            {
              src: GG(e),
              alt: t,
              loading: "lazy",
              className: oe(
                "size-full object-contain object-center transition-opacity",
                !s && "opacity-0"
              ),
              onLoad: () => l(!0),
              onError: () => a(!0)
            }
          ),
          /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "View full size" })
        ]
      }
    ),
    /* @__PURE__ */ f.jsxs(
      Om,
      {
        "aria-describedby": void 0,
        className: "h-dvh max-h-none w-dvw max-w-none rounded-none border-none bg-black p-4 shadow-none",
        children: [
          /* @__PURE__ */ f.jsx(Qv, { className: "sr-only", children: t }),
          /* @__PURE__ */ f.jsx(
            "img",
            {
              src: e,
              alt: t,
              className: "size-full min-h-0 object-contain object-center"
            }
          )
        ]
      }
    )
  ] });
}, _fe = ({
  alt: e,
  size: t,
  ...n
}) => n.icon ? /* @__PURE__ */ f.jsx(o1, { icon: n.icon, size: t }) : n.src ? /* @__PURE__ */ f.jsx(Tfe, { src: n.src, alt: e, size: t }, n.src) : /* @__PURE__ */ f.jsx(o1, { icon: "image", size: t }), Ofe = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  Fv,
  {
    className: oe("grid gap-2", e),
    ...t,
    ref: n
  }
));
Ofe.displayName = Fv.displayName;
const Afe = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  Lv,
  {
    ref: n,
    className: oe(
      "aspect-square h-4 w-4 rounded-full border border-neutral-900 text-neutral-900 ring-offset-white focus:outline-hidden focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f.jsx(Ioe, { className: "flex items-center justify-center", children: /* @__PURE__ */ f.jsx(Ve, { icon: D3, className: "size-2.5 text-current" }) })
  }
));
Afe.displayName = Lv.displayName;
const kfe = It(({ dateTime: e, full: t = !1, ...n }, r) => {
  const o = new Date(e);
  return /* @__PURE__ */ f.jsx(
    "time",
    {
      dateTime: Qd(o) ? "Invalid Date" : o.toISOString(),
      "data-invalid-date": Qd(o),
      "aria-invalid": !0,
      ref: r,
      ...n,
      children: AC(o, t)
    }
  );
});
kfe.displayName = "RelativeDateTime";
var Dfe = Object.defineProperty, Rl = (e, t) => Dfe(e, "name", { value: t, configurable: !0 }), u_ = !!(typeof window < "u" && window.document && window.document.createElement);
function Fo(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return /* @__PURE__ */ Rl(function(o) {
    if (e == null || e(o), n === !1 || !o || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  }, "handleEvent");
}
Rl(Fo, "composeEventHandlers");
function Pfe(e) {
  var t;
  if (!u_)
    throw new Error("Cannot access window outside of the DOM");
  return ((t = e == null ? void 0 : e.ownerDocument) == null ? void 0 : t.defaultView) ?? window;
}
Rl(Pfe, "getOwnerWindow");
function i1(e) {
  if (!u_)
    throw new Error("Cannot access document outside of the DOM");
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
Rl(i1, "getOwnerDocument");
function d_(e, t = !1) {
  const { activeElement: n } = i1(e);
  if (!(n != null && n.nodeName))
    return null;
  if (f_(n) && n.contentDocument)
    return d_(n.contentDocument.body, t);
  if (t) {
    const r = n.getAttribute("aria-activedescendant");
    if (r) {
      const o = i1(n).getElementById(r);
      if (o)
        return o;
    }
  }
  return n;
}
Rl(d_, "getActiveElement");
function f_(e) {
  return e.tagName === "IFRAME";
}
Rl(f_, "isFrame");
var Nfe = Object.defineProperty, Gr = (e, t) => Nfe(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function Mfe(e, t) {
  const n = S.createContext(t);
  n.displayName = e + "Context";
  const r = /* @__PURE__ */ Gr((i) => {
    const { children: a, ...s } = i, l = S.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ f.jsx(n.Provider, { value: l, children: a });
  }, "Provider");
  r.displayName = e + "Provider";
  function o(i, a = {}) {
    const { optional: s = !1 } = a, l = S.useContext(n);
    if (l) return l;
    if (t !== void 0) return t;
    if (!s)
      throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return Gr(o, "useContext"), [r, o];
}
Gr(Mfe, "createContext");
// @__NO_SIDE_EFFECTS__
function Tu(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = S.createContext(a);
    s.displayName = i + "Context";
    const l = n.length;
    n = [...n, a];
    const c = /* @__PURE__ */ Gr((d) => {
      var b;
      const { scope: m, children: h, ...v } = d, g = ((b = m == null ? void 0 : m[e]) == null ? void 0 : b[l]) || s, x = S.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ f.jsx(g.Provider, { value: x, children: h });
    }, "Provider");
    c.displayName = i + "Provider";
    function u(d, m, h = {}) {
      var b;
      const { optional: v = !1 } = h, g = ((b = m == null ? void 0 : m[e]) == null ? void 0 : b[l]) || s, x = S.useContext(g);
      if (x) return x;
      if (a !== void 0) return a;
      if (!v)
        throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return Gr(u, "useContext"), [c, u];
  }
  Gr(r, "createContext");
  const o = /* @__PURE__ */ Gr(() => {
    const i = n.map((a) => S.createContext(a));
    return /* @__PURE__ */ Gr(function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return S.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    }, "useScope");
  }, "createScope");
  return o.scopeName = e, [r, m_(o, ...t)];
}
Gr(Tu, "createContextScope");
function m_(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = /* @__PURE__ */ Gr(() => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return /* @__PURE__ */ Gr(function(i) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return S.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    }, "useComposedScopes");
  }, "createScope");
  return n.scopeName = t.scopeName, n;
}
Gr(m_, "composeContextScopes");
var Ffe = Object.defineProperty, P2 = (e, t) => Ffe(e, "name", { value: t, configurable: !0 });
function a1(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
P2(a1, "setRef");
function p_(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = a1(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : a1(e[o], null);
        }
      };
  };
}
P2(p_, "composeRefs");
function Vi(...e) {
  return S.useCallback(p_(...e), e);
}
P2(Vi, "useComposedRefs");
var Lfe = Object.defineProperty, So = (e, t) => Lfe(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function rl(e) {
  const t = S.forwardRef((n, r) => {
    let { children: o, ...i } = n, a = null, s = !1;
    const l = [];
    s1(o) && typeof pd == "function" && (o = pd(o._payload)), S.Children.forEach(o, (m) => {
      var h;
      if (y_(m)) {
        s = !0;
        const v = m;
        let g = "child" in v.props ? v.props.child : v.props.children;
        s1(g) && typeof pd == "function" && (g = pd(g._payload)), a = zfe(v, g), l.push((h = a == null ? void 0 : a.props) == null ? void 0 : h.children);
      } else
        l.push(m);
    }), a ? a = S.cloneElement(a, void 0, l) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !s && S.Children.count(o) === 1 && S.isValidElement(o) && (a = o)
    );
    const c = a ? v_(a) : void 0, u = Vi(r, c);
    if (!a) {
      if (o || o === 0)
        throw new Error(
          s ? Gfe(e) : Bfe(e)
        );
      return o;
    }
    const d = g_(i, a.props ?? {});
    return a.type !== S.Fragment && (d.ref = r ? u : c), S.cloneElement(a, d);
  });
  return t.displayName = `${e}.Slot`, t;
}
So(rl, "createSlot");
var h_ = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $fe(e) {
  const t = /* @__PURE__ */ So((n) => "child" in n ? n.children(n.child) : n.children, "Slottable");
  return t.displayName = `${e}.Slottable`, t.__radixId = h_, t;
}
So($fe, "createSlottable");
var zfe = /* @__PURE__ */ So((e, t) => {
  if ("child" in e.props) {
    const n = e.props.child;
    return S.isValidElement(n) ? S.cloneElement(n, void 0, e.props.children(n.props.children)) : null;
  }
  return S.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function g_(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...s) => {
      const l = i(...s);
      return o(...s), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
So(g_, "mergeProps");
function v_(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
So(v_, "getElementRef");
function y_(e) {
  return S.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === h_;
}
So(y_, "isSlottable");
var jfe = Symbol.for("react.lazy");
function s1(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === jfe && "_payload" in e && b_(e._payload);
}
So(s1, "isLazyComponent");
function b_(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
So(b_, "isPromiseLike");
var Bfe = /* @__PURE__ */ So((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), Gfe = /* @__PURE__ */ So((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), pd = S[" use ".trim().toString()], Vfe = Object.defineProperty, _n = (e, t) => Vfe(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function S_(e) {
  const t = e + "CollectionProvider", [n, r] = /* @__PURE__ */ Tu(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = /* @__PURE__ */ _n((g) => {
    const { scope: x, children: b } = g, C = S.useRef(null), I = S.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ f.jsx(o, { scope: x, itemMap: I, collectionRef: C, children: b });
  }, "CollectionProvider");
  a.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ rl(s), c = S.forwardRef(
    (g, x) => {
      const { scope: b, children: C } = g, I = i(s, b), T = Vi(x, I.collectionRef);
      return /* @__PURE__ */ f.jsx(l, { ref: T, children: C });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", m = /* @__PURE__ */ rl(u), h = S.forwardRef(
    (g, x) => {
      const { scope: b, children: C, ...I } = g, T = S.useRef(null), R = Vi(x, T), A = i(u, b);
      return S.useEffect(() => (A.itemMap.set(T, { ref: T, ...I }), () => void A.itemMap.delete(T))), /* @__PURE__ */ f.jsx(m, { [d]: "", ref: R, children: C });
    }
  );
  h.displayName = u;
  function v(g) {
    const x = i(e + "CollectionConsumer", g);
    return S.useCallback(() => {
      const C = x.collectionRef.current;
      if (!C) return [];
      const I = Array.from(C.querySelectorAll(`[${d}]`));
      return Array.from(x.itemMap.values()).sort(
        (A, _) => I.indexOf(A.ref.current) - I.indexOf(_.ref.current)
      );
    }, [x.collectionRef, x.itemMap]);
  }
  return _n(v, "useCollection"), [
    { Provider: a, Slot: c, ItemSlot: h },
    v,
    r
  ];
}
_n(S_, "createCollection");
var iS = /* @__PURE__ */ new WeakMap(), pn, br, lh = (br = class extends Map {
  constructor(n) {
    super(n);
    Iy(this, pn);
    lp(this, pn, [...super.keys()]), iS.set(this, !0);
  }
  set(n, r) {
    return iS.get(this) && (this.has(n) ? zn(this, pn)[zn(this, pn).indexOf(n)] = n : zn(this, pn).push(n)), super.set(n, r), this;
  }
  insert(n, r, o) {
    const i = this.has(r), a = zn(this, pn).length, s = N2(n);
    let l = s >= 0 ? s : a + s;
    const c = l < 0 || l >= a ? -1 : l;
    if (c === this.size || i && c === this.size - 1 || c === -1)
      return this.set(r, o), this;
    const u = this.size + (i ? 0 : 1);
    s < 0 && l++;
    const d = [...zn(this, pn)];
    let m, h = !1;
    for (let v = l; v < u; v++)
      if (l === v) {
        let g = d[v];
        d[v] === r && (g = d[v + 1]), i && this.delete(r), m = this.get(g), this.set(r, o);
      } else {
        !h && d[v - 1] === r && (h = !0);
        const g = d[h ? v : v - 1], x = m;
        m = this.get(g), this.delete(g), this.set(g, x);
      }
    return this;
  }
  with(n, r, o) {
    const i = new br(this);
    return i.insert(n, r, o), i;
  }
  before(n) {
    const r = zn(this, pn).indexOf(n) - 1;
    if (!(r < 0))
      return this.entryAt(r);
  }
  /**
   * Sets a new key-value pair at the position before the given key.
   */
  setBefore(n, r, o) {
    const i = zn(this, pn).indexOf(n);
    return i === -1 ? this : this.insert(i, r, o);
  }
  after(n) {
    let r = zn(this, pn).indexOf(n);
    if (r = r === -1 || r === this.size - 1 ? -1 : r + 1, r !== -1)
      return this.entryAt(r);
  }
  /**
   * Sets a new key-value pair at the position after the given key.
   */
  setAfter(n, r, o) {
    const i = zn(this, pn).indexOf(n);
    return i === -1 ? this : this.insert(i + 1, r, o);
  }
  first() {
    return this.entryAt(0);
  }
  last() {
    return this.entryAt(-1);
  }
  clear() {
    return lp(this, pn, []), super.clear();
  }
  delete(n) {
    const r = super.delete(n);
    return r && zn(this, pn).splice(zn(this, pn).indexOf(n), 1), r;
  }
  deleteAt(n) {
    const r = this.keyAt(n);
    return r !== void 0 ? this.delete(r) : !1;
  }
  at(n) {
    const r = Ud(zn(this, pn), n);
    if (r !== void 0)
      return this.get(r);
  }
  entryAt(n) {
    const r = Ud(zn(this, pn), n);
    if (r !== void 0)
      return [r, this.get(r)];
  }
  indexOf(n) {
    return zn(this, pn).indexOf(n);
  }
  keyAt(n) {
    return Ud(zn(this, pn), n);
  }
  from(n, r) {
    const o = this.indexOf(n);
    if (o === -1)
      return;
    let i = o + r;
    return i < 0 && (i = 0), i >= this.size && (i = this.size - 1), this.at(i);
  }
  keyFrom(n, r) {
    const o = this.indexOf(n);
    if (o === -1)
      return;
    let i = o + r;
    return i < 0 && (i = 0), i >= this.size && (i = this.size - 1), this.keyAt(i);
  }
  find(n, r) {
    let o = 0;
    for (const i of this) {
      if (Reflect.apply(n, r, [i, o, this]))
        return i;
      o++;
    }
  }
  findIndex(n, r) {
    let o = 0;
    for (const i of this) {
      if (Reflect.apply(n, r, [i, o, this]))
        return o;
      o++;
    }
    return -1;
  }
  filter(n, r) {
    const o = [];
    let i = 0;
    for (const a of this)
      Reflect.apply(n, r, [a, i, this]) && o.push(a), i++;
    return new br(o);
  }
  map(n, r) {
    const o = [];
    let i = 0;
    for (const a of this)
      o.push([a[0], Reflect.apply(n, r, [a, i, this])]), i++;
    return new br(o);
  }
  reduce(...n) {
    const [r, o] = n;
    let i = 0, a = o ?? this.at(0);
    for (const s of this)
      i === 0 && n.length === 1 ? a = s : a = Reflect.apply(r, this, [a, s, i, this]), i++;
    return a;
  }
  reduceRight(...n) {
    const [r, o] = n;
    let i = o ?? this.at(-1);
    for (let a = this.size - 1; a >= 0; a--) {
      const s = this.at(a);
      a === this.size - 1 && n.length === 1 ? i = s : i = Reflect.apply(r, this, [i, s, a, this]);
    }
    return i;
  }
  toSorted(n) {
    const r = [...this.entries()].sort(n);
    return new br(r);
  }
  toReversed() {
    const n = new br();
    for (let r = this.size - 1; r >= 0; r--) {
      const o = this.keyAt(r), i = this.get(o);
      n.set(o, i);
    }
    return n;
  }
  toSpliced(...n) {
    const r = [...this.entries()];
    return r.splice(...n), new br(r);
  }
  slice(n, r) {
    const o = new br();
    let i = this.size - 1;
    if (n === void 0)
      return o;
    n < 0 && (n = n + this.size), r !== void 0 && r > 0 && (i = r - 1);
    for (let a = n; a <= i; a++) {
      const s = this.keyAt(a), l = this.get(s);
      o.set(s, l);
    }
    return o;
  }
  every(n, r) {
    let o = 0;
    for (const i of this) {
      if (!Reflect.apply(n, r, [i, o, this]))
        return !1;
      o++;
    }
    return !0;
  }
  some(n, r) {
    let o = 0;
    for (const i of this) {
      if (Reflect.apply(n, r, [i, o, this]))
        return !0;
      o++;
    }
    return !1;
  }
}, pn = new WeakMap(), _n(br, "OrderedDict"), br);
function Ud(e, t) {
  if ("at" in Array.prototype)
    return Array.prototype.at.call(e, t);
  const n = x_(e, t);
  return n === -1 ? void 0 : e[n];
}
_n(Ud, "at");
function x_(e, t) {
  const n = e.length, r = N2(t), o = r >= 0 ? r : n + r;
  return o < 0 || o >= n ? -1 : o;
}
_n(x_, "toSafeIndex");
function N2(e) {
  return e !== e || e === 0 ? 0 : Math.trunc(e);
}
_n(N2, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function Ufe(e) {
  const t = e + "CollectionProvider", [n, r] = /* @__PURE__ */ Tu(t), [o, i] = n(
    t,
    {
      collectionElement: null,
      collectionRef: { current: null },
      collectionRefObject: { current: null },
      itemMap: new lh(),
      setItemMap: /* @__PURE__ */ _n(() => {
      }, "setItemMap")
    }
  ), a = /* @__PURE__ */ _n(({ state: I, ...T }) => I ? /* @__PURE__ */ f.jsx(l, { ...T, state: I }) : /* @__PURE__ */ f.jsx(s, { ...T }), "CollectionProvider");
  a.displayName = t;
  const s = /* @__PURE__ */ _n((I) => {
    const T = x();
    return /* @__PURE__ */ f.jsx(l, { ...I, state: T });
  }, "CollectionInit");
  s.displayName = t + "Init";
  const l = /* @__PURE__ */ _n((I) => {
    const { scope: T, children: R, state: A } = I, _ = S.useRef(null), [k, M] = S.useState(
      null
    ), j = Vi(_, M), [G, U] = A;
    return S.useEffect(() => {
      if (!k) return;
      const B = E_(() => {
      });
      return B.observe(k, {
        childList: !0,
        subtree: !0
      }), () => {
        B.disconnect();
      };
    }, [k]), /* @__PURE__ */ f.jsx(
      o,
      {
        scope: T,
        itemMap: G,
        setItemMap: U,
        collectionRef: j,
        collectionRefObject: _,
        collectionElement: k,
        children: R
      }
    );
  }, "CollectionProviderImpl");
  l.displayName = t + "Impl";
  const c = e + "CollectionSlot", u = /* @__PURE__ */ rl(c), d = S.forwardRef(
    (I, T) => {
      const { scope: R, children: A } = I, _ = i(c, R), k = Vi(T, _.collectionRef);
      return /* @__PURE__ */ f.jsx(u, { ref: k, children: A });
    }
  );
  d.displayName = c;
  const m = e + "CollectionItemSlot", h = "data-radix-collection-item", v = /* @__PURE__ */ rl(m), g = S.forwardRef(
    (I, T) => {
      const { scope: R, children: A, ..._ } = I, k = S.useRef(null), [M, j] = S.useState(null), G = Vi(T, k, j), U = i(m, R), { setItemMap: B } = U, K = S.useRef(_);
      C_(K.current, _) || (K.current = _);
      const ee = K.current;
      return S.useEffect(() => {
        const Y = ee;
        return B((J) => M ? J.has(M) ? J.set(M, { ...Y, element: M }).toSorted(l1) : (J.set(M, { ...Y, element: M }), J.toSorted(l1)) : J), () => {
          B((J) => !M || !J.has(M) ? J : (J.delete(M), new lh(J)));
        };
      }, [M, ee, B]), /* @__PURE__ */ f.jsx(v, { [h]: "", ref: G, children: A });
    }
  );
  g.displayName = m;
  function x() {
    return S.useState(new lh());
  }
  _n(x, "useInitCollection");
  function b(I) {
    const { itemMap: T } = i(e + "CollectionConsumer", I);
    return T;
  }
  return _n(b, "useCollection"), [
    { Provider: a, Slot: d, ItemSlot: g },
    {
      createCollectionScope: r,
      useCollection: b,
      useInitCollection: x
    }
  ];
}
_n(Ufe, "createCollection");
function C_(e, t) {
  if (e === t) return !0;
  if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (const o of n)
    if (!Object.prototype.hasOwnProperty.call(t, o) || e[o] !== t[o]) return !1;
  return !0;
}
_n(C_, "shallowEqual");
function w_(e, t) {
  return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
_n(w_, "isElementPreceding");
function l1(e, t) {
  return !e[1].element || !t[1].element ? 0 : w_(e[1].element, t[1].element) ? -1 : 1;
}
_n(l1, "sortByDocumentPosition");
function E_(e) {
  return new MutationObserver((n) => {
    for (const r of n)
      if (r.type === "childList") {
        e();
        return;
      }
  });
}
_n(E_, "getChildListObserver");
var ol = globalThis != null && globalThis.document ? S.useLayoutEffect : () => {
}, Wfe = Object.defineProperty, Hfe = (e, t) => Wfe(e, "name", { value: t, configurable: !0 }), qfe = S[" useId ".trim().toString()] || (() => {
}), Yfe = 0;
function M2(e) {
  const [t, n] = S.useState(qfe());
  return ol(() => {
    e || n((r) => r ?? String(Yfe++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
Hfe(M2, "useId");
var Kfe = Object.defineProperty, Zfe = (e, t) => Kfe(e, "name", { value: t, configurable: !0 }), Xfe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Tl = Xfe.reduce((e, t) => {
  const n = /* @__PURE__ */ rl(`Primitive.${t}`), r = S.forwardRef((o, i) => {
    const { asChild: a, ...s } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f.jsx(l, { ...s, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Jfe(e, t) {
  e && cl.flushSync(() => e.dispatchEvent(t));
}
Zfe(Jfe, "dispatchDiscreteCustomEvent");
var Qfe = Object.defineProperty, eme = (e, t) => Qfe(e, "name", { value: t, configurable: !0 });
function I_(e) {
  const t = S.useRef(e);
  return S.useEffect(() => {
    t.current = e;
  }), S.useMemo(() => ((...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }), []);
}
eme(I_, "useCallbackRef");
var tme = Object.defineProperty, nme = (e, t) => tme(e, "name", { value: t, configurable: !0 }), aS = S[" useEffectEvent ".trim().toString()], sS = S[" useInsertionEffect ".trim().toString()];
function R_(e) {
  if (typeof aS == "function")
    return aS(e);
  const t = S.useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return typeof sS == "function" ? sS(() => {
    t.current = e;
  }) : ol(() => {
    t.current = e;
  }), S.useMemo(() => ((...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }), []);
}
nme(R_, "useEffectEvent");
var rme = Object.defineProperty, _u = (e, t) => rme(e, "name", { value: t, configurable: !0 }), ome = S[" useInsertionEffect ".trim().toString()] || ol;
function F2({
  prop: e,
  defaultProp: t,
  onChange: n = /* @__PURE__ */ _u(() => {
  }, "onChange"),
  caller: r
}) {
  const [o, i, a] = T_({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : o, c = S.useCallback(
    (u) => {
      var d;
      if (s) {
        const m = __(u) ? u(e) : u;
        m !== e && ((d = a.current) == null || d.call(a, m));
      } else
        i(u);
    },
    [s, e, i, a]
  );
  return [l, c];
}
_u(F2, "useControllableState");
function T_({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = S.useState(e), o = S.useRef(n), i = S.useRef(t);
  return ome(() => {
    i.current = t;
  }, [t]), S.useEffect(() => {
    var a;
    o.current !== n && ((a = i.current) == null || a.call(i, n), o.current = n);
  }, [n, o]), [n, r, i];
}
_u(T_, "useUncontrolledState");
function __(e) {
  return typeof e == "function";
}
_u(__, "isFunction");
var lS = Symbol("RADIX:SYNC_STATE");
function ime(e, t, n, r) {
  const { prop: o, defaultProp: i, onChange: a, caller: s } = t, l = o !== void 0, c = R_(a), u = [{ ...n, state: i }];
  r && u.push(r);
  const [d, m] = S.useReducer(
    (x, b) => {
      if (b.type === lS)
        return { ...x, state: b.state };
      const C = e(x, b);
      return l && !Object.is(C.state, x.state) && c(C.state), C;
    },
    ...u
  ), h = d.state, v = S.useRef(h);
  S.useEffect(() => {
    v.current !== h && (v.current = h, l || c(h));
  }, [h, v, l]);
  const g = S.useMemo(() => o !== void 0 ? { ...d, state: o } : d, [d, o]);
  return S.useEffect(() => {
    l && !Object.is(o, d.state) && m({ type: lS, state: o });
  }, [o, d.state, l]), [g, m];
}
_u(ime, "useControllableStateReducer");
var ame = Object.defineProperty, sme = (e, t) => ame(e, "name", { value: t, configurable: !0 }), lme = S.createContext(void 0);
function L2(e) {
  const t = S.useContext(lme);
  return e || t || "ltr";
}
sme(L2, "useDirection");
var cme = Object.defineProperty, $2 = (e, t) => cme(e, "name", { value: t, configurable: !0 }), ch = !1;
function O_() {
  const [e, t] = S.useState(ch);
  return S.useEffect(() => {
    ch || (ch = !0, t(!0));
  }, []), e;
}
$2(O_, "useIsHydrated");
var A_ = S[" useSyncExternalStore ".trim().toString()];
function k_() {
  return () => {
  };
}
$2(k_, "subscribe");
function D_() {
  return A_(
    k_,
    () => !0,
    () => !1
  );
}
$2(D_, "useIsHydratedModern");
var ume = typeof A_ == "function" ? D_ : O_, dme = Object.defineProperty, is = (e, t) => dme(e, "name", { value: t, configurable: !0 }), uh = "rovingFocusGroup.onEntryFocus", fme = { bubbles: !1, cancelable: !0 }, Bm = "RovingFocusGroup", [c1, P_, mme] = /* @__PURE__ */ S_(Bm), [pme, N_] = /* @__PURE__ */ Tu(
  Bm,
  [mme]
), [hme, gme] = pme(Bm), vme = /* @__PURE__ */ S.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ is(function(t, n) {
    return /* @__PURE__ */ f.jsx(c1.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ f.jsx(c1.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ f.jsx(yme, { ...t, ref: n }) }) });
  }, "RovingFocusGroup")
), yme = /* @__PURE__ */ S.forwardRef(/* @__PURE__ */ is(function(t, n) {
  const {
    __scopeRovingFocusGroup: r,
    orientation: o,
    loop: i = !1,
    dir: a,
    currentTabStopId: s,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: c,
    onEntryFocus: u,
    preventScrollOnEntryFocus: d = !1,
    ...m
  } = t, h = S.useRef(null), v = Vi(n, h), g = L2(a), [x, b] = F2({
    prop: s,
    defaultProp: l ?? null,
    onChange: c,
    caller: Bm
  }), [C, I] = S.useState(!1), T = I_(u), R = P_(r), A = S.useRef(!1), [_, k] = S.useState(0);
  return S.useEffect(() => {
    const M = h.current;
    if (M)
      return M.addEventListener(uh, T), () => M.removeEventListener(uh, T);
  }, [T]), /* @__PURE__ */ f.jsx(
    hme,
    {
      scope: r,
      orientation: o,
      dir: g,
      loop: i,
      currentTabStopId: x,
      onItemFocus: S.useCallback(
        (M) => b(M),
        [b]
      ),
      onItemShiftTab: S.useCallback(() => I(!0), []),
      onFocusableItemAdd: S.useCallback(
        () => k((M) => M + 1),
        []
      ),
      onFocusableItemRemove: S.useCallback(
        () => k((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ f.jsx(
        Tl.div,
        {
          tabIndex: C || _ === 0 ? -1 : 0,
          "data-orientation": o,
          ...m,
          ref: v,
          style: { outline: "none", ...t.style },
          onMouseDown: Fo(t.onMouseDown, () => {
            A.current = !0;
          }),
          onFocus: Fo(t.onFocus, (M) => {
            const j = !A.current;
            if (M.target === M.currentTarget && j && !C) {
              const G = new CustomEvent(uh, fme);
              if (M.currentTarget.dispatchEvent(G), !G.defaultPrevented) {
                const U = R().filter((J) => J.focusable), B = U.find((J) => J.active), K = U.find((J) => J.id === x), Y = [B, K, ...U].filter(
                  Boolean
                ).map((J) => J.ref.current);
                z2(Y, d);
              }
            }
            A.current = !1;
          }),
          onBlur: Fo(t.onBlur, () => I(!1))
        }
      )
    }
  );
}, "RovingFocusGroupImpl")), bme = "RovingFocusGroupItem", Sme = /* @__PURE__ */ S.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ is(function(t, n) {
    const {
      __scopeRovingFocusGroup: r,
      focusable: o = !0,
      active: i = !1,
      tabStopId: a,
      children: s,
      ...l
    } = t, c = M2(), u = a || c, d = gme(bme, r), m = d.currentTabStopId === u, h = P_(r), { onFocusableItemAdd: v, onFocusableItemRemove: g, currentTabStopId: x } = d, b = ume();
    return ol(() => {
      if (!(!b || !o))
        return v(), () => g();
    }, [b, o, v, g]), S.useEffect(() => {
      if (!(b || !o))
        return v(), () => g();
    }, [b, o, v, g]), /* @__PURE__ */ f.jsx(
      c1.ItemSlot,
      {
        scope: r,
        id: u,
        focusable: o,
        active: i,
        children: /* @__PURE__ */ f.jsx(
          Tl.span,
          {
            tabIndex: m ? 0 : -1,
            "data-orientation": d.orientation,
            ...l,
            ref: n,
            onMouseDown: Fo(t.onMouseDown, (C) => {
              o ? d.onItemFocus(u) : C.preventDefault();
            }),
            onFocus: Fo(t.onFocus, () => d.onItemFocus(u)),
            onKeyDown: Fo(t.onKeyDown, (C) => {
              if (C.key === "Tab" && C.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (C.target !== C.currentTarget) return;
              const I = F_(C, d.orientation, d.dir);
              if (I !== void 0) {
                if (C.metaKey || C.ctrlKey || C.altKey || C.shiftKey) return;
                C.preventDefault();
                let R = h().filter((A) => A.focusable).map((A) => A.ref.current);
                if (I === "last") R.reverse();
                else if (I === "prev" || I === "next") {
                  I === "prev" && R.reverse();
                  const A = R.indexOf(C.currentTarget);
                  R = d.loop ? L_(R, A + 1) : R.slice(A + 1);
                }
                setTimeout(() => z2(R));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: m, hasTabStop: x != null }) : s
          }
        )
      }
    );
  }, "RovingFocusGroupItem")
), xme = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function M_(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
is(M_, "getDirectionAwareKey");
function F_(e, t, n) {
  const r = M_(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return xme[r];
}
is(F_, "getFocusIntent");
function z2(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
is(z2, "focusFirst");
function L_(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
is(L_, "wrapArray");
var Cme = vme, wme = Sme, Eme = Object.defineProperty, hi = (e, t) => Eme(e, "name", { value: t, configurable: !0 });
function $_(e, t) {
  return S.useReducer((n, r) => t[n][r] ?? n, e);
}
hi($_, "useStateMachine");
var Ime = /* @__PURE__ */ hi((e) => {
  const { present: t, children: n } = e, r = z_(t), o = typeof n == "function" ? n({ present: r.isPresent }) : S.Children.only(n), i = j_(r.ref, B_(o));
  return typeof n == "function" || r.isPresent ? S.cloneElement(o, { ref: i }) : null;
}, "Presence");
function z_(e) {
  const [t, n] = S.useState(), r = S.useRef(null), o = S.useRef(e), i = S.useRef("none"), a = S.useRef(void 0), s = e ? "mounted" : "unmounted", [l, c] = $_(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return S.useEffect(() => {
    l === "mounted" ? (i.current = a.current ?? Os(r.current), a.current = void 0) : i.current = "none";
  }, [l]), ol(() => {
    const u = r.current, d = o.current;
    if (d !== e) {
      const h = i.current, v = Os(u);
      e ? (a.current = v, c("MOUNT")) : v === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && h !== v ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), ol(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, m = /* @__PURE__ */ hi((v) => {
        const x = Os(r.current).includes(CSS.escape(v.animationName));
        if (v.target === t && x && (c("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, "handleAnimationEnd"), h = /* @__PURE__ */ hi((v) => {
        v.target === t && (i.current = Os(r.current));
      }, "handleAnimationStart");
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: S.useCallback((u) => {
      if (u) {
        const d = getComputedStyle(u);
        r.current = d, a.current = Os(d);
      } else
        r.current = null;
      n(u);
    }, [])
  };
}
hi(z_, "usePresence");
function u1(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
hi(u1, "setRef");
function j_(...e) {
  const t = S.useRef(e);
  return t.current = e, S.useCallback((n) => {
    const r = t.current;
    let o = !1;
    const i = r.map((a) => {
      const s = u1(a, n);
      return !o && typeof s == "function" && (o = !0), s;
    });
    if (o)
      return () => {
        for (let a = 0; a < i.length; a++) {
          const s = i[a];
          typeof s == "function" ? s() : u1(r[a], null);
        }
      };
  }, []);
}
hi(j_, "useStableComposedRefs");
function Os(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
hi(Os, "getAnimationName");
function B_(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
hi(B_, "getElementRef");
var Rme = Object.defineProperty, _l = (e, t) => Rme(e, "name", { value: t, configurable: !0 }), j2 = "Tabs", [Tme, Bve] = /* @__PURE__ */ Tu(j2, [
  N_
]), G_ = N_(), [_me, B2] = Tme(j2), Ome = /* @__PURE__ */ S.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ _l(function(t, n) {
    const {
      __scopeTabs: r,
      value: o,
      onValueChange: i,
      defaultValue: a,
      orientation: s = "horizontal",
      dir: l,
      activationMode: c = "automatic",
      ...u
    } = t, d = L2(l), [m, h] = F2({
      prop: o,
      onChange: i,
      defaultProp: a ?? "",
      caller: j2
    });
    return /* @__PURE__ */ f.jsx(
      _me,
      {
        scope: r,
        baseId: M2(),
        value: m,
        onValueChange: h,
        orientation: s,
        dir: d,
        activationMode: c,
        children: /* @__PURE__ */ f.jsx(
          Tl.div,
          {
            dir: d,
            "data-orientation": s,
            ...u,
            ref: n
          }
        )
      }
    );
  }, "Tabs")
), Ame = "TabsList", kme = /* @__PURE__ */ S.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ _l(function(t, n) {
    const { __scopeTabs: r, loop: o = !0, ...i } = t, a = B2(Ame, r), s = G_(r);
    return /* @__PURE__ */ f.jsx(
      Cme,
      {
        asChild: !0,
        ...s,
        orientation: a.orientation,
        dir: a.dir,
        loop: o,
        children: /* @__PURE__ */ f.jsx(
          Tl.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...i,
            ref: n
          }
        )
      }
    );
  }, "TabsList")
), Dme = "TabsTrigger", Pme = /* @__PURE__ */ S.forwardRef(
  /* @__PURE__ */ _l(function(t, n) {
    const { __scopeTabs: r, value: o, disabled: i = !1, ...a } = t, s = B2(Dme, r), l = G_(r), c = G2(s.baseId, o), u = V2(s.baseId, o), d = o === s.value;
    return /* @__PURE__ */ f.jsx(
      wme,
      {
        asChild: !0,
        ...l,
        focusable: !i,
        active: d,
        children: /* @__PURE__ */ f.jsx(
          Tl.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": d,
            "aria-controls": u,
            "data-state": d ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: c,
            ...a,
            ref: n,
            onMouseDown: Fo(t.onMouseDown, (m) => {
              !i && m.button === 0 && m.ctrlKey === !1 ? s.onValueChange(o) : m.preventDefault();
            }),
            onKeyDown: Fo(t.onKeyDown, (m) => {
              i || m.target !== m.currentTarget || [" ", "Enter"].includes(m.key) && s.onValueChange(o);
            }),
            onFocus: Fo(t.onFocus, () => {
              const m = s.activationMode !== "manual";
              !d && !i && m && s.onValueChange(o);
            })
          }
        )
      }
    );
  }, "TabsTrigger")
), Nme = "TabsContent", Mme = /* @__PURE__ */ S.forwardRef(
  /* @__PURE__ */ _l(function(t, n) {
    const { __scopeTabs: r, value: o, forceMount: i, children: a, ...s } = t, l = B2(Nme, r), c = G2(l.baseId, o), u = V2(l.baseId, o), d = o === l.value, m = S.useRef(d);
    return S.useEffect(() => {
      const h = requestAnimationFrame(() => m.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ f.jsx(Ime, { present: i || d, children: ({ present: h }) => /* @__PURE__ */ f.jsx(
      Tl.div,
      {
        "data-state": d ? "active" : "inactive",
        "data-orientation": l.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !h,
        id: u,
        tabIndex: 0,
        ...s,
        ref: n,
        style: {
          ...t.style,
          animationDuration: m.current ? "0s" : void 0
        },
        children: h && a
      }
    ) });
  }, "TabsContent")
);
function G2(e, t) {
  return `${e}-trigger-${t}`;
}
_l(G2, "makeTriggerId");
function V2(e, t) {
  return `${e}-content-${t}`;
}
_l(V2, "makeContentId");
var Fme = Ome, V_ = kme, U_ = Pme, W_ = Mme;
const Lme = Fme, $me = qr("flex overflow-x-auto", {
  variants: {
    variant: {
      underline: "gap-1 border-b border-neutral-200",
      pill: "gap-1.5"
    }
  },
  defaultVariants: { variant: "underline" }
}), H_ = S.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ f.jsx(
  V_,
  {
    ref: r,
    className: oe($me({ variant: t }), e),
    ...n
  }
));
H_.displayName = V_.displayName;
const zme = qr(
  [
    "cursor-pointer px-3 text-sm whitespace-nowrap text-neutral-500 transition-colors",
    "hover:text-neutral-800 focus-visible:ring-2 focus-visible:ring-corso-blue-600 focus-visible:outline-hidden focus-visible:ring-inset",
    "disabled:pointer-events-none disabled:opacity-50"
  ],
  {
    variants: {
      variant: {
        underline: "-mb-px border-b-2 border-transparent py-2 data-[state=active]:border-corso-blue-600 data-[state=active]:font-semibold data-[state=active]:text-neutral-900",
        pill: "rounded-full py-1 data-[state=active]:bg-neutral-900 data-[state=active]:font-medium data-[state=active]:text-white"
      }
    },
    defaultVariants: { variant: "underline" }
  }
), q_ = S.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ f.jsx(
  U_,
  {
    ref: r,
    className: oe(zme({ variant: t }), e),
    ...n
  }
));
q_.displayName = U_.displayName;
const Y_ = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  W_,
  {
    ref: n,
    className: oe(
      "rounded-sm focus-visible:ring-2 focus-visible:ring-corso-blue-600 focus-visible:ring-offset-2 focus-visible:outline-hidden",
      e
    ),
    ...t
  }
));
Y_.displayName = W_.displayName;
function jme(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = S.createContext(a), l = n.length;
    n = [...n, a];
    const c = (d) => {
      var b;
      const { scope: m, children: h, ...v } = d, g = ((b = m == null ? void 0 : m[e]) == null ? void 0 : b[l]) || s, x = S.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ f.jsx(g.Provider, { value: x, children: h });
    };
    c.displayName = i + "Provider";
    function u(d, m) {
      var g;
      const h = ((g = m == null ? void 0 : m[e]) == null ? void 0 : g[l]) || s, v = S.useContext(h);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const o = () => {
    const i = n.map((a) => S.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || i;
      return S.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, Bme(o, ...t)];
}
function Bme(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = r.reduce((s, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...s, ...d };
      }, {});
      return S.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Gme = "DismissableLayer", d1 = "dismissableLayer.update", Vme = "dismissableLayer.pointerDownOutside", Ume = "dismissableLayer.focusOutside", cS, K_ = S.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Z_ = S.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, c = S.useContext(K_), [u, d] = S.useState(null), m = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = S.useState({}), v = mt(t, (_) => d(_)), g = Array.from(c.layers), [x] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), b = g.indexOf(x), C = u ? g.indexOf(u) : -1, I = c.layersWithOutsidePointerEventsDisabled.size > 0, T = C >= b, R = qme((_) => {
      const k = _.target, M = [...c.branches].some((j) => j.contains(k));
      !T || M || (o == null || o(_), a == null || a(_), _.defaultPrevented || s == null || s());
    }, m), A = Yme((_) => {
      const k = _.target;
      [...c.branches].some((j) => j.contains(k)) || (i == null || i(_), a == null || a(_), _.defaultPrevented || s == null || s());
    }, m);
    return hR((_) => {
      C === c.layers.size - 1 && (r == null || r(_), !_.defaultPrevented && s && (_.preventDefault(), s()));
    }, m), S.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (cS = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), uS(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = cS);
        };
    }, [u, m, n, c]), S.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), uS());
    }, [u, c]), S.useEffect(() => {
      const _ = () => h({});
      return document.addEventListener(d1, _), () => document.removeEventListener(d1, _);
    }, []), /* @__PURE__ */ f.jsx(
      at.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: I ? T ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Re(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Re(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Re(
          e.onPointerDownCapture,
          R.onPointerDownCapture
        )
      }
    );
  }
);
Z_.displayName = Gme;
var Wme = "DismissableLayerBranch", Hme = S.forwardRef((e, t) => {
  const n = S.useContext(K_), r = S.useRef(null), o = mt(t, r);
  return S.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ f.jsx(at.div, { ...e, ref: o });
});
Hme.displayName = Wme;
function qme(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = tr(e), r = S.useRef(!1), o = S.useRef(() => {
  });
  return S.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          X_(
            Vme,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Yme(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = tr(e), r = S.useRef(!1);
  return S.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && X_(Ume, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function uS() {
  const e = new CustomEvent(d1);
  document.dispatchEvent(e);
}
function X_(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Dv(o, i) : o.dispatchEvent(i);
}
var Kme = "Portal", J_ = S.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, i] = S.useState(!1);
  An(() => i(!0), []);
  const a = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? M1.createPortal(/* @__PURE__ */ f.jsx(at.div, { ...r, ref: t }), a) : null;
});
J_.displayName = Kme;
function Zme(e, t) {
  return S.useReducer((n, r) => t[n][r] ?? n, e);
}
var Gm = (e) => {
  const { present: t, children: n } = e, r = Xme(t), o = typeof n == "function" ? n({ present: r.isPresent }) : S.Children.only(n), i = mt(r.ref, Jme(o));
  return typeof n == "function" || r.isPresent ? S.cloneElement(o, { ref: i }) : null;
};
Gm.displayName = "Presence";
function Xme(e) {
  const [t, n] = S.useState(), r = S.useRef({}), o = S.useRef(e), i = S.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = Zme(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return S.useEffect(() => {
    const c = hd(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [s]), An(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const m = i.current, h = hd(c);
      e ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && m !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), An(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (h) => {
        const g = hd(r.current).includes(h.animationName);
        if (h.target === t && g && (l("ANIMATION_END"), !o.current)) {
          const x = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = x);
          });
        }
      }, m = (h) => {
        h.target === t && (i.current = hd(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: S.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function hd(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Jme(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Qme = "VisuallyHidden", U2 = S.forwardRef(
  (e, t) => /* @__PURE__ */ f.jsx(
    at.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
U2.displayName = Qme;
var epe = U2, [Vm] = jme("Tooltip", [
  da
]), Um = da(), Q_ = "TooltipProvider", tpe = 700, f1 = "tooltip.open", [npe, W2] = Vm(Q_), eO = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = tpe,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, [a, s] = S.useState(!0), l = S.useRef(!1), c = S.useRef(0);
  return S.useEffect(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ f.jsx(
    npe,
    {
      scope: t,
      isOpenDelayed: a,
      delayDuration: n,
      onOpen: S.useCallback(() => {
        window.clearTimeout(c.current), s(!1);
      }, []),
      onClose: S.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => s(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: l,
      onPointerInTransitChange: S.useCallback((u) => {
        l.current = u;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
eO.displayName = Q_;
var Wm = "Tooltip", [rpe, Ou] = Vm(Wm), tO = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: i,
    disableHoverableContent: a,
    delayDuration: s
  } = e, l = W2(Wm, e.__scopeTooltip), c = Um(t), [u, d] = S.useState(null), m = _r(), h = S.useRef(0), v = a ?? l.disableHoverableContent, g = s ?? l.delayDuration, x = S.useRef(!1), [b = !1, C] = di({
    prop: r,
    defaultProp: o,
    onChange: (_) => {
      _ ? (l.onOpen(), document.dispatchEvent(new CustomEvent(f1))) : l.onClose(), i == null || i(_);
    }
  }), I = S.useMemo(() => b ? x.current ? "delayed-open" : "instant-open" : "closed", [b]), T = S.useCallback(() => {
    window.clearTimeout(h.current), x.current = !1, C(!0);
  }, [C]), R = S.useCallback(() => {
    window.clearTimeout(h.current), C(!1);
  }, [C]), A = S.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      x.current = !0, C(!0);
    }, g);
  }, [g, C]);
  return S.useEffect(() => () => window.clearTimeout(h.current), []), /* @__PURE__ */ f.jsx(vu, { ...c, children: /* @__PURE__ */ f.jsx(
    rpe,
    {
      scope: t,
      contentId: m,
      open: b,
      stateAttribute: I,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: S.useCallback(() => {
        l.isOpenDelayed ? A() : T();
      }, [l.isOpenDelayed, A, T]),
      onTriggerLeave: S.useCallback(() => {
        v ? R() : window.clearTimeout(h.current);
      }, [R, v]),
      onOpen: T,
      onClose: R,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
tO.displayName = Wm;
var m1 = "TooltipTrigger", nO = S.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Ou(m1, n), i = W2(m1, n), a = Um(n), s = S.useRef(null), l = mt(t, s, o.onTriggerChange), c = S.useRef(!1), u = S.useRef(!1), d = S.useCallback(() => c.current = !1, []);
    return S.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ f.jsx(yu, { asChild: !0, ...a, children: /* @__PURE__ */ f.jsx(
      at.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: Re(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !u.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: Re(e.onPointerLeave, () => {
          o.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: Re(e.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: Re(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: Re(e.onBlur, o.onClose),
        onClick: Re(e.onClick, o.onClose)
      }
    ) });
  }
);
nO.displayName = m1;
var H2 = "TooltipPortal", [ope, ipe] = Vm(H2, {
  forceMount: void 0
}), q2 = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = Ou(H2, t);
  return /* @__PURE__ */ f.jsx(ope, { scope: t, forceMount: n, children: /* @__PURE__ */ f.jsx(Gm, { present: n || i.open, children: /* @__PURE__ */ f.jsx(J_, { asChild: !0, container: o, children: r }) }) });
};
q2.displayName = H2;
var il = "TooltipContent", rO = S.forwardRef(
  (e, t) => {
    const n = ipe(il, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, a = Ou(il, e.__scopeTooltip);
    return /* @__PURE__ */ f.jsx(Gm, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ f.jsx(oO, { side: o, ...i, ref: t }) : /* @__PURE__ */ f.jsx(ape, { side: o, ...i, ref: t }) });
  }
), ape = S.forwardRef((e, t) => {
  const n = Ou(il, e.__scopeTooltip), r = W2(il, e.__scopeTooltip), o = S.useRef(null), i = mt(t, o), [a, s] = S.useState(null), { trigger: l, onClose: c } = n, u = o.current, { onPointerInTransitChange: d } = r, m = S.useCallback(() => {
    s(null), d(!1);
  }, [d]), h = S.useCallback(
    (v, g) => {
      const x = v.currentTarget, b = { x: v.clientX, y: v.clientY }, C = upe(b, x.getBoundingClientRect()), I = dpe(b, C), T = fpe(g.getBoundingClientRect()), R = ppe([...I, ...T]);
      s(R), d(!0);
    },
    [d]
  );
  return S.useEffect(() => () => m(), [m]), S.useEffect(() => {
    if (l && u) {
      const v = (x) => h(x, u), g = (x) => h(x, l);
      return l.addEventListener("pointerleave", v), u.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", v), u.removeEventListener("pointerleave", g);
      };
    }
  }, [l, u, h, m]), S.useEffect(() => {
    if (a) {
      const v = (g) => {
        const x = g.target, b = { x: g.clientX, y: g.clientY }, C = (l == null ? void 0 : l.contains(x)) || (u == null ? void 0 : u.contains(x)), I = !mpe(b, a);
        C ? m() : I && (m(), c());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [l, u, a, c, m]), /* @__PURE__ */ f.jsx(oO, { ...e, ref: i });
}), [spe, lpe] = Vm(Wm, { isInside: !1 }), oO = S.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      ...s
    } = e, l = Ou(il, n), c = Um(n), { onClose: u } = l;
    return S.useEffect(() => (document.addEventListener(f1, u), () => document.removeEventListener(f1, u)), [u]), S.useEffect(() => {
      if (l.trigger) {
        const d = (m) => {
          const h = m.target;
          h != null && h.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ f.jsx(
      Z_,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: a,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ f.jsxs(
          Pm,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ f.jsx($3, { children: r }),
              /* @__PURE__ */ f.jsx(spe, { scope: n, isInside: !0, children: /* @__PURE__ */ f.jsx(epe, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
rO.displayName = il;
var iO = "TooltipArrow", cpe = S.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Um(n);
    return lpe(
      iO,
      n
    ).isInside ? null : /* @__PURE__ */ f.jsx(Nm, { ...o, ...r, ref: t });
  }
);
cpe.displayName = iO;
function upe(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function dpe(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function fpe(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function mpe(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, l = t[i].y, c = t[a].x, u = t[a].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (o = !o);
  }
  return o;
}
function ppe(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), hpe(t);
}
function hpe(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var gpe = eO, vpe = tO, aO = nO, ype = q2, sO = rO;
const Y2 = ({
  delayDuration: e = 100,
  ...t
}) => /* @__PURE__ */ f.jsx(gpe, { delayDuration: e, ...t }), K2 = vpe, Gve = ype, Hm = S.forwardRef(({ asChild: e, type: t = e ? void 0 : "button", ...n }, r) => /* @__PURE__ */ f.jsx(
  aO,
  {
    ref: r,
    asChild: e,
    type: t,
    ...n
  }
));
Hm.displayName = aO.displayName;
const qm = S.forwardRef(({ className: e, sideOffset: t = 4, collisionPadding: n = 4, ...r }, o) => /* @__PURE__ */ f.jsx(q2, { children: /* @__PURE__ */ f.jsx(
  sO,
  {
    ref: o,
    sideOffset: t,
    collisionPadding: n,
    className: oe(
      "max-w-(--radix-tooltip-content-available-width) origin-(--radix-tooltip-content-transform-origin)",
      "z-50 overflow-hidden rounded-md border border-neutral-200 bg-white px-3 py-1.5 text-sm text-neutral-950 shadow-md",
      "animate-in duration-200 fade-in-0 zoom-in-90",
      "data-[state=closed]:animate-out data-[state=closed]:duration-200 data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-90",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
) }));
qm.displayName = sO.displayName;
function lO({
  children: e,
  show: t
}) {
  return /* @__PURE__ */ f.jsx(Gm, { present: t, children: e });
}
function dS({
  icon: e,
  accessibilityLabel: t,
  children: n,
  loading: r = !1,
  side: o = "left"
}) {
  return /* @__PURE__ */ f.jsxs(
    "span",
    {
      className: oe(
        "inline-flex w-full items-center justify-center gap-2",
        o === "left" ? "flex-row" : "flex-row-reverse"
      ),
      children: [
        r ? /* @__PURE__ */ f.jsx(J1, {}) : e !== void 0 && /* @__PURE__ */ f.jsx(Ve, { icon: e }),
        t && /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: t }),
        n
      ]
    }
  );
}
const Fn = It(
  ({
    className: e,
    loading: t = !1,
    // button variants
    pressed: n,
    variant: r,
    size: o,
    // action content
    accessibilityLabel: i,
    children: a,
    icon: s,
    side: l,
    // remaining action
    ...c
  }, u) => {
    const [d, m] = Fe(!1);
    return "to" in c && c.to !== void 0 ? /* @__PURE__ */ f.jsx(
      en,
      {
        className: e,
        ref: u,
        size: o,
        icon: s && a == null,
        disabled: t,
        variant: r,
        pressed: n,
        asChild: !0,
        children: /* @__PURE__ */ f.jsx(
          Yc,
          {
            className: oe(t && "pointer-events-none cursor-wait"),
            ...c,
            onClick: (h) => {
              if (!c.download || typeof c.to != "string") return;
              const v = new URL(c.to, window.location.origin);
              h.preventDefault(), m(!0), fetch(v).then(async (g) => {
                if (!g.ok)
                  throw new Error(
                    `Download Response Error: ${g.status}`,
                    { cause: g }
                  );
                const x = v.pathname.split("/").pop() ?? "download", b = await g.blob(), C = URL.createObjectURL(b), I = document.createElement("a");
                I.download = x, I.href = C, I.click(), URL.revokeObjectURL(C);
              }).catch((g) => {
                console.error("Download Error", g);
              }).finally(() => m(!1));
            },
            children: /* @__PURE__ */ f.jsx(
              dS,
              {
                icon: s,
                accessibilityLabel: i,
                loading: t || d,
                side: l,
                children: a
              }
            )
          }
        )
      }
    ) : /* @__PURE__ */ f.jsx(
      en,
      {
        className: oe(
          t && "cursor-wait",
          c.disabled && "cursor-not-allowed",
          e
        ),
        ref: u,
        size: o,
        icon: s && a == null,
        disabled: t || c.disabled,
        variant: r,
        pressed: n,
        ...c,
        children: /* @__PURE__ */ f.jsx(
          dS,
          {
            icon: s,
            accessibilityLabel: i,
            loading: t,
            side: l,
            children: a
          }
        )
      }
    );
  }
);
Fn.displayName = "Action";
const Z2 = Nn({
  size: "md",
  titleId: ""
}), bpe = "@container grid w-full min-w-0 grid-cols-[auto_minmax(0,1fr)_auto] grid-rows-[auto_auto_auto_auto_1fr] [grid-template-areas:'media_content_amount'_'media_stacked-amount_.'_'media_additional-content_.'_'media_supporting-content_supporting-content'_'media_._.']", vt = ({
  size: e = "md",
  children: t
}) => {
  const n = oi(), r = Be(() => ({ size: e, titleId: n }), [e, n]), o = /* @__PURE__ */ f.jsx(Z2.Provider, { value: r, children: t });
  return /* @__PURE__ */ f.jsx("article", { "aria-labelledby": n, className: bpe, children: o });
}, Spe = (e) => {
  const { size: t } = On(Z2);
  return (
    // margins rather than a grid gap, so an absent media or amount leaves no gutter
    /* @__PURE__ */ f.jsx("div", { className: "mr-3 [grid-area:media]", children: /* @__PURE__ */ f.jsx(_fe, { ...e, size: t }) })
  );
}, xpe = qr("block text-sm font-medium", {
  variants: {
    tone: {
      neutral: "text-neutral-800",
      critical: "text-red-600"
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
}), Cpe = ({
  children: e,
  tone: t
}) => {
  const { titleId: n } = On(Z2);
  return (
    // a span, not a paragraph, so a button such as `ClickToCopy` can wrap it
    /* @__PURE__ */ f.jsx("span", { id: n, className: xpe({ tone: t }), children: e })
  );
}, wpe = ({ children: e }) => /* @__PURE__ */ f.jsx("div", { className: "flex flex-col gap-1 [grid-area:content]", children: e }), Epe = ({ children: e }) => /* @__PURE__ */ f.jsx("div", { className: "flex flex-wrap items-center gap-1 text-xs text-neutral-500 empty:hidden", children: e }), Ipe = ({ children: e }) => (
  // hidden when every row is empty too, since an empty `Detail` hides itself but still counts as a child
  /* @__PURE__ */ f.jsx("div", { className: "mt-1 flex flex-col gap-1 [grid-area:additional-content] [&:not(:has(>:not(:empty)))]:hidden", children: e })
), Ym = ({ children: e }) => /* @__PURE__ */ f.jsx("div", { className: "mt-1 text-sm text-neutral-800 tabular-nums [grid-area:stacked-amount] @xs:mt-0 @xs:ml-3 @xs:text-right @xs:[grid-area:amount]", children: e }), Rpe = ({ children: e }) => /* @__PURE__ */ f.jsx(Ym, { children: e }), Tpe = ({ children: e }) => /* @__PURE__ */ f.jsx("div", { className: "mt-3 [grid-area:supporting-content]", children: e }), _pe = ({
  currencyCode: e,
  unitPrice: t,
  quantity: n,
  unitTax: r
}) => /* @__PURE__ */ f.jsxs(Ym, { children: [
  dt.currency(t + (r ?? 0), e),
  n != null && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    " × ",
    dt.count(n)
  ] })
] }), Ope = ({
  currencyCode: e,
  amount: t
}) => /* @__PURE__ */ f.jsx(Ym, { children: dt.currency(t, e) }), Ape = ({ quantity: e }) => /* @__PURE__ */ f.jsxs(Ym, { children: [
  /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Quantity" }),
  " ",
  /* @__PURE__ */ f.jsx("span", { "aria-hidden": "true", children: "×" }),
  " ",
  dt.count(e)
] }), kpe = "Default Title", cO = (e) => (Array.isArray(e) ? e.map(({ value: t }) => t) : Object.values(e)).filter((t) => t !== kpe).join(" / "), Dpe = ({
  options: e
}) => {
  const t = cO(e);
  return t ? /* @__PURE__ */ f.jsx(ka, { children: t }) : null;
}, Ppe = ({ sku: e }) => /* @__PURE__ */ f.jsxs("span", { children: [
  /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "SKU" }),
  " ",
  e
] });
vt.Media = Spe;
vt.Content = wpe;
vt.Title = Cpe;
vt.Detail = Epe;
vt.AdditionalContent = Ipe;
vt.Amount = Rpe;
vt.SupportingContent = Tpe;
vt.Price = _pe;
vt.Money = Ope;
vt.Quantity = Ape;
vt.Options = Dpe;
vt.Sku = Ppe;
const uO = ({
  title: e,
  media: t,
  currencyCode: n,
  amount: r,
  size: o,
  children: i
}) => /* @__PURE__ */ f.jsxs(vt, { size: o, children: [
  t && /* @__PURE__ */ f.jsx(vt.Media, { ...t, alt: e }),
  /* @__PURE__ */ f.jsxs(vt.Content, { children: [
    /* @__PURE__ */ f.jsx(vt.Title, { children: e }),
    i
  ] }),
  /* @__PURE__ */ f.jsx(vt.Money, { currencyCode: n, amount: r })
] });
uO.Detail = vt.Detail;
const dO = Nn(/* @__PURE__ */ new Map()), X2 = () => On(dO), Npe = (e) => X2().has(e), Vve = (e) => X2().get(e);
function Mpe({
  nest: e,
  children: t
}) {
  const n = X2(), r = Be(() => {
    const o = n.get(e) ?? 0;
    return new Map(n).set(e, o + 1);
  }, [e, n]);
  return /* @__PURE__ */ f.jsx(dO.Provider, { value: r, children: t });
}
function un({
  flush: e = !1,
  flat: t = !1,
  stretch: n = !1,
  id: r,
  children: o
}) {
  const i = Npe("card");
  return /* @__PURE__ */ f.jsx(
    "section",
    {
      id: r,
      className: oe(
        "flex flex-col gap-4 overflow-auto rounded-lg border bg-white",
        !e && "px-3 py-5 lg:p-4",
        n && "h-full",
        !i && !t && "shadow-sm"
      ),
      children: /* @__PURE__ */ f.jsx(Mpe, { nest: "card", children: o })
    }
  );
}
function Fpe({
  as: e = "p",
  id: t,
  children: n
}) {
  return /* @__PURE__ */ f.jsx(
    e,
    {
      id: t,
      className: "text-sm font-bold text-neutral-900 opacity-75",
      children: n
    }
  );
}
un.Heading = Fpe;
function Lpe({ children: e }) {
  return /* @__PURE__ */ f.jsx("p", { className: "text-sm text-pretty text-neutral-500", children: e });
}
un.Description = Lpe;
function $pe({
  divided: e = !1,
  children: t
}) {
  return /* @__PURE__ */ f.jsx(
    "header",
    {
      className: oe(
        "flex min-w-0 flex-1 flex-col justify-center gap-1 px-6 py-5",
        e && "border-b"
      ),
      children: t
    }
  );
}
un.Header = $pe;
function zpe({
  as: e = "div",
  children: t
}) {
  return /* @__PURE__ */ f.jsx(e, { className: "grid auto-cols-max grid-flow-col grid-cols-[1fr] items-center gap-2", children: t });
}
un.Line = zpe;
function J2({
  children: e,
  accessibilityLabel: t = "Help"
}) {
  return /* @__PURE__ */ f.jsx(Y2, { children: /* @__PURE__ */ f.jsxs(K2, { children: [
    /* @__PURE__ */ f.jsx(Hm, { "aria-label": t, children: /* @__PURE__ */ f.jsx(
      Ve,
      {
        icon: "help",
        className: "opacity-100 group-focus-within/help-tooltip-scope:opacity-100 group-hover/help-tooltip-scope:opacity-100 in-[.group\\/help-tooltip-scope]:opacity-0"
      }
    ) }),
    /* @__PURE__ */ f.jsx(qm, { children: /* @__PURE__ */ f.jsx("div", { className: "max-w-xs text-pretty", children: e }) })
  ] }) });
}
function jpe({ children: e }) {
  return /* @__PURE__ */ f.jsx("div", { className: "group/help-tooltip-scope contents", children: e });
}
J2.Scope = jpe;
const Q2 = ({
  title: e,
  headingLevel: t,
  description: n,
  info: r
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsxs(un.Line, { children: [
    /* @__PURE__ */ f.jsx(un.Heading, { as: t, children: e }),
    r && /* @__PURE__ */ f.jsx(J2, { accessibilityLabel: `About ${e}`, children: r })
  ] }),
  n && /* @__PURE__ */ f.jsx(un.Description, { children: n })
] }), Km = (e) => /* @__PURE__ */ f.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ f.jsx(Q2, { ...e }) }), as = ({
  message: e,
  compact: t = !1
}) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: oe(
      "flex items-center justify-center text-sm text-neutral-500",
      t ? "h-40" : "h-64"
    ),
    children: e
  }
), Hc = (e) => Number.isFinite(e) && e > 0, yc = "\0other", fO = "var(--color-neutral-400)", mO = ({
  children: e,
  placeholder: t
}) => /* @__PURE__ */ f.jsx(
  "output",
  {
    "aria-live": "off",
    className: "block min-h-5 text-xs text-neutral-600 tabular-nums",
    children: e ?? /* @__PURE__ */ f.jsx("span", { className: "text-neutral-400", children: t })
  }
), ey = (e) => {
  const t = No[e % No.length] ?? No[0];
  return e < No.length ? t : `color-mix(in oklab, ${t} 62%, var(--color-neutral-900))`;
}, Na = (e, t) => dt.share(t > 0 ? e / t : 0), pO = () => {
  const [e, t] = Fe(null), [n, r] = Fe(0);
  return oa(() => {
    if (!e) return;
    const o = () => r(e.getBoundingClientRect().width);
    if (o(), typeof ResizeObserver > "u") return;
    const i = new ResizeObserver(o);
    return i.observe(e), () => i.disconnect();
  }, [e]), [t, n];
}, dh = (e) => Number.isFinite(e) && e >= 0, Bpe = ({
  title: e,
  headingLevel: t = "h3",
  description: n,
  info: r,
  data: o,
  color: i = No[0],
  valueFormatter: a = dt.count,
  emptyMessage: s = "No data for this period",
  unavailableLabel: l = "Unavailable"
}) => {
  const c = Math.max(
    0,
    ...o.map(({ value: u }) => dh(u) ? u : 0)
  );
  return /* @__PURE__ */ f.jsxs(un, { stretch: !0, children: [
    /* @__PURE__ */ f.jsx(
      Km,
      {
        title: e,
        headingLevel: t,
        description: n,
        info: r
      }
    ),
    o.length > 0 ? /* @__PURE__ */ f.jsx("ol", { "aria-label": e, className: "flex flex-col gap-3 text-xs", children: o.map((u) => /* @__PURE__ */ f.jsxs(
      "li",
      {
        className: "grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-1",
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "truncate text-neutral-600", title: u.label, children: u.label }),
          /* @__PURE__ */ f.jsx("span", { className: "text-neutral-900 tabular-nums", children: dh(u.value) ? a(u.value) : l }),
          /* @__PURE__ */ f.jsx(
            "span",
            {
              "aria-hidden": !0,
              className: "col-span-2 h-2 overflow-hidden rounded-sm bg-neutral-100",
              children: /* @__PURE__ */ f.jsx(
                "span",
                {
                  className: "block h-full rounded-sm",
                  style: {
                    width: `${dh(u.value) && c > 0 ? u.value / c * 100 : 0}%`,
                    backgroundColor: i
                  }
                }
              )
            }
          )
        ]
      },
      u.key
    )) }) : /* @__PURE__ */ f.jsx(as, { message: s, compact: !0 })
  ] });
};
var fh, fS;
function Gpe() {
  if (fS) return fh;
  fS = 1;
  var e = "Expected a function", t = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, o = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, a = /^0o[0-7]+$/i, s = parseInt, l = typeof zu == "object" && zu && zu.Object === Object && zu, c = typeof self == "object" && self && self.Object === Object && self, u = l || c || Function("return this")(), d = Object.prototype, m = d.toString, h = Math.max, v = Math.min, g = function() {
    return u.Date.now();
  };
  function x(R, A, _) {
    var k, M, j, G, U, B, K = 0, ee = !1, Y = !1, J = !0;
    if (typeof R != "function")
      throw new TypeError(e);
    A = T(A) || 0, b(_) && (ee = !!_.leading, Y = "maxWait" in _, j = Y ? h(T(_.maxWait) || 0, A) : j, J = "trailing" in _ ? !!_.trailing : J);
    function ye(te) {
      var he = k, ge = M;
      return k = M = void 0, K = te, G = R.apply(ge, he), G;
    }
    function re(te) {
      return K = te, U = setTimeout(F, A), ee ? ye(te) : G;
    }
    function le(te) {
      var he = te - B, ge = te - K, de = A - he;
      return Y ? v(de, j - ge) : de;
    }
    function Te(te) {
      var he = te - B, ge = te - K;
      return B === void 0 || he >= A || he < 0 || Y && ge >= j;
    }
    function F() {
      var te = g();
      if (Te(te))
        return Z(te);
      U = setTimeout(F, le(te));
    }
    function Z(te) {
      return U = void 0, J && k ? ye(te) : (k = M = void 0, G);
    }
    function se() {
      U !== void 0 && clearTimeout(U), K = 0, k = B = M = U = void 0;
    }
    function ae() {
      return U === void 0 ? G : Z(g());
    }
    function ue() {
      var te = g(), he = Te(te);
      if (k = arguments, M = this, B = te, he) {
        if (U === void 0)
          return re(B);
        if (Y)
          return U = setTimeout(F, A), ye(B);
      }
      return U === void 0 && (U = setTimeout(F, A)), G;
    }
    return ue.cancel = se, ue.flush = ae, ue;
  }
  function b(R) {
    var A = typeof R;
    return !!R && (A == "object" || A == "function");
  }
  function C(R) {
    return !!R && typeof R == "object";
  }
  function I(R) {
    return typeof R == "symbol" || C(R) && m.call(R) == n;
  }
  function T(R) {
    if (typeof R == "number")
      return R;
    if (I(R))
      return t;
    if (b(R)) {
      var A = typeof R.valueOf == "function" ? R.valueOf() : R;
      R = b(A) ? A + "" : A;
    }
    if (typeof R != "string")
      return R === 0 ? R : +R;
    R = R.replace(r, "");
    var _ = i.test(R);
    return _ || a.test(R) ? s(R.slice(2), _ ? 2 : 8) : o.test(R) ? t : +R;
  }
  return fh = x, fh;
}
var Vpe = Gpe();
const mS = /* @__PURE__ */ JM(Vpe);
var pS = typeof window < "u" ? oa : Le;
function hO() {
  const [e, t] = Fe(null), n = Ke(async (r) => {
    if (!(navigator != null && navigator.clipboard))
      return console.warn("Clipboard not supported"), !1;
    try {
      return await navigator.clipboard.writeText(r), t(r), !0;
    } catch (o) {
      return console.warn("Copy failed", o), t(null), !1;
    }
  }, []);
  return [e, n];
}
function gO(e) {
  const t = He(e);
  t.current = e, Le(
    () => () => {
      t.current();
    },
    []
  );
}
function Upe(e, t = 500, n) {
  const r = He();
  gO(() => {
    r.current && r.current.cancel();
  });
  const o = Be(() => {
    const i = mS(e, t, n), a = (...s) => i(...s);
    return a.cancel = () => {
      i.cancel();
    }, a.isPending = () => !!r.current, a.flush = () => i.flush(), a;
  }, [e, t, n]);
  return Le(() => {
    r.current = mS(e, t, n);
  }, [e, t, n]), o;
}
function vO(e, t = {}) {
  const { preserveTitleOnUnmount: n = !0 } = t, r = He(null);
  pS(() => {
    r.current = window.document.title;
  }, []), pS(() => {
    window.document.title = e;
  }, [e]), gO(() => {
    !n && r.current && (window.document.title = r.current);
  });
}
function yO(e) {
  const [t, n] = Fe(0);
  Le(() => {
    if (!t) return;
    const o = setTimeout(() => {
      n(0);
    }, e);
    return () => clearTimeout(o);
  }, [e, t]);
  const r = Ke(() => {
    n((o) => o + 1);
  }, []);
  return [t > 0, r];
}
const hS = ({
  value: e,
  children: t
}) => {
  const [n, r] = Fe(!1), [o, i] = yO(1500), [a, s] = Fe(), [, l] = hO(), c = ze({ copied: a, showing: o || !n }).with({ showing: !0, copied: !0 }, () => "Copied").with({ showing: !0, copied: !1 }, () => "Copy failed").otherwise(() => e);
  return /* @__PURE__ */ f.jsxs(Y2, { children: [
    /* @__PURE__ */ f.jsxs(K2, { open: n || o, onOpenChange: r, children: [
      /* @__PURE__ */ f.jsxs(
        Hm,
        {
          className: "w-fit max-w-full cursor-pointer rounded-sm text-left focus-visible:ring-2 focus-visible:ring-corso-blue-600 focus-visible:outline-none",
          onClick: (u) => {
            u.preventDefault(), l(e).then((d) => {
              s(d), i();
            }).catch((d) => console.error(d));
          },
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Copy" }),
            " ",
            t
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(qm, { children: c })
    ] }),
    /* @__PURE__ */ f.jsx("span", { "aria-live": "polite", className: "sr-only", children: o && c })
  ] });
};
function Uve({
  onClick: e,
  onCopied: t,
  variant: n,
  accessibilityLabel: r = "Copy to clipboard"
}) {
  const [, o] = hO(), [i, a] = yO(1e3), s = Ke(async () => {
    e && (await o(e()), t == null || t(), a());
  }, [o, e, t, a]);
  return /* @__PURE__ */ f.jsx(
    Fn,
    {
      accessibilityLabel: r,
      icon: i ? D9 : V9,
      variant: n,
      onClick: () => {
        s().catch((l) => console.error(l));
      }
    }
  );
}
function Wve({
  label: e,
  options: t,
  value: n,
  onChange: r,
  onSearchChange: o,
  emptyLabel: i = "Nothing found.",
  placeholder: a,
  align: s,
  disabled: l = !1
}) {
  var T;
  const c = oi(), [u, d] = Fe(""), [m, h] = Fe(!1), v = Ke(
    (R) => {
      r == null || r(R.value), h(!1);
    },
    [r]
  ), g = Ke(
    (R) => R.value === n,
    [n]
  ), x = Ke(
    () => u.trim().toLowerCase(),
    [u]
  )(), b = Ke(
    (R) => [
      R.value,
      ...R.keywords ?? [],
      ...typeof R.label == "string" ? [R.label] : []
    ].some(
      (_) => _.toLowerCase().includes(x)
    ),
    [x]
  ), C = Ke(
    (R) => [R.label, ...R.keywords ?? []].some(
      (_) => _.toLowerCase().includes(x)
    ),
    [x]
  ), I = Be(
    () => t.map((R) => {
      if ("value" in R)
        return b(R) ? R : void 0;
      if (C(R) && R.options.length)
        return R;
      const A = {
        ...R,
        options: R.options.filter(b)
      };
      return A.options.length ? A : void 0;
    }).filter(Gi),
    [t, C, b]
  );
  return /* @__PURE__ */ f.jsxs(xl, { open: m, onOpenChange: h, modal: !0, children: [
    /* @__PURE__ */ f.jsx(Cl, { asChild: !0, children: /* @__PURE__ */ f.jsxs(
      en,
      {
        role: "combobox",
        "aria-expanded": m,
        "aria-controls": m ? c : void 0,
        "aria-haspopup": "dialog",
        className: "justify-between",
        "aria-label": e,
        disabled: l,
        children: [
          /* @__PURE__ */ f.jsx("span", { className: "truncate", children: n ? (T = t.map(
            (R) => "options" in R ? R.options : R
          ).flat().find((R) => R.value === n)) == null ? void 0 : T.label : e }),
          /* @__PURE__ */ f.jsx(
            Ve,
            {
              icon: "chevronDown",
              className: oe(
                "ml-2 shrink-0 opacity-50 transition-all duration-100",
                m && "-rotate-180"
              )
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ f.jsx(ts, { id: c, className: "p-0", align: s, children: /* @__PURE__ */ f.jsxs(Am, { shouldFilter: !1, children: [
      /* @__PURE__ */ f.jsx(
        e2,
        {
          "aria-label": a,
          placeholder: a,
          value: u,
          onValueChange: (R) => {
            d(R), o == null || o(R);
          },
          className: "border-none ring-0 outline-hidden focus:ring-0"
        }
      ),
      /* @__PURE__ */ f.jsxs(t2, { children: [
        /* @__PURE__ */ f.jsx(n2, { children: i }),
        /* @__PURE__ */ f.jsx(xf, { children: I.map((R) => "options" in R ? /* @__PURE__ */ f.jsx(xf, { heading: R.label, children: R.options.map((A) => /* @__PURE__ */ f.jsxs(
          _a,
          {
            value: A.value,
            keywords: A.keywords,
            onSelect: () => v(A),
            children: [
              /* @__PURE__ */ f.jsx(
                Ve,
                {
                  icon: "check",
                  className: oe(
                    "mr-2 shrink-0",
                    g(A) ? "opacity-100" : "opacity-0"
                  )
                }
              ),
              A.label
            ]
          },
          A.value
        )) }, R.label) : /* @__PURE__ */ f.jsxs(
          _a,
          {
            value: R.value,
            keywords: R.keywords,
            onSelect: () => v(R),
            children: [
              /* @__PURE__ */ f.jsx(
                Ve,
                {
                  icon: "check",
                  className: oe(
                    "mr-2 shrink-0",
                    g(R) ? "opacity-100" : "opacity-0"
                  )
                }
              ),
              R.label
            ]
          },
          R.value
        )) })
      ] })
    ] }) })
  ] });
}
const Wpe = qr("", {
  variants: {
    size: {
      xl: "max-w-4xl",
      lg: "max-w-2xl",
      default: "max-w-lg"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function bO({
  show: e,
  title: t,
  icon: n,
  description: r,
  onClose: o,
  children: i,
  actions: a,
  size: s
}) {
  const l = oi(), c = He(null);
  return /* @__PURE__ */ f.jsx(
    Jv,
    {
      modal: !0,
      open: e,
      onOpenChange: (u) => {
        u || o();
      },
      children: /* @__PURE__ */ f.jsxs(
        Om,
        {
          tabIndex: -1,
          ref: c,
          onOpenAutoFocus: (u) => {
            var d;
            u.preventDefault(), (d = c.current) == null || d.focus();
          },
          className: Wpe({ size: s }),
          "aria-describedby": r ? l : void 0,
          children: [
            /* @__PURE__ */ f.jsxs(UR, { children: [
              /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-2", children: [
                n,
                /* @__PURE__ */ f.jsx(Qv, { children: t })
              ] }),
              r && /* @__PURE__ */ f.jsx(HR, { id: l, children: r })
            ] }),
            i,
            a && /* @__PURE__ */ f.jsx(WR, { className: "gap-2", children: a })
          ]
        }
      )
    }
  );
}
const Hpe = {
  destructive: /* @__PURE__ */ f.jsx("div", { className: "flex size-12 shrink-0 items-center justify-center rounded-full bg-red-50 sm:mx-0 sm:h-10 sm:w-10", children: /* @__PURE__ */ f.jsx(
    Ve,
    {
      icon: "errorInline",
      className: "h-6 w-6 text-red-600",
      "aria-hidden": "true"
    }
  ) }),
  primary: null,
  caution: /* @__PURE__ */ f.jsx("div", { className: "flex size-12 shrink-0 items-center justify-center rounded-full bg-amber-100 sm:mx-0 sm:h-10 sm:w-10", children: /* @__PURE__ */ f.jsx(
    Ve,
    {
      icon: "warningInline",
      className: "h-6 w-6 text-amber-600",
      "aria-hidden": "true"
    }
  ) })
};
function SO({
  title: e,
  prompt: t,
  show: n,
  onCancel: r,
  cancelText: o = "Cancel",
  onConfirm: i,
  confirmText: a = "OK",
  variant: s = "destructive",
  loading: l = !1
}) {
  return /* @__PURE__ */ f.jsx(
    bO,
    {
      show: n || l,
      onClose: r,
      title: e,
      icon: Hpe[s],
      actions: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(Fn, { onClick: r, children: o }),
        /* @__PURE__ */ f.jsx(Fn, { variant: s, onClick: i, loading: l, children: a })
      ] }),
      children: /* @__PURE__ */ f.jsx("p", { className: "text-sm text-neutral-500", children: t })
    }
  );
}
function qpe({
  shouldBlock: e,
  title: t,
  prompt: n,
  onCancel: r,
  cancelText: o,
  onProceed: i,
  proceedText: a
}) {
  const s = mk(e), l = Ke(
    (c) => {
      e && (c.preventDefault(), c.returnValue = "");
    },
    [e]
  );
  return pk(l), /* @__PURE__ */ f.jsx(
    SO,
    {
      title: t,
      show: s.state === "blocked",
      prompt: n,
      confirmText: a,
      cancelText: o,
      onConfirm: () => {
        var c;
        i == null || i(), (c = s.proceed) == null || c.call(s);
      },
      onCancel: () => {
        var c;
        r == null || r(), (c = s.reset) == null || c.call(s);
      }
    }
  );
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function ji(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function kr(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: ji(n, r[e])
    }));
  };
}
function Zm(e) {
  return e instanceof Function;
}
function Ype(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function Kpe(e, t) {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push(i);
      const a = t(i);
      a != null && a.length && r(a);
    });
  };
  return r(e), n;
}
function Je(e, t, n) {
  let r = [], o;
  return (i) => {
    let a;
    n.key && n.debug && (a = Date.now());
    const s = e(i);
    if (!(s.length !== r.length || s.some((u, d) => r[d] !== u)))
      return o;
    r = s;
    let c;
    if (n.key && n.debug && (c = Date.now()), o = t(...s), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - a) * 100) / 100, d = Math.round((Date.now() - c) * 100) / 100, m = d / 16, h = (v, g) => {
        for (v = String(v); v.length < g; )
          v = " " + v;
        return v;
      };
      console.info(`%c⏱ ${h(d, 5)} /${h(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * m, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return o;
  };
}
function Qe(e, t, n, r) {
  return {
    debug: () => {
      var o;
      return (o = e == null ? void 0 : e.debugAll) != null ? o : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function Zpe(e, t, n, r) {
  const o = () => {
    var a;
    return (a = i.getValue()) != null ? a : e.options.renderFallbackValue;
  }, i = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: o,
    getContext: Je(() => [e, n, t, i], (a, s, l, c) => ({
      table: a,
      column: s,
      row: l,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), Qe(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((a) => {
    a.createCell == null || a.createCell(i, n, t, e);
  }, {}), i;
}
function Xpe(e, t, n, r) {
  var o, i;
  const s = {
    ...e._getDefaultColumnDef(),
    ...t
  }, l = s.accessorKey;
  let c = (o = (i = s.id) != null ? i : l ? typeof String.prototype.replaceAll == "function" ? l.replaceAll(".", "_") : l.replace(/\./g, "_") : void 0) != null ? o : typeof s.header == "string" ? s.header : void 0, u;
  if (s.accessorFn ? u = s.accessorFn : l && (l.includes(".") ? u = (m) => {
    let h = m;
    for (const g of l.split(".")) {
      var v;
      h = (v = h) == null ? void 0 : v[g], process.env.NODE_ENV !== "production" && h === void 0 && console.warn(`"${g}" in deeply nested key "${l}" returned undefined.`);
    }
    return h;
  } : u = (m) => m[s.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(c)}`,
    accessorFn: u,
    parent: r,
    depth: n,
    columnDef: s,
    columns: [],
    getFlatColumns: Je(() => [!0], () => {
      var m;
      return [d, ...(m = d.columns) == null ? void 0 : m.flatMap((h) => h.getFlatColumns())];
    }, Qe(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: Je(() => [e._getOrderColumnsFn()], (m) => {
      var h;
      if ((h = d.columns) != null && h.length) {
        let v = d.columns.flatMap((g) => g.getLeafColumns());
        return m(v);
      }
      return [d];
    }, Qe(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const m of e._features)
    m.createColumn == null || m.createColumn(d, e);
  return d;
}
const Bn = "debugHeaders";
function gS(e, t, n) {
  var r;
  let i = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const a = [], s = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(s), a.push(l);
      };
      return s(i), a;
    },
    getContext: () => ({
      table: e,
      header: i,
      column: t
    })
  };
  return e._features.forEach((a) => {
    a.createHeader == null || a.createHeader(i, e);
  }), i;
}
const Jpe = {
  createTable: (e) => {
    e.getHeaderGroups = Je(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => {
      var i, a;
      const s = (i = r == null ? void 0 : r.map((d) => n.find((m) => m.id === d)).filter(Boolean)) != null ? i : [], l = (a = o == null ? void 0 : o.map((d) => n.find((m) => m.id === d)).filter(Boolean)) != null ? a : [], c = n.filter((d) => !(r != null && r.includes(d.id)) && !(o != null && o.includes(d.id)));
      return gd(t, [...s, ...c, ...l], e);
    }, Qe(e.options, Bn, "getHeaderGroups")), e.getCenterHeaderGroups = Je(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => (n = n.filter((i) => !(r != null && r.includes(i.id)) && !(o != null && o.includes(i.id))), gd(t, n, e, "center")), Qe(e.options, Bn, "getCenterHeaderGroups")), e.getLeftHeaderGroups = Je(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((a) => n.find((s) => s.id === a)).filter(Boolean)) != null ? o : [];
      return gd(t, i, e, "left");
    }, Qe(e.options, Bn, "getLeftHeaderGroups")), e.getRightHeaderGroups = Je(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((a) => n.find((s) => s.id === a)).filter(Boolean)) != null ? o : [];
      return gd(t, i, e, "right");
    }, Qe(e.options, Bn, "getRightHeaderGroups")), e.getFooterGroups = Je(() => [e.getHeaderGroups()], (t) => [...t].reverse(), Qe(e.options, Bn, "getFooterGroups")), e.getLeftFooterGroups = Je(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), Qe(e.options, Bn, "getLeftFooterGroups")), e.getCenterFooterGroups = Je(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), Qe(e.options, Bn, "getCenterFooterGroups")), e.getRightFooterGroups = Je(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), Qe(e.options, Bn, "getRightFooterGroups")), e.getFlatHeaders = Je(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Qe(e.options, Bn, "getFlatHeaders")), e.getLeftFlatHeaders = Je(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Qe(e.options, Bn, "getLeftFlatHeaders")), e.getCenterFlatHeaders = Je(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Qe(e.options, Bn, "getCenterFlatHeaders")), e.getRightFlatHeaders = Je(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Qe(e.options, Bn, "getRightFlatHeaders")), e.getCenterLeafHeaders = Je(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Qe(e.options, Bn, "getCenterLeafHeaders")), e.getLeftLeafHeaders = Je(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Qe(e.options, Bn, "getLeftLeafHeaders")), e.getRightLeafHeaders = Je(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Qe(e.options, Bn, "getRightLeafHeaders")), e.getLeafHeaders = Je(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var o, i, a, s, l, c;
      return [...(o = (i = t[0]) == null ? void 0 : i.headers) != null ? o : [], ...(a = (s = n[0]) == null ? void 0 : s.headers) != null ? a : [], ...(l = (c = r[0]) == null ? void 0 : c.headers) != null ? l : []].map((u) => u.getLeafHeaders()).flat();
    }, Qe(e.options, Bn, "getLeafHeaders"));
  }
};
function gd(e, t, n, r) {
  var o, i;
  let a = 0;
  const s = function(m, h) {
    h === void 0 && (h = 1), a = Math.max(a, h), m.filter((v) => v.getIsVisible()).forEach((v) => {
      var g;
      (g = v.columns) != null && g.length && s(v.columns, h + 1);
    }, 0);
  };
  s(e);
  let l = [];
  const c = (m, h) => {
    const v = {
      depth: h,
      id: [r, `${h}`].filter(Boolean).join("_"),
      headers: []
    }, g = [];
    m.forEach((x) => {
      const b = [...g].reverse()[0], C = x.column.depth === v.depth;
      let I, T = !1;
      if (C && x.column.parent ? I = x.column.parent : (I = x.column, T = !0), b && (b == null ? void 0 : b.column) === I)
        b.subHeaders.push(x);
      else {
        const R = gS(n, I, {
          id: [r, h, I.id, x == null ? void 0 : x.id].filter(Boolean).join("_"),
          isPlaceholder: T,
          placeholderId: T ? `${g.filter((A) => A.column === I).length}` : void 0,
          depth: h,
          index: g.length
        });
        R.subHeaders.push(x), g.push(R);
      }
      v.headers.push(x), x.headerGroup = v;
    }), l.push(v), h > 0 && c(g, h - 1);
  }, u = t.map((m, h) => gS(n, m, {
    depth: a,
    index: h
  }));
  c(u, a - 1), l.reverse();
  const d = (m) => m.filter((v) => v.column.getIsVisible()).map((v) => {
    let g = 0, x = 0, b = [0];
    v.subHeaders && v.subHeaders.length ? (b = [], d(v.subHeaders).forEach((I) => {
      let {
        colSpan: T,
        rowSpan: R
      } = I;
      g += T, b.push(R);
    })) : g = 1;
    const C = Math.min(...b);
    return x = x + C, v.colSpan = g, v.rowSpan = x, {
      colSpan: g,
      rowSpan: x
    };
  });
  return d((o = (i = l[0]) == null ? void 0 : i.headers) != null ? o : []), l;
}
const Qpe = (e, t, n, r, o, i, a) => {
  let s = {
    id: t,
    index: r,
    original: n,
    depth: o,
    parentId: a,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (s._valuesCache.hasOwnProperty(l))
        return s._valuesCache[l];
      const c = e.getColumn(l);
      if (c != null && c.accessorFn)
        return s._valuesCache[l] = c.accessorFn(s.original, r), s._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (s._uniqueValuesCache.hasOwnProperty(l))
        return s._uniqueValuesCache[l];
      const c = e.getColumn(l);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (s._uniqueValuesCache[l] = c.columnDef.getUniqueValues(s.original, r), s._uniqueValuesCache[l]) : (s._uniqueValuesCache[l] = [s.getValue(l)], s._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var c;
      return (c = s.getValue(l)) != null ? c : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => Kpe(s.subRows, (l) => l.subRows),
    getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], c = s;
      for (; ; ) {
        const u = c.getParentRow();
        if (!u) break;
        l.push(u), c = u;
      }
      return l.reverse();
    },
    getAllCells: Je(() => [e.getAllLeafColumns()], (l) => l.map((c) => Zpe(e, s, c, c.id)), Qe(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: Je(() => [s.getAllCells()], (l) => l.reduce((c, u) => (c[u.column.id] = u, c), {}), Qe(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < e._features.length; l++) {
    const c = e._features[l];
    c == null || c.createRow == null || c.createRow(s, e);
  }
  return s;
}, ehe = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, xO = (e, t, n) => {
  var r, o;
  const i = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(i));
};
xO.autoRemove = (e) => lo(e);
const CO = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
CO.autoRemove = (e) => lo(e);
const wO = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
wO.autoRemove = (e) => lo(e);
const EO = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
EO.autoRemove = (e) => lo(e) || !(e != null && e.length);
const IO = (e, t, n) => !n.some((r) => {
  var o;
  return !((o = e.getValue(t)) != null && o.includes(r));
});
IO.autoRemove = (e) => lo(e) || !(e != null && e.length);
const RO = (e, t, n) => n.some((r) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(r);
});
RO.autoRemove = (e) => lo(e) || !(e != null && e.length);
const TO = (e, t, n) => e.getValue(t) === n;
TO.autoRemove = (e) => lo(e);
const _O = (e, t, n) => e.getValue(t) == n;
_O.autoRemove = (e) => lo(e);
const ty = (e, t, n) => {
  let [r, o] = n;
  const i = e.getValue(t);
  return i >= r && i <= o;
};
ty.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, o = typeof n != "number" ? parseFloat(n) : n, i = t === null || Number.isNaN(r) ? -1 / 0 : r, a = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (i > a) {
    const s = i;
    i = a, a = s;
  }
  return [i, a];
};
ty.autoRemove = (e) => lo(e) || lo(e[0]) && lo(e[1]);
const Ko = {
  includesString: xO,
  includesStringSensitive: CO,
  equalsString: wO,
  arrIncludes: EO,
  arrIncludesAll: IO,
  arrIncludesSome: RO,
  equals: TO,
  weakEquals: _O,
  inNumberRange: ty
};
function lo(e) {
  return e == null || e === "";
}
const the = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: kr("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? Ko.includesString : typeof r == "number" ? Ko.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? Ko.equals : Array.isArray(r) ? Ko.arrIncludes : Ko.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return Zm(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : Ko[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, o;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const o = e.getFilterFn(), i = r == null ? void 0 : r.find((u) => u.id === e.id), a = ji(n, i ? i.value : void 0);
        if (vS(o, a, e)) {
          var s;
          return (s = r == null ? void 0 : r.filter((u) => u.id !== e.id)) != null ? s : [];
        }
        const l = {
          id: e.id,
          value: a
        };
        if (i) {
          var c;
          return (c = r == null ? void 0 : r.map((u) => u.id === e.id ? l : u)) != null ? c : [];
        }
        return r != null && r.length ? [...r, l] : [l];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (o) => {
        var i;
        return (i = ji(t, o)) == null ? void 0 : i.filter((a) => {
          const s = n.find((l) => l.id === a.id);
          if (s) {
            const l = s.getFilterFn();
            if (vS(l, a.value, s))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function vS(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const nhe = (e, t, n) => n.reduce((r, o) => {
  const i = o.getValue(e);
  return r + (typeof i == "number" ? i : 0);
}, 0), rhe = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r > i || r === void 0 && i >= i) && (r = i);
  }), r;
}, ohe = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r < i || r === void 0 && i >= i) && (r = i);
  }), r;
}, ihe = (e, t, n) => {
  let r, o;
  return n.forEach((i) => {
    const a = i.getValue(e);
    a != null && (r === void 0 ? a >= a && (r = o = a) : (r > a && (r = a), o < a && (o = a)));
  }), [r, o];
}, ahe = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((o) => {
    let i = o.getValue(e);
    i != null && (i = +i) >= i && (++n, r += i);
  }), n) return r / n;
}, she = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((i) => i.getValue(e));
  if (!Ype(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((i, a) => i - a);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, lhe = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), che = (e, t) => new Set(t.map((n) => n.getValue(e))).size, uhe = (e, t) => t.length, mh = {
  sum: nhe,
  min: rhe,
  max: ohe,
  extent: ihe,
  mean: ahe,
  median: she,
  unique: lhe,
  uniqueCount: che,
  count: uhe
}, dhe = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: kr("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return mh.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return mh.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Zm(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : mh[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function fhe(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((i) => !t.includes(i.id));
  return n === "remove" ? r : [...t.map((i) => e.find((a) => a.id === i)).filter(Boolean), ...r];
}
const mhe = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: kr("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = Je((n) => [bc(t, n)], (n) => n.findIndex((r) => r.id === e.id), Qe(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = bc(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const o = bc(t, n);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = Je(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (o) => {
      let i = [];
      if (!(t != null && t.length))
        i = o;
      else {
        const a = [...t], s = [...o];
        for (; s.length && a.length; ) {
          const l = a.shift(), c = s.findIndex((u) => u.id === l);
          c > -1 && i.push(s.splice(c, 1)[0]);
        }
        i = [...i, ...s];
      }
      return fhe(i, n, r);
    }, Qe(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, ph = () => ({
  left: [],
  right: []
}), phe = {
  getInitialState: (e) => ({
    columnPinning: ph(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: kr("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      t.setColumnPinning((o) => {
        var i, a;
        if (n === "right") {
          var s, l;
          return {
            left: ((s = o == null ? void 0 : o.left) != null ? s : []).filter((d) => !(r != null && r.includes(d))),
            right: [...((l = o == null ? void 0 : o.right) != null ? l : []).filter((d) => !(r != null && r.includes(d))), ...r]
          };
        }
        if (n === "left") {
          var c, u;
          return {
            left: [...((c = o == null ? void 0 : o.left) != null ? c : []).filter((d) => !(r != null && r.includes(d))), ...r],
            right: ((u = o == null ? void 0 : o.right) != null ? u : []).filter((d) => !(r != null && r.includes(d)))
          };
        }
        return {
          left: ((i = o == null ? void 0 : o.left) != null ? i : []).filter((d) => !(r != null && r.includes(d))),
          right: ((a = o == null ? void 0 : o.right) != null ? a : []).filter((d) => !(r != null && r.includes(d)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, i, a;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((i = (a = t.options.enableColumnPinning) != null ? a : t.options.enablePinning) != null ? i : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((s) => s.id), {
        left: r,
        right: o
      } = t.getState().columnPinning, i = n.some((s) => r == null ? void 0 : r.includes(s)), a = n.some((s) => o == null ? void 0 : o.includes(s));
      return i ? "left" : a ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      return o ? (n = (r = t.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = Je(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, o) => {
      const i = [...r ?? [], ...o ?? []];
      return n.filter((a) => !i.includes(a.column.id));
    }, Qe(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = Je(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((i) => n.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), Qe(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = Je(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((i) => n.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), Qe(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? ph() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : ph());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var o, i;
        return !!((o = r.left) != null && o.length || (i = r.right) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = Je(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Qe(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = Je(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Qe(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = Je(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return t.filter((i) => !o.includes(i.id));
    }, Qe(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, vd = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, hh = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), hhe = {
  getDefaultColumnDef: () => vd,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: hh(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: kr("columnSizing", e),
    onColumnSizingInfoChange: kr("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, o;
      const i = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : vd.minSize, (r = i ?? e.columnDef.size) != null ? r : vd.size), (o = e.columnDef.maxSize) != null ? o : vd.maxSize);
    }, e.getStart = Je((n) => [n, bc(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((o, i) => o + i.getSize(), 0), Qe(t.options, "debugColumns", "getStart")), e.getAfter = Je((n) => [n, bc(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((o, i) => o + i.getSize(), 0), Qe(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...o
        } = n;
        return o;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var i;
          n += (i = o.column.getSize()) != null ? i : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), o = r == null ? void 0 : r.getCanResize();
      return (i) => {
        if (!r || !o || (i.persist == null || i.persist(), gh(i) && i.touches && i.touches.length > 1))
          return;
        const a = e.getSize(), s = e ? e.getLeafHeaders().map((b) => [b.column.id, b.column.getSize()]) : [[r.id, r.getSize()]], l = gh(i) ? Math.round(i.touches[0].clientX) : i.clientX, c = {}, u = (b, C) => {
          typeof C == "number" && (t.setColumnSizingInfo((I) => {
            var T, R;
            const A = t.options.columnResizeDirection === "rtl" ? -1 : 1, _ = (C - ((T = I == null ? void 0 : I.startOffset) != null ? T : 0)) * A, k = Math.max(_ / ((R = I == null ? void 0 : I.startSize) != null ? R : 0), -0.999999);
            return I.columnSizingStart.forEach((M) => {
              let [j, G] = M;
              c[j] = Math.round(Math.max(G + G * k, 0) * 100) / 100;
            }), {
              ...I,
              deltaOffset: _,
              deltaPercentage: k
            };
          }), (t.options.columnResizeMode === "onChange" || b === "end") && t.setColumnSizing((I) => ({
            ...I,
            ...c
          })));
        }, d = (b) => u("move", b), m = (b) => {
          u("end", b), t.setColumnSizingInfo((C) => ({
            ...C,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, h = n || typeof document < "u" ? document : null, v = {
          moveHandler: (b) => d(b.clientX),
          upHandler: (b) => {
            h == null || h.removeEventListener("mousemove", v.moveHandler), h == null || h.removeEventListener("mouseup", v.upHandler), m(b.clientX);
          }
        }, g = {
          moveHandler: (b) => (b.cancelable && (b.preventDefault(), b.stopPropagation()), d(b.touches[0].clientX), !1),
          upHandler: (b) => {
            var C;
            h == null || h.removeEventListener("touchmove", g.moveHandler), h == null || h.removeEventListener("touchend", g.upHandler), b.cancelable && (b.preventDefault(), b.stopPropagation()), m((C = b.touches[0]) == null ? void 0 : C.clientX);
          }
        }, x = ghe() ? {
          passive: !1
        } : !1;
        gh(i) ? (h == null || h.addEventListener("touchmove", g.moveHandler, x), h == null || h.addEventListener("touchend", g.upHandler, x)) : (h == null || h.addEventListener("mousemove", v.moveHandler, x), h == null || h.addEventListener("mouseup", v.upHandler, x)), t.setColumnSizingInfo((b) => ({
          ...b,
          startOffset: l,
          startSize: a,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? hh() : (n = e.initialState.columnSizingInfo) != null ? n : hh());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    };
  }
};
let yd = null;
function ghe() {
  if (typeof yd == "boolean") return yd;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return yd = e, yd;
}
function gh(e) {
  return e.type === "touchstart";
}
const vhe = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: kr("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const o = e.columns;
      return (n = o.length ? o.some((i) => i.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = Je(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), Qe(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = Je(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], Qe(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => Je(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), Qe(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, i) => ({
        ...o,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function bc(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const yhe = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, bhe = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: kr("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, o, i;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && ((i = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? i : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Ko.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return Zm(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : Ko[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, She = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: kr("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, i;
      e.setExpanded(r ? {} : (o = (i = e.initialState) == null ? void 0 : i.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((i) => {
        const a = i.split(".");
        r = Math.max(r, a.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var o;
        const i = r === !0 ? !0 : !!(r != null && r[e.id]);
        let a = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((s) => {
          a[s] = !0;
        }) : a = r, n = (o = n) != null ? o : !i, !i && n)
          return {
            ...a,
            [e.id]: !0
          };
        if (i && !n) {
          const {
            [e.id]: s,
            ...l
          } = a;
          return l;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, o;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, p1 = 0, h1 = 10, vh = () => ({
  pageIndex: p1,
  pageSize: h1
}), xhe = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...vh(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: kr("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (i) => ji(r, i);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? vh() : (o = e.initialState.pagination) != null ? o : vh());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let i = ji(r, o.pageIndex);
        const a = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, a)), {
          ...o,
          pageIndex: i
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, i;
      e.setPageIndex(r ? p1 : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? o : p1);
    }, e.resetPageSize = (r) => {
      var o, i;
      e.setPageSize(r ? h1 : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? o : h1);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const i = Math.max(1, ji(r, o.pageSize)), a = o.pageSize * o.pageIndex, s = Math.floor(a / i);
        return {
          ...o,
          pageIndex: s,
          pageSize: i
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var i;
      let a = ji(r, (i = e.options.pageCount) != null ? i : -1);
      return typeof a == "number" && (a = Math.max(-1, a)), {
        ...o,
        pageCount: a
      };
    }), e.getPageOptions = Je(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((i, a) => a)), o;
    }, Qe(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, yh = () => ({
  top: [],
  bottom: []
}), Che = {
  getInitialState: (e) => ({
    rowPinning: yh(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: kr("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, o) => {
      const i = r ? e.getLeafRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], a = o ? e.getParentRows().map((l) => {
        let {
          id: c
        } = l;
        return c;
      }) : [], s = /* @__PURE__ */ new Set([...a, e.id, ...i]);
      t.setRowPinning((l) => {
        var c, u;
        if (n === "bottom") {
          var d, m;
          return {
            top: ((d = l == null ? void 0 : l.top) != null ? d : []).filter((g) => !(s != null && s.has(g))),
            bottom: [...((m = l == null ? void 0 : l.bottom) != null ? m : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)]
          };
        }
        if (n === "top") {
          var h, v;
          return {
            top: [...((h = l == null ? void 0 : l.top) != null ? h : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)],
            bottom: ((v = l == null ? void 0 : l.bottom) != null ? v : []).filter((g) => !(s != null && s.has(g)))
          };
        }
        return {
          top: ((c = l == null ? void 0 : l.top) != null ? c : []).filter((g) => !(s != null && s.has(g))),
          bottom: ((u = l == null ? void 0 : l.bottom) != null ? u : []).filter((g) => !(s != null && s.has(g)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? o) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: o
      } = t.getState().rowPinning, i = n.some((s) => r == null ? void 0 : r.includes(s)), a = n.some((s) => o == null ? void 0 : o.includes(s));
      return i ? "top" : a ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      if (!o) return -1;
      const i = (n = o === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((a) => {
        let {
          id: s
        } = a;
        return s;
      });
      return (r = i == null ? void 0 : i.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? yh() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : yh());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var o, i;
        return !!((o = r.top) != null && o.length || (i = r.bottom) != null && i.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((a) => {
          const s = e.getRow(a, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((a) => t.find((s) => s.id === a))
      )).filter(Boolean).map((a) => ({
        ...a,
        position: r
      }));
    }, e.getTopRows = Je(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), Qe(e.options, "debugRows", "getTopRows")), e.getBottomRows = Je(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), Qe(e.options, "debugRows", "getBottomRows")), e.getCenterRows = Je(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((i) => !o.has(i.id));
    }, Qe(e.options, "debugRows", "getCenterRows"));
  }
}, whe = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: kr("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = e.getPreGroupedRowModel().flatRows;
        return t ? o.forEach((i) => {
          i.getCanSelect() && (r[i.id] = !0);
        }) : o.forEach((i) => {
          delete r[i.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return e.getRowModel().rows.forEach((i) => {
        g1(o, i.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = Je(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? bh(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Qe(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = Je(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? bh(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Qe(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = Je(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? bh(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Qe(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((o) => !n[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const o = e.getIsSelected();
      t.setRowSelection((i) => {
        var a;
        if (n = typeof n < "u" ? n : !o, e.getCanSelect() && o === n)
          return i;
        const s = {
          ...i
        };
        return g1(s, e.id, n, (a = r == null ? void 0 : r.selectChildren) != null ? a : !0, t), s;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return ny(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return v1(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return v1(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var o;
        n && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, g1 = (e, t, n, r, o) => {
  var i;
  const a = o.getRow(t, !0);
  n ? (a.getCanMultiSelect() || Object.keys(e).forEach((s) => delete e[s]), a.getCanSelect() && (e[t] = !0)) : delete e[t], r && (i = a.subRows) != null && i.length && a.getCanSelectSubRows() && a.subRows.forEach((s) => g1(e, s.id, n, r, o));
};
function bh(e, t) {
  const n = e.getState().rowSelection, r = [], o = {}, i = function(a, s) {
    return a.map((l) => {
      var c;
      const u = ny(l, n);
      if (u && (r.push(l), o[l.id] = l), (c = l.subRows) != null && c.length && (l = {
        ...l,
        subRows: i(l.subRows)
      }), u)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: i(t.rows),
    flatRows: r,
    rowsById: o
  };
}
function ny(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function v1(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let o = !0, i = !1;
  return e.subRows.forEach((a) => {
    if (!(i && !o) && (a.getCanSelect() && (ny(a, t) ? i = !0 : o = !1), a.subRows && a.subRows.length)) {
      const s = v1(a, t);
      s === "all" ? i = !0 : (s === "some" && (i = !0), o = !1);
    }
  }), o ? "all" : i ? "some" : !1;
}
const y1 = /([0-9]+)/gm, Ehe = (e, t, n) => OO(ta(e.getValue(n)).toLowerCase(), ta(t.getValue(n)).toLowerCase()), Ihe = (e, t, n) => OO(ta(e.getValue(n)), ta(t.getValue(n))), Rhe = (e, t, n) => ry(ta(e.getValue(n)).toLowerCase(), ta(t.getValue(n)).toLowerCase()), The = (e, t, n) => ry(ta(e.getValue(n)), ta(t.getValue(n))), _he = (e, t, n) => {
  const r = e.getValue(n), o = t.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, Ohe = (e, t, n) => ry(e.getValue(n), t.getValue(n));
function ry(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function ta(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function OO(e, t) {
  const n = e.split(y1).filter(Boolean), r = t.split(y1).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), i = r.shift(), a = parseInt(o, 10), s = parseInt(i, 10), l = [a, s].sort();
    if (isNaN(l[0])) {
      if (o > i)
        return 1;
      if (i > o)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(a) ? -1 : 1;
    if (a > s)
      return 1;
    if (s > a)
      return -1;
  }
  return n.length - r.length;
}
const Wl = {
  alphanumeric: Ehe,
  alphanumericCaseSensitive: Ihe,
  text: Rhe,
  textCaseSensitive: The,
  datetime: _he,
  basic: Ohe
}, Ahe = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: kr("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const i = o == null ? void 0 : o.getValue(e.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return Wl.datetime;
        if (typeof i == "string" && (r = !0, i.split(y1).length > 1))
          return Wl.alphanumeric;
      }
      return r ? Wl.text : Wl.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Zm(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : Wl[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const o = e.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      t.setSorting((a) => {
        const s = a == null ? void 0 : a.find((h) => h.id === e.id), l = a == null ? void 0 : a.findIndex((h) => h.id === e.id);
        let c = [], u, d = i ? n : o === "desc";
        if (a != null && a.length && e.getCanMultiSort() && r ? s ? u = "toggle" : u = "add" : a != null && a.length && l !== a.length - 1 ? u = "replace" : s ? u = "toggle" : u = "replace", u === "toggle" && (i || o || (u = "remove")), u === "add") {
          var m;
          c = [...a, {
            id: e.id,
            desc: d
          }], c.splice(0, c.length - ((m = t.options.maxMultiSortColCount) != null ? m : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? c = a.map((h) => h.id === e.id ? {
          ...h,
          desc: d
        } : h) : u === "remove" ? c = a.filter((h) => h.id !== e.id) : c = [{
          id: e.id,
          desc: d
        }];
        return c;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, o;
      const i = e.getFirstSortDir(), a = e.getIsSorted();
      return a ? a !== i && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = t.options.enableMultiRemove) != null) || o) ? !1 : a === "desc" ? "asc" : "desc" : i;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, khe = [
  Jpe,
  vhe,
  mhe,
  phe,
  ehe,
  the,
  yhe,
  //depends on ColumnFaceting
  bhe,
  //depends on ColumnFiltering
  Ahe,
  dhe,
  //depends on RowSorting
  She,
  xhe,
  Che,
  whe,
  hhe
];
function Dhe(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...khe, ...(t = e._features) != null ? t : []];
  let o = {
    _features: r
  };
  const i = o._features.reduce((m, h) => Object.assign(m, h.getDefaultOptions == null ? void 0 : h.getDefaultOptions(o)), {}), a = (m) => o.options.mergeOptions ? o.options.mergeOptions(i, m) : {
    ...i,
    ...m
  };
  let l = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  o._features.forEach((m) => {
    var h;
    l = (h = m.getInitialState == null ? void 0 : m.getInitialState(l)) != null ? h : l;
  });
  const c = [];
  let u = !1;
  const d = {
    _features: r,
    options: {
      ...i,
      ...e
    },
    initialState: l,
    _queue: (m) => {
      c.push(m), u || (u = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        u = !1;
      }).catch((h) => setTimeout(() => {
        throw h;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (m) => {
      const h = ji(m, o.options);
      o.options = a(h);
    },
    getState: () => o.options.state,
    setState: (m) => {
      o.options.onStateChange == null || o.options.onStateChange(m);
    },
    _getRowId: (m, h, v) => {
      var g;
      return (g = o.options.getRowId == null ? void 0 : o.options.getRowId(m, h, v)) != null ? g : `${v ? [v.id, h].join(".") : h}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (m, h) => {
      let v = (h ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[m];
      if (!v && (v = o.getCoreRowModel().rowsById[m], !v))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${m}`) : new Error();
      return v;
    },
    _getDefaultColumnDef: Je(() => [o.options.defaultColumn], (m) => {
      var h;
      return m = (h = m) != null ? h : {}, {
        header: (v) => {
          const g = v.header.column.columnDef;
          return g.accessorKey ? g.accessorKey : g.accessorFn ? g.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (v) => {
          var g, x;
          return (g = (x = v.renderValue()) == null || x.toString == null ? void 0 : x.toString()) != null ? g : null;
        },
        ...o._features.reduce((v, g) => Object.assign(v, g.getDefaultColumnDef == null ? void 0 : g.getDefaultColumnDef()), {}),
        ...m
      };
    }, Qe(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: Je(() => [o._getColumnDefs()], (m) => {
      const h = function(v, g, x) {
        return x === void 0 && (x = 0), v.map((b) => {
          const C = Xpe(o, b, x, g), I = b;
          return C.columns = I.columns ? h(I.columns, C, x + 1) : [], C;
        });
      };
      return h(m);
    }, Qe(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: Je(() => [o.getAllColumns()], (m) => m.flatMap((h) => h.getFlatColumns()), Qe(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: Je(() => [o.getAllFlatColumns()], (m) => m.reduce((h, v) => (h[v.id] = v, h), {}), Qe(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: Je(() => [o.getAllColumns(), o._getOrderColumnsFn()], (m, h) => {
      let v = m.flatMap((g) => g.getLeafColumns());
      return h(v);
    }, Qe(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (m) => {
      const h = o._getAllFlatColumnsById()[m];
      return process.env.NODE_ENV !== "production" && !h && console.error(`[Table] Column with id '${m}' does not exist.`), h;
    }
  };
  Object.assign(o, d);
  for (let m = 0; m < o._features.length; m++) {
    const h = o._features[m];
    h == null || h.createTable == null || h.createTable(o);
  }
  return o;
}
function Phe() {
  return (e) => Je(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, i, a) {
      i === void 0 && (i = 0);
      const s = [];
      for (let c = 0; c < o.length; c++) {
        const u = Qpe(e, e._getRowId(o[c], c, a), o[c], c, i, void 0, a == null ? void 0 : a.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, s.push(u), e.options.getSubRows) {
          var l;
          u.originalSubRows = e.options.getSubRows(o[c], c), (l = u.originalSubRows) != null && l.length && (u.subRows = r(u.originalSubRows, i + 1, u));
        }
      }
      return s;
    };
    return n.rows = r(t), n;
  }, Qe(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function Nhe() {
  return (e) => Je(() => [e.getState().expanded, e.getPreExpandedRowModel(), e.options.paginateExpandedRows], (t, n, r) => !n.rows.length || t !== !0 && !Object.keys(t ?? {}).length || !r ? n : Mhe(n), Qe(e.options, "debugTable", "getExpandedRowModel"));
}
function Mhe(e) {
  const t = [], n = (r) => {
    var o;
    t.push(r), (o = r.subRows) != null && o.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function yS(e, t) {
  return e ? Fhe(e) ? /* @__PURE__ */ S.createElement(e, t) : e : null;
}
function Fhe(e) {
  return Lhe(e) || typeof e == "function" || $he(e);
}
function Lhe(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function $he(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function zhe(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = S.useState(() => ({
    current: Dhe(t)
  })), [r, o] = S.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (a) => {
      o(a), e.onStateChange == null || e.onStateChange(a);
    }
  })), n.current;
}
function Sh({
  title: e,
  icon: t,
  details: n,
  action: r
}) {
  return /* @__PURE__ */ f.jsxs("section", { className: "flex flex-col items-center justify-center gap-4 p-8 text-sm", children: [
    /* @__PURE__ */ f.jsxs("header", { className: "flex flex-col items-center gap-2 text-xl font-semibold", children: [
      /* @__PURE__ */ f.jsx(Ve, { icon: t, className: "size-10 text-neutral-500" }),
      /* @__PURE__ */ f.jsx("h2", { children: e })
    ] }),
    n,
    r && /* @__PURE__ */ f.jsx(Fn, { onClick: r.onClick, children: r.label })
  ] });
}
function oy({
  data: e,
  columns: t,
  caption: n,
  onRowClick: r,
  getSubRows: o
}) {
  const i = zhe({
    data: e,
    columns: t,
    getCoreRowModel: Phe(),
    getSubRows: o,
    getExpandedRowModel: Nhe()
  });
  return /* @__PURE__ */ f.jsx("div", { className: "relative overflow-auto", children: /* @__PURE__ */ f.jsxs("table", { className: "min-w-full", children: [
    n && /* @__PURE__ */ f.jsx("caption", { className: "sr-only", children: n }),
    /* @__PURE__ */ f.jsx("thead", { children: i.getHeaderGroups().map((a) => /* @__PURE__ */ f.jsx("tr", { children: a.headers.map((s) => /* @__PURE__ */ f.jsx(
      "th",
      {
        className: "sticky top-0 bg-neutral-100 py-2 pr-3 pl-4 text-left text-xs font-semibold text-neutral-900 sm:pl-6 lg:pl-8",
        children: yS(
          s.column.columnDef.header,
          s.getContext()
        )
      },
      s.id
    )) }, a.id)) }),
    /* @__PURE__ */ f.jsx("tbody", { children: i.getRowModel().rows.map((a) => /* @__PURE__ */ f.jsx(
      "tr",
      {
        className: oe(
          "group/row hover:bg-neutral-100",
          a.depth > 0 && "bg-neutral-50",
          r && "cursor-pointer"
        ),
        tabIndex: 0,
        onClick: () => r == null ? void 0 : r(a.original),
        children: a.getVisibleCells().map((s, l) => {
          const c = yS(
            s.column.columnDef.cell,
            s.getContext()
          );
          return /* @__PURE__ */ f.jsxs(
            "td",
            {
              className: oe(
                "py-2 pr-3 pl-4 text-xs text-neutral-800 group-not-last/row:border-b group-not-last/row:border-neutral-200 sm:pl-6 lg:pl-8",
                a.depth > 0 && "text-neutral-600"
              ),
              children: [
                l === 0 && a.getCanExpand() && /* @__PURE__ */ f.jsxs(
                  "button",
                  {
                    type: "button",
                    "aria-expanded": a.getIsExpanded(),
                    onClick: (u) => {
                      u.stopPropagation(), a.toggleExpanded();
                    },
                    style: { marginLeft: `${a.depth - 1.25}rem` },
                    className: "flex cursor-pointer items-center gap-2 rounded-sm font-medium focus-visible:ring-2 focus-visible:ring-corso-blue-600 focus-visible:outline-hidden",
                    children: [
                      /* @__PURE__ */ f.jsx(
                        Ve,
                        {
                          icon: "chevronRight",
                          className: oe(
                            "size-3 text-neutral-500 transition-transform",
                            a.getIsExpanded() && "rotate-90"
                          )
                        }
                      ),
                      c
                    ]
                  }
                ),
                l === 0 && !a.getCanExpand() && a.depth > 0 && /* @__PURE__ */ f.jsx("span", { style: { paddingLeft: `${a.depth}rem` }, children: c }),
                (l > 0 || !a.getCanExpand() && a.depth === 0) && c
              ]
            },
            s.id
          );
        })
      },
      a.id
    )) })
  ] }) });
}
const Hve = It(({ className: e, indeterminate: t, ...n }, r) => {
  const o = He(null), i = r ?? o;
  return Le(() => {
    "current" in i && i.current && (i.current.indeterminate = t ?? !1);
  }, [i, t]), /* @__PURE__ */ f.jsx(
    "input",
    {
      ref: i,
      type: "checkbox",
      className: oe(
        "h-5 w-5 rounded-md text-corso-blue-600 shadow-xs ring-1 ring-neutral-300 ring-inset focus-within:ring-2 focus-within:ring-corso-blue-600 focus-within:ring-inset disabled:cursor-not-allowed disabled:bg-neutral-400 disabled:text-neutral-500 disabled:ring-neutral-200",
        e
      ),
      ...n
    }
  );
}), jhe = qr("flex flex-col gap-1 [&[hidden]]:hidden"), al = It(
  ({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
    "div",
    {
      className: oe(jhe({ className: e })),
      ref: n,
      ...t
    }
  )
);
al.displayName = "FieldGroup";
function fr({
  children: e,
  className: t,
  error: n,
  ...r
}) {
  return /* @__PURE__ */ f.jsx(
    "span",
    {
      ...r,
      className: oe(
        "text-xs text-neutral-500",
        n && "text-red-600",
        t
      ),
      role: n ? "alert" : void 0,
      children: e
    }
  );
}
function bS({
  children: e,
  position: t = "end"
}) {
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: oe(
        "flex items-center gap-1 text-sm text-neutral-500 select-none peer-invalid:text-red-600",
        t === "start" ? "order-first" : "order-last"
      ),
      children: e
    }
  );
}
const ss = It(
  ({
    id: e,
    label: t,
    labelVisuallyHidden: n = !1,
    visuallyRequired: r = !1,
    value: o,
    details: i,
    error: a,
    addon: {
      insideStart: s = null,
      insideEnd: l = null,
      outsideStart: c = null,
      outsideEnd: u = null
    } = {},
    // additional native input props, extracted for extra usage and then propagated to the `input` element
    type: d,
    required: m,
    hidden: h,
    className: v,
    onChange: g,
    ...x
  }, b) => {
    const C = `${e}-details`, I = `${e}-error`, T = He(null), [R, A] = Fe(null);
    return fk(b, () => T.current), Le(() => {
      const _ = T.current, k = (M) => {
        M.preventDefault();
      };
      return _ && (_.addEventListener("invalid", k), _.setCustomValidity(a ? "Invalid" : "")), () => {
        _ == null || _.removeEventListener("invalid", k);
      };
    }, [a]), /* @__PURE__ */ f.jsxs(al, { className: v, "data-testid": e, hidden: h, children: [
      /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: oe(
            "flex items-center justify-between",
            n && "sr-only"
            // applied to label group wrapper
          ),
          children: [
            /* @__PURE__ */ f.jsx(pi, { htmlFor: e, children: t }),
            r || m ? /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Required" }) : /* @__PURE__ */ f.jsx(fr, { children: "Optional" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-2 md:flex-row", children: [
        c,
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            className: oe(
              // base styles for default/neutral state
              "flex w-full gap-1 rounded-md px-3 py-1.5 text-sm leading-6 text-neutral-800 shadow-xs ring-1 ring-neutral-300 ring-inset focus-within:ring-2 focus-within:ring-corso-blue-600",
              // disabled styles; the `disabled:`
              "has-disabled:cursor-not-allowed has-disabled:bg-neutral-50 has-disabled:text-neutral-500 has-disabled:ring-neutral-200",
              // error state style overrides
              "has-user-invalid:text-red-900 has-user-invalid:ring-red-300 has-user-invalid:focus-within:ring-red-600"
            ),
            children: [
              /* @__PURE__ */ f.jsx(
                "input",
                {
                  ...x,
                  onChange: (_) => {
                    g == null || g(_), A(null), _.currentTarget.checkValidity();
                  },
                  onBlur: (_) => {
                    A(null), _.currentTarget.checkValidity();
                  },
                  onInvalid: (_) => A(_.currentTarget.validationMessage),
                  id: e,
                  className: oe(
                    "peer w-full flex-1 border-none bg-transparent p-0 text-sm placeholder:text-neutral-400 focus:ring-0",
                    // error state styles
                    "user-invalid:text-red-900 user-invalid:ring-red-300 user-invalid:placeholder:text-red-300 user-invalid:focus:ring-red-600",
                    // file selector button styles
                    "file:rounded-md file:border-0 file:bg-transparent file:text-neutral-800 file:ring-1 file:ring-neutral-300 file:ring-inset file:user-invalid:text-red-900 file:user-invalid:ring-red-300 focus:outline-0 file:focus:ring-2 file:focus:ring-corso-blue-600 file:user-invalid:focus:ring-red-600"
                  ),
                  "aria-describedby": [i && C, a && I].filter(Boolean).join(" "),
                  type: d,
                  "aria-required": r || m,
                  required: m,
                  ref: T,
                  value: o !== void 0 ? o ?? "" : void 0
                }
              ),
              s && /* @__PURE__ */ f.jsx(bS, { position: "start", children: s }),
              l && /* @__PURE__ */ f.jsx(bS, { position: "end", children: l })
            ]
          }
        ),
        u
      ] }),
      a && /* @__PURE__ */ f.jsx(fr, { error: !0, id: I, "data-error": "custom", children: a }),
      !a && !!(R != null && R.length) && R !== "Invalid" && /* @__PURE__ */ f.jsx(fr, { error: !0, id: I, "data-error": "native", children: R }),
      i && /* @__PURE__ */ f.jsx(fr, { id: C, children: i })
    ] });
  }
), qve = It(
  ({
    id: e,
    onChange: t,
    value: n,
    ...r
  }, o) => {
    const a = `#${((n == null ? void 0 : n.trim().toLowerCase()) ?? "").replace(/[^0-9a-f]/g, "")}`, s = Ke(
      (l) => {
        const c = `#${l.target.value.toLowerCase().replace(/[^0-9a-f]/g, "")}`;
        t(c);
      },
      [t]
    );
    return /* @__PURE__ */ f.jsx(
      ss,
      {
        type: "text",
        id: e,
        value: a,
        onChange: s,
        pattern: "^#[0-9a-f]{6}$",
        ...r,
        addon: {
          insideStart: /* @__PURE__ */ f.jsxs(
            "label",
            {
              className: "block size-6 rounded-md border",
              style: {
                background: /^#[0-9a-f]{6}$/i.test(a) ? a : "#000000"
              },
              children: [
                /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Pick a color" }),
                /* @__PURE__ */ f.jsx(
                  "input",
                  {
                    type: "color",
                    className: "sr-only",
                    value: a,
                    onChange: s,
                    ref: o,
                    ...r
                  }
                )
              ]
            }
          ),
          insideEnd: "HEX"
        }
      }
    );
  }
);
function AO() {
  return (/* @__PURE__ */ new Date()).getTimezoneOffset() * 6e4;
}
function Bhe(e) {
  const t = new Date(e);
  return new Date(
    t.getTime() + AO()
  ).toISOString();
}
function Ghe(e) {
  const t = new Date(e);
  return new Date(
    t.getTime() - AO()
  ).toISOString();
}
const Yve = It(
  ({
    value: e,
    onChange: t,
    ...n
  }, r) => /* @__PURE__ */ f.jsx(
    ss,
    {
      type: "date",
      ref: r,
      value: e ? Ghe(e).substring(0, 10) : "",
      onChange: (o) => {
        t(o.target.value ? Bhe(o.target.value) : "");
      },
      ...n
    }
  )
), Kve = It(
  ({ ...e }, t) => /* @__PURE__ */ f.jsx(ss, { type: "email", ref: t, ...e })
);
function Zve({
  legend: e,
  children: t
}) {
  return /* @__PURE__ */ f.jsxs("fieldset", { className: "rounded-md border p-4 pt-2", children: [
    /* @__PURE__ */ f.jsx("legend", { className: "rounded-md border px-2 py-1 text-xs", children: e }),
    t
  ] });
}
function Vhe(e, t = 2) {
  if (e === 0)
    return "0 bytes";
  const n = 1024, r = t < 0 ? 0 : t, o = [
    "bytes",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB",
    "EB",
    "ZB",
    "YB"
  ], i = Math.floor(Math.log(e) / Math.log(n)), a = Math.min(i, o.length - 1);
  return `${parseFloat((e / n ** a).toFixed(r))} ${o[a] ?? ""}`.trim();
}
const Xve = It(
  ({
    id: e,
    label: t,
    labelVisuallyHidden: n = !1,
    visuallyRequired: r = !1,
    details: o,
    error: i,
    required: a,
    hidden: s,
    className: l,
    multiple: c,
    onChange: u,
    ...d
  }, m) => {
    const [h, v] = Fe([]), [g, x] = Fe(!1), b = `${e}-details`, C = `${e}-error`;
    return /* @__PURE__ */ f.jsxs(al, { className: l, "data-testid": e, hidden: s, children: [
      /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: oe(
            "flex items-center justify-between",
            n && "sr-only"
          ),
          children: [
            /* @__PURE__ */ f.jsx(pi, { htmlFor: e, children: t }),
            r || a ? /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Required" }) : /* @__PURE__ */ f.jsx(fr, { children: "Optional" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: oe(
            "relative flex w-full flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-neutral-300 bg-neutral-50 p-4 text-center text-sm text-neutral-600 focus-within:border-corso-blue-600 focus-within:brightness-97 hover:brightness-97",
            "has-disabled:cursor-not-allowed has-disabled:opacity-60 has-disabled:hover:brightness-100",
            g && "border-corso-blue-600 brightness-97",
            i && "border-red-600"
          ),
          children: [
            /* @__PURE__ */ f.jsx(Ve, { icon: "upload", className: "size-10" }),
            /* @__PURE__ */ f.jsx("span", { children: g ? "Drop to add" : `Drag and drop your ${c ? "files" : "file"} here or click to browse` }),
            o && /* @__PURE__ */ f.jsx("span", { id: b, children: o }),
            /* @__PURE__ */ f.jsx(
              "input",
              {
                ...d,
                id: e,
                ref: m,
                type: "file",
                multiple: c,
                required: a,
                "aria-required": r || a,
                "aria-describedby": [o && b, i && C].filter(Boolean).join(" "),
                className: "absolute inset-0 cursor-pointer opacity-0 disabled:cursor-not-allowed",
                onDragEnter: () => x(!0),
                onDragLeave: () => x(!1),
                onDrop: () => x(!1),
                onChange: (I) => {
                  v(Array.from(I.currentTarget.files ?? [])), u == null || u(I);
                }
              }
            )
          ]
        }
      ),
      !!h.length && /* @__PURE__ */ f.jsx("ul", { className: "flex flex-col gap-1", children: h.map(({ name: I, size: T }) => /* @__PURE__ */ f.jsxs(
        "li",
        {
          className: "flex items-center gap-2 text-sm text-neutral-800",
          children: [
            /* @__PURE__ */ f.jsx(Ve, { icon: "file", className: "text-neutral-500" }),
            /* @__PURE__ */ f.jsx("span", { className: "min-w-0 truncate", children: I }),
            /* @__PURE__ */ f.jsx(fr, { children: Vhe(T, 1) })
          ]
        },
        I
      )) }),
      i && /* @__PURE__ */ f.jsx(fr, { error: !0, id: C, children: i })
    ] });
  }
), Jve = It(
  ({ ...e }, t) => /* @__PURE__ */ f.jsx(ss, { type: "number", ref: t, ...e })
), Qve = It(
  ({ error: e, ...t }, n) => {
    const [r, o] = Fe(!1);
    return /* @__PURE__ */ f.jsx(
      ss,
      {
        type: r ? "text" : "password",
        ref: n,
        error: e,
        ...t,
        addon: {
          insideEnd: /* @__PURE__ */ f.jsxs(
            "button",
            {
              type: "button",
              className: oe(
                "rounded-md focus:ring-2 focus:ring-corso-blue-600 focus:ring-offset-2 focus:outline-hidden",
                !!e && "focus:ring-red-600"
              ),
              onClick: () => o((i) => !i),
              children: [
                /* @__PURE__ */ f.jsxs("span", { className: "sr-only", children: [
                  r ? "Hide" : "Show",
                  " password"
                ] }),
                r ? /* @__PURE__ */ f.jsx(Ve, { icon: "eyeSlash", className: "size-4" }) : /* @__PURE__ */ f.jsx(Ve, { icon: "eye", className: "size-4" })
              ]
            }
          )
        }
      }
    );
  }
);
function e2e({
  id: e,
  label: t,
  labelVisuallyHidden: n = !1,
  details: r,
  error: o = !1,
  value: i,
  onChange: a,
  options: s,
  disabled: l = !1
}) {
  const c = Ke(
    (m) => {
      a(m.target.value);
    },
    [a]
  ), u = `${e}-details`, d = `${e}-error`;
  return /* @__PURE__ */ f.jsxs("div", { children: [
    /* @__PURE__ */ f.jsx(
      "p",
      {
        className: oe(
          "flex items-center gap-1 text-sm leading-6 font-medium text-neutral-800",
          n && "sr-only"
        ),
        children: t
      }
    ),
    o && /* @__PURE__ */ f.jsx(fr, { error: !0, id: d, children: o }),
    r && /* @__PURE__ */ f.jsx(fr, { id: u, children: r }),
    /* @__PURE__ */ f.jsxs("fieldset", { className: oe(n ? "mt-4" : "mt-2"), children: [
      /* @__PURE__ */ f.jsx("legend", { className: "sr-only", children: t }),
      /* @__PURE__ */ f.jsx("div", { className: "space-y-4", children: Object.entries(s).map(([m, h]) => /* @__PURE__ */ f.jsxs("div", { className: "flex items-center", children: [
        /* @__PURE__ */ f.jsx(
          "input",
          {
            id: `${e}-${m}`,
            name: e,
            type: "radio",
            value: m,
            disabled: l,
            checked: i === m,
            onChange: c,
            className: oe(
              "h-4 w-4 border-neutral-300 text-corso-blue-600 accent-corso-blue-600 focus:ring-corso-blue-600 disabled:cursor-not-allowed disabled:opacity-50"
            )
          }
        ),
        /* @__PURE__ */ f.jsx(
          "label",
          {
            htmlFor: `${e}-${m}`,
            className: "ml-3 block text-sm text-neutral-800",
            children: h
          }
        )
      ] }, m)) })
    ] })
  ] });
}
function Uhe(...e) {
  const t = He(null);
  return Le(() => {
    e.forEach((n) => {
      n && (typeof n == "function" ? n(t.current) : n.current = t.current);
    });
  }, [e]), t;
}
const t2e = It(
  ({
    id: e,
    label: t,
    name: n,
    checked: r,
    defaultChecked: o,
    onChange: i,
    details: a,
    disabled: s,
    error: l,
    labelVisuallyHidden: c = !1,
    hidden: u = !1,
    ...d
  }, m) => {
    const h = r ?? o ?? !1, v = He(null), g = Uhe(m, v), x = `${e}-details`, b = `${e}-error`;
    return /* @__PURE__ */ f.jsxs("div", { className: "flex items-center justify-between gap-2", hidden: u, children: [
      /* @__PURE__ */ f.jsxs("span", { className: "flex grow flex-col", children: [
        /* @__PURE__ */ f.jsx(pi, { htmlFor: e, className: oe(c && "sr-only"), children: t }),
        l && /* @__PURE__ */ f.jsx(fr, { error: !0, id: b, children: l }),
        /* @__PURE__ */ f.jsx(fr, { id: x, children: a })
      ] }),
      /* @__PURE__ */ f.jsx(
        "input",
        {
          className: "hidden",
          type: "checkbox",
          name: n,
          id: e,
          "aria-invalid": !!l,
          "aria-describedby": [a && x, l && b].filter(Boolean).join(" "),
          checked: r,
          defaultChecked: o,
          onChange: i,
          ref: g,
          disabled: s,
          ...d
        }
      ),
      /* @__PURE__ */ f.jsx(
        "button",
        {
          id: `${e}-switch-button`,
          "aria-label": h ? `Toggle ${t} off` : `Toggle ${t} on`,
          type: "button",
          className: oe(
            "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-neutral-300 transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-corso-blue-600 focus:ring-offset-2 focus:outline-hidden",
            "disabled:cursor-not-allowed disabled:opacity-60",
            h && "bg-corso-blue-600 disabled:bg-corso-blue-600"
          ),
          disabled: s,
          onClick: () => {
            var C;
            (C = g.current) == null || C.click();
          },
          children: /* @__PURE__ */ f.jsx(
            "span",
            {
              "aria-hidden": "true",
              className: oe(
                h ? "translate-x-5" : "translate-x-0",
                "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out"
              )
            }
          )
        }
      )
    ] });
  }
), n2e = It(
  ({
    id: e,
    label: t,
    labelVisuallyHidden: n = !1,
    details: r,
    error: o,
    required: i,
    disabled: a,
    hidden: s,
    rows: l = 5,
    ...c
  }, u) => {
    const d = `${e}-details`, m = `${e}-error`;
    return /* @__PURE__ */ f.jsxs(al, { hidden: s, children: [
      /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: oe(
            "flex items-center justify-between",
            n && "sr-only"
            // applied to label group wrapper
          ),
          children: [
            /* @__PURE__ */ f.jsx(pi, { htmlFor: e, children: t }),
            i ? /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Required" }) : /* @__PURE__ */ f.jsx(fr, { children: "Optional" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(
        "div",
        {
          className: oe(
            // base styles for default/neutral state
            "flex w-full gap-1 rounded-md px-3 py-1.5 text-neutral-800 shadow-xs ring-1 ring-neutral-300 ring-inset focus-within:ring-2 focus-within:ring-corso-blue-600 focus-within:ring-inset sm:text-sm sm:leading-6",
            // disabled styles; the `disabled:` pseudo-class won't work on this wrapper, as it's needed on the `input` itself
            a && "cursor-not-allowed bg-neutral-50 text-neutral-500 ring-neutral-200",
            // error state style overrides
            !!o && "text-red-900 ring-red-300 focus-within:ring-red-600"
          ),
          children: /* @__PURE__ */ f.jsx(
            "textarea",
            {
              id: e,
              className: oe(
                "flex-1 border-0 bg-transparent p-0 text-sm text-ellipsis focus:ring-0",
                "placeholder:text-neutral-400",
                !!o && "placeholder:text-red-300"
                // file selector button styles
              ),
              "aria-invalid": !!o,
              "aria-describedby": [r && d, o && m].filter(Boolean).join(" "),
              required: i,
              disabled: a,
              ref: u,
              rows: l,
              ...c
            }
          )
        }
      ),
      o && /* @__PURE__ */ f.jsx(fr, { error: !0, id: m, children: o }),
      r && /* @__PURE__ */ f.jsx(fr, { id: d, children: r })
    ] });
  }
), kO = It(
  ({ ...e }, t) => /* @__PURE__ */ f.jsx(ss, { type: "text", ref: t, ...e })
), r2e = It(
  ({ ...e }, t) => /* @__PURE__ */ f.jsx(ss, { type: "url", ref: t, ...e })
);
function Es(e, t, n) {
  let r = n.initialDeps ?? [], o;
  return () => {
    var i, a, s, l;
    let c;
    n.key && ((i = n.debug) != null && i.call(n)) && (c = Date.now());
    const u = e();
    if (!(u.length !== r.length || u.some((h, v) => r[v] !== h)))
      return o;
    r = u;
    let m;
    if (n.key && ((a = n.debug) != null && a.call(n)) && (m = Date.now()), o = t(...u), n.key && ((s = n.debug) != null && s.call(n))) {
      const h = Math.round((Date.now() - c) * 100) / 100, v = Math.round((Date.now() - m) * 100) / 100, g = v / 16, x = (b, C) => {
        for (b = String(b); b.length < C; )
          b = " " + b;
        return b;
      };
      console.info(
        `%c⏱ ${x(v, 5)} /${x(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (l = n == null ? void 0 : n.onChange) == null || l.call(n, o), o;
  };
}
function xh(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const Whe = (e, t) => Math.abs(e - t) < 1, Hhe = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, qhe = (e) => e, Yhe = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, Khe = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (a) => {
    const { width: s, height: l } = a;
    t({ width: Math.round(s), height: Math.round(l) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((a) => {
    const s = a[0];
    if (s != null && s.borderBoxSize) {
      const l = s.borderBoxSize[0];
      if (l) {
        o({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    o(n.getBoundingClientRect());
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, SS = {
  passive: !0
}, Zhe = typeof window > "u" ? !0 : "onscrollend" in window, Xhe = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const i = Zhe ? () => {
  } : Hhe(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), a = (c) => () => {
    const { horizontal: u, isRtl: d } = e.options;
    o = u ? n.scrollLeft * (d && -1 || 1) : n.scrollTop, i(), t(o, c);
  }, s = a(!0), l = a(!1);
  return l(), n.addEventListener("scroll", s, SS), n.addEventListener("scrollend", l, SS), () => {
    n.removeEventListener("scroll", s), n.removeEventListener("scrollend", l);
  };
}, Jhe = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, Qhe = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  const a = e + t;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: a,
    behavior: n
  });
};
let ege = class {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var o;
          return (o = r()) == null ? void 0 : o.disconnect();
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: qhe,
        rangeExtractor: Yhe,
        onChange: () => {
        },
        measureElement: Jhe,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, o;
      (o = (r = this.options).onChange) == null || o.call(r, this, n);
    }, this.maybeNotify = Es(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.observer.disconnect(), this.elementsCache.clear();
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let a = r - 1; a >= 0; a--) {
        const s = n[a];
        if (o.has(s.lane))
          continue;
        const l = i.get(
          s.lane
        );
        if (l == null || s.end > l.end ? i.set(s.lane, s) : s.end < l.end && o.set(s.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((a, s) => a.end === s.end ? a.index - s.index : a.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = Es(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, i, a) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: a
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Es(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: i, enabled: a }, s) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let u = l; u < n; u++) {
          const d = i(u), m = this.options.lanes === 1 ? c[u - 1] : this.getFurthestMeasurement(c, u), h = m ? m.end + this.options.gap : r + o, v = s.get(d), g = typeof v == "number" ? v : this.options.estimateSize(u), x = h + g, b = m ? m.lane : u % this.options.lanes;
          c[u] = {
            index: u,
            start: h,
            size: g,
            end: x,
            key: d,
            lane: b
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Es(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, o) => this.range = n.length > 0 && r > 0 ? tge({
        measurements: n,
        outerSize: r,
        scrollOffset: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Es(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, o, i) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: o,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), i = this.measurementsCache[o];
      if (!i)
        return;
      const a = i.key, s = this.elementsCache.get(a);
      s !== n && (s && this.observer.unobserve(s), this.observer.observe(n), this.elementsCache.set(a, n)), n.isConnected && this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.itemSizeCache.get(o.key) ?? o.size, a = r - i;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, a, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", a), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, o) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(o));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = Es(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, a = n.length; i < a; i++) {
          const s = n[i], l = r[s];
          o.push(l);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return xh(
          r[DO(
            0,
            r.length - 1,
            (o) => xh(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const o = this.getSize(), i = this.getScrollOffset();
      r === "auto" && (n <= i ? r = "start" : n >= i + o ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - o : r === "center" && (n = n - o / 2);
      const a = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[a] : this.scrollElement[a] : 0) - o;
      return Math.max(Math.min(l, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.getSize(), a = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= a + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= a + this.options.scrollPaddingStart)
          r = "start";
        else
          return [a, r];
      const s = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(s, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, r);
      if (!i) return;
      const [a, s] = i;
      this._scrollToOffset(a, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [c] = xh(
            this.getOffsetForIndex(n, s)
          );
          Whe(c, this.getScrollOffset()) || this.scrollToIndex(n, { align: s, behavior: o });
        } else
          this.scrollToIndex(n, { align: s, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      return r.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((i) => i.end)
      ), o - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
};
const DO = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function tge({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, i = DO(0, r, (s) => e[s].start, n);
  let a = i;
  for (; a < r && e[a].end < n + t; )
    a++;
  return { startIndex: i, endIndex: a };
}
const nge = typeof document < "u" ? S.useLayoutEffect : S.useEffect;
function rge(e) {
  const t = S.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, i) => {
      var a;
      i ? F1(t) : t(), (a = e.onChange) == null || a.call(e, o, i);
    }
  }, [r] = S.useState(
    () => new ege(n)
  );
  return r.setOptions(n), S.useEffect(() => r._didMount(), []), nge(() => r._willUpdate()), r;
}
function oge(e) {
  return rge({
    observeElementRect: Khe,
    observeElementOffset: Xhe,
    scrollToFn: Qhe,
    ...e
  });
}
const ige = 10;
function age({
  items: e,
  estimateSize: t,
  children: n,
  visibleCount: r = ige
}) {
  var c, u;
  const o = He(null), i = oge({
    count: e.length,
    getScrollElement: () => o.current,
    estimateSize: t
  });
  if (!e.length) return null;
  const a = i.getTotalSize(), s = Math.floor(a / e.length), l = i.getVirtualItems();
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: o,
      className: "max-h-(--virtual-wrapper-height) w-full overflow-auto",
      style: {
        "--virtual-wrapper-height": `min(${r * s}px, 50svh)`
      },
      "data-virtual-root": !0,
      children: /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: "h-(--virtual-height) w-full",
          style: { "--virtual-height": `${a}px` },
          children: [
            /* @__PURE__ */ f.jsx(
              "div",
              {
                "data-virtual-spacer": "top",
                className: "h-(--virtual-spacer-size)",
                style: {
                  "--virtual-spacer-size": `${((c = l.at(0)) == null ? void 0 : c.start) ?? 0}px`
                }
              }
            ),
            l.map((d) => {
              const m = e[d.index];
              return m === void 0 ? null : /* @__PURE__ */ f.jsx(
                "div",
                {
                  "data-virtual-item": !0,
                  "data-index": d.index,
                  ref: i.measureElement,
                  children: n(m, d.index)
                },
                d.key
              );
            }),
            /* @__PURE__ */ f.jsx(
              "div",
              {
                "data-virtual-spacer": "bottom",
                className: "h-(--virtual-spacer-size)",
                style: {
                  "--virtual-spacer-size": `${a - (((u = l.at(-1)) == null ? void 0 : u.end) ?? 0)}px`
                }
              }
            )
          ]
        }
      )
    }
  );
}
function Ch(e, t) {
  return e.some(
    (n) => "options" in n ? n.options.some((r) => r.value === t) : n.value === t
  );
}
function iy({
  options: e,
  value: t = [],
  onChange: n,
  emptyLabel: r,
  placeholder: o,
  viewSelectedThreshold: i = 10,
  estimatedSize: a = 32,
  creatable: s = !1,
  clearable: l = !1,
  togglable: c = !1
}) {
  const [u, d] = Fe(null), [m, h] = Fe(""), [v, g] = Fe(
    t.filter((F) => !Ch(e, F.value))
  );
  Le(() => {
    g((F) => {
      const Z = t.filter((ae) => !Ch(e, ae.value));
      return [...F.filter(
        (ae) => !Ch(e, ae.value) && !Z.some((ue) => ue.value === ae.value)
      ), ...Z];
    });
  }, [t, e]);
  const x = Ke(
    (F) => {
      n == null || n(t.filter((Z) => Z.value !== F.value));
    },
    [n, t]
  ), b = Ke(
    (F) => t.some((Z) => Z.value === F.value),
    [t]
  ), C = Be(
    () => new Map(
      e.filter((F) => "options" in F).map((F) => [F.label, F])
    ),
    [e]
  ), I = Ke(
    (F) => {
      const { options: Z } = C.get(F.label) ?? F, se = Z.filter(b).length;
      return se ? se === Z.length ? "all" : "some" : "none";
    },
    [C, b]
  ), T = Ke(
    (F) => {
      const Z = new Set(
        F.options.map((ue) => ue.value)
      );
      if (I(F) === "all") {
        n == null || n(
          t.filter((ue) => !Z.has(ue.value))
        );
        return;
      }
      const ae = new Map(
        t.map((ue) => [ue.value, ue])
      );
      F.options.forEach((ue) => {
        ae.set(ue.value, ue);
      }), n == null || n([...ae.values()]);
    },
    [I, n, t]
  ), [R, A] = Fe(!1), _ = Be(
    () => m.trim().toLowerCase(),
    [m]
  ), k = Ke(
    (F) => [
      F.value,
      ...F.keywords ?? [],
      ...typeof F.label == "string" ? [F.label] : []
    ].some(
      (se) => se.toLowerCase().includes(_)
    ),
    [_]
  ), M = Ke(
    (F) => [F.label, ...F.keywords ?? []].some(
      (se) => se.toLowerCase().includes(_)
    ),
    [_]
  ), j = Be(
    () => e.map((F) => {
      if ("value" in F)
        return k(F) ? F : void 0;
      if (M(F) && F.options.length)
        return F;
      const Z = {
        ...F,
        options: F.options.filter(k)
      };
      return Z.options.length ? Z : void 0;
    }).filter(Gi).map((F) => {
      if (!R) return F;
      if ("value" in F) return b(F) ? F : void 0;
      const Z = {
        ...F,
        options: F.options.filter(
          (se) => b(se)
        )
      };
      return Z.options.length ? Z : void 0;
    }).filter(Gi),
    [
      e,
      M,
      k,
      R,
      b
    ]
  ), G = Be(
    () => j.filter((F) => "options" in F),
    [j]
  ), U = Be(
    () => u ? G.find((F) => F.label === u) : void 0,
    [u, G]
  );
  Le(() => {
    u && (U || d(null));
  }, [U, u]);
  const B = Be(
    () => v.filter(k),
    [v, k]
  ), K = Be(
    () => [B, j].flat().flatMap((F) => "options" in F ? F.options : F),
    [B, j]
  ), ee = Be(
    () => U ? U.options : K,
    [U, K]
  );
  Le(() => {
    const F = e.flatMap(
      (se) => "options" in se ? se.options.map((ae) => ae.value) : se.value
    );
    new Set(F).size !== F.length && console.warn(
      `${iy.name}: Duplicate values found across options, this may lead to unexpected behavior.`
    );
  }, [e]), Le(() => {
    !t.length && R && A(!1);
  }, [R, t.length]);
  const Y = Be(
    () => [
      // meta item: clear
      ...l || c ? [
        {
          value: "meta-clear",
          disabled: !ee.some((F) => b(F)),
          onSelect: () => {
            const F = new Set(
              ee.map((Z) => Z.value)
            );
            n == null || n(
              t.filter((Z) => !F.has(Z.value))
            );
          },
          children: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
            /* @__PURE__ */ f.jsx(Ve, { icon: "close", className: "mr-2" }),
            "Clear"
          ] })
        }
      ] : [],
      // meta item: toggle to select all
      ...c && ee.length ? [
        {
          value: "meta-toggle",
          disabled: ee.every((F) => b(F)),
          onSelect: () => {
            const F = ee.every(
              (se) => b(se)
            ), Z = new Set(
              ee.map((se) => se.value)
            );
            if (F)
              n == null || n(
                t.filter((se) => !Z.has(se.value))
              );
            else {
              const se = new Map(t.map((ae) => [ae.value, ae]));
              ee.forEach((ae) => se.set(ae.value, ae)), n == null || n([...se.values()]);
            }
          },
          children: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
            /* @__PURE__ */ f.jsx(Ve, { icon: "add", className: "mr-2" }),
            "Select All"
          ] })
        }
      ] : [],
      // meta item: create a new item
      ...s && m && j.every(
        (F) => "options" in F ? F.options.every(
          (Z) => Z.value !== m
        ) : F.value !== m
      ) ? [
        {
          value: "meta-create",
          onSelect: () => {
            const F = {
              value: m,
              label: m
            };
            g([...v, F]), n == null || n([...t, F]), h("");
          },
          children: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
            /* @__PURE__ */ f.jsx(Ve, { icon: "add", className: "mr-2" }),
            'Add "',
            m,
            '"'
          ] })
        }
      ] : [],
      // meta item: show/hide unselected
      ...ee.length > i || R ? [
        {
          value: "meta-toggle-visible",
          disabled: !R && !ee.some((F) => b(F)),
          onSelect: () => A((F) => !F),
          children: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
            /* @__PURE__ */ f.jsx(Ve, { icon: "eye", className: "mr-2" }),
            R ? "Show All" : "Show Selected"
          ] })
        }
      ] : []
    ].filter(Gi),
    [
      l,
      s,
      v,
      j,
      m,
      b,
      n,
      R,
      c,
      t,
      ee,
      i
    ]
  ), J = Be(
    () => j.filter(
      (F) => "value" in F
    ),
    [j]
  ), ye = Be(
    () => j.filter(
      (F) => "options" in F
    ),
    [j]
  ), re = Be(
    () => new Map(ye.map((F) => [`group-${F.label}`, F])),
    [ye]
  ), le = Ke(
    (F) => {
      if (F.key === "ArrowLeft" && U) {
        F.preventDefault(), d(null);
        return;
      }
      if (F.key !== "ArrowRight" || U) return;
      const Z = F.currentTarget.querySelector(
        '[cmdk-item][aria-selected="true"]'
      );
      if (!Z) return;
      const se = Z.getAttribute("data-value");
      if (!se) return;
      const ae = re.get(se);
      ae && (F.preventDefault(), d(ae.label));
    },
    [U, re]
  ), Te = Be(
    () => [
      ...Y.length ? [
        {
          kind: "meta",
          options: Y
        }
      ] : [],
      ...U ? [
        {
          kind: "active-group-header",
          group: U
        },
        ...U.options.map((F) => ({
          kind: "option",
          ...F
        }))
      ] : [
        ...B.map((F) => ({
          kind: "option",
          ...F
        })),
        ...J.map((F) => ({
          kind: "option",
          ...F
        })),
        ...ye.map((F) => ({
          kind: "group",
          group: F
        }))
      ]
    ],
    [
      U,
      B,
      Y,
      ye,
      J
    ]
  );
  return /* @__PURE__ */ f.jsxs(Am, { shouldFilter: !1, onKeyDown: le, children: [
    /* @__PURE__ */ f.jsx(
      e2,
      {
        "aria-label": o,
        placeholder: o,
        value: m,
        onValueChange: h,
        onKeyDown: (F) => {
          if (m || !["Delete", "Backspace"].includes(F.key)) return;
          const Z = t.at(-1);
          Z && x(Z);
        }
      }
    ),
    /* @__PURE__ */ f.jsxs(t2, { className: "contents", children: [
      /* @__PURE__ */ f.jsx(n2, { children: r ?? (s ? "Nothing found, search to create something new." : "Nothing Found.") }),
      Te.length ? /* @__PURE__ */ f.jsx(xf, { children: /* @__PURE__ */ f.jsx(
        age,
        {
          items: Te,
          estimateSize: (F) => {
            const Z = Te[F];
            return (Z == null ? void 0 : Z.kind) === "meta" ? Z.options.length * a : a;
          },
          children: (F) => {
            if (F.kind === "meta")
              return /* @__PURE__ */ f.jsx(ll, { children: F.options.map((Z) => /* @__PURE__ */ f.jsx(_a, { ...Z }, Z.value)) }, F.kind);
            if (F.kind === "active-group-header")
              return /* @__PURE__ */ f.jsxs(
                _a,
                {
                  value: `group-header-${F.group.label}`,
                  onSelect: () => d(null),
                  children: [
                    /* @__PURE__ */ f.jsx(Ve, { icon: "chevronLeft", className: "mr-2 shrink-0" }),
                    F.group.label
                  ]
                },
                `group-header-${F.group.label}`
              );
            if (F.kind === "group") {
              const Z = I(F.group);
              return /* @__PURE__ */ f.jsxs(
                _a,
                {
                  value: `group-${F.group.label}`,
                  keywords: F.group.keywords,
                  onSelect: () => T(F.group),
                  className: "group",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      "div",
                      {
                        className: oe(
                          "mr-2 flex size-4 flex-shrink-0 items-center justify-center rounded p-0.5",
                          Z === "none" ? "border border-neutral-300" : "bg-corso-blue-600 text-white"
                        ),
                        "aria-hidden": "true",
                        children: ze(Z).with("all", () => /* @__PURE__ */ f.jsx(Ve, { icon: fb })).with("some", () => /* @__PURE__ */ f.jsx(Ve, { icon: fL })).with("none", () => null).exhaustive()
                      }
                    ),
                    /* @__PURE__ */ f.jsxs("div", { className: "grid flex-grow grid-cols-[auto_1fr] items-center gap-1", children: [
                      F.group.label,
                      /* @__PURE__ */ f.jsxs(
                        "button",
                        {
                          type: "button",
                          className: "group/action flex size-full items-center justify-end opacity-0 group-aria-selected:opacity-100",
                          onMouseDown: (se) => {
                            se.preventDefault(), se.stopPropagation();
                          },
                          onClick: (se) => {
                            se.preventDefault(), se.stopPropagation(), d(F.group.label);
                          },
                          children: [
                            /* @__PURE__ */ f.jsxs("span", { className: "sr-only", children: [
                              "View ",
                              F.group.label,
                              " options"
                            ] }),
                            /* @__PURE__ */ f.jsx("div", { className: "rounded p-1 group-focus-within/action:bg-neutral-200 group-hover/action:bg-neutral-200", children: /* @__PURE__ */ f.jsx(Ve, { icon: "chevronRight" }) })
                          ]
                        }
                      )
                    ] })
                  ]
                },
                `group-${F.group.label}`
              );
            }
            return /* @__PURE__ */ f.jsxs(
              _a,
              {
                value: F.value,
                keywords: F.keywords,
                onSelect: () => {
                  b(F) ? x(F) : n == null || n([...t, F]);
                },
                children: [
                  /* @__PURE__ */ f.jsx(
                    "div",
                    {
                      className: oe(
                        "mr-2 flex size-4 flex-shrink-0 items-center justify-center rounded p-0.5",
                        b(F) ? "bg-corso-blue-600 text-white" : "border border-neutral-300"
                      ),
                      "aria-hidden": "true",
                      children: b(F) && /* @__PURE__ */ f.jsx(Ve, { icon: fb })
                    }
                  ),
                  F.label
                ]
              },
              `option-${F.value}`
            );
          }
        }
      ) }) : null
    ] })
  ] });
}
function i2e({
  label: e,
  labelVisuallyHidden: t = !1,
  details: n,
  error: r,
  visibleLimit: o = 5,
  defaultOpen: i = !1,
  // MultiSelectContent props
  value: a = [],
  placeholder: s,
  ...l
}) {
  const c = oi(), u = oi(), [d, m] = Fe(i);
  return /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ f.jsx(pi, { htmlFor: c, className: oe(t && "sr-only"), children: e }),
    /* @__PURE__ */ f.jsxs(
      xl,
      {
        open: d,
        onOpenChange: m,
        modal: !0,
        children: [
          /* @__PURE__ */ f.jsx(Cl, { asChild: !0, id: c, children: /* @__PURE__ */ f.jsxs(
            en,
            {
              role: "combobox",
              "aria-expanded": d,
              "aria-controls": d ? u : void 0,
              "aria-haspopup": "dialog",
              className: "w-full justify-between gap-2",
              children: [
                a.length ? /* @__PURE__ */ f.jsxs("div", { className: "flex flex-wrap gap-1", children: [
                  a.slice(0, o).map((h) => /* @__PURE__ */ f.jsx(ka, { children: h.label }, h.value)),
                  o && a.length > o && /* @__PURE__ */ f.jsxs(ka, { variant: "info", children: [
                    "+",
                    a.length - o,
                    " More"
                  ] })
                ] }) : /* @__PURE__ */ f.jsxs(
                  "span",
                  {
                    className: oe(
                      "flex items-center gap-2 font-normal text-neutral-500",
                      d && "invisible"
                    ),
                    children: [
                      /* @__PURE__ */ f.jsx(Ve, { icon: "search", className: "shrink-0 opacity-50" }),
                      s
                    ]
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  Ve,
                  {
                    icon: "chevronDown",
                    className: oe(
                      "shrink-0 opacity-50 transition-all duration-100",
                      d && "-rotate-180"
                    )
                  }
                )
              ]
            }
          ) }),
          /* @__PURE__ */ f.jsx(ts, { id: u, className: "p-0", children: /* @__PURE__ */ f.jsx(
            iy,
            {
              value: a,
              placeholder: s,
              ...l
            }
          ) })
        ]
      }
    ),
    r && /* @__PURE__ */ f.jsx("section", { className: "text-xs text-red-600", children: r }),
    n && /* @__PURE__ */ f.jsx("section", { className: "text-xs text-neutral-500", children: n })
  ] });
}
const Xm = It(({ label: e, value: t, className: n, verb: r, pinned: o = !1, ...i }, a) => /* @__PURE__ */ f.jsxs(
  en,
  {
    ref: a,
    variant: "ghost",
    className: oe(
      "h-full gap-px rounded-none p-0 text-xs hover:bg-transparent active:bg-transparent",
      n
    ),
    ...i,
    children: [
      /* @__PURE__ */ f.jsxs(
        "span",
        {
          className: oe(
            "flex h-full items-center rounded-l-md bg-neutral-200 px-2.5 text-neutral-800",
            !t && "rounded-r-md",
            !t && !o && "group-hover:rounded-r-none"
          ),
          children: [
            e,
            t && r && ` ${r}`
          ]
        }
      ),
      t && " ",
      t && /* @__PURE__ */ f.jsx(
        "span",
        {
          className: oe(
            "flex h-full items-center rounded-r-md bg-corso-blue-100 px-2.5 text-corso-blue-800",
            !o && "group-hover:rounded-r-none"
          ),
          children: t
        }
      )
    ]
  }
));
Xm.displayName = "FilterTriggerPill";
const PO = It(({ label: e, tone: t = "default", className: n, ...r }, o) => /* @__PURE__ */ f.jsx(
  en,
  {
    ref: o,
    type: "button",
    variant: "ghost",
    "aria-label": `Remove filter: ${e}`,
    className: oe(
      "flex h-full w-0 justify-start overflow-hidden rounded-l-none rounded-r-md p-0 pl-1 opacity-0",
      "transition-[width,opacity] duration-150",
      "group-hover:w-6 group-hover:opacity-100 focus-visible:w-6 focus-visible:opacity-100",
      t === "info" ? "hover:bg-corso-blue-200 active:bg-corso-blue-200 bg-corso-blue-100 text-corso-blue-800 hover:text-corso-blue-800" : "bg-neutral-200 text-neutral-800 hover:bg-neutral-300 hover:text-neutral-800 active:bg-neutral-300",
      n
    ),
    ...r,
    children: /* @__PURE__ */ f.jsx(Ve, { icon: zL, className: "size-3.5 shrink-0" })
  }
));
PO.displayName = "FilterRemoveButton";
const ri = {
  /** Free text; only used for a search term and not rendered as a pill. */
  text: "text",
  /** Rolling presets or a custom date range. */
  date: "date",
  /** Checkboxes with search when there are many options. */
  multiselect: "multiselect",
  /** Yes/no; converted to a boolean at the request level. */
  boolean: "boolean"
}, _o = { ...ei, custom: "custom" }, a2e = [
  { value: _o.today, label: "Today" },
  { value: _o.last7Days, label: "Last 7 Days" },
  { value: _o.last30Days, label: "Last 30 Days" },
  { value: _o.last90Days, label: "Last 90 Days" },
  { value: _o.last12Months, label: "Last 12 Months" },
  { value: _o.custom, label: "Custom" }
], sge = (e) => ze(e.value).with(
  { kind: "preset" },
  ({ preset: t }) => {
    var n;
    return ((n = e.options.find((r) => r.value === t)) == null ? void 0 : n.label) ?? "";
  }
).with(
  { range: { start: Ft.not(Ft.nullish), end: Ft.not(Ft.nullish) } },
  ({ range: t }) => `${dt.date(t.start)} - ${dt.date(t.end)}`
).with(
  { range: { start: Ft.not(Ft.nullish) } },
  ({ range: t }) => `Starting ${dt.date(t.start)}`
).with(
  { range: { end: Ft.not(Ft.nullish) } },
  ({ range: t }) => `Ending ${dt.date(t.end)}`
).otherwise(() => ""), lge = (e) => e.flatMap(
  (t) => "options" in t ? t.options : [t]
), cge = (e) => {
  const n = new Set(e.value ?? []), r = e.options.flatMap((a) => "options" in a ? a.options.length > 0 && a.options.every((l) => n.has(l.value)) ? [a.label] : a.options.filter((l) => n.has(l.value)).map((l) => l.label).filter((l) => typeof l == "string") : n.has(a.value) && typeof a.label == "string" ? [a.label] : []), o = dt.list.unit(r.slice(0, 3)), i = r.length - 3;
  return i > 0 ? `${o} + ${i} more` : o;
}, uge = (e) => ze(e).with({ type: ri.date }, sge).with({ type: ri.multiselect }, cge).with(
  { type: ri.boolean },
  (t) => {
    var n;
    return ((n = t.options.find((r) => r.value === t.value)) == null ? void 0 : n.label) ?? "";
  }
).with({ type: ri.text }, ({ value: t }) => t ?? "").exhaustive(), xS = (e) => e.value !== void 0, ay = (e) => {
  const t = uge(e);
  return t === "" ? void 0 : t;
}, NO = ({
  onClick: e,
  disabled: t
}) => /* @__PURE__ */ f.jsx(
  en,
  {
    disabled: t,
    variant: "link",
    className: "min-h-8 text-xs",
    onClick: e,
    children: "Clear"
  }
), dge = ({
  filter: e,
  onChange: t,
  onClose: n,
  defaultOpen: r,
  pinned: o
}) => {
  const { options: i, value: a } = e, [s, l] = Fe(
    ze(a).with({ kind: "preset" }, ({ preset: h }) => h).with({ kind: "custom" }, () => _o.custom).otherwise(() => null)
  ), c = (a == null ? void 0 : a.kind) === "custom" ? a.range : { start: null, end: null }, u = (h) => {
    l(h), h !== _o.custom && t({ kind: "preset", preset: h });
  }, d = (h) => (v) => t({
    kind: "custom",
    range: { ...c, [h]: v ? v.toISOString() : null }
  }), m = {
    ...e,
    value: s === _o.custom ? { kind: "custom", range: c } : a
  };
  return /* @__PURE__ */ f.jsxs(
    rs,
    {
      defaultOpen: r,
      onOpenChange: (h) => !h && n(),
      children: [
        /* @__PURE__ */ f.jsx(os, { asChild: !0, children: /* @__PURE__ */ f.jsx(
          Xm,
          {
            label: e.label,
            verb: e.verb,
            value: ay(m),
            pinned: o
          }
        ) }),
        /* @__PURE__ */ f.jsxs(pa, { align: "start", children: [
          /* @__PURE__ */ f.jsx(
            D2,
            {
              value: s ?? void 0,
              onValueChange: (h) => u(h),
              children: i.map((h) => /* @__PURE__ */ f.jsx(
                jm,
                {
                  value: h.value,
                  onSelect: (v) => v.preventDefault(),
                  children: h.label
                },
                h.value
              ))
            }
          ),
          s === _o.custom && /* @__PURE__ */ f.jsxs("div", { className: "space-y-3 p-2", children: [
            /* @__PURE__ */ f.jsxs(al, { children: [
              /* @__PURE__ */ f.jsx(pi, { htmlFor: `${e.id}-starting`, children: "Starting" }),
              /* @__PURE__ */ f.jsx(
                $4,
                {
                  id: `${e.id}-starting`,
                  value: c.start ? new Date(c.start) : void 0,
                  onChange: d("start"),
                  disabled: c.end ? { after: new Date(c.end) } : void 0
                }
              )
            ] }),
            /* @__PURE__ */ f.jsxs(al, { children: [
              /* @__PURE__ */ f.jsx(pi, { htmlFor: `${e.id}-ending`, children: "Ending" }),
              /* @__PURE__ */ f.jsx(
                $4,
                {
                  id: `${e.id}-ending`,
                  value: c.end ? new Date(c.end) : void 0,
                  onChange: d("end"),
                  disabled: c.start ? { before: new Date(c.start) } : void 0
                }
              )
            ] })
          ] }),
          !o && /* @__PURE__ */ f.jsx("div", { className: "px-2 py-1", children: /* @__PURE__ */ f.jsx(
            NO,
            {
              disabled: !a,
              onClick: () => {
                l(null), t(void 0);
              }
            }
          ) })
        ] })
      ]
    }
  );
}, fge = ({
  filter: e,
  onChange: t,
  onClose: n,
  defaultOpen: r,
  pinned: o
}) => {
  const i = new Set(e.value ?? []);
  return (
    // modal keeps the popover from flickering and closing on open
    /* @__PURE__ */ f.jsxs(
      xl,
      {
        defaultOpen: r,
        onOpenChange: (a) => !a && n(),
        modal: !0,
        children: [
          /* @__PURE__ */ f.jsx(Cl, { asChild: !0, children: /* @__PURE__ */ f.jsx(
            Xm,
            {
              label: e.label,
              verb: e.verb,
              value: ay(e),
              pinned: o
            }
          ) }),
          /* @__PURE__ */ f.jsx(ts, { align: "start", className: "p-0", children: /* @__PURE__ */ f.jsx(
            iy,
            {
              options: e.options,
              placeholder: e.placeholder,
              value: lge(e.options).filter(
                (a) => i.has(a.value)
              ),
              onChange: (a) => t(
                a.length ? a.map((s) => s.value) : void 0
              )
            }
          ) })
        ]
      }
    )
  );
}, mge = ({
  filter: e,
  onChange: t,
  onClose: n,
  defaultOpen: r,
  pinned: o
}) => /* @__PURE__ */ f.jsxs(
  rs,
  {
    defaultOpen: r,
    onOpenChange: (i) => !i && n(),
    children: [
      /* @__PURE__ */ f.jsx(os, { asChild: !0, children: /* @__PURE__ */ f.jsx(
        Xm,
        {
          label: e.label,
          verb: e.verb,
          value: ay(e),
          pinned: o
        }
      ) }),
      /* @__PURE__ */ f.jsxs(pa, { align: "start", children: [
        /* @__PURE__ */ f.jsx(
          D2,
          {
            value: e.value === void 0 ? void 0 : `${e.value}`,
            onValueChange: (i) => t(i === "true"),
            children: e.options.map((i) => /* @__PURE__ */ f.jsx(
              jm,
              {
                value: `${i.value}`,
                onSelect: (a) => a.preventDefault(),
                children: i.label
              },
              `${i.value}`
            ))
          }
        ),
        !o && /* @__PURE__ */ f.jsx("div", { className: "px-2 py-1", children: /* @__PURE__ */ f.jsx(
          NO,
          {
            disabled: e.value === void 0,
            onClick: () => t(void 0)
          }
        ) })
      ] })
    ]
  }
), wh = ({
  filter: e,
  onChange: t,
  onRemove: n,
  onClose: r,
  defaultOpen: o
}) => {
  const i = !n, a = () => {
    n && !xS(e) && n(), r == null || r();
  }, s = (c) => t({ ...e, value: c }), l = { onClose: a, defaultOpen: o, pinned: i };
  return /* @__PURE__ */ f.jsxs("div", { className: "group inline-flex h-8 overflow-hidden rounded-md text-xs", children: [
    ze(e).with({ type: ri.multiselect }, (c) => /* @__PURE__ */ f.jsx(
      fge,
      {
        ...l,
        filter: c,
        onChange: s
      }
    )).with({ type: ri.date }, (c) => /* @__PURE__ */ f.jsx(dge, { ...l, filter: c, onChange: s })).with({ type: ri.boolean }, (c) => /* @__PURE__ */ f.jsx(mge, { ...l, filter: c, onChange: s })).with({ type: ri.text }, () => null).exhaustive(),
    n && /* @__PURE__ */ f.jsx(
      PO,
      {
        label: e.label,
        tone: xS(e) ? "info" : "default",
        onClick: n
      }
    )
  ] });
}, pge = ({
  options: e,
  onSelect: t
}) => /* @__PURE__ */ f.jsxs(rs, { children: [
  /* @__PURE__ */ f.jsx(os, { asChild: !0, children: /* @__PURE__ */ f.jsx(Fn, { className: "min-h-8 cursor-pointer text-xs", icon: "add", children: "Add filter" }) }),
  /* @__PURE__ */ f.jsx(pa, { align: "start", children: e.map(({ id: n, label: r }) => /* @__PURE__ */ f.jsx(
    Rr,
    {
      onSelect: () => t(n),
      className: "text-xs",
      children: r
    },
    n
  )) })
] }), CS = (e) => e != null, hge = ({
  filters: e,
  activeFilters: t,
  pinned: n = [],
  onChange: r,
  onRemoveFilters: o,
  className: i,
  "data-testid": a
}) => {
  const [s, l] = Fe(null), c = Object.entries(e), u = (g, x) => ({ ...x, value: t[g] }), d = c.filter(([g]) => n.includes(g)), m = c.filter(
    ([g]) => CS(t[g]) && !n.includes(g) && g !== s
  ), h = c.find(([g]) => g === s), v = c.filter(
    ([g]) => !n.includes(g) && !CS(t[g]) && g !== s
  ).map(([g, { label: x }]) => ({ id: g, label: x })).sort((g, x) => g.label.localeCompare(x.label));
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      "data-testid": a,
      className: oe("flex flex-wrap items-center gap-2", i),
      children: [
        d.map(([g, x]) => /* @__PURE__ */ f.jsx(
          wh,
          {
            filter: u(g, x),
            onChange: r
          },
          g
        )),
        m.map(([g, x]) => /* @__PURE__ */ f.jsx(
          wh,
          {
            filter: u(g, x),
            onChange: r,
            onRemove: () => o([g])
          },
          g
        )),
        h && /* @__PURE__ */ f.jsx(
          wh,
          {
            defaultOpen: !0,
            filter: u(h[0], h[1]),
            onChange: r,
            onRemove: () => l(null),
            onClose: () => l(null)
          },
          h[0]
        ),
        v.length > 0 && /* @__PURE__ */ f.jsx(pge, { options: v, onSelect: l }),
        m.length > 0 && /* @__PURE__ */ f.jsx(
          Fn,
          {
            className: "min-h-8 cursor-pointer text-xs",
            icon: "close",
            onClick: () => o(m.map(([g]) => g)),
            children: "Clear all"
          }
        )
      ]
    }
  );
}, b1 = (e) => `from:${e}`, S1 = (e) => `to:${e}`, wS = {
  wide: { margin: 150, labelChars: 18, inside: !1 },
  narrow: { margin: 4, labelChars: 14, inside: !0 }
}, gge = (e) => e === 0 || e >= 560 ? wS.wide : wS.narrow, vge = (e, t) => e.length > t ? `${e.slice(0, t - 1)}…` : e, Eh = (e, t) => {
  var r;
  const n = /* @__PURE__ */ new Map();
  for (const o of e) {
    const i = t(o);
    n.set(i, {
      flow: o,
      total: (((r = n.get(i)) == null ? void 0 : r.total) ?? 0) + o.value
    });
  }
  return [...n].sort(([, o], [, i]) => i.total - o.total);
}, yge = (e, t, n) => {
  var m;
  const r = e.filter(({ value: h }) => Hc(h)).map((h) => ({ ...h, fromKey: h.from })), o = new Set(
    Eh(r, ({ fromKey: h }) => h).slice(0, t).map(([h]) => h)
  ), i = /* @__PURE__ */ new Map();
  for (const h of r) {
    const v = o.has(h.fromKey), g = v ? h.fromKey : yc, x = JSON.stringify([g, h.to]);
    i.set(x, {
      fromKey: g,
      from: v ? h.from : n,
      to: h.to,
      value: (((m = i.get(x)) == null ? void 0 : m.value) ?? 0) + h.value
    });
  }
  const a = [...i.values()], s = Eh(a, ({ fromKey: h }) => h), l = Eh(a, ({ to: h }) => h), c = [
    ...s.map(([h, { flow: v, total: g }], x) => ({
      key: b1(h),
      name: v.from,
      side: "from",
      total: g,
      color: h === yc ? fO : ey(x)
    })),
    ...l.map(([h, { total: v }]) => ({
      key: S1(h),
      name: h,
      side: "to",
      total: v,
      color: "var(--color-neutral-500)"
    }))
  ], u = (h) => c.findIndex((v) => v.key === h), d = a.map((h) => ({
    source: u(b1(h.fromKey)),
    target: u(S1(h.to)),
    value: h.value
  }));
  return {
    nodes: c,
    links: d,
    flows: a,
    total: s.reduce((h, [, { total: v }]) => h + v, 0)
  };
}, x1 = (e) => "key" in e && typeof e.key == "string" ? e.key : void 0, bge = (e, t) => ze(e).with(null, () => !0).with(
  { kind: "link" },
  ({ from: n, to: r }) => t.from === n && t.to === r
).with({ kind: "node" }, ({ key: n }) => t.from === n || t.to === n).exhaustive(), Sge = ({
  x: e = 0,
  y: t = 0,
  width: n = 0,
  height: r = 0,
  payload: o,
  nodes: i,
  onHover: a,
  valueFormatter: s,
  layout: l
}) => {
  const c = o && x1(o), u = i.find((m) => m.key === c);
  if (!u) return null;
  const d = u.side === "from" === l.inside;
  return /* @__PURE__ */ f.jsxs(
    "g",
    {
      onMouseEnter: () => a({ kind: "node", key: u.key }),
      onMouseLeave: () => a(null),
      children: [
        /* @__PURE__ */ f.jsx(
          "rect",
          {
            x: e,
            y: t,
            width: n,
            height: Math.max(r, 1),
            rx: 2,
            fill: u.color
          }
        ),
        /* @__PURE__ */ f.jsxs(
          "text",
          {
            x: d ? e + n + 6 : e - 6,
            y: t + r / 2,
            textAnchor: d ? "start" : "end",
            dominantBaseline: "central",
            className: "fill-neutral-700 stroke-white text-xs [paint-order:stroke]",
            strokeWidth: l.inside ? 3 : 0,
            children: [
              /* @__PURE__ */ f.jsx("title", { children: u.name }),
              vge(u.name, l.labelChars),
              !l.inside && /* @__PURE__ */ f.jsx("tspan", { className: "fill-neutral-400 tabular-nums", dx: 6, children: s(u.total) })
            ]
          }
        )
      ]
    }
  );
}, xge = ({
  sourceX: e = 0,
  sourceY: t = 0,
  sourceControlX: n = 0,
  targetX: r = 0,
  targetY: o = 0,
  targetControlX: i = 0,
  linkWidth: a = 0,
  payload: s,
  nodes: l,
  hovered: c,
  onHover: u
}) => {
  var h;
  const d = s && {
    from: x1(s.source) ?? "",
    to: x1(s.target) ?? ""
  };
  if (!d) return null;
  const m = ze({ isIdle: c === null, lit: bge(c, d) }).with({ isIdle: !0 }, () => 0.35).with({ lit: !0 }, () => 0.65).otherwise(() => 0.08);
  return /* @__PURE__ */ f.jsx(
    "path",
    {
      d: `M${e},${t} C${n},${t} ${i},${o} ${r},${o}`,
      fill: "none",
      stroke: ((h = l.find(({ key: v }) => v === d.from)) == null ? void 0 : h.color) ?? No[0],
      strokeWidth: Math.max(a, 1),
      strokeOpacity: m,
      className: "transition-[stroke-opacity] duration-150",
      onMouseEnter: () => u({ kind: "link", ...d }),
      onMouseLeave: () => u(null)
    }
  );
}, Cge = ({
  hovered: e,
  nodes: t,
  flows: n,
  total: r,
  valueFormatter: o
}) => ze(e).with({ kind: "link" }, (i) => {
  const a = n.find(
    ({ fromKey: l, to: c }) => b1(l) === i.from && S1(c) === i.to
  ), s = t.find(({ key: l }) => l === i.from);
  return a && s && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("span", { className: "font-medium text-neutral-900", children: a.from }),
    " → ",
    /* @__PURE__ */ f.jsx("span", { className: "font-medium text-neutral-900", children: a.to }),
    `: ${o(a.value)}, ${Na(a.value, s.total)} of ${a.from}`
  ] });
}).with({ kind: "node" }, ({ key: i }) => {
  const a = t.find((s) => s.key === i);
  return a && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("span", { className: "font-medium text-neutral-900", children: a.name }),
    `: ${o(a.total)}, ${Na(a.total, r)} of those shown`
  ] });
}).exhaustive(), wge = ({
  title: e,
  headingLevel: t = "h3",
  description: n,
  info: r,
  data: o,
  maxSources: i = 8,
  otherLabel: a = "Others",
  valueFormatter: s = dt.count,
  emptyMessage: l = "No data for this period"
}) => {
  const [c, u] = Fe(null), [d, m] = pO(), h = gge(m), { nodes: v, links: g, flows: x, total: b } = yge(o, i, a), C = {
    nodes: v,
    hovered: c,
    onHover: u,
    valueFormatter: s,
    layout: h
  };
  return /* @__PURE__ */ f.jsxs(un, { stretch: !0, children: [
    /* @__PURE__ */ f.jsx(
      Km,
      {
        title: e,
        headingLevel: t,
        description: n,
        info: r
      }
    ),
    g.length > 0 ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx("div", { ref: d, children: /* @__PURE__ */ f.jsx(
        qf,
        {
          "aria-hidden": !0,
          className: "h-80",
          onMouseLeave: () => u(null),
          children: /* @__PURE__ */ f.jsx(
            yk,
            {
              data: { nodes: v, links: g },
              node: /* @__PURE__ */ f.jsx(Sge, { ...C }),
              link: /* @__PURE__ */ f.jsx(xge, { ...C }),
              accessibilityLayer: !1,
              nodePadding: 14,
              nodeWidth: 10,
              linkCurvature: 0.55,
              margin: {
                top: 8,
                right: h.margin,
                bottom: 8,
                left: h.margin
              }
            }
          )
        }
      ) }),
      /* @__PURE__ */ f.jsx(mO, { placeholder: "Hover a flow or a node to see its share", children: c && /* @__PURE__ */ f.jsx(
        Cge,
        {
          hovered: c,
          nodes: v,
          flows: x,
          total: b,
          valueFormatter: s
        }
      ) }),
      /* @__PURE__ */ f.jsxs("table", { className: "sr-only", children: [
        /* @__PURE__ */ f.jsx("caption", { children: e }),
        /* @__PURE__ */ f.jsx("thead", { children: /* @__PURE__ */ f.jsxs("tr", { children: [
          /* @__PURE__ */ f.jsx("th", { scope: "col", children: "From" }),
          /* @__PURE__ */ f.jsx("th", { scope: "col", children: "To" }),
          /* @__PURE__ */ f.jsx("th", { scope: "col", children: "Value" })
        ] }) }),
        /* @__PURE__ */ f.jsx("tbody", { children: x.map((I) => /* @__PURE__ */ f.jsxs("tr", { children: [
          /* @__PURE__ */ f.jsx("td", { children: I.from }),
          /* @__PURE__ */ f.jsx("td", { children: I.to }),
          /* @__PURE__ */ f.jsx("td", { children: s(I.value) })
        ] }, JSON.stringify([I.fromKey, I.to]))) })
      ] })
    ] }) : /* @__PURE__ */ f.jsx(as, { message: l })
  ] });
};
function s2e({
  onReset: e,
  onSubmit: t,
  form: n,
  isDirty: r = !1,
  isSubmitting: o = !1
}) {
  const i = He(null), a = r || o;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(lO, { show: a, children: /* @__PURE__ */ f.jsxs(
      "div",
      {
        className: oe(
          "fixed right-6 bottom-6 z-10 flex flex-col flex-wrap items-end gap-2 duration-200 *:shadow-lg",
          a ? "animate-in zoom-in-90 fade-in" : "animate-out zoom-out-90 fade-out"
        ),
        children: [
          /* @__PURE__ */ f.jsx(
            Fn,
            {
              icon: "undo",
              accessibilityLabel: "Revert Changes",
              size: "lg",
              form: n,
              type: n ? "reset" : "button",
              disabled: o,
              onClick: e,
              ref: i
            }
          ),
          /* @__PURE__ */ f.jsx(
            Fn,
            {
              icon: G9,
              variant: "primary",
              size: "lg",
              form: n,
              type: n ? "submit" : "button",
              disabled: o,
              loading: o,
              onClick: () => t == null ? void 0 : t(),
              children: "Save"
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ f.jsx(
      qpe,
      {
        shouldBlock: r,
        title: "Unsaved Changes",
        prompt: "You have unsaved changes. Do you wish to proceed and discard your changes?",
        cancelText: "Return to Page",
        onProceed: () => {
          var s;
          return (s = i.current) == null ? void 0 : s.click();
        },
        proceedText: "Discard Changes"
      }
    )
  ] });
}
const MO = ({
  title: e,
  headingLevel: t = "h3",
  description: n,
  info: r,
  data: o,
  granularity: i = js.day,
  series: a,
  value: s,
  defaultSeries: l,
  onSeriesChange: c,
  valueFormatter: u = dt.count,
  emptyMessage: d = "No data for this period",
  tooltipCursor: m,
  children: h
}) => {
  var T;
  const [v, g] = Fe(
    l ?? ((T = a[0]) == null ? void 0 : T.key)
  ), x = s ?? v, b = a.find(({ key: R }) => R === x) ?? a[0], C = b == null ? void 0 : b.key;
  Le(() => {
    C === void 0 || C === x || (g(C), c == null || c(C));
  }, [C, x, c]);
  const I = a.map((R) => ({
    ...R,
    total: (R.aggregate ?? zoe.sum)(
      o.flatMap((A) => A[R.key] ?? [])
    )
  }));
  return /* @__PURE__ */ f.jsx("div", { className: "@container w-full min-w-0", children: /* @__PURE__ */ f.jsxs(un, { flush: !0, children: [
    /* @__PURE__ */ f.jsxs("div", { className: "flex flex-wrap gap-px overflow-hidden border-b", children: [
      /* @__PURE__ */ f.jsx("div", { className: "flex min-w-0 grow-999 basis-56", children: /* @__PURE__ */ f.jsx(un.Header, { children: /* @__PURE__ */ f.jsx(
        Q2,
        {
          title: e,
          headingLevel: t,
          description: n,
          info: r
        }
      ) }) }),
      /* @__PURE__ */ f.jsx(
        joe,
        {
          series: I,
          value: C,
          label: `${e} series`,
          valueFormatter: u,
          onValueChange: (R) => {
            g(R), c == null || c(R);
          },
          className: "grow outline-1 outline-neutral-200"
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "px-3 pb-5 @xl:px-6", children: o.length > 0 && b ? /* @__PURE__ */ f.jsx(qf, { children: h({
      activeSeries: b,
      chartProps: {
        "aria-label": `${e}: ${b.label}`,
        data: o,
        margin: { top: 8, right: 12, left: 12, bottom: 0 }
      },
      axes: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(bk, { vertical: !1 }),
        /* @__PURE__ */ f.jsx(
          Sk,
          {
            dataKey: "date",
            tickLine: !1,
            axisLine: !1,
            tickMargin: 10,
            minTickGap: 32,
            tickFormatter: (R) => Fp(R, i, "tick")
          }
        ),
        /* @__PURE__ */ f.jsx(
          TC,
          {
            cursor: m,
            formatLabel: (R) => Fp(R, i, "label"),
            formatValue: u
          }
        )
      ] })
    }) }) : /* @__PURE__ */ f.jsx(as, { message: d }) }),
    o.length > 0 && /* @__PURE__ */ f.jsxs("table", { className: "sr-only", children: [
      /* @__PURE__ */ f.jsx("caption", { children: `${e} data` }),
      /* @__PURE__ */ f.jsx("thead", { children: /* @__PURE__ */ f.jsxs("tr", { children: [
        /* @__PURE__ */ f.jsx("th", { scope: "col", children: "Date" }),
        a.map((R) => /* @__PURE__ */ f.jsx("th", { scope: "col", children: R.label }, R.key))
      ] }) }),
      /* @__PURE__ */ f.jsx("tbody", { children: o.map((R) => /* @__PURE__ */ f.jsxs("tr", { children: [
        /* @__PURE__ */ f.jsx("th", { scope: "row", children: Fp(R.date, i, "label") }),
        a.map((A) => {
          const _ = R[A.key];
          return /* @__PURE__ */ f.jsx("td", { children: ze(_).with(void 0, () => "—").otherwise((k) => u(k)) }, A.key);
        })
      ] }, R.date)) })
    ] })
  ] }) });
}, Ege = (e) => /* @__PURE__ */ f.jsx(MO, { ...e, children: ({ activeSeries: t, chartProps: n, axes: r }) => /* @__PURE__ */ f.jsxs(xk, { ...n, children: [
  r,
  /* @__PURE__ */ f.jsx(
    Ck,
    {
      dataKey: t.key,
      name: t.label,
      fill: t.color,
      radius: [2, 2, 0, 0]
    },
    t.key
  )
] }) }), Ige = (e) => /* @__PURE__ */ f.jsx(
  MO,
  {
    ...e,
    tooltipCursor: { stroke: "var(--color-neutral-200)", strokeWidth: 1 },
    children: ({ activeSeries: t, chartProps: n, axes: r }) => /* @__PURE__ */ f.jsxs(rx, { ...n, children: [
      r,
      /* @__PURE__ */ f.jsx(
        ox,
        {
          type: "monotone",
          dataKey: t.key,
          name: t.label,
          stroke: t.color,
          strokeWidth: 2,
          dot: !1
        },
        t.key
      )
    ] })
  }
), FO = ({
  label: e,
  value: t,
  badge: n,
  description: r,
  info: o,
  trend: i,
  trendColor: a = No[0],
  className: s
}) => {
  const l = i == null ? void 0 : i.map((c, u) => ({ index: u, value: c }));
  return /* @__PURE__ */ f.jsx("div", { className: oe("h-full min-w-0", s), children: /* @__PURE__ */ f.jsx(un, { stretch: !0, children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-1 items-start gap-2", children: [
    /* @__PURE__ */ f.jsxs("dl", { className: "flex min-w-0 flex-1 flex-col justify-between gap-2 self-stretch", children: [
      /* @__PURE__ */ f.jsx(un.Heading, { as: "dt", children: e }),
      /* @__PURE__ */ f.jsxs("dd", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ f.jsxs("span", { className: "flex flex-col items-start gap-2", children: [
          /* @__PURE__ */ f.jsx("span", { className: "text-3xl leading-none font-semibold tracking-tight text-neutral-900 tabular-nums", children: t }),
          n
        ] }),
        r && /* @__PURE__ */ f.jsx("span", { className: "text-xs text-neutral-500", children: r }),
        i && i.filter((c) => c !== null).length > 1 && /* @__PURE__ */ f.jsx("span", { className: "mt-1 block h-10 w-full", "aria-hidden": !0, children: /* @__PURE__ */ f.jsx(tx, { width: "100%", height: "100%", children: /* @__PURE__ */ f.jsx(
          rx,
          {
            accessibilityLayer: !1,
            data: l,
            margin: { top: 2, right: 0, bottom: 2, left: 0 },
            children: /* @__PURE__ */ f.jsx(
              ox,
              {
                type: "monotone",
                dataKey: "value",
                connectNulls: !0,
                stroke: a,
                strokeWidth: 2,
                dot: !1,
                isAnimationActive: !1
              }
            )
          }
        ) }) })
      ] })
    ] }),
    o && /* @__PURE__ */ f.jsx("span", { className: "flex h-5 items-center", children: /* @__PURE__ */ f.jsx(J2, { accessibilityLabel: `About ${e}`, children: o }) })
  ] }) }) });
}, Rge = ({
  value: e,
  percent: t,
  x: n,
  y: r,
  cx: o,
  textAnchor: i,
  valueFormatter: a
}) => {
  const s = a(e), l = Math.min(n, o * 2 - n) - 8;
  return t < 0.05 || s.length * 7 > l ? null : /* @__PURE__ */ f.jsx(
    "text",
    {
      x: n,
      y: r,
      textAnchor: i,
      dominantBaseline: "central",
      className: "fill-neutral-900 text-xs tabular-nums",
      "aria-hidden": !0,
      children: s
    }
  );
}, Ih = (e) => Number.isFinite(e) && e >= 0, l2e = ({
  title: e,
  headingLevel: t = "h3",
  description: n,
  data: r,
  valueFormatter: o = dt.count,
  emptyMessage: i = "No data for this period",
  zeroMessage: a = "All values are zero for this period",
  unavailableLabel: s = "Unavailable"
}) => {
  const l = r.some(({ value: d }) => Ih(d)), c = r.filter(({ value: d }) => Ih(d) && d > 0).map((d) => ({ ...d, fill: d.color })), u = ({
    value: d,
    percent: m,
    x: h,
    y: v,
    cx: g,
    textAnchor: x
  }) => typeof d == "number" && typeof m == "number" && typeof g == "number" ? /* @__PURE__ */ f.jsx(
    Rge,
    {
      value: d,
      percent: m,
      x: h,
      y: v,
      cx: g,
      textAnchor: x,
      valueFormatter: o
    }
  ) : null;
  return /* @__PURE__ */ f.jsxs(un, { children: [
    /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-1 text-center", children: [
      /* @__PURE__ */ f.jsx(un.Heading, { as: t, children: e }),
      n && /* @__PURE__ */ f.jsx(un.Description, { children: n })
    ] }),
    c.length > 0 ? /* @__PURE__ */ f.jsx(qf, { className: "mx-auto max-w-sm", children: /* @__PURE__ */ f.jsxs(ix, { "aria-label": e, children: [
      /* @__PURE__ */ f.jsx(TC, { formatValue: o }),
      /* @__PURE__ */ f.jsx(
        Ah,
        {
          data: c,
          dataKey: "value",
          nameKey: "label",
          outerRadius: "65%",
          labelLine: !1,
          animationBegin: 0,
          animationDuration: 300,
          label: u
        }
      )
    ] }) }) : /* @__PURE__ */ f.jsx(as, { message: l ? a : i }),
    r.length > 0 && /* @__PURE__ */ f.jsx(
      "ul",
      {
        "aria-label": `${e} legend`,
        className: "mx-auto flex w-full max-w-sm flex-col gap-1 text-xs",
        children: r.map((d) => /* @__PURE__ */ f.jsxs("li", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ f.jsx(
            "span",
            {
              "aria-hidden": !0,
              className: "size-2 shrink-0 rounded-sm",
              style: { backgroundColor: d.color }
            }
          ),
          /* @__PURE__ */ f.jsx("span", { className: "min-w-0 flex-1 truncate text-neutral-600", children: d.label }),
          /* @__PURE__ */ f.jsx("span", { className: "text-neutral-900 tabular-nums", children: Ih(d.value) ? o(d.value) : s })
        ] }, d.key))
      }
    )
  ] });
}, Tge = ({
  title: e,
  description: t,
  currencyCode: n,
  amount: r
}) => (
  // the transparent side borders and padding match the list's, so the summary's amount aligns and stacks with its lines'
  /* @__PURE__ */ f.jsx("div", { className: "border-x border-transparent px-3 py-2", children: /* @__PURE__ */ f.jsxs(vt, { children: [
    /* @__PURE__ */ f.jsxs(vt.Content, { children: [
      /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ f.jsx(vt.Title, { children: e }),
        /* @__PURE__ */ f.jsx(w7, {})
      ] }),
      t && /* @__PURE__ */ f.jsx(vt.Detail, { children: t })
    ] }),
    /* @__PURE__ */ f.jsx(vt.Money, { currencyCode: n, amount: r })
  ] }) })
), LO = ({
  summary: e,
  defaultOpen: t,
  children: n
}) => {
  const r = /* @__PURE__ */ f.jsx("ul", { className: "divide-y divide-neutral-200 overflow-hidden rounded-md border border-neutral-200", children: n });
  return e ? /* @__PURE__ */ f.jsx(
    jle,
    {
      defaultOpen: t,
      renderSummary: /* @__PURE__ */ f.jsx(Tge, { ...e }),
      children: /* @__PURE__ */ f.jsx("div", { className: "pt-1", children: r })
    }
  ) : r;
}, _ge = ({ children: e }) => /* @__PURE__ */ f.jsx("li", { className: "p-3", children: e }), Oge = ({
  title: e,
  currencyCode: t,
  amount: n
}) => /* @__PURE__ */ f.jsx("li", { className: "bg-neutral-50 p-3", children: /* @__PURE__ */ f.jsx(uO, { title: e, currencyCode: t, amount: n }) });
LO.Item = _ge;
LO.Total = Oge;
function sy({
  buttonAs: e,
  children: t,
  align: n
}) {
  return /* @__PURE__ */ f.jsxs(rs, { children: [
    /* @__PURE__ */ f.jsx(os, { asChild: !0, children: e }),
    /* @__PURE__ */ f.jsx(pa, { align: n, children: t })
  ] });
}
const ly = "flex items-center w-full gap-2 text-left text-sm text-neutral-800";
sy.ItemButton = ({
  children: e,
  onClick: t,
  disabled: n,
  hidden: r
}) => /* @__PURE__ */ f.jsx(Rr, { onClick: t, disabled: n, hidden: r, children: /* @__PURE__ */ f.jsx("div", { className: ly, children: e }) });
sy.ItemNavLink = ({
  children: e,
  disabled: t,
  hidden: n,
  ...r
}) => /* @__PURE__ */ f.jsx(Rr, { disabled: t, hidden: n, children: /* @__PURE__ */ f.jsx(Oh, { className: ly, ...r, children: e }) });
sy.ItemLink = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(Rr, { children: /* @__PURE__ */ f.jsx(Yc, { className: ly, ...t, children: e }) });
const Age = ({
  title: e,
  src: t,
  options: n,
  sku: r,
  price: o,
  quantity: i,
  size: a,
  children: s
}) => {
  const l = n ? cO(n) : "", c = e && l ? `${e} - ${l}` : e || "Unknown product";
  return /* @__PURE__ */ f.jsxs(vt, { size: a, children: [
    /* @__PURE__ */ f.jsx(vt.Media, { src: t, alt: c }),
    /* @__PURE__ */ f.jsxs(vt.Content, { children: [
      e ? /* @__PURE__ */ f.jsx(hS, { value: c, children: /* @__PURE__ */ f.jsx(vt.Title, { children: e }) }) : /* @__PURE__ */ f.jsx(vt.Title, { tone: "critical", children: "Unknown product" }),
      (l || r) && /* @__PURE__ */ f.jsxs(vt.Detail, { children: [
        n && /* @__PURE__ */ f.jsx(vt.Options, { options: n }),
        r && /* @__PURE__ */ f.jsx(hS, { value: r, children: /* @__PURE__ */ f.jsx(vt.Sku, { sku: r }) })
      ] })
    ] }),
    (o == null ? void 0 : o.unitPrice) != null ? /* @__PURE__ */ f.jsx(
      vt.Price,
      {
        ...o,
        unitPrice: o.unitPrice,
        quantity: i
      }
    ) : i != null && /* @__PURE__ */ f.jsx(vt.Quantity, { quantity: i }),
    s && /* @__PURE__ */ f.jsx(vt.AdditionalContent, { children: s })
  ] });
};
Age.Detail = vt.Detail;
function cy({
  horizontal: e = !1,
  children: t
}) {
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: oe(
        "flex flex-col rounded-md bg-white lg:flex-row",
        "*:min-w-max *:flex-auto *:rounded-none",
        // all direct children
        // ? maybe include margin adjustments for borders; however, it doesn't work to show color on the overlapping rings/borders
        // '[&>*:not(:first-child)]:-mt-px lg:[&>*:not(:first-child)]:-ml-px lg:[&>*:not(:first-child)]:mt-0', // all children except first
        // TODO consider if this can be simplified
        !e && "*:first:rounded-t-md lg:*:first:rounded-l-md lg:*:first:rounded-r-none",
        // first direct child
        !e && "*:last:rounded-b-md lg:*:last:rounded-l-none lg:*:last:rounded-r-md",
        // last direct child
        e && "flex-row *:first:rounded-l-md *:first:rounded-r-none *:last:rounded-l-none *:last:rounded-r-md"
      ),
      children: t
    }
  );
}
function c2e({ show: e }) {
  return /* @__PURE__ */ f.jsx(
    J1,
    {
      className: oe("invisible size-5 text-neutral-600", e && "visible")
    }
  );
}
function u2e({
  defaultValue: e = "",
  placeholder: t,
  onSearch: n
}) {
  const [r, o] = Fe(e), i = Upe(n);
  return /* @__PURE__ */ f.jsx(
    kO,
    {
      id: "search",
      label: "Search",
      className: "grow",
      onChange: (a) => {
        const { value: s } = a.target;
        o(s), i(s);
      },
      value: r,
      labelVisuallyHidden: !0,
      placeholder: t,
      addon: {
        insideStart: /* @__PURE__ */ f.jsx(Ve, { icon: "search", className: "size-3" })
      }
    }
  );
}
function kge({
  data: e,
  columns: t,
  pageInfo: n,
  onPageChange: r,
  onRowClick: o,
  isFetching: i,
  isError: a,
  onRetry: s,
  isSearchTooLong: l,
  entityLabel: c,
  onClearFilters: u
}) {
  return l ? /* @__PURE__ */ f.jsx(
    Sh,
    {
      title: "Search term too long",
      details: "Please shorten your search term to continue.",
      icon: "warning"
    }
  ) : a ? /* @__PURE__ */ f.jsx(
    Sh,
    {
      title: "Something went wrong",
      details: "We encountered an error while fetching the data.",
      icon: "error",
      action: { label: "Retry", onClick: s }
    }
  ) : e.length === 0 ? i ? null : /* @__PURE__ */ f.jsx(
    Sh,
    {
      title: `No ${c} found`,
      icon: "search",
      details: "Try changing the filters or search terms for this view.",
      action: { label: `View all ${c}`, onClick: u }
    }
  ) : /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(oy, { data: e, columns: t, onRowClick: o }),
    (n.nextCursor !== null || n.prevCursor !== null) && /* @__PURE__ */ f.jsx("div", { className: "flex justify-center border-t bg-neutral-100 p-2", children: /* @__PURE__ */ f.jsxs(cy, { horizontal: !0, children: [
      /* @__PURE__ */ f.jsx(
        Fn,
        {
          icon: "chevronLeft",
          onClick: () => n.prevCursor !== null && r({ direction: "prev", id: n.prevCursor }),
          accessibilityLabel: "Previous page",
          disabled: n.prevCursor === null
        }
      ),
      /* @__PURE__ */ f.jsx(
        Fn,
        {
          icon: "chevronRight",
          onClick: () => n.nextCursor !== null && r({ direction: "next", id: n.nextCursor }),
          accessibilityLabel: "Next page",
          disabled: n.nextCursor === null
        }
      )
    ] }) })
  ] });
}
function d2e({ controls: e, ...t }) {
  return /* @__PURE__ */ f.jsx(un, { flush: !0, children: /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: "flex max-h-[80dvh] flex-col gap-0 divide-y divide-neutral-200",
      "data-testid": "searchTable",
      children: [
        e,
        /* @__PURE__ */ f.jsx(kge, { ...t })
      ]
    }
  ) });
}
var Au = (e) => e.type === "checkbox", Oa = (e) => e instanceof Date, sr = (e) => e == null;
const $O = (e) => typeof e == "object";
var vn = (e) => !sr(e) && !Array.isArray(e) && $O(e) && !Oa(e), Dge = (e) => vn(e) && e.target ? Au(e.target) ? e.target.checked : e.target.value : e, Pge = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Nge = (e, t) => e.has(Pge(t)), Mge = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return vn(t) && t.hasOwnProperty("isPrototypeOf");
}, uy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Rn(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (!(uy && (e instanceof Blob || r)) && (n || vn(e)))
    if (t = n ? [] : Object.create(Object.getPrototypeOf(e)), !n && !Mge(e))
      t = e;
    else
      for (const o in e)
        e.hasOwnProperty(o) && (t[o] = Rn(e[o]));
  else
    return e;
  return t;
}
var Jm = (e) => /^\w*$/.test(e), ln = (e) => e === void 0, dy = (e) => Array.isArray(e) ? e.filter(Boolean) : [], fy = (e) => dy(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Ge = (e, t, n) => {
  if (!t || !vn(e))
    return n;
  const r = (Jm(t) ? [t] : fy(t)).reduce((o, i) => sr(o) ? o : o[i], e);
  return ln(r) || r === e ? ln(e[t]) ? n : e[t] : r;
}, To = (e) => typeof e == "boolean", Ut = (e, t, n) => {
  let r = -1;
  const o = Jm(t) ? [t] : fy(t), i = o.length, a = i - 1;
  for (; ++r < i; ) {
    const s = o[r];
    let l = n;
    if (r !== a) {
      const c = e[s];
      l = vn(c) || Array.isArray(c) ? c : isNaN(+o[r + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    e[s] = l, e = e[s];
  }
};
const ES = {
  BLUR: "blur",
  FOCUS_OUT: "focusout"
}, no = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Wo = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Fge = H.createContext(null);
Fge.displayName = "HookFormContext";
var Lge = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const i in e)
    Object.defineProperty(o, i, {
      get: () => {
        const a = i;
        return t._proxyFormState[a] !== no.all && (t._proxyFormState[a] = !r || no.all), e[a];
      }
    });
  return o;
};
const $ge = typeof window < "u" ? H.useLayoutEffect : H.useEffect;
var Ir = (e) => typeof e == "string", zge = (e, t, n, r, o) => Ir(e) ? (r && t.watch.add(e), Ge(n, e, o)) : Array.isArray(e) ? e.map((i) => (r && t.watch.add(i), Ge(n, i))) : (r && (t.watchAll = !0), n), C1 = (e) => sr(e) || !$O(e);
function Mi(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (C1(e) || C1(t))
    return e === t;
  if (Oa(e) && Oa(t))
    return e.getTime() === t.getTime();
  const r = Object.keys(e), o = Object.keys(t);
  if (r.length !== o.length)
    return !1;
  if (n.has(e) || n.has(t))
    return !0;
  n.add(e), n.add(t);
  for (const i of r) {
    const a = e[i];
    if (!o.includes(i))
      return !1;
    if (i !== "ref") {
      const s = t[i];
      if (Oa(a) && Oa(s) || vn(a) && vn(s) || Array.isArray(a) && Array.isArray(s) ? !Mi(a, s, n) : a !== s)
        return !1;
    }
  }
  return !0;
}
var jge = (e, t, n, r, o) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: o || !0
  }
} : {}, Sc = (e) => Array.isArray(e) ? e : [e], IS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (o) => {
      for (const i of e)
        i.next && i.next(o);
    },
    subscribe: (o) => (e.push(o), {
      unsubscribe: () => {
        e = e.filter((i) => i !== o);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
};
function zO(e, t) {
  const n = {};
  for (const r in e)
    if (e.hasOwnProperty(r)) {
      const o = e[r], i = t[r];
      if (o && vn(o) && i) {
        const a = zO(o, i);
        vn(a) && (n[r] = a);
      } else e[r] && (n[r] = i);
    }
  return n;
}
var ar = (e) => vn(e) && !Object.keys(e).length, my = (e) => e.type === "file", ro = (e) => typeof e == "function", Df = (e) => {
  if (!uy)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, jO = (e) => e.type === "select-multiple", py = (e) => e.type === "radio", Bge = (e) => py(e) || Au(e), Rh = (e) => Df(e) && e.isConnected;
function Gge(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = ln(e) ? r++ : e[t[r++]];
  return e;
}
function Vge(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !ln(e[t]))
      return !1;
  return !0;
}
function mn(e, t) {
  const n = Array.isArray(t) ? t : Jm(t) ? [t] : fy(t), r = n.length === 1 ? e : Gge(e, n), o = n.length - 1, i = n[o];
  return r && delete r[i], o !== 0 && (vn(r) && ar(r) || Array.isArray(r) && Vge(r)) && mn(e, n.slice(0, -1)), e;
}
var Uge = (e) => {
  for (const t in e)
    if (ro(e[t]))
      return !0;
  return !1;
};
function BO(e) {
  return Array.isArray(e) || vn(e) && !Uge(e);
}
function w1(e, t = {}) {
  for (const n in e)
    BO(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, w1(e[n], t[n])) : ln(e[n]) || (t[n] = !0);
  return t;
}
function As(e, t, n) {
  n || (n = w1(t));
  for (const r in e)
    BO(e[r]) ? ln(t) || C1(n[r]) ? n[r] = w1(e[r], Array.isArray(e[r]) ? [] : {}) : As(e[r], sr(t) ? {} : t[r], n[r]) : n[r] = !Mi(e[r], t[r]);
  return n;
}
const RS = {
  value: !1,
  isValid: !1
}, TS = { value: !0, isValid: !0 };
var GO = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ln(e[0].attributes.value) ? ln(e[0].value) || e[0].value === "" ? TS : { value: e[0].value, isValid: !0 } : TS
    ) : RS;
  }
  return RS;
}, VO = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => ln(e) ? e : t ? e === "" ? NaN : e && +e : n && Ir(e) ? new Date(e) : r ? r(e) : e;
const _S = {
  isValid: !1,
  value: null
};
var UO = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, _S) : _S;
function OS(e) {
  const t = e.ref;
  return my(t) ? t.files : py(t) ? UO(e.refs).value : jO(t) ? [...t.selectedOptions].map(({ value: n }) => n) : Au(t) ? GO(e.refs).value : VO(ln(t.value) ? e.ref.value : t.value, e);
}
var Wge = (e, t, n, r) => {
  const o = {};
  for (const i of e) {
    const a = Ge(t, i);
    a && Ut(o, i, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: o,
    shouldUseNativeValidation: r
  };
}, Pf = (e) => e instanceof RegExp, Hl = (e) => ln(e) ? e : Pf(e) ? e.source : vn(e) ? Pf(e.value) ? e.value.source : e.value : e, AS = (e) => ({
  isOnSubmit: !e || e === no.onSubmit,
  isOnBlur: e === no.onBlur,
  isOnChange: e === no.onChange,
  isOnAll: e === no.all,
  isOnTouch: e === no.onTouched
});
const kS = "AsyncFunction";
var Hge = (e) => !!e && !!e.validate && !!(ro(e.validate) && e.validate.constructor.name === kS || vn(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === kS)), qge = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), DS = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const xc = (e, t, n, r) => {
  for (const o of n || Object.keys(e)) {
    const i = Ge(e, o);
    if (i) {
      const { _f: a, ...s } = i;
      if (a) {
        if (a.refs && a.refs[0] && t(a.refs[0], o) && !r)
          return !0;
        if (a.ref && t(a.ref, a.name) && !r)
          return !0;
        if (xc(s, t))
          break;
      } else if (vn(s) && xc(s, t))
        break;
    }
  }
};
function PS(e, t, n) {
  const r = Ge(e, n);
  if (r || Jm(n))
    return {
      error: r,
      name: n
    };
  const o = n.split(".");
  for (; o.length; ) {
    const i = o.join("."), a = Ge(t, i), s = Ge(e, i);
    if (a && !Array.isArray(a) && n !== i)
      return { name: n };
    if (s && s.type)
      return {
        name: i,
        error: s
      };
    if (s && s.root && s.root.type)
      return {
        name: `${i}.root`,
        error: s.root
      };
    o.pop();
  }
  return {
    name: n
  };
}
var Yge = (e, t, n, r) => {
  n(e);
  const { name: o, ...i } = e;
  return ar(i) || Object.keys(i).length >= Object.keys(t).length || Object.keys(i).find((a) => t[a] === (!r || no.all));
}, Kge = (e, t, n) => !e || !t || e === t || Sc(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r))), Zge = (e, t, n, r, o) => o.isOnAll ? !1 : !n && o.isOnTouch ? !(t || e) : (n ? r.isOnBlur : o.isOnBlur) ? !e : (n ? r.isOnChange : o.isOnChange) ? e : !0, Xge = (e, t) => !dy(Ge(e, t)).length && mn(e, t), Jge = (e, t, n) => {
  const r = Sc(Ge(e, n));
  return Ut(r, "root", t[n]), Ut(e, n, r), e;
};
function NS(e, t, n = "validate") {
  if (Ir(e) || Array.isArray(e) && e.every(Ir) || To(e) && !e)
    return {
      type: n,
      message: Ir(e) ? e : "",
      ref: t
    };
}
var Is = (e) => vn(e) && !Pf(e) ? e : {
  value: e,
  message: ""
}, MS = async (e, t, n, r, o, i) => {
  const { ref: a, refs: s, required: l, maxLength: c, minLength: u, min: d, max: m, pattern: h, validate: v, name: g, valueAsNumber: x, mount: b } = e._f, C = Ge(n, g);
  if (!b || t.has(g))
    return {};
  const I = s ? s[0] : a, T = (U) => {
    o && I.reportValidity && (I.setCustomValidity(To(U) ? "" : U || ""), I.reportValidity());
  }, R = {}, A = py(a), _ = Au(a), k = A || _, M = (x || my(a)) && ln(a.value) && ln(C) || Df(a) && a.value === "" || C === "" || Array.isArray(C) && !C.length, j = jge.bind(null, g, r, R), G = (U, B, K, ee = Wo.maxLength, Y = Wo.minLength) => {
    const J = U ? B : K;
    R[g] = {
      type: U ? ee : Y,
      message: J,
      ref: a,
      ...j(U ? ee : Y, J)
    };
  };
  if (i ? !Array.isArray(C) || !C.length : l && (!k && (M || sr(C)) || To(C) && !C || _ && !GO(s).isValid || A && !UO(s).isValid)) {
    const { value: U, message: B } = Ir(l) ? { value: !!l, message: l } : Is(l);
    if (U && (R[g] = {
      type: Wo.required,
      message: B,
      ref: I,
      ...j(Wo.required, B)
    }, !r))
      return T(B), R;
  }
  if (!M && (!sr(d) || !sr(m))) {
    let U, B;
    const K = Is(m), ee = Is(d);
    if (!sr(C) && !isNaN(C)) {
      const Y = a.valueAsNumber || C && +C;
      sr(K.value) || (U = Y > K.value), sr(ee.value) || (B = Y < ee.value);
    } else {
      const Y = a.valueAsDate || new Date(C), J = (le) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + le), ye = a.type == "time", re = a.type == "week";
      Ir(K.value) && C && (U = ye ? J(C) > J(K.value) : re ? C > K.value : Y > new Date(K.value)), Ir(ee.value) && C && (B = ye ? J(C) < J(ee.value) : re ? C < ee.value : Y < new Date(ee.value));
    }
    if ((U || B) && (G(!!U, K.message, ee.message, Wo.max, Wo.min), !r))
      return T(R[g].message), R;
  }
  if ((c || u) && !M && (Ir(C) || i && Array.isArray(C))) {
    const U = Is(c), B = Is(u), K = !sr(U.value) && C.length > +U.value, ee = !sr(B.value) && C.length < +B.value;
    if ((K || ee) && (G(K, U.message, B.message), !r))
      return T(R[g].message), R;
  }
  if (h && !M && Ir(C)) {
    const { value: U, message: B } = Is(h);
    if (Pf(U) && !C.match(U) && (R[g] = {
      type: Wo.pattern,
      message: B,
      ref: a,
      ...j(Wo.pattern, B)
    }, !r))
      return T(B), R;
  }
  if (v) {
    if (ro(v)) {
      const U = await v(C, n), B = NS(U, I);
      if (B && (R[g] = {
        ...B,
        ...j(Wo.validate, B.message)
      }, !r))
        return T(B.message), R;
    } else if (vn(v)) {
      let U = {};
      for (const B in v) {
        if (!ar(U) && !r)
          break;
        const K = NS(await v[B](C, n), I, B);
        K && (U = {
          ...K,
          ...j(B, K.message)
        }, T(K.message), r && (R[g] = U));
      }
      if (!ar(U) && (R[g] = {
        ref: I,
        ...U
      }, !r))
        return R;
    }
  }
  return T(!0), R;
};
const Qge = {
  mode: no.onSubmit,
  reValidateMode: no.onChange,
  shouldFocusError: !0
};
function e1e(e = {}) {
  let t = {
    ...Qge,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: ro(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, o = vn(t.defaultValues) || vn(t.values) ? Rn(t.defaultValues || t.values) || {} : {}, i = t.shouldUnregister ? {} : Rn(o), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let d = {
    ...u
  };
  const m = {
    array: IS(),
    state: IS()
  }, h = t.criteriaMode === no.all, v = (L) => (q) => {
    clearTimeout(c), c = setTimeout(L, q);
  }, g = async (L) => {
    if (!t.disabled && (u.isValid || d.isValid || L)) {
      const q = t.resolver ? ar((await _()).errors) : await M(r, !0);
      q !== n.isValid && m.state.next({
        isValid: q
      });
    }
  }, x = (L, q) => {
    !t.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((L || Array.from(s.mount)).forEach((Q) => {
      Q && (q ? Ut(n.validatingFields, Q, q) : mn(n.validatingFields, Q));
    }), m.state.next({
      validatingFields: n.validatingFields,
      isValidating: !ar(n.validatingFields)
    }));
  }, b = (L, q = [], Q, Se, ve = !0, me = !0) => {
    if (Se && Q && !t.disabled) {
      if (a.action = !0, me && Array.isArray(Ge(r, L))) {
        const Ne = Q(Ge(r, L), Se.argA, Se.argB);
        ve && Ut(r, L, Ne);
      }
      if (me && Array.isArray(Ge(n.errors, L))) {
        const Ne = Q(Ge(n.errors, L), Se.argA, Se.argB);
        ve && Ut(n.errors, L, Ne), Xge(n.errors, L);
      }
      if ((u.touchedFields || d.touchedFields) && me && Array.isArray(Ge(n.touchedFields, L))) {
        const Ne = Q(Ge(n.touchedFields, L), Se.argA, Se.argB);
        ve && Ut(n.touchedFields, L, Ne);
      }
      (u.dirtyFields || d.dirtyFields) && (n.dirtyFields = As(o, i)), m.state.next({
        name: L,
        isDirty: G(L, q),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Ut(i, L, q);
  }, C = (L, q) => {
    Ut(n.errors, L, q), m.state.next({
      errors: n.errors
    });
  }, I = (L) => {
    n.errors = L, m.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, T = (L, q, Q, Se) => {
    const ve = Ge(r, L);
    if (ve) {
      const me = Ge(i, L, ln(Q) ? Ge(o, L) : Q);
      ln(me) || Se && Se.defaultChecked || q ? Ut(i, L, q ? me : OS(ve._f)) : K(L, me), a.mount && g();
    }
  }, R = (L, q, Q, Se, ve) => {
    let me = !1, Ne = !1;
    const et = {
      name: L
    };
    if (!t.disabled) {
      if (!Q || Se) {
        (u.isDirty || d.isDirty) && (Ne = n.isDirty, n.isDirty = et.isDirty = G(), me = Ne !== et.isDirty);
        const ot = Mi(Ge(o, L), q);
        Ne = !!Ge(n.dirtyFields, L), ot ? mn(n.dirtyFields, L) : Ut(n.dirtyFields, L, !0), et.dirtyFields = n.dirtyFields, me = me || (u.dirtyFields || d.dirtyFields) && Ne !== !ot;
      }
      if (Q) {
        const ot = Ge(n.touchedFields, L);
        ot || (Ut(n.touchedFields, L, Q), et.touchedFields = n.touchedFields, me = me || (u.touchedFields || d.touchedFields) && ot !== Q);
      }
      me && ve && m.state.next(et);
    }
    return me ? et : {};
  }, A = (L, q, Q, Se) => {
    const ve = Ge(n.errors, L), me = (u.isValid || d.isValid) && To(q) && n.isValid !== q;
    if (t.delayError && Q ? (l = v(() => C(L, Q)), l(t.delayError)) : (clearTimeout(c), l = null, Q ? Ut(n.errors, L, Q) : mn(n.errors, L)), (Q ? !Mi(ve, Q) : ve) || !ar(Se) || me) {
      const Ne = {
        ...Se,
        ...me && To(q) ? { isValid: q } : {},
        errors: n.errors,
        name: L
      };
      n = {
        ...n,
        ...Ne
      }, m.state.next(Ne);
    }
  }, _ = async (L) => {
    x(L, !0);
    const q = await t.resolver(i, t.context, Wge(L || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
    return x(L), q;
  }, k = async (L) => {
    const { errors: q } = await _(L);
    if (L)
      for (const Q of L) {
        const Se = Ge(q, Q);
        Se ? Ut(n.errors, Q, Se) : mn(n.errors, Q);
      }
    else
      n.errors = q;
    return q;
  }, M = async (L, q, Q = {
    valid: !0
  }) => {
    for (const Se in L) {
      const ve = L[Se];
      if (ve) {
        const { _f: me, ...Ne } = ve;
        if (me) {
          const et = s.array.has(me.name), ot = ve._f && Hge(ve._f);
          ot && u.validatingFields && x([me.name], !0);
          const Ot = await MS(ve, s.disabled, i, h, t.shouldUseNativeValidation && !q, et);
          if (ot && u.validatingFields && x([me.name]), Ot[me.name] && (Q.valid = !1, q))
            break;
          !q && (Ge(Ot, me.name) ? et ? Jge(n.errors, Ot, me.name) : Ut(n.errors, me.name, Ot[me.name]) : mn(n.errors, me.name));
        }
        !ar(Ne) && await M(Ne, q, Q);
      }
    }
    return Q.valid;
  }, j = () => {
    for (const L of s.unMount) {
      const q = Ge(r, L);
      q && (q._f.refs ? q._f.refs.every((Q) => !Rh(Q)) : !Rh(q._f.ref)) && te(L);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, G = (L, q) => !t.disabled && (L && q && Ut(i, L, q), !Mi(le(), o)), U = (L, q, Q) => zge(L, s, {
    ...a.mount ? i : ln(q) ? o : Ir(L) ? { [L]: q } : q
  }, Q, q), B = (L) => dy(Ge(a.mount ? i : o, L, t.shouldUnregister ? Ge(o, L, []) : [])), K = (L, q, Q = {}) => {
    const Se = Ge(r, L);
    let ve = q;
    if (Se) {
      const me = Se._f;
      me && (!me.disabled && Ut(i, L, VO(q, me)), ve = Df(me.ref) && sr(q) ? "" : q, jO(me.ref) ? [...me.ref.options].forEach((Ne) => Ne.selected = ve.includes(Ne.value)) : me.refs ? Au(me.ref) ? me.refs.forEach((Ne) => {
        (!Ne.defaultChecked || !Ne.disabled) && (Array.isArray(ve) ? Ne.checked = !!ve.find((et) => et === Ne.value) : Ne.checked = ve === Ne.value || !!ve);
      }) : me.refs.forEach((Ne) => Ne.checked = Ne.value === ve) : my(me.ref) ? me.ref.value = "" : (me.ref.value = ve, me.ref.type || m.state.next({
        name: L,
        values: Rn(i)
      })));
    }
    (Q.shouldDirty || Q.shouldTouch) && R(L, ve, Q.shouldTouch, Q.shouldDirty, !0), Q.shouldValidate && re(L);
  }, ee = (L, q, Q) => {
    for (const Se in q) {
      if (!q.hasOwnProperty(Se))
        return;
      const ve = q[Se], me = L + "." + Se, Ne = Ge(r, me);
      (s.array.has(L) || vn(ve) || Ne && !Ne._f) && !Oa(ve) ? ee(me, ve, Q) : K(me, ve, Q);
    }
  }, Y = (L, q, Q = {}) => {
    const Se = Ge(r, L), ve = s.array.has(L), me = Rn(q);
    Ut(i, L, me), ve ? (m.array.next({
      name: L,
      values: Rn(i)
    }), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && Q.shouldDirty && m.state.next({
      name: L,
      dirtyFields: As(o, i),
      isDirty: G(L, me)
    })) : Se && !Se._f && !sr(me) ? ee(L, me, Q) : K(L, me, Q), DS(L, s) && m.state.next({ ...n, name: L }), m.state.next({
      name: a.mount ? L : void 0,
      values: Rn(i)
    });
  }, J = async (L) => {
    a.mount = !0;
    const q = L.target;
    let Q = q.name, Se = !0;
    const ve = Ge(r, Q), me = (ot) => {
      Se = Number.isNaN(ot) || Oa(ot) && isNaN(ot.getTime()) || Mi(ot, Ge(i, Q, ot));
    }, Ne = AS(t.mode), et = AS(t.reValidateMode);
    if (ve) {
      let ot, Ot;
      const nn = q.type ? OS(ve._f) : Dge(L), Nt = L.type === ES.BLUR || L.type === ES.FOCUS_OUT, wn = !qge(ve._f) && !t.resolver && !Ge(n.errors, Q) && !ve._f.deps || Zge(Nt, Ge(n.touchedFields, Q), n.isSubmitted, et, Ne), kn = DS(Q, s, Nt);
      Ut(i, Q, nn), Nt ? (!q || !q.readOnly) && (ve._f.onBlur && ve._f.onBlur(L), l && l(0)) : ve._f.onChange && ve._f.onChange(L);
      const hr = R(Q, nn, Nt), gr = !ar(hr) || kn;
      if (!Nt && m.state.next({
        name: Q,
        type: L.type,
        values: Rn(i)
      }), wn)
        return (u.isValid || d.isValid) && (t.mode === "onBlur" ? Nt && g() : Nt || g()), gr && m.state.next({ name: Q, ...kn ? {} : hr });
      if (!Nt && kn && m.state.next({ ...n }), t.resolver) {
        const { errors: vr } = await _([Q]);
        if (me(nn), Se) {
          const Mr = PS(n.errors, r, Q), Kn = PS(vr, r, Mr.name || Q);
          ot = Kn.error, Q = Kn.name, Ot = ar(vr);
        }
      } else
        x([Q], !0), ot = (await MS(ve, s.disabled, i, h, t.shouldUseNativeValidation))[Q], x([Q]), me(nn), Se && (ot ? Ot = !1 : (u.isValid || d.isValid) && (Ot = await M(r, !0)));
      Se && (ve._f.deps && (!Array.isArray(ve._f.deps) || ve._f.deps.length > 0) && re(ve._f.deps), A(Q, Ot, ot, hr));
    }
  }, ye = (L, q) => {
    if (Ge(n.errors, q) && L.focus)
      return L.focus(), 1;
  }, re = async (L, q = {}) => {
    let Q, Se;
    const ve = Sc(L);
    if (t.resolver) {
      const me = await k(ln(L) ? L : ve);
      Q = ar(me), Se = L ? !ve.some((Ne) => Ge(me, Ne)) : Q;
    } else L ? (Se = (await Promise.all(ve.map(async (me) => {
      const Ne = Ge(r, me);
      return await M(Ne && Ne._f ? { [me]: Ne } : Ne);
    }))).every(Boolean), !(!Se && !n.isValid) && g()) : Se = Q = await M(r);
    return m.state.next({
      ...!Ir(L) || (u.isValid || d.isValid) && Q !== n.isValid ? {} : { name: L },
      ...t.resolver || !L ? { isValid: Q } : {},
      errors: n.errors
    }), q.shouldFocus && !Se && xc(r, ye, L ? ve : s.mount), Se;
  }, le = (L, q) => {
    let Q = {
      ...a.mount ? i : o
    };
    return q && (Q = zO(q.dirtyFields ? n.dirtyFields : n.touchedFields, Q)), ln(L) ? Q : Ir(L) ? Ge(Q, L) : L.map((Se) => Ge(Q, Se));
  }, Te = (L, q) => ({
    invalid: !!Ge((q || n).errors, L),
    isDirty: !!Ge((q || n).dirtyFields, L),
    error: Ge((q || n).errors, L),
    isValidating: !!Ge(n.validatingFields, L),
    isTouched: !!Ge((q || n).touchedFields, L)
  }), F = (L) => {
    L && Sc(L).forEach((q) => mn(n.errors, q)), m.state.next({
      errors: L ? n.errors : {}
    });
  }, Z = (L, q, Q) => {
    const Se = (Ge(r, L, { _f: {} })._f || {}).ref, ve = Ge(n.errors, L) || {}, { ref: me, message: Ne, type: et, ...ot } = ve;
    Ut(n.errors, L, {
      ...ot,
      ...q,
      ref: Se
    }), m.state.next({
      name: L,
      errors: n.errors,
      isValid: !1
    }), Q && Q.shouldFocus && Se && Se.focus && Se.focus();
  }, se = (L, q) => ro(L) ? m.state.subscribe({
    next: (Q) => "values" in Q && L(U(void 0, q), Q)
  }) : U(L, q, !0), ae = (L) => m.state.subscribe({
    next: (q) => {
      Kge(L.name, q.name, L.exact) && Yge(q, L.formState || u, Rt, L.reRenderRoot) && L.callback({
        values: { ...i },
        ...n,
        ...q,
        defaultValues: o
      });
    }
  }).unsubscribe, ue = (L) => (a.mount = !0, d = {
    ...d,
    ...L.formState
  }, ae({
    ...L,
    formState: d
  })), te = (L, q = {}) => {
    for (const Q of L ? Sc(L) : s.mount)
      s.mount.delete(Q), s.array.delete(Q), q.keepValue || (mn(r, Q), mn(i, Q)), !q.keepError && mn(n.errors, Q), !q.keepDirty && mn(n.dirtyFields, Q), !q.keepTouched && mn(n.touchedFields, Q), !q.keepIsValidating && mn(n.validatingFields, Q), !t.shouldUnregister && !q.keepDefaultValue && mn(o, Q);
    m.state.next({
      values: Rn(i)
    }), m.state.next({
      ...n,
      ...q.keepDirty ? { isDirty: G() } : {}
    }), !q.keepIsValid && g();
  }, he = ({ disabled: L, name: q }) => {
    (To(L) && a.mount || L || s.disabled.has(q)) && (L ? s.disabled.add(q) : s.disabled.delete(q));
  }, ge = (L, q = {}) => {
    let Q = Ge(r, L);
    const Se = To(q.disabled) || To(t.disabled);
    return Ut(r, L, {
      ...Q || {},
      _f: {
        ...Q && Q._f ? Q._f : { ref: { name: L } },
        name: L,
        mount: !0,
        ...q
      }
    }), s.mount.add(L), Q ? he({
      disabled: To(q.disabled) ? q.disabled : t.disabled,
      name: L
    }) : T(L, !0, q.value), {
      ...Se ? { disabled: q.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!q.required,
        min: Hl(q.min),
        max: Hl(q.max),
        minLength: Hl(q.minLength),
        maxLength: Hl(q.maxLength),
        pattern: Hl(q.pattern)
      } : {},
      name: L,
      onChange: J,
      onBlur: J,
      ref: (ve) => {
        if (ve) {
          ge(L, q), Q = Ge(r, L);
          const me = ln(ve.value) && ve.querySelectorAll && ve.querySelectorAll("input,select,textarea")[0] || ve, Ne = Bge(me), et = Q._f.refs || [];
          if (Ne ? et.find((ot) => ot === me) : me === Q._f.ref)
            return;
          Ut(r, L, {
            _f: {
              ...Q._f,
              ...Ne ? {
                refs: [
                  ...et.filter(Rh),
                  me,
                  ...Array.isArray(Ge(o, L)) ? [{}] : []
                ],
                ref: { type: me.type, name: L }
              } : { ref: me }
            }
          }), T(L, !1, void 0, me);
        } else
          Q = Ge(r, L, {}), Q._f && (Q._f.mount = !1), (t.shouldUnregister || q.shouldUnregister) && !(Nge(s.array, L) && a.action) && s.unMount.add(L);
      }
    };
  }, de = () => t.shouldFocusError && xc(r, ye, s.mount), xe = (L) => {
    To(L) && (m.state.next({ disabled: L }), xc(r, (q, Q) => {
      const Se = Ge(r, Q);
      Se && (q.disabled = Se._f.disabled || L, Array.isArray(Se._f.refs) && Se._f.refs.forEach((ve) => {
        ve.disabled = Se._f.disabled || L;
      }));
    }, 0, !1));
  }, ce = (L, q) => async (Q) => {
    let Se;
    Q && (Q.preventDefault && Q.preventDefault(), Q.persist && Q.persist());
    let ve = Rn(i);
    if (m.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: me, values: Ne } = await _();
      n.errors = me, ve = Rn(Ne);
    } else
      await M(r);
    if (s.disabled.size)
      for (const me of s.disabled)
        mn(ve, me);
    if (mn(n.errors, "root"), ar(n.errors)) {
      m.state.next({
        errors: {}
      });
      try {
        await L(ve, Q);
      } catch (me) {
        Se = me;
      }
    } else
      q && await q({ ...n.errors }, Q), de(), setTimeout(de);
    if (m.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ar(n.errors) && !Se,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), Se)
      throw Se;
  }, je = (L, q = {}) => {
    Ge(r, L) && (ln(q.defaultValue) ? Y(L, Rn(Ge(o, L))) : (Y(L, q.defaultValue), Ut(o, L, Rn(q.defaultValue))), q.keepTouched || mn(n.touchedFields, L), q.keepDirty || (mn(n.dirtyFields, L), n.isDirty = q.defaultValue ? G(L, Rn(Ge(o, L))) : G()), q.keepError || (mn(n.errors, L), u.isValid && g()), m.state.next({ ...n }));
  }, z = (L, q = {}) => {
    const Q = L ? Rn(L) : o, Se = Rn(Q), ve = ar(L), me = ve ? o : Se;
    if (q.keepDefaultValues || (o = Q), !q.keepValues) {
      if (q.keepDirtyValues) {
        const Ne = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(As(o, i))
        ]);
        for (const et of Array.from(Ne))
          Ge(n.dirtyFields, et) ? Ut(me, et, Ge(i, et)) : Y(et, Ge(me, et));
      } else {
        if (uy && ln(L))
          for (const Ne of s.mount) {
            const et = Ge(r, Ne);
            if (et && et._f) {
              const ot = Array.isArray(et._f.refs) ? et._f.refs[0] : et._f.ref;
              if (Df(ot)) {
                const Ot = ot.closest("form");
                if (Ot) {
                  Ot.reset();
                  break;
                }
              }
            }
          }
        if (q.keepFieldsRef)
          for (const Ne of s.mount)
            Y(Ne, Ge(me, Ne));
        else
          r = {};
      }
      i = t.shouldUnregister ? q.keepDefaultValues ? Rn(o) : {} : Rn(me), m.array.next({
        values: { ...me }
      }), m.state.next({
        values: { ...me }
      });
    }
    s = {
      mount: q.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !u.isValid || !!q.keepIsValid || !!q.keepDirtyValues, a.watch = !!t.shouldUnregister, m.state.next({
      submitCount: q.keepSubmitCount ? n.submitCount : 0,
      isDirty: ve ? !1 : q.keepDirty ? n.isDirty : !!(q.keepDefaultValues && !Mi(L, o)),
      isSubmitted: q.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: ve ? {} : q.keepDirtyValues ? q.keepDefaultValues && i ? As(o, i) : n.dirtyFields : q.keepDefaultValues && L ? As(o, L) : q.keepDirty ? n.dirtyFields : {},
      touchedFields: q.keepTouched ? n.touchedFields : {},
      errors: q.keepErrors ? n.errors : {},
      isSubmitSuccessful: q.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: o
    });
  }, Ue = (L, q) => z(ro(L) ? L(i) : L, q), st = (L, q = {}) => {
    const Q = Ge(r, L), Se = Q && Q._f;
    if (Se) {
      const ve = Se.refs ? Se.refs[0] : Se.ref;
      ve.focus && (ve.focus(), q.shouldSelect && ro(ve.select) && ve.select());
    }
  }, Rt = (L) => {
    n = {
      ...n,
      ...L
    };
  }, _t = {
    control: {
      register: ge,
      unregister: te,
      getFieldState: Te,
      handleSubmit: ce,
      setError: Z,
      _subscribe: ae,
      _runSchema: _,
      _focusError: de,
      _getWatch: U,
      _getDirty: G,
      _setValid: g,
      _setFieldArray: b,
      _setDisabledField: he,
      _setErrors: I,
      _getFieldArray: B,
      _reset: z,
      _resetDefaultValues: () => ro(t.defaultValues) && t.defaultValues().then((L) => {
        Ue(L, t.resetOptions), m.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: j,
      _disableForm: xe,
      _subjects: m,
      _proxyFormState: u,
      get _fields() {
        return r;
      },
      get _formValues() {
        return i;
      },
      get _state() {
        return a;
      },
      set _state(L) {
        a = L;
      },
      get _defaultValues() {
        return o;
      },
      get _names() {
        return s;
      },
      set _names(L) {
        s = L;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return t;
      },
      set _options(L) {
        t = {
          ...t,
          ...L
        };
      }
    },
    subscribe: ue,
    trigger: re,
    register: ge,
    handleSubmit: ce,
    watch: se,
    setValue: Y,
    getValues: le,
    reset: Ue,
    resetField: je,
    clearErrors: F,
    unregister: te,
    setError: Z,
    setFocus: st,
    getFieldState: Te
  };
  return {
    ..._t,
    formControl: _t
  };
}
function t1e(e = {}) {
  const t = H.useRef(void 0), n = H.useRef(void 0), [r, o] = H.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: ro(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    isReady: !1,
    defaultValues: ro(e.defaultValues) ? void 0 : e.defaultValues
  });
  if (!t.current)
    if (e.formControl)
      t.current = {
        ...e.formControl,
        formState: r
      }, e.defaultValues && !ro(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: a, ...s } = e1e(e);
      t.current = {
        ...s,
        formState: r
      };
    }
  const i = t.current.control;
  return i._options = e, $ge(() => {
    const a = i._subscribe({
      formState: i._proxyFormState,
      callback: () => o({ ...i._formState }),
      reRenderRoot: !0
    });
    return o((s) => ({
      ...s,
      isReady: !0
    })), i._formState.isReady = !0, a;
  }, [i]), H.useEffect(() => i._disableForm(e.disabled), [i, e.disabled]), H.useEffect(() => {
    e.mode && (i._options.mode = e.mode), e.reValidateMode && (i._options.reValidateMode = e.reValidateMode);
  }, [i, e.mode, e.reValidateMode]), H.useEffect(() => {
    e.errors && (i._setErrors(e.errors), i._focusError());
  }, [i, e.errors]), H.useEffect(() => {
    e.shouldUnregister && i._subjects.state.next({
      values: i._getWatch()
    });
  }, [i, e.shouldUnregister]), H.useEffect(() => {
    if (i._proxyFormState.isDirty) {
      const a = i._getDirty();
      a !== r.isDirty && i._subjects.state.next({
        isDirty: a
      });
    }
  }, [i, r.isDirty]), H.useEffect(() => {
    e.values && !Mi(e.values, n.current) ? (i._reset(e.values, {
      keepFieldsRef: !0,
      ...i._options.resetOptions
    }), n.current = e.values, o((a) => ({ ...a }))) : i._resetDefaultValues();
  }, [i, e.values]), H.useEffect(() => {
    i._state.mount || (i._setValid(), i._state.mount = !0), i._state.watch && (i._state.watch = !1, i._subjects.state.next({ ...i._formState })), i._removeUnmounted();
  }), t.current.formState = Lge(r, i), t.current;
}
const WO = "bg-neutral-300/50 text-neutral-900";
function E1({
  title: e,
  show: t,
  onCancel: n,
  onConfirm: r,
  confirmText: o,
  defaultValues: i,
  pending: a
}) {
  var m;
  const {
    register: s,
    watch: l,
    handleSubmit: c,
    formState: { errors: u }
  } = t1e({
    defaultValues: {
      name: (i == null ? void 0 : i.name) ?? ""
    }
  }), d = l("name");
  return /* @__PURE__ */ f.jsx(
    bO,
    {
      title: e,
      show: t,
      onClose: n,
      actions: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(en, { onClick: n, children: "Cancel" }),
        /* @__PURE__ */ f.jsxs(en, { type: "submit", form: "view-form", variant: "primary", children: [
          a && /* @__PURE__ */ f.jsx(J1, {}),
          o
        ] })
      ] }),
      children: /* @__PURE__ */ f.jsx(
        "form",
        {
          id: "view-form",
          onSubmit: c(r),
          children: /* @__PURE__ */ f.jsx(
            kO,
            {
              required: !0,
              label: "Name",
              id: "name",
              addon: {
                insideEnd: /* @__PURE__ */ f.jsx("div", { className: "flex items-center gap-1", children: /* @__PURE__ */ f.jsx("p", { className: "text-xs text-neutral-500", children: `${d.length}/40` }) })
              },
              ...s("name", {
                required: "Name is required",
                maxLength: {
                  value: 40,
                  message: "Name must be less than 40 characters"
                }
              }),
              error: (m = u.name) == null ? void 0 : m.message
            }
          )
        }
      )
    }
  );
}
function f2e({
  onCreate: e,
  pending: t,
  triggerContent: n,
  triggerVariant: r = "default",
  triggerSize: o = "default",
  triggerIcon: i = !1
}) {
  const [a, s] = Fe(!1);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      en,
      {
        variant: r,
        onClick: () => s(!0),
        className: "min-h-8 text-xs",
        size: o,
        icon: i,
        children: n
      }
    ),
    /* @__PURE__ */ f.jsx(
      E1,
      {
        title: "Create new view",
        show: a,
        onCancel: () => s(!1),
        confirmText: "Create view",
        onConfirm: (l) => e(l, () => s(!1)),
        pending: t
      }
    )
  ] });
}
function n1e({
  view: e,
  onEdit: t,
  onRename: n,
  onDuplicate: r,
  onDelete: o,
  renamePending: i,
  duplicatePending: a,
  deletePending: s
}) {
  const [l, c] = Fe(!1), [u, d] = Fe(!1), [m, h] = Fe(!1);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(rs, { children: [
      /* @__PURE__ */ f.jsx(os, { asChild: !0, children: /* @__PURE__ */ f.jsxs(
        en,
        {
          variant: "ghost",
          className: oe("min-h-8 gap-2 text-xs", WO),
          "aria-current": !0,
          children: [
            e.name,
            " ",
            /* @__PURE__ */ f.jsx(Ve, { className: "size-3", icon: "chevronDown" })
          ]
        }
      ) }),
      /* @__PURE__ */ f.jsxs(pa, { align: "start", children: [
        /* @__PURE__ */ f.jsxs(
          Rr,
          {
            className: "gap-2",
            onSelect: () => c(!0),
            children: [
              /* @__PURE__ */ f.jsx(Ve, { icon: "info" }),
              "Rename view"
            ]
          }
        ),
        /* @__PURE__ */ f.jsxs(
          Rr,
          {
            className: "gap-2",
            onSelect: () => d(!0),
            children: [
              /* @__PURE__ */ f.jsx(Ve, { icon: "duplicate" }),
              "Duplicate view"
            ]
          }
        ),
        /* @__PURE__ */ f.jsxs(Rr, { className: "gap-2", onSelect: () => t(e), children: [
          /* @__PURE__ */ f.jsx(Ve, { icon: "edit" }),
          "Edit view"
        ] }),
        /* @__PURE__ */ f.jsxs(
          Rr,
          {
            className: "gap-2 text-red-700 focus:bg-red-100 focus:text-red-700",
            onSelect: () => h(!0),
            children: [
              /* @__PURE__ */ f.jsx(Ve, { icon: "remove" }),
              "Delete view"
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ f.jsx(
      E1,
      {
        title: "Rename view",
        show: l,
        onCancel: () => c(!1),
        confirmText: "Rename view",
        defaultValues: { name: e.name },
        onConfirm: (v) => n({ ...e, name: v.name }, () => c(!1)),
        pending: i
      }
    ),
    /* @__PURE__ */ f.jsx(
      E1,
      {
        title: "Duplicate view",
        show: u,
        onCancel: () => d(!1),
        confirmText: "Duplicate view",
        defaultValues: { name: `Copy of ${e.name}` },
        onConfirm: (v) => {
          const { id: g, ...x } = e;
          r(
            { ...x, name: v.name },
            () => d(!1)
          );
        },
        pending: a
      }
    ),
    /* @__PURE__ */ f.jsx(
      SO,
      {
        title: "Delete view",
        show: m,
        onCancel: () => h(!1),
        onConfirm: () => o(e, () => h(!1)),
        confirmText: "Delete view?",
        variant: "destructive",
        prompt: `This cannot be undone. ${e.name} will no longer be available.`,
        loading: s
      }
    )
  ] });
}
function m2e({
  views: e,
  selectedView: t,
  onViewSelect: n,
  className: r,
  ...o
}) {
  return /* @__PURE__ */ f.jsxs("div", { className: oe("flex grow gap-2", r), children: [
    /* @__PURE__ */ f.jsx(
      en,
      {
        className: oe("min-h-8 text-xs", !t && WO),
        variant: "ghost",
        "aria-current": !t,
        onClick: () => n(null),
        children: "All"
      }
    ),
    e.map(
      (i) => i.id === (t == null ? void 0 : t.id) ? /* @__PURE__ */ Lt(
        n1e,
        {
          ...o,
          view: t,
          key: `${i.id}-${i.name}`
        }
      ) : /* @__PURE__ */ f.jsx(
        en,
        {
          className: "min-h-8 text-xs",
          variant: "ghost",
          onClick: () => n(i),
          children: i.name
        },
        i.id
      )
    )
  ] });
}
function FS(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var r1e = [" ", "Enter", "ArrowUp", "ArrowDown"], o1e = [" ", "Enter"], ku = "Select", [Qm, ep, i1e] = Pv(ku), [Ol] = Vo(ku, [
  i1e,
  da
]), tp = da(), [a1e, ha] = Ol(ku), [s1e, l1e] = Ol(ku), HO = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: a,
    defaultValue: s,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: d,
    disabled: m,
    required: h
  } = e, v = tp(t), [g, x] = S.useState(null), [b, C] = S.useState(null), [I, T] = S.useState(!1), R = xm(c), [A = !1, _] = di({
    prop: r,
    defaultProp: o,
    onChange: i
  }), [k, M] = di({
    prop: a,
    defaultProp: s,
    onChange: l
  }), j = S.useRef(null), G = g ? !!g.closest("form") : !0, [U, B] = S.useState(/* @__PURE__ */ new Set()), K = Array.from(U).map((ee) => ee.props.value).join(";");
  return /* @__PURE__ */ f.jsx(vu, { ...v, children: /* @__PURE__ */ f.jsxs(
    a1e,
    {
      required: h,
      scope: t,
      trigger: g,
      onTriggerChange: x,
      valueNode: b,
      onValueNodeChange: C,
      valueNodeHasChildren: I,
      onValueNodeHasChildrenChange: T,
      contentId: _r(),
      value: k,
      onValueChange: M,
      open: A,
      onOpenChange: _,
      dir: R,
      triggerPointerDownPosRef: j,
      disabled: m,
      children: [
        /* @__PURE__ */ f.jsx(Qm.Provider, { scope: t, children: /* @__PURE__ */ f.jsx(
          s1e,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: S.useCallback((ee) => {
              B((Y) => new Set(Y).add(ee));
            }, []),
            onNativeOptionRemove: S.useCallback((ee) => {
              B((Y) => {
                const J = new Set(Y);
                return J.delete(ee), J;
              });
            }, []),
            children: n
          }
        ) }),
        G ? /* @__PURE__ */ f.jsxs(
          yA,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: u,
            autoComplete: d,
            value: k,
            onChange: (ee) => M(ee.target.value),
            disabled: m,
            children: [
              k === void 0 ? /* @__PURE__ */ f.jsx("option", { value: "" }) : null,
              Array.from(U)
            ]
          },
          K
        ) : null
      ]
    }
  ) });
};
HO.displayName = ku;
var qO = "SelectTrigger", YO = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = tp(n), a = ha(qO, n), s = a.disabled || r, l = mt(t, a.onTriggerChange), c = ep(n), [u, d, m] = bA((v) => {
      const g = c().filter((C) => !C.disabled), x = g.find((C) => C.value === a.value), b = SA(g, v, x);
      b !== void 0 && a.onValueChange(b.value);
    }), h = () => {
      s || (a.onOpenChange(!0), m());
    };
    return /* @__PURE__ */ f.jsx(yu, { asChild: !0, ...i, children: /* @__PURE__ */ f.jsx(
      at.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": vA(a.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: Re(o.onClick, (v) => {
          v.currentTarget.focus();
        }),
        onPointerDown: Re(o.onPointerDown, (v) => {
          const g = v.target;
          g.hasPointerCapture(v.pointerId) && g.releasePointerCapture(v.pointerId), v.button === 0 && v.ctrlKey === !1 && (h(), a.triggerPointerDownPosRef.current = {
            x: Math.round(v.pageX),
            y: Math.round(v.pageY)
          }, v.preventDefault());
        }),
        onKeyDown: Re(o.onKeyDown, (v) => {
          const g = u.current !== "";
          !(v.ctrlKey || v.altKey || v.metaKey) && v.key.length === 1 && d(v.key), !(g && v.key === " ") && r1e.includes(v.key) && (h(), v.preventDefault());
        })
      }
    ) });
  }
);
YO.displayName = qO;
var KO = "SelectValue", ZO = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: a = "", ...s } = e, l = ha(KO, n), { onValueNodeHasChildrenChange: c } = l, u = i !== void 0, d = mt(t, l.onValueNodeChange);
    return An(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ f.jsx(
      at.span,
      {
        ...s,
        ref: d,
        style: { pointerEvents: "none" },
        children: vA(l.value) ? /* @__PURE__ */ f.jsx(f.Fragment, { children: a }) : i
      }
    );
  }
);
ZO.displayName = KO;
var c1e = "SelectIcon", XO = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ f.jsx(at.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
XO.displayName = c1e;
var u1e = "SelectPortal", JO = (e) => /* @__PURE__ */ f.jsx(pu, { asChild: !0, ...e });
JO.displayName = u1e;
var qa = "SelectContent", QO = S.forwardRef(
  (e, t) => {
    const n = ha(qa, e.__scopeSelect), [r, o] = S.useState();
    if (An(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? cl.createPortal(
        /* @__PURE__ */ f.jsx(eA, { scope: e.__scopeSelect, children: /* @__PURE__ */ f.jsx(Qm.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ f.jsx("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ f.jsx(tA, { ...e, ref: t });
  }
);
QO.displayName = qa;
var Zo = 10, [eA, ga] = Ol(qa), d1e = "SelectContentImpl", tA = S.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: g,
      avoidCollisions: x,
      //
      ...b
    } = e, C = ha(qa, n), [I, T] = S.useState(null), [R, A] = S.useState(null), _ = mt(t, (te) => T(te)), [k, M] = S.useState(null), [j, G] = S.useState(
      null
    ), U = ep(n), [B, K] = S.useState(!1), ee = S.useRef(!1);
    S.useEffect(() => {
      if (I) return uu(I);
    }, [I]), Tm();
    const Y = S.useCallback(
      (te) => {
        const [he, ...ge] = U().map((ce) => ce.ref.current), [de] = ge.slice(-1), xe = document.activeElement;
        for (const ce of te)
          if (ce === xe || (ce == null || ce.scrollIntoView({ block: "nearest" }), ce === he && R && (R.scrollTop = 0), ce === de && R && (R.scrollTop = R.scrollHeight), ce == null || ce.focus(), document.activeElement !== xe)) return;
      },
      [U, R]
    ), J = S.useCallback(
      () => Y([k, I]),
      [Y, k, I]
    );
    S.useEffect(() => {
      B && J();
    }, [B, J]);
    const { onOpenChange: ye, triggerPointerDownPosRef: re } = C;
    S.useEffect(() => {
      if (I) {
        let te = { x: 0, y: 0 };
        const he = (de) => {
          var xe, ce;
          te = {
            x: Math.abs(Math.round(de.pageX) - (((xe = re.current) == null ? void 0 : xe.x) ?? 0)),
            y: Math.abs(Math.round(de.pageY) - (((ce = re.current) == null ? void 0 : ce.y) ?? 0))
          };
        }, ge = (de) => {
          te.x <= 10 && te.y <= 10 ? de.preventDefault() : I.contains(de.target) || ye(!1), document.removeEventListener("pointermove", he), re.current = null;
        };
        return re.current !== null && (document.addEventListener("pointermove", he), document.addEventListener("pointerup", ge, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", he), document.removeEventListener("pointerup", ge, { capture: !0 });
        };
      }
    }, [I, ye, re]), S.useEffect(() => {
      const te = () => ye(!1);
      return window.addEventListener("blur", te), window.addEventListener("resize", te), () => {
        window.removeEventListener("blur", te), window.removeEventListener("resize", te);
      };
    }, [ye]);
    const [le, Te] = bA((te) => {
      const he = U().filter((xe) => !xe.disabled), ge = he.find((xe) => xe.ref.current === document.activeElement), de = SA(he, te, ge);
      de && setTimeout(() => de.ref.current.focus());
    }), F = S.useCallback(
      (te, he, ge) => {
        const de = !ee.current && !ge;
        (C.value !== void 0 && C.value === he || de) && (M(te), de && (ee.current = !0));
      },
      [C.value]
    ), Z = S.useCallback(() => I == null ? void 0 : I.focus(), [I]), se = S.useCallback(
      (te, he, ge) => {
        const de = !ee.current && !ge;
        (C.value !== void 0 && C.value === he || de) && G(te);
      },
      [C.value]
    ), ae = r === "popper" ? I1 : nA, ue = ae === I1 ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: g,
      avoidCollisions: x
    } : {};
    return /* @__PURE__ */ f.jsx(
      eA,
      {
        scope: n,
        content: I,
        viewport: R,
        onViewportChange: A,
        itemRefCallback: F,
        selectedItem: k,
        onItemLeave: Z,
        itemTextRefCallback: se,
        focusSelectedItem: J,
        selectedItemText: j,
        position: r,
        isPositioned: B,
        searchRef: le,
        children: /* @__PURE__ */ f.jsx(hu, { as: si, allowPinchZoom: !0, children: /* @__PURE__ */ f.jsx(
          mu,
          {
            asChild: !0,
            trapped: C.open,
            onMountAutoFocus: (te) => {
              te.preventDefault();
            },
            onUnmountAutoFocus: Re(o, (te) => {
              var he;
              (he = C.trigger) == null || he.focus({ preventScroll: !0 }), te.preventDefault();
            }),
            children: /* @__PURE__ */ f.jsx(
              fu,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: a,
                onFocusOutside: (te) => te.preventDefault(),
                onDismiss: () => C.onOpenChange(!1),
                children: /* @__PURE__ */ f.jsx(
                  ae,
                  {
                    role: "listbox",
                    id: C.contentId,
                    "data-state": C.open ? "open" : "closed",
                    dir: C.dir,
                    onContextMenu: (te) => te.preventDefault(),
                    ...b,
                    ...ue,
                    onPlaced: () => K(!0),
                    ref: _,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: Re(b.onKeyDown, (te) => {
                      const he = te.ctrlKey || te.altKey || te.metaKey;
                      if (te.key === "Tab" && te.preventDefault(), !he && te.key.length === 1 && Te(te.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(te.key)) {
                        let de = U().filter((xe) => !xe.disabled).map((xe) => xe.ref.current);
                        if (["ArrowUp", "End"].includes(te.key) && (de = de.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(te.key)) {
                          const xe = te.target, ce = de.indexOf(xe);
                          de = de.slice(ce + 1);
                        }
                        setTimeout(() => Y(de)), te.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
tA.displayName = d1e;
var f1e = "SelectItemAlignedPosition", nA = S.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = ha(qa, n), a = ga(qa, n), [s, l] = S.useState(null), [c, u] = S.useState(null), d = mt(t, (_) => u(_)), m = ep(n), h = S.useRef(!1), v = S.useRef(!0), { viewport: g, selectedItem: x, selectedItemText: b, focusSelectedItem: C } = a, I = S.useCallback(() => {
    if (i.trigger && i.valueNode && s && c && g && x && b) {
      const _ = i.trigger.getBoundingClientRect(), k = c.getBoundingClientRect(), M = i.valueNode.getBoundingClientRect(), j = b.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const xe = j.left - k.left, ce = M.left - xe, je = _.left - ce, z = _.width + je, Ue = Math.max(z, k.width), st = window.innerWidth - Zo, Rt = FS(ce, [Zo, st - Ue]);
        s.style.minWidth = z + "px", s.style.left = Rt + "px";
      } else {
        const xe = k.right - j.right, ce = window.innerWidth - M.right - xe, je = window.innerWidth - _.right - ce, z = _.width + je, Ue = Math.max(z, k.width), st = window.innerWidth - Zo, Rt = FS(ce, [Zo, st - Ue]);
        s.style.minWidth = z + "px", s.style.right = Rt + "px";
      }
      const G = m(), U = window.innerHeight - Zo * 2, B = g.scrollHeight, K = window.getComputedStyle(c), ee = parseInt(K.borderTopWidth, 10), Y = parseInt(K.paddingTop, 10), J = parseInt(K.borderBottomWidth, 10), ye = parseInt(K.paddingBottom, 10), re = ee + Y + B + ye + J, le = Math.min(x.offsetHeight * 5, re), Te = window.getComputedStyle(g), F = parseInt(Te.paddingTop, 10), Z = parseInt(Te.paddingBottom, 10), se = _.top + _.height / 2 - Zo, ae = U - se, ue = x.offsetHeight / 2, te = x.offsetTop + ue, he = ee + Y + te, ge = re - he;
      if (he <= se) {
        const xe = x === G[G.length - 1].ref.current;
        s.style.bottom = "0px";
        const ce = c.clientHeight - g.offsetTop - g.offsetHeight, je = Math.max(
          ae,
          ue + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (xe ? Z : 0) + ce + J
        ), z = he + je;
        s.style.height = z + "px";
      } else {
        const xe = x === G[0].ref.current;
        s.style.top = "0px";
        const je = Math.max(
          se,
          ee + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (xe ? F : 0) + ue
        ) + ge;
        s.style.height = je + "px", g.scrollTop = he - se + g.offsetTop;
      }
      s.style.margin = `${Zo}px 0`, s.style.minHeight = le + "px", s.style.maxHeight = U + "px", r == null || r(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    m,
    i.trigger,
    i.valueNode,
    s,
    c,
    g,
    x,
    b,
    i.dir,
    r
  ]);
  An(() => I(), [I]);
  const [T, R] = S.useState();
  An(() => {
    c && R(window.getComputedStyle(c).zIndex);
  }, [c]);
  const A = S.useCallback(
    (_) => {
      _ && v.current === !0 && (I(), C == null || C(), v.current = !1);
    },
    [I, C]
  );
  return /* @__PURE__ */ f.jsx(
    p1e,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: A,
      children: /* @__PURE__ */ f.jsx(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: T
          },
          children: /* @__PURE__ */ f.jsx(
            at.div,
            {
              ...o,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
nA.displayName = f1e;
var m1e = "SelectPopperPosition", I1 = S.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = Zo,
    ...i
  } = e, a = tp(n);
  return /* @__PURE__ */ f.jsx(
    Pm,
    {
      ...a,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
I1.displayName = m1e;
var [p1e, hy] = Ol(qa, {}), R1 = "SelectViewport", rA = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = ga(R1, n), a = hy(R1, n), s = mt(t, i.onViewportChange), l = S.useRef(0);
    return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ f.jsx(Qm.Slot, { scope: n, children: /* @__PURE__ */ f.jsx(
        at.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...o.style
          },
          onScroll: Re(o.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: m } = a;
            if (m != null && m.current && d) {
              const h = Math.abs(l.current - u.scrollTop);
              if (h > 0) {
                const v = window.innerHeight - Zo * 2, g = parseFloat(d.style.minHeight), x = parseFloat(d.style.height), b = Math.max(g, x);
                if (b < v) {
                  const C = b + h, I = Math.min(v, C), T = C - I;
                  d.style.height = I + "px", d.style.bottom === "0px" && (u.scrollTop = T > 0 ? T : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
rA.displayName = R1;
var oA = "SelectGroup", [h1e, g1e] = Ol(oA), iA = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = _r();
    return /* @__PURE__ */ f.jsx(h1e, { scope: n, id: o, children: /* @__PURE__ */ f.jsx(at.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
iA.displayName = oA;
var aA = "SelectLabel", sA = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = g1e(aA, n);
    return /* @__PURE__ */ f.jsx(at.div, { id: o.id, ...r, ref: t });
  }
);
sA.displayName = aA;
var Nf = "SelectItem", [v1e, lA] = Ol(Nf), cA = S.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...a
    } = e, s = ha(Nf, n), l = ga(Nf, n), c = s.value === r, [u, d] = S.useState(i ?? ""), [m, h] = S.useState(!1), v = mt(
      t,
      (b) => {
        var C;
        return (C = l.itemRefCallback) == null ? void 0 : C.call(l, b, r, o);
      }
    ), g = _r(), x = () => {
      o || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ f.jsx(
      v1e,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: g,
        isSelected: c,
        onItemTextChange: S.useCallback((b) => {
          d((C) => C || ((b == null ? void 0 : b.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ f.jsx(
          Qm.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: u,
            children: /* @__PURE__ */ f.jsx(
              at.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": c && m,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...a,
                ref: v,
                onFocus: Re(a.onFocus, () => h(!0)),
                onBlur: Re(a.onBlur, () => h(!1)),
                onPointerUp: Re(a.onPointerUp, x),
                onPointerMove: Re(a.onPointerMove, (b) => {
                  var C;
                  o ? (C = l.onItemLeave) == null || C.call(l) : b.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Re(a.onPointerLeave, (b) => {
                  var C;
                  b.currentTarget === document.activeElement && ((C = l.onItemLeave) == null || C.call(l));
                }),
                onKeyDown: Re(a.onKeyDown, (b) => {
                  var I;
                  ((I = l.searchRef) == null ? void 0 : I.current) !== "" && b.key === " " || (o1e.includes(b.key) && x(), b.key === " " && b.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
cA.displayName = Nf;
var rc = "SelectItemText", uA = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, a = ha(rc, n), s = ga(rc, n), l = lA(rc, n), c = l1e(rc, n), [u, d] = S.useState(null), m = mt(
      t,
      (b) => d(b),
      l.onItemTextChange,
      (b) => {
        var C;
        return (C = s.itemTextRefCallback) == null ? void 0 : C.call(s, b, l.value, l.disabled);
      }
    ), h = u == null ? void 0 : u.textContent, v = S.useMemo(
      () => /* @__PURE__ */ f.jsx("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: x } = c;
    return An(() => (g(v), () => x(v)), [g, x, v]), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx(at.span, { id: l.textId, ...i, ref: m }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? cl.createPortal(i.children, a.valueNode) : null
    ] });
  }
);
uA.displayName = rc;
var dA = "SelectItemIndicator", fA = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return lA(dA, n).isSelected ? /* @__PURE__ */ f.jsx(at.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
fA.displayName = dA;
var T1 = "SelectScrollUpButton", mA = S.forwardRef((e, t) => {
  const n = ga(T1, e.__scopeSelect), r = hy(T1, e.__scopeSelect), [o, i] = S.useState(!1), a = mt(t, r.onScrollButtonChange);
  return An(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        i(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ f.jsx(
    hA,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
mA.displayName = T1;
var _1 = "SelectScrollDownButton", pA = S.forwardRef((e, t) => {
  const n = ga(_1, e.__scopeSelect), r = hy(_1, e.__scopeSelect), [o, i] = S.useState(!1), a = mt(t, r.onScrollButtonChange);
  return An(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        i(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ f.jsx(
    hA,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
pA.displayName = _1;
var hA = S.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = ga("SelectScrollButton", n), a = S.useRef(null), s = ep(n), l = S.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return S.useEffect(() => () => l(), [l]), An(() => {
    var u;
    const c = s().find((d) => d.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ f.jsx(
    at.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: Re(o.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: Re(o.onPointerMove, () => {
        var c;
        (c = i.onItemLeave) == null || c.call(i), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: Re(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), y1e = "SelectSeparator", gA = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ f.jsx(at.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
gA.displayName = y1e;
var O1 = "SelectArrow", b1e = S.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = tp(n), i = ha(O1, n), a = ga(O1, n);
    return i.open && a.position === "popper" ? /* @__PURE__ */ f.jsx(Nm, { ...o, ...r, ref: t }) : null;
  }
);
b1e.displayName = O1;
function vA(e) {
  return e === "" || e === void 0;
}
var yA = S.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = S.useRef(null), i = mt(t, o), a = RI(n);
    return S.useEffect(() => {
      const s = o.current, l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== n && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(s, n), s.dispatchEvent(d);
      }
    }, [a, n]), /* @__PURE__ */ f.jsx(U2, { asChild: !0, children: /* @__PURE__ */ f.jsx("select", { ...r, ref: i, defaultValue: n }) });
  }
);
yA.displayName = "BubbleSelect";
function bA(e) {
  const t = tr(e), n = S.useRef(""), r = S.useRef(0), o = S.useCallback(
    (a) => {
      const s = n.current + a;
      t(s), (function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      })(s);
    },
    [t]
  ), i = S.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return S.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function SA(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = S1e(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function S1e(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var x1e = HO, xA = YO, C1e = ZO, w1e = XO, E1e = JO, CA = QO, I1e = rA, R1e = iA, wA = sA, EA = cA, T1e = uA, _1e = fA, IA = mA, RA = pA, TA = gA;
const O1e = x1e, A1e = R1e, k1e = C1e, _A = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f.jsxs(
  xA,
  {
    ref: r,
    className: oe(
      "group flex w-full items-center justify-between gap-1 rounded-md border border-neutral-200 bg-white px-3 py-2 text-sm ring-offset-white focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 data-placeholder:text-neutral-500 data-placeholder:placeholder:text-neutral-500",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ f.jsx(w1e, { asChild: !0, children: /* @__PURE__ */ f.jsx(
        Ve,
        {
          icon: "chevronDown",
          className: "opacity-50 transition-all duration-100 group-aria-expanded:-rotate-180"
        }
      ) })
    ]
  }
));
_A.displayName = xA.displayName;
const OA = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  IA,
  {
    ref: n,
    className: oe(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f.jsx(Ve, { icon: "chevronUp" })
  }
));
OA.displayName = IA.displayName;
const AA = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  RA,
  {
    ref: n,
    className: oe(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ f.jsx(Ve, { icon: "chevronDown" })
  }
));
AA.displayName = RA.displayName;
const kA = S.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ f.jsx(E1e, { children: /* @__PURE__ */ f.jsxs(
  CA,
  {
    ref: o,
    className: oe(
      "relative z-50 max-h-96 min-w-32 overflow-hidden rounded-md border border-neutral-200 bg-white text-neutral-950 shadow-md",
      "duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-90 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-90",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ f.jsx(OA, {}),
      /* @__PURE__ */ f.jsx(
        I1e,
        {
          className: oe(
            "p-1",
            n === "popper" && "h-(--radix-select-trigger-height) w-full min-w-(--radix-select-trigger-width)"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ f.jsx(AA, {})
    ]
  }
) }));
kA.displayName = CA.displayName;
const DA = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  wA,
  {
    ref: n,
    className: oe(
      "px-2 py-1.5 text-xs font-medium text-neutral-500",
      e
    ),
    ...t
  }
));
DA.displayName = wA.displayName;
const A1 = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ f.jsxs(
  EA,
  {
    ref: r,
    className: oe(
      "grid w-full cursor-default grid-cols-[auto_1fr] items-center justify-between gap-2 rounded-xs px-2 py-1.5 text-sm outline-hidden select-none focus:bg-neutral-100 focus:text-neutral-900 data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ f.jsx("span", { className: "flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ f.jsx(_1e, { children: /* @__PURE__ */ f.jsx(Ve, { icon: "check" }) }) }),
      /* @__PURE__ */ f.jsx(T1e, { children: t })
    ]
  }
));
A1.displayName = EA.displayName;
const D1e = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  TA,
  {
    ref: n,
    className: oe("-mx-1 my-1 h-px bg-neutral-100", e),
    ...t
  }
));
D1e.displayName = TA.displayName;
function p2e({
  label: e,
  labelVisuallyHidden: t = !1,
  options: n,
  defaultValue: r,
  value: o,
  onChange: i,
  defaultOpen: a,
  open: s,
  onOpenChange: l,
  name: c,
  disabled: u,
  required: d,
  placeholder: m = "Select an option",
  error: h,
  details: v
}) {
  const g = oi();
  return /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ f.jsx(pi, { htmlFor: g, className: oe(t && "sr-only"), children: e }),
    /* @__PURE__ */ f.jsxs(
      O1e,
      {
        defaultValue: r,
        value: CK(o) ? "" : o,
        onValueChange: i,
        defaultOpen: a,
        open: s,
        onOpenChange: l,
        name: c,
        disabled: u,
        required: d,
        children: [
          /* @__PURE__ */ f.jsx(_A, { id: g, children: /* @__PURE__ */ f.jsx(k1e, { placeholder: m }) }),
          /* @__PURE__ */ f.jsx(kA, { children: n.map((x) => "options" in x ? /* @__PURE__ */ f.jsxs(A1e, { children: [
            /* @__PURE__ */ f.jsx(DA, { children: x.label }),
            x.options.map((b) => /* @__PURE__ */ f.jsx(
              A1,
              {
                value: b.value,
                children: b.label
              },
              b.value
            ))
          ] }, x.key) : /* @__PURE__ */ f.jsx(A1, { value: x.value, children: x.label }, x.value)) })
        ]
      }
    ),
    h && /* @__PURE__ */ f.jsx("section", { className: "text-xs text-red-600", children: h }),
    v && /* @__PURE__ */ f.jsx("section", { className: "text-xs text-neutral-500", children: v })
  ] });
}
function h2e({
  children: e,
  content: t,
  side: n,
  asChild: r
}) {
  return /* @__PURE__ */ f.jsx(Y2, { children: /* @__PURE__ */ f.jsxs(K2, { children: [
    /* @__PURE__ */ f.jsx(Hm, { asChild: r, children: e }),
    /* @__PURE__ */ f.jsx(qm, { side: n, children: t })
  ] }) });
}
function g2e({ options: e, value: t, onChange: n }) {
  var o;
  const r = ((o = e.find((i) => i.value === t.column)) == null ? void 0 : o.sortLabels) ?? {
    asc: "Oldest to newest",
    desc: "Newest to oldest"
  };
  return /* @__PURE__ */ f.jsxs(rs, { children: [
    /* @__PURE__ */ f.jsx(os, { asChild: !0, children: /* @__PURE__ */ f.jsx(
      Fn,
      {
        className: "min-h-8",
        icon: cL,
        accessibilityLabel: "Sort"
      }
    ) }),
    /* @__PURE__ */ f.jsxs(pa, { align: "end", children: [
      /* @__PURE__ */ f.jsx(i_, { className: "text-xs", children: "Sort by" }),
      /* @__PURE__ */ f.jsx(
        D2,
        {
          value: t.column,
          onValueChange: (i) => n({ column: i, direction: t.direction }),
          children: e.map((i) => /* @__PURE__ */ f.jsx(
            jm,
            {
              value: i.value,
              className: "text-xs",
              onSelect: (a) => a.preventDefault(),
              children: i.label
            },
            i.value
          ))
        }
      ),
      /* @__PURE__ */ f.jsx(a_, {}),
      /* @__PURE__ */ f.jsxs(
        Rr,
        {
          className: oe(
            "text-xs",
            t.direction === "asc" && "bg-neutral-200"
          ),
          onSelect: (i) => {
            i.preventDefault(), n({ column: t.column, direction: "asc" });
          },
          children: [
            /* @__PURE__ */ f.jsx(Ve, { icon: sF, className: "mr-2" }),
            r.asc
          ]
        }
      ),
      /* @__PURE__ */ f.jsxs(
        Rr,
        {
          className: oe(
            "text-xs",
            t.direction === "desc" && "bg-neutral-200"
          ),
          onSelect: (i) => {
            i.preventDefault(), n({ column: t.column, direction: "desc" });
          },
          children: [
            /* @__PURE__ */ f.jsx(Ve, { icon: tL, className: "mr-2" }),
            r.desc
          ]
        }
      )
    ] })
  ] });
}
const P1e = "var(--color-neutral-200)", N1e = (e) => typeof e == "object" && e !== null && "parentValue" in e && "color" in e, M1e = (e, t) => `color-mix(in oklab, ${e} ${Math.max(35, 85 - t * 10)}%, white)`, LS = (e) => [...e].sort((t, n) => n.value - t.value), F1e = ({
  data: e,
  maxSlices: t,
  maxChildren: n,
  otherLabel: r,
  restLabel: o
}) => {
  const i = LS(e.filter(({ value: m }) => Hc(m))), a = i.slice(0, t), s = i.slice(t), l = [
    ...a,
    ...s.length > 0 ? [
      {
        key: yc,
        label: r,
        value: s.reduce((m, { value: h }) => m + h, 0),
        children: []
      }
    ] : []
  ], c = l.map((m, h) => ({
    key: m.key,
    label: m.label,
    value: m.value,
    color: m.key === yc ? fO : ey(h),
    parent: m.key,
    parentValue: m.value
  })), u = c.flatMap((m) => {
    const h = l.find(({ key: I }) => I === m.key), g = LS(
      ((h == null ? void 0 : h.children) ?? []).filter(({ value: I }) => Hc(I))
    ).filter(({ muted: I }) => !I), x = g.slice(0, n), b = m.value - x.reduce((I, { value: T }) => I + T, 0), C = (I, T) => ({
      key: `${m.key}/${I.key}`,
      label: I.label,
      value: I.value,
      color: I.muted ? P1e : M1e(m.color, T),
      parent: m.key,
      parentLabel: m.label,
      parentValue: m.value
    });
    return [
      ...x.map(C),
      ...b > 0 ? [
        C(
          {
            key: "rest",
            // folded slices and folded details are made up of details, not items without one
            label: m.key === yc || g.length > x.length ? o : "No detail",
            value: b,
            muted: !0
          },
          x.length
        )
      ] : []
    ];
  }), d = c.reduce((m, { value: h }) => m + h, 0);
  return { inner: c, outer: u, total: d };
}, L1e = ({
  active: e,
  payload: t,
  total: n,
  valueFormatter: r
}) => {
  var i;
  const o = (i = t == null ? void 0 : t[0]) == null ? void 0 : i.payload;
  return !e || !N1e(o) ? null : /* @__PURE__ */ f.jsxs(IC, { heading: o.parentLabel, children: [
    /* @__PURE__ */ f.jsx(
      RC,
      {
        color: o.color,
        name: o.label,
        value: r(o.value)
      }
    ),
    /* @__PURE__ */ f.jsx("p", { className: "text-neutral-500 tabular-nums", children: o.parentLabel ? `${Na(o.value, o.parentValue)} of ${o.parentLabel}, ${Na(o.value, n)} of all` : `${Na(o.value, n)} of all` })
  ] });
}, $1e = ({
  title: e,
  headingLevel: t = "h3",
  description: n,
  info: r,
  data: o,
  maxSlices: i = 8,
  maxChildren: a = 6,
  otherLabel: s = "Others",
  restLabel: l = "Other details",
  valueFormatter: c = dt.count,
  emptyMessage: u = "No data for this period"
}) => {
  const [d, m] = Fe(null), { inner: h, outer: v, total: g } = F1e({
    data: o,
    maxSlices: i,
    maxChildren: a,
    otherLabel: s,
    restLabel: l
  }), x = ({ parent: b }) => d === null || d === b ? 1 : 0.3;
  return /* @__PURE__ */ f.jsxs(un, { stretch: !0, children: [
    /* @__PURE__ */ f.jsx(
      Km,
      {
        title: e,
        headingLevel: t,
        description: n,
        info: r
      }
    ),
    h.length > 0 ? /* @__PURE__ */ f.jsx("div", { className: "@container", children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-4 @lg:flex-row @lg:items-center", children: [
      /* @__PURE__ */ f.jsxs("div", { className: "relative mx-auto w-full max-w-72 shrink-0", children: [
        /* @__PURE__ */ f.jsx(
          qf,
          {
            "aria-hidden": !0,
            className: "aspect-square h-auto",
            onMouseLeave: () => m(null),
            children: /* @__PURE__ */ f.jsxs(ix, { accessibilityLayer: !1, children: [
              /* @__PURE__ */ f.jsx(
                nx,
                {
                  cursor: !1,
                  wrapperStyle: { zIndex: 10 },
                  content: /* @__PURE__ */ f.jsx(
                    L1e,
                    {
                      total: g,
                      valueFormatter: c
                    }
                  )
                }
              ),
              /* @__PURE__ */ f.jsx(
                Ah,
                {
                  data: h,
                  dataKey: "value",
                  nameKey: "label",
                  innerRadius: "30%",
                  outerRadius: "58%",
                  startAngle: 90,
                  endAngle: -270,
                  stroke: "white",
                  strokeWidth: 2,
                  animationBegin: 0,
                  animationDuration: 400,
                  onMouseEnter: (b, C) => {
                    var I;
                    return m(((I = h[C]) == null ? void 0 : I.parent) ?? null);
                  },
                  children: h.map((b) => /* @__PURE__ */ f.jsx(
                    Ry,
                    {
                      fill: b.color,
                      fillOpacity: x(b),
                      className: "transition-[fill-opacity] duration-150"
                    },
                    b.key
                  ))
                }
              ),
              /* @__PURE__ */ f.jsx(
                Ah,
                {
                  data: v,
                  dataKey: "value",
                  nameKey: "label",
                  innerRadius: "61%",
                  outerRadius: "92%",
                  startAngle: 90,
                  endAngle: -270,
                  stroke: "white",
                  strokeWidth: 1.5,
                  animationBegin: 150,
                  animationDuration: 400,
                  onMouseEnter: (b, C) => {
                    var I;
                    return m(((I = v[C]) == null ? void 0 : I.parent) ?? null);
                  },
                  children: v.map((b) => /* @__PURE__ */ f.jsx(
                    Ry,
                    {
                      fill: b.color,
                      fillOpacity: x(b),
                      className: "transition-[fill-opacity] duration-150"
                    },
                    b.key
                  ))
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            "aria-hidden": !0,
            className: "pointer-events-none absolute inset-0 flex flex-col items-center justify-center",
            children: [
              /* @__PURE__ */ f.jsx("span", { className: "text-base font-semibold text-neutral-900 tabular-nums", children: c(g) }),
              /* @__PURE__ */ f.jsx("span", { className: "text-[10px] tracking-wide text-neutral-500 uppercase", children: "Total" })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx(
        "ul",
        {
          "aria-label": `${e} legend`,
          className: "flex min-w-0 flex-1 flex-col gap-1.5 text-xs",
          children: h.map((b) => /* @__PURE__ */ f.jsxs(
            "li",
            {
              className: "flex items-center gap-2 rounded-sm px-1 transition-opacity",
              style: { opacity: x(b) },
              onMouseEnter: () => m(b.parent),
              onMouseLeave: () => m(null),
              children: [
                /* @__PURE__ */ f.jsx(
                  "span",
                  {
                    "aria-hidden": !0,
                    className: "size-2 shrink-0 rounded-sm",
                    style: { backgroundColor: b.color }
                  }
                ),
                /* @__PURE__ */ f.jsx("span", { className: "min-w-0 flex-1 truncate text-neutral-600", children: b.label }),
                /* @__PURE__ */ f.jsx("span", { className: "text-neutral-900 tabular-nums", children: c(b.value) }),
                /* @__PURE__ */ f.jsx("span", { className: "w-10 text-right text-neutral-400 tabular-nums", children: Na(b.value, g) }),
                /* @__PURE__ */ f.jsx("ul", { className: "sr-only", children: v.filter(({ parent: C }) => C === b.parent).map((C) => /* @__PURE__ */ f.jsx("li", { children: `${C.label}: ${c(C.value)}` }, C.key)) })
              ]
            },
            b.key
          ))
        }
      )
    ] }) }) : /* @__PURE__ */ f.jsx(as, { message: u })
  ] });
}, $S = (e) => e.map((t) => /* @__PURE__ */ f.jsx(ka, { children: t }, t));
function v2e({ tags: e }) {
  return /* @__PURE__ */ f.jsx("div", { className: "flex flex-wrap gap-1", children: e.length > 2 ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(ka, { children: e[0] }),
    /* @__PURE__ */ f.jsx(ka, { children: e[1] }),
    /* @__PURE__ */ f.jsxs(xl, { children: [
      /* @__PURE__ */ f.jsx(Cl, { onClick: (t) => t.stopPropagation(), children: /* @__PURE__ */ f.jsxs(ka, { hoverable: !0, children: [
        "+",
        e.length - 2
      ] }) }),
      /* @__PURE__ */ f.jsx(ts, { align: "end", children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-wrap gap-1", children: $S(e.slice(2)) }) })
    ] })
  ] }) : $S(e) });
}
const zS = 640, Mf = 300, z1e = 11, j1e = 34, jS = 4, PA = 0.56, B1e = (e, t, n, r) => {
  const o = n.length * r * PA / 2 + jS, i = r * 1.05 / 2 + jS / 2;
  return {
    left: e - o,
    right: e + o,
    top: t - i,
    bottom: t + i
  };
}, G1e = (e, t) => e.left < t.right && t.left < e.right && e.top < t.bottom && t.top < e.bottom, V1e = ({ left: e, right: t, top: n, bottom: r }, o) => e >= 0 && t <= o && n >= 0 && r <= Mf, U1e = (e, t, n) => {
  var u;
  const r = [...e].filter(({ value: d }) => Hc(d)).sort((d, m) => m.value - d.value || d.label.localeCompare(m.label)).slice(0, t), o = ((u = r[0]) == null ? void 0 : u.value) ?? 0, i = (d) => j1e * Math.sqrt(d / o), a = Math.min(
    1,
    ...r.map(
      ({ value: d, label: m }) => n * 0.8 / (m.length * PA * i(d))
    )
  ), s = (d) => Math.max(z1e, i(d) * a), l = [], c = [];
  return r.forEach((d, m) => {
    const h = s(d.value);
    for (let v = 0; v < 4e3; v += 1) {
      const g = v * 0.25, x = 1.1 * g, b = n / 2 + x * Math.cos(g) * (n / Mf), C = Mf / 2 + x * Math.sin(g), I = B1e(b, C, d.label, h);
      if (V1e(I, n) && !l.some((T) => G1e(I, T))) {
        l.push(I), c.push({ ...d, x: b, y: C, size: h, rank: m });
        return;
      }
    }
  }), c;
}, W1e = ({
  title: e,
  headingLevel: t = "h3",
  description: n,
  info: r,
  data: o,
  maxWords: i = 40,
  valueFormatter: a = dt.count,
  emptyMessage: s = "No data for this period"
}) => {
  const [l, c] = Fe(null), [u, d] = pO(), m = d > 0 ? Math.min(d, zS) : zS, h = Be(
    () => U1e(o, i, m),
    [o, i, m]
  ), v = o.filter(({ value: b }) => Hc(b)), g = v.reduce((b, { value: C }) => b + C, 0), x = h.find(({ key: b }) => b === l);
  return /* @__PURE__ */ f.jsxs(un, { stretch: !0, children: [
    /* @__PURE__ */ f.jsx(
      Km,
      {
        title: e,
        headingLevel: t,
        description: n,
        info: r
      }
    ),
    h.length > 0 ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx("div", { ref: u, children: /* @__PURE__ */ f.jsx(
        "svg",
        {
          "aria-hidden": !0,
          viewBox: `0 0 ${m} ${Mf}`,
          className: "w-full select-none",
          onMouseLeave: () => c(null),
          children: h.map((b) => /* @__PURE__ */ f.jsx(
            "text",
            {
              x: b.x,
              y: b.y,
              textAnchor: "middle",
              dominantBaseline: "central",
              fontSize: b.size,
              fill: ey(b.rank),
              opacity: l === null || l === b.key ? 1 : 0.25,
              className: b.rank < 3 ? "font-semibold transition-opacity duration-150" : "font-medium transition-opacity duration-150",
              onMouseEnter: () => c(b.key),
              children: b.label
            },
            b.key
          ))
        }
      ) }),
      /* @__PURE__ */ f.jsx(mO, { placeholder: "Hover a word to see how often it came up", children: x && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx("span", { className: "font-medium text-neutral-900", children: x.label }),
        `: ${a(x.value)}, ${Na(x.value, g)} of those listed`
      ] }) }),
      /* @__PURE__ */ f.jsx("ol", { "aria-label": e, className: "sr-only", children: v.map((b) => /* @__PURE__ */ f.jsx("li", { children: `${b.label}: ${a(b.value)}` }, b.key)) })
    ] }) : /* @__PURE__ */ f.jsx(as, { message: s })
  ] });
}, NA = Nn(null);
function MA() {
  const e = On(NA);
  if (!e)
    throw new Error("useLoadingContext must be used within a LoadingProvider");
  return e;
}
function y2e() {
  const { setLoading: e } = MA();
  return Le(() => (e(!0), () => e(!1)), [e]), null;
}
function b2e({ children: e }) {
  const [t, n] = Fe(!1), r = Be(() => ({ loading: t, setLoading: n }), [t]);
  return /* @__PURE__ */ f.jsx(NA.Provider, { value: r, children: e });
}
const k1 = 0.99, H1e = 1e-3, q1e = 2500;
function Y1e(e) {
  return k1 * (1 - Math.exp(-e / q1e));
}
function S2e({ className: e }) {
  const { loading: t } = MA(), [n, r] = Fe(0);
  return Le(() => {
    if (r(0), !t) return;
    let o, i = requestAnimationFrame(function a(s) {
      o ?? (o = s);
      const l = Y1e(s - o);
      if (k1 - l < H1e) {
        r(k1);
        return;
      }
      r(l), i = requestAnimationFrame(a);
    });
    return () => cancelAnimationFrame(i);
  }, [t]), t ? /* @__PURE__ */ f.jsx(
    "progress",
    {
      className: oe(
        e,
        "h-1 w-full [&::-moz-progress-bar]:bg-corso-blue-500 [&::-webkit-progress-bar]:bg-neutral-700 [&::-webkit-progress-value]:bg-corso-blue-500"
      ),
      value: n,
      "aria-label": "Loading"
    }
  ) : null;
}
const K1e = qr(
  "rounded-md border text-sm duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 motion-reduce:animate-none",
  {
    variants: {
      variant: {
        default: "border-neutral-200 bg-neutral-100 text-neutral-600",
        info: "border-corso-blue-100 bg-corso-blue-100 text-corso-blue-600",
        warning: "border-amber-200 bg-amber-100 text-amber-600",
        critical: "border-red-200 bg-red-100 text-red-600",
        tip: "border-violet-200 bg-violet-100 text-violet-600"
      },
      // this is counter to the `Card` which is elevated by default, and made flat by nesting or through a prop this is better to opt-in for elevation when it isn't the normal case, besides it's subtle anyway
      elevated: {
        true: "shadow-sm"
      }
    },
    defaultVariants: {
      variant: "default",
      elevated: !1
    }
  }
), Z1e = {
  default: "bell",
  info: "info",
  warning: "warningInline",
  critical: "errorInline",
  tip: "lightbulb"
};
function X1e({
  heading: e,
  dismissible: t,
  children: n,
  ...r
}) {
  const o = r.variant ?? "default", [i, a] = Fe(!1);
  return /* @__PURE__ */ f.jsx(lO, { show: !i, children: /* @__PURE__ */ f.jsxs(
    "div",
    {
      role: o === "critical" ? "alert" : "status",
      "data-state": i ? "closed" : "open",
      className: oe(K1e({ ...r })),
      children: [
        /* @__PURE__ */ f.jsxs("header", { className: "flex justify-between gap-2 px-3 py-2", children: [
          /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ f.jsx(Ve, { icon: Z1e[o], className: "shrink-0" }),
            /* @__PURE__ */ f.jsx("p", { className: "font-medium wrap-anywhere", children: e })
          ] }),
          /* @__PURE__ */ f.jsx("div", { className: "flex items-center gap-2", children: t && /* @__PURE__ */ f.jsx(
            Fn,
            {
              className: "-my-2 -mr-2 text-inherit",
              variant: "ghost",
              icon: "close",
              accessibilityLabel: "Dismiss",
              onClick: () => a(!0)
            }
          ) })
        ] }),
        n && /* @__PURE__ */ f.jsx(
          "div",
          {
            className: "-mx-px -mb-px rounded-b-md border-x border-b bg-white px-3 py-2 text-neutral-900",
            "data-part": "children",
            children: n
          }
        )
      ]
    }
  ) });
}
const J1e = qr(
  "flex items-center justify-center gap-x-6 px-6 py-2.5 sm:px-3.5 sm:data-[dismissible=true]:before:flex-1",
  {
    variants: {
      variant: {
        default: "bg-neutral-800 text-sm text-neutral-50",
        danger: "bg-red-700 text-sm text-red-50",
        info: "bg-corso-blue-700 text-sm text-corso-blue-50",
        warning: "bg-amber-600 text-sm text-amber-50",
        ai: "ai-shimmer font-medium text-white"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), x2e = It(
  ({
    className: e,
    variant: t,
    dismissible: n = !1,
    dismissed: r,
    onDismiss: o,
    children: i,
    ...a
  }, s) => {
    const [l, c] = Fe(!1);
    return l && r === void 0 ? null : /* @__PURE__ */ f.jsxs(
      "div",
      {
        "data-dismissible": n,
        className: oe(J1e({ variant: t }), e),
        ref: s,
        ...a,
        children: [
          i,
          !!n && /* @__PURE__ */ f.jsx("div", { className: "flex flex-1 items-center justify-end", children: /* @__PURE__ */ f.jsxs(
            "button",
            {
              type: "button",
              className: "flex items-center justify-center",
              onClick: () => {
                c(!0), o == null || o();
              },
              children: [
                /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Dismiss" }),
                /* @__PURE__ */ f.jsx(Ve, { icon: "close", className: "size-6", "aria-hidden": "true" })
              ]
            }
          ) })
        ]
      }
    );
  }
);
function Q1e() {
  return /* @__PURE__ */ f.jsx("div", { className: "h-1.5 w-1.5 rounded-full bg-neutral-100 ring-1 ring-neutral-300" });
}
function C2e({
  events: e,
  renderIcon: t,
  children: n
}) {
  return e.length ? /* @__PURE__ */ f.jsx("ul", { className: "space-y-4", children: e.map((r, o, i) => /* @__PURE__ */ f.jsxs(
    "li",
    {
      className: "relative flex gap-x-4",
      style: {
        "--feed-icon-size": typeof r == "object" && "iconSize" in r ? r.iconSize : "1.5rem"
      },
      children: [
        /* @__PURE__ */ f.jsx(
          "div",
          {
            className: oe(
              o === e.length - 1 ? "h-(--feed-icon-size)" : "-bottom-(--feed-icon-size)",
              "absolute top-0 left-0 flex w-(--feed-icon-size) justify-center"
            ),
            children: /* @__PURE__ */ f.jsx("div", { className: "w-px bg-neutral-200" })
          }
        ),
        /* @__PURE__ */ f.jsx("div", { className: "relative flex size-(--feed-icon-size) flex-none items-center justify-center bg-white", children: (t == null ? void 0 : t(r, o, i)) ?? /* @__PURE__ */ f.jsx(Q1e, {}) }),
        /* @__PURE__ */ f.jsx("div", { className: "flex w-full flex-col justify-between sm:flex-row sm:items-center sm:gap-4", children: n(r, o, i) })
      ]
    },
    typeof r == "object" && "id" in r ? r.id : r
  )) }) : null;
}
function w2e() {
  return /* @__PURE__ */ f.jsx("main", { className: "flex min-h-full items-center justify-center bg-neutral-900 text-white embedded:bg-white embedded:text-corso-blue-600", children: /* @__PURE__ */ f.jsx("span", { className: "flex -rotate-90 items-center justify-center motion-safe:animate-pulse", children: /* @__PURE__ */ f.jsx(O3, { size: "xl" }) }) });
}
function E2e({
  title: e,
  details: t,
  children: n
}) {
  return vO(`Corso · ${e}`, {
    preserveTitleOnUnmount: !1
  }), /* @__PURE__ */ f.jsxs("main", { className: "grid min-h-full grid-rows-[auto_1fr] place-items-center gap-8 bg-neutral-800 px-6 py-24 sm:py-32 lg:px-8 embedded:bg-white", children: [
    /* @__PURE__ */ f.jsx("div", { className: "text-corso-blue-600 embedded:text-corso-blue-600", children: /* @__PURE__ */ f.jsx(O3, { size: "lg" }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "max-w-prose space-y-12 text-center", children: [
      /* @__PURE__ */ f.jsx("h1", { className: "text-3xl font-medium tracking-tight text-neutral-100 sm:text-5xl embedded:text-neutral-800", children: e }),
      /* @__PURE__ */ f.jsx("p", { className: "text-base leading-7 text-neutral-600", children: t }),
      n
    ] })
  ] });
}
function FA({
  children: e,
  className: t,
  columns: n = 2,
  as: r = "ul",
  items: o
}) {
  return o.length ? /* @__PURE__ */ f.jsx(
    r,
    {
      className: oe(
        "grid gap-2 text-sm text-neutral-500",
        n === 2 && "sm:grid-cols-2",
        t
      ),
      children: o.map(e)
    }
  ) : null;
}
function e0e({ children: e }) {
  return /* @__PURE__ */ f.jsx("li", { className: "ml-4 list-disc marker:text-neutral-500", children: e });
}
FA.Item = e0e;
function t0e({ children: e }) {
  return /* @__PURE__ */ f.jsx("li", { className: "ml-4 list-decimal marker:text-neutral-500", children: e });
}
FA.NumberedItem = t0e;
const BS = "flex items-center w-full gap-2 text-left text-sm text-neutral-800";
function Cc({
  icon: e,
  accessibilityLabel: t,
  content: n,
  contents: r = !1
}) {
  return /* @__PURE__ */ f.jsxs(
    "span",
    {
      className: oe(
        "inline-flex w-full items-center justify-center gap-2",
        r && "contents"
      ),
      children: [
        e && /* @__PURE__ */ f.jsx(Ve, { icon: e }),
        t && /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: t }),
        n
      ]
    }
  );
}
function Rs({
  action: e,
  size: t = "default",
  variant: n = "default"
}) {
  const r = !!e.icon && e.content === void 0;
  return "onAction" in e ? /* @__PURE__ */ f.jsx(
    en,
    {
      size: t,
      variant: n,
      icon: r,
      onClick: e.onAction,
      disabled: e.disabled,
      hidden: e.hidden,
      children: /* @__PURE__ */ f.jsx(
        Cc,
        {
          icon: e.icon,
          accessibilityLabel: e.accessibilityLabel,
          content: e.content
        }
      )
    }
  ) : /* @__PURE__ */ f.jsx(
    en,
    {
      size: t,
      icon: r,
      variant: n,
      hidden: e.hidden,
      asChild: !0,
      children: /* @__PURE__ */ f.jsx(Yc, { to: e.to, target: e.target, children: /* @__PURE__ */ f.jsx(
        Cc,
        {
          icon: e.icon,
          accessibilityLabel: e.accessibilityLabel,
          content: e.content
        }
      ) })
    }
  );
}
function n0e({
  action: { actions: e, ...t }
}) {
  return /* @__PURE__ */ f.jsxs(rs, { children: [
    /* @__PURE__ */ f.jsx(os, { asChild: !0, children: /* @__PURE__ */ f.jsx(
      en,
      {
        icon: !!t.icon,
        disabled: t.disabled,
        hidden: e.every((n) => n.hidden),
        children: /* @__PURE__ */ f.jsxs("div", { className: "flex items-center justify-between gap-1", children: [
          /* @__PURE__ */ f.jsx(
            Cc,
            {
              icon: t.icon,
              accessibilityLabel: t.accessibilityLabel,
              content: t.content
            }
          ),
          /* @__PURE__ */ f.jsx(Ve, { icon: "chevronDown", className: "size-3" })
        ] })
      }
    ) }),
    /* @__PURE__ */ f.jsx(pa, { align: "end", children: e.map((n) => /* @__PURE__ */ f.jsx(ll, { children: "onAction" in n ? /* @__PURE__ */ f.jsx(
      Rr,
      {
        onClick: n.onAction,
        disabled: n.disabled,
        hidden: n.hidden,
        children: /* @__PURE__ */ f.jsx("div", { className: BS, children: /* @__PURE__ */ f.jsx(
          Cc,
          {
            icon: n.icon,
            accessibilityLabel: n.accessibilityLabel,
            content: n.content,
            contents: !0
          }
        ) })
      }
    ) : /* @__PURE__ */ f.jsx(Rr, { hidden: n.hidden, children: /* @__PURE__ */ f.jsx(
      Yc,
      {
        to: n.to,
        target: n.target,
        className: BS,
        children: /* @__PURE__ */ f.jsx(
          Cc,
          {
            icon: n.icon,
            accessibilityLabel: n.accessibilityLabel,
            content: n.content,
            contents: !0
          }
        )
      }
    ) }) }, n.id)) })
  ] });
}
const LA = Nn(null), $A = Nn(
  () => {
  }
);
function I2e({ children: e }) {
  const [t, n] = Fe(null);
  return /* @__PURE__ */ f.jsx($A.Provider, { value: n, children: /* @__PURE__ */ f.jsx(LA.Provider, { value: t, children: e }) });
}
const R2e = () => On(LA), r0e = qr(void 0, {
  variants: {
    size: {
      narrow: "mx-auto max-w-(--breakpoint-md)",
      default: "mx-auto max-w-(--breakpoint-lg)",
      fullWidth: void 0
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function T2e({
  backAction: e,
  title: t,
  titleMetadata: n,
  subtitle: r,
  primaryAction: o,
  secondaryActions: i,
  size: a,
  children: s,
  overrideActions: l,
  paginationActions: c
}) {
  const u = typeof t == "string" ? t : t.content;
  vO(`Corso · ${u}`, {
    preserveTitleOnUnmount: !1
  });
  const d = On($A);
  return Le(() => (d(u), () => d(null)), [d, u]), /* @__PURE__ */ f.jsxs("section", { className: r0e({ size: a }), children: [
    /* @__PURE__ */ f.jsxs("header", { className: "mb-4 flex flex-col justify-between gap-2 md:flex-row md:items-center", children: [
      /* @__PURE__ */ f.jsxs("div", { className: "flex items-start gap-2", children: [
        e && (e === !0 ? /* @__PURE__ */ f.jsx(
          Rs,
          {
            variant: "ghost",
            action: {
              icon: "arrowLeft",
              to: "..",
              accessibilityLabel: "Back"
            }
          }
        ) : /* @__PURE__ */ f.jsx(
          Rs,
          {
            variant: "ghost",
            action: {
              icon: "arrowLeft",
              ...e
            }
          }
        )),
        /* @__PURE__ */ f.jsxs("div", { children: [
          /* @__PURE__ */ f.jsxs("div", { className: "flex items-center justify-start gap-1.5", children: [
            /* @__PURE__ */ f.jsx("h1", { className: "text-lg font-bold", children: typeof t == "string" ? t : /* @__PURE__ */ f.jsxs(
              Yc,
              {
                to: t.to,
                target: t.target,
                className: "flex items-center gap-1 text-lg font-semibold hover:underline focus:underline",
                rel: "noreferrer",
                children: [
                  t.content,
                  t.target === "_blank" && /* @__PURE__ */ f.jsx(Ve, { icon: "externalLink" })
                ]
              }
            ) }),
            n
          ] }),
          r && /* @__PURE__ */ f.jsx("div", { className: "text-sm text-neutral-500", children: r })
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col flex-wrap gap-2 md:flex-row md:items-center md:justify-end", children: [
        l,
        i == null ? void 0 : i.map(
          (m) => "actions" in m ? /* @__PURE__ */ f.jsx(n0e, { action: m }, m.id) : /* @__PURE__ */ f.jsx(Rs, { action: m }, m.id)
        ),
        o && /* @__PURE__ */ f.jsx(Rs, { variant: "primary", action: o }),
        c && /* @__PURE__ */ f.jsxs("div", { className: "flex gap-1", children: [
          /* @__PURE__ */ f.jsx(
            Rs,
            {
              action: {
                icon: "chevronUp",
                accessibilityLabel: "Previous",
                ...c.previous
              }
            }
          ),
          /* @__PURE__ */ f.jsx(
            Rs,
            {
              action: {
                icon: "chevronDown",
                accessibilityLabel: "Next",
                ...c.next
              }
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ f.jsx("main", { children: s })
  ] });
}
const zA = "motion-safe:animate-pulse bg-neutral-200";
function o0e({
  diameter: e = "40px",
  className: t
}) {
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: oe("rounded-full", zA, t),
      style: { width: e, height: e }
    }
  );
}
function jA({
  height: e,
  width: t,
  className: n
}) {
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: oe("rounded-md", zA, n),
      style: { height: e, width: t }
    }
  );
}
const i0e = (e = 70, t = 100) => `${Math.floor(Math.random() * (t - e) + e)}%`;
function* a0e() {
  let e = 0;
  for (; ; )
    e += 1, yield `key-${e}`;
}
function BA({ lineHeight: e = "1em" }) {
  return /* @__PURE__ */ f.jsx(jA, { height: e, width: i0e() });
}
const GA = a0e();
function s0e({
  lines: e = 3,
  lineHeight: t = "1em",
  className: n
}) {
  const r = Be(
    () => Array.from({ length: e }).map(() => /* @__PURE__ */ f.jsx(BA, { lineHeight: t }, String(GA.next().value))),
    [e, t]
  );
  return /* @__PURE__ */ f.jsx("div", { className: oe("flex flex-col gap-1", n), children: r });
}
function Al({
  children: e = null,
  // ReactNode can be undefined`
  skeleton: t,
  instances: n = 1,
  isLoading: r = !1
}) {
  const o = Be(
    () => Array.from({ length: n }).map(() => /* @__PURE__ */ f.jsx(t, {}, String(GA.next().value))),
    [n, t]
  );
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: r ? o : e });
}
Al.Circle = o0e;
Al.Rectangle = jA;
Al.Text = BA;
Al.TextBlock = s0e;
function np({
  title: e,
  detail: t,
  icon: n,
  iconClassName: r,
  className: o,
  children: i
}) {
  return /* @__PURE__ */ f.jsx(
    "section",
    {
      className: oe(
        "flex size-full md:items-center md:justify-center",
        o
      ),
      children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-2 md:mx-auto md:items-center md:gap-4", children: [
        /* @__PURE__ */ f.jsx(
          Ve,
          {
            icon: n,
            className: oe("size-6 opacity-50 md:size-12", r)
          }
        ),
        /* @__PURE__ */ f.jsx("p", { className: "text-lg font-semibold md:text-2xl", children: e }),
        /* @__PURE__ */ f.jsx("p", { className: "max-w-prose text-pretty", children: t }),
        i
      ] })
    }
  );
}
function l0e({
  title: e = "Loading",
  detail: t = "Please wait while we load the page."
}) {
  return /* @__PURE__ */ f.jsx(
    np,
    {
      icon: "spinner",
      iconClassName: "animate-spin",
      title: e,
      detail: t
    }
  );
}
np.Loading = l0e;
function c0e({
  title: e = "Something went wrong",
  detail: t = "We encountered an unexpected issue.",
  error: n
}) {
  const r = hk(), o = gk();
  return Le(() => {
    o && console.error(o);
  }, [o]), Le(() => {
    n && console.error(n);
  }, [n]), /* @__PURE__ */ f.jsx(
    np,
    {
      title: e,
      detail: `${t} Try reloading this page or contact our support team if the problem persists.`,
      icon: "error",
      children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ f.jsx(en, { asChild: !0, size: "lg", children: /* @__PURE__ */ f.jsx(Oh, { to: r.pathname, replace: !0, reloadDocument: !0, children: "Reload" }) }),
        /* @__PURE__ */ f.jsx(en, { asChild: !0, variant: "link", children: /* @__PURE__ */ f.jsx(Oh, { to: "/", replace: !0, reloadDocument: !0, children: "Go to Home" }) })
      ] })
    }
  );
}
np.Error = c0e;
const we = {
  count: "count",
  currency: "currency",
  // always US dollars, whatever the store sells in
  usd: "usd",
  // a fraction of one
  percent: "percent",
  // a bare number, to two places
  decimal: "decimal",
  days: "days",
  // shown as hours
  minutes: "minutes",
  // a bare number: Intl has no metric ton, so the metric's label names the unit
  gramsAsMetricTons: "gramsAsMetricTons",
  // what the same carbon comes to in other terms, which a tile's title names
  gramsAsMilesDriven: "gramsAsMilesDriven",
  gramsAsTreesPlanted: "gramsAsTreesPlanted",
  gramsAsHoursAirConditioned: "gramsAsHoursAirConditioned",
  gramsAsDaysOfHomeElectricity: "gramsAsDaysOfHomeElectricity"
}, GS = {
  label: "Created date",
  description: "Counts claims opened in the range, resolved or not."
}, VS = {
  label: "Finalized date",
  description: "Counts claims approved or denied in the range, whenever they were opened."
}, ql = "Averaged over the items that have both dates.", US = (e) => `Items sold in the range with a ${e} approved or denied since, as a share of all items sold.`, VA = {
  claimItems: {
    metrics: {
      claims: {
        label: In.claims,
        format: we.count,
        info: "Each request counts once, however many items are on it."
      },
      lineItems: {
        label: In.lineItems,
        format: we.count,
        info: "Each product on a request counts once, whatever its quantity."
      },
      items: {
        label: In.items,
        format: we.count,
        info: "Every unit counts, so two of one product on a request count as two."
      },
      itemsPerClaim: {
        label: In.itemsPerClaim,
        format: we.decimal,
        info: "Items over requests, so a request for two of one product counts two."
      },
      refundDeflectionRate: {
        label: In.refundDeflectionRate,
        format: we.percent,
        info: "Of resolved items, the share resolved by anything but a refund, such as an exchange, store credit or Shop Now. Items with no resolution yet are left out."
      },
      refundSaveRate: {
        label: In.refundSaveRate,
        format: we.percent,
        info: "Of resolved items the shopper asked to refund, the share resolved another way instead. Items with no resolution yet are left out."
      },
      resolvedExternally: {
        label: In.resolvedExternally,
        format: we.count
      },
      requestedAmount: {
        label: In.requestedAmount,
        format: we.currency
      },
      resolvedAmount: {
        label: In.resolvedAmount,
        format: we.currency
      },
      itemValue: {
        label: In.itemValue,
        format: we.currency,
        info: "Unit price times quantity, from the original order."
      },
      itemCost: {
        label: In.itemCost,
        format: we.currency
      },
      labelCost: {
        label: In.labelCost,
        format: we.currency,
        info: "A label that covers several items on a request counts once."
      },
      avgLabelCost: {
        label: In.avgLabelCost,
        format: we.currency,
        info: "Averaged per label, not per item."
      },
      avgDaysOrderToClaim: {
        label: In.avgDaysOrderToClaim,
        format: we.days,
        info: ql
      },
      avgDaysClaimToTransit: {
        label: In.avgDaysClaimToTransit,
        format: we.days,
        info: ql
      },
      avgDaysInTransit: {
        label: In.avgDaysInTransit,
        format: we.days,
        info: ql
      },
      avgDaysDeliveredToResolved: {
        label: In.avgDaysDeliveredToResolved,
        format: we.days,
        info: ql
      },
      avgDaysClaimToResolved: {
        label: In.avgDaysClaimToResolved,
        format: we.days,
        info: ql
      }
    },
    dimensions: {
      reason: { label: "Reason" },
      reasonDetail: { label: "Reason detail" },
      // Corso's own categories, which every store's reasons map to
      reasonCategory: {
        label: "Reason category",
        names: sK
      },
      status: { label: "Status", names: bg },
      claimStatus: { label: "Resolution status" },
      resolution: {
        label: "Resolution",
        names: Ad
      },
      requestedResolution: {
        label: "Requested resolution",
        names: Ad
      },
      productType: { label: "Product type" },
      inspectionGrade: { label: "Inspection grade" },
      productTitle: { label: "Product" },
      variantTitle: { label: "Variant" },
      sku: { label: "SKU" }
    },
    timeFields: {
      createdOn: GS,
      finalizedOn: VS,
      deliveredOn: { label: "Delivered date" },
      inTransitOn: { label: "In transit date" },
      inspectionCreatedOn: { label: "Inspection date" }
    }
  },
  orderItems: {
    metrics: {
      itemsSold: { label: "Items sold", format: we.count },
      returnItemsFinalized: {
        label: "Return items finalized",
        format: we.count
      },
      warrantyItemsFinalized: {
        label: "Warranty items finalized",
        format: we.count
      },
      returnRate: {
        label: "Item return rate",
        format: we.percent,
        info: US("return request")
      },
      warrantyRate: {
        label: "Warranty claim rate",
        format: we.percent,
        info: US("warranty request")
      }
    },
    dimensions: {
      productTitle: { label: "Product" },
      variantTitle: { label: "Variant" },
      lineItemName: { label: "Line item" }
    },
    timeFields: { createdOn: { label: "Order date" } }
  },
  claims: {
    metrics: {
      claims: { label: "Requests", format: we.count },
      newRevenue: { label: "New revenue", format: we.currency },
      retainedRevenue: {
        label: "Retained revenue",
        format: we.currency
      },
      feesApplied: { label: "Fees applied", format: we.currency },
      returnShippingCharged: {
        label: "Return shipping charged",
        format: we.currency
      },
      giftCardIncentives: {
        label: "Gift card incentives",
        format: we.currency
      },
      shopNowIncentives: {
        label: "Shop Now incentives",
        format: we.currency
      },
      totalRevenue: {
        label: "New & retained revenue",
        format: we.currency
      },
      totalFees: { label: "All fees applied", format: we.currency },
      totalIncentives: {
        label: "All incentives applied",
        format: we.currency
      }
    },
    dimensions: {
      status: { label: "Status", names: bg },
      creditResolution: {
        label: "Credit chosen",
        names: Ad
      }
    },
    timeFields: { createdOn: GS, finalizedOn: VS }
  },
  orders: {
    metrics: {
      orders: { label: "Orders", format: we.count },
      protectedOrders: {
        label: "Protected orders",
        format: we.count
      },
      attachRate: { label: "Attach rate", format: we.percent },
      protectionPrice: { label: "Protection price", format: we.usd },
      avgProtectionPrice: {
        label: "Average protection price",
        format: we.usd
      },
      shippingCharged: {
        label: "Shipping charged",
        format: we.currency
      },
      avgShippingCharge: {
        label: "Average shipping charge",
        format: we.currency
      },
      carbonGrams: {
        label: "Carbon (metric tons)",
        format: we.gramsAsMetricTons
      }
    },
    dimensions: {
      salesChannel: { label: "Sales channel" },
      shippingTitle: { label: "Shipping method" },
      carrier: { label: "Carrier" },
      orderProtectionPrice: { label: "Protection price" }
    },
    timeFields: { orderedOn: { label: "Order date" } }
  },
  shippingClaims: {
    metrics: {
      claims: { label: "Claims", format: we.count },
      refundAmount: { label: "Refund amount", format: we.currency },
      reorderAmount: { label: "Reorder amount", format: we.currency },
      totalClaimAmount: {
        label: "Total claim amount",
        format: we.currency
      },
      avgRefundAmount: {
        label: "Average refund amount",
        format: we.currency
      },
      avgReorderAmount: {
        label: "Average reorder amount",
        format: we.currency
      }
    },
    dimensions: {
      reason: { label: "Reason", names: m8 },
      status: { label: "Status", names: f8 },
      source: { label: "Source", names: x5 }
    },
    timeFields: {
      createdOn: { label: "Created date" },
      resolvedOn: { label: "Resolved date" }
    }
  },
  registrations: {
    metrics: {
      registrations: { label: "Registrations", format: we.count },
      registeredProducts: {
        label: "Registered products",
        format: we.count
      },
      orderClaims: { label: "Order claims", format: we.count },
      newCustomers: {
        label: "New customers",
        format: we.count,
        info: "Registrations that created the customer in your store."
      },
      newSubscribers: {
        label: "New email subscribers",
        format: we.count,
        info: "Registrations that subscribed a customer to your email marketing who was not subscribed before."
      }
    },
    dimensions: {
      salesChannelName: { label: "Sales channel" },
      productTitle: { label: "Product" },
      variantDisplayName: { label: "Variant" }
    },
    timeFields: {
      createdOn: {
        label: "Registration date",
        description: "Counts products registered in the range."
      },
      purchasedOn: {
        label: "Estimated purchase date",
        description: "Counts registered products bought in the range, as the customer estimated."
      }
    }
  },
  orderEdits: {
    metrics: {
      edits: { label: "Order edits", format: we.count },
      minutesSaved: { label: "Hours saved", format: we.minutes },
      newRevenue: { label: "New revenue", format: we.currency }
    },
    dimensions: {
      editType: {
        label: "Edit type",
        names: D.orderEditStoredTypeName
      },
      orderId: { label: "Corso order ID" }
    },
    timeFields: { createdOn: { label: "Edit date" } }
  },
  supportConversations: {
    metrics: {
      conversations: {
        label: "New conversations",
        format: we.count,
        info: "Counted as Front counts them: a conversation idle for 5 days starts a new one when it picks up again."
      },
      avgFirstResponseMinutes: {
        label: "Avg first response time",
        format: we.minutes,
        info: "Business hours only, Monday to Friday 9 to 5 Mountain, as Front reports it. Autoreplies are not a response."
      }
    },
    dimensions: {},
    timeFields: {
      startedOn: { label: "Start date" },
      firstRespondedOn: { label: "First response date" }
    }
  },
  supportMessages: {
    metrics: {
      messagesSent: {
        label: "Messages sent",
        format: we.count,
        info: "Includes autoreplies, as Front counts them."
      },
      messagesReceived: {
        label: "Messages received",
        format: we.count
      }
    },
    dimensions: {
      sentBy: {
        label: "Sent by",
        names: {
          customer: "Customer",
          teammate: "Concierge team",
          automation: "Automated"
        }
      },
      channel: { label: "Channel" }
    },
    timeFields: { sentOn: { label: "Sent date" } }
  },
  supportCsat: {
    metrics: {
      csatScore: {
        label: "CSAT score",
        format: we.percent,
        info: "Average survey rating as a share of the top rating."
      },
      scoresCollected: {
        label: "CSAT scores collected",
        format: we.count
      },
      scoresWithComment: {
        label: "Scores with a comment",
        format: we.count
      }
    },
    dimensions: { csatRating: { label: "Rating" } },
    timeFields: { ratedOn: { label: "Rating date" } }
  }
}, gy = VA, [
  u0e,
  d0e,
  f0e,
  m0e,
  p0e,
  h0e,
  g0e,
  v0e,
  y0e,
  b0e
] = Xs.datasets, UA = {
  claimItems: u0e,
  orderItems: d0e,
  claims: f0e,
  orders: m0e,
  shippingClaims: p0e,
  registrations: h0e,
  orderEdits: g0e,
  supportConversations: v0e,
  supportMessages: y0e,
  supportCsat: b0e
}, na = (e, t) => ({
  ...UA[e].metrics[t],
  ...gy[e].metrics[t]
}), rp = (e, t) => gy[e].dimensions[t], D1 = (e, t) => gy[e].timeFields[t], vy = (e, t) => {
  var n;
  return (n = UA[e].filters[t]) == null ? void 0 : n.dimension;
}, eo = {
  text: "text",
  count: "count",
  currency: "currency",
  // always US dollars, whatever the store sells in
  usd: "usd",
  dateTime: "dateTime"
}, Xn = { format: eo.text }, Ho = { format: eo.dateTime }, S0e = {
  claimItems: {
    id: Xn,
    createdOn: Ho,
    finalizedOn: Ho,
    deliveredOn: Ho,
    inTransitOn: Ho,
    inspectionCreatedOn: Ho,
    orderedOn: Ho,
    orderNumber: Xn,
    productTitle: Xn,
    sku: Xn,
    quantity: { format: eo.count },
    reason: Xn,
    resolution: {
      ...Xn,
      names: VA.claimItems.dimensions.resolution.names
    },
    inspectionGrade: Xn
  },
  orders: {
    id: Xn,
    orderedOn: Ho,
    orderNumber: Xn,
    salesChannel: Xn,
    orderTotal: { format: eo.currency },
    protectionPrice: { format: eo.usd }
  },
  shippingClaims: {
    id: Xn,
    createdOn: Ho,
    resolvedOn: Ho,
    orderName: Xn,
    status: Xn,
    resolution: Xn,
    reason: Xn
  }
}, x0e = (e, t) => S0e[e][t], cn = {
  kpi: "kpi",
  overTime: "overTime",
  ranking: "ranking",
  table: "table",
  flow: "flow",
  sunburst: "sunburst",
  list: "list"
}, WS = { bar: "bar", line: "line" }, oc = { bars: "bars", cloud: "cloud" }, WA = ({
  metrics: e,
  share: t
}) => {
  const n = e;
  return t === void 0 || n.includes(t) ? n : [...n, t];
}, Ya = {
  store: "store",
  local: "local"
}, C0e = (e) => ze(e).with({ key: Ya.store }, ({ iana: t }) => t).with({ key: Ya.local }, () => {
}).exhaustive(), w0e = (e) => new Date(
  e.getUTCFullYear(),
  e.getUTCMonth(),
  e.getUTCDate(),
  e.getUTCHours(),
  e.getUTCMinutes(),
  e.getUTCSeconds()
), E0e = (e) => new Date(
  Date.UTC(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds()
  )
), HA = (e, t) => {
  const n = new Intl.DateTimeFormat("en-US", {
    timeZone: t,
    hourCycle: "h23",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }).formatToParts(e), r = (o) => {
    var i;
    return Number((i = n.find((a) => a.type === o)) == null ? void 0 : i.value);
  };
  return new Date(
    Date.UTC(
      r("year"),
      r("month") - 1,
      r("day"),
      r("hour"),
      r("minute"),
      r("second")
    )
  );
}, I0e = (e, t) => w0e(HA(e, t)), R0e = (e, t) => {
  const n = E0e(e).getTime(), r = (a) => HA(new Date(a), t).getTime() - a, o = n - r(n), i = n - r(o);
  return new Date(Math.max(o, i));
}, qA = (e, t) => ze(t).with(
  { key: Ya.store },
  ({ iana: n }) => I0e(e, n)
).with({ key: Ya.local }, () => e).exhaustive(), T0e = (e, t) => ze(t).with(
  { key: Ya.store },
  ({ iana: n }) => R0e(e, n)
).with({ key: Ya.local }, () => e).exhaustive(), _0e = (e, t) => qA(new Date(e), t), O0e = 92, Th = (e, t, n) => {
  const r = (i) => T0e(i, n).toISOString(), o = e.map(r);
  return {
    from: o[0] ?? r(t),
    to: r(t),
    bucketEdges: o
  };
}, A0e = (e, t) => {
  const n = qA(/* @__PURE__ */ new Date(), t), r = qre(e, n);
  return ze(r.start).with(Ft.nullish, "", () => null).otherwise((o) => {
    const i = new Date(o), a = Ic(
      li(r.end ? new Date(r.end) : n),
      1
    ), s = Vf(a, i), l = Th([i], a, t), c = (Date.parse(l.to) - Date.parse(l.from)) / 864e5;
    return ze({ days: s, elapsedDays: c }).with(
      { days: Ft.number.lt(1) },
      { elapsedDays: Ft.number.gt(Xs.limits.maxRangeDays) },
      () => null
    ).with({ days: Ft.number.lte(O0e) }, () => ({
      granularity: js.day,
      range: Th(
        Array.from({ length: s }, (u, d) => Ic(i, d)),
        a,
        t
      )
    })).otherwise(() => {
      const u = Array.from(
        { length: Math.ceil(Xs.limits.maxRangeDays / 28) },
        (d, m) => Z3(Gf(i, m + 1))
      ).filter((d) => d < a);
      return {
        granularity: js.month,
        range: Th([i, ...u], a, t)
      };
    });
  });
}, gi = (e, t, n) => {
  const r = n == null ? void 0 : n[t];
  return ze(r).with(Ft.string, (o) => Number.parseFloat(o)).with(Ft.number, (o) => o).with(
    Ft.nullish,
    () => ze(na(e, t).additive).with("ratio", () => {
    }).with("sum", "distinct", () => 0).exhaustive()
  ).exhaustive();
}, { maxRows: HS } = Xs.limits, YA = ({
  date: e,
  timeZone: t
}) => ze(A0e(e, t)).with(null, () => {
  throw new Error("Unsupported analytics date range");
}).otherwise((n) => n), yy = ({ scope: e, metrics: t, dimensions: n, top: r }, o = !1) => {
  const { granularity: i, range: a } = YA(e), s = ze(o).returnType().with(!0, () => ({
    bucketEdges: a.bucketEdges,
    orderBy: [{ field: "bucketStart", direction: "asc" }]
  })).with(!1, () => ({
    bucketEdges: [],
    orderBy: [{ field: t[0], direction: "desc" }]
  })).exhaustive(), l = {
    dataset: e.dataset,
    metrics: [...t],
    filters: e.filters,
    limit: Math.min(r ?? HS, HS),
    dimensions: [...n],
    time: {
      field: e.timeField,
      ...a,
      bucketEdges: s.bucketEdges
    },
    // the API wants every grouping field in the order
    orderBy: [
      ...s.orderBy,
      ...n.map((c) => ({ field: c, direction: "asc" }))
    ]
  };
  return { granularity: i, request: l };
}, k0e = ({ dimensions: e }, t) => t.map((n) => {
  const r = e.map((o) => n[o] ?? null);
  return { key: JSON.stringify(r), groups: r, row: n };
}), op = 300 * 1e3;
function by(e) {
  return L1({
    queryKey: ["analytics", "totals", e == null ? void 0 : e.scope.source.key, e],
    queryFn: async () => {
      if (e === void 0) return [];
      const { rows: t } = await e.scope.source.query(
        yy(e).request
      );
      return t;
    },
    // a range with nothing in it comes back as no row
    select: (t) => t[0] ?? {},
    staleTime: op,
    enabled: e !== void 0
  });
}
function KA(e, t = e, n = !0) {
  const r = by(n ? t : void 0), o = L1({
    queryKey: ["analytics", "over-time", e.scope.source.key, e],
    queryFn: async () => {
      const { granularity: i, request: a } = yy(e, !0), { rows: s } = await e.scope.source.query(a);
      return { granularity: i, edges: a.time.bucketEdges, rows: s };
    },
    select: ({ granularity: i, edges: a, rows: s }) => {
      const l = new Map(
        s.map((c) => [Date.parse(c.bucketStart ?? ""), c])
      );
      return {
        granularity: i,
        points: a.map((c) => ({
          date: Yre(_0e(c, e.scope.timeZone)),
          row: l.get(Date.parse(c))
        }))
      };
    },
    staleTime: op,
    enabled: n
  });
  return ze({
    error: o.error ?? r.error,
    bucketed: o.data,
    whole: r.data
  }).with({ error: Ft.nonNullable }, ({ error: i }) => ({
    status: "error",
    error: i
  })).with(
    { bucketed: Ft.nonNullable, whole: Ft.nonNullable },
    ({ bucketed: i, whole: a }) => ({
      status: "success",
      data: { ...i, totals: a }
    })
  ).otherwise(() => ({ status: "pending" }));
}
const ZA = (e, t) => Rk({
  queryKey: ["analytics", "breakdown", e.scope.source.key, e],
  queryFn: async () => {
    const { rows: n, truncated: r } = await e.scope.source.query(
      yy(e).request
    );
    return { rows: n, truncated: r };
  },
  select: ({ rows: n, truncated: r }) => ({
    rows: k0e(e, n),
    truncated: r
  }),
  staleTime: op,
  enabled: t
});
function ip(e, t = !0) {
  return L1(ZA(e, t));
}
function D0e(e, t = !0) {
  return Ek({
    queries: e.map((n) => ZA(n, t))
  });
}
const P0e = 50, N0e = null, M0e = (e, t) => {
  const { from: n, to: r } = YA(e).range;
  return {
    list: e.dataset,
    time: { field: e.timeField, from: n, to: r },
    filters: e.filters,
    cursor: t,
    limit: P0e
  };
};
function F0e(e) {
  return Ik({
    queryKey: ["analytics", "list", e.source.key, e],
    queryFn: ({ pageParam: t }) => e.source.list(M0e(e, t)),
    initialPageParam: N0e,
    getNextPageParam: ({ nextCursor: t }) => t,
    staleTime: op
  });
}
const sl = "h2", Ts = (e, t) => dt.number(
  e,
  Math.abs(e) < 10 ** -t ? { maximumSignificantDigits: 2 } : { maximumFractionDigits: t }
), ls = (e) => (t, n, r = na(t, n).format) => {
  const o = ze(r).with(we.count, () => (i) => dt.count(i)).with(
    we.currency,
    we.usd,
    (i) => (a) => dt.currency(
      a,
      i === we.usd ? "USD" : e
    )
  ).with(
    we.percent,
    () => (i) => dt.percent(i)
  ).with(we.decimal, () => (i) => Ts(i, 2)).with(
    we.days,
    () => (i) => dt.number(i, {
      style: "unit",
      unit: "day",
      unitDisplay: "long",
      maximumFractionDigits: 1
    })
  ).with(
    we.minutes,
    () => (i) => dt.number(i / 60, {
      style: "unit",
      unit: "hour",
      unitDisplay: "long",
      maximumFractionDigits: 1
    })
  ).with(
    we.gramsAsMetricTons,
    () => (i) => Ts(i / 1e6, 2)
  ).with(
    we.gramsAsMilesDriven,
    () => (i) => Ts(i / 1e3 / 0.40395454545454546, 0)
  ).with(
    we.gramsAsTreesPlanted,
    () => (i) => Ts(i / 1e3 / 20, 0)
  ).with(
    we.gramsAsHoursAirConditioned,
    () => (i) => Ts(
      i / 1e6 / 0.0012979042093803866 / 24,
      0
    )
  ).with(
    we.gramsAsDaysOfHomeElectricity,
    () => (i) => Ts(i / 1e6 / 1.4956 * 365, 0)
  ).exhaustive();
  return (i) => ze(i).with(void 0, () => "—").otherwise(o);
}, ra = (e, t, n) => ze(n).with(null, "", () => "Not set").otherwise((r) => {
  var o;
  return ((o = rp(e, t).names) == null ? void 0 : o[r]) ?? r;
}), XA = ({ title: e }) => /* @__PURE__ */ f.jsx(
  X1e,
  {
    variant: "critical",
    heading: `Failed to load ${e}. Please try again later.`
  }
), JA = (e, t, n) => {
  const r = {};
  for (const o of t)
    ze(gi(e, o, n)).with(void 0, () => {
    }).otherwise((i) => {
      r[o] = i;
    });
  return r;
}, kl = (...e) => ze(e.filter(xK)).with([], () => {
}).otherwise((t) => t.join(". ")), cs = (e, t, n) => ze([
  ...ze(t).with(void 0, () => []).otherwise((r) => [r]),
  ...n.flatMap((r) => {
    const { label: o, info: i } = na(e, r);
    return ze(i).with(void 0, () => []).otherwise((a) => [
      // beside others, a line says which metric it is about
      n.length > 1 ? `${o}: ${a}` : a
    ]);
  })
]).with([], () => {
}).otherwise((r) => /* @__PURE__ */ f.jsx("div", { className: "flex flex-col gap-1.5", children: r.map((o) => /* @__PURE__ */ f.jsx("p", { children: o }, o)) })), QA = (e) => `Showing the first ${dt.count(e)}. There are more than fit here.`, us = ({
  title: e,
  answer: t,
  height: n,
  children: r
}) => ze(t).with({ status: "error" }, () => /* @__PURE__ */ f.jsx(XA, { title: e })).with({ status: "pending" }, () => /* @__PURE__ */ f.jsx(Al.Rectangle, { height: n, width: "100%" })).with({ status: "success" }, ({ data: o }) => r(o)).exhaustive(), L0e = ({
  title: e,
  dataset: t,
  widget: n,
  shared: r,
  note: o
}) => {
  const i = ls(r.scope.source.currency);
  return (
    // a zero would read as real data while loading
    /* @__PURE__ */ f.jsx(us, { title: e, answer: by(r), height: "104px", children: (a) => /* @__PURE__ */ f.jsx(
      FO,
      {
        label: e,
        value: i(
          t,
          n.metric,
          n.format
        )(gi(t, n.metric, a)),
        description: kl(n.description, o),
        info: cs(t, n.info, [n.metric])
      }
    ) })
  );
}, $0e = ({
  title: e,
  dataset: t,
  widget: n,
  shared: r,
  buckets: o,
  note: i
}) => {
  const a = ls(r.scope.source.currency);
  return /* @__PURE__ */ f.jsx(
    us,
    {
      title: e,
      answer: KA(o, r),
      height: "144px",
      children: (s) => /* @__PURE__ */ f.jsx(
        FO,
        {
          label: e,
          value: a(
            t,
            n.metric,
            n.format
          )(gi(t, n.metric, s.totals)),
          description: kl(n.description, i),
          info: cs(t, n.info, [n.metric]),
          trend: s.points.map(
            ({ row: l }) => ze(gi(t, n.metric, l)).with(void 0, () => null).otherwise((c) => c)
          )
        }
      )
    }
  );
}, z0e = ({
  title: e,
  dataset: t,
  widget: n,
  shared: r,
  buckets: o,
  note: i
}) => {
  const a = ls(r.scope.source.currency), s = ze(n.mark).with(WS.bar, () => Ege).with(WS.line, () => Ige).exhaustive();
  return /* @__PURE__ */ f.jsx(
    us,
    {
      title: e,
      answer: KA(o, r),
      height: "360px",
      children: (l) => {
        const c = l.points.map(
          ({ date: d, row: m }) => ({
            date: d,
            ...JA(t, n.metrics, m)
          })
        ), u = n.metrics.map(
          (d, m) => ({
            key: d,
            label: na(t, d).label,
            color: No[m % No.length] ?? No[0],
            aggregate: () => gi(t, d, l.totals)
          })
        );
        return /* @__PURE__ */ f.jsx(
          s,
          {
            title: e,
            headingLevel: sl,
            description: kl(n.description, i),
            info: cs(t, n.info, n.metrics),
            data: c,
            granularity: l.granularity,
            valueFormatter: a(t, n.metrics[0]),
            series: u
          }
        );
      }
    }
  );
}, Sy = (e, t, n, r) => kl(
  t.description ?? na(e, t.metric).label,
  // a widget that asked for its top groups shows all it asked for
  n.truncated && t.limit === void 0 ? QA(n.rows.length) : void 0,
  r
), j0e = ({
  title: e,
  dataset: t,
  widget: n,
  shared: r,
  note: o
}) => {
  var h;
  const i = ls(r.scope.source.currency), a = ip(r), s = (h = a.data) == null ? void 0 : h.rows, { metric: l, dimension: c, limit: u } = n, d = n.mark === oc.cloud || n.hideUnset === !0, m = Be(
    () => (s ?? []).flatMap(
      ({ key: v, groups: [g = null], row: x }) => ze(gi(t, l, x)).with(void 0, () => []).otherwise((b) => [{ key: v, group: g, value: b }])
    ).filter(({ group: v }) => !d || v !== null && v !== "").sort((v, g) => g.value - v.value).slice(0, u).map(({ key: v, group: g, value: x }) => ({
      key: v,
      label: ra(t, c, g),
      value: x
    })),
    [s, t, l, c, u, d]
  );
  return /* @__PURE__ */ f.jsx(
    us,
    {
      title: e,
      answer: a,
      height: n.mark === oc.cloud ? "320px" : "240px",
      children: (v) => {
        const g = Sy(t, n, v, o), x = cs(t, n.info, [l]), b = i(t, l);
        return ze(n.mark).with(oc.cloud, () => /* @__PURE__ */ f.jsx(
          W1e,
          {
            title: e,
            headingLevel: sl,
            description: g,
            info: x,
            valueFormatter: b,
            maxWords: u,
            data: m
          }
        )).with(oc.bars, void 0, () => /* @__PURE__ */ f.jsx(
          Bpe,
          {
            title: e,
            headingLevel: sl,
            description: g,
            info: x,
            valueFormatter: b,
            data: m
          }
        )).exhaustive();
      }
    }
  );
}, B0e = (e) => e.length === 1, G0e = (e) => e.length > 1, ek = (e, t, n, r, o = 0) => ze(n).when(
  B0e,
  ([i]) => t.map(({ key: a, groups: s, values: l }) => ({
    key: a,
    labels: [ra(e, i, s[o] ?? null)],
    values: l
  }))
).when(G0e, ([i, ...a]) => {
  const s = /* @__PURE__ */ new Map();
  for (const c of t) {
    const u = c.groups[o] ?? null, d = s.get(u) ?? {
      key: JSON.stringify(c.groups.slice(0, o + 1)),
      labels: [ra(e, i, u)],
      values: {},
      rows: [],
      hasDetail: !1
    };
    for (const m of r) {
      const h = c.values[m];
      ze(h).with(void 0, () => {
      }).otherwise((v) => {
        d.values[m] = (d.values[m] ?? 0) + v;
      });
    }
    d.rows.push(c), d.hasDetail || (d.hasDetail = c.groups.slice(o + 1).some((m) => m !== null)), s.set(u, d);
  }
  const [l] = r;
  return [...s.values()].map(
    ({ rows: c, hasDetail: u, ...d }) => ({
      ...d,
      // a group whose only row has no further grouping has nothing to open
      details: ze(u).with(
        !0,
        () => ek(e, c, a, r, o + 1)
      ).with(!1, () => {
      }).exhaustive()
    })
  ).sort((c, u) => (u.values[l] ?? 0) - (c.values[l] ?? 0));
}).exhaustive(), tk = ({
  title: e,
  description: t,
  info: n,
  isEmpty: r,
  children: o
}) => /* @__PURE__ */ f.jsxs(un, { flush: !0, children: [
  /* @__PURE__ */ f.jsx(un.Header, { divided: !0, children: /* @__PURE__ */ f.jsx(
    Q2,
    {
      title: e,
      headingLevel: sl,
      description: t,
      info: n
    }
  ) }),
  ze(r).with(!0, () => /* @__PURE__ */ f.jsx(as, { message: "No data for this period", compact: !0 })).with(!1, () => o).exhaustive()
] }), V0e = (e, t) => e === void 0 || !t ? void 0 : e / t, U0e = ({
  title: e,
  dataset: t,
  widget: n,
  shared: r,
  note: o,
  whole: i
}) => {
  const a = ls(r.scope.source.currency), s = n.dimensions, l = n.metrics, { share: c } = n, u = WA(n), d = by(i), m = c === void 0 || !d.isSuccess ? void 0 : gi(t, c, d.data), h = n.limit !== void 0;
  return /* @__PURE__ */ f.jsx(
    us,
    {
      title: e,
      answer: ip(r),
      height: "240px",
      children: (v) => {
        const g = v.rows.map(({ key: b, groups: C, row: I }) => ({
          key: b,
          groups: C,
          values: JA(t, u, I)
        })), x = ze(h).with(
          !0,
          () => g.map(
            ({ key: b, groups: C, values: I }) => ({
              key: b,
              labels: s.map(
                (T, R) => ra(t, T, C[R] ?? null)
              ),
              values: I
            })
          )
        ).with(!1, () => ek(t, g, s, u)).exhaustive();
        return /* @__PURE__ */ f.jsxs(
          tk,
          {
            title: e,
            description: kl(n.description, o),
            info: cs(t, n.info, l),
            isEmpty: x.length === 0,
            children: [
              /* @__PURE__ */ f.jsx(
                oy,
                {
                  caption: e,
                  data: x,
                  columns: [
                    ...ze(h).with(!0, () => s).with(!1, () => s.slice(0, 1)).exhaustive().map(
                      (b, C) => ({
                        id: b,
                        header: rp(t, b).label,
                        accessorFn: ({ labels: I }) => I[C] ?? ""
                      })
                    ),
                    ...l.map(
                      (b) => ({
                        id: b,
                        header: na(t, b).label,
                        accessorFn: ({ values: C }) => a(t, b)(C[b])
                      })
                    ),
                    ...c === void 0 ? [] : [
                      {
                        id: "share",
                        header: `% of ${na(t, c).label.toLowerCase()}`,
                        accessorFn: ({ values: b }) => ze(V0e(b[c], m)).with(void 0, () => "—").otherwise((C) => dt.share(C))
                      }
                    ]
                  ],
                  getSubRows: ({ details: b }) => b
                }
              ),
              ze({ truncated: v.truncated, isTopN: h }).with({ truncated: !1 }, () => null).with({ truncated: !0, isTopN: !0 }, () => /* @__PURE__ */ f.jsxs("p", { className: "border-t px-6 py-3 text-xs text-neutral-500", children: [
                "Showing the top ",
                dt.count(v.rows.length)
              ] })).with({ truncated: !0, isTopN: !1 }, () => /* @__PURE__ */ f.jsx("p", { className: "border-t px-6 py-3 text-xs text-neutral-500", children: QA(v.rows.length) })).exhaustive()
            ]
          }
        );
      }
    }
  );
}, W0e = ({
  title: e,
  dataset: t,
  widget: n,
  shared: r,
  note: o
}) => {
  const i = ls(r.scope.source.currency), [a, s] = n.dimensions;
  return /* @__PURE__ */ f.jsx(
    us,
    {
      title: e,
      answer: ip(r),
      height: "400px",
      children: (l) => /* @__PURE__ */ f.jsx(
        wge,
        {
          title: e,
          headingLevel: sl,
          description: Sy(t, n, l, o),
          info: cs(t, n.info, [n.metric]),
          valueFormatter: i(t, n.metric),
          otherLabel: n.otherLabel,
          data: l.rows.flatMap(
            ({ groups: [c = null, u = null], row: d }) => ze({
              value: gi(t, n.metric, d),
              isHidden: n.hideUnset === !0 && (c === null || u === null)
            }).with({ value: Ft.number, isHidden: !1 }, ({ value: m }) => [
              {
                from: ra(t, a, c),
                to: ra(t, s, u),
                value: m
              }
            ]).otherwise(() => [])
          )
        }
      )
    }
  );
}, H0e = ({
  title: e,
  dataset: t,
  widget: n,
  shared: r,
  note: o
}) => {
  const i = ls(r.scope.source.currency), [a, s] = n.dimensions;
  return /* @__PURE__ */ f.jsx(
    us,
    {
      title: e,
      answer: ip(r),
      height: "360px",
      children: (l) => {
        const c = /* @__PURE__ */ new Map();
        for (const {
          groups: [d = null, m = null],
          row: h
        } of l.rows) {
          const v = gi(t, n.metric, h);
          if (v !== void 0) {
            const g = c.get(d) ?? [];
            g.push({
              key: JSON.stringify(m),
              label: ra(t, s, m),
              value: v,
              // an unset detail fills out its parent's arc, quietly
              muted: m === null || m === ""
            }), c.set(d, g);
          }
        }
        const u = [...c].map(([d, m]) => ({
          key: JSON.stringify(d),
          label: ra(t, a, d),
          value: m.reduce((h, v) => h + v.value, 0),
          children: m
        }));
        return /* @__PURE__ */ f.jsx(
          $1e,
          {
            title: e,
            headingLevel: sl,
            description: Sy(t, n, l, o),
            info: cs(t, n.info, [n.metric]),
            valueFormatter: i(t, n.metric),
            otherLabel: n.otherLabel,
            data: u
          }
        );
      }
    }
  );
}, q0e = ({
  placed: { title: e, dataset: t, widget: n },
  shared: r,
  buckets: o,
  whole: i,
  note: a
}) => ze(n).with({ kind: cn.kpi, trend: !0 }, (s) => /* @__PURE__ */ f.jsx(
  $0e,
  {
    title: e,
    dataset: t,
    widget: s,
    shared: r,
    buckets: o,
    note: a
  }
)).with({ kind: cn.kpi }, (s) => /* @__PURE__ */ f.jsx(
  L0e,
  {
    title: e,
    dataset: t,
    widget: s,
    shared: r,
    note: a
  }
)).with({ kind: cn.overTime }, (s) => /* @__PURE__ */ f.jsx(
  z0e,
  {
    title: e,
    dataset: t,
    widget: s,
    shared: r,
    buckets: o,
    note: a
  }
)).with({ kind: cn.ranking }, (s) => /* @__PURE__ */ f.jsx(
  j0e,
  {
    title: e,
    dataset: t,
    widget: s,
    shared: r,
    note: a
  }
)).with({ kind: cn.table }, (s) => /* @__PURE__ */ f.jsx(
  U0e,
  {
    title: e,
    dataset: t,
    widget: s,
    shared: r,
    note: a,
    whole: i
  }
)).with({ kind: cn.flow }, (s) => /* @__PURE__ */ f.jsx(
  W0e,
  {
    title: e,
    dataset: t,
    widget: s,
    shared: r,
    note: a
  }
)).with({ kind: cn.sunburst }, (s) => /* @__PURE__ */ f.jsx(
  H0e,
  {
    title: e,
    dataset: t,
    widget: s,
    shared: r,
    note: a
  }
)).exhaustive(), Y0e = ({ plan: e }) => /* @__PURE__ */ f.jsx(
  q0e,
  {
    placed: e.placed,
    shared: e.shared,
    buckets: e.buckets,
    whole: e.whole,
    note: e.note
  }
), qS = (e) => ze(e).with(Ft.number, (t) => t).with(Ft.string, (t) => Number.parseFloat(t)).exhaustive(), K0e = (e, t) => (n, r) => {
  const { format: o, names: i } = x0e(n, r), a = ze(o).with(
    eo.text,
    // merchant-written text, and a code with no name, is shown as stored
    () => (s) => (i == null ? void 0 : i[s]) ?? `${s}`
  ).with(
    eo.count,
    () => (s) => dt.count(qS(s))
  ).with(
    eo.currency,
    eo.usd,
    (s) => (l) => dt.currency(
      qS(l),
      s === eo.usd ? "USD" : t
    )
  ).with(
    eo.dateTime,
    () => (s) => dt.dateTime(s, {
      dateStyle: "medium",
      timeStyle: "short",
      timeZone: C0e(e)
    })
  ).exhaustive();
  return (s) => ze(s).with(Ft.nullish, () => "—").otherwise(a);
}, Z0e = ({ getValue: e }) => /* @__PURE__ */ f.jsx("span", { className: "whitespace-nowrap", children: e() }), X0e = ({
  placed: { title: e, widget: t },
  scope: n,
  note: r
}) => {
  const o = K0e(n.timeZone, n.source.currency), [i, a] = Fe(0), s = F0e(n);
  return ze(s).with({ status: "error" }, () => /* @__PURE__ */ f.jsx(XA, { title: e })).with({ status: "pending" }, () => /* @__PURE__ */ f.jsx(Al.Rectangle, { height: "240px", width: "100%" })).with(
    { status: "success" },
    ({ data: l, hasNextPage: c, isFetchingNextPage: u, fetchNextPage: d }) => {
      var x;
      const m = Math.min(i, l.pages.length - 1), h = ((x = l.pages[m]) == null ? void 0 : x.rows) ?? [], v = m < l.pages.length - 1, g = v || c;
      return /* @__PURE__ */ f.jsxs(
        tk,
        {
          title: e,
          description: kl(t.description, r),
          info: t.info,
          isEmpty: h.length === 0 && m === 0,
          children: [
            /* @__PURE__ */ f.jsx(
              oy,
              {
                caption: e,
                data: h,
                columns: t.columns.map(({ column: b, title: C }) => {
                  const I = o(t.list, b);
                  return {
                    id: b,
                    header: C,
                    accessorFn: (T) => I(T[b]),
                    cell: Z0e
                  };
                })
              }
            ),
            (m > 0 || g) && /* @__PURE__ */ f.jsx("div", { className: "flex justify-center bg-neutral-100 p-2", children: /* @__PURE__ */ f.jsxs(cy, { horizontal: !0, children: [
              /* @__PURE__ */ f.jsx(
                Fn,
                {
                  icon: "chevronLeft",
                  accessibilityLabel: "Previous page",
                  disabled: m === 0,
                  onClick: () => a(m - 1)
                }
              ),
              /* @__PURE__ */ f.jsx(
                Fn,
                {
                  icon: "chevronRight",
                  accessibilityLabel: "Next page",
                  disabled: !g || u,
                  onClick: () => {
                    a(m + 1), ze(v).with(!0, () => {
                    }).with(!1, () => d()).exhaustive();
                  }
                }
              )
            ] }) })
          ]
        }
      );
    }
  ).exhaustive();
}, J0e = (e) => e.kind === cn.kpi, xy = (e) => e.kind === cn.list, nk = (e) => !xy(e) && e.dataset !== void 0, Q0e = (e) => !xy(e) && !nk(e), rk = (e, t, n, r) => ({
  key: r,
  title: ze(n).when(J0e, (i) => i.title ?? na(e, i.metric).label).otherwise(({ title: i }) => i),
  dataset: e,
  timeField: t,
  widget: n
}), eve = (e, t) => rk(e.dataset, e.timeField, e, t), tve = (e, t, n) => ({
  key: t,
  title: e.title,
  dataset: e.list,
  timeField: e.timeFields.find((o) => o === n) ?? e.timeFields[0],
  widget: e
}), ok = (e, t) => {
  const n = e.timeFields.find((o) => o === t) ?? e.timeFields[0], r = e.widgets.map(
    (o, i) => ze(o).when(xy, (a) => tve(a, `${i}`, n)).when(nk, (a) => eve(a, `${i}`)).when(
      Q0e,
      (a) => rk(e.dataset, a.timeField ?? n, a, `${i}`)
    ).exhaustive()
  );
  return {
    timeField: n,
    // the viewer only chooses what's counted by when there's more than one date
    isCountable: e.timeFields.length > 1,
    timeFields: e.timeFields.map((o) => ({
      value: o,
      ...D1(e.dataset, o)
    })),
    widgets: r
  };
}, ap = it(
  YY.shape.filters.pick({
    productTitles: !0,
    statuses: !0
  }).shape
), qc = ap.keyof().options, nve = {
  productTitles: [],
  statuses: ["shippingClaims"]
}, ik = (e, t) => vy(e, t) !== void 0 && !nve[t].some((n) => n === e), rve = (e) => qc.some((t) => t === e), P1 = (e, t) => {
  const n = {};
  return e.forEach((r) => {
    const o = t[r];
    o !== void 0 && (n[r] = o);
  }), n;
}, ak = (e, t) => P1(
  qc.filter((n) => !e.includes(n)),
  t
), sk = (e, t) => {
  const n = vy(e, t);
  return n === void 0 ? [] : [n];
}, ove = (e, t) => sk(e, t).flatMap((n) => {
  const { names: r } = rp(e, n);
  return r === void 0 ? [] : [r];
})[0], wc = (e) => {
  const [t = e] = Xs.datasets.map(({ dataset: n }) => n).flatMap((n) => {
    const r = vy(n, e);
    return r === void 0 ? [] : [rp(n, r).label];
  });
  return t;
}, ive = {
  claimItems: "items",
  orderItems: "itemsSold",
  registrations: "registeredProducts",
  claims: "claims"
}, { maxFilterValues: YS } = Xs.limits, ave = ({
  offered: e,
  filters: t,
  onChange: n
}) => {
  const r = r9(), [o, i] = Fe(!1), a = D0e(
    e.map(({ choices: l }) => l),
    o
  ), s = Object.fromEntries(
    e.map(({ filter: l, names: c }, u) => {
      var x;
      const d = a[u], m = (((x = d == null ? void 0 : d.data) == null ? void 0 : x.rows) ?? []).flatMap(
        ({ groups: [b] }) => b ? [b] : []
      ), v = [
        // a choice the current range no longer offers stays in the list, still chosen
        ...(t[l] ?? []).filter((b) => !m.includes(b)),
        ...m
      ].map((b) => ({ value: b, label: (c == null ? void 0 : c[b]) ?? b })), g = {
        id: l,
        type: ri.multiselect,
        label: wc(l),
        verb: "is",
        options: v,
        placeholder: ze(d).with(void 0, { status: "pending" }, () => "Loading…").with({ status: "error" }, () => "Failed to load. Try again later.").with(
          { status: "success", data: { truncated: !0 } },
          ({ data: b }) => `Search the ${dt.count(b.rows.length)} most common`
        ).with({ status: "success" }, () => "Search").exhaustive()
      };
      return [l, g];
    })
  );
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      onPointerEnter: () => i(!0),
      onFocusCapture: () => i(!0),
      children: /* @__PURE__ */ f.jsx(
        hge,
        {
          filters: s,
          activeFilters: t,
          onChange: ({ id: l, value: c }) => {
            if (!rve(l)) return;
            const u = wc(l);
            ze(ap.safeParse({ ...t, [l]: c })).with({ success: !0 }, ({ data: d }) => n(d)).with(
              { success: !1 },
              () => r.show(
                c !== void 0 && c.length > YS ? `${u} can be filtered by up to ${dt.count(YS)} choices.` : `${u} can't be filtered by that choice.`
              )
            ).exhaustive();
          },
          onRemoveFilters: (l) => n(ak(l, t))
        }
      )
    }
  );
}, Yl = (...e) => (t) => e.some((n) => n === t.kind), sve = [
  cn.ranking,
  cn.sunburst
], Cy = (e = {}, t = {}, n = {}) => ({ ...e, ...t, ...n }), lve = (e, t, n) => {
  const { dataset: r, timeField: o, widget: i } = e, a = {
    source: t.source,
    dataset: r,
    date: t.date,
    timeZone: t.timeZone,
    timeField: o,
    filters: Cy(i.filters, t.filters[r], n)
  }, s = (c, u, d = [], m) => ({
    placed: e,
    requestKey: c,
    scopeKey: JSON.stringify(a),
    question: { scope: a, metrics: u, dimensions: d, top: m },
    isTrend: i.kind === cn.kpi && i.trend === !0
  }), l = (c, u) => ({ ...c, whole: u });
  return ze(i).when(
    Yl(cn.kpi),
    (c) => s("totals", [c.metric])
  ).when(
    Yl(cn.overTime),
    (c) => s("totals", c.metrics)
  ).when(
    Yl(cn.ranking),
    (c) => {
      const { dimension: u, metric: d, limit: m } = c, h = c.mark === oc.cloud || c.hideUnset === !0;
      return ze(m).with(
        void 0,
        () => s(`ranking:${u}`, [d], [u])
      ).otherwise(
        (v) => s(
          // a top-N is cut by its own metric, so it can't read a breakdown ranked by another
          ["ranking", u, d].join(":"),
          [d],
          [u],
          // the unset group can take a place among the top, so one more is asked for when it is hidden
          v + (h ? 1 : 0)
        )
      );
    }
  ).when(
    Yl(cn.table),
    (c) => l(
      s(
        // a whole breakdown reads the same rows as a chart on its groupings, so the two share a request
        c.limit === void 0 ? ["breakdown", ...c.dimensions].join(":") : `table:${c.title}`,
        WA(c),
        c.dimensions,
        c.limit
      ),
      // a table's share is of the range's total
      c.share === void 0 ? void 0 : s("totals", [c.share])
    )
  ).when(
    Yl(
      cn.flow,
      cn.sunburst
    ),
    ({ dimensions: c, metric: u }) => s(["breakdown", ...c].join(":"), [u], c)
  ).exhaustive();
}, cve = ({ dataset: e, timeField: t, widget: n }, r, o) => ({
  source: r.source,
  dataset: e,
  date: r.date,
  timeZone: r.timeZone,
  timeField: t,
  filters: Cy(n.filters, r.filters[e], o)
}), uve = (e, t, n, r) => ({
  scope: {
    source: n.source,
    dataset: e,
    date: n.date,
    timeZone: n.timeZone,
    timeField: t,
    filters: Cy(void 0, n.filters[e])
  },
  metrics: [ive[e]],
  dimensions: sk(e, r)
}), lk = (e) => e.widget.kind === cn.list, dve = (e) => !lk(e), fve = (e) => (t) => ik(t.dataset, e), mve = (e, t = {}) => qc.filter(
  (n) => ik(e, n) && !Object.hasOwn(t, n)
), pve = ({ scopeKey: e }) => (t) => t.scopeKey === e, _h = (e, t) => {
  const { scope: n, metrics: r, dimensions: o, top: i } = e.question, [a = r[0], ...s] = new Set(
    t.flatMap(
      (c) => ze(c).when(pve(e), (u) => u.question.metrics).otherwise(() => [])
    )
  );
  return {
    scope: n,
    metrics: [a, ...s],
    dimensions: o,
    top: i
  };
}, hve = (e, t, n) => {
  const { whole: r } = e;
  return {
    note: n,
    placed: e.placed,
    whole: r && _h(
      r,
      t.filter(({ requestKey: i }) => i === r.requestKey)
    ),
    shared: _h(
      e,
      t.filter(({ requestKey: i }) => i === e.requestKey)
    ),
    // every trend tile in one scope draws from one bucketed request
    buckets: ze(e.isTrend).with(
      !0,
      () => _h(
        e,
        t.filter(({ isTrend: i }) => i)
      )
    ).with(!1, () => e.question).exhaustive()
  };
}, gve = ({
  source: e,
  group: t,
  report: n,
  date: r,
  view: { timeField: o, timeZone: i, filters: a, setFilters: s },
  offersFilters: l = !0
}) => {
  const c = l ? a : {}, { timeField: u, isCountable: d, widgets: m } = ok(n, o), h = { source: e, date: r, timeZone: i, filters: t.filters }, v = m.map((M) => {
    const j = mve(M.dataset, M.widget.filters), G = {
      dated: D1(M.dataset, M.timeField).label,
      key: M.key,
      kind: M.widget.kind,
      taken: j
    };
    return ze(M).when(lk, (U) => ({
      ...G,
      show: "list",
      list: U,
      scope: cve(U, h, P1(j, c))
    })).when(dve, (U) => ({
      ...G,
      show: "widget",
      ask: lve(U, h, P1(j, c))
    })).exhaustive();
  }), g = (M) => {
    const j = m.flatMap(
      (B) => ze(B).when(fve(M), (K) => [
        uve(K.dataset, K.timeField, h, M)
      ]).otherwise(() => [])
    ), G = j.find(
      ({ scope: B }) => B.dataset === n.dataset && B.timeField === u
    ) ?? j[0];
    return G === void 0 ? [] : [{
      filter: M,
      choices: G,
      names: ove(G.scope.dataset, M)
    }];
  }, x = l ? qc.flatMap(g) : [], b = (M) => c[M] !== void 0, C = qc.filter(
    (M) => b(M) && !x.some((j) => j.filter === M)
  ), I = D1(n.dataset, u).label, T = (M) => {
    const j = x.map(({ filter: U }) => U).filter((U) => b(U) && !M.taken.includes(U)), G = [
      ...d && M.dated !== I ? [`Always by ${M.dated.toLowerCase()}`] : [],
      ...j.length === 0 ? [] : [`Not filtered by ${j.map(wc).join(" or ")}`]
    ];
    return G.length === 0 ? void 0 : G.join(" · ");
  }, R = v.flatMap(
    (M) => ze(M).with(
      { show: "widget" },
      ({ ask: j }) => j.whole === void 0 ? [j] : [j, j.whole]
    ).with({ show: "list" }, () => []).exhaustive()
  ), A = (M) => ze(M).with({ show: "list" }, ({ list: j, scope: G }) => /* @__PURE__ */ f.jsx(X0e, { placed: j, scope: G, note: T(M) })).with({ show: "widget" }, ({ ask: j }) => /* @__PURE__ */ f.jsx(Y0e, { plan: hve(j, R, T(M)) })).exhaustive(), _ = v.filter(({ kind: M }) => M === cn.kpi), k = v.filter(({ kind: M }) => M !== cn.kpi);
  return /* @__PURE__ */ f.jsxs("div", { className: "@container flex flex-col gap-4", children: [
    x.length > 0 && /* @__PURE__ */ f.jsx(
      ave,
      {
        offered: x,
        filters: c,
        onChange: s
      }
    ),
    C.map((M) => /* @__PURE__ */ f.jsxs("p", { className: "text-xs text-neutral-500", children: [
      `${wc(M)} filter doesn't apply to this tab. `,
      /* @__PURE__ */ f.jsx(
        Fn,
        {
          variant: "link",
          className: "text-xs",
          onClick: () => s(ak([M], c)),
          children: `Clear ${wc(M)}`
        }
      )
    ] }, M)),
    _.length > 0 && /* @__PURE__ */ f.jsx("div", { className: "grid grid-cols-1 gap-4 @md:grid-cols-2 @5xl:grid-cols-4", children: _.map((M) => /* @__PURE__ */ f.jsx(ll, { children: A(M) }, M.key)) }),
    /* @__PURE__ */ f.jsx("div", { className: "grid grid-cols-1 gap-4 @3xl:grid-cols-2", children: k.map((M) => /* @__PURE__ */ f.jsx(
      "div",
      {
        className: oe(
          "min-w-0",
          !sve.includes(M.kind) && "@3xl:col-span-2"
        ),
        children: A(M)
      },
      M.key
    )) })
  ] });
}, _2e = ({
  source: e,
  group: t,
  date: n,
  view: r,
  offersFilters: o
}) => {
  const {
    report: i,
    setReport: a,
    timeField: s,
    setTimeField: l
  } = r, c = t.reports.find(({ key: g }) => g === i) ?? t.reports[0], { timeField: u, timeFields: d, isCountable: m } = ok(c, s), h = d.find(({ value: g }) => g === u), v = oi();
  return /* @__PURE__ */ f.jsxs(
    Lme,
    {
      value: c.key,
      onValueChange: a,
      className: "flex flex-col gap-4",
      children: [
        /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ f.jsxs("div", { className: "flex flex-wrap items-center justify-between gap-2", children: [
            /* @__PURE__ */ f.jsx(H_, { variant: "pill", "aria-label": `${t.label} reports`, children: t.reports.map((g) => /* @__PURE__ */ f.jsx(q_, { variant: "pill", value: g.key, children: g.label }, g.key)) }),
            m && /* @__PURE__ */ f.jsxs(
              "fieldset",
              {
                className: "flex items-center gap-2",
                "aria-describedby": h != null && h.description ? v : void 0,
                children: [
                  /* @__PURE__ */ f.jsx("legend", { className: "float-left text-xs text-neutral-500", children: "Count by" }),
                  /* @__PURE__ */ f.jsx(cy, { horizontal: !0, children: d.map(({ value: g, label: x }) => /* @__PURE__ */ f.jsx(
                    Fn,
                    {
                      pressed: g === u,
                      onClick: () => l(g),
                      children: x
                    },
                    g
                  )) })
                ]
              }
            )
          ] }),
          m && (h == null ? void 0 : h.description) && /* @__PURE__ */ f.jsx("p", { id: v, className: "text-xs text-neutral-500", children: h.description })
        ] }),
        t.reports.map((g) => /* @__PURE__ */ f.jsx(Y_, { value: g.key, children: /* @__PURE__ */ f.jsx(
          gve,
          {
            source: e,
            group: t,
            report: g,
            date: n,
            view: r,
            offersFilters: o
          }
        ) }, g.key))
      ]
    }
  );
}, KS = (e) => e ? Ds(new Date(e), "yyyy-MM-dd") : null, ZS = bY().transform((e) => nj(e).toISOString()), vve = y({
  range: ne(ei).optional(),
  from: ZS.optional(),
  to: ZS.optional(),
  tz: ne(Ya).optional(),
  report: p().optional(),
  by: p().optional()
}), XS = ap.keyof().options;
function O2e(e) {
  const [t, n] = vk(), r = ex(), o = (d) => n(
    (m) => {
      const h = new URLSearchParams(m);
      for (const [v, g] of Object.entries(d))
        h.delete(v), ze(g).with(Ft.nullish, () => {
        }).with(Ft.string, (x) => h.set(v, x)).with(
          Ft.array(Ft.string),
          (x) => x.forEach((b) => h.append(v, b))
        ).exhaustive();
      return h;
    },
    { replace: !0 }
  ), i = (d) => o(d), a = (d) => o(d), s = Be(
    () => vve.parse(Object.fromEntries(t)),
    [t]
  ), l = Be(
    () => y(e).parse(Object.fromEntries(t)),
    [e, t]
  ), c = Be(
    () => ap.parse(
      Object.fromEntries(
        XS.flatMap(
          (d) => t.has(d) ? [[d, t.getAll(d)]] : []
        )
      )
    ),
    [t]
  ), u = ze({
    start: s.from ?? null,
    end: s.to ?? null
  }).returnType().with({ start: null, end: null }, () => ({
    kind: "preset",
    preset: s.range ?? ei.last30Days
  })).otherwise((d) => ({ kind: "custom", range: d }));
  return {
    search: l,
    update: a,
    tz: s.tz,
    date: u,
    setDate: (d) => i(
      ze(d).with({ kind: "preset" }, (m) => ({
        range: m.preset,
        from: null,
        to: null
      })).with({ kind: "custom" }, (m) => ({
        range: null,
        from: KS(m.range.start),
        to: KS(m.range.end)
      })).exhaustive()
    ),
    group: r.group ?? null,
    report: s.report ?? null,
    setReport: (d) => i({ report: d }),
    timeField: s.by ?? null,
    setTimeField: (d) => i({ by: d }),
    filters: c,
    setFilters: (d) => i(
      Object.fromEntries(
        XS.map((m) => [m, d[m] ?? null])
      )
    )
  };
}
const yve = () => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = [];
  let r = null;
  const o = (i) => {
    var a;
    r = null, (a = t.get(i)) == null || a.forEach((s) => s());
  };
  return {
    set(i, a, s) {
      const l = e.get(i) ?? n, c = l.findIndex((u) => u.id === a);
      e.set(
        i,
        c === -1 ? [...l, { id: a, value: s }] : l.map((u, d) => d === c ? { id: a, value: s } : u)
      ), o(i);
    },
    get: (i) => e.get(i) ?? n,
    has: (i) => {
      var a;
      return (((a = e.get(i)) == null ? void 0 : a.length) ?? 0) > 0;
    },
    delete(i, a) {
      const s = e.get(i);
      s && (e.set(
        i,
        s.filter((l) => l.id !== a)
      ), o(i));
    },
    subscribe(i, a) {
      const s = t.get(i) ?? /* @__PURE__ */ new Set();
      return t.set(i, s), s.add(a), () => {
        s.delete(a);
      };
    },
    getFilled(i) {
      return r ?? (r = new Set(
        i.filter((a) => {
          var s;
          return (((s = e.get(a)) == null ? void 0 : s.length) ?? 0) > 0;
        })
      )), r;
    },
    hasSubscribers: (i) => {
      var a;
      return (((a = t.get(i)) == null ? void 0 : a.size) ?? 0) > 0;
    }
  };
}, A2e = (...e) => {
  new Set(e);
  const t = Nn(null), n = () => {
    const l = On(t);
    if (!l) throw new Error("Slot components must be used within Provider");
    return l;
  };
  return { Provider: ({ children: l }) => {
    const c = He(null);
    return c.current ?? (c.current = yve()), Le(() => {
    }, []), /* @__PURE__ */ f.jsx(t.Provider, { value: c.current, children: l });
  }, Slot: ({ name: l, children: c }) => {
    const u = n(), d = oi();
    return oa(() => (u.set(l, d, c), () => {
      u.delete(l, d);
    })), null;
  }, Outlet: ({
    name: l,
    children: c
  }) => {
    const u = n(), d = Ke(
      (h) => u.subscribe(l, h),
      [u, l]
    ), m = cp(d, () => u.get(l));
    return m.length === 0 ? c ?? null : m.map(({ id: h, value: v }) => /* @__PURE__ */ f.jsx(ll, { children: v }, h));
  }, useIsFilled: (l) => {
    const c = n(), u = Ke(
      (d) => c.subscribe(l, d),
      [c, l]
    );
    return cp(u, () => c.has(l));
  }, useFilledSlots: () => {
    const l = n(), c = Ke(
      (u) => {
        const d = e.map(
          (m) => l.subscribe(m, u)
        );
        return () => d.forEach((m) => m());
      },
      [l]
    );
    return cp(c, () => l.getFilled(e));
  } };
};
export {
  Fn as Action,
  X1e as Alert,
  uO as AmountLineItem,
  Y0e as AnalyticsWidget,
  ka as Badge,
  x2e as Banner,
  Bpe as BarList,
  en as Button,
  cy as ButtonGroup,
  s0 as Calendar,
  un as Card,
  DG as Carousel,
  PG as CarouselContent,
  NG as CarouselItem,
  FG as CarouselNext,
  MG as CarouselPrevious,
  qf as ChartContainer,
  as as ChartEmpty,
  js as ChartGranularity,
  Km as ChartHeader,
  Q2 as ChartHeading,
  WS as ChartMark,
  mO as ChartReadout,
  joe as ChartSeriesSelector,
  TC as ChartTooltip,
  IC as ChartTooltipFrame,
  RC as ChartTooltipItem,
  Hve as Checkbox,
  hS as ClickToCopy,
  Uve as ClipboardButton,
  qve as ColorInput,
  Wve as Combobox,
  Am as Command,
  kve as CommandDialog,
  n2 as CommandEmpty,
  xf as CommandGroup,
  e2 as CommandInput,
  _a as CommandItem,
  t2 as CommandList,
  Ave as CommandLoading,
  xse as CommandSeparator,
  Cse as CommandShortcut,
  SO as ConfirmModal,
  qpe as ConfirmWithBlocker,
  O3 as CorsoIcon,
  Tve as CorsoLogo,
  f2e as CreateSearchView,
  Ya as DashboardTimeZone,
  oy as DataTable,
  Sh as DataTableStatus,
  Yve as DateInput,
  $4 as DatePicker,
  Dve as DatePickerWithRange,
  _o as DatePreset,
  Jv as Dialog,
  Sse as DialogClose,
  Om as DialogContent,
  HR as DialogDescription,
  WR as DialogFooter,
  UR as DialogHeader,
  VR as DialogOverlay,
  bse as DialogPortal,
  Qv as DialogTitle,
  yse as DialogTrigger,
  jle as Disclosure,
  w7 as DisclosureChevron,
  Nve as DragAndDrop,
  Mve as DragAndDropGrip,
  Fve as DragAndDropSortableList,
  ode as Drawer,
  $ve as DrawerClose,
  sde as DrawerContent,
  ude as DrawerDescription,
  lde as DrawerFooter,
  ade as DrawerHandle,
  sT as DrawerOverlay,
  ide as DrawerPortal,
  cde as DrawerTitle,
  Lve as DrawerTrigger,
  rs as DropdownMenu,
  wfe as DropdownMenuCheckboxItem,
  pa as DropdownMenuContent,
  zve as DropdownMenuGroup,
  Rr as DropdownMenuItem,
  i_ as DropdownMenuLabel,
  D2 as DropdownMenuRadioGroup,
  jm as DropdownMenuRadioItem,
  a_ as DropdownMenuSeparator,
  Efe as DropdownMenuShortcut,
  jve as DropdownMenuSub,
  Cfe as DropdownMenuSubContent,
  xfe as DropdownMenuSubTrigger,
  os as DropdownMenuTrigger,
  Kve as EmailInput,
  C2e as Feed,
  Q1e as FeedFallbackIcon,
  al as FieldGroup,
  Zve as Fieldset,
  Xve as FileInput,
  hge as FilterBar,
  wh as FilterControl,
  ri as FilterControlType,
  PO as FilterRemoveButton,
  Xm as FilterTriggerPill,
  s2e as FloatingSave,
  wge as FlowChart,
  w2e as FullPageLoader,
  E2e as FullPageStatus,
  J2 as HelpfulTooltip,
  Ve as Icon,
  ss as Input,
  Ege as InteractiveBarChart,
  MO as InteractiveChartCard,
  Ige as InteractiveLineChart,
  FO as KpiTile,
  q1e as LOADING_BAR_TIME_CONSTANT,
  pi as Label,
  l2e as LabeledPieChart,
  LO as LineItemList,
  FA as List,
  eo as ListColumnFormat,
  X0e as ListWidget,
  y2e as Loading,
  S2e as LoadingBar,
  b2e as LoadingProvider,
  _fe as Media,
  sy as Menu,
  we as MetricFormat,
  bO as Modal,
  i2e as MultiSelect,
  iy as MultiSelectContent,
  R$ as NamedIcon,
  Mpe as NestedTracker,
  Jve as NumberInput,
  Age as OrderLineItem,
  T2e as Page,
  np as PageStatus,
  I2e as PageTitleProvider,
  Qve as PasswordInput,
  xl as Popover,
  ts as PopoverContent,
  Cl as PopoverTrigger,
  Ofe as RadioGroup,
  e2e as RadioGroupInput,
  oc as RankingMark,
  kfe as RelativeDateTime,
  _2e as ReportGroupPanel,
  gve as ReportView,
  u2e as SearchInput,
  c2e as SearchSpinner,
  d2e as SearchTable,
  m2e as SearchViews,
  p2e as SimpleSelect,
  Pve as SimpleSummary,
  h2e as SimpleTooltip,
  Al as Skeleton,
  n9 as Snackbar,
  g2e as SortMenu,
  J1 as SpinnerIcon,
  $1e as SunburstChart,
  fr as SupportingText,
  t2e as SwitchInput,
  tk as TableCard,
  Lme as Tabs,
  Y_ as TabsContent,
  H_ as TabsList,
  q_ as TabsTrigger,
  v2e as TagBadges,
  n2e as TextAreaInput,
  kO as TextInput,
  K2 as Tooltip,
  qm as TooltipContent,
  Gve as TooltipPortal,
  Y2 as TooltipProvider,
  Hm as TooltipTrigger,
  lO as Transition,
  r2e as UrlInput,
  ave as ViewerFilterBar,
  age as Virtualizer,
  XA as WidgetError,
  cn as WidgetKind,
  W1e as WordCloud,
  _$ as badgeVariants,
  J1e as bannerVariants,
  _0e as bucketDate,
  Yh as buttonVariants,
  zoe as chartAggregate,
  No as chartColors,
  ive as choiceCount,
  sk as choiceDimensionsOf,
  ove as choiceNamesOf,
  oe as cn,
  A2e as createSlots,
  a2e as datePresetOptions,
  kl as described,
  rp as dimensionOf,
  ak as dropViewerFilters,
  jhe as fieldGroupVariants,
  vy as filterDimensionOf,
  Fp as formatChartDate,
  uge as formatFilterValue,
  C0e as intlZoneOf,
  Hc as isPlottable,
  vI as isUtcTimestamp,
  ik as isViewed,
  rve as isViewerFilter,
  x0e as listColumnOf,
  na as metricOf,
  gi as metricValue,
  fO as otherColor,
  yc as otherKey,
  P1 as pickViewerFilters,
  ok as placedOf,
  ey as seriesColor,
  Na as shareOf,
  op as staleTime,
  WA as tableMetricsOf,
  D1 as timeFieldOf,
  A0e as timeFor,
  Yre as toChartDate,
  ip as useAnalyticsBreakdown,
  D0e as useAnalyticsBreakdowns,
  F0e as useAnalyticsList,
  KA as useAnalyticsOverTime,
  by as useAnalyticsTotals,
  O2e as useDashboardSearch,
  Npe as useIsNested,
  MA as useLoading,
  Vve as useNestedDepth,
  R2e as usePageTitle,
  Rve as usePathParams,
  r9 as useToast,
  pO as useWidth,
  wc as viewerFilterLabelOf,
  qc as viewerFilterNames,
  ap as viewerFilters
};
